/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// The babel polyfills are required for older browsers like IE9
	
	__webpack_require__(147);
	
	// This has to be done before loading wr360
	
	var _improveWebrotate360 = __webpack_require__(132);
	
	(0, _improveWebrotate360.improveWebrotate360)();
	
	var $ = __webpack_require__(3);
	__webpack_require__(272);
	
	var Application = __webpack_require__(131);
	
	$(function () {
	    new Application.Application();
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , core      = __webpack_require__(23)
	  , hide      = __webpack_require__(21)
	  , redefine  = __webpack_require__(16)
	  , ctx       = __webpack_require__(19)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 2 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(100)('wks')
	  , uid    = __webpack_require__(32)
	  , Symbol = __webpack_require__(7).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(54),
	    isLength = __webpack_require__(26),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 10 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(282),
	    baseAssign = __webpack_require__(110),
	    createAssigner = __webpack_require__(298);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1)
	  , core    = __webpack_require__(23)
	  , fails   = __webpack_require__(8);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(7)
	  , hide      = __webpack_require__(21)
	  , SRC       = __webpack_require__(32)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(23).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(48)
	  , defined = __webpack_require__(20);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(30);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(2)
	  , createDesc = __webpack_require__(28);
	module.exports = __webpack_require__(14) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(20);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(287),
	    createWrapper = __webpack_require__(305),
	    functions = __webpack_require__(324),
	    restParam = __webpack_require__(67);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Binds methods of an object to the object itself, overwriting the existing
	 * method. Method names may be specified as individual arguments or as arrays
	 * of method names. If no method names are provided all enumerable function
	 * properties, own and inherited, of `object` are bound.
	 *
	 * **Note:** This method does not set the "length" property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Object} object The object to bind and assign the bound methods to.
	 * @param {...(string|string[])} [methodNames] The object method names to bind,
	 *  specified as individual method names or arrays of method names.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var view = {
	 *   'label': 'docs',
	 *   'onClick': function() {
	 *     console.log('clicked ' + this.label);
	 *   }
	 * };
	 *
	 * _.bindAll(view);
	 * jQuery('#docs').on('click', view.onClick);
	 * // => logs 'clicked docs' when the element is clicked
	 */
	var bindAll = restParam(function(object, methodNames) {
	  methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	  var index = -1,
	      length = methodNames.length;
	
	  while (++index < length) {
	    var key = methodNames[index];
	    object[key] = createWrapper(object[key], BIND_FLAG, object);
	  }
	  return object;
	});
	
	module.exports = bindAll;


/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(6)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	/*
	FlameViewportScale. 0.12. Facilitates a simple viewport scale query.
	Optic Swerve, opticswerve.com
	Documented at http://menacingcloud.com/?c=viewportScale
	*/
	
	/*--------------------------|
	| FlameViewportScale		|
	|--------------------------*/
	function FlameViewportScale() {
		this.delay = 600; // Delay after calling update to account for viewport bounce
		this.orientation;
		this.screenWidth; // Screen width corrected for orientation
		this.timeout;
		this.viewportScale;
	
		// Get current scale
		//-------------------
		this.getScale = function() {
			this.viewportScale = undefined;
	
			// Get viewport width
			var viewportWidth = document.documentElement.clientWidth;
	
			// Abort. Screen width is greater than the viewport width (not fullscreen).
			if(screen.width > viewportWidth) {
				console.log('Aborted viewport scale measurement. Screen width > viewport width');
				return;
	
			}
	
			// Get the orientation corrected screen width
			this.updateOrientation();
			this.screenWidth = screen.width;
	
			if(this.orientation === 'portrait') {
				// Take smaller of the two dimensions
				if(screen.width > screen.height) this.screenWidth = screen.height;
	
			}
			else {
				// Take larger of the two dimensions
				if(screen.width < screen.height) this.screenWidth = screen.height;
	
			}
	
			// Calculate viewport scale
			this.viewportScale = this.screenWidth / window.innerWidth;
			return this.viewportScale;
	
		};
	
		// Update viewport orientation
		//-----------------------------
		this.updateOrientation = function() {
			this.orientation = window.orientation;
	
			if(this.orientation === undefined) {
				// No JavaScript orientation support. Work it out.
				if(document.documentElement.clientWidth > document.documentElement.clientHeight) this.orientation = 'landscape';
				else this.orientation = 'portrait';
	
			}
			else if(this.orientation === 0 || this.orientation === 180) this.orientation = 'portrait';
			else this.orientation = 'landscape'; // Assumed default, most laptop and PC screens.
	
		};
	
		// Update
		//--------	
		this.update = function(callback) {
			// Clear timeout if already set
			if(this.timeout !== undefined) {
				clearTimeout(this.timeout);
				this.timeout = undefined;
	
			}
	
			if(this.delay > 0) {
				// Delay compensates for viewport bounce
				var viewScale = this;
	
				this.timeout = setTimeout(function() {
					viewScale.getScale();
					if(callback !== undefined) callback();
	
				}, this.delay);
	
			}
			else {
				// Immediate scale update
				this.getScale();
				if(callback !== undefined) callback();
	
			}
	
		};
	
		return true;
	
	}
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = FlameViewportScale;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(54),
	    isArrayLike = __webpack_require__(55),
	    isObject = __webpack_require__(12),
	    shimKeys = __webpack_require__(318);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(19)
	  , call        = __webpack_require__(93)
	  , isArrayIter = __webpack_require__(90)
	  , anObject    = __webpack_require__(5)
	  , toLength    = __webpack_require__(11)
	  , getIterFn   = __webpack_require__(104);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(2).setDesc
	  , has = __webpack_require__(10)
	  , TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(77);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(19)
	  , IObject  = __webpack_require__(48)
	  , toObject = __webpack_require__(24)
	  , toLength = __webpack_require__(11)
	  , asc      = __webpack_require__(151);
	module.exports = function(TYPE){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(22)
	  , TAG = __webpack_require__(6)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(7)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(16)
	  , redefineAll    = __webpack_require__(49)
	  , forOf          = __webpack_require__(35)
	  , strictNew      = __webpack_require__(51)
	  , isObject       = __webpack_require__(4)
	  , fails          = __webpack_require__(8)
	  , $iterDetect    = __webpack_require__(60)
	  , setToStringTag = __webpack_require__(37);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO;
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        strictNew(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    IS_WEAK || instance.forEach(function(val, key){
	      BUGGY_ZERO = 1 / key === -Infinity;
	    });
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(21)
	  , redefine = __webpack_require__(16)
	  , fails    = __webpack_require__(8)
	  , defined  = __webpack_require__(20)
	  , wks      = __webpack_require__(6);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , original = ''[KEY];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return original.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return original.call(string, this); }
	    );
	  }
	};

/***/ },
/* 47 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(22);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(16);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(7)
	  , $           = __webpack_require__(2)
	  , DESCRIPTORS = __webpack_require__(14)
	  , SPECIES     = __webpack_require__(6)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , defined = __webpack_require__(20)
	  , fails   = __webpack_require__(8)
	  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec){
	  var exp  = {};
	  exp[KEY] = exec(trim);
	  $export($export.P + $export.F * fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  }), 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        factory(require('jquery'), require('hammerjs'));
	    } else {
	        factory(jQuery, Hammer);
	    }
	}(function($, Hammer) {
	    function hammerify(el, options) {
	        var $el = $(el);
	        if(!$el.data("hammer")) {
	            $el.data("hammer", new Hammer($el[0], options));
	        }
	    }
	
	    $.fn.hammer = function(options) {
	        return this.each(function() {
	            hammerify(this, options);
	        });
	    };
	
	    // extend the emit method to also trigger jQuery events
	    Hammer.Manager.prototype.emit = (function(originalEmit) {
	        return function(type, data) {
	            originalEmit.call(this, type, data);
	            $(this.element).trigger({
	                type: type,
	                gesture: data
	            });
	        };
	    })(Hammer.Manager.prototype.emit);
	}));


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(322);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(74),
	    isLength = __webpack_require__(26);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(55),
	    isObjectLike = __webpack_require__(29);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(6)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(22);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(61)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(16)
	  , hide           = __webpack_require__(21)
	  , has            = __webpack_require__(10)
	  , Iterators      = __webpack_require__(36)
	  , $iterCreate    = __webpack_require__(94)
	  , setToStringTag = __webpack_require__(37)
	  , getProto       = __webpack_require__(2).getProto
	  , ITERATOR       = __webpack_require__(6)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(6)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 62 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	module.exports = Math.expm1 || function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	};

/***/ },
/* 63 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(2).getDesc
	  , isObject = __webpack_require__(4)
	  , anObject = __webpack_require__(5);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(19)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(20);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(92)
	  , defined  = __webpack_require__(20);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 67 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(69),
	    baseLodash = __webpack_require__(72);
	
	/** Used as references for `-Infinity` and `Infinity`. */
	var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = POSITIVE_INFINITY;
	  this.__views__ = [];
	}
	
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(prototype) {
	    if (isObject(prototype)) {
	      object.prototype = prototype;
	      var result = new object;
	      object.prototype = undefined;
	    }
	    return result || {};
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(290),
	    isObject = __webpack_require__(12),
	    isObjectLike = __webpack_require__(29);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype all chaining wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(69),
	    isObject = __webpack_require__(12);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors.
	    // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(113);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(9),
	    toObject = __webpack_require__(27);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(295),
	    isArray = __webpack_require__(9);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// Load all the components of the TosRUs lightbox
	__webpack_require__(271);
	
	// require('jQuery.TosRUs/src/js/addons/jquery.tosrus.autoplay');
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	
	// require('jQuery.TosRUs/src/js/media/jquery.tosrus.html');
	// require('jQuery.TosRUs/src/js/media/jquery.tosrus.image');
	// require('jQuery.TosRUs/src/js/media/jquery.tosrus.vimeo');
	// require('jQuery.TosRUs/src/js/media/jquery.tosrus.youtube');
	


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13), __webpack_require__(321), __webpack_require__(320), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_RESULT__ = function (assign, isEqual, clone, Emitter) {
	    'use strict';
	
	    var BaseModel = function BaseModel() {};
	    assign(BaseModel.prototype, Emitter.prototype);
	    assign(BaseModel.prototype, {
	
	        attrs: {},
	        _previousAttrs: {},
	
	        set: function set(key, val, force) {
	            var previousAttrs = clone(this.attrs);
	
	            if (typeof key === 'object') {
	                assign(this.attrs, key);
	                force = val;
	            } else {
	                this.attrs[key] = val;
	            }
	
	            if (force === true || !isEqual(previousAttrs, this.attrs)) {
	                this._previousAttrs = previousAttrs;
	                this.emit('change');
	            }
	        },
	
	        isChanged: function isChanged(key) {
	            if (isEqual(this.prev(key), this.get(key))) {
	                return false;
	            }
	            return true;
	        },
	
	        get: function get(key) {
	            return this.attrs[key];
	        },
	
	        prev: function prev(key) {
	            return this._previousAttrs[key];
	        }
	    });
	
	    return {
	        BaseModel: BaseModel
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _spinJs = __webpack_require__(330);
	
	var _spinJs2 = _interopRequireDefault(_spinJs);
	
	// Maintain a unique ID for each LoadingIndicator instance which is used to
	// create unique, per-instance globals. Not that we use more than one... :)
	var loadingIndicatorSequence = 0;
	
	/**
	 * Handles showing a scroll.js spinner when jscroll is loading a new page.
	 */
	
	var LoadingIndicator = (function () {
	    function LoadingIndicator() {
	        _classCallCheck(this, LoadingIndicator);
	
	        this.id = loadingIndicatorSequence++;
	        this.loadingCount = 0;
	        this.spinner = new _spinJs2['default']();
	        this.registerGlobalInsertionFunc();
	    }
	
	    _createClass(LoadingIndicator, [{
	        key: 'getGlobalInsertionFuncKey',
	        value: function getGlobalInsertionFuncKey() {
	            return '__veInsertSpinner' + this.id;
	        }
	    }, {
	        key: 'getScriptTagId',
	        value: function getScriptTagId() {
	            return 've-spinner-placeholder-' + this.id;
	        }
	    }, {
	        key: 'registerGlobalInsertionFunc',
	        value: function registerGlobalInsertionFunc() {
	            window[this.getGlobalInsertionFuncKey()] = this.insertSpinner.bind(this);
	        }
	    }, {
	        key: 'getScriptTagHtml',
	        value: function getScriptTagHtml() {
	            return '<script id="ve-spinner-placeholder-' + this.id + '">' + 'window.' + this.getGlobalInsertionFuncKey() + '();' + '</script>';
	        }
	    }, {
	        key: 'getScriptElement',
	        value: function getScriptElement() {
	            return (0, _jquery2['default'])('#' + this.getScriptTagId());
	        }
	    }, {
	        key: 'insertSpinner',
	        value: function insertSpinner() {
	            this.loadingCount++;
	
	            this.spinner.spin();
	            this.getScriptElement().replaceWith(this.spinner.el);
	        }
	    }, {
	        key: 'removeSpinner',
	        value: function removeSpinner() {
	            // Only remove when the reference count hits zero. Required as jscroll
	            // fires the callback to mark the end of scrolling after a next scroll
	            // has already started.
	            if (--this.loadingCount === 0) this.spinner.stop();
	        }
	    }]);
	
	    return LoadingIndicator;
	})();

	exports.LoadingIndicator = LoadingIndicator;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	// Ensure tosrus has been loaded (it's a jquery plugin)
	
	__webpack_require__(78);
	
	var PLUGIN = 'tosrus';
	
	var tosrus = _jquery2['default'][PLUGIN];
	
	exports.tosrus = tosrus;
	
	var BaseTosRUsMediaPlugin = (function () {
	    function BaseTosRUsMediaPlugin() {
	        _classCallCheck(this, BaseTosRUsMediaPlugin);
	
	        this.initialised = false;
	
	        // Wrap the tosrus API methods to support its unusual calling contention
	        var _arr = ['filter', 'init'];
	        for (var _i = 0; _i < _arr.length; _i++) {
	            var op = _arr[_i];var _arr2 = ['Anchors', 'Slides'];
	
	            for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	                var type = _arr2[_i2];
	                var _name = op + type;
	                this[_name] = this.createTosApiMethod(this[_name]);
	            }
	        }
	    }
	
	    _createClass(BaseTosRUsMediaPlugin, [{
	        key: '_doDeferredInit',
	
	        /**
	         * TosRUs defers the initialisation of its globals until the first time
	         *  it's called, so we can't initialise them on startup.
	         */
	        value: function _doDeferredInit() {
	            if (this.initialised === true) return;
	            this.init();
	            this.initialised = true;
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this._tos = {
	                classes: tosrus._c,
	                data: tosrus._d,
	                events: tosrus._e,
	                funcs: tosrus._f,
	                globals: tosrus._g
	            };
	        }
	
	        /**
	         * Create a method which handles the this parameter passed by tos while
	         * maintaining our actual plugin instance.
	         */
	    }, {
	        key: 'createTosApiMethod',
	        value: function createTosApiMethod(targetMethod) {
	            var self = this;
	            return function () {
	                // tosrus calls plugin methods with this set to its own context info
	                var tosContext = this;
	
	                // At the point that an api method is called, it's safe to
	                // initialise.
	                self._doDeferredInit();
	
	                // Invoke the actual api method implementation with the context
	                // as the first argument (instead of as this).
	                return targetMethod.apply(self, [tosContext].concat([].slice.apply(arguments)));
	            };
	        }
	    }, {
	        key: 'tos',
	        get: function get() {
	            if (this._tos === undefined) {
	                throw new Error('this.tos referenced while uninitialised');
	            }
	            return this._tos;
	        }
	    }]);
	
	    return BaseTosRUsMediaPlugin;
	})();

	exports.BaseTosRUsMediaPlugin = BaseTosRUsMediaPlugin;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(17)
	  , toLength  = __webpack_require__(11)
	  , toIndex   = __webpack_require__(38);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(2)
	  , hide         = __webpack_require__(21)
	  , redefineAll  = __webpack_require__(49)
	  , ctx          = __webpack_require__(19)
	  , strictNew    = __webpack_require__(51)
	  , defined      = __webpack_require__(20)
	  , forOf        = __webpack_require__(35)
	  , $iterDefine  = __webpack_require__(59)
	  , step         = __webpack_require__(95)
	  , ID           = __webpack_require__(32)('id')
	  , $has         = __webpack_require__(10)
	  , isObject     = __webpack_require__(4)
	  , setSpecies   = __webpack_require__(50)
	  , DESCRIPTORS  = __webpack_require__(14)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(35)
	  , classof = __webpack_require__(44);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide              = __webpack_require__(21)
	  , redefineAll       = __webpack_require__(49)
	  , anObject          = __webpack_require__(5)
	  , isObject          = __webpack_require__(4)
	  , strictNew         = __webpack_require__(51)
	  , forOf             = __webpack_require__(35)
	  , createArrayMethod = __webpack_require__(43)
	  , $has              = __webpack_require__(10)
	  , WEAK              = __webpack_require__(32)('weak')
	  , isExtensible      = Object.isExtensible || isObject
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for frozen keys
	var frozenStore = function(that){
	  return that._l || (that._l = new FrozenStore);
	};
	var FrozenStore = function(){
	  this.a = [];
	};
	var findFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	FrozenStore.prototype = {
	  get: function(key){
	    var entry = findFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this)['delete'](key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this).has(key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    if(!isExtensible(anObject(key))){
	      frozenStore(that).set(key, value);
	    } else {
	      $has(key, WEAK) || hide(key, WEAK, {});
	      key[WEAK][that._i] = value;
	    } return that;
	  },
	  frozenStore: frozenStore,
	  WEAK: WEAK
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(4)
	  , document = __webpack_require__(7).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(5);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(17)
	  , getNames  = __webpack_require__(2).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7).document && document.documentElement;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(36)
	  , ITERATOR   = __webpack_require__(6)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(4)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(4)
	  , cof      = __webpack_require__(22)
	  , MATCH    = __webpack_require__(6)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(5);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(2)
	  , descriptor     = __webpack_require__(28)
	  , setToStringTag = __webpack_require__(37)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(21)(IteratorPrototype, __webpack_require__(6)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 96 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(2)
	  , toIObject = __webpack_require__(17)
	  , isEnum    = $.isEnum;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var $        = __webpack_require__(2)
	  , anObject = __webpack_require__(5)
	  , Reflect  = __webpack_require__(7).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = $.getNames(anObject(it))
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-string-pad-left-right
	var toLength = __webpack_require__(11)
	  , repeat   = __webpack_require__(102)
	  , defined  = __webpack_require__(20);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength)return S;
	  if(fillStr == '')fillStr = ' ';
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(20);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(19)
	  , invoke             = __webpack_require__(47)
	  , html               = __webpack_require__(89)
	  , cel                = __webpack_require__(86)
	  , global             = __webpack_require__(7)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(22)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(44)
	  , ITERATOR  = __webpack_require__(6)('iterator')
	  , Iterators = __webpack_require__(36);
	module.exports = __webpack_require__(23).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(31)
	  , step             = __webpack_require__(95)
	  , Iterators        = __webpack_require__(36)
	  , toIObject        = __webpack_require__(17);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(59)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	
	/*!
	 * jScroll - jQuery Plugin for Infinite Scrolling / Auto-Paging
	 * http://jscroll.com/
	 *
	 * Copyright 2011-2013, Philip Klauzinski
	 * http://klauzinski.com/
	 * Dual licensed under the MIT and GPL Version 2 licenses.
	 * http://jscroll.com/#license
	 * http://www.opensource.org/licenses/mit-license.php
	 * http://www.gnu.org/licenses/gpl-2.0.html
	 *
	 * @author Philip Klauzinski
	 * @version 2.3.5
	 * @requires jQuery v1.4.3+
	 * @preserve
	 */
	(function($) {
	
	    'use strict';
	
	    // Define the jscroll namespace and default settings
	    $.jscroll = {
	        defaults: {
	            debug: false,
	            autoTrigger: true,
	            autoTriggerUntil: false,
	            loadingHtml: '<small>Loading...</small>',
	            loadingFunction: false,
	            padding: 0,
	            nextSelector: 'a:last',
	            contentSelector: '',
	            pagingSelector: '',
	            callback: false
	        }
	    };
	
	    // Constructor
	    var jScroll = function($e, options) {
	
	        // Private vars and methods
	        var _data = $e.data('jscroll'),
	            _userOptions = (typeof options === 'function') ? { callback: options } : options,
	            _options = $.extend({}, $.jscroll.defaults, _userOptions, _data || {}),
	            _isWindow = ($e.css('overflow-y') === 'visible'),
	            _$next = $e.find(_options.nextSelector).first(),
	            _$window = $(window),
	            _$body = $('body'),
	            _$scroll = _isWindow ? _$window : $e,
	            _nextHref = $.trim(_$next.attr('href') + ' ' + _options.contentSelector),
	
	            // Check if a loading image is defined and preload
	            _preloadImage = function() {
	                var src = $(_options.loadingHtml).filter('img').attr('src');
	                if (src) {
	                    var image = new Image();
	                    image.src = src;
	                }
	            },
	
	            // Wrap inner content, if it isn't already
	            _wrapInnerContent = function() {
	                if (!$e.find('.jscroll-inner').length) {
	                    $e.contents().wrapAll('<div class="jscroll-inner" />');
	                }
	            },
	
	            // Find the next link's parent, or add one, and hide it
	            _nextWrap = function($next) {
	                var $parent;
	                if (_options.pagingSelector) {
	                    $next.closest(_options.pagingSelector).hide();
	                } else {
	                    $parent = $next.parent().not('.jscroll-inner,.jscroll-added').addClass('jscroll-next-parent').hide();
	                    if (!$parent.length) {
	                        $next.wrap('<div class="jscroll-next-parent" />').parent().hide();
	                    }
	                }
	            },
	
	            // Remove the jscroll behavior and data from an element
	            _destroy = function() {
	                return _$scroll.unbind('.jscroll')
	                    .removeData('jscroll')
	                    .find('.jscroll-inner').children().unwrap()
	                    .filter('.jscroll-added').children().unwrap();
	            },
	
	            // Observe the scroll event for when to trigger the next load
	            _observe = function() {
	                if ($e.is(':visible')) {
	                    _wrapInnerContent();
	                    var $inner = $e.find('div.jscroll-inner').first(),
	                        data = $e.data('jscroll'),
	                        borderTopWidth = parseInt($e.css('borderTopWidth'), 10),
	                        borderTopWidthInt = isNaN(borderTopWidth) ? 0 : borderTopWidth,
	                        iContainerTop = parseInt($e.css('paddingTop'), 10) + borderTopWidthInt,
	                        iTopHeight = _isWindow ? _$scroll.scrollTop() : $e.offset().top,
	                        innerTop = $inner.length ? $inner.offset().top : 0,
	                        iTotalHeight = Math.ceil(iTopHeight - innerTop + _$scroll.height() + iContainerTop);
	
	                    if (!data.waiting && iTotalHeight + _options.padding >= $inner.outerHeight()) {
	                        //data.nextHref = $.trim(data.nextHref + ' ' + _options.contentSelector);
	                        _debug('info', 'jScroll:', $inner.outerHeight() - iTotalHeight, 'from bottom. Loading next request...');
	                        return _load();
	                    }
	                }
	            },
	
	            // Check if the href for the next set of content has been set
	            _checkNextHref = function(data) {
	                data = data || $e.data('jscroll');
	                if (!data || !data.nextHref) {
	                    _debug('warn', 'jScroll: nextSelector not found - destroying');
	                    _destroy();
	                    return false;
	                } else {
	                    _setBindings();
	                    return true;
	                }
	            },
	
	            _setBindings = function() {
	                var $next = $e.find(_options.nextSelector).first();
	                if (!$next.length) {
	                    return;
	                }
	                if (_options.autoTrigger && (_options.autoTriggerUntil === false || _options.autoTriggerUntil > 0)) {
	                    _nextWrap($next);
	                     var scrollingBodyHeight = _$body.height() - $e.offset().top,
	                    	scrollingHeight = ($e.height() < scrollingBodyHeight) ? $e.height() : scrollingBodyHeight,
	                    	windowHeight = ($e.offset().top - _$window.scrollTop() > 0) ? _$window.height() - ($e.offset().top - $(window).scrollTop()) : _$window.height();
	                    if (scrollingHeight <= windowHeight) {
	                        _observe();
	                    }
	                    _$scroll.unbind('.jscroll').bind('scroll.jscroll', function() {
	                        return _observe();
	                    });
	                    if (_options.autoTriggerUntil > 0) {
	                        _options.autoTriggerUntil--;
	                    }
	                } else {
	                    _$scroll.unbind('.jscroll');
	                    $next.bind('click.jscroll', function() {
	                        _nextWrap($next);
	                        _load();
	                        return false;
	                    });
	                }
	            },
	
	            // Load the next set of content, if available
	            _load = function() {
	                var $inner = $e.find('div.jscroll-inner').first(),
	                    data = $e.data('jscroll');
	
	                data.waiting = true;
	                $inner.append('<div class="jscroll-added" />')
	                    .children('.jscroll-added').last()
	                    .html('<div class="jscroll-loading" id="jscroll-loading">' + _options.loadingHtml + '</div>')
	                    .promise()
	                    .done(function(){
	                        if (_options.loadingFunction) {
	                            _options.loadingFunction();
	                        }
	                    });
	
	                return $e.animate({scrollTop: $inner.outerHeight()}, 0, function() {
	                    $inner.find('div.jscroll-added').last().load(data.nextHref, function(r, status) {
	                        if (status === 'error') {
	                            return _destroy();
	                        }
	                        var $next = $(this).find(_options.nextSelector).first();
	                        data.waiting = false;
	                        data.nextHref = $next.attr('href') ? $.trim($next.attr('href') + ' ' + _options.contentSelector) : false;
	                        $('.jscroll-next-parent', $e).remove(); // Remove the previous next link now that we have a new one
	                        _checkNextHref();
	                        if (_options.callback) {
	                            _options.callback.call(this);
	                        }
	                        _debug('dir', data);
	                    });
	                });
	            },
	
	            // Safe console debug - http://klauzinski.com/javascript/safe-firebug-console-in-javascript
	            _debug = function(m) {
	                if (_options.debug && typeof console === 'object' && (typeof m === 'object' || typeof console[m] === 'function')) {
	                    if (typeof m === 'object') {
	                        var args = [];
	                        for (var sMethod in m) {
	                            if (typeof console[sMethod] === 'function') {
	                                args = (m[sMethod].length) ? m[sMethod] : [m[sMethod]];
	                                console[sMethod].apply(console, args);
	                            } else {
	                                console.log.apply(console, args);
	                            }
	                        }
	                    } else {
	                        console[m].apply(console, Array.prototype.slice.call(arguments, 1));
	                    }
	                }
	            };
	
	        // Initialization
	        $e.data('jscroll', $.extend({}, _data, {initialized: true, waiting: false, nextHref: _nextHref}));
	        _wrapInnerContent();
	        _preloadImage();
	        _setBindings();
	
	        // Expose API methods via the jQuery.jscroll namespace, e.g. $('sel').jscroll.method()
	        $.extend($e.jscroll, {
	            destroy: _destroy
	        });
	        return $e;
	    };
	
	    // Define the jscroll plugin method and loop
	    $.fn.jscroll = function(m) {
	        return this.each(function() {
	            var $this = $(this),
	                data = $this.data('jscroll'), jscroll;
	
	            // Instantiate jScroll on this element if it hasn't been already
	            if (data && data.initialized) {
	                return;
	            }
	            jscroll = new jScroll($this, m);
	        });
	    };
	
	})(jQuery);
	


/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(69),
	    baseLodash = __webpack_require__(72);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	 * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	 */
	function LodashWrapper(value, chainAll, actions) {
	  this.__wrapped__ = value;
	  this.__actions__ = actions || [];
	  this.__chain__ = !!chainAll;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(285),
	    keys = __webpack_require__(34);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(112),
	    createBaseEach = __webpack_require__(299);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(288),
	    keys = __webpack_require__(34);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(77),
	    metaMap = __webpack_require__(121);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders) {
	  var holdersLength = holders.length,
	      argsIndex = -1,
	      argsLength = nativeMax(args.length - holdersLength, 0),
	      leftIndex = -1,
	      leftLength = partials.length,
	      result = Array(leftLength + argsLength);
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    result[holders[argsIndex]] = args[argsIndex];
	  }
	  while (argsLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 117 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders) {
	  var holdersIndex = -1,
	      holdersLength = holders.length,
	      argsIndex = -1,
	      argsLength = nativeMax(args.length - holdersLength, 0),
	      rightIndex = -1,
	      rightLength = partials.length,
	      result = Array(argsLength + rightLength);
	
	  while (++argsIndex < argsLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    result[offset + holders[holdersIndex]] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(121),
	    noop = __webpack_require__(327);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(55),
	    isIndex = __webpack_require__(42),
	    isObject = __webpack_require__(12);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var getNative = __webpack_require__(54);
	
	/** Native method references. */
	var WeakMap = getNative(global, 'WeakMap');
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 122 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    if (array[index] === placeholder) {
	      array[index] = PLACEHOLDER;
	      result[++resIndex] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(114),
	    now = __webpack_require__(278);
	
	/** Used to detect when a function becomes hot. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity function
	 * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(9),
	    isIndex = __webpack_require__(42),
	    isLength = __webpack_require__(26),
	    isObject = __webpack_require__(12);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 126 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./view/BehindTheScenesHomePage": 133,
		"./view/BehindTheScenesPage": 134,
		"./view/ExhibitionDetailPage": 135,
		"./view/ExhibitionMaterialsPage": 136,
		"./view/PortalPage": 137,
		"./view/ThreeSixtyViewerPage": 138
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 127;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(333);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(263);
	
	__webpack_require__(329);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel/polyfill is allowed");
	}
	global._babelPolyfill = true;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(129);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodashObjectAssign = __webpack_require__(13);
	
	var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);
	
	var _lodashFunctionBindAll = __webpack_require__(25);
	
	var _lodashFunctionBindAll2 = _interopRequireDefault(_lodashFunctionBindAll);
	
	var _lodashObjectHas = __webpack_require__(325);
	
	var _lodashObjectHas2 = _interopRequireDefault(_lodashObjectHas);
	
	var _viewComponentsLightbox = __webpack_require__(143);
	
	var _modelBaseModel = __webpack_require__(79);
	
	var BaseModel = _interopRequireWildcard(_modelBaseModel);
	
	// Configure a dynamic require function to allow requiring any of the Page
	// modules at runtime.
	var dynamicRequire = __webpack_require__(127);
	
	var PAGES = {
	    'portal': 'PortalPage',
	    'exhibition': 'ExhibitionMaterialsPage',
	    'map': 'ExhibitionMaterialsPage',
	    'timeline': 'ExhibitionMaterialsPage',
	    'exhibition-detail': 'ExhibitionDetailPage',
	    'btspost': 'BehindTheScenesPage',
	    'btsindex': 'BehindTheScenesHomePage',
	    '360-viewer': 'ThreeSixtyViewerPage'
	};
	
	var Application = (function () {
	    function Application() {
	        _classCallCheck(this, Application);
	
	        this.initialize();
	    }
	
	    _createClass(Application, [{
	        key: 'initialize',
	        value: function initialize() {
	            (0, _lodashFunctionBindAll2['default'])(this, ['clickBtnToTop', 'clickBtnMobileLocalNavToggle', 'clickBtnToggleCodeInput', 'touchMoveBackdrop', 'resizeHandler', 'modelChangedHandler']);
	
	            this.$el = (0, _jquery2['default'])('body');
	            this.model = new BaseModel.BaseModel();
	
	            // Initialise the appropreate page object for the current page
	            var pageId = this.$el.attr('id');
	
	            if ((0, _lodashObjectHas2['default'])(PAGES, pageId)) {
	                var pageClass = dynamicRequire('./view/' + PAGES[pageId]);
	                this.page = new pageClass({
	                    appModel: this.model
	                });
	            }
	
	            this.bindEvents();
	            this.updateModelMediaQuery();
	            (0, _viewComponentsLightbox.init)();
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            this.$el.on('click', '.js-btn-to-top', this.clickBtnToTop);
	            this.$el.on('click', '.js-local-nav .js-mobile .js-btn-toggle', this.clickBtnMobileLocalNavToggle);
	            this.$el.on('click', '.js-btn-toggle-code-input', this.clickBtnToggleCodeInput);
	
	            this.$el.on('touchmove', '.js-backdrop', this.touchMoveBackdrop);
	
	            (0, _jquery2['default'])(window).on('resize', this.resizeHandler);
	
	            this.model.on('change', this.modelChangedHandler);
	        }
	    }, {
	        key: 'modelChangedHandler',
	        value: function modelChangedHandler() {
	            if (this.model.isChanged('deviceType')) {
	                this.deviceTypeChangedHandler();
	            }
	
	            if (this.model.isChanged('mediaQuery')) {
	                this.mediaQueryChangedHandler();
	            }
	
	            if (this.model.isChanged('backdropped')) {
	                this.backdroppedChangedHandler();
	            }
	        }
	    }, {
	        key: 'clickBtnToggleCodeInput',
	        value: function clickBtnToggleCodeInput(e) {
	            this.toggleCodeInput();
	        }
	    }, {
	        key: 'mediaQueryChangedHandler',
	        value: function mediaQueryChangedHandler() {
	            if (this.model.get('mediaQuery') === 'largeLandscape') {
	                (0, _jquery2['default'])('.js-local-nav ul').removeAttr('style');
	                this.$el.find('.js-code-input').removeAttr('style').data('shown', false);
	            }
	        }
	    }, {
	        key: 'deviceTypeChangedHandler',
	        value: function deviceTypeChangedHandler() {
	            if (this.model.get('deviceType') === 'mobile') {
	                (0, _jquery2['default'])('.js-hero, .js-detail-sidebar').removeAttr('style');
	            }
	            this.model.set('backdropped', false);
	        }
	    }, {
	        key: 'backdroppedChangedHandler',
	        value: function backdroppedChangedHandler() {
	            var backdropped = this.model.get('backdropped');
	
	            if (backdropped === true) {
	                this.$el.prepend((0, _jquery2['default'])('<div class="backdrop js-backdrop" />'));
	            } else {
	                this.$el.find('.js-backdrop').remove();
	            }
	
	            this.$el.toggleClass('backdropped', backdropped);
	        }
	    }, {
	        key: 'clickBtnMobileLocalNavToggle',
	        value: function clickBtnMobileLocalNavToggle(event) {
	            this.toggleLocalMobileNavigation();
	            event.preventDefault();
	        }
	    }, {
	        key: 'clickBtnToTop',
	        value: function clickBtnToTop(event) {
	            this.scrollToTop(150);
	            event.preventDefault();
	        }
	    }, {
	        key: 'resizeHandler',
	        value: function resizeHandler(event) {
	            this.updateModelMediaQuery();
	        }
	    }, {
	        key: 'touchMoveBackdrop',
	        value: function touchMoveBackdrop(event) {
	            event.preventDefault();
	        }
	    }, {
	        key: 'toggleLocalMobileNavigation',
	        value: function toggleLocalMobileNavigation() {
	            this.$el.find('.js-local-nav ul').slideToggle('fast');
	        }
	    }, {
	        key: 'getMediaQueryForWidth',
	        value: function getMediaQueryForWidth(width) {
	            var query = 'largeLandscape';
	
	            if (width <= 420) {
	                query = 'smallPortrait';
	            } else if (width <= 767) {
	                query = 'smallLandscape';
	            } else if (width <= 960) {
	                query = 'largePortrait';
	            }
	
	            return query;
	        }
	    }, {
	        key: 'getDeviceModeForMediaQuery',
	        value: function getDeviceModeForMediaQuery(mediaQuery) {
	            var mode = 'desktop';
	            if (mediaQuery === 'smallLandscape' || mediaQuery === 'smallPortrait') {
	                mode = 'mobile';
	            }
	            return mode;
	        }
	    }, {
	        key: 'updateModelMediaQuery',
	        value: function updateModelMediaQuery() {
	            var currentMediaQuery = this.model.get('mediaQuery'),
	                newMediaQuery = this.getMediaQueryForWidth(document.documentElement.clientWidth);
	
	            if (newMediaQuery !== currentMediaQuery) {
	                this.model.set({
	                    mediaQuery: newMediaQuery,
	                    deviceType: this.getDeviceModeForMediaQuery(newMediaQuery)
	                });
	            }
	        }
	    }, {
	        key: 'toggleCodeInput',
	        value: function toggleCodeInput(show, animated) {
	            var $codeInput = this.$el.find('.js-code-input'),
	                currentlyShown = $codeInput.data('shown'),
	                animateTo;
	
	            show = show !== undefined ? show : !currentlyShown;
	            animated = animated !== undefined ? animated : true;
	
	            if (show !== currentlyShown) {
	
	                animateTo = {
	                    bottom: show === true ? 0 : -$codeInput.find('form').outerHeight()
	                };
	
	                if (animated === true) {
	                    $codeInput.animate(animateTo, 150);
	                } else {
	                    $codeInput.css(animateTo);
	                }
	
	                $codeInput.data('shown', show);
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop(animationTime, callback) {
	            if (animationTime) {
	                (0, _jquery2['default'])('body, html').animate({
	                    'scrollTop': 0
	                }, animationTime, callback);
	            } else {
	                (0, _jquery2['default'])('body, html').scrollTop(0);
	            }
	        }
	    }]);
	
	    return Application;
	})();

	exports.Application = Application;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// Hack webrotate 360 to remove the advertising. We're using it under the terms
	// of the GPL so we can do whatever we like to it.
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.improveWebrotate360 = improveWebrotate360;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _assert = __webpack_require__(128);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _lodashCollectionSize = __webpack_require__(277);
	
	var _lodashCollectionSize2 = _interopRequireDefault(_lodashCollectionSize);
	
	var MOUSE_RIGHT = 3;
	var IMAGE_ROTATOR_INTERVALS = [/*'fl', 'fq', 'aV',*/'oa', 'pp'];
	var CONTEXT_MENU_EVENT_PROP = 'oO';
	
	/**
	 * Stop webrotate 360 wasting CPU time by continuously checking and updating
	 * its HTML.
	 */
	function removeSetIntervals(imageRotator) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = IMAGE_ROTATOR_INTERVALS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var prop = _step.value;
	
	            if (imageRotator[prop] !== 0) {
	                clearInterval(imageRotator[prop]);
	            }
	            imageRotator[prop] = -1;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator['return']) {
	                _iterator['return']();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	/**
	 * Stop webrotate360 blocking the right click context menu.
	 * It stores the 'contextmenu' event name in an obfuscated string. This
	 * function deletes the obfuscated event name to prevent it being bound.
	 */
	function preventContextMenuBlocking(imageRotator) {
	    imageRotator[CONTEXT_MENU_EVENT_PROP] = '';
	}
	
	/**
	 * Stop webrotate 360 showing a custom advertising menu when right clicking.
	 *
	 * @param imageRotator An ImageRotator instance
	 * @param cls The ImageRotator class
	 */
	function disableAnnoyingRightClickMenu(imageRotator, cls) {
	    // The onMouseDown method is used to handle left and right clicks. We only
	    // report left clicks to webrotate360 so it never opens the menu.
	    imageRotator.onMouseDown = function (e) {
	        if (e.which === MOUSE_RIGHT) return;
	        return cls.prototype.onMouseDown.call(imageRotator, e);
	    };
	}
	
	/**
	 * Get a patched version of the ImageRotator class which disables unwanted
	 * webrotate 360 functionality.
	 */
	function getImprovedImageRotator(imageRotatorCls) {
	
	    function ImprovedRotator() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        imageRotatorCls.apply(this, args);
	
	        removeSetIntervals(this);
	        preventContextMenuBlocking(this);
	        disableAnnoyingRightClickMenu(this, ImprovedRotator);
	    }
	    ImprovedRotator.prototype = Object.create(imageRotatorCls);
	    return ImprovedRotator;
	}
	
	/**
	 * Improve the webrotate 360 library by disabling unwanted functionality.
	 */
	
	function improveWebrotate360() {
	    // The strategy used is to use get/set properties to intercept the
	    // ImageRotator class being created by the webrotate code. This is neccisary
	    // as the library pre-creates the first instance of the class before
	    // returning, so we have to patch the ImageRotator after its created, but
	    // before they create the first instance.
	    if (window.WR360 !== undefined) throw new Error('WR360 is already defined, improveWebrotate360() must' + 'be run BEFORE the webrotate 360 script is loaded.');
	
	    var wr360 = {},
	        ImageRotator = undefined;
	
	    Object.defineProperty(window, 'WR360', {
	        enumerable: true,
	        configurable: false,
	        get: function get() {
	            return wr360;
	        },
	        set: function set(val) {
	            (0, _assert2['default'])(typeof val === 'object' && (0, _lodashCollectionSize2['default'])(val) === 0, 'Tried to assign non-empty object to window.WR360, this ' + 'shouldn\'t happen...');
	            // Ignore the attempt to set the value as we always want to use our
	            // own hooked version of WR360.
	        }
	    });
	
	    // Hook the ImageRotator property such that we subclass ImageRotator as it's
	    // being set on the WR360 global, before it has a chance to be used.
	    Object.defineProperty(wr360, 'ImageRotator', {
	        enumerable: true,
	        configurable: false,
	        get: function get() {
	            return ImageRotator;
	        },
	        set: function set(imageRotatorCls) {
	            ImageRotator = getImprovedImageRotator(imageRotatorCls);
	        }
	    });
	}

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(106);
	
	var _componentsJscrollSpin = __webpack_require__(80);
	
	var BehindTheScenesHomePage = (function () {
	    function BehindTheScenesHomePage(options) {
	        _classCallCheck(this, BehindTheScenesHomePage);
	
	        this.$el = (0, _jquery2['default'])(options.el || 'body');
	
	        this.loadingIndicator = new _componentsJscrollSpin.LoadingIndicator();
	        this.setupInfiniteScrolling();
	    }
	
	    _createClass(BehindTheScenesHomePage, [{
	        key: 'setupInfiniteScrolling',
	        value: function setupInfiniteScrolling() {
	            var _this = this;
	
	            this.$el.find('#bts-content .container').jscroll({
	                // This kinda sucks, but jscroll doesn't provide a callback to run
	                // js to create loading HTML so we'll have to make our own callback
	                // by inserting a script tag which calls our function.
	                loadingHtml: this.loadingIndicator.getScriptTagHtml(),
	                nextSelector: '.navi .js-next-link a',
	                contentSelector: '.container > .item-row, .container > .navi',
	                callback: function callback() {
	                    return _this.loadingIndicator.removeSpinner();
	                }
	            });
	        }
	    }]);
	
	    return BehindTheScenesHomePage;
	})();
	
	exports['default'] = BehindTheScenesHomePage;
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll) {
	    'use strict';
	
	    var BehindTheScenesPage = function BehindTheScenesPage(options) {
	        assign(this.options, options);
	
	        this.initialize();
	    };
	
	    assign(BehindTheScenesPage.prototype, {
	        options: {},
	        leftOpen: false,
	        rightOpen: false,
	        initialize: function initialize() {
	            bindAll(this);
	
	            this.$el = $('body');
	            this.checkDevice();
	
	            $('.btn-prev-text span').animate({
	                width: 29
	            }, 100);
	            $('.btn-next-post').animate({
	                width: 29
	            }, 100);
	        },
	        hoverPrevNav: function hoverPrevNav() {
	            if (this.leftOpen === false) {
	                if (this.leftOpen === false) {
	                    $('.btn-prev-post').animate({
	                        width: 125
	                    }, 100);
	                    this.leftOpen = true;
	                }
	            }
	        },
	        unHoverPrevTextNav: function unHoverPrevTextNav() {
	            if (this.leftOpen) {
	                $('.btn-prev-post').animate({
	                    width: 29
	                }, 100);
	                this.leftOpen = true;
	            }
	            this.leftOpen = false;
	        },
	        hoverNextNav: function hoverNextNav() {
	            if (this.rightOpen === false) {
	                $('.btn-next-post').animate({
	                    width: 105
	                }, 100);
	                this.rightOpen = true;
	            }
	        },
	        unHoverNextTextNav: function unHoverNextTextNav() {
	            if (this.rightOpen) {
	                $('.btn-next-post').animate({
	                    width: 29
	                }, 100);
	                this.rightOpen = true;
	            }
	            this.rightOpen = false;
	        },
	        checkDevice: function checkDevice() {
	            if ($('.js').hasClass('touch') === false) {
	                this.$el.on('mouseenter', '#left', this.hoverPrevNav);
	                this.$el.on('mouseleave', '#left', this.unHoverPrevTextNav);
	                this.$el.on('mouseenter', '#right', this.hoverNextNav);
	                this.$el.on('mouseleave', '#right', this.unHoverNextTextNav);
	            }
	        }
	    });
	
	    return BehindTheScenesPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25), __webpack_require__(142), __webpack_require__(18), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll, Zoomer, Hammer) {
	    'use strict';
	
	    var ExhibitionDetailPage = function ExhibitionDetailPage(options) {
	        assign(this.options, options);
	        this.initialize();
	    };
	
	    assign(ExhibitionDetailPage.prototype, {
	        options: {},
	
	        initialize: function initialize() {
	            bindAll(this);
	
	            this.$el = $('body');
	            this.$detailPanel = this.$el.find('.js-detail-panel');
	
	            this.bindEvents();
	            this.initializeZoomingViewer();
	            this.resizeHandler();
	        },
	
	        bindEvents: function bindEvents() {
	            this.$el.on('click', '.js-btn-toggle', this.clickBtnDetailToggle);
	            this.$el.on('click', '.btn-extended-captions', this.clickBtnToggleExtendedCaptions);
	
	            this.$detailPanel.hammer().on('swipe', this.detailPanelSwipe);
	
	            this.options.appModel.on('change', this.modelChangedHandler);
	            $(window).resize(this.resizeHandler);
	        },
	
	        clickBtnToggleExtendedCaptions: function clickBtnToggleExtendedCaptions(event) {
	            this.toggleExtendedCaptions();
	        },
	
	        detailPanelSwipe: function detailPanelSwipe(event) {
	            if (this.options.appModel.get('deviceType') === 'desktop') {
	                if (event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) {
	                    var opening = event.gesture.direction === Hammer.DIRECTION_LEFT;
	                    this.toggleDetailPanel(opening);
	                }
	            }
	        },
	
	        resizeHandler: function resizeHandler() {
	            var $navBar = this.$el.find('#nav-bar'),
	                $content = this.$el.find('#content');
	
	            $content.height($(window).height() - $navBar.height());
	        },
	
	        modelChangedHandler: function modelChangedHandler() {
	            if (this.options.appModel.isChanged('deviceType')) {
	                this.deviceTypeChangedHandler();
	            }
	        },
	
	        deviceTypeChangedHandler: function deviceTypeChangedHandler() {
	            var deviceType = this.options.appModel.get('deviceType');
	            this.$el.find('.mobile.js-btn-toggle').removeClass('active');
	            this.$el.find('.js-btn-toggle:not(.mobile)').removeClass('inverted-arrow-icon');
	            this.$detailPanel.removeAttr('style').data('shown', deviceType === 'desktop');
	        },
	
	        clickBtnDetailToggle: function clickBtnDetailToggle(event) {
	            this.toggleDetailPanel();
	            event.preventDefault();
	        },
	
	        toggleDetailPanel: function toggleDetailPanel(show, animate) {
	            var animateTo = {};
	
	            show = show !== undefined ? show : !this.$detailPanel.data('shown');
	            animate = animate !== undefined ? animate : true;
	
	            if (show !== this.$detailPanel.data('shown')) {
	                if (this.options.appModel.get('deviceType') === 'mobile') {
	                    animateTo.bottom = show === true ? '0%' : '-100%';
	                    $('.mobile.toggle-btn').toggleClass('active', show);
	                } else {
	                    animateTo.right = show === true ? 0 : -344;
	                    $('.js-btn-toggle:not(.mobile)').toggleClass('inverted-arrow-icon', !show);
	                }
	
	                if (animate) {
	                    this.$detailPanel.stop().animate(animateTo, 250);
	                } else {
	                    this.$detailPanel.css(animateTo);
	                }
	
	                this.$detailPanel.data('shown', show);
	            }
	        },
	
	        initializeZoomingViewer: function initializeZoomingViewer() {
	            var $zoomer = $('#zoomer'),
	                zoomer;
	
	            zoomer = new Zoomer.Zoomer({
	                $el: $zoomer,
	                configureViewerFromDataAttribute: true,
	                // Specify additional OpenSeadragon.Viewer options here
	                viewerOptions: {}
	            });
	            zoomer.openTileSourceFromDataAttribute();
	        },
	
	        toggleExtendedCaptions: function toggleExtendedCaptions() {
	            var $extendedCaption = this.$el.find('.js-long-caption'),
	                $shortCaption = this.$el.find('.js-short-caption'),
	                show = !$extendedCaption.is(':visible'),
	                btnText = 'Shortcaptions';
	
	            if ($extendedCaption.is(':animated') === false && $shortCaption.is(':animated') === false) {
	                if (show === false) {
	                    btnText = 'Extended captions';
	                    $extendedCaption.stop().slideToggle(300, function () {
	                        $shortCaption.stop().slideToggle(300);
	                    });
	                } else {
	                    $shortCaption.stop().slideToggle(300, function () {
	                        $extendedCaption.stop().slideToggle(300);
	                    });
	                }
	            }
	
	            this.$el.find('.btn-extended-captions').text(btnText).removeClass(show ? 'read-less' : 'read-more').addClass(show ? 'read-more' : 'read-less');
	        }
	    });
	
	    return ExhibitionDetailPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25), __webpack_require__(141), __webpack_require__(18), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll, Twitter, Hammer) {
	    'use strict';
	
	    var ExhibitionMaterialsPage = function ExhibitionMaterialsPage(options) {
	        assign(this.options, options);
	        this.initialize();
	    };
	
	    assign(ExhibitionMaterialsPage.prototype, {
	        initialize: function initialize() {
	
	            var $jsSocial = $('.js-social'),
	                hashtag = $jsSocial.data('hashtag'),
	                proxyUrl = $jsSocial.data('twitter-proxy-url');
	
	            bindAll(this);
	            this.$el = $('body');
	            this.bindEvents();
	            this.origHeroHeight = 0;
	            this.heroHeight = 0;
	            this.heroLineHeight = parseInt($('.hero-content').css('line-height'), 10);
	            this.smallHeroHeight = 300;
	            if (this.smallHeroHeight % 20 !== 0) {
	                while (this.smallHeroHeight % 20 !== 0) {
	                    this.smallHeroHeight += 1;
	                }
	            }
	            this.readMore = false;
	
	            if (hashtag && proxyUrl !== undefined) {
	                this.twitter = new Twitter.Twitter({
	                    ht: '%23' + hashtag,
	                    classAppend: '.jstwitter',
	                    proxyUrl: proxyUrl
	                });
	            }
	        },
	        bindEvents: function bindEvents() {
	            // Clicking the arrows of the desktop themes navigation
	            this.$el.on('click', '.js-themes-nav .js-btn-next', this.clickBtnNextThemeNav);
	            this.$el.on('click', '.js-themes-nav .js-btn-prev', this.clickBtnPrevThemeNav);
	            // Swiping the desktop version of the themes navigation
	            this.$el.find('.js-themes-nav-container').hammer().on('swipe', this.swipeThemesNav);
	
	            // Clicking + touchmobile the mobile version of the themes navigation
	            this.$el.on('click', '.js-mobile.js-btn-toggle-themes-nav', this.clickBtnMobileThemesNavToggle);
	            this.$el.on('touchmove', '.js-mobile.js-btn-toggle-themes-nav', this.touchMoveBtnToggleThemesNav);
	
	            // Toggling the hero information panel
	            this.$el.on('click', '.js-hero .js-toggle-btn', this.clickBtnHeroToggle);
	            this.$el.find('.js-hero').hammer().on('swipe', this.swipeHero);
	
	            // Appmodel change
	            this.options.appModel.on('change', this.appModelChangedHandler);
	
	            // Clicking on readmore/readless
	            this.$el.on('click', '.read-more', this.toggleReadMoreLess);
	            this.$el.on('click', '.read-less', this.toggleReadMoreLess);
	
	            //Browser width detection
	            $(window).bind('resize', this.widthChangeDetection);
	            this.originalScreen = true;
	        },
	
	        clickBtnHeroToggle: function clickBtnHeroToggle(event) {
	            this.toggleHero();
	        },
	
	        swipeHero: function swipeHero(event) {
	            if (this.options.appModel.get('deviceType') === 'desktop') {
	                if (event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) {
	                    this.toggleHero(event.gesture.direction === Hammer.DIRECTION_LEFT);
	                }
	            }
	        },
	
	        toggleHero: function toggleHero(show, animate) {
	            var animateTo = {},
	                $hero = $('.js-hero'),
	                currentlyShown = $hero.data('shown');
	
	            show = show !== undefined ? show : !currentlyShown;
	            animate = animate !== undefined ? animate : true;
	
	            if (show !== currentlyShown) {
	                animateTo.marginRight = show === true ? 0 : -$hero.outerWidth();
	
	                if (animate) {
	                    $hero.animate(animateTo, 150);
	                } else {
	                    $hero.css(animateTo);
	                }
	
	                $hero.find('.js-toggle-btn').toggleClass('inverted-arrow-icon', !show);
	                $hero.data('shown', show);
	            }
	        },
	
	        swipeThemesNav: function swipeThemesNav(event) {
	            if (event.gesture.direction & Hammer.DIRECTION_HORIZONTAL && this.options.appModel.get('deviceType') === 'desktop') {
	
	                this.scrollThemeNavigation(event.gesture.direction === Hammer.DIRECTION_LEFT);
	            }
	        },
	
	        appModelChangedHandler: function appModelChangedHandler() {
	            if (this.options.appModel.isChanged('deviceType')) {
	                this.deviceTypeChangedHandler();
	            }
	            if (this.options.appModel.isChanged('mediaQuery')) {
	                this.queryChangedHandler();
	            }
	        },
	
	        deviceTypeChangedHandler: function deviceTypeChangedHandler() {
	            var device = this.options.appModel.get('deviceType'),
	                firstRun = this.options.appModel.prev('deviceType') === undefined,
	                self = this,
	                content;
	            $('.js-hero .js-toggle-btn').removeClass('inverted-arrow-icon');
	            if (device === 'desktop') {
	                this.setBackgroundOnElement($('.js-hero').data('background-image-url'), $('.js-hero-background'));
	                this.$el.find('.js-hero').removeAttr('style').data('shown', true);
	                $('.hero-content > .moreless > *').first().unwrap();
	                $('.hero-content .read-more').remove();
	                this.readMore = false;
	                if (firstRun === false) {
	                    $('.js-themes-nav .container, .js-btn-toggle-themes-nav').removeAttr('style');
	                    $('.js-btn-toggle-themes-nav').removeClass('active');
	                    this.removeBackgroundFromElement($('.js-hero-mobile-background'));
	                }
	            } else {
	                self.originalScreen = true;
	                $('.read-less').text('READ MORE');
	                $('.read-less').addClass('read-more').removeClass('read-less');
	                self.origHeroHeight = $('.hero-content').height();
	                self.heroHeight = $('.hero-content').height();
	                if (self.heroHeight > self.smallHeroHeight + 50) {
	                    content = $('.hero-content').wrapInner('<div class="moreless less">');
	                    $('.moreless').after('<a class="mobile read-more" href="javascript:;">Read more</a>');
	                    $('.moreless').css('height', self.smallHeroHeight + 'px');
	                    this.setBackgroundOnElement($('.js-hero').data('background-image-url'), $('.js-hero-mobile-background'));
	                    if (firstRun === false) {
	                        this.removeBackgroundFromElement($('.js-hero-background'));
	                    }
	                }
	            }
	        },
	        queryChangedHandler: function queryChangedHandler() {
	            var query = this.options.appModel.get('mediaQuery'),
	                self = this;
	            if (query === 'smallPortrait') {
	                if (self.originalScreen === false) {
	                    self.heroHeight += 180;
	                }
	                if (self.readMore === true) {
	                    $('.moreless').css('height', self.heroHeight + 'px');
	                }
	                self.originalScreen = false;
	            } else {
	                if (self.originalScreen === false) {
	                    self.heroHeight -= 180;
	                }
	                if (self.readMore === true) {
	                    $('.moreless').css('height', self.heroHeight + 'px');
	                }
	                self.originalScreen = false;
	            }
	        },
	        setBackgroundOnElement: function setBackgroundOnElement(backgroundUrl, $el) {
	            $el.css('background-image', 'url(' + backgroundUrl + ')');
	        },
	
	        removeBackgroundFromElement: function removeBackgroundFromElement($el) {
	            $el.css('background-image', 'none');
	        },
	
	        touchMoveBtnToggleThemesNav: function touchMoveBtnToggleThemesNav(event) {
	            event.preventDefault();
	        },
	
	        clickBtnPrevThemeNav: function clickBtnPrevThemeNav(event) {
	            this.scrollThemeNavigation(false);
	            event.preventDefault();
	        },
	
	        clickBtnMobileThemesNavToggle: function clickBtnMobileThemesNavToggle(event) {
	            this.toggleMobileThemesNavigation();
	            event.preventDefault();
	        },
	
	        clickBtnNextThemeNav: function clickBtnNextThemeNav(event) {
	            this.scrollThemeNavigation(true);
	            event.preventDefault();
	        },
	
	        scrollThemeNavigation: function scrollThemeNavigation(forwards) {
	            var movement = $('.js-themes-nav li').outerWidth(true) * 6,
	                $themesNavUl = $('.js-themes-nav ul');
	
	            if (forwards === false) {
	                movement *= -1;
	            }
	
	            $themesNavUl.stop().animate({
	                scrollLeft: $themesNavUl.scrollLeft() + movement
	            }, 400);
	        },
	
	        toggleMobileThemesNavigation: function toggleMobileThemesNavigation() {
	            var $themesNavContainer = this.$el.find('.js-themes-nav-container'),
	                $btnThemesNav = this.$el.find('.js-mobile.js-btn-toggle-themes-nav'),
	                currentScrollPosition = this.$el.scrollTop(),
	                currentlyShown = $btnThemesNav.hasClass('active'),
	                self = this,
	                toggle = function toggle() {
	                $btnThemesNav.stop().animate({
	                    left: currentlyShown === true ? 0 : $themesNavContainer.outerWidth()
	                }, 'fast');
	                $themesNavContainer.stop().animate({
	                    left: currentlyShown === true ? -$themesNavContainer.outerWidth() : 0
	                }, 'fast');
	
	                self.options.appModel.set('backdropped', !currentlyShown);
	            };
	
	            if (this.$el.scrollTop() !== 0) {
	                $('body, html').animate({
	                    'scrollTop': 0
	                }, 150, toggle);
	            } else {
	                toggle();
	            }
	
	            $btnThemesNav.toggleClass('active', !currentlyShown);
	        },
	        toggleReadMoreLess: function toggleReadMoreLess() {
	            var self = this;
	            if (this.readMore) {
	                this.readMore = false;
	                $('.read-less').text('READ MORE');
	                $('.read-less').addClass('read-more').removeClass('read-less');
	                $('.moreless').animate({ height: self.smallHeroHeight + 'px' }, 200);
	            } else {
	                this.readMore = true;
	                $('.read-more').text('READ LESS');
	                $('.read-more').addClass('read-less').removeClass('read-more');
	                $('.moreless').animate({ height: self.heroHeight + 'px' }, 200, function () {
	                    // Ensure the expanded text is always full height after the
	                    // animation (the height is not currently correct if the
	                    // page width is resized after load...).
	                    $(this).css({ height: '' });
	                });
	            }
	        },
	
	        options: {}
	    });
	
	    return ExhibitionMaterialsPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(106);
	
	__webpack_require__(53);
	
	var _hammerjs = __webpack_require__(18);
	
	var _hammerjs2 = _interopRequireDefault(_hammerjs);
	
	var _lodashObjectAssign = __webpack_require__(13);
	
	var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);
	
	var _lodashFunctionBindAll = __webpack_require__(25);
	
	var _lodashFunctionBindAll2 = _interopRequireDefault(_lodashFunctionBindAll);
	
	var _componentsBackgroundSlider = __webpack_require__(139);
	
	var _componentsBackgroundSlider2 = _interopRequireDefault(_componentsBackgroundSlider);
	
	var _componentsFacebook = __webpack_require__(140);
	
	var _componentsFacebook2 = _interopRequireDefault(_componentsFacebook);
	
	var _componentsJscrollSpin = __webpack_require__(80);
	
	var PortalPage = (function () {
	    function PortalPage() {
	        _classCallCheck(this, PortalPage);
	
	        this.initialize();
	    }
	
	    _createClass(PortalPage, [{
	        key: 'initialize',
	        value: function initialize() {
	            this.$el = (0, _jquery2['default'])('body');
	
	            (0, _lodashFunctionBindAll2['default'])(this, ['clickBtnNextExhibition', 'clickBtnPrevExhibition', 'carouselNavClickHandler', 'carouselSwipeHandler']);
	
	            this.backgroundSlider = new _componentsBackgroundSlider2['default'].BackgroundSlider({
	                $el: (0, _jquery2['default'])('#hero')
	            });
	
	            (0, _jquery2['default'])('.fb-share').each(function (index, item) {
	                var fb = new _componentsFacebook2['default'].Facebook({
	                    $el: (0, _jquery2['default'])(this),
	                    link: (0, _jquery2['default'])(this).data('fb-link')
	                });
	            });
	
	            this.$carouselItems = (0, _jquery2['default'])('.js-carousel-nav a');
	            this.activeItem = 0;
	            this.bindEvents();
	            this.moveCarousel(undefined, 0);
	
	            this.loadingIndicator = new _componentsJscrollSpin.LoadingIndicator();
	            this.setupInfiniteScrolling();
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            this.$el.on('click', '.js-btn-next-exhibition', this.clickBtnNextExhibition);
	            this.$el.on('click', '.js-btn-prev-exhibition', this.clickBtnPrevExhibition);
	            this.$el.on('click', '.js-carousel-nav a', this.carouselNavClickHandler);
	
	            this.$el.find('.js-hero').hammer().on('swipe', this.carouselSwipeHandler);
	        }
	    }, {
	        key: 'carouselSwipeHandler',
	        value: function carouselSwipeHandler(event) {
	            var direction = 'previous';
	
	            if (event.gesture.direction & _hammerjs2['default'].DIRECTION_HORIZONTAL) {
	                if (event.gesture.direction === _hammerjs2['default'].DIRECTION_LEFT) {
	                    direction = 'next';
	                }
	
	                this.moveCarousel(direction);
	            }
	        }
	    }, {
	        key: 'carouselNavClickHandler',
	        value: function carouselNavClickHandler(event) {
	            var clickedIndex = this.$carouselItems.index(event.currentTarget),
	                direction = 'next';
	
	            if (clickedIndex !== this.activeItem) {
	                if (clickedIndex < this.activeItem) {
	                    direction = 'previous';
	                }
	
	                this.moveCarousel(direction, clickedIndex);
	            }
	        }
	    }, {
	        key: 'getRelativeCarouselItemIndex',
	        value: function getRelativeCarouselItemIndex(relation) {
	            var activeItem = this.activeItem,
	                relativeItem;
	
	            relativeItem = activeItem + 1;
	            if (relation === 'previous') {
	                if (activeItem === 0) {
	                    relativeItem = this.$carouselItems.length - 1;
	                } else {
	                    relativeItem = this.activeItem - 1;
	                }
	            } else if (activeItem === this.$carouselItems.length - 1) {
	                relativeItem = 0;
	            }
	
	            return relativeItem;
	        }
	    }, {
	        key: 'moveCarousel',
	        value: function moveCarousel(direction, itemIndex) {
	            if (this.backgroundSlider.model.get('sliding') !== true) {
	                itemIndex = itemIndex !== undefined ? itemIndex : this.getRelativeCarouselItemIndex(direction);
	
	                var self = this,
	                    $carouselInfo = self.$el.find('.js-carousel-info > div'),
	                    $item = (0, _jquery2['default'])(this.$carouselItems[itemIndex]),
	                    $titleWrap = self.$el.find('.js-carousel-title');
	
	                $titleWrap.stop().animate({
	                    opacity: 0
	                }, 300);
	
	                this.backgroundSlider.slideToNewBackgroundImage(direction, $item.data('image-url'), function () {
	                    $titleWrap.html($item.data('info-text')).append((0, _jquery2['default'])('<strong />').text($item.text()));
	
	                    (0, _jquery2['default'])('.js-btn-view-exhibition.virtual').attr('href', $item.data('exhibition-url-virtual')).toggle(!!$item.data('exhibition-url-virtual'));
	
	                    (0, _jquery2['default'])('.js-btn-view-exhibition.physical').attr('href', $item.data('exhibition-url-physical')).toggle(!!$item.data('exhibition-url-physical'));
	
	                    self.$carouselItems.removeClass('active');
	                    $item.addClass('active');
	
	                    self.activeItem = itemIndex;
	
	                    $titleWrap.stop().animate({
	                        opacity: 1
	                    }, 500);
	                });
	            }
	        }
	    }, {
	        key: 'clickBtnNextExhibition',
	        value: function clickBtnNextExhibition() {
	            this.moveCarousel('next');
	        }
	    }, {
	        key: 'clickBtnPrevExhibition',
	        value: function clickBtnPrevExhibition() {
	            this.moveCarousel('previous');
	        }
	    }, {
	        key: 'setupInfiniteScrolling',
	        value: function setupInfiniteScrolling() {
	            var _this = this;
	
	            this.$el.find('#exhibition-list').jscroll({
	                // This kinda sucks, but jscroll doesn't provide a callback to run
	                // js to create loading HTML so we'll have to make our own callback
	                // by inserting a script tag which calls our function.
	                loadingHtml: this.loadingIndicator.getScriptTagHtml(),
	                nextSelector: '.navi .js-next-link a',
	                contentSelector: '#exhibition-list > *',
	                callback: function callback() {
	                    return _this.loadingIndicator.removeSpinner();
	                }
	            });
	        }
	    }]);
	
	    return PortalPage;
	})();
	
	exports['default'] = PortalPage;
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(265)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign) {
	    'use strict';
	
	    function getWordpressViewerConfig() {
	        if (!window.__virtualexhibitions360Viewer) {
	            throw new Error('Wordpress didn\'t set __virtualexhibitions360Viewer global');
	        }
	        return window.__virtualexhibitions360Viewer;
	    }
	
	    var ThreeSixtyViewerPage = function ThreeSixtyViewerPage(options) {
	        this.options = assign({}, this.defaultOptions(), options || {});
	
	        this.$el = $(this.options.el);
	        this.$viewer = $('.wr360_player');
	        this.createViewer();
	    };
	
	    assign(ThreeSixtyViewerPage.prototype, {
	        defaultOptions: function defaultOptions() {
	            return assign({
	                el: 'body'
	            }, getWordpressViewerConfig());
	        },
	
	        createViewer: function createViewer() {
	            this.$viewer.rotator({
	                // There is no license file for the free version, so no point
	                // in making an ajax request. So we use an empty data URL.
	                licenseFileURL: "data:text/plain;base64,",
	                configFileURL: this.options.configUrl,
	                graphicsPath: this.options.graphicsUrl,
	                zIndexLayersOn: true,
	                rootPath: '/blah/'
	            });
	        }
	    });
	
	    return ThreeSixtyViewerPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25), __webpack_require__(79)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll, BaseModel) {
	    'use strict';
	
	    var BackgroundSlider = function BackgroundSlider(options) {
	        assign(this.options, options);
	        this.$el = options.$el;
	        this.initialize();
	    };
	
	    assign(BackgroundSlider.prototype, {
	        initialize: function initialize() {
	            bindAll(this);
	
	            this.model = new BaseModel.BaseModel();
	            this.$backgroundHolder = this.$el.find('.js-background-slider');
	
	            if (this.$backgroundHolder.length <= 0) {
	                this.$backgroundHolder = this.createBackgroundElement();
	                this.$el.prepend(this.$backgroundHolder);
	            }
	
	            this.bindEvents();
	        },
	
	        bindEvents: function bindEvents() {
	            this.model.on('change', this.modelChangedHandler);
	        },
	
	        modelChangedHandler: function modelChangedHandler() {
	            if (this.model.isChanged('sliding')) {
	                if (this.model.get('sliding') === true) {
	                    this.changeBackground();
	                } else if (this.queue.length > 0) {
	                    this.model.set(this.queue.shift());
	                }
	            }
	        },
	
	        changeBackground: function changeBackground() {
	            var self = this,
	                $newBackgroundHolder = this.createNewBackgroundElementFromUrl(this.model.get('backgroundUrl')),
	                callback = self.model.get('callback'),
	                onFinish = function onFinish() {
	                self.$backgroundHolder.remove();
	                self.$backgroundHolder = $newBackgroundHolder;
	
	                if (typeof callback === 'function') {
	                    callback.call();
	                }
	
	                self.model.set('sliding', false);
	            };
	
	            if (this.model.get('direction')) {
	                this.slideToNewBackground(this.$backgroundHolder, $newBackgroundHolder, this.model.get('direction'), onFinish);
	            } else {
	                self.$backgroundHolder.after($newBackgroundHolder);
	                onFinish();
	            }
	        },
	
	        createNewBackgroundElementFromUrl: function createNewBackgroundElementFromUrl(url) {
	            return this.applyBackgroundImageToElement(url, this.createBackgroundElement());
	        },
	
	        slideToNewBackground: function slideToNewBackground($fromBackground, $toBackground, slideDirection, callback) {
	            var toBackgroundStartPosition = '100%',
	                fromBackgroundEndPosition = '-100%';
	
	            $fromBackground.after($toBackground);
	
	            if (slideDirection === 'previous') {
	                toBackgroundStartPosition = fromBackgroundEndPosition;
	                fromBackgroundEndPosition = '100%';
	            }
	
	            $fromBackground.css({
	                right: 'auto',
	                left: 0
	            });
	
	            $toBackground.css({
	                right: 'auto',
	                left: toBackgroundStartPosition
	            });
	
	            $fromBackground.animate({
	                left: fromBackgroundEndPosition
	            }, 'slow');
	
	            $toBackground.animate({
	                left: 0
	            }, 'slow', callback);
	        },
	
	        applyBackgroundImageToElement: function applyBackgroundImageToElement(url, $element) {
	            return $element.css({
	                backgroundImage: 'url(' + url + ')'
	            });
	        },
	
	        createBackgroundElement: function createBackgroundElement() {
	            return $('<div class="js-background-slider background-slider" />');
	        },
	
	        slideToNewBackgroundImage: function slideToNewBackgroundImage(direction, url, callback) {
	            var slideData = {
	                direction: direction,
	                backgroundUrl: url,
	                sliding: true,
	                callback: callback
	            };
	
	            if (this.model.get('sliding') !== true) {
	                this.model.set(slideData);
	            } else if (this.options.enableQueue === true) {
	                this.queue.push(slideData);
	            }
	        },
	
	        queue: [],
	
	        options: {}
	    });
	
	    return {
	        BackgroundSlider: BackgroundSlider
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll) {
	    'use strict';
	    var Facebook,
	        facebookInitialized = false;
	
	    Facebook = function (options) {
	        assign(this, options);
	
	        if (facebookInitialized === false) {
	            this.initFacebook();
	            facebookInitialized = true;
	        }
	
	        this.init();
	    };
	
	    assign(Facebook.prototype, {
	        init: function init() {
	            bindAll(this);
	            this.bindEvents();
	        },
	
	        initFacebook: function initFacebook() {
	            // Load external FB script
	            var fbScript = document.createElement('script');
	            fbScript.type = 'text/javascript';
	            fbScript.src = document.location.protocol + '//connect.facebook.net/en_US/all.js';
	            fbScript.async = true;
	            $('head').append(fbScript);
	
	            window.fbAsyncInit = function () {
	                FB.init({ appId: '412961045463060', status: true, cookie: true, xfbml: true, oauth: true });
	                FB.Event.subscribe('auth.login', function (response) {
	                    Facebook.prototype.login();
	                });
	                FB.Event.subscribe('auth.logout', function (response) {
	                    Facebook.prototype.logout();
	                });
	                FB.getLoginStatus(function (response) {
	                    if (response.session) {
	                        Facebook.prototype.greet();
	                    }
	                });
	            };
	        },
	
	        bindEvents: function bindEvents() {
	            this.$el.on('click', this.onShareClick);
	        },
	
	        onShareClick: function onShareClick(event) {
	            this.share();
	        },
	
	        login: function login() {
	            FB.api('/me', function (response) {});
	        },
	
	        logout: function logout() {},
	
	        greet: function greet() {
	            FB.api('/me', function (response) {});
	        },
	
	        share: function share() {
	            var share = {
	                method: 'stream.share',
	                u: this.link
	            };
	
	            FB.ui(share, function (response) {});
	        }
	    });
	
	    return {
	        Facebook: Facebook
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, hammer) {
	    'use strict';
	    var Twitter = function Twitter(options) {
	        this.hashtag = options.ht;
	        this.appendTo = options.classAppend;
	        this.proxyUrl = options.proxyUrl;
	        this.initialize();
	    };
	    assign(Twitter.prototype, {
	        oldPage: 1,
	        currentPage: 1,
	        hashtag: '',
	        numTweets: 9,
	        appendTo: '',
	        initialize: function initialize() {
	            //navigation and twitter-info
	            $(this.appendTo).after('<nav><div class="twit-nav"></div></nav>');
	            $(this.appendTo).parent().after('<div class="twitter-info"><div><p>Use <a href="twitterlink" target="_blank"><strong class="twit-hashtag"></strong></a> to leave a message via twitter</p></div></div>');
	            //Change hashtag in twitter info
	            var ht = this.hashtag.replace('%23', '#');
	            $('.twit-hashtag').text(ht);
	            //Change link to chosen hashtag
	            $('a[href="twitterlink"]').attr('href', 'http://www.twitter.com/home?status=' + this.hashtag);
	            this.loadTweets();
	        },
	        loadTweets: function loadTweets() {
	            var self = this;
	            $.ajax({
	                url: this.proxyUrl,
	                type: 'GET',
	                dataType: 'json',
	                timeout: 5000,
	                success: function success(data, textStatus, xhr) {
	                    var retrievedData = [],
	                        singleUserData = [],
	                        i;
	                    for (i = 0; i < data.results.length; i += 1) {
	                        singleUserData = {};
	                        singleUserData.profilelink = data.results[i].from_user;
	                        singleUserData.imagesource = data.results[i].profile_image_url;
	                        singleUserData.tweettext = Twitter.prototype.ify.clean(data.results[i].text);
	                        singleUserData.fromfullname = data.results[i].from_user_name;
	                        singleUserData.fromuser = data.results[i].from_user;
	                        singleUserData.ago = Twitter.prototype.relativeTime(data.results[i].created_at);
	                        retrievedData[i] = singleUserData;
	                    }
	                    self.generatePages(retrievedData);
	                    setTimeout(this.loadTweets, 600000);
	                },
	                error: function error(jqXHR, textStatus, _error) {
	                    $(self.appendTo).append("<p>Couldn't reach the Twitter server. Please try again later.</p>");
	                }
	            });
	        },
	        generatePages: function generatePages(data) {
	            var pageCount = 1,
	                ht = this.hashtag;
	            if (data.length === 0) {
	                $('.twitter-info').addClass('notweets');
	                $('.notweets').text("");
	                $('.notweets').append('<div><p>No tweets posted yet! Use <a href="twitterlink" target="_blank"><strong class="twit-hashtag"></strong></a> to leave a message via Twitter.</p></div>');
	                ht = ht.replace('%23', '#');
	                $('.twit-hashtag').text(ht);
	                //Change link to chosen hashtag
	                $('a[href="twitterlink"]').attr('href', 'http://www.twitter.com/home?status=' + this.hashtag);
	            }
	            if (data.length < 4) {
	                pageCount = 1;
	                this.addTweets(data, pageCount);
	            } else if (data.length > 3 && data.length < 7) {
	                pageCount = 2;
	                $('.twit-nav').empty();
	                $('.twit-nav').append('<a href="javascript:;" class="twit-page1"></a><a href="javascript:;" class="twit-page2"></a>');
	                this.addTweets(data, pageCount);
	            } else if (data.length > 6) {
	                pageCount = 3;
	                $('.twit-nav').empty();
	                $('.twit-nav').append('<a href="javascript:;" class="twit-page1"></a><a href="javascript:;" class="twit-page2"></a><a href="javascript:;" class="twit-page3"></a>');
	                this.addTweets(data, pageCount);
	            }
	            this.generateClickHandlers(data, pageCount);
	        },
	        /*Twitter navigation*/
	        generateClickHandlers: function generateClickHandlers(data, pages) {
	            var self = this,
	                page1,
	                page2,
	                page3;
	            if (pages === 2) {
	                page1 = $('.twit-page1');
	                page2 = $('.twit-page2');
	            }
	            if (pages === 3) {
	                page1 = $('.twit-page1');
	                page2 = $('.twit-page2');
	                page3 = $('.twit-page3');
	            }
	            if (page1 !== undefined) {
	                page1.click(function () {
	                    self.oldPage = self.currentPage;
	                    self.currentPage = 1;
	                    var diff = self.oldPage - self.currentPage;
	                    self.animate(diff, data, pages);
	                });
	            }
	            if (page2 !== undefined) {
	                page2.click(function () {
	                    self.oldPage = self.currentPage;
	                    self.currentPage = 2;
	                    var diff = self.oldPage - self.currentPage;
	                    self.animate(diff, data, pages);
	                });
	            }
	            if (page3 !== undefined) {
	                page3.click(function () {
	                    self.oldPage = self.currentPage;
	                    self.currentPage = 3;
	                    var diff = self.oldPage - self.currentPage;
	                    self.animate(diff, data, pages);
	                });
	            }
	            $('.jstwitter').hammer().on('swipe', function (event) {
	                if (event.gesture.direction === 'left') {
	                    if (pages === 3) {
	                        if (self.currentPage !== 3) {
	                            self.oldPage = self.currentPage;
	                            self.currentPage += 1;
	                            self.animate(-1, data, pages);
	                        }
	                    }
	                    if (pages === 2) {
	                        if (self.currentPage !== 2) {
	                            self.oldPage = self.currentPage;
	                            self.currentPage += 1;
	                            self.animate(-1, data, pages);
	                        }
	                    }
	                }
	                if (event.gesture.direction === 'right') {
	                    if (self.currentPage !== 1) {
	                        self.oldPage = self.currentPage;
	                        self.currentPage -= 1;
	                        self.animate(1, data, pages);
	                    }
	                }
	            });
	        },
	        animate: function animate(diff, data, pages) {
	            //Set Navigation
	            var self = this,
	                i;
	            for (i = 1; i < pages + 1; i += 1) {
	                $('.twit-page' + i).removeClass('active');
	            }
	            $('.twit-page' + this.currentPage).addClass('active');
	            if (diff === 1) {
	                $('.jstwitter').animate({
	                    opacity: '0',
	                    left: '+=200'
	                }, 100, function () {
	                    $('.jstwitter').empty();
	                    $('.jstwitter').css({
	                        left: '-=500'
	                    });
	                    $('.jstwitter').animate({
	                        opacity: 1,
	                        left: '+=300'
	                    });
	                    self.addTweets(data, pages);
	                });
	            }
	            if (diff === -1) {
	                $('.jstwitter').animate({
	                    opacity: '0',
	                    left: '-=200'
	                }, 100, function () {
	                    $('.jstwitter').empty();
	                    $('.jstwitter').css({
	                        left: '+=500'
	                    });
	                    $('.jstwitter').animate({
	                        opacity: 1,
	                        left: '-=300'
	                    });
	                    self.addTweets(data, pages);
	                });
	            }
	            if (diff === 2) {
	                $('.jstwitter').animate({
	                    opacity: '0',
	                    left: '+=200'
	                }, 100, function () {
	                    $('.jstwitter').empty();
	                    $('.jstwitter').css({
	                        left: '-=500'
	                    });
	                    $('.jstwitter').animate({
	                        opacity: 1,
	                        left: '+=300'
	                    });
	                    self.addTweets(data, pages);
	                });
	            }
	            if (diff === -2) {
	                $('.jstwitter').animate({
	                    opacity: '0',
	                    left: '-=200'
	                }, 100, function () {
	                    $('.jstwitter').empty();
	                    $('.jstwitter').css({
	                        left: '+=500'
	                    });
	                    $('.jstwitter').animate({
	                        opacity: 1,
	                        left: '-=300'
	                    });
	                    self.addTweets(data, pages);
	                });
	            }
	        },
	        addTweets: function addTweets(data, pages) {
	            var self = this,
	                i;
	            $('.jstwitter').empty();
	            if (this.currentPage === 1) {
	                $('.twit-page1').addClass('active');
	            }
	            if (this.currentPage === 2) {
	                $('.twit-page2').addClass('active');
	            }
	            if (this.currentPage === 3) {
	                $('.twit-page3').addClass('active');
	            }
	            if (pages === 1) {
	                for (i = 0; i < data.length; i += 1) {
	                    self.appendTweets(data, i);
	                }
	            }
	            if (pages === 2) {
	                if (this.currentPage === 1) {
	                    for (i = 0; i < 3; i += 1) {
	                        self.appendTweets(data, i);
	                    }
	                }
	                if (this.currentPage === 2) {
	                    for (i = 3; i < 6; i += 1) {
	                        self.appendTweets(data, i);
	                    }
	                }
	            }
	            if (pages === 3) {
	                if (this.currentPage === 1) {
	                    for (i = 0; i < 3; i += 1) {
	                        self.appendTweets(data, i);
	                    }
	                }
	                if (this.currentPage === 2) {
	                    for (i = 3; i < 6; i += 1) {
	                        self.appendTweets(data, i);
	                    }
	                }
	                if (this.currentPage === 3) {
	                    for (i = 6; i < 9; i += 1) {
	                        self.appendTweets(data, i);
	                    }
	                }
	            }
	        },
	        appendTweets: function appendTweets(data, i) {
	
	            var html = ' <article><a href="PROFILELINK" target="_blank"><img src="IMGSOURCE" alt="FROMUSER twitter avatar" /></a><div class="comment-content"><div class="arrow"></div><header><h5><a href="PROFILELINK" target="_blank">FROMUSERFULLNAME</a></h5><p class="twit-timestamp">AGO</p></header><p>TWEET_TEXT</p></div></article>';
	            if (data[i] !== undefined) {
	                $(this.appendTo).append(html.replace(/PROFILELINK/g, 'http://twitter.com/' + data[i].fromuser).replace('IMGSOURCE', data[i].imagesource).replace('TWEET_TEXT', data[i].tweettext).replace('FROMUSERFULLNAME', data[i].fromfullname).replace(/FROMUSER/g, data[i].fromuser).replace('AGO', data[i].ago));
	            }
	        },
	        relativeTime: function relativeTime(userDate) {
	            var currentTime = new Date(),
	                postTime = new Date(userDate),
	                diff = currentTime - postTime,
	                second = 1000,
	                minute = second * 60,
	                hour = minute * 60,
	                day = hour * 24;
	            if (isNaN(diff) || diff < 0) {
	                return '';
	            }
	            if (diff < second * 5) {
	                return 'right now';
	            }
	            if (diff < minute) {
	                return Math.floor(diff / second) + ' seconds ago';
	            }
	            if (diff < minute * 2) {
	                return 'about 1 minute ago';
	            }
	            if (diff < hour) {
	                return Math.floor(diff / minute) + ' minutes ago';
	            }
	            if (diff < hour * 2) {
	                return 'about 1 hour ago';
	            }
	            if (diff < day) {
	                return Math.floor(diff / hour) + ' hours ago';
	            }
	            if (diff > day && diff < day * 2) {
	                return 'yesterday';
	            }
	            if (diff < day * 365) {
	                return Math.floor(diff / day) + ' days ago';
	            }
	        },
	        ify: {
	            link: function link(tweet) {
	                return tweet.replace(/\b(((https*\:\/\/)|www\.)[^\"\']+?)(([!?,.\)]+)?(\s|$))/g, function (link, m1, m2, m3, m4) {
	                    var http = m2.match(/w/) ? 'http://' : '';
	                    return '<a class="twit-hyperlink" target="_blank" href="' + http + m1 + '">' + (m1.length > 25 ? m1.substr(0, 24) + '...' : m1) + '</a>' + m4;
	                });
	            },
	            at: function at(tweet) {
	                return tweet.replace(/\B[@＠]([a-zA-Z0-9_]{1,20})/g, function (m, username) {
	                    return '<a target="_blank" class="twit-at" href="http://twitter.com/intent/user?screen_name=' + username + '">@' + username + '</a>';
	                });
	            },
	            clean: function clean(tweet) {
	                return this.at(this.link(tweet));
	            }
	        }
	    });
	    return {
	        Twitter: Twitter
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(13), __webpack_require__(25), __webpack_require__(12), __webpack_require__(279), __webpack_require__(264)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, assign, bindAll, isObject, defer, OpenSeadragon) {
	    'use strict';
	
	    var Zoomer = function Zoomer(options) {
	        var viewerOptions, viewerDataOpts;
	
	        // Bind all methods to always have correct this val
	        bindAll(this);
	
	        options = assign({}, this.options, options);
	
	        if (!options.$el instanceof $) {
	            throw new Error('$el was not a jQuery obj: ' + options.$el);
	        }
	        if (options.$el.length === 0) {
	            throw new Error('$el was empty');
	        }
	
	        this.$zoomerElement = options.$el.first();
	
	        // Build options object to use when creating the Viewer. Default to
	        // our default viewer options.
	        viewerOptions = assign({}, this.getViewerDefaults());
	
	        // Mix in options from our $el's data attribute if requested
	        if (options.configureViewerFromDataAttribute) {
	            viewerDataOpts = this.$zoomerElement.data('viewer-conf');
	
	            // We require the data attr to be a JSON object
	            if (!isObject(viewerDataOpts)) {
	                throw new Error('data-viewer-conf attr did not contain an ' + 'object');
	            }
	
	            assign(viewerOptions, viewerDataOpts);
	        }
	
	        // Mix in any options provided to the constructor...
	        assign(viewerOptions, options.viewerOptions);
	
	        // Finally mix in settings implied by our state...
	        assign(viewerOptions, {
	            element: this.$zoomerElement[0]
	        });
	
	        this.viewerOptions = viewerOptions;
	        this.initialize();
	    };
	
	    assign(Zoomer.prototype, {
	        options: {
	            $el: null,
	            configureViewerFromDataAttribute: false,
	            viewerOptions: {}
	        },
	
	        viewer: null,
	
	        initialize: function initialize() {
	            // Create & start the OpenSeadragon viewer. Note that no image
	            // content is loaded at this point, call openTileSource() to start
	            // showing an image.
	            this.viewer = new OpenSeadragon(this.viewerOptions);
	        },
	
	        getViewer: function getViewer() {
	            return this.viewer;
	        },
	
	        openTileSource: function openTileSource(tileSource) {
	            this.getViewer().open(tileSource);
	        },
	
	        openTileSourceFromDataAttribute: function openTileSourceFromDataAttribute() {
	            this._asyncLoadTileSourceFromDataAttr(this.openTileSource);
	        },
	
	        getViewerDefaults: function getViewerDefaults() {
	            return {
	                debugMode: false,
	                showNavigationControl: false,
	                showNavigator: false,
	                springStiffness: 3,
	                animationTime: 0.7,
	                minPixelRatio: 0.3,
	                hash: '' + Math.random()
	            };
	        },
	
	        /**
	         * Load the tilesource specified by data-zoomerConf attribute on our
	         * $zoomerElement. This is an async call, the loaded tile source will
	         * be passed to the provided callback function.
	         *
	         * The data-tilesource-conf attr on this.$zoomerElement should contain
	         * a JSON string with content in on of two forms:
	         *
	         * Hard coded values:
	         * {
	         *     "srcType": "HARD_CODED",
	         *     "data": {
	         *         "width": 2131,
	         *         "height": 2858,
	         *         "tileSize": 256,
	         *         "tileOverlap": 1,
	         *         "fileFormat": 'jpg',
	         *         "displayRects": []
	         *     },
	         *     "tilesUrl": "http://cudl.lib.cam.ac.uk/content/images/PR-07743-B-00014-00109-000-00001_files/"
	         * }
	         *
	         * Or a dzi URL to fetch the values from:
	         * {
	         *     "srcType": "URL",
	         *     "dziUrl": "http://some.where/some/path/foo.dzi",
	         *     "tilesUrl": "http://some.where.else/content/images/foo_files/"
	         * }
	         */
	        _asyncLoadTileSourceFromDataAttr: function _asyncLoadTileSourceFromDataAttr(callback) {
	            var tilesourceConf, onTileSourceLoaded, hardCodedConf, tileSource;
	
	            tilesourceConf = this.$zoomerElement.data('tilesource-conf');
	
	            // Tile sources can either be defined by hard coded settings, or a
	            // URL pointing to a DZI file with the same data (widths, heights
	            // etc)
	            if (tilesourceConf.srcType === 'HARD_CODED') {
	                hardCodedConf = tilesourceConf.data;
	
	                // Ensure the hard-coded data has the required fields
	                if (!(hardCodedConf.width && hardCodedConf.height && hardCodedConf.tileSize && hardCodedConf.tileOverlap && hardCodedConf.fileFormat)) {
	
	                    throw new Error('Hard coded Zoomer config data did have ' + 'all required params: ' + hardCodedConf);
	                }
	
	                // Create the tilesource from the hard-coded data.
	                tileSource = {
	                    Image: {
	                        xmlns: 'http://schemas.microsoft.com/deepzoom/2008',
	                        Url: tilesourceConf.tilesUrl,
	                        Format: hardCodedConf.fileFormat,
	                        TileSize: hardCodedConf.tileSize,
	                        Size: {
	                            Height: hardCodedConf.height,
	                            Width: hardCodedConf.width
	                        }
	                    }
	                };
	
	                // Async call callback even though we already have
	                // the tileSource loaded to be consistent with the async
	                // URL fetching path below.
	                defer(function () {
	                    callback(tileSource);
	                });
	            } else if (tilesourceConf.srcType === 'URL') {
	
	                // OpenSeadragon doesn't seem to allow tiles to live separatly
	                // from the DZI files. As a workaround we fetch the DZI ourself
	                // and manually specify a fake Url for the DZI which points to
	                // our tiles.
	                $.get(tilesourceConf.dziUrl).done(function (tileSource) {
	                    tileSource.Image.Url = tilesourceConf.tilesUrl;
	                    callback(tileSource);
	                }).fail(function () {
	                    console.error('Unable to load tilesource from: ' + tilesourceConf.dziUrl);
	                });
	            }
	        }
	    });
	
	    return {
	        Zoomer: Zoomer
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * This module controls the Virtual Exhibitions lightbox used to display
	 * images, videos and iframes in a modal window.
	 */
	
	// We use the tosrus lightbox
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.init = init;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodashLangIsArray = __webpack_require__(9);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	var _node_modulesLodashCollectionEach = __webpack_require__(274);
	
	var _node_modulesLodashCollectionEach2 = _interopRequireDefault(_node_modulesLodashCollectionEach);
	
	var _node_modulesLodashCollectionGroupBy = __webpack_require__(276);
	
	var _node_modulesLodashCollectionGroupBy2 = _interopRequireDefault(_node_modulesLodashCollectionGroupBy);
	
	__webpack_require__(78);
	
	var _tosrusIframe = __webpack_require__(144);
	
	var _tosrusVeYoutube = __webpack_require__(145);
	
	/**
	 * Elements in this special group are always displayed in their own individual
	 * lightbox.
	 */
	var DEFAULT_GROUP = '__default';
	var LIGHTBOX_LINK_CLASS = 've-lightbox';
	var LIGHTBOX_GROUP_DATA_ATTR = 'lightbox-group';
	
	/**
	 * Insert each tagged link into a lightbox, grouped according to the group attr.
	 * Ungrouped links are placed into a single default group to allow content to
	 * be paged between with the lightbox open.
	 */
	
	function init() {
	    registerMedia();
	
	    var groups = (0, _node_modulesLodashCollectionGroupBy2['default'])((0, _jquery2['default'])('a.' + LIGHTBOX_LINK_CLASS), function (el) {
	        return (0, _jquery2['default'])(el).data(LIGHTBOX_GROUP_DATA_ATTR) || DEFAULT_GROUP;
	    });
	    (0, _node_modulesLodashCollectionEach2['default'])(groups, createLightbox);
	}
	
	function registerMedia() {
	    (0, _tosrusIframe.register)();
	    (0, _tosrusVeYoutube.register)();
	}
	
	function createLightbox(elements) {
	    (0, _jquery2['default'])(elements).tosrus({
	        caption: {
	            attributes: ['title']
	        },
	        pagination: {
	            add: (0, _lodashLangIsArray2['default'])(elements) && elements.length
	        },
	        youtube: {
	            imageLink: false
	        }
	    });
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * This module implements a TosRUs media plugin to show iframes in slides.
	 *
	 * TosRUs already has a generic html media plugin which allows iframes to be
	 * inserted, but it's not ideal as it doesn't scale the HTML to fit the
	 * available area.
	 *
	 * This plugins works like the youtube plugin in that the iframe can be given
	 * an aspect ratio, and it's given as much space as possible given that aspect
	 * ratio.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports.register = register;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tosrus = __webpack_require__(81);
	
	var MEDIA = 'iframe',
	    DEFAULT_OPTIONS = {
	    ratio: 16 / 9
	};
	
	var IFrameTosRUsMediaPlugin = (function (_BaseTosRUsMediaPlugin) {
	    _inherits(IFrameTosRUsMediaPlugin, _BaseTosRUsMediaPlugin);
	
	    function IFrameTosRUsMediaPlugin() {
	        _classCallCheck(this, IFrameTosRUsMediaPlugin);
	
	        _get(Object.getPrototypeOf(IFrameTosRUsMediaPlugin.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(IFrameTosRUsMediaPlugin, [{
	        key: 'init',
	        value: function init() {
	            _get(Object.getPrototypeOf(IFrameTosRUsMediaPlugin.prototype), 'init', this).call(this);
	
	            // Define additional constants used by this media plugin
	            this.tos.data.add('media ratio');
	        }
	    }, {
	        key: 'filterAnchors',
	        value: function filterAnchors(tosInstance, $anchor) {
	            return $anchor.data(this.tos.data.media) === MEDIA;
	        }
	    }, {
	        key: 'initAnchors',
	        value: function initAnchors(tosInstance, $slide, href) {
	            var $anchor = $slide.data(this.tos.data.anchor);
	
	            (0, _jquery2['default'])('<iframe>')
	            // Allow the iframe's src to be different to the a's href
	            .attr('src', $anchor.data('tos-iframe-src') || href).appendTo($slide);
	
	            this.initIframe(tosInstance, $slide);
	        }
	    }, {
	        key: 'initIframe',
	        value: function initIframe(tosInstance, $slide) {
	            var _this = this;
	
	            var $iframe = $slide.children('iframe');
	            var $anchor = $slide.data(this.tos.data.anchor) || (0, _jquery2['default'])();
	
	            var ratio = $anchor.data(this.tos.data.ratio) || tosInstance.opts[MEDIA].ratio;
	
	            $slide.removeClass(this.tos.classes.loading).trigger(this.tos.events.loaded).on(this.tos.events.loading, function () {
	                return _this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio);
	            });
	
	            this.tos.globals.$wndw.on(this.tos.events.resize, function () {
	                return _this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio);
	            });
	        }
	
	        // These two *Slides functions are used when TosRUs is used inline rather
	        // than as a modal. We don't do that, so these aren't implemented at the
	        // moment.
	    }, {
	        key: 'filterSlides',
	        value: function filterSlides(tosInstance, $slide) {
	            // TODO: implement
	            return false;
	        }
	    }, {
	        key: 'initSlides',
	        value: function initSlides(tosInstance, $slide) {
	            throw new Exception('Not implemented');
	        }
	    }]);
	
	    return IFrameTosRUsMediaPlugin;
	})(_tosrus.BaseTosRUsMediaPlugin);
	
	exports.IFrameTosRUsMediaPlugin = IFrameTosRUsMediaPlugin;
	
	function register() {
	    _tosrus.tosrus.media[MEDIA] = new IFrameTosRUsMediaPlugin();
	    _tosrus.tosrus.defaults.media[MEDIA] = {};
	    _tosrus.tosrus.defaults[MEDIA] = DEFAULT_OPTIONS;
	}

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * This module implements TosRUs media plugin to show YouTube videos.
	 *
	 * The built-in YouTube media plugin from TosRUs has some problems:
	 *   - It hard codes http URLs which makes it not work on https pages
	 *   - It uses an undocumented postMessage() protocol used internally by the
	 *     YouTube player JS api.
	 *   - It uses the protocol incorrectly, leading to it breaking the video by
	 *     pausing a stopped video. This is potentially a bug in the YouTube player
	 *     itself though.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports.register = register;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tosrus = __webpack_require__(81);
	
	var _youtubePlayerApi = __webpack_require__(146);
	
	var MEDIA = 've-youtube',
	    DEFAULT_OPTIONS = {
	    ratio: 16 / 9
	};
	
	var YouTubeJsApiTosRUsMediaPlugin = (function (_BaseTosRUsMediaPlugin) {
	    _inherits(YouTubeJsApiTosRUsMediaPlugin, _BaseTosRUsMediaPlugin);
	
	    function YouTubeJsApiTosRUsMediaPlugin() {
	        _classCallCheck(this, YouTubeJsApiTosRUsMediaPlugin);
	
	        _get(Object.getPrototypeOf(YouTubeJsApiTosRUsMediaPlugin.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(YouTubeJsApiTosRUsMediaPlugin, [{
	        key: 'init',
	        value: function init() {
	            _get(Object.getPrototypeOf(YouTubeJsApiTosRUsMediaPlugin.prototype), 'init', this).call(this);
	
	            this.tos.data.add('ratio');
	        }
	    }, {
	        key: 'filterAnchors',
	        value: function filterAnchors(tosInstance, $anchor) {
	            var a = $anchor.get(0);
	            return (/^(?:www\.)youtube.com$/i.test(a.host) && /^\/watch$/.test(a.pathname) && /[?&]v=[^&]+/.test(a.search)
	            );
	        }
	    }, {
	        key: 'getYouTypeId',
	        value: function getYouTypeId(href) {
	            var query = (0, _jquery2['default'])('<a>').attr('href', href).prop('search');
	            var id = query.replace(/[?&]v=([^&]+)(?:$|&)/, '$1');
	            return id ? decodeURIComponent(id) : null;
	        }
	    }, {
	        key: 'initAnchors',
	        value: function initAnchors(tosInstance, $slide, href) {
	            var $anchor = $slide.data(this.tos.data.anchor);
	            var id = this.getYouTypeId(href);
	            // Create a placeholder element to be replaced by the YouTube JS API.
	            var $placeholder = (0, _jquery2['default'])('<div class="tosrus-youtube-player-placeholder">').appendTo($slide);
	
	            this.initVideo(tosInstance, $slide, $placeholder, id);
	        }
	    }, {
	        key: 'getVideoSize',
	        value: function getVideoSize($slide, ratio) {
	            var w = $slide.width();
	            var h = $slide.height();
	
	            if (ratio > w / h) return [w, w / ratio];else return [h * ratio, h];
	        }
	    }, {
	        key: 'initVideo',
	        value: function initVideo(tosInstance, $slide, $placeholder, id) {
	            var _this = this;
	
	            var $anchor = $slide.data(this.tos.data.anchor) || (0, _jquery2['default'])();
	            var ratio = $anchor.data(this.tos.data.ratio) || tosInstance.opts[MEDIA].ratio;
	
	            (0, _youtubePlayerApi.getYouTubePlayerApi)().then(function (YT) {
	                var _getVideoSize = _this.getVideoSize($slide, ratio);
	
	                var _getVideoSize2 = _slicedToArray(_getVideoSize, 2);
	
	                var w = _getVideoSize2[0];
	                var h = _getVideoSize2[1];
	
	                var player = new YT.Player($placeholder.get(0), {
	                    videoId: id,
	                    width: w,
	                    height: h
	                });
	
	                var $iframe = (0, _jquery2['default'])(player.getIframe());
	
	                $slide.removeClass(_this.tos.classes.loading).trigger(_this.tos.events.loaded).on(_this.tos.events.loading, function () {
	                    _this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio);
	                });
	
	                tosInstance.nodes.$wrpr.on(_this.tos.events.sliding, function () {
	                    // Pausing a stopped video breaks the video, so we have
	                    // to ensure it needs pausing first.
	                    var state = player.getPlayerState();
	
	                    if (state === _youtubePlayerApi.YOUTUBE_STATE_PLAYING || state === _youtubePlayerApi.YOUTUBE_STATE_BUFFERING) {
	                        player.pauseVideo();
	                    }
	                }).on(_this.tos.events.closing, function () {
	                    player.stopVideo();
	                });
	
	                _this.tos.globals.$wndw.on(_this.tos.events.resize, function () {
	                    _this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio);
	                });
	            });
	        }
	    }]);
	
	    return YouTubeJsApiTosRUsMediaPlugin;
	})(_tosrus.BaseTosRUsMediaPlugin);
	
	exports.YouTubeJsApiTosRUsMediaPlugin = YouTubeJsApiTosRUsMediaPlugin;
	
	function register() {
	    _tosrus.tosrus.media[MEDIA] = new YouTubeJsApiTosRUsMediaPlugin();
	    _tosrus.tosrus.defaults.media[MEDIA] = {};
	    _tosrus.tosrus.defaults[MEDIA] = DEFAULT_OPTIONS;
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.getYouTubePlayerApi = getYouTubePlayerApi;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var youtubePlayerApiPromise = undefined;
	
	var YOUTUBE_STATE_PLAYING = 1,
	    YOUTUBE_STATE_BUFFERING = 3;
	
	exports.YOUTUBE_STATE_PLAYING = YOUTUBE_STATE_PLAYING;
	exports.YOUTUBE_STATE_BUFFERING = YOUTUBE_STATE_BUFFERING;
	// Get a Promise of the YT player API.
	
	function getYouTubePlayerApi() {
	    if (youtubePlayerApiPromise !== undefined) return youtubePlayerApiPromise;
	
	    if (window.YT) return youtubePlayerApiPromise = new Promise(function (resolve) {
	        return resolve(window.YT);
	    });
	
	    return youtubePlayerApiPromise = new Promise(function (resolve, reject) {
	        // Don't overwrite existing listeners for YT loading
	        var previousApiReadyCallback = window.onYouTubeIframeAPIReady;
	
	        window.onYouTubeIframeAPIReady = function () {
	            var YT = window.YT;
	
	            if (!YT) reject('onYouTubeIframeAPIReady() called without YT loaded');else resolve(YT);
	
	            // Play nicely with anyone else loading the YT api
	            if (typeof previousApiReadyCallback === 'function') previousApiReadyCallback();
	        };
	
	        // If a listener function was already defined assume the script
	        // is already being loaded by someone else.
	        if (typeof previousApiReadyCallback !== 'function') {
	            _jquery2['default'].ajax({
	                url: 'https://www.youtube.com/iframe_api',
	                dataType: 'script',
	                cache: true
	            });
	        }
	    });
	}

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(130);


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(24)
	  , toIndex  = __webpack_require__(38)
	  , toLength = __webpack_require__(11);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , $$    = arguments
	    , end   = $$.length > 2 ? $$[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(24)
	  , toIndex  = __webpack_require__(38)
	  , toLength = __webpack_require__(11);
	module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , $$     = arguments
	    , $$len  = $$.length
	    , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
	    , end    = $$len > 2 ? $$[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var isObject = __webpack_require__(4)
	  , isArray  = __webpack_require__(58)
	  , SPECIES  = __webpack_require__(6)('species');
	module.exports = function(original, length){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length);
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(2);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(2)
	  , toIObject = __webpack_require__(17);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , macrotask = __webpack_require__(103).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(22)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(2)
	  , toObject = __webpack_require__(24)
	  , IObject  = __webpack_require__(48);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(8)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(157)
	  , invoke    = __webpack_require__(47)
	  , aFunction = __webpack_require__(30);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that  = this
	      , $$    = arguments
	      , $$len = $$.length
	      , j = 0, k = 0, args;
	    if(!holder && !$$len)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
	    while($$len > k)args.push($$[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(5)
	  , aFunction = __webpack_require__(30)
	  , SPECIES   = __webpack_require__(6)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(4);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(2)
	  , $export           = __webpack_require__(1)
	  , DESCRIPTORS       = __webpack_require__(14)
	  , createDesc        = __webpack_require__(28)
	  , html              = __webpack_require__(89)
	  , cel               = __webpack_require__(86)
	  , has               = __webpack_require__(10)
	  , cof               = __webpack_require__(22)
	  , invoke            = __webpack_require__(47)
	  , fails             = __webpack_require__(8)
	  , anObject          = __webpack_require__(5)
	  , aFunction         = __webpack_require__(30)
	  , isObject          = __webpack_require__(4)
	  , toObject          = __webpack_require__(24)
	  , toIObject         = __webpack_require__(17)
	  , toInteger         = __webpack_require__(39)
	  , toIndex           = __webpack_require__(38)
	  , toLength          = __webpack_require__(11)
	  , IObject           = __webpack_require__(48)
	  , IE_PROTO          = __webpack_require__(32)('__proto__')
	  , createArrayMethod = __webpack_require__(43)
	  , arrayIndexOf      = __webpack_require__(82)(false)
	  , ObjectProto       = Object.prototype
	  , ArrayProto        = Array.prototype
	  , arraySlice        = ArrayProto.slice
	  , arrayJoin         = ArrayProto.join
	  , defineProperty    = $.setDesc
	  , getOwnDescriptor  = $.getDesc
	  , defineProperties  = $.setDescs
	  , factories         = {}
	  , IE8_DOM_DEFINE;
	
	if(!DESCRIPTORS){
	  IE8_DOM_DEFINE = !fails(function(){
	    return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
	  });
	  $.setDesc = function(O, P, Attributes){
	    if(IE8_DOM_DEFINE)try {
	      return defineProperty(O, P, Attributes);
	    } catch(e){ /* empty */ }
	    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	    if('value' in Attributes)anObject(O)[P] = Attributes.value;
	    return O;
	  };
	  $.getDesc = function(O, P){
	    if(IE8_DOM_DEFINE)try {
	      return getOwnDescriptor(O, P);
	    } catch(e){ /* empty */ }
	    if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
	  };
	  $.setDescs = defineProperties = function(O, Properties){
	    anObject(O);
	    var keys   = $.getKeys(Properties)
	      , length = keys.length
	      , i = 0
	      , P;
	    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
	    return O;
	  };
	}
	$export($export.S + $export.F * !DESCRIPTORS, 'Object', {
	  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $.getDesc,
	  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	  defineProperty: $.setDesc,
	  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties
	});
	
	  // IE 8- don't enum bug keys
	var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
	            'toLocaleString,toString,valueOf').split(',')
	  // Additional keys for getOwnPropertyNames
	  , keys2 = keys1.concat('length', 'prototype')
	  , keysLen1 = keys1.length;
	
	// Create object with `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = cel('iframe')
	    , i      = keysLen1
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict.prototype[keys1[i]];
	  return createDict();
	};
	var createGetKeys = function(names, length){
	  return function(object){
	    var O      = toIObject(object)
	      , i      = 0
	      , result = []
	      , key;
	    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	    // Don't enum bug & hidden keys
	    while(length > i)if(has(O, key = names[i++])){
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	    return result;
	  };
	};
	var Empty = function(){};
	$export($export.S, 'Object', {
	  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	  getPrototypeOf: $.getProto = $.getProto || function(O){
	    O = toObject(O);
	    if(has(O, IE_PROTO))return O[IE_PROTO];
	    if(typeof O.constructor == 'function' && O instanceof O.constructor){
	      return O.constructor.prototype;
	    } return O instanceof Object ? ObjectProto : null;
	  },
	  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
	  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	  create: $.create = $.create || function(O, /*?*/Properties){
	    var result;
	    if(O !== null){
	      Empty.prototype = anObject(O);
	      result = new Empty();
	      Empty.prototype = null;
	      // add "__proto__" for Object.getPrototypeOf shim
	      result[IE_PROTO] = O;
	    } else result = createDict();
	    return Properties === undefined ? result : defineProperties(result, Properties);
	  },
	  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
	});
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }
	  return factories[len](F, args);
	};
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	$export($export.P, 'Function', {
	  bind: function bind(that /*, args... */){
	    var fn       = aFunction(this)
	      , partArgs = arraySlice.call(arguments, 1);
	    var bound = function(/* args... */){
	      var args = partArgs.concat(arraySlice.call(arguments));
	      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	    };
	    if(isObject(fn.prototype))bound.prototype = fn.prototype;
	    return bound;
	  }
	});
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * fails(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});
	$export($export.P + $export.F * (IObject != Object), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
	  }
	});
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	$export($export.S, 'Array', {isArray: __webpack_require__(58)});
	
	var createArrayReduce = function(isRight){
	  return function(callbackfn, memo){
	    aFunction(callbackfn);
	    var O      = IObject(this)
	      , length = toLength(O.length)
	      , index  = isRight ? length - 1 : 0
	      , i      = isRight ? -1 : 1;
	    if(arguments.length < 2)for(;;){
	      if(index in O){
	        memo = O[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if(isRight ? index < 0 : length <= index){
	        throw TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
	      memo = callbackfn(memo, O[index], index, this);
	    }
	    return memo;
	  };
	};
	
	var methodize = function($fn){
	  return function(arg1/*, arg2 = undefined */){
	    return $fn(this, arg1, arguments[1]);
	  };
	};
	
	$export($export.P, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: $.each = $.each || methodize(createArrayMethod(0)),
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: methodize(createArrayMethod(1)),
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: methodize(createArrayMethod(2)),
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: methodize(createArrayMethod(3)),
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: methodize(createArrayMethod(4)),
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: createArrayReduce(false),
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: createArrayReduce(true),
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: methodize(arrayIndexOf),
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
	    if(index < 0)index = toLength(length + index);
	    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
	    return -1;
	  }
	});
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	$export($export.S, 'Date', {now: function(){ return +new Date; }});
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(this))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(149)});
	
	__webpack_require__(31)('copyWithin');

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {fill: __webpack_require__(150)});
	
	__webpack_require__(31)('fill');

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(43)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(31)(KEY);

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(43)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(31)(KEY);

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(19)
	  , $export     = __webpack_require__(1)
	  , toObject    = __webpack_require__(24)
	  , call        = __webpack_require__(93)
	  , isArrayIter = __webpack_require__(90)
	  , toLength    = __webpack_require__(11)
	  , getIterFn   = __webpack_require__(104);
	$export($export.S + $export.F * !__webpack_require__(60)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , $$     = arguments
	      , $$len  = $$.length
	      , result = new (typeof this == 'function' ? this : Array)($$len);
	    while($$len > index)result[index] = $$[index++];
	    result.length = $$len;
	    return result;
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(50)('Array');

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $             = __webpack_require__(2)
	  , isObject      = __webpack_require__(4)
	  , HAS_INSTANCE  = __webpack_require__(6)('hasInstance')
	  , FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = $.getProto(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var setDesc    = __webpack_require__(2).setDesc
	  , createDesc = __webpack_require__(28)
	  , has        = __webpack_require__(10)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(14) && setDesc(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    var match = ('' + this).match(nameRE)
	      , name  = match ? match[1] : '';
	    has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
	    return name;
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(83);
	
	// 23.1 Map Objects
	__webpack_require__(45)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1)
	  , log1p   = __webpack_require__(96)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	// V8 bug https://code.google.com/p/v8/issues/detail?id=3509
	$export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	$export($export.S, 'Math', {asinh: asinh});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1)
	  , sign    = __webpack_require__(63);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {expm1: __webpack_require__(62)});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(1)
	  , sign      = __webpack_require__(63)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum   = 0
	      , i     = 0
	      , $$    = arguments
	      , $$len = $$.length
	      , larg  = 0
	      , arg, div;
	    while(i < $$len){
	      arg = abs($$[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(96)});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {sign: __webpack_require__(63)});

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(62)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(62)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(2)
	  , global      = __webpack_require__(7)
	  , has         = __webpack_require__(10)
	  , cof         = __webpack_require__(22)
	  , toPrimitive = __webpack_require__(160)
	  , fails       = __webpack_require__(8)
	  , $trim       = __webpack_require__(52).trim
	  , NUMBER      = 'Number'
	  , $Number     = global[NUMBER]
	  , Base        = $Number
	  , proto       = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF  = cof($.create(proto)) == NUMBER
	  , TRIM        = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? new Base(toNumber(it)) : toNumber(it);
	  };
	  $.each.call(__webpack_require__(14) ? $.getNames(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), function(key){
	    if(has(Base, key) && !has($Number, key)){
	      $.setDesc($Number, key, $.getDesc(Base, key));
	    }
	  });
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(16)(global, NUMBER, $Number);
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(1)
	  , _isFinite = __webpack_require__(7).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(91)});

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(1)
	  , isInteger = __webpack_require__(91)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.12 Number.parseFloat(string)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {parseFloat: parseFloat});

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.13 Number.parseInt(string, radix)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {parseInt: parseInt});

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(155)});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(17);
	
	__webpack_require__(15)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(15)('getOwnPropertyNames', function(){
	  return __webpack_require__(88).get;
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(24);
	
	__webpack_require__(15)('getPrototypeOf', function($getPrototypeOf){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {is: __webpack_require__(99)});

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(24);
	
	__webpack_require__(15)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
	  };
	});

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(4);
	
	__webpack_require__(15)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(64).set});

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(44)
	  , test    = {};
	test[__webpack_require__(6)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(16)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(2)
	  , LIBRARY    = __webpack_require__(61)
	  , global     = __webpack_require__(7)
	  , ctx        = __webpack_require__(19)
	  , classof    = __webpack_require__(44)
	  , $export    = __webpack_require__(1)
	  , isObject   = __webpack_require__(4)
	  , anObject   = __webpack_require__(5)
	  , aFunction  = __webpack_require__(30)
	  , strictNew  = __webpack_require__(51)
	  , forOf      = __webpack_require__(35)
	  , setProto   = __webpack_require__(64).set
	  , same       = __webpack_require__(99)
	  , SPECIES    = __webpack_require__(6)('species')
	  , speciesConstructor = __webpack_require__(159)
	  , asap       = __webpack_require__(154)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(14)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(49)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(37)(P, PROMISE);
	__webpack_require__(50)(PROMISE);
	Wrapper = __webpack_require__(23)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(60)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export  = __webpack_require__(1)
	  , _apply   = Function.apply
	  , anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(target, thisArgument, anObject(argumentsList));
	  }
	});

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $         = __webpack_require__(2)
	  , $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(30)
	  , anObject  = __webpack_require__(5)
	  , isObject  = __webpack_require__(4)
	  , bind      = Function.bind || __webpack_require__(23).Function.prototype.bind;
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = $.create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var $        = __webpack_require__(2)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(5);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    try {
	      $.setDesc(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(1)
	  , getDesc  = __webpack_require__(2).getDesc
	  , anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = getDesc(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(5);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(94)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var $        = __webpack_require__(2)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return $.getDesc(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(1)
	  , getProto = __webpack_require__(2).getProto
	  , anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var $        = __webpack_require__(2)
	  , has      = __webpack_require__(10)
	  , $export  = __webpack_require__(1)
	  , isObject = __webpack_require__(4)
	  , anObject = __webpack_require__(5);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(1)
	  , anObject      = __webpack_require__(5)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(98)});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(1)
	  , anObject           = __webpack_require__(5)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(1)
	  , setProto = __webpack_require__(64);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var $          = __webpack_require__(2)
	  , has        = __webpack_require__(10)
	  , $export    = __webpack_require__(1)
	  , createDesc = __webpack_require__(28)
	  , anObject   = __webpack_require__(5)
	  , isObject   = __webpack_require__(4);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = $.getDesc(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = $.getProto(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    $.setDesc(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(2)
	  , global   = __webpack_require__(7)
	  , isRegExp = __webpack_require__(92)
	  , $flags   = __webpack_require__(87)
	  , $RegExp  = global.RegExp
	  , Base     = $RegExp
	  , proto    = $RegExp.prototype
	  , re1      = /a/g
	  , re2      = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(8)(function(){
	  re2[__webpack_require__(6)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
	      : CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
	  };
	  $.each.call($.getNames(Base), function(key){
	    key in $RegExp || $.setDesc($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  });
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(16)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(50)('RegExp');

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	var $ = __webpack_require__(2);
	if(__webpack_require__(14) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(87)
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(46)('match', 1, function(defined, MATCH){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(46)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(46)('search', 1, function(defined, SEARCH){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  };
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(46)('split', 2, function(defined, SPLIT, $split){
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return function split(separator, limit){
	    'use strict';
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined
	      ? fn.call(separator, O, limit)
	      : $split.call(String(O), separator, limit);
	  };
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(83);
	
	// 23.2 Set Objects
	__webpack_require__(45)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(65)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(1)
	  , toLength  = __webpack_require__(11)
	  , context   = __webpack_require__(66)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(57)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , $$   = arguments
	      , endPosition = $$.length > 1 ? $$[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(1)
	  , toIndex        = __webpack_require__(38)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res   = []
	      , $$    = arguments
	      , $$len = $$.length
	      , i     = 0
	      , code;
	    while($$len > i){
	      code = +$$[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(1)
	  , context  = __webpack_require__(66)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(57)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(65)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(59)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(17)
	  , toLength  = __webpack_require__(11);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl   = toIObject(callSite.raw)
	      , len   = toLength(tpl.length)
	      , $$    = arguments
	      , $$len = $$.length
	      , res   = []
	      , i     = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < $$len)res.push(String($$[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(102)
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(1)
	  , toLength    = __webpack_require__(11)
	  , context     = __webpack_require__(66)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(57)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , $$     = arguments
	      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(52)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(2)
	  , global         = __webpack_require__(7)
	  , has            = __webpack_require__(10)
	  , DESCRIPTORS    = __webpack_require__(14)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(16)
	  , $fails         = __webpack_require__(8)
	  , shared         = __webpack_require__(100)
	  , setToStringTag = __webpack_require__(37)
	  , uid            = __webpack_require__(32)
	  , wks            = __webpack_require__(6)
	  , keyOf          = __webpack_require__(153)
	  , $names         = __webpack_require__(88)
	  , enumKeys       = __webpack_require__(152)
	  , isArray        = __webpack_require__(58)
	  , anObject       = __webpack_require__(5)
	  , toIObject      = __webpack_require__(17)
	  , createDesc     = __webpack_require__(28)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(61)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(2)
	  , redefine     = __webpack_require__(16)
	  , weak         = __webpack_require__(85)
	  , isObject     = __webpack_require__(4)
	  , has          = __webpack_require__(10)
	  , frozenStore  = weak.frozenStore
	  , WEAK         = weak.WEAK
	  , isExtensible = Object.isExtensible || isObject
	  , tmp          = {};
	
	// 23.3 WeakMap Objects
	var $WeakMap = __webpack_require__(45)('WeakMap', function(get){
	  return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      if(!isExtensible(key))return frozenStore(this).get(key);
	      if(has(key, WEAK))return key[WEAK][this._i];
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	}, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  $.each.call(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on leaky map
	      if(isObject(a) && !isExtensible(a)){
	        var result = frozenStore(this)[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(85);
	
	// 23.4 WeakSet Objects
	__webpack_require__(45)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(1)
	  , $includes = __webpack_require__(82)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(31)('includes');

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(84)('Map')});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export  = __webpack_require__(1)
	  , $entries = __webpack_require__(97)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/WebReflection/9353781
	var $          = __webpack_require__(2)
	  , $export    = __webpack_require__(1)
	  , ownKeys    = __webpack_require__(98)
	  , toIObject  = __webpack_require__(17)
	  , createDesc = __webpack_require__(28);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , setDesc = $.setDesc
	      , getDesc = $.getDesc
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i){
	      D = getDesc(O, key = keys[i++]);
	      if(key in result)setDesc(result, key, createDesc(0, D));
	      else result[key] = D;
	    } return result;
	  }
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export = __webpack_require__(1)
	  , $values = __webpack_require__(97)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1)
	  , $re     = __webpack_require__(158)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(84)('Set')});

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(65)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(101);
	
	$export($export.P, 'String', {
	  padLeft: function padLeft(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(101);
	
	$export($export.P, 'String', {
	  padRight: function padRight(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(52)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(52)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// JavaScript 1.6 / Strawman array statics shim
	var $       = __webpack_require__(2)
	  , $export = __webpack_require__(1)
	  , $ctx    = __webpack_require__(19)
	  , $Array  = __webpack_require__(23).Array || Array
	  , statics = {};
	var setStatics = function(keys, length){
	  $.each.call(keys.split(','), function(key){
	    if(length == undefined && key in $Array)statics[key] = $Array[key];
	    else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
	  });
	};
	setStatics('pop,reverse,shift,keys,values,entries', 1);
	setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	           'reduce,reduceRight,copyWithin,fill');
	$export($export.S, 'Array', statics);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(105);
	var global      = __webpack_require__(7)
	  , hide        = __webpack_require__(21)
	  , Iterators   = __webpack_require__(36)
	  , ITERATOR    = __webpack_require__(6)('iterator')
	  , NL          = global.NodeList
	  , HTC         = global.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype
	  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
	if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
	if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , $task   = __webpack_require__(103);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(7)
	  , $export    = __webpack_require__(1)
	  , invoke     = __webpack_require__(47)
	  , partial    = __webpack_require__(156)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(161);
	__webpack_require__(244);
	__webpack_require__(199);
	__webpack_require__(207);
	__webpack_require__(211);
	__webpack_require__(212);
	__webpack_require__(200);
	__webpack_require__(210);
	__webpack_require__(209);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(204);
	__webpack_require__(201);
	__webpack_require__(203);
	__webpack_require__(208);
	__webpack_require__(202);
	__webpack_require__(170);
	__webpack_require__(169);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(237);
	__webpack_require__(240);
	__webpack_require__(243);
	__webpack_require__(239);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(238);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(105);
	__webpack_require__(168);
	__webpack_require__(162);
	__webpack_require__(163);
	__webpack_require__(165);
	__webpack_require__(164);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(213);
	__webpack_require__(171);
	__webpack_require__(234);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(221);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(226);
	__webpack_require__(247);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(252);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(249);
	__webpack_require__(248);
	__webpack_require__(253);
	__webpack_require__(259);
	__webpack_require__(262);
	__webpack_require__(261);
	__webpack_require__(260);
	module.exports = __webpack_require__(23);

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;//! OpenSeadragon 2.1.0
	//! Built on 2015-11-12
	//! Git commit: v2.1.0-0-404a248
	//! http://openseadragon.github.io
	//! License: http://openseadragon.github.io/license/
	
	/*
	 * OpenSeadragon
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Portions of this source file taken from jQuery:
	 *
	 * Copyright 2011 John Resig
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/*
	 * Portions of this source file taken from mattsnider.com:
	 *
	 * Copyright (c) 2006-2013 Matt Snider
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the "Software"),
	 * to deal in the Software without restriction, including without limitation
	 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
	 * and/or sell copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included
	 * in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
	 * OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR
	 * THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	
	/**
	 * @version  OpenSeadragon 2.1.0
	 *
	 * @file
	 * <h2><strong>OpenSeadragon - Javascript Deep Zooming</strong></h2>
	 * <p>
	 * OpenSeadragon provides an html interface for creating
	 * deep zoom user interfaces.  The simplest examples include deep
	 * zoom for large resolution images, and complex examples include
	 * zoomable map interfaces driven by SVG files.
	 * </p>
	 *
	 */
	
	/**
	 * @module OpenSeadragon
	 *
	 */
	
	/**
	 * @namespace OpenSeadragon
	 *
	 * @classdesc The root namespace for OpenSeadragon.  All utility methods
	 * and classes are defined on or below this namespace.
	 *
	 */
	
	
	// Typedefs
	
	 /**
	  * All required and optional settings for instantiating a new instance of an OpenSeadragon image viewer.
	  *
	  * @typedef {Object} Options
	  * @memberof OpenSeadragon
	  *
	  * @property {String} id
	  *     Id of the element to append the viewer's container element to. If not provided, the 'element' property must be provided.
	  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
	  *
	  * @property {Element} element
	  *     The element to append the viewer's container element to. If not provided, the 'id' property must be provided.
	  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
	  *
	  * @property {Array|String|Function|Object} [tileSources=null]
	  *     Tile source(s) to open initially. This is a complex parameter; see
	  *     {@link OpenSeadragon.Viewer#open} for details.
	  *
	  * @property {Number} [tabIndex=0]
	  *     Tabbing order index to assign to the viewer element. Positive values are selected in increasing order. When tabIndex is 0
	  *     source order is used. A negative value omits the viewer from the tabbing order.
	  *
	  * @property {Array} overlays Array of objects defining permanent overlays of
	  *     the viewer. The overlays added via this option and later removed with
	  *     {@link OpenSeadragon.Viewer#removeOverlay} will be added back when a new
	  *     image is opened.
	  *     To add overlays which can be definitively removed, one must use
	  *     {@link OpenSeadragon.Viewer#addOverlay}
	  *     If displaying a sequence of images, the overlays can be associated
	  *     with a specific page by passing the overlays array to the page's
	  *     tile source configuration.
	  *     Expected properties:
	  *     * x, y, (or px, py for pixel coordinates) to define the location.
	  *     * width, height in point if using x,y or in pixels if using px,py. If width
	  *       and height are specified, the overlay size is adjusted when zooming,
	  *       otherwise the size stays the size of the content (or the size defined by CSS).
	  *     * className to associate a class to the overlay
	  *     * id to set the overlay element. If an element with this id already exists,
	  *       it is reused, otherwise it is created. If not specified, a new element is
	  *       created.
	  *     * placement a string to define the relative position to the viewport.
	  *       Only used if no width and height are specified. Default: 'TOP_LEFT'.
	  *       See {@link OpenSeadragon.OverlayPlacement} for possible values.
	  *
	  * @property {String} [xmlPath=null]
	  *     <strong>DEPRECATED</strong>. A relative path to load a DZI file from the server.
	  *     Prefer the newer Options.tileSources.
	  *
	  * @property {String} [prefixUrl='/images/']
	  *     Prepends the prefixUrl to navImages paths, which is very useful
	  *     since the default paths are rarely useful for production
	  *     environments.
	  *
	  * @property {OpenSeadragon.NavImages} [navImages]
	  *     An object with a property for each button or other built-in navigation
	  *     control, eg the current 'zoomIn', 'zoomOut', 'home', and 'fullpage'.
	  *     Each of those in turn provides an image path for each state of the button
	  *     or navigation control, eg 'REST', 'GROUP', 'HOVER', 'PRESS'. Finally the
	  *     image paths, by default assume there is a folder on the servers root path
	  *     called '/images', eg '/images/zoomin_rest.png'.  If you need to adjust
	  *     these paths, prefer setting the option.prefixUrl rather than overriding
	  *     every image path directly through this setting.
	  *
	  * @property {Boolean} [debugMode=false]
	  *     TODO: provide an in-screen panel providing event detail feedback.
	  *
	  * @property {String} [debugGridColor='#437AB2']
	  *
	  * @property {Number} [blendTime=0]
	  *     Specifies the duration of animation as higher or lower level tiles are
	  *     replacing the existing tile.
	  *
	  * @property {Boolean} [alwaysBlend=false]
	  *     Forces the tile to always blend.  By default the tiles skip blending
	  *     when the blendTime is surpassed and the current animation frame would
	  *     not complete the blend.
	  *
	  * @property {Boolean} [autoHideControls=true]
	  *     If the user stops interacting with the viewport, fade the navigation
	  *     controls.  Useful for presentation since the controls are by default
	  *     floated on top of the image the user is viewing.
	  *
	  * @property {Boolean} [immediateRender=false]
	  *     Render the best closest level first, ignoring the lowering levels which
	  *     provide the effect of very blurry to sharp. It is recommended to change
	  *     setting to true for mobile devices.
	  *
	  * @property {Number} [defaultZoomLevel=0]
	  *     Zoom level to use when image is first opened or the home button is clicked.
	  *     If 0, adjusts to fit viewer.
	  *
	  * @property {Number} [opacity=1]
	  *     Default opacity of the tiled images (1=opaque, 0=transparent)
	  *
	  * @property {String|CanvasGradient|CanvasPattern|Function} [placeholderFillStyle=null]
	  *     Draws a colored rectangle behind the tile if it is not loaded yet.
	  *     You can pass a CSS color value like "#FF8800".
	  *     When passing a function the tiledImage and canvas context are available as argument which is useful when you draw a gradient or pattern.
	  *
	  * @property {Number} [degrees=0]
	  *     Initial rotation.
	  *
	  * @property {Number} [minZoomLevel=null]
	  *
	  * @property {Number} [maxZoomLevel=null]
	  *
	  * @property {Boolean} [homeFillsViewer=false]
	  *     Make the 'home' button fill the viewer and clip the image, instead
	  *     of fitting the image to the viewer and letterboxing.
	  *
	  * @property {Boolean} [panHorizontal=true]
	  *     Allow horizontal pan.
	  *
	  * @property {Boolean} [panVertical=true]
	  *     Allow vertical pan.
	  *
	  * @property {Boolean} [constrainDuringPan=false]
	  *
	  * @property {Boolean} [wrapHorizontal=false]
	  *     Set to true to force the image to wrap horizontally within the viewport.
	  *     Useful for maps or images representing the surface of a sphere or cylinder.
	  *
	  * @property {Boolean} [wrapVertical=false]
	  *     Set to true to force the image to wrap vertically within the viewport.
	  *     Useful for maps or images representing the surface of a sphere or cylinder.
	  *
	  * @property {Number} [minZoomImageRatio=0.9]
	  *     The minimum percentage ( expressed as a number between 0 and 1 ) of
	  *     the viewport height or width at which the zoom out will be constrained.
	  *     Setting it to 0, for example will allow you to zoom out infinity.
	  *
	  * @property {Number} [maxZoomPixelRatio=1.1]
	  *     The maximum ratio to allow a zoom-in to affect the highest level pixel
	  *     ratio. This can be set to Infinity to allow 'infinite' zooming into the
	  *     image though it is less effective visually if the HTML5 Canvas is not
	  *     availble on the viewing device.
	  *
	  * @property {Boolean} [autoResize=true]
	  *     Set to false to prevent polling for viewer size changes. Useful for providing custom resize behavior.
	  *
	  * @property {Boolean} [preserveImageSizeOnResize=false]
	  *     Set to true to have the image size preserved when the viewer is resized. This requires autoResize=true (default).
	  *
	  * @property {Number} [minScrollDeltaTime=50]
	  *     Number of milliseconds between canvas-scroll events. This value helps normalize the rate of canvas-scroll
	  *     events between different devices, causing the faster devices to slow down enough to make the zoom control
	  *     more manageable.
	  *
	  * @property {Number} [pixelsPerWheelLine=40]
	  *     For pixel-resolution scrolling devices, the number of pixels equal to one scroll line.
	  *
	  * @property {Number} [visibilityRatio=0.5]
	  *     The percentage ( as a number from 0 to 1 ) of the source image which
	  *     must be kept within the viewport.  If the image is dragged beyond that
	  *     limit, it will 'bounce' back until the minimum visibility ratio is
	  *     achieved.  Setting this to 0 and wrapHorizontal ( or wrapVertical ) to
	  *     true will provide the effect of an infinitely scrolling viewport.
	  *
	  * @property {Object} [viewportMargins={}]
	  *     Pushes the "home" region in from the sides by the specified amounts.
	  *     Possible subproperties (Numbers, in screen coordinates): left, top, right, bottom.
	  *
	  * @property {Number} [imageLoaderLimit=0]
	  *     The maximum number of image requests to make concurrently. By default
	  *     it is set to 0 allowing the browser to make the maximum number of
	  *     image requests in parallel as allowed by the browsers policy.
	  *
	  * @property {Number} [clickTimeThreshold=300]
	  *      The number of milliseconds within which a pointer down-up event combination
	  *      will be treated as a click gesture.
	  *
	  * @property {Number} [clickDistThreshold=5]
	  *      The maximum distance allowed between a pointer down event and a pointer up event
	  *      to be treated as a click gesture.
	  *
	  * @property {Number} [dblClickTimeThreshold=300]
	  *      The number of milliseconds within which two pointer down-up event combinations
	  *      will be treated as a double-click gesture.
	  *
	  * @property {Number} [dblClickDistThreshold=20]
	  *      The maximum distance allowed between two pointer click events
	  *      to be treated as a double-click gesture.
	  *
	  * @property {Number} [springStiffness=6.5]
	  *
	  * @property {Number} [animationTime=1.2]
	  *     Specifies the animation duration per each {@link OpenSeadragon.Spring}
	  *     which occur when the image is dragged or zoomed.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsMouse]
	  *     Settings for gestures generated by a mouse pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsMouse.scrollToZoom=true] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsMouse.clickToZoom=true] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsMouse.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsMouse.pinchToZoom=false] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsMouse.flickEnabled=false] - Enable flick gesture
	  * @property {Number} [gestureSettingsMouse.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsMouse.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsMouse.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsTouch]
	  *     Settings for gestures generated by a touch pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsTouch.scrollToZoom=false] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsTouch.clickToZoom=false] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsTouch.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsTouch.pinchToZoom=true] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsTouch.flickEnabled=true] - Enable flick gesture
	  * @property {Number} [gestureSettingsTouch.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsTouch.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsTouch.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsPen]
	  *     Settings for gestures generated by a pen pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsPen.scrollToZoom=false] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsPen.clickToZoom=true] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsPen.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsPen.pinchToZoom=false] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsPen.flickEnabled=false] - Enable flick gesture
	  * @property {Number} [gestureSettingsPen.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsPen.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsPen.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsUnknown]
	  *     Settings for gestures generated by unknown pointer devices. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsUnknown.scrollToZoom=true] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsUnknown.clickToZoom=false] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsUnknown.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsUnknown.pinchToZoom=true] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsUnknown.flickEnabled=true] - Enable flick gesture
	  * @property {Number} [gestureSettingsUnknown.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsUnknown.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsUnknown.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {Number} [zoomPerClick=2.0]
	  *     The "zoom distance" per mouse click or touch tap. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the click-to-zoom feature (also see gestureSettings[Mouse|Touch|Pen].clickToZoom/dblClickToZoom).</em>
	  *
	  * @property {Number} [zoomPerScroll=1.2]
	  *     The "zoom distance" per mouse scroll or touch pinch. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the mouse-wheel zoom feature (also see gestureSettings[Mouse|Touch|Pen].scrollToZoom}).</em>
	  *
	  * @property {Number} [zoomPerSecond=1.0]
	  *     The number of seconds to animate a single zoom event over.
	  *
	  * @property {Boolean} [showNavigator=false]
	  *     Set to true to make the navigator minimap appear.
	  *
	  * @property {String} [navigatorId=navigator-GENERATED DATE]
	  *     The ID of a div to hold the navigator minimap.
	  *     If an ID is specified, the navigatorPosition, navigatorSizeRatio, navigatorMaintainSizeRatio, and navigatorTop|Left|Height|Width options will be ignored.
	  *     If an ID is not specified, a div element will be generated and placed on top of the main image.
	  *
	  * @property {String} [navigatorPosition='TOP_RIGHT']
	  *     Valid values are 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_RIGHT', or 'ABSOLUTE'.<br>
	  *     If 'ABSOLUTE' is specified, then navigatorTop|Left|Height|Width determines the size and position of the navigator minimap in the viewer, and navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.<br>
	  *     For 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', and 'BOTTOM_RIGHT', the navigatorSizeRatio or navigatorHeight|Width values determine the size of the navigator minimap.
	  *
	  * @property {Number} [navigatorSizeRatio=0.2]
	  *     Ratio of navigator size to viewer size. Ignored if navigatorHeight|Width are specified.
	  *
	  * @property {Boolean} [navigatorMaintainSizeRatio=false]
	  *     If true, the navigator minimap is resized (using navigatorSizeRatio) when the viewer size changes.
	  *
	  * @property {Number|String} [navigatorTop=null]
	  *     Specifies the location of the navigator minimap (see navigatorPosition).
	  *
	  * @property {Number|String} [navigatorLeft=null]
	  *     Specifies the location of the navigator minimap (see navigatorPosition).
	  *
	  * @property {Number|String} [navigatorHeight=null]
	  *     Specifies the size of the navigator minimap (see navigatorPosition).
	  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
	  *
	  * @property {Number|String} [navigatorWidth=null]
	  *     Specifies the size of the navigator minimap (see navigatorPosition).
	  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
	  *
	  * @property {Boolean} [navigatorAutoResize=true]
	  *     Set to false to prevent polling for navigator size changes. Useful for providing custom resize behavior.
	  *     Setting to false can also improve performance when the navigator is configured to a fixed size.
	  *
	  * @property {Boolean} [navigatorRotate=true]
	  *     If true, the navigator will be rotated together with the viewer.
	  *
	  * @property {Number} [controlsFadeDelay=2000]
	  *     The number of milliseconds to wait once the user has stopped interacting
	  *     with the interface before begining to fade the controls. Assumes
	  *     showNavigationControl and autoHideControls are both true.
	  *
	  * @property {Number} [controlsFadeLength=1500]
	  *     The number of milliseconds to animate the controls fading out.
	  *
	  * @property {Number} [maxImageCacheCount=200]
	  *     The max number of images we should keep in memory (per drawer).
	  *
	  * @property {Number} [timeout=30000]
	  *
	  * @property {Boolean} [useCanvas=true]
	  *     Set to false to not use an HTML canvas element for image rendering even if canvas is supported.
	  *
	  * @property {Number} [minPixelRatio=0.5]
	  *     The higher the minPixelRatio, the lower the quality of the image that
	  *     is considered sufficient to stop rendering a given zoom level.  For
	  *     example, if you are targeting mobile devices with less bandwith you may
	  *     try setting this to 1.5 or higher.
	  *
	  * @property {Boolean} [mouseNavEnabled=true]
	  *     Is the user able to interact with the image via mouse or touch. Default
	  *     interactions include draging the image in a plane, and zooming in toward
	  *     and away from the image.
	  *
	  * @property {Boolean} [showNavigationControl=true]
	  *     Set to false to prevent the appearance of the default navigation controls.<br>
	  *     Note that if set to false, the customs buttons set by the options
	  *     zoomInButton, zoomOutButton etc, are rendered inactive.
	  *
	  * @property {OpenSeadragon.ControlAnchor} [navigationControlAnchor=TOP_LEFT]
	  *     Placement of the default navigation controls.
	  *     To set the placement of the sequence controls, see the
	  *     sequenceControlAnchor option.
	  *
	  * @property {Boolean} [showZoomControl=true]
	  *     If true then + and - buttons to zoom in and out are displayed.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showHomeControl=true]
	  *     If true then the 'Go home' button is displayed to go back to the original
	  *     zoom and pan.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showFullPageControl=true]
	  *     If true then the 'Toggle full page' button is displayed to switch
	  *     between full page and normal mode.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showRotationControl=false]
	  *     If true then the rotate left/right controls will be displayed as part of the
	  *     standard controls. This is also subject to the browser support for rotate
	  *     (e.g. viewer.drawer.canRotate()).<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showSequenceControl=true]
	  *     If sequenceMode is true, then provide buttons for navigating forward and
	  *     backward through the images.
	  *
	  * @property {OpenSeadragon.ControlAnchor} [sequenceControlAnchor=TOP_LEFT]
	  *     Placement of the default sequence controls.
	  *
	  * @property {Boolean} [navPrevNextWrap=false]
	  *     If true then the 'previous' button will wrap to the last image when
	  *     viewing the first image and the 'next' button will wrap to the first
	  *     image when viewing the last image.
	  *
	  * @property {String} zoomInButton
	  *     Set the id of the custom 'Zoom in' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} zoomOutButton
	  *     Set the id of the custom 'Zoom out' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} homeButton
	  *     Set the id of the custom 'Go home' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} fullPageButton
	  *     Set the id of the custom 'Toggle full page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} rotateLeftButton
	  *     Set the id of the custom 'Rotate left' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} rotateRightButton
	  *     Set the id of the custom 'Rotate right' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} previousButton
	  *     Set the id of the custom 'Previous page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} nextButton
	  *     Set the id of the custom 'Next page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {Boolean} [sequenceMode=false]
	  *     Set to true to have the viewer treat your tilesources as a sequence of images to
	  *     be opened one at a time rather than all at once.
	  *
	  * @property {Number} [initialPage=0]
	  *     If sequenceMode is true, display this page initially.
	  *
	  * @property {Boolean} [preserveViewport=false]
	  *     If sequenceMode is true, then normally navigating through each image resets the
	  *     viewport to 'home' position.  If preserveViewport is set to true, then the viewport
	  *     position is preserved when navigating between images in the sequence.
	  *
	  * @property {Boolean} [preserveOverlays=false]
	  *     If sequenceMode is true, then normally navigating through each image
	  *     resets the overlays.
	  *     If preserveOverlays is set to true, then the overlays added with {@link OpenSeadragon.Viewer#addOverlay}
	  *     are preserved when navigating between images in the sequence.
	  *     Note: setting preserveOverlays overrides any overlays specified in the global
	  *     "overlays" option for the Viewer. It's also not compatible with specifying
	  *     per-tileSource overlays via the options, as those overlays will persist
	  *     even after the tileSource is closed.
	  *
	  * @property {Boolean} [showReferenceStrip=false]
	  *     If sequenceMode is true, then display a scrolling strip of image thumbnails for
	  *     navigating through the images.
	  *
	  * @property {String} [referenceStripScroll='horizontal']
	  *
	  * @property {Element} [referenceStripElement=null]
	  *
	  * @property {Number} [referenceStripHeight=null]
	  *
	  * @property {Number} [referenceStripWidth=null]
	  *
	  * @property {String} [referenceStripPosition='BOTTOM_LEFT']
	  *
	  * @property {Number} [referenceStripSizeRatio=0.2]
	  *
	  * @property {Boolean} [collectionMode=false]
	  *     Set to true to have the viewer arrange your TiledImages in a grid or line.
	  *
	  * @property {Number} [collectionRows=3]
	  *     If collectionMode is true, specifies how many rows the grid should have. Use 1 to make a line.
	  *     If collectionLayout is 'vertical', specifies how many columns instead.
	  *
	  * @property {Number} [collectionColumns=0]
	  *     If collectionMode is true, specifies how many columns the grid should have. Use 1 to make a line.
	  *     If collectionLayout is 'vertical', specifies how many rows instead. Ignored if collectionRows is not set to a falsy value.
	  *
	  * @property {String} [collectionLayout='horizontal']
	  *     If collectionMode is true, specifies whether to arrange vertically or horizontally.
	  *
	  * @property {Number} [collectionTileSize=800]
	  *     If collectionMode is true, specifies the size, in viewport coordinates, for each TiledImage to fit into.
	  *     The TiledImage will be centered within a square of the specified size.
	  *
	  * @property {Number} [collectionTileMargin=80]
	  *     If collectionMode is true, specifies the margin, in viewport coordinates, between each TiledImage.
	  *
	  * @property {String|Boolean} [crossOriginPolicy=false]
	  *     Valid values are 'Anonymous', 'use-credentials', and false. If false, canvas requests will
	  *     not use CORS, and the canvas will be tainted.
	  *
	  * @property {Boolean} [ajaxWithCredentials=false]
	  *     Whether to set the withCredentials XHR flag for AJAX requests (when loading tile sources).
	  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
	  *
	  */
	
	 /**
	  * Settings for gestures generated by a pointer device.
	  *
	  * @typedef {Object} GestureSettings
	  * @memberof OpenSeadragon
	  *
	  * @property {Boolean} scrollToZoom
	  *     Set to false to disable zooming on scroll gestures.
	  *
	  * @property {Boolean} clickToZoom
	  *     Set to false to disable zooming on click gestures.
	  *
	  * @property {Boolean} dblClickToZoom
	  *     Set to false to disable zooming on double-click gestures. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  *
	  * @property {Boolean} pinchToZoom
	  *     Set to false to disable zooming on pinch gestures.
	  *
	  * @property {Boolean} flickEnabled
	  *     Set to false to disable the kinetic panning effect (flick) at the end of a drag gesture.
	  *
	  * @property {Number} flickMinSpeed
	  *     If flickEnabled is true, the minimum speed (in pixels-per-second) required to cause the kinetic panning effect (flick) at the end of a drag gesture.
	  *
	  * @property {Number} flickMomentum
	  *     If flickEnabled is true, a constant multiplied by the velocity to determine the distance of the kinetic panning effect (flick) at the end of a drag gesture.
	  *     A larger value will make the flick feel "lighter", while a smaller value will make the flick feel "heavier".
	  *     Note: springStiffness and animationTime also affect the "spring" used to stop the flick animation.
	  *
	  */
	
	/**
	  * The names for the image resources used for the image navigation buttons.
	  *
	  * @typedef {Object} NavImages
	  * @memberof OpenSeadragon
	  *
	  * @property {Object} zoomIn - Images for the zoom-in button.
	  * @property {String} zoomIn.REST
	  * @property {String} zoomIn.GROUP
	  * @property {String} zoomIn.HOVER
	  * @property {String} zoomIn.DOWN
	  *
	  * @property {Object} zoomOut - Images for the zoom-out button.
	  * @property {String} zoomOut.REST
	  * @property {String} zoomOut.GROUP
	  * @property {String} zoomOut.HOVER
	  * @property {String} zoomOut.DOWN
	  *
	  * @property {Object} home - Images for the home button.
	  * @property {String} home.REST
	  * @property {String} home.GROUP
	  * @property {String} home.HOVER
	  * @property {String} home.DOWN
	  *
	  * @property {Object} fullpage - Images for the full-page button.
	  * @property {String} fullpage.REST
	  * @property {String} fullpage.GROUP
	  * @property {String} fullpage.HOVER
	  * @property {String} fullpage.DOWN
	  *
	  * @property {Object} rotateleft - Images for the rotate left button.
	  * @property {String} rotateleft.REST
	  * @property {String} rotateleft.GROUP
	  * @property {String} rotateleft.HOVER
	  * @property {String} rotateleft.DOWN
	  *
	  * @property {Object} rotateright - Images for the rotate right button.
	  * @property {String} rotateright.REST
	  * @property {String} rotateright.GROUP
	  * @property {String} rotateright.HOVER
	  * @property {String} rotateright.DOWN
	  *
	  * @property {Object} previous - Images for the previous button.
	  * @property {String} previous.REST
	  * @property {String} previous.GROUP
	  * @property {String} previous.HOVER
	  * @property {String} previous.DOWN
	  *
	  * @property {Object} next - Images for the next button.
	  * @property {String} next.REST
	  * @property {String} next.GROUP
	  * @property {String} next.HOVER
	  * @property {String} next.DOWN
	  *
	  */
	
	
	 /**
	  * This function serves as a single point of instantiation for an {@link OpenSeadragon.Viewer}, including all
	  * combinations of out-of-the-box configurable features.
	  *
	  * @function OpenSeadragon
	  * @memberof module:OpenSeadragon
	  * @param {OpenSeadragon.Options} options - Viewer options.
	  * @returns {OpenSeadragon.Viewer}
	  */
	window.OpenSeadragon = window.OpenSeadragon || function( options ){
	
	    return new OpenSeadragon.Viewer( options );
	
	};
	
	if (true) {
	   !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	       return (window.OpenSeadragon);
	   }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	(function( $ ){
	
	
	    /**
	     * The OpenSeadragon version.
	     *
	     * @member {Object} OpenSeadragon.version
	     * @property {String} versionStr - The version number as a string ('major.minor.revision').
	     * @property {Number} major - The major version number.
	     * @property {Number} minor - The minor version number.
	     * @property {Number} revision - The revision number.
	     * @since 1.0.0
	     */
	    $.version = {
	        versionStr: '2.1.0',
	        major: parseInt('2', 10),
	        minor: parseInt('1', 10),
	        revision: parseInt('0', 10)
	    };
	
	
	    /**
	     * Taken from jquery 1.6.1
	     * [[Class]] -> type pairs
	     * @private
	     */
	    var class2type = {
	            '[object Boolean]':     'boolean',
	            '[object Number]':      'number',
	            '[object String]':      'string',
	            '[object Function]':    'function',
	            '[object Array]':       'array',
	            '[object Date]':        'date',
	            '[object RegExp]':      'regexp',
	            '[object Object]':      'object'
	        },
	        // Save a reference to some core methods
	        toString    = Object.prototype.toString,
	        hasOwn      = Object.prototype.hasOwnProperty;
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isFunction
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isFunction = function( obj ) {
	        return $.type(obj) === "function";
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isArray
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isArray = Array.isArray || function( obj ) {
	        return $.type(obj) === "array";
	    };
	
	
	    /**
	     * A crude way of determining if an object is a window.
	     * Taken from jQuery 1.6.1
	     * @function isWindow
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isWindow = function( obj ) {
	        return obj && typeof obj === "object" && "setInterval" in obj;
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function type
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.type = function( obj ) {
	        return ( obj === null ) || ( obj === undefined ) ?
	            String( obj ) :
	            class2type[ toString.call(obj) ] || "object";
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isPlainObject
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isPlainObject = function( obj ) {
	        // Must be an Object.
	        // Because of IE, we also have to check the presence of the constructor property.
	        // Make sure that DOM nodes and window objects don't pass through, as well
	        if ( !obj || OpenSeadragon.type(obj) !== "object" || obj.nodeType || $.isWindow( obj ) ) {
	            return false;
	        }
	
	        // Not own constructor property must be Object
	        if ( obj.constructor &&
	            !hasOwn.call(obj, "constructor") &&
	            !hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
	            return false;
	        }
	
	        // Own properties are enumerated firstly, so to speed up,
	        // if last one is own, then all properties are own.
	
	        var lastKey;
	        for (var key in obj ) {
	            lastKey = key;
	        }
	
	        return lastKey === undefined || hasOwn.call( obj, lastKey );
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isEmptyObject
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isEmptyObject = function( obj ) {
	        for ( var name in obj ) {
	            return false;
	        }
	        return true;
	    };
	
	
	    /**
	     * True if the browser supports the HTML5 canvas element
	     * @member {Boolean} supportsCanvas
	     * @memberof OpenSeadragon
	     */
	    $.supportsCanvas = (function () {
	        var canvasElement = document.createElement( 'canvas' );
	        return !!( $.isFunction( canvasElement.getContext ) &&
	                    canvasElement.getContext( '2d' ) );
	    }());
	
	    /**
	     * Test whether the submitted canvas is tainted or not.
	     * @argument {Canvas} canvas The canvas to test.
	     * @returns {Boolean} True if the canvas is tainted.
	     */
	    $.isCanvasTainted = function(canvas) {
	        var isTainted = false;
	        try {
	            // We test if the canvas is tainted by retrieving data from it.
	            // An exception will be raised if the canvas is tainted.
	            var data = canvas.getContext('2d').getImageData(0, 0, 1, 1);
	        } catch (e) {
	            isTainted = true;
	        }
	        return isTainted;
	    };
	
	    /**
	     * A ratio comparing the device screen's pixel density to the canvas's backing store pixel density. Defaults to 1 if canvas isn't supported by the browser.
	     * @member {Number} pixelDensityRatio
	     * @memberof OpenSeadragon
	     */
	    $.pixelDensityRatio = (function () {
	        if ( $.supportsCanvas ) {
	            var context = document.createElement('canvas').getContext('2d');
	            var devicePixelRatio = window.devicePixelRatio || 1;
	            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
	                                    context.mozBackingStorePixelRatio ||
	                                    context.msBackingStorePixelRatio ||
	                                    context.oBackingStorePixelRatio ||
	                                    context.backingStorePixelRatio || 1;
	            return devicePixelRatio / backingStoreRatio;
	        } else {
	            return 1;
	        }
	    }());
	
	}( OpenSeadragon ));
	
	/**
	 *  This closure defines all static methods available to the OpenSeadragon
	 *  namespace.  Many, if not most, are taked directly from jQuery for use
	 *  to simplify and reduce common programming patterns.  More static methods
	 *  from jQuery may eventually make their way into this though we are
	 *  attempting to avoid an explicit dependency on jQuery only because
	 *  OpenSeadragon is a broadly useful code base and would be made less broad
	 *  by requiring jQuery fully.
	 *
	 *  Some static methods have also been refactored from the original OpenSeadragon
	 *  project.
	 */
	(function( $ ){
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function extend
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.extend = function() {
	        var options,
	            name,
	            src,
	            copy,
	            copyIsArray,
	            clone,
	            target  = arguments[ 0 ] || {},
	            length  = arguments.length,
	            deep    = false,
	            i       = 1;
	
	        // Handle a deep copy situation
	        if ( typeof target === "boolean" ) {
	            deep    = target;
	            target  = arguments[ 1 ] || {};
	            // skip the boolean and the target
	            i = 2;
	        }
	
	        // Handle case when target is a string or something (possible in deep copy)
	        if ( typeof target !== "object" && !OpenSeadragon.isFunction( target ) ) {
	            target = {};
	        }
	
	        // extend jQuery itself if only one argument is passed
	        if ( length === i ) {
	            target = this;
	            --i;
	        }
	
	        for ( ; i < length; i++ ) {
	            // Only deal with non-null/undefined values
	            options = arguments[ i ];
	            if ( options !== null || options !== undefined ) {
	                // Extend the base object
	                for ( name in options ) {
	                    src = target[ name ];
	                    copy = options[ name ];
	
	                    // Prevent never-ending loop
	                    if ( target === copy ) {
	                        continue;
	                    }
	
	                    // Recurse if we're merging plain objects or arrays
	                    if ( deep && copy && ( OpenSeadragon.isPlainObject( copy ) || ( copyIsArray = OpenSeadragon.isArray( copy ) ) ) ) {
	                        if ( copyIsArray ) {
	                            copyIsArray = false;
	                            clone = src && OpenSeadragon.isArray( src ) ? src : [];
	
	                        } else {
	                            clone = src && OpenSeadragon.isPlainObject( src ) ? src : {};
	                        }
	
	                        // Never move original objects, clone them
	                        target[ name ] = OpenSeadragon.extend( deep, clone, copy );
	
	                    // Don't bring in undefined values
	                    } else if ( copy !== undefined ) {
	                        target[ name ] = copy;
	                    }
	                }
	            }
	        }
	
	        // Return the modified object
	        return target;
	    };
	
	
	    $.extend( $, /** @lends OpenSeadragon */{
	        /**
	         * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
	         * @static
	         * @type {Object}
	         */
	        DEFAULT_SETTINGS: {
	            //DATA SOURCE DETAILS
	            xmlPath:                null,
	            tileSources:            null,
	            tileHost:               null,
	            initialPage:            0,
	            crossOriginPolicy:      false,
	            ajaxWithCredentials:    false,
	
	            //PAN AND ZOOM SETTINGS AND CONSTRAINTS
	            panHorizontal:          true,
	            panVertical:            true,
	            constrainDuringPan:     false,
	            wrapHorizontal:         false,
	            wrapVertical:           false,
	            visibilityRatio:        0.5, //-> how much of the viewer can be negative space
	            minPixelRatio:          0.5, //->closer to 0 draws tiles meant for a higher zoom at this zoom
	            defaultZoomLevel:       0,
	            minZoomLevel:           null,
	            maxZoomLevel:           null,
	            homeFillsViewer:        false,
	
	            //UI RESPONSIVENESS AND FEEL
	            clickTimeThreshold:     300,
	            clickDistThreshold:     5,
	            dblClickTimeThreshold:  300,
	            dblClickDistThreshold:  20,
	            springStiffness:        6.5,
	            animationTime:          1.2,
	            gestureSettingsMouse:   { scrollToZoom: true,  clickToZoom: true,  dblClickToZoom: false, pinchToZoom: false, flickEnabled: false, flickMinSpeed: 120, flickMomentum: 0.25, pinchRotate: false },
	            gestureSettingsTouch:   { scrollToZoom: false, clickToZoom: false, dblClickToZoom: true,  pinchToZoom: true,  flickEnabled: true,  flickMinSpeed: 120, flickMomentum: 0.25, pinchRotate: false },
	            gestureSettingsPen:     { scrollToZoom: false, clickToZoom: true,  dblClickToZoom: false, pinchToZoom: false, flickEnabled: false, flickMinSpeed: 120, flickMomentum: 0.25, pinchRotate: false },
	            gestureSettingsUnknown: { scrollToZoom: false, clickToZoom: false, dblClickToZoom: true,  pinchToZoom: true,  flickEnabled: true,  flickMinSpeed: 120, flickMomentum: 0.25, pinchRotate: false },
	            zoomPerClick:           2,
	            zoomPerScroll:          1.2,
	            zoomPerSecond:          1.0,
	            blendTime:              0,
	            alwaysBlend:            false,
	            autoHideControls:       true,
	            immediateRender:        false,
	            minZoomImageRatio:      0.9, //-> closer to 0 allows zoom out to infinity
	            maxZoomPixelRatio:      1.1, //-> higher allows 'over zoom' into pixels
	            pixelsPerWheelLine:     40,
	            autoResize:             true,
	            preserveImageSizeOnResize: false, // requires autoResize=true
	            minScrollDeltaTime:     50,
	
	            //DEFAULT CONTROL SETTINGS
	            showSequenceControl:     true,  //SEQUENCE
	            sequenceControlAnchor:   null,  //SEQUENCE
	            preserveViewport:        false, //SEQUENCE
	            preserveOverlays:        false, //SEQUENCE
	            navPrevNextWrap:         false, //SEQUENCE
	            showNavigationControl:   true,  //ZOOM/HOME/FULL/ROTATION
	            navigationControlAnchor: null,  //ZOOM/HOME/FULL/ROTATION
	            showZoomControl:         true,  //ZOOM
	            showHomeControl:         true,  //HOME
	            showFullPageControl:     true,  //FULL
	            showRotationControl:     false, //ROTATION
	            controlsFadeDelay:       2000,  //ZOOM/HOME/FULL/SEQUENCE
	            controlsFadeLength:      1500,  //ZOOM/HOME/FULL/SEQUENCE
	            mouseNavEnabled:         true,  //GENERAL MOUSE INTERACTIVITY
	
	            //VIEWPORT NAVIGATOR SETTINGS
	            showNavigator:              false,
	            navigatorId:                null,
	            navigatorPosition:          null,
	            navigatorSizeRatio:         0.2,
	            navigatorMaintainSizeRatio: false,
	            navigatorTop:               null,
	            navigatorLeft:              null,
	            navigatorHeight:            null,
	            navigatorWidth:             null,
	            navigatorAutoResize:        true,
	            navigatorRotate:            true,
	
	            // INITIAL ROTATION
	            degrees:                    0,
	
	            // APPEARANCE
	            opacity:                    1,
	            placeholderFillStyle:       null,
	
	            //REFERENCE STRIP SETTINGS
	            showReferenceStrip:          false,
	            referenceStripScroll:       'horizontal',
	            referenceStripElement:       null,
	            referenceStripHeight:        null,
	            referenceStripWidth:         null,
	            referenceStripPosition:      'BOTTOM_LEFT',
	            referenceStripSizeRatio:     0.2,
	
	            //COLLECTION VISUALIZATION SETTINGS
	            collectionRows:         3, //or columns depending on layout
	            collectionColumns:      0, //columns in horizontal layout, rows in vertical layout
	            collectionLayout:       'horizontal', //vertical
	            collectionMode:         false,
	            collectionTileSize:     800,
	            collectionTileMargin:   80,
	
	            //PERFORMANCE SETTINGS
	            imageLoaderLimit:       0,
	            maxImageCacheCount:     200,
	            timeout:                30000,
	            useCanvas:              true,  // Use canvas element for drawing if available
	
	            //INTERFACE RESOURCE SETTINGS
	            prefixUrl:              "/images/",
	            navImages: {
	                zoomIn: {
	                    REST:   'zoomin_rest.png',
	                    GROUP:  'zoomin_grouphover.png',
	                    HOVER:  'zoomin_hover.png',
	                    DOWN:   'zoomin_pressed.png'
	                },
	                zoomOut: {
	                    REST:   'zoomout_rest.png',
	                    GROUP:  'zoomout_grouphover.png',
	                    HOVER:  'zoomout_hover.png',
	                    DOWN:   'zoomout_pressed.png'
	                },
	                home: {
	                    REST:   'home_rest.png',
	                    GROUP:  'home_grouphover.png',
	                    HOVER:  'home_hover.png',
	                    DOWN:   'home_pressed.png'
	                },
	                fullpage: {
	                    REST:   'fullpage_rest.png',
	                    GROUP:  'fullpage_grouphover.png',
	                    HOVER:  'fullpage_hover.png',
	                    DOWN:   'fullpage_pressed.png'
	                },
	                rotateleft: {
	                    REST:   'rotateleft_rest.png',
	                    GROUP:  'rotateleft_grouphover.png',
	                    HOVER:  'rotateleft_hover.png',
	                    DOWN:   'rotateleft_pressed.png'
	                },
	                rotateright: {
	                    REST:   'rotateright_rest.png',
	                    GROUP:  'rotateright_grouphover.png',
	                    HOVER:  'rotateright_hover.png',
	                    DOWN:   'rotateright_pressed.png'
	                },
	                previous: {
	                    REST:   'previous_rest.png',
	                    GROUP:  'previous_grouphover.png',
	                    HOVER:  'previous_hover.png',
	                    DOWN:   'previous_pressed.png'
	                },
	                next: {
	                    REST:   'next_rest.png',
	                    GROUP:  'next_grouphover.png',
	                    HOVER:  'next_hover.png',
	                    DOWN:   'next_pressed.png'
	                }
	            },
	
	            //DEVELOPER SETTINGS
	            debugMode:              false,
	            debugGridColor:         '#437AB2'
	        },
	
	
	        /**
	         * TODO: get rid of this.  I can't see how it's required at all.  Looks
	         *       like an early legacy code artifact.
	         * @static
	         * @ignore
	         */
	        SIGNAL: "----seadragon----",
	
	
	        /**
	         * Returns a function which invokes the method as if it were a method belonging to the object.
	         * @function
	         * @param {Object} object
	         * @param {Function} method
	         * @returns {Function}
	         */
	        delegate: function( object, method ) {
	            return function(){
	                var args = arguments;
	                if ( args === undefined ){
	                    args = [];
	                }
	                return method.apply( object, args );
	            };
	        },
	
	
	        /**
	         * An enumeration of Browser vendors.
	         * @static
	         * @type {Object}
	         * @property {Number} UNKNOWN
	         * @property {Number} IE
	         * @property {Number} FIREFOX
	         * @property {Number} SAFARI
	         * @property {Number} CHROME
	         * @property {Number} OPERA
	         */
	        BROWSERS: {
	            UNKNOWN:    0,
	            IE:         1,
	            FIREFOX:    2,
	            SAFARI:     3,
	            CHROME:     4,
	            OPERA:      5
	        },
	
	
	        /**
	         * Returns a DOM Element for the given id or element.
	         * @function
	         * @param {String|Element} element Accepts an id or element.
	         * @returns {Element} The element with the given id, null, or the element itself.
	         */
	        getElement: function( element ) {
	            if ( typeof ( element ) == "string" ) {
	                element = document.getElementById( element );
	            }
	            return element;
	        },
	
	
	        /**
	         * Determines the position of the upper-left corner of the element.
	         * @function
	         * @param {Element|String} element - the elemenet we want the position for.
	         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
	         */
	        getElementPosition: function( element ) {
	            var result = new $.Point(),
	                isFixed,
	                offsetParent;
	
	            element      = $.getElement( element );
	            isFixed      = $.getElementStyle( element ).position == "fixed";
	            offsetParent = getOffsetParent( element, isFixed );
	
	            while ( offsetParent ) {
	
	                result.x += element.offsetLeft;
	                result.y += element.offsetTop;
	
	                if ( isFixed ) {
	                    result = result.plus( $.getPageScroll() );
	                }
	
	                element = offsetParent;
	                isFixed = $.getElementStyle( element ).position == "fixed";
	                offsetParent = getOffsetParent( element, isFixed );
	            }
	
	            return result;
	        },
	
	
	        /**
	         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
	         * @function
	         * @param {Element|String} element - the element we want the position for.
	         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
	         */
	        getElementOffset: function( element ) {
	            element = $.getElement( element );
	
	            var doc = element && element.ownerDocument,
	                docElement,
	                win,
	                boundingRect = { top: 0, left: 0 };
	
	            if ( !doc ) {
	                return new $.Point();
	            }
	
	            docElement = doc.documentElement;
	
	            if ( typeof element.getBoundingClientRect !== typeof undefined ) {
	                boundingRect = element.getBoundingClientRect();
	            }
	
	            win = ( doc == doc.window ) ?
	                doc :
	                ( doc.nodeType === 9 ) ?
	                    doc.defaultView || doc.parentWindow :
	                    false;
	
	            return new $.Point(
	                boundingRect.left + ( win.pageXOffset || docElement.scrollLeft ) - ( docElement.clientLeft || 0 ),
	                boundingRect.top + ( win.pageYOffset || docElement.scrollTop ) - ( docElement.clientTop || 0 )
	            );
	        },
	
	
	        /**
	         * Determines the height and width of the given element.
	         * @function
	         * @param {Element|String} element
	         * @returns {OpenSeadragon.Point}
	         */
	        getElementSize: function( element ) {
	            element = $.getElement( element );
	
	            return new $.Point(
	                element.clientWidth,
	                element.clientHeight
	            );
	        },
	
	
	        /**
	         * Returns the CSSStyle object for the given element.
	         * @function
	         * @param {Element|String} element
	         * @returns {CSSStyle}
	         */
	        getElementStyle:
	            document.documentElement.currentStyle ?
	            function( element ) {
	                element = $.getElement( element );
	                return element.currentStyle;
	            } :
	            function( element ) {
	                element = $.getElement( element );
	                return window.getComputedStyle( element, "" );
	            },
	
	
	        /**
	         * Determines if a point is within the bounding rectangle of the given element (hit-test).
	         * @function
	         * @param {Element|String} element
	         * @param {OpenSeadragon.Point} point
	         * @returns {Boolean}
	         */
	        pointInElement: function( element, point ) {
	            element = $.getElement( element );
	            var offset = $.getElementOffset( element ),
	                size = $.getElementSize( element );
	            return point.x >= offset.x && point.x < offset.x + size.x && point.y < offset.y + size.y && point.y >= offset.y;
	        },
	
	
	        /**
	         * Gets the latest event, really only useful internally since its
	         * specific to IE behavior.
	         * @function
	         * @param {Event} [event]
	         * @returns {Event}
	         * @deprecated For internal use only
	         * @private
	         */
	        getEvent: function( event ) {
	            if( event ){
	                $.getEvent = function( event ) {
	                    return event;
	                };
	            } else {
	                $.getEvent = function() {
	                    return window.event;
	                };
	            }
	            return $.getEvent( event );
	        },
	
	
	        /**
	         * Gets the position of the mouse on the screen for a given event.
	         * @function
	         * @param {Event} [event]
	         * @returns {OpenSeadragon.Point}
	         */
	        getMousePosition: function( event ) {
	
	            if ( typeof( event.pageX ) == "number" ) {
	                $.getMousePosition = function( event ){
	                    var result = new $.Point();
	
	                    event = $.getEvent( event );
	                    result.x = event.pageX;
	                    result.y = event.pageY;
	
	                    return result;
	                };
	            } else if ( typeof( event.clientX ) == "number" ) {
	                $.getMousePosition = function( event ){
	                    var result = new $.Point();
	
	                    event = $.getEvent( event );
	                    result.x =
	                        event.clientX +
	                        document.body.scrollLeft +
	                        document.documentElement.scrollLeft;
	                    result.y =
	                        event.clientY +
	                        document.body.scrollTop +
	                        document.documentElement.scrollTop;
	
	                    return result;
	                };
	            } else {
	                throw new Error(
	                    "Unknown event mouse position, no known technique."
	                );
	            }
	
	            return $.getMousePosition( event );
	        },
	
	
	        /**
	         * Determines the page's current scroll position.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        getPageScroll: function() {
	            var docElement  = document.documentElement || {},
	                body        = document.body || {};
	
	            if ( typeof( window.pageXOffset ) == "number" ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        window.pageXOffset,
	                        window.pageYOffset
	                    );
	                };
	            } else if ( body.scrollLeft || body.scrollTop ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        document.body.scrollLeft,
	                        document.body.scrollTop
	                    );
	                };
	            } else if ( docElement.scrollLeft || docElement.scrollTop ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        document.documentElement.scrollLeft,
	                        document.documentElement.scrollTop
	                    );
	                };
	            } else {
	                // We can't reassign the function yet, as there was no scroll.
	                return new $.Point(0,0);
	            }
	
	            return $.getPageScroll();
	        },
	
	        /**
	         * Set the page scroll position.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        setPageScroll: function( scroll ) {
	            if ( typeof ( window.scrollTo ) !== "undefined" ) {
	                $.setPageScroll = function( scroll ) {
	                    window.scrollTo( scroll.x, scroll.y );
	                };
	            } else {
	                var originalScroll = $.getPageScroll();
	                if ( originalScroll.x === scroll.x &&
	                    originalScroll.y === scroll.y ) {
	                    // We are already correctly positioned and there
	                    // is no way to detect the correct method.
	                    return;
	                }
	
	                document.body.scrollLeft = scroll.x;
	                document.body.scrollTop = scroll.y;
	                var currentScroll = $.getPageScroll();
	                if ( currentScroll.x !== originalScroll.x &&
	                    currentScroll.y !== originalScroll.y ) {
	                    $.setPageScroll = function( scroll ) {
	                        document.body.scrollLeft = scroll.x;
	                        document.body.scrollTop = scroll.y;
	                    };
	                    return;
	                }
	
	                document.documentElement.scrollLeft = scroll.x;
	                document.documentElement.scrollTop = scroll.y;
	                currentScroll = $.getPageScroll();
	                if ( currentScroll.x !== originalScroll.x &&
	                    currentScroll.y !== originalScroll.y ) {
	                    $.setPageScroll = function( scroll ) {
	                        document.documentElement.scrollLeft = scroll.x;
	                        document.documentElement.scrollTop = scroll.y;
	                    };
	                    return;
	                }
	
	                // We can't find anything working, so we do nothing.
	                $.setPageScroll = function( scroll ) {
	                };
	            }
	
	            return $.setPageScroll( scroll );
	        },
	
	        /**
	         * Determines the size of the browsers window.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        getWindowSize: function() {
	            var docElement = document.documentElement || {},
	                body    = document.body || {};
	
	            if ( typeof( window.innerWidth ) == 'number' ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        window.innerWidth,
	                        window.innerHeight
	                    );
	                };
	            } else if ( docElement.clientWidth || docElement.clientHeight ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        document.documentElement.clientWidth,
	                        document.documentElement.clientHeight
	                    );
	                };
	            } else if ( body.clientWidth || body.clientHeight ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        document.body.clientWidth,
	                        document.body.clientHeight
	                    );
	                };
	            } else {
	                throw new Error("Unknown window size, no known technique.");
	            }
	
	            return $.getWindowSize();
	        },
	
	
	        /**
	         * Wraps the given element in a nest of divs so that the element can
	         * be easily centered using CSS tables
	         * @function
	         * @param {Element|String} element
	         * @returns {Element} outermost wrapper element
	         */
	        makeCenteredNode: function( element ) {
	            // Convert a possible ID to an actual HTMLElement
	            element = $.getElement( element );
	
	            /*
	                CSS tables require you to have a display:table/row/cell hierarchy so we need to create
	                three nested wrapper divs:
	             */
	
	            var wrappers = [
	                $.makeNeutralElement( 'div' ),
	                $.makeNeutralElement( 'div' ),
	                $.makeNeutralElement( 'div' )
	            ];
	
	            // It feels like we should be able to pass style dicts to makeNeutralElement:
	            $.extend(wrappers[0].style, {
	                display: "table",
	                height: "100%",
	                width: "100%"
	            });
	
	            $.extend(wrappers[1].style, {
	                display: "table-row"
	            });
	
	            $.extend(wrappers[2].style, {
	                display: "table-cell",
	                verticalAlign: "middle",
	                textAlign: "center"
	            });
	
	            wrappers[0].appendChild(wrappers[1]);
	            wrappers[1].appendChild(wrappers[2]);
	            wrappers[2].appendChild(element);
	
	            return wrappers[0];
	        },
	
	
	        /**
	         * Creates an easily positionable element of the given type that therefor
	         * serves as an excellent container element.
	         * @function
	         * @param {String} tagName
	         * @returns {Element}
	         */
	        makeNeutralElement: function( tagName ) {
	            var element = document.createElement( tagName ),
	                style   = element.style;
	
	            style.background = "transparent none";
	            style.border     = "none";
	            style.margin     = "0px";
	            style.padding    = "0px";
	            style.position   = "static";
	
	            return element;
	        },
	
	
	        /**
	         * Returns the current milliseconds, using Date.now() if available
	         * @function
	         */
	        now: function( ) {
	          if (Date.now) {
	            $.now = Date.now;
	          } else {
	            $.now = function() { return new Date().getTime(); };
	          }
	
	          return $.now();
	        },
	
	
	        /**
	         * Ensures an image is loaded correctly to support alpha transparency.
	         * Generally only IE has issues doing this correctly for formats like
	         * png.
	         * @function
	         * @param {String} src
	         * @returns {Element}
	         */
	        makeTransparentImage: function( src ) {
	
	            $.makeTransparentImage = function( src ){
	                var img = $.makeNeutralElement( "img" );
	
	                img.src = src;
	
	                return img;
	            };
	
	            if ( $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7 ) {
	
	                $.makeTransparentImage = function( src ){
	                    var img     = $.makeNeutralElement( "img" ),
	                        element = null;
	
	                    element = $.makeNeutralElement("span");
	                    element.style.display = "inline-block";
	
	                    img.onload = function() {
	                        element.style.width  = element.style.width || img.width + "px";
	                        element.style.height = element.style.height || img.height + "px";
	
	                        img.onload = null;
	                        img = null;     // to prevent memory leaks in IE
	                    };
	
	                    img.src = src;
	                    element.style.filter =
	                        "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" +
	                        src +
	                        "', sizingMethod='scale')";
	
	                    return element;
	                };
	
	            }
	
	            return $.makeTransparentImage( src );
	        },
	
	
	        /**
	         * Sets the opacity of the specified element.
	         * @function
	         * @param {Element|String} element
	         * @param {Number} opacity
	         * @param {Boolean} [usesAlpha]
	         */
	        setElementOpacity: function( element, opacity, usesAlpha ) {
	
	            var ieOpacity,
	                ieFilter;
	
	            element = $.getElement( element );
	
	            if ( usesAlpha && !$.Browser.alpha ) {
	                opacity = Math.round( opacity );
	            }
	
	            if ( $.Browser.opacity ) {
	                element.style.opacity = opacity < 1 ? opacity : "";
	            } else {
	                if ( opacity < 1 ) {
	                    ieOpacity = Math.round( 100 * opacity );
	                    ieFilter  = "alpha(opacity=" + ieOpacity + ")";
	                    element.style.filter = ieFilter;
	                } else {
	                    element.style.filter = "";
	                }
	            }
	        },
	
	
	        /**
	         * Sets the specified element's touch-action style attribute to 'none'.
	         * @function
	         * @param {Element|String} element
	         */
	        setElementTouchActionNone: function( element ) {
	            element = $.getElement( element );
	            if ( typeof element.style.touchAction !== 'undefined' ) {
	                element.style.touchAction = 'none';
	            } else if ( typeof element.style.msTouchAction !== 'undefined' ) {
	                element.style.msTouchAction = 'none';
	            }
	        },
	
	
	        /**
	         * Add the specified CSS class to the element if not present.
	         * @function
	         * @param {Element|String} element
	         * @param {String} className
	         */
	        addClass: function( element, className ) {
	            element = $.getElement( element );
	
	            if ( ! element.className ) {
	                element.className = className;
	            } else if ( ( ' ' + element.className + ' ' ).
	                indexOf( ' ' + className + ' ' ) === -1 ) {
	                element.className += ' ' + className;
	            }
	        },
	
	        /**
	         * Find the first index at which an element is found in an array or -1
	         * if not present.
	         *
	         * Code taken and adapted from
	         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
	         *
	         * @function
	         * @param {Array} array The array from which to find the element
	         * @param {Object} searchElement The element to find
	         * @param {Number} [fromIndex=0] Index to start research.
	         * @returns {Number} The index of the element in the array.
	         */
	        indexOf: function( array, searchElement, fromIndex ) {
	            if ( Array.prototype.indexOf ) {
	                this.indexOf = function( array, searchElement, fromIndex ) {
	                    return array.indexOf( searchElement, fromIndex );
	                };
	            } else {
	                this.indexOf = function( array, searchElement, fromIndex ) {
	                    var i,
	                        pivot = ( fromIndex ) ? fromIndex : 0,
	                        length;
	                    if ( !array ) {
	                        throw new TypeError( );
	                    }
	
	                    length = array.length;
	                    if ( length === 0 || pivot >= length ) {
	                        return -1;
	                    }
	
	                    if ( pivot < 0 ) {
	                        pivot = length - Math.abs( pivot );
	                    }
	
	                    for ( i = pivot; i < length; i++ ) {
	                        if ( array[i] === searchElement ) {
	                            return i;
	                        }
	                    }
	                    return -1;
	                };
	            }
	            return this.indexOf( array, searchElement, fromIndex );
	        },
	
	        /**
	         * Remove the specified CSS class from the element.
	         * @function
	         * @param {Element|String} element
	         * @param {String} className
	         */
	        removeClass: function( element, className ) {
	            var oldClasses,
	                newClasses = [],
	                i;
	
	            element = $.getElement( element );
	            oldClasses = element.className.split( /\s+/ );
	            for ( i = 0; i < oldClasses.length; i++ ) {
	                if ( oldClasses[ i ] && oldClasses[ i ] !== className ) {
	                    newClasses.push( oldClasses[ i ] );
	                }
	            }
	            element.className = newClasses.join(' ');
	        },
	
	
	        /**
	         * Adds an event listener for the given element, eventName and handler.
	         * @function
	         * @param {Element|String} element
	         * @param {String} eventName
	         * @param {Function} handler
	         * @param {Boolean} [useCapture]
	         */
	        addEvent: (function () {
	            if ( window.addEventListener ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.addEventListener( eventName, handler, useCapture );
	                };
	            } else if ( window.attachEvent ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.attachEvent( 'on' + eventName, handler );
	                };
	            } else {
	                throw new Error( "No known event model." );
	            }
	        }()),
	
	
	        /**
	         * Remove a given event listener for the given element, event type and
	         * handler.
	         * @function
	         * @param {Element|String} element
	         * @param {String} eventName
	         * @param {Function} handler
	         * @param {Boolean} [useCapture]
	         */
	        removeEvent: (function () {
	            if ( window.removeEventListener ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.removeEventListener( eventName, handler, useCapture );
	                };
	            } else if ( window.detachEvent ) {
	                return function( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.detachEvent( 'on' + eventName, handler );
	                };
	            } else {
	                throw new Error( "No known event model." );
	            }
	        }()),
	
	
	        /**
	         * Cancels the default browser behavior had the event propagated all
	         * the way up the DOM to the window object.
	         * @function
	         * @param {Event} [event]
	         */
	        cancelEvent: function( event ) {
	            event = $.getEvent( event );
	
	            if ( event.preventDefault ) {
	                $.cancelEvent = function( event ){
	                    // W3C for preventing default
	                    event.preventDefault();
	                };
	            } else {
	                $.cancelEvent = function( event ){
	                    event = $.getEvent( event );
	                    // legacy for preventing default
	                    event.cancel = true;
	                    // IE for preventing default
	                    event.returnValue = false;
	                };
	            }
	            $.cancelEvent( event );
	        },
	
	
	        /**
	         * Stops the propagation of the event up the DOM.
	         * @function
	         * @param {Event} [event]
	         */
	        stopEvent: function( event ) {
	            event = $.getEvent( event );
	
	            if ( event.stopPropagation ) {
	                // W3C for stopping propagation
	                $.stopEvent = function( event ){
	                    event.stopPropagation();
	                };
	            } else {
	                // IE for stopping propagation
	                $.stopEvent = function( event ){
	                    event = $.getEvent( event );
	                    event.cancelBubble = true;
	                };
	
	            }
	
	            $.stopEvent( event );
	        },
	
	
	        /**
	         * Similar to OpenSeadragon.delegate, but it does not immediately call
	         * the method on the object, returning a function which can be called
	         * repeatedly to delegate the method. It also allows additonal arguments
	         * to be passed during construction which will be added during each
	         * invocation, and each invocation can add additional arguments as well.
	         *
	         * @function
	         * @param {Object} object
	         * @param {Function} method
	         * @param [args] any additional arguments are passed as arguments to the
	         *  created callback
	         * @returns {Function}
	         */
	        createCallback: function( object, method ) {
	            //TODO: This pattern is painful to use and debug.  It's much cleaner
	            //      to use pinning plus anonymous functions.  Get rid of this
	            //      pattern!
	            var initialArgs = [],
	                i;
	            for ( i = 2; i < arguments.length; i++ ) {
	                initialArgs.push( arguments[ i ] );
	            }
	
	            return function() {
	                var args = initialArgs.concat( [] ),
	                    i;
	                for ( i = 0; i < arguments.length; i++ ) {
	                    args.push( arguments[ i ] );
	                }
	
	                return method.apply( object, args );
	            };
	        },
	
	
	        /**
	         * Retreives the value of a url parameter from the window.location string.
	         * @function
	         * @param {String} key
	         * @returns {String} The value of the url parameter or null if no param matches.
	         */
	        getUrlParameter: function( key ) {
	            var value = URLPARAMS[ key ];
	            return value ? value : null;
	        },
	
	        /**
	         * Retrieves the protocol used by the url. The url can either be absolute
	         * or relative.
	         * @function
	         * @private
	         * @param {String} url The url to retrieve the protocol from.
	         * @return {String} The protocol (http:, https:, file:, ftp: ...)
	         */
	        getUrlProtocol: function( url ) {
	            var match = url.match(/^([a-z]+:)\/\//i);
	            if ( match === null ) {
	                // Relative URL, retrive the protocol from window.location
	                return window.location.protocol;
	            }
	            return match[1].toLowerCase();
	        },
	
	        /**
	         * Create an XHR object
	         * @private
	         * @param {type} [local] If set to true, the XHR will be file: protocol
	         * compatible if possible (but may raise a warning in the browser).
	         * @returns {XMLHttpRequest}
	         */
	        createAjaxRequest: function( local ) {
	            // IE11 does not support window.ActiveXObject so we just try to
	            // create one to see if it is supported.
	            // See: http://msdn.microsoft.com/en-us/library/ie/dn423948%28v=vs.85%29.aspx
	            var supportActiveX;
	            try {
	                /* global ActiveXObject:true */
	                supportActiveX = !!new ActiveXObject( "Microsoft.XMLHTTP" );
	            } catch( e ) {
	                supportActiveX = false;
	            }
	
	            if ( supportActiveX ) {
	                if ( window.XMLHttpRequest ) {
	                    $.createAjaxRequest = function( local ) {
	                        if ( local ) {
	                            return new ActiveXObject( "Microsoft.XMLHTTP" );
	                        }
	                        return new XMLHttpRequest();
	                    };
	                } else {
	                    $.createAjaxRequest = function() {
	                        return new ActiveXObject( "Microsoft.XMLHTTP" );
	                    };
	                }
	            } else if ( window.XMLHttpRequest ) {
	                $.createAjaxRequest = function() {
	                    return new XMLHttpRequest();
	                };
	            } else {
	                throw new Error( "Browser doesn't support XMLHttpRequest." );
	            }
	            return $.createAjaxRequest( local );
	        },
	
	        /**
	         * Makes an AJAX request.
	         * @param {Object} options
	         * @param {String} options.url - the url to request
	         * @param {Function} options.success - a function to call on a successful response
	         * @param {Function} options.error - a function to call on when an error occurs
	         * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
	         * @throws {Error}
	         */
	        makeAjaxRequest: function( url, onSuccess, onError ) {
	            var withCredentials;
	
	            // Note that our preferred API is that you pass in a single object; the named
	            // arguments are for legacy support.
	            if( $.isPlainObject( url ) ){
	                onSuccess = url.success;
	                onError = url.error;
	                withCredentials = url.withCredentials;
	                url = url.url;
	            }
	
	            var protocol = $.getUrlProtocol( url );
	            var request = $.createAjaxRequest( protocol === "file:" );
	
	            if ( !$.isFunction( onSuccess ) ) {
	                throw new Error( "makeAjaxRequest requires a success callback" );
	            }
	
	            request.onreadystatechange = function() {
	                // 4 = DONE (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Properties)
	                if ( request.readyState == 4 ) {
	                    request.onreadystatechange = function(){};
	
	                    // With protocols other than http/https, the status is 200
	                    // on Firefox and 0 on other browsers
	                    if ( request.status === 200 ||
	                        ( request.status === 0 &&
	                          protocol !== "http:" &&
	                          protocol !== "https:" )) {
	                        onSuccess( request );
	                    } else {
	                        $.console.log( "AJAX request returned %d: %s", request.status, url );
	
	                        if ( $.isFunction( onError ) ) {
	                            onError( request );
	                        }
	                    }
	                }
	            };
	
	            if (withCredentials) {
	                request.withCredentials = true;
	            }
	
	            try {
	                request.open( "GET", url, true );
	                request.send( null );
	            } catch (e) {
	                var msg = e.message;
	
	                /*
	                    IE < 10 does not support CORS and an XHR request to a different origin will fail as soon
	                    as send() is called. This is particularly easy to miss during development and appear in
	                    production if you use a CDN or domain sharding and the security policy is likely to break
	                    exception handlers since any attempt to access a property of the request object will
	                    raise an access denied TypeError inside the catch block.
	
	                    To be friendlier, we'll check for this specific error and add a documentation pointer
	                    to point developers in the right direction. We test the exception number because IE's
	                    error messages are localized.
	                */
	                var oldIE = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;
	                if ( oldIE && typeof( e.number ) != "undefined" && e.number == -2147024891 ) {
	                    msg += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain";
	                }
	
	                $.console.log( "%s while making AJAX request: %s", e.name, msg );
	
	                request.onreadystatechange = function(){};
	
	                if (window.XDomainRequest) { // IE9 or IE8 might as well try to use XDomainRequest
	                    var xdr = new XDomainRequest();
	                    if (xdr) {
	                        xdr.onload = function (e) {
	                            if ( $.isFunction( onSuccess ) ) {
	                                onSuccess({ // Faking an xhr object
	                                    responseText: xdr.responseText,
	                                    status: 200, // XDomainRequest doesn't support status codes, so we just fake one! :/
	                                    statusText: 'OK'
	                                });
	                            }
	                        };
	                        xdr.onerror = function (e) {
	                            if ( $.isFunction ( onError ) ) {
	                                onError({ // Faking an xhr object
	                                    responseText: xdr.responseText,
	                                    status: 444, // 444 No Response
	                                    statusText: 'An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser.'
	                                });
	                            }
	                        };
	                        try {
	                            xdr.open('GET', url);
	                            xdr.send();
	                        } catch (e2) {
	                            if ( $.isFunction( onError ) ) {
	                                onError( request, e );
	                            }
	                        }
	                    }
	                } else {
	                    if ( $.isFunction( onError ) ) {
	                        onError( request, e );
	                    }
	                }
	            }
	        },
	
	        /**
	         * Taken from jQuery 1.6.1
	         * @function
	         * @param {Object} options
	         * @param {String} options.url
	         * @param {Function} options.callback
	         * @param {String} [options.param='callback'] The name of the url parameter
	         *      to request the jsonp provider with.
	         * @param {String} [options.callbackName=] The name of the callback to
	         *      request the jsonp provider with.
	         */
	        jsonp: function( options ){
	            var script,
	                url     = options.url,
	                head    = document.head ||
	                    document.getElementsByTagName( "head" )[ 0 ] ||
	                    document.documentElement,
	                jsonpCallback = options.callbackName || 'openseadragon' + $.now(),
	                previous      = window[ jsonpCallback ],
	                replace       = "$1" + jsonpCallback + "$2",
	                callbackParam = options.param || 'callback',
	                callback      = options.callback;
	
	            url = url.replace( /(\=)\?(&|$)|\?\?/i, replace );
	            // Add callback manually
	            url += (/\?/.test( url ) ? "&" : "?") + callbackParam + "=" + jsonpCallback;
	
	            // Install callback
	            window[ jsonpCallback ] = function( response ) {
	                if ( !previous ){
	                    try{
	                        delete window[ jsonpCallback ];
	                    }catch(e){
	                        //swallow
	                    }
	                } else {
	                    window[ jsonpCallback ] = previous;
	                }
	                if( callback && $.isFunction( callback ) ){
	                    callback( response );
	                }
	            };
	
	            script = document.createElement( "script" );
	
	            //TODO: having an issue with async info requests
	            if( undefined !== options.async || false !== options.async ){
	                script.async = "async";
	            }
	
	            if ( options.scriptCharset ) {
	                script.charset = options.scriptCharset;
	            }
	
	            script.src = url;
	
	            // Attach handlers for all browsers
	            script.onload = script.onreadystatechange = function( _, isAbort ) {
	
	                if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
	                    // Handle memory leak in IE
	                    script.onload = script.onreadystatechange = null;
	
	                    // Remove the script
	                    if ( head && script.parentNode ) {
	                        head.removeChild( script );
	                    }
	
	                    // Dereference the script
	                    script = undefined;
	                }
	            };
	            // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
	            // This arises when a base node is used (#2709 and #4378).
	            head.insertBefore( script, head.firstChild );
	
	        },
	
	
	        /**
	         * Fully deprecated. Will throw an error.
	         * @function
	         * @deprecated use {@link OpenSeadragon.Viewer#open}
	         */
	        createFromDZI: function() {
	            throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
	        },
	
	        /**
	         * Parses an XML string into a DOM Document.
	         * @function
	         * @param {String} string
	         * @returns {Document}
	         */
	        parseXml: function( string ) {
	            if ( window.DOMParser ) {
	
	                $.parseXml = function( string ) {
	                    var xmlDoc = null,
	                        parser;
	
	                    parser = new DOMParser();
	                    xmlDoc = parser.parseFromString( string, "text/xml" );
	                    return xmlDoc;
	                };
	
	            } else if ( window.ActiveXObject ) {
	
	                $.parseXml = function( string ) {
	                    var xmlDoc = null;
	
	                    xmlDoc = new ActiveXObject( "Microsoft.XMLDOM" );
	                    xmlDoc.async = false;
	                    xmlDoc.loadXML( string );
	                    return xmlDoc;
	                };
	
	            } else {
	                throw new Error( "Browser doesn't support XML DOM." );
	            }
	
	            return $.parseXml( string );
	        },
	
	        /**
	         * Parses a JSON string into a Javascript object.
	         * @function
	         * @param {String} string
	         * @returns {Object}
	         */
	        parseJSON: function(string) {
	            if (window.JSON && window.JSON.parse) {
	                $.parseJSON = window.JSON.parse;
	            } else {
	                // Should only be used by IE8 in non standards mode
	                $.parseJSON = function(string) {
	                    /*jshint evil:true*/
	                    return eval('(' + string + ')');
	                };
	            }
	            return $.parseJSON(string);
	        },
	
	        /**
	         * Reports whether the image format is supported for tiling in this
	         * version.
	         * @function
	         * @param {String} [extension]
	         * @returns {Boolean}
	         */
	        imageFormatSupported: function( extension ) {
	            extension = extension ? extension : "";
	            return !!FILEFORMATS[ extension.toLowerCase() ];
	        }
	
	    });
	
	
	    /**
	     * The current browser vendor, version, and related information regarding detected features.
	     * @member {Object} Browser
	     * @memberof OpenSeadragon
	     * @static
	     * @type {Object}
	     * @property {OpenSeadragon.BROWSERS} vendor - One of the {@link OpenSeadragon.BROWSERS} enumeration values.
	     * @property {Number} version
	     * @property {Boolean} alpha - Does the browser support image alpha transparency.
	     */
	    $.Browser = {
	        vendor:     $.BROWSERS.UNKNOWN,
	        version:    0,
	        alpha:      true
	    };
	
	
	    var FILEFORMATS = {
	            "bmp":  false,
	            "jpeg": true,
	            "jpg":  true,
	            "png":  true,
	            "tif":  false,
	            "wdp":  false
	        },
	        URLPARAMS = {};
	
	    (function() {
	        //A small auto-executing routine to determine the browser vendor,
	        //version and supporting feature sets.
	        var app = navigator.appName,
	            ver = navigator.appVersion,
	            ua  = navigator.userAgent,
	            regex;
	
	        //console.error( 'appName: ' + navigator.appName );
	        //console.error( 'appVersion: ' + navigator.appVersion );
	        //console.error( 'userAgent: ' + navigator.userAgent );
	
	        switch( navigator.appName ){
	            case "Microsoft Internet Explorer":
	                if( !!window.attachEvent &&
	                    !!window.ActiveXObject ) {
	
	                    $.Browser.vendor = $.BROWSERS.IE;
	                    $.Browser.version = parseFloat(
	                        ua.substring(
	                            ua.indexOf( "MSIE" ) + 5,
	                            ua.indexOf( ";", ua.indexOf( "MSIE" ) ) )
	                        );
	                }
	                break;
	            case "Netscape":
	                if( !!window.addEventListener ){
	                    if ( ua.indexOf( "Firefox" ) >= 0 ) {
	                        $.Browser.vendor = $.BROWSERS.FIREFOX;
	                        $.Browser.version = parseFloat(
	                            ua.substring( ua.indexOf( "Firefox" ) + 8 )
	                        );
	                    } else if ( ua.indexOf( "Safari" ) >= 0 ) {
	                        $.Browser.vendor = ua.indexOf( "Chrome" ) >= 0 ?
	                            $.BROWSERS.CHROME :
	                            $.BROWSERS.SAFARI;
	                        $.Browser.version = parseFloat(
	                            ua.substring(
	                                ua.substring( 0, ua.indexOf( "Safari" ) ).lastIndexOf( "/" ) + 1,
	                                ua.indexOf( "Safari" )
	                            )
	                        );
	                    } else {
	                        regex = new RegExp( "Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
	                        if ( regex.exec( ua ) !== null ) {
	                            $.Browser.vendor = $.BROWSERS.IE;
	                            $.Browser.version = parseFloat( RegExp.$1 );
	                        }
	                    }
	                }
	                break;
	            case "Opera":
	                $.Browser.vendor = $.BROWSERS.OPERA;
	                $.Browser.version = parseFloat( ver );
	                break;
	        }
	
	            // ignore '?' portion of query string
	        var query = window.location.search.substring( 1 ),
	            parts = query.split('&'),
	            part,
	            sep,
	            i;
	
	        for ( i = 0; i < parts.length; i++ ) {
	            part = parts[ i ];
	            sep  = part.indexOf( '=' );
	
	            if ( sep > 0 ) {
	                URLPARAMS[ part.substring( 0, sep ) ] =
	                    decodeURIComponent( part.substring( sep + 1 ) );
	            }
	        }
	
	        //determine if this browser supports image alpha transparency
	        $.Browser.alpha = !(
	            (
	                $.Browser.vendor == $.BROWSERS.IE &&
	                $.Browser.version < 9
	            ) || (
	                $.Browser.vendor == $.BROWSERS.CHROME &&
	                $.Browser.version < 2
	            )
	        );
	
	        //determine if this browser supports element.style.opacity
	        $.Browser.opacity = !(
	            $.Browser.vendor == $.BROWSERS.IE &&
	            $.Browser.version < 9
	        );
	
	    })();
	
	
	    //TODO: $.console is often used inside a try/catch block which generally
	    //      prevents allowings errors to occur with detection until a debugger
	    //      is attached.  Although I've been guilty of the same anti-pattern
	    //      I eventually was convinced that errors should naturally propogate in
	    //      all but the most special cases.
	    /**
	     * A convenient alias for console when available, and a simple null
	     * function when console is unavailable.
	     * @static
	     * @private
	     */
	    var nullfunction = function( msg ){
	            //document.location.hash = msg;
	        };
	
	    $.console = window.console || {
	        log:    nullfunction,
	        debug:  nullfunction,
	        info:   nullfunction,
	        warn:   nullfunction,
	        error:  nullfunction,
	        assert: nullfunction
	    };
	
	
	    // Adding support for HTML5's requestAnimationFrame as suggested by acdha.
	    // Implementation taken from matt synder's post here:
	    // http://mattsnider.com/cross-browser-and-legacy-supported-requestframeanimation/
	    (function( w ) {
	
	        // most browsers have an implementation
	        var requestAnimationFrame = w.requestAnimationFrame ||
	            w.mozRequestAnimationFrame ||
	            w.webkitRequestAnimationFrame ||
	            w.msRequestAnimationFrame;
	
	        var cancelAnimationFrame = w.cancelAnimationFrame ||
	            w.mozCancelAnimationFrame ||
	            w.webkitCancelAnimationFrame ||
	            w.msCancelAnimationFrame;
	
	        // polyfill, when necessary
	        if ( requestAnimationFrame && cancelAnimationFrame ) {
	            // We can't assign these window methods directly to $ because they
	            // expect their "this" to be "window", so we call them in wrappers.
	            $.requestAnimationFrame = function(){
	                return requestAnimationFrame.apply( w, arguments );
	            };
	            $.cancelAnimationFrame = function(){
	                return cancelAnimationFrame.apply( w, arguments );
	            };
	        } else {
	            var aAnimQueue = [],
	                processing = [],
	                iRequestId = 0,
	                iIntervalId;
	
	            // create a mock requestAnimationFrame function
	            $.requestAnimationFrame = function( callback ) {
	                aAnimQueue.push( [ ++iRequestId, callback ] );
	
	                if ( !iIntervalId ) {
	                    iIntervalId = setInterval( function() {
	                        if ( aAnimQueue.length ) {
	                            var time = $.now();
	                            // Process all of the currently outstanding frame
	                            // requests, but none that get added during the
	                            // processing.
	                            // Swap the arrays so we don't have to create a new
	                            // array every frame.
	                            var temp = processing;
	                            processing = aAnimQueue;
	                            aAnimQueue = temp;
	                            while ( processing.length ) {
	                                processing.shift()[ 1 ]( time );
	                            }
	                        } else {
	                            // don't continue the interval, if unnecessary
	                            clearInterval( iIntervalId );
	                            iIntervalId = undefined;
	                        }
	                    }, 1000 / 50);  // estimating support for 50 frames per second
	                }
	
	                return iRequestId;
	            };
	
	            // create a mock cancelAnimationFrame function
	            $.cancelAnimationFrame = function( requestId ) {
	                // find the request ID and remove it
	                var i, j;
	                for ( i = 0, j = aAnimQueue.length; i < j; i += 1 ) {
	                    if ( aAnimQueue[ i ][ 0 ] === requestId ) {
	                        aAnimQueue.splice( i, 1 );
	                        return;
	                    }
	                }
	
	                // If it's not in the queue, it may be in the set we're currently
	                // processing (if cancelAnimationFrame is called from within a
	                // requestAnimationFrame callback).
	                for ( i = 0, j = processing.length; i < j; i += 1 ) {
	                    if ( processing[ i ][ 0 ] === requestId ) {
	                        processing.splice( i, 1 );
	                        return;
	                    }
	                }
	            };
	        }
	    })( window );
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Element} element
	     * @param {Boolean} [isFixed]
	     * @returns {Element}
	     */
	    function getOffsetParent( element, isFixed ) {
	        if ( isFixed && element != document.body ) {
	            return document.body;
	        } else {
	            return element.offsetParent;
	        }
	    }
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {XMLHttpRequest} xhr
	     * @param {String} tilesUrl
	     * @deprecated
	     */
	    function processDZIResponse( xhr, tilesUrl ) {
	        var status,
	            statusText,
	            doc = null;
	
	        if ( !xhr ) {
	            throw new Error( $.getString( "Errors.Security" ) );
	        } else if ( xhr.status !== 200 && xhr.status !== 0 ) {
	            status     = xhr.status;
	            statusText = ( status == 404 ) ?
	                "Not Found" :
	                xhr.statusText;
	            throw new Error( $.getString( "Errors.Status", status, statusText ) );
	        }
	
	        if ( xhr.responseXML && xhr.responseXML.documentElement ) {
	            doc = xhr.responseXML;
	        } else if ( xhr.responseText ) {
	            doc = $.parseXml( xhr.responseText );
	        }
	
	        return processDZIXml( doc, tilesUrl );
	    }
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Document} xmlDoc
	     * @param {String} tilesUrl
	     * @deprecated
	     */
	    function processDZIXml( xmlDoc, tilesUrl ) {
	
	        if ( !xmlDoc || !xmlDoc.documentElement ) {
	            throw new Error( $.getString( "Errors.Xml" ) );
	        }
	
	        var root     = xmlDoc.documentElement,
	            rootName = root.tagName;
	
	        if ( rootName == "Image" ) {
	            try {
	                return processDZI( root, tilesUrl );
	            } catch ( e ) {
	                throw (e instanceof Error) ?
	                    e :
	                    new Error( $.getString("Errors.Dzi") );
	            }
	        } else if ( rootName == "Collection" ) {
	            throw new Error( $.getString( "Errors.Dzc" ) );
	        } else if ( rootName == "Error" ) {
	            return $._processDZIError( root );
	        }
	
	        throw new Error( $.getString( "Errors.Dzi" ) );
	    }
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Element} imageNode
	     * @param {String} tilesUrl
	     * @deprecated
	     */
	    function processDZI( imageNode, tilesUrl ) {
	        var fileFormat    = imageNode.getAttribute( "Format" ),
	            sizeNode      = imageNode.getElementsByTagName( "Size" )[ 0 ],
	            dispRectNodes = imageNode.getElementsByTagName( "DisplayRect" ),
	            width         = parseInt( sizeNode.getAttribute( "Width" ), 10 ),
	            height        = parseInt( sizeNode.getAttribute( "Height" ), 10 ),
	            tileSize      = parseInt( imageNode.getAttribute( "TileSize" ), 10 ),
	            tileOverlap   = parseInt( imageNode.getAttribute( "Overlap" ), 10 ),
	            dispRects     = [],
	            dispRectNode,
	            rectNode,
	            i;
	
	        if ( !$.imageFormatSupported( fileFormat ) ) {
	            throw new Error(
	                $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
	            );
	        }
	
	        for ( i = 0; i < dispRectNodes.length; i++ ) {
	            dispRectNode = dispRectNodes[ i ];
	            rectNode     = dispRectNode.getElementsByTagName( "Rect" )[ 0 ];
	
	            dispRects.push( new $.DisplayRect(
	                parseInt( rectNode.getAttribute( "X" ), 10 ),
	                parseInt( rectNode.getAttribute( "Y" ), 10 ),
	                parseInt( rectNode.getAttribute( "Width" ), 10 ),
	                parseInt( rectNode.getAttribute( "Height" ), 10 ),
	                0,  // ignore MinLevel attribute, bug in Deep Zoom Composer
	                parseInt( dispRectNode.getAttribute( "MaxLevel" ), 10 )
	            ));
	        }
	        return new $.DziTileSource(
	            width,
	            height,
	            tileSize,
	            tileOverlap,
	            tilesUrl,
	            fileFormat,
	            dispRects
	        );
	    }
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Element} imageNode
	     * @param {String} tilesUrl
	     * @deprecated
	     */
	    function processDZIJSON( imageData, tilesUrl ) {
	        var fileFormat    = imageData.Format,
	            sizeData      = imageData.Size,
	            dispRectData  = imageData.DisplayRect || [],
	            width         = parseInt( sizeData.Width, 10 ),
	            height        = parseInt( sizeData.Height, 10 ),
	            tileSize      = parseInt( imageData.TileSize, 10 ),
	            tileOverlap   = parseInt( imageData.Overlap, 10 ),
	            dispRects     = [],
	            rectData,
	            i;
	
	        if ( !$.imageFormatSupported( fileFormat ) ) {
	            throw new Error(
	                $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
	            );
	        }
	
	        for ( i = 0; i < dispRectData.length; i++ ) {
	            rectData     = dispRectData[ i ].Rect;
	
	            dispRects.push( new $.DisplayRect(
	                parseInt( rectData.X, 10 ),
	                parseInt( rectData.Y, 10 ),
	                parseInt( rectData.Width, 10 ),
	                parseInt( rectData.Height, 10 ),
	                0,  // ignore MinLevel attribute, bug in Deep Zoom Composer
	                parseInt( rectData.MaxLevel, 10 )
	            ));
	        }
	        return new $.DziTileSource(
	            width,
	            height,
	            tileSize,
	            tileOverlap,
	            tilesUrl,
	            fileFormat,
	            dispRects
	        );
	    }
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Document} errorNode
	     * @throws {Error}
	     * @deprecated
	     */
	    $._processDZIError = function ( errorNode ) {
	        var messageNode = errorNode.getElementsByTagName( "Message" )[ 0 ],
	            message     = messageNode.firstChild.nodeValue;
	
	        throw new Error(message);
	    };
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - full-screen support functions
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ) {
	    /**
	     * Determine native full screen support we can get from the browser.
	     * @member fullScreenApi
	     * @memberof OpenSeadragon
	     * @type {object}
	     * @property {Boolean} supportsFullScreen Return true if full screen API is supported.
	     * @property {Function} isFullScreen Return true if currently in full screen mode.
	     * @property {Function} getFullScreenElement Return the element currently in full screen mode.
	     * @property {Function} requestFullScreen Make a request to go in full screen mode.
	     * @property {Function} exitFullScreen Make a request to exit full screen mode.
	     * @property {Function} cancelFullScreen Deprecated, use exitFullScreen instead.
	     * @property {String} fullScreenEventName Event fired when the full screen mode change.
	     * @property {String} fullScreenErrorEventName Event fired when a request to go
	     * in full screen mode failed.
	     */
	    var fullScreenApi = {
	        supportsFullScreen: false,
	        isFullScreen: function() { return false; },
	        getFullScreenElement: function() { return null; },
	        requestFullScreen: function() {},
	        exitFullScreen: function() {},
	        cancelFullScreen: function() {},
	        fullScreenEventName: '',
	        fullScreenErrorEventName: ''
	    };
	
	    // check for native support
	    if ( document.exitFullscreen ) {
	        // W3C standard
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.fullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.requestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.exitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "fullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "fullscreenerror";
	    } else if ( document.msExitFullscreen ) {
	        // IE 11
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.msFullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.msRequestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.msExitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "MSFullscreenChange";
	        fullScreenApi.fullScreenErrorEventName = "MSFullscreenError";
	    } else if ( document.webkitExitFullscreen ) {
	        // Recent webkit
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.webkitFullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.webkitRequestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.webkitExitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
	    } else if ( document.webkitCancelFullScreen ) {
	        // Old webkit
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.webkitCurrentFullScreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.webkitRequestFullScreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.webkitCancelFullScreen();
	        };
	        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
	    } else if ( document.mozCancelFullScreen ) {
	        // Firefox
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.mozFullScreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.mozRequestFullScreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.mozCancelFullScreen();
	        };
	        fullScreenApi.fullScreenEventName = "mozfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "mozfullscreenerror";
	    }
	    fullScreenApi.isFullScreen = function() {
	        return fullScreenApi.getFullScreenElement() !== null;
	    };
	    fullScreenApi.cancelFullScreen = function() {
	        $.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead.");
	        fullScreenApi.exitFullScreen();
	    };
	
	    // export api
	    $.extend( $, fullScreenApi );
	
	})( OpenSeadragon );
	
	/*
	 * OpenSeadragon - EventSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($){
	
	/**
	 * Event handler method signature used by all OpenSeadragon events.
	 *
	 * @callback EventHandler
	 * @memberof OpenSeadragon
	 * @param {Object} event - See individual events for event-specific properties.
	 */
	
	
	/**
	 * @class EventSource
	 * @classdesc For use by classes which want to support custom, non-browser events.
	 *
	 * @memberof OpenSeadragon
	 */
	$.EventSource = function() {
	    this.events = {};
	};
	
	$.EventSource.prototype = /** @lends OpenSeadragon.EventSource.prototype */{
	
	    // TODO: Add a method 'one' which automatically unbinds a listener after the first triggered event that matches.
	
	    /**
	     * Add an event handler for a given event.
	     * @function
	     * @param {String} eventName - Name of event to register.
	     * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
	     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
	     */
	    addHandler: function ( eventName, handler, userData ) {
	        var events = this.events[ eventName ];
	        if ( !events ) {
	            this.events[ eventName ] = events = [];
	        }
	        if ( handler && $.isFunction( handler ) ) {
	            events[ events.length ] = { handler: handler, userData: userData || null };
	        }
	    },
	
	    /**
	     * Remove a specific event handler for a given event.
	     * @function
	     * @param {String} eventName - Name of event for which the handler is to be removed.
	     * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
	     */
	    removeHandler: function ( eventName, handler ) {
	        var events = this.events[ eventName ],
	            handlers = [],
	            i;
	        if ( !events ) {
	            return;
	        }
	        if ( $.isArray( events ) ) {
	            for ( i = 0; i < events.length; i++ ) {
	                if ( events[i].handler !== handler ) {
	                    handlers.push( events[ i ] );
	                }
	            }
	            this.events[ eventName ] = handlers;
	        }
	    },
	
	
	    /**
	     * Remove all event handlers for a given event type. If no type is given all
	     * event handlers for every event type are removed.
	     * @function
	     * @param {String} eventName - Name of event for which all handlers are to be removed.
	     */
	    removeAllHandlers: function( eventName ) {
	        if ( eventName ){
	            this.events[ eventName ] = [];
	        } else{
	            for ( var eventType in this.events ) {
	                this.events[ eventType ] = [];
	            }
	        }
	    },
	
	    /**
	     * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
	     * @function
	     * @param {String} eventName - Name of event to get handlers for.
	     */
	    getHandler: function ( eventName ) {
	        var events = this.events[ eventName ];
	        if ( !events || !events.length ) {
	            return null;
	        }
	        events = events.length === 1 ?
	            [ events[ 0 ] ] :
	            Array.apply( null, events );
	        return function ( source, args ) {
	            var i,
	                length = events.length;
	            for ( i = 0; i < length; i++ ) {
	                if ( events[ i ] ) {
	                    args.eventSource = source;
	                    args.userData = events[ i ].userData;
	                    events[ i ].handler( args );
	                }
	            }
	        };
	    },
	
	    /**
	     * Trigger an event, optionally passing additional information.
	     * @function
	     * @param {String} eventName - Name of event to register.
	     * @param {Object} eventArgs - Event-specific data.
	     */
	    raiseEvent: function( eventName, eventArgs ) {
	        //uncomment if you want to get a log of all events
	        //$.console.log( eventName );
	        var handler = this.getHandler( eventName );
	
	        if ( handler ) {
	            if ( !eventArgs ) {
	                eventArgs = {};
	            }
	
	            handler( this, eventArgs );
	        }
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - MouseTracker
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ( $ ) {
	
	    // All MouseTracker instances
	    var MOUSETRACKERS  = [];
	
	    // dictionary from hash to private properties
	    var THIS           = {};
	
	
	    /**
	     * @class MouseTracker
	     * @classdesc Provides simplified handling of common pointer device (mouse, touch, pen, etc.) gestures
	     *            and keyboard events on a specified element.
	     * @memberof OpenSeadragon
	     * @param {Object} options
	     *      Allows configurable properties to be entirely specified by passing
	     *      an options object to the constructor.  The constructor also supports
	     *      the original positional arguments 'element', 'clickTimeThreshold',
	     *      and 'clickDistThreshold' in that order.
	     * @param {Element|String} options.element
	     *      A reference to an element or an element id for which the pointer/key
	     *      events will be monitored.
	     * @param {Boolean} [options.startDisabled=false]
	     *      If true, event tracking on the element will not start until
	     *      {@link OpenSeadragon.MouseTracker.setTracking|setTracking} is called.
	     * @param {Number} options.clickTimeThreshold
	     *      The number of milliseconds within which a pointer down-up event combination
	     *      will be treated as a click gesture.
	     * @param {Number} options.clickDistThreshold
	     *      The maximum distance allowed between a pointer down event and a pointer up event
	     *      to be treated as a click gesture.
	     * @param {Number} options.dblClickTimeThreshold
	     *      The number of milliseconds within which two pointer down-up event combinations
	     *      will be treated as a double-click gesture.
	     * @param {Number} options.dblClickDistThreshold
	     *      The maximum distance allowed between two pointer click events
	     *      to be treated as a click gesture.
	     * @param {Number} [options.stopDelay=50]
	     *      The number of milliseconds without pointer move before the stop
	     *      event is fired.
	     * @param {OpenSeadragon.EventHandler} [options.enterHandler=null]
	     *      An optional handler for pointer enter.
	     * @param {OpenSeadragon.EventHandler} [options.exitHandler=null]
	     *      An optional handler for pointer exit.
	     * @param {OpenSeadragon.EventHandler} [options.pressHandler=null]
	     *      An optional handler for pointer press.
	     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryPressHandler=null]
	     *      An optional handler for pointer non-primary button press.
	     * @param {OpenSeadragon.EventHandler} [options.releaseHandler=null]
	     *      An optional handler for pointer release.
	     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryReleaseHandler=null]
	     *      An optional handler for pointer non-primary button release.
	     * @param {OpenSeadragon.EventHandler} [options.moveHandler=null]
	     *      An optional handler for pointer move.
	     * @param {OpenSeadragon.EventHandler} [options.scrollHandler=null]
	     *      An optional handler for mouse wheel scroll.
	     * @param {OpenSeadragon.EventHandler} [options.clickHandler=null]
	     *      An optional handler for pointer click.
	     * @param {OpenSeadragon.EventHandler} [options.dblClickHandler=null]
	     *      An optional handler for pointer double-click.
	     * @param {OpenSeadragon.EventHandler} [options.dragHandler=null]
	     *      An optional handler for the drag gesture.
	     * @param {OpenSeadragon.EventHandler} [options.dragEndHandler=null]
	     *      An optional handler for after a drag gesture.
	     * @param {OpenSeadragon.EventHandler} [options.pinchHandler=null]
	     *      An optional handler for the pinch gesture.
	     * @param {OpenSeadragon.EventHandler} [options.keyDownHandler=null]
	     *      An optional handler for keydown.
	     * @param {OpenSeadragon.EventHandler} [options.keyUpHandler=null]
	     *      An optional handler for keyup.
	     * @param {OpenSeadragon.EventHandler} [options.keyHandler=null]
	     *      An optional handler for keypress.
	     * @param {OpenSeadragon.EventHandler} [options.focusHandler=null]
	     *      An optional handler for focus.
	     * @param {OpenSeadragon.EventHandler} [options.blurHandler=null]
	     *      An optional handler for blur.
	     * @param {Object} [options.userData=null]
	     *      Arbitrary object to be passed unchanged to any attached handler methods.
	     */
	    $.MouseTracker = function ( options ) {
	
	        MOUSETRACKERS.push( this );
	
	        var args = arguments;
	
	        if ( !$.isPlainObject( options ) ) {
	            options = {
	                element:            args[ 0 ],
	                clickTimeThreshold: args[ 1 ],
	                clickDistThreshold: args[ 2 ]
	            };
	        }
	
	        this.hash               = Math.random(); // An unique hash for this tracker.
	        /**
	         * The element for which pointer events are being monitored.
	         * @member {Element} element
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.element            = $.getElement( options.element );
	        /**
	         * The number of milliseconds within which a pointer down-up event combination
	         * will be treated as a click gesture.
	         * @member {Number} clickTimeThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.clickTimeThreshold = options.clickTimeThreshold || $.DEFAULT_SETTINGS.clickTimeThreshold;
	        /**
	         * The maximum distance allowed between a pointer down event and a pointer up event
	         * to be treated as a click gesture.
	         * @member {Number} clickDistThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.clickDistThreshold = options.clickDistThreshold || $.DEFAULT_SETTINGS.clickDistThreshold;
	        /**
	         * The number of milliseconds within which two pointer down-up event combinations
	         * will be treated as a double-click gesture.
	         * @member {Number} dblClickTimeThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.dblClickTimeThreshold = options.dblClickTimeThreshold || $.DEFAULT_SETTINGS.dblClickTimeThreshold;
	        /**
	         * The maximum distance allowed between two pointer click events
	         * to be treated as a click gesture.
	         * @member {Number} clickDistThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.dblClickDistThreshold = options.dblClickDistThreshold || $.DEFAULT_SETTINGS.dblClickDistThreshold;
	        this.userData              = options.userData          || null;
	        this.stopDelay             = options.stopDelay         || 50;
	
	        this.enterHandler             = options.enterHandler             || null;
	        this.exitHandler              = options.exitHandler              || null;
	        this.pressHandler             = options.pressHandler             || null;
	        this.nonPrimaryPressHandler   = options.nonPrimaryPressHandler   || null;
	        this.releaseHandler           = options.releaseHandler           || null;
	        this.nonPrimaryReleaseHandler = options.nonPrimaryReleaseHandler || null;
	        this.moveHandler              = options.moveHandler              || null;
	        this.scrollHandler            = options.scrollHandler            || null;
	        this.clickHandler             = options.clickHandler             || null;
	        this.dblClickHandler          = options.dblClickHandler          || null;
	        this.dragHandler              = options.dragHandler              || null;
	        this.dragEndHandler           = options.dragEndHandler           || null;
	        this.pinchHandler             = options.pinchHandler             || null;
	        this.stopHandler              = options.stopHandler              || null;
	        this.keyDownHandler           = options.keyDownHandler           || null;
	        this.keyUpHandler             = options.keyUpHandler             || null;
	        this.keyHandler               = options.keyHandler               || null;
	        this.focusHandler             = options.focusHandler             || null;
	        this.blurHandler              = options.blurHandler              || null;
	
	        //Store private properties in a scope sealed hash map
	        var _this = this;
	
	        /**
	         * @private
	         * @property {Boolean} tracking
	         *      Are we currently tracking pointer events for this element.
	         */
	        THIS[ this.hash ] = {
	            click:                 function ( event ) { onClick( _this, event ); },
	            dblclick:              function ( event ) { onDblClick( _this, event ); },
	            keydown:               function ( event ) { onKeyDown( _this, event ); },
	            keyup:                 function ( event ) { onKeyUp( _this, event ); },
	            keypress:              function ( event ) { onKeyPress( _this, event ); },
	            focus:                 function ( event ) { onFocus( _this, event ); },
	            blur:                  function ( event ) { onBlur( _this, event ); },
	
	            wheel:                 function ( event ) { onWheel( _this, event ); },
	            mousewheel:            function ( event ) { onMouseWheel( _this, event ); },
	            DOMMouseScroll:        function ( event ) { onMouseWheel( _this, event ); },
	            MozMousePixelScroll:   function ( event ) { onMouseWheel( _this, event ); },
	
	            mouseenter:            function ( event ) { onMouseEnter( _this, event ); }, // Used on IE8 only
	            mouseleave:            function ( event ) { onMouseLeave( _this, event ); }, // Used on IE8 only
	            mouseover:             function ( event ) { onMouseOver( _this, event ); },
	            mouseout:              function ( event ) { onMouseOut( _this, event ); },
	            mousedown:             function ( event ) { onMouseDown( _this, event ); },
	            mouseup:               function ( event ) { onMouseUp( _this, event ); },
	            mouseupcaptured:       function ( event ) { onMouseUpCaptured( _this, event ); },
	            mousemove:             function ( event ) { onMouseMove( _this, event ); },
	            mousemovecaptured:     function ( event ) { onMouseMoveCaptured( _this, event ); },
	
	            touchstart:            function ( event ) { onTouchStart( _this, event ); },
	            touchend:              function ( event ) { onTouchEnd( _this, event ); },
	            touchendcaptured:      function ( event ) { onTouchEndCaptured( _this, event ); },
	            touchmove:             function ( event ) { onTouchMove( _this, event ); },
	            touchmovecaptured:     function ( event ) { onTouchMoveCaptured( _this, event ); },
	            touchcancel:           function ( event ) { onTouchCancel( _this, event ); },
	
	            gesturestart:          function ( event ) { onGestureStart( _this, event ); },
	            gesturechange:         function ( event ) { onGestureChange( _this, event ); },
	
	            pointerover:           function ( event ) { onPointerOver( _this, event ); },
	            MSPointerOver:         function ( event ) { onPointerOver( _this, event ); },
	            pointerout:            function ( event ) { onPointerOut( _this, event ); },
	            MSPointerOut:          function ( event ) { onPointerOut( _this, event ); },
	            pointerdown:           function ( event ) { onPointerDown( _this, event ); },
	            MSPointerDown:         function ( event ) { onPointerDown( _this, event ); },
	            pointerup:             function ( event ) { onPointerUp( _this, event ); },
	            MSPointerUp:           function ( event ) { onPointerUp( _this, event ); },
	            pointermove:           function ( event ) { onPointerMove( _this, event ); },
	            MSPointerMove:         function ( event ) { onPointerMove( _this, event ); },
	            pointercancel:         function ( event ) { onPointerCancel( _this, event ); },
	            MSPointerCancel:       function ( event ) { onPointerCancel( _this, event ); },
	            pointerupcaptured:     function ( event ) { onPointerUpCaptured( _this, event ); },
	            pointermovecaptured:   function ( event ) { onPointerMoveCaptured( _this, event ); },
	
	            tracking:              false,
	
	            // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
	            // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
	            // Active pointers are any pointer being tracked for this element which are in the hit-test area
	            //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
	            activePointersLists:   [],
	
	            // Tracking for double-click gesture
	            lastClickPos:          null,
	            dblClickTimeOut:       null,
	
	            // Tracking for pinch gesture
	            pinchGPoints:          [],
	            lastPinchDist:         0,
	            currentPinchDist:      0,
	            lastPinchCenter:       null,
	            currentPinchCenter:    null
	        };
	
	        if ( !options.startDisabled ) {
	            this.setTracking( true );
	        }
	    };
	
	    $.MouseTracker.prototype = /** @lends OpenSeadragon.MouseTracker.prototype */{
	
	        /**
	         * Clean up any events or objects created by the tracker.
	         * @function
	         */
	        destroy: function () {
	            var i;
	
	            stopTracking( this );
	            this.element = null;
	
	            for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	                if ( MOUSETRACKERS[ i ] === this ) {
	                    MOUSETRACKERS.splice( i, 1 );
	                    break;
	                }
	            }
	
	            THIS[ this.hash ] = null;
	            delete THIS[ this.hash ];
	        },
	
	        /**
	         * Are we currently tracking events on this element.
	         * @deprecated Just use this.tracking
	         * @function
	         * @returns {Boolean} Are we currently tracking events on this element.
	         */
	        isTracking: function () {
	            return THIS[ this.hash ].tracking;
	        },
	
	        /**
	         * Enable or disable whether or not we are tracking events on this element.
	         * @function
	         * @param {Boolean} track True to start tracking, false to stop tracking.
	         * @returns {OpenSeadragon.MouseTracker} Chainable.
	         */
	        setTracking: function ( track ) {
	            if ( track ) {
	                startTracking( this );
	            } else {
	                stopTracking( this );
	            }
	            //chain
	            return this;
	        },
	
	        /**
	         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
	         * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
	         * @function
	         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
	         * @returns {OpenSeadragon.MouseTracker.GesturePointList}
	         */
	        getActivePointersListByType: function ( type ) {
	            var delegate = THIS[ this.hash ],
	                i,
	                len = delegate.activePointersLists.length,
	                list;
	
	            for ( i = 0; i < len; i++ ) {
	                if ( delegate.activePointersLists[ i ].type === type ) {
	                    return delegate.activePointersLists[ i ];
	                }
	            }
	
	            list = new $.MouseTracker.GesturePointList( type );
	            delegate.activePointersLists.push( list );
	            return list;
	        },
	
	        /**
	         * Returns the total number of pointers currently active on the tracked element.
	         * @function
	         * @returns {Number}
	         */
	        getActivePointerCount: function () {
	            var delegate = THIS[ this.hash ],
	                i,
	                len = delegate.activePointersLists.length,
	                count = 0;
	
	            for ( i = 0; i < len; i++ ) {
	                count += delegate.activePointersLists[ i ].getLength();
	            }
	
	            return count;
	        },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Number} event.pointers
	         *      Number of pointers (all types) active in the tracked element.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.buttonDownAny
	         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        enterHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Number} event.pointers
	         *      Number of pointers (all types) active in the tracked element.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.buttonDownAny
	         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        exitHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        pressHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.button
	         *      Button which caused the event.
	         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        nonPrimaryPressHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.insideElementReleased
	         *      True if the cursor inside the tracked element when the button was released.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        releaseHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.button
	         *      Button which caused the event.
	         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        nonPrimaryReleaseHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        moveHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.scroll
	         *      The scroll delta for the event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        scrollHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Boolean} event.quick
	         *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        clickHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dblClickHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {OpenSeadragon.Point} event.delta
	         *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
	         * @param {Number} event.speed
	         *     Current computed speed, in pixels per second.
	         * @param {Number} event.direction
	         *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dragHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.speed
	         *     Speed at the end of a drag gesture, in pixels per second.
	         * @param {Number} event.direction
	         *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dragEndHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
	         *      Gesture points associated with the gesture. Velocity data can be found here.
	         * @param {OpenSeadragon.Point} event.lastCenter
	         *      The previous center point of the two pinch contact points relative to the tracked element.
	         * @param {OpenSeadragon.Point} event.center
	         *      The center point of the two pinch contact points relative to the tracked element.
	         * @param {Number} event.lastDistance
	         *      The previous distance between the two pinch contact points in CSS pixels.
	         * @param {Number} event.distance
	         *      The distance between the two pinch contact points in CSS pixels.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        pinchHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        stopHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyDownHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyUpHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        focusHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        blurHandler: function () { }
	    };
	
	
	    /**
	     * Provides continuous computation of velocity (speed and direction) of active pointers.
	     * This is a singleton, used by all MouseTracker instances, as it is unlikely there will ever be more than
	     * two active gesture pointers at a time.
	     *
	     * @private
	     * @member gesturePointVelocityTracker
	     * @memberof OpenSeadragon.MouseTracker
	     */
	    $.MouseTracker.gesturePointVelocityTracker = (function () {
	        var trackerPoints = [],
	            intervalId = 0,
	            lastTime = 0;
	
	        // Generates a unique identifier for a tracked gesture point
	        var _generateGuid = function ( tracker, gPoint ) {
	            return tracker.hash.toString() + gPoint.type + gPoint.id.toString();
	        };
	
	        // Interval timer callback. Computes velocity for all tracked gesture points.
	        var _doTracking = function () {
	            var i,
	                len = trackerPoints.length,
	                trackPoint,
	                gPoint,
	                now = $.now(),
	                elapsedTime,
	                distance,
	                speed;
	
	            elapsedTime = now - lastTime;
	            lastTime = now;
	
	            for ( i = 0; i < len; i++ ) {
	                trackPoint = trackerPoints[ i ];
	                gPoint = trackPoint.gPoint;
	                // Math.atan2 gives us just what we need for a velocity vector, as we can simply
	                //   use cos()/sin() to extract the x/y velocity components.
	                gPoint.direction = Math.atan2( gPoint.currentPos.y - trackPoint.lastPos.y, gPoint.currentPos.x - trackPoint.lastPos.x );
	                // speed = distance / elapsed time
	                distance = trackPoint.lastPos.distanceTo( gPoint.currentPos );
	                trackPoint.lastPos = gPoint.currentPos;
	                speed = 1000 * distance / ( elapsedTime + 1 );
	                // Simple biased average, favors the most recent speed computation. Smooths out erratic gestures a bit.
	                gPoint.speed = 0.75 * speed + 0.25 * gPoint.speed;
	            }
	        };
	
	        // Public. Add a gesture point to be tracked
	        var addPoint = function ( tracker, gPoint ) {
	            var guid = _generateGuid( tracker, gPoint );
	
	            trackerPoints.push(
	                {
	                    guid: guid,
	                    gPoint: gPoint,
	                    lastPos: gPoint.currentPos
	                } );
	
	            // Only fire up the interval timer when there's gesture pointers to track
	            if ( trackerPoints.length === 1 ) {
	                lastTime = $.now();
	                intervalId = window.setInterval( _doTracking, 50 );
	            }
	        };
	
	        // Public. Stop tracking a gesture point
	        var removePoint = function ( tracker, gPoint ) {
	            var guid = _generateGuid( tracker, gPoint ),
	                i,
	                len = trackerPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( trackerPoints[ i ].guid === guid ) {
	                    trackerPoints.splice( i, 1 );
	                    // Only run the interval timer if theres gesture pointers to track
	                    len--;
	                    if ( len === 0 ) {
	                        window.clearInterval( intervalId );
	                    }
	                    break;
	                }
	            }
	        };
	
	        return {
	            addPoint:    addPoint,
	            removePoint: removePoint
	        };
	    } )();
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Pointer event model and feature detection
	///////////////////////////////////////////////////////////////////////////////
	
	    $.MouseTracker.captureElement = document;
	
	    /**
	     * Detect available mouse wheel event name.
	     */
	    $.MouseTracker.wheelEventName = ( $.Browser.vendor == $.BROWSERS.IE && $.Browser.version > 8 ) ||
	                                                ( 'onwheel' in document.createElement( 'div' ) ) ? 'wheel' : // Modern browsers support 'wheel'
	                                    document.onmousewheel !== undefined ? 'mousewheel' :                     // Webkit and IE support at least 'mousewheel'
	                                    'DOMMouseScroll';                                                        // Assume old Firefox
	
	    /**
	     * Detect legacy mouse capture support.
	     */
	    $.MouseTracker.supportsMouseCapture = (function () {
	        var divElement = document.createElement( 'div' );
	        return $.isFunction( divElement.setCapture ) && $.isFunction( divElement.releaseCapture );
	    }());
	
	    /**
	     * Detect browser pointer device event model(s) and build appropriate list of events to subscribe to.
	     */
	    $.MouseTracker.subscribeEvents = [ "click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", $.MouseTracker.wheelEventName ];
	
	    if( $.MouseTracker.wheelEventName == "DOMMouseScroll" ) {
	        // Older Firefox
	        $.MouseTracker.subscribeEvents.push( "MozMousePixelScroll" );
	    }
	
	    // Note: window.navigator.pointerEnable is deprecated on IE 11 and not part of W3C spec.
	    if ( window.PointerEvent && ( window.navigator.pointerEnabled || $.Browser.vendor !== $.BROWSERS.IE ) ) {
	        // IE11 and other W3C Pointer Event implementations (see http://www.w3.org/TR/pointerevents)
	        $.MouseTracker.havePointerEvents = true;
	        $.MouseTracker.subscribeEvents.push( "pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel" );
	        $.MouseTracker.unprefixedPointerEvents = true;
	        if( navigator.maxTouchPoints ) {
	            $.MouseTracker.maxTouchPoints = navigator.maxTouchPoints;
	        } else {
	            $.MouseTracker.maxTouchPoints = 0;
	        }
	        $.MouseTracker.haveMouseEnter = false;
	    } else if ( window.MSPointerEvent && window.navigator.msPointerEnabled ) {
	        // IE10
	        $.MouseTracker.havePointerEvents = true;
	        $.MouseTracker.subscribeEvents.push( "MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel" );
	        $.MouseTracker.unprefixedPointerEvents = false;
	        if( navigator.msMaxTouchPoints ) {
	            $.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints;
	        } else {
	            $.MouseTracker.maxTouchPoints = 0;
	        }
	        $.MouseTracker.haveMouseEnter = false;
	    } else {
	        // Legacy W3C mouse events
	        $.MouseTracker.havePointerEvents = false;
	        if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	            $.MouseTracker.subscribeEvents.push( "mouseenter", "mouseleave" );
	            $.MouseTracker.haveMouseEnter = true;
	        } else {
	            $.MouseTracker.subscribeEvents.push( "mouseover", "mouseout" );
	            $.MouseTracker.haveMouseEnter = false;
	        }
	        $.MouseTracker.subscribeEvents.push( "mousedown", "mouseup", "mousemove" );
	        if ( 'ontouchstart' in window ) {
	            // iOS, Android, and other W3c Touch Event implementations
	            //    (see http://www.w3.org/TR/touch-events/)
	            //    (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            //    (see https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            $.MouseTracker.subscribeEvents.push( "touchstart", "touchend", "touchmove", "touchcancel" );
	        }
	        if ( 'ongesturestart' in window ) {
	            // iOS (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            //   Subscribe to these to prevent default gesture handling
	            $.MouseTracker.subscribeEvents.push( "gesturestart", "gesturechange" );
	        }
	        $.MouseTracker.mousePointerId = "legacy-mouse";
	        $.MouseTracker.maxTouchPoints = 10;
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Classes and typedefs
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * Represents a point of contact on the screen made by a mouse cursor, pen, touch, or other pointer device.
	     *
	     * @typedef {Object} GesturePoint
	     * @memberof OpenSeadragon.MouseTracker
	     *
	     * @property {Number} id
	     *     Identifier unique from all other active GesturePoints for a given pointer device.
	     * @property {String} type
	     *     The pointer device type: "mouse", "touch", "pen", etc.
	     * @property {Boolean} captured
	     *     True if events for the gesture point are captured to the tracked element.
	     * @property {Boolean} isPrimary
	     *     True if the gesture point is a master pointer amongst the set of active pointers for each pointer type. True for mouse and primary (first) touch/pen pointers.
	     * @property {Boolean} insideElementPressed
	     *     True if button pressed or contact point initiated inside the screen area of the tracked element.
	     * @property {Boolean} insideElement
	     *     True if pointer or contact point is currently inside the bounds of the tracked element.
	     * @property {Number} speed
	     *     Current computed speed, in pixels per second.
	     * @property {Number} direction
	     *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {OpenSeadragon.Point} contactPos
	     *     The initial pointer contact position, relative to the page including any scrolling. Only valid if the pointer has contact (pressed, touch contact, pen contact).
	     * @property {Number} contactTime
	     *     The initial pointer contact time, in milliseconds. Only valid if the pointer has contact (pressed, touch contact, pen contact).
	     * @property {OpenSeadragon.Point} lastPos
	     *     The last pointer position, relative to the page including any scrolling.
	     * @property {Number} lastTime
	     *     The last pointer contact time, in milliseconds.
	     * @property {OpenSeadragon.Point} currentPos
	     *     The current pointer position, relative to the page including any scrolling.
	     * @property {Number} currentTime
	     *     The current pointer contact time, in milliseconds.
	     */
	
	
	    /**
	     * @class GesturePointList
	     * @classdesc Provides an abstraction for a set of active {@link OpenSeadragon.MouseTracker.GesturePoint|GesturePoint} objects for a given pointer device type.
	     *            Active pointers are any pointer being tracked for this element which are in the hit-test area
	     *            of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
	     * @memberof OpenSeadragon.MouseTracker
	     * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
	     */
	    $.MouseTracker.GesturePointList = function ( type ) {
	        this._gPoints = [];
	        /**
	         * The pointer device type: "mouse", "touch", "pen", etc.
	         * @member {String} type
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.type = type;
	        /**
	         * Current buttons pressed for the device.
	         * Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @member {Number} buttons
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.buttons = 0;
	        /**
	         * Current number of contact points (touch points, mouse down, etc.) for the device.
	         * @member {Number} contacts
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.contacts = 0;
	        /**
	         * Current number of clicks for the device. Used for multiple click gesture tracking.
	         * @member {Number} clicks
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.clicks = 0;
	        /**
	         * Current number of captured pointers for the device.
	         * @member {Number} captureCount
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.captureCount = 0;
	    };
	    $.MouseTracker.GesturePointList.prototype = /** @lends OpenSeadragon.MouseTracker.GesturePointList.prototype */{
	        /**
	         * @function
	         * @returns {Number} Number of gesture points in the list.
	         */
	        getLength: function () {
	            return this._gPoints.length;
	        },
	        /**
	         * @function
	         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
	         */
	        asArray: function () {
	            return this._gPoints;
	        },
	        /**
	         * @function
	         * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
	         * @returns {Number} Number of gesture points in the list.
	         */
	        add: function ( gp ) {
	            return this._gPoints.push( gp );
	        },
	        /**
	         * @function
	         * @param {Number} id - The id of the gesture point to remove from the list.
	         * @returns {Number} Number of gesture points in the list.
	         */
	        removeById: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].id === id ) {
	                    this._gPoints.splice( i, 1 );
	                    break;
	                }
	            }
	            return this._gPoints.length;
	        },
	        /**
	         * @function
	         * @param {Number} index - The index of the gesture point to retrieve from the list.
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
	         */
	        getByIndex: function ( index ) {
	            if ( index < this._gPoints.length) {
	                return this._gPoints[ index ];
	            }
	
	            return null;
	        },
	        /**
	         * @function
	         * @param {Number} id - The id of the gesture point to retrieve from the list.
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
	         */
	        getById: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].id === id ) {
	                    return this._gPoints[ i ];
	                }
	            }
	            return null;
	        },
	        /**
	         * @function
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
	         */
	        getPrimary: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].isPrimary ) {
	                    return this._gPoints[ i ];
	                }
	            }
	            return null;
	        }
	    };
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Utility functions
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * Removes all tracked pointers.
	     * @private
	     * @inner
	     */
	    function clearTrackedPointers( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            i,
	            pointerListCount = delegate.activePointersLists.length;
	
	        for ( i = 0; i < pointerListCount; i++ ) {
	            if ( delegate.activePointersLists[ i ].captureCount > 0 ) {
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'mousemove',
	                    delegate.mousemovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'mouseup',
	                    delegate.mouseupcaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    $.MouseTracker.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
	                    delegate.pointermovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    $.MouseTracker.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
	                    delegate.pointerupcaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'touchmove',
	                    delegate.touchmovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'touchend',
	                    delegate.touchendcaptured,
	                    true
	                );
	
	                delegate.activePointersLists[ i ].captureCount = 0;
	            }
	        }
	
	        for ( i = 0; i < pointerListCount; i++ ) {
	            delegate.activePointersLists.pop();
	        }
	    }
	
	    /**
	     * Starts tracking pointer events on the tracked element.
	     * @private
	     * @inner
	     */
	    function startTracking( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            event,
	            i;
	
	        if ( !delegate.tracking ) {
	            for ( i = 0; i < $.MouseTracker.subscribeEvents.length; i++ ) {
	                event = $.MouseTracker.subscribeEvents[ i ];
	                $.addEvent(
	                    tracker.element,
	                    event,
	                    delegate[ event ],
	                    false
	                );
	            }
	
	            clearTrackedPointers( tracker );
	
	            delegate.tracking = true;
	        }
	    }
	
	    /**
	     * Stops tracking pointer events on the tracked element.
	     * @private
	     * @inner
	     */
	    function stopTracking( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            event,
	            i;
	
	        if ( delegate.tracking ) {
	            for ( i = 0; i < $.MouseTracker.subscribeEvents.length; i++ ) {
	                event = $.MouseTracker.subscribeEvents[ i ];
	                $.removeEvent(
	                    tracker.element,
	                    event,
	                    delegate[ event ],
	                    false
	                );
	            }
	
	            clearTrackedPointers( tracker );
	
	            delegate.tracking = false;
	        }
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getCaptureEventParams( tracker, pointerType ) {
	        var delegate = THIS[ tracker.hash ];
	
	        if ( pointerType === 'pointerevent' ) {
	            return {
	                upName: $.MouseTracker.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
	                upHandler: delegate.pointerupcaptured,
	                moveName: $.MouseTracker.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
	                moveHandler: delegate.pointermovecaptured
	            };
	        } else if ( pointerType === 'mouse' ) {
	            return {
	                upName: 'mouseup',
	                upHandler: delegate.mouseupcaptured,
	                moveName: 'mousemove',
	                moveHandler: delegate.mousemovecaptured
	            };
	        } else if ( pointerType === 'touch' ) {
	            return {
	                upName: 'touchend',
	                upHandler: delegate.touchendcaptured,
	                moveName: 'touchmove',
	                moveHandler: delegate.touchmovecaptured
	            };
	        } else {
	            throw new Error( "MouseTracker.getCaptureEventParams: Unknown pointer type." );
	        }
	    }
	
	    /**
	     * Begin capturing pointer events to the tracked element.
	     * @private
	     * @inner
	     */
	    function capturePointer( tracker, pointerType ) {
	        var pointsList = tracker.getActivePointersListByType( pointerType ),
	            eventParams;
	
	        pointsList.captureCount++;
	
	        if ( pointsList.captureCount === 1 ) {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                tracker.element.setCapture( true );
	            } else {
	                eventParams = getCaptureEventParams( tracker, $.MouseTracker.havePointerEvents ? 'pointerevent' : pointerType );
	                // We emulate mouse capture by hanging listeners on the document object.
	                //    (Note we listen on the capture phase so the captured handlers will get called first)
	                $.addEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.upName,
	                    eventParams.upHandler,
	                    true
	                );
	                $.addEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.moveName,
	                    eventParams.moveHandler,
	                    true
	                );
	            }
	        }
	    }
	
	
	    /**
	     * Stop capturing pointer events to the tracked element.
	     * @private
	     * @inner
	     */
	    function releasePointer( tracker, pointerType ) {
	        var pointsList = tracker.getActivePointersListByType( pointerType ),
	            eventParams;
	
	        pointsList.captureCount--;
	
	        if ( pointsList.captureCount === 0 ) {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                tracker.element.releaseCapture();
	            } else {
	                eventParams = getCaptureEventParams( tracker, $.MouseTracker.havePointerEvents ? 'pointerevent' : pointerType );
	                // We emulate mouse capture by hanging listeners on the document object.
	                //    (Note we listen on the capture phase so the captured handlers will get called first)
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.moveName,
	                    eventParams.moveHandler,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.upName,
	                    eventParams.upHandler,
	                    true
	                );
	            }
	        }
	    }
	
	
	    /**
	     * Gets a W3C Pointer Events model compatible pointer type string from a DOM pointer event.
	     * IE10 used a long integer value, but the W3C specification (and IE11+) use a string "mouse", "touch", "pen", etc.
	     * @private
	     * @inner
	     */
	    function getPointerType( event ) {
	        var pointerTypeStr;
	        if ( $.MouseTracker.unprefixedPointerEvents ) {
	            pointerTypeStr = event.pointerType;
	        } else {
	            // IE10
	            //  MSPOINTER_TYPE_TOUCH: 0x00000002
	            //  MSPOINTER_TYPE_PEN:   0x00000003
	            //  MSPOINTER_TYPE_MOUSE: 0x00000004
	            switch( event.pointerType )
	            {
	                case 0x00000002:
	                    pointerTypeStr = 'touch';
	                    break;
	                case 0x00000003:
	                    pointerTypeStr = 'pen';
	                    break;
	                case 0x00000004:
	                    pointerTypeStr = 'mouse';
	                    break;
	                default:
	                    pointerTypeStr = '';
	            }
	        }
	        return pointerTypeStr;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function getMouseAbsolute( event ) {
	        return $.getMousePosition( event );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getMouseRelative( event, element ) {
	        return getPointRelativeToAbsolute( getMouseAbsolute( event ), element );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getPointRelativeToAbsolute( point, element ) {
	        var offset = $.getElementOffset( element );
	        return point.minus( offset );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getCenterPoint( point1, point2 ) {
	        return new $.Point( ( point1.x + point2.x ) / 2, ( point1.y + point2.y ) / 2 );
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Device-specific DOM event handlers
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * @private
	     * @inner
	     */
	    function onClick( tracker, event ) {
	        if ( tracker.clickHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onDblClick( tracker, event ) {
	        if ( tracker.dblClickHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyDown( tracker, event ) {
	        //$.console.log( "keydown %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyDownHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyDownHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyUp( tracker, event ) {
	        //$.console.log( "keyup %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyUpHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyUpHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyPress( tracker, event ) {
	        //$.console.log( "keypress %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onFocus( tracker, event ) {
	        //console.log( "focus %s", event );
	        var propagate;
	        if ( tracker.focusHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.focusHandler(
	                {
	                    eventSource:          tracker,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onBlur( tracker, event ) {
	        //console.log( "blur %s", event );
	        var propagate;
	        if ( tracker.blurHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.blurHandler(
	                {
	                    eventSource:          tracker,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * Handler for 'wheel' events
	     *
	     * @private
	     * @inner
	     */
	    function onWheel( tracker, event ) {
	        handleWheelEvent( tracker, event, event );
	    }
	
	
	    /**
	     * Handler for 'mousewheel', 'DOMMouseScroll', and 'MozMousePixelScroll' events
	     *
	     * @private
	     * @inner
	     */
	    function onMouseWheel( tracker, event ) {
	        event = $.getEvent( event );
	
	        // Simulate a 'wheel' event
	        var simulatedEvent = {
	            target:     event.target || event.srcElement,
	            type:       "wheel",
	            shiftKey:   event.shiftKey || false,
	            clientX:    event.clientX,
	            clientY:    event.clientY,
	            pageX:      event.pageX ? event.pageX : event.clientX,
	            pageY:      event.pageY ? event.pageY : event.clientY,
	            deltaMode:  event.type == "MozMousePixelScroll" ? 0 : 1, // 0=pixel, 1=line, 2=page
	            deltaX:     0,
	            deltaZ:     0
	        };
	
	        // Calculate deltaY
	        if ( $.MouseTracker.wheelEventName == "mousewheel" ) {
	            simulatedEvent.deltaY = - 1 / $.DEFAULT_SETTINGS.pixelsPerWheelLine * event.wheelDelta;
	        } else {
	            simulatedEvent.deltaY = event.detail;
	        }
	
	        handleWheelEvent( tracker, simulatedEvent, event );
	    }
	
	
	    /**
	     * Handles 'wheel' events.
	     * The event may be simulated by the legacy mouse wheel event handler (onMouseWheel()).
	     *
	     * @private
	     * @inner
	     */
	    function handleWheelEvent( tracker, event, originalEvent ) {
	        var nDelta = 0,
	            propagate;
	
	        // The nDelta variable is gated to provide smooth z-index scrolling
	        //   since the mouse wheel allows for substantial deltas meant for rapid
	        //   y-index scrolling.
	        // event.deltaMode: 0=pixel, 1=line, 2=page
	        // TODO: Deltas in pixel mode should be accumulated then a scroll value computed after $.DEFAULT_SETTINGS.pixelsPerWheelLine threshold reached
	        nDelta = event.deltaY < 0 ? 1 : -1;
	
	        if ( tracker.scrollHandler ) {
	            propagate = tracker.scrollHandler(
	                {
	                    eventSource:          tracker,
	                    pointerType:          'mouse',
	                    position:             getMouseRelative( event, tracker.element ),
	                    scroll:               nDelta,
	                    shift:                event.shiftKey,
	                    isTouchEvent:         false,
	                    originalEvent:        originalEvent,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( originalEvent );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function isParentChild( parent, child )
	    {
	       if ( parent === child ) {
	           return false;
	       }
	       while ( child && child !== parent ) {
	           child = child.parentNode;
	       }
	       return child === parent;
	    }
	
	
	    /**
	     * Only used on IE 8
	     *
	     * @private
	     * @inner
	     */
	    function onMouseEnter( tracker, event ) {
	        event = $.getEvent( event );
	
	        handleMouseEnter( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseOver( tracker, event ) {
	        event = $.getEvent( event );
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        handleMouseEnter( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseEnter( tracker, event ) {
	        var gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersEnter( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * Only used on IE 8
	     *
	     * @private
	     * @inner
	     */
	    function onMouseLeave( tracker, event ) {
	        event = $.getEvent( event );
	
	        handleMouseExit( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseOut( tracker, event ) {
	        event = $.getEvent( event );
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        handleMouseExit( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseExit( tracker, event ) {
	        var gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersExit( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * Returns a W3C DOM level 3 standard button value given an event.button property:
	     *   -1 == none, 0 == primary/left, 1 == middle, 2 == secondary/right, 3 == X1/back, 4 == X2/forward, 5 == eraser (pen)
	     * @private
	     * @inner
	     */
	    function getStandardizedButton( button ) {
	        if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	            // On IE 8, 0 == none, 1 == left, 2 == right, 3 == left and right, 4 == middle, 5 == left and middle, 6 == right and middle, 7 == all three
	            // TODO: Support chorded (multiple) button presses on IE 8?
	            if ( button === 1 ) {
	                return 0;
	            } else if ( button === 2 ) {
	                return 2;
	            } else if ( button === 4 ) {
	                return 1;
	            } else {
	                return -1;
	            }
	        } else {
	            return button;
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseDown( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersDown( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
	            $.stopEvent( event );
	            capturePointer( tracker, 'mouse' );
	        }
	
	        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseUp( tracker, event ) {
	        handleMouseUp( tracker, event );
	    }
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onMouseUp is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onMouseUpCaptured( tracker, event ) {
	        handleMouseUp( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseUp( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersUp( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
	            releasePointer( tracker, 'mouse' );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseMove( tracker, event ) {
	        handleMouseMove( tracker, event );
	   }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onMouseMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onMouseMoveCaptured( tracker, event ) {
	        handleMouseMove( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseMove( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersMove( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function abortTouchContacts( tracker, event, pointsList ) {
	        var i,
	            gPointCount = pointsList.getLength(),
	            abortGPoints = [];
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            abortGPoints.push( pointsList.getByIndex( i ) );
	        }
	
	        if ( abortGPoints.length > 0 ) {
	            // simulate touchend
	            updatePointersUp( tracker, event, abortGPoints, 0 ); // 0 means primary button press/release or touch contact
	            // release pointer capture
	            pointsList.captureCount = 1;
	            releasePointer( tracker, 'touch' );
	            // simulate touchleave
	            updatePointersExit( tracker, event, abortGPoints );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchStart( tracker, event ) {
	        var time,
	            i,
	            j,
	            touchCount = event.changedTouches.length,
	            gPoints = [],
	            parentGPoints,
	            pointsList = tracker.getActivePointersListByType( 'touch' );
	
	        time = $.now();
	
	        if ( pointsList.getLength() > event.touches.length - touchCount ) {
	            $.console.warn('Tracked touch contact count doesn\'t match event.touches.length. Removing all tracked touch pointers.');
	            abortTouchContacts( tracker, event, pointsList );
	        }
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: time
	            } );
	        }
	
	        // simulate touchenter on our tracked element
	        updatePointersEnter( tracker, event, gPoints );
	
	        // simulate touchenter on our tracked element's tracked ancestor elements
	        for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	            if ( MOUSETRACKERS[ i ] !== tracker && MOUSETRACKERS[ i ].isTracking() && isParentChild( MOUSETRACKERS[ i ].element, tracker.element ) ) {
	                parentGPoints = [];
	                for ( j = 0; j < touchCount; j++ ) {
	                    parentGPoints.push( {
	                        id: event.changedTouches[ j ].identifier,
	                        type: 'touch',
	                        // isPrimary not set - let the updatePointers functions determine it
	                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
	                        currentTime: time
	                    } );
	                }
	                updatePointersEnter( MOUSETRACKERS[ i ], event, parentGPoints );
	            }
	        }
	
	        if ( updatePointersDown( tracker, event, gPoints, 0 ) ) { // 0 means primary button press/release or touch contact
	            $.stopEvent( event );
	            capturePointer( tracker, 'touch' );
	        }
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchEnd( tracker, event ) {
	        handleTouchEnd( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
	     * onTouchEnd is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onTouchEndCaptured( tracker, event ) {
	        handleTouchEnd( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleTouchEnd( tracker, event ) {
	        var time,
	            i,
	            j,
	            touchCount = event.changedTouches.length,
	            gPoints = [],
	            parentGPoints;
	
	        time = $.now();
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: time
	            } );
	        }
	
	        if ( updatePointersUp( tracker, event, gPoints, 0 ) ) {
	            releasePointer( tracker, 'touch' );
	        }
	
	        // simulate touchleave on our tracked element
	        updatePointersExit( tracker, event, gPoints );
	
	        // simulate touchleave on our tracked element's tracked ancestor elements
	        for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	            if ( MOUSETRACKERS[ i ] !== tracker && MOUSETRACKERS[ i ].isTracking() && isParentChild( MOUSETRACKERS[ i ].element, tracker.element ) ) {
	                parentGPoints = [];
	                for ( j = 0; j < touchCount; j++ ) {
	                    parentGPoints.push( {
	                        id: event.changedTouches[ j ].identifier,
	                        type: 'touch',
	                        // isPrimary not set - let the updatePointers functions determine it
	                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
	                        currentTime: time
	                    } );
	                }
	                updatePointersExit( MOUSETRACKERS[ i ], event, parentGPoints );
	            }
	        }
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchMove( tracker, event ) {
	        handleTouchMove( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
	     * onTouchMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onTouchMoveCaptured( tracker, event ) {
	        handleTouchMove( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleTouchMove( tracker, event ) {
	        var i,
	            touchCount = event.changedTouches.length,
	            gPoints = [];
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: $.now()
	            } );
	        }
	
	        updatePointersMove( tracker, event, gPoints );
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchCancel( tracker, event ) {
	        var i,
	            touchCount = event.changedTouches.length,
	            gPoints = [],
	            pointsList = tracker.getActivePointersListByType( 'touch' );
	        
	        abortTouchContacts( tracker, event, pointsList );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onGestureStart( tracker, event ) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onGestureChange( tracker, event ) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerOver( tracker, event ) {
	        var gPoint;
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersEnter( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerOut( tracker, event ) {
	        var gPoint;
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersExit( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerDown( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersDown( tracker, event, [ gPoint ], event.button ) ) {
	            $.stopEvent( event );
	            capturePointer( tracker, gPoint.type );
	        }
	
	        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerUp( tracker, event ) {
	        handlePointerUp( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onPointerUp is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onPointerUpCaptured( tracker, event ) {
	        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
	        if ( pointsList.getById( event.pointerId ) ) {
	            handlePointerUp( tracker, event );
	        }
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerUp( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersUp( tracker, event, [ gPoint ], event.button ) ) {
	            releasePointer( tracker, gPoint.type );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerMove( tracker, event ) {
	        handlePointerMove( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onPointerMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onPointerMoveCaptured( tracker, event ) {
	        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
	        if ( pointsList.getById( event.pointerId ) ) {
	            handlePointerMove( tracker, event );
	        }
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerMove( tracker, event ) {
	        // Pointer changed coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersMove( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerCancel( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event )
	        };
	
	        updatePointersCancel( tracker, event, [ gPoint ] );
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Device-agnostic DOM event handlers
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
	     *     The GesturePointList to track the pointer in.
	     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
	     *      Gesture point to track.
	     * @returns {Number} Number of gesture points in pointsList.
	     */
	    function startTrackingPointer( pointsList, gPoint ) {
	
	        // If isPrimary is not known for the pointer then set it according to our rules:
	        //    true if the first pointer in the gesture, otherwise false
	        if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
	            if ( pointsList.getLength() === 0 ) {
	                gPoint.isPrimary = true;
	            } else {
	                gPoint.isPrimary = false;
	            }
	        }
	        gPoint.speed = 0;
	        gPoint.direction = 0;
	        gPoint.contactPos = gPoint.currentPos;
	        gPoint.contactTime = gPoint.currentTime;
	        gPoint.lastPos = gPoint.currentPos;
	        gPoint.lastTime = gPoint.currentTime;
	
	        return pointsList.add( gPoint );
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
	     *     The GesturePointList to stop tracking the pointer on.
	     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
	     *      Gesture point to stop tracking.
	     * @returns {Number} Number of gesture points in pointsList.
	     */
	    function stopTrackingPointer( pointsList, gPoint ) {
	        var listLength,
	            primaryPoint;
	
	        if ( pointsList.getById( gPoint.id ) ) {
	            listLength = pointsList.removeById( gPoint.id );
	
	            // If isPrimary is not known for the pointer and we just removed the primary pointer from the list then we need to set another pointer as primary
	            if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
	                primaryPoint = pointsList.getPrimary();
	                if ( !primaryPoint ) {
	                    primaryPoint = pointsList.getByIndex( 0 );
	                    if ( primaryPoint ) {
	                        primaryPoint.isPrimary = true;
	                    }
	                }
	            }
	        } else {
	            listLength = pointsList.getLength();
	        }
	
	        return listLength;
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersEnter( tracker, event, gPoints ) {
	        var pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            propagate;
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                updateGPoint.insideElement = true;
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	
	                curGPoint = updateGPoint;
	            } else {
	                // Initialize for tracking and add to the tracking list
	                curGPoint.captured = false;
	                curGPoint.insideElementPressed = false;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	
	            // Enter
	            if ( tracker.enterHandler ) {
	                propagate = tracker.enterHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          curGPoint.type,
	                        position:             getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        pointers:             tracker.getActivePointerCount(),
	                        insideElementPressed: curGPoint.insideElementPressed,
	                        buttonDownAny:        pointsList.buttons !== 0,
	                        isTouchEvent:         curGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersExit( tracker, event, gPoints ) {
	        var delegate = THIS[ tracker.hash ],
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            propagate;
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer. If captured then update it, else stop tracking it
	                if ( updateGPoint.captured ) {
	                    updateGPoint.insideElement = false;
	                    updateGPoint.lastPos = updateGPoint.currentPos;
	                    updateGPoint.lastTime = updateGPoint.currentTime;
	                    updateGPoint.currentPos = curGPoint.currentPos;
	                    updateGPoint.currentTime = curGPoint.currentTime;
	                } else {
	                    stopTrackingPointer( pointsList, updateGPoint );
	                }
	
	                curGPoint = updateGPoint;
	            }
	
	            // Exit
	            if ( tracker.exitHandler ) {
	                propagate = tracker.exitHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          curGPoint.type,
	                        position:             getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        pointers:             tracker.getActivePointerCount(),
	                        insideElementPressed: updateGPoint ? updateGPoint.insideElementPressed : false,
	                        buttonDownAny:        pointsList.buttons !== 0,
	                        isTouchEvent:         curGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     * @param {Number} buttonChanged
	     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
	     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
	     *
	     * @returns {Boolean} True if pointers should be captured to the tracked element, otherwise false.
	     */
	    function updatePointersDown( tracker, event, gPoints, buttonChanged ) {
	        var delegate = THIS[ tracker.hash ],
	            propagate,
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        } else {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons += 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons += 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons += 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons += 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons += 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons += 32;
	                }
	            } else {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons |= 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons |= 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons |= 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons |= 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons |= 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons |= 32;
	                }
	            }
	        }
	
	        // Only capture and track primary button, pen, and touch contacts
	        if ( buttonChanged !== 0 ) {
	            // Aux Press
	            if ( tracker.nonPrimaryPressHandler ) {
	                propagate = tracker.nonPrimaryPressHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPoints[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
	                        button:               buttonChanged,
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            return false;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                updateGPoint.captured = true;
	                updateGPoint.insideElementPressed = true;
	                updateGPoint.insideElement = true;
	                updateGPoint.contactPos = curGPoint.currentPos;
	                updateGPoint.contactTime = curGPoint.currentTime;
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	
	                curGPoint = updateGPoint;
	            } else {
	                // Initialize for tracking and add to the tracking list (no pointerover or pointermove event occurred before this)
	                curGPoint.captured = true;
	                curGPoint.insideElementPressed = true;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	
	            pointsList.contacts++;
	            //$.console.log('contacts++ ', pointsList.contacts);
	
	            if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	                $.MouseTracker.gesturePointVelocityTracker.addPoint( tracker, curGPoint );
	            }
	
	            if ( pointsList.contacts === 1 ) {
	                // Press
	                if ( tracker.pressHandler ) {
	                    propagate = tracker.pressHandler(
	                        {
	                            eventSource:          tracker,
	                            pointerType:          curGPoint.type,
	                            position:             getPointRelativeToAbsolute( curGPoint.contactPos, tracker.element ),
	                            buttons:              pointsList.buttons,
	                            isTouchEvent:         curGPoint.type === 'touch',
	                            originalEvent:        event,
	                            preventDefaultAction: false,
	                            userData:             tracker.userData
	                        }
	                    );
	                    if ( propagate === false ) {
	                        $.cancelEvent( event );
	                    }
	                }
	            } else if ( pointsList.contacts === 2 ) {
	                if ( tracker.pinchHandler && curGPoint.type === 'touch' ) {
	                    // Initialize for pinch
	                    delegate.pinchGPoints = pointsList.asArray();
	                    delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                    delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                }
	            }
	        }
	
	        return true;
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     * @param {Number} buttonChanged
	     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
	     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
	     *
	     * @returns {Boolean} True if pointer capture should be released from the tracked element, otherwise false.
	     */
	    function updatePointersUp( tracker, event, gPoints, buttonChanged ) {
	        var delegate = THIS[ tracker.hash ],
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            propagate,
	            insideElementReleased,
	            releasePoint,
	            releaseTime,
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            releaseCapture = false,
	            wasCaptured = false,
	            quick;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        } else {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons -= 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons -= 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons -= 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons -= 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons -= 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons -= 32;
	                }
	            } else {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons ^= ~1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons ^= ~4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons ^= ~2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons ^= ~8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons ^= ~16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons ^= ~32;
	                }
	            }
	        }
	
	        // Only capture and track primary button, pen, and touch contacts
	        if ( buttonChanged !== 0 ) {
	            // Aux Release
	            if ( tracker.nonPrimaryReleaseHandler ) {
	                propagate = tracker.nonPrimaryReleaseHandler(
	                    {
	                        eventSource:           tracker,
	                        pointerType:           gPoints[ 0 ].type,
	                        position:              getPointRelativeToAbsolute(  gPoints[ 0 ].currentPos, tracker.element ),
	                        button:                buttonChanged,
	                        buttons:               pointsList.buttons,
	                        isTouchEvent:          gPoints[ 0 ].type === 'touch',
	                        originalEvent:         event,
	                        preventDefaultAction:  false,
	                        userData:              tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            return false;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Update the pointer, stop tracking it if not still in this element
	                if ( updateGPoint.captured ) {
	                    updateGPoint.captured = false;
	                    releaseCapture = true;
	                    wasCaptured = true;
	                }
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	                if ( !updateGPoint.insideElement ) {
	                    stopTrackingPointer( pointsList, updateGPoint );
	                }
	
	                releasePoint = updateGPoint.currentPos;
	                releaseTime = updateGPoint.currentTime;
	
	                if ( wasCaptured ) {
	                    // Pointer was activated in our element but could have been removed in any element since events are captured to our element
	
	                    pointsList.contacts--;
	                    //$.console.log('contacts-- ', pointsList.contacts);
	
	                    if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	                        $.MouseTracker.gesturePointVelocityTracker.removePoint( tracker, updateGPoint );
	                    }
	
	                    if ( pointsList.contacts === 0 ) {
	
	                        // Release (pressed in our element)
	                        if ( tracker.releaseHandler ) {
	                            propagate = tracker.releaseHandler(
	                                {
	                                    eventSource:           tracker,
	                                    pointerType:           updateGPoint.type,
	                                    position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
	                                    buttons:               pointsList.buttons,
	                                    insideElementPressed:  updateGPoint.insideElementPressed,
	                                    insideElementReleased: updateGPoint.insideElement,
	                                    isTouchEvent:          updateGPoint.type === 'touch',
	                                    originalEvent:         event,
	                                    preventDefaultAction:  false,
	                                    userData:              tracker.userData
	                                }
	                            );
	                            if ( propagate === false ) {
	                                $.cancelEvent( event );
	                            }
	                        }
	
	                        // Drag End
	                        if ( tracker.dragEndHandler && !updateGPoint.currentPos.equals( updateGPoint.contactPos ) ) {
	                            propagate = tracker.dragEndHandler(
	                                {
	                                    eventSource:          tracker,
	                                    pointerType:          updateGPoint.type,
	                                    position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                    speed:                updateGPoint.speed,
	                                    direction:            updateGPoint.direction,
	                                    shift:                event.shiftKey,
	                                    isTouchEvent:         updateGPoint.type === 'touch',
	                                    originalEvent:        event,
	                                    preventDefaultAction: false,
	                                    userData:             tracker.userData
	                                }
	                            );
	                            if ( propagate === false ) {
	                                $.cancelEvent( event );
	                            }
	                        }
	
	                        // Click / Double-Click
	                        if ( ( tracker.clickHandler || tracker.dblClickHandler ) && updateGPoint.insideElement ) {
	                            quick = releaseTime - updateGPoint.contactTime <= tracker.clickTimeThreshold &&
	                                            updateGPoint.contactPos.distanceTo( releasePoint ) <= tracker.clickDistThreshold;
	
	                            // Click
	                            if ( tracker.clickHandler ) {
	                                propagate = tracker.clickHandler(
	                                    {
	                                        eventSource:          tracker,
	                                        pointerType:          updateGPoint.type,
	                                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                        quick:                quick,
	                                        shift:                event.shiftKey,
	                                        isTouchEvent:         updateGPoint.type === 'touch',
	                                        originalEvent:        event,
	                                        preventDefaultAction: false,
	                                        userData:             tracker.userData
	                                    }
	                                );
	                                if ( propagate === false ) {
	                                    $.cancelEvent( event );
	                                }
	                            }
	
	                            // Double-Click
	                            if ( tracker.dblClickHandler && quick ) {
	                                pointsList.clicks++;
	                                if ( pointsList.clicks === 1 ) {
	                                    delegate.lastClickPos = releasePoint;
	                                    /*jshint loopfunc:true*/
	                                    delegate.dblClickTimeOut = setTimeout( function() {
	                                        pointsList.clicks = 0;
	                                    }, tracker.dblClickTimeThreshold );
	                                    /*jshint loopfunc:false*/
	                                } else if ( pointsList.clicks === 2 ) {
	                                    clearTimeout( delegate.dblClickTimeOut );
	                                    pointsList.clicks = 0;
	                                    if ( delegate.lastClickPos.distanceTo( releasePoint ) <= tracker.dblClickDistThreshold ) {
	                                        propagate = tracker.dblClickHandler(
	                                            {
	                                                eventSource:          tracker,
	                                                pointerType:          updateGPoint.type,
	                                                position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                                shift:                event.shiftKey,
	                                                isTouchEvent:         updateGPoint.type === 'touch',
	                                                originalEvent:        event,
	                                                preventDefaultAction: false,
	                                                userData:             tracker.userData
	                                            }
	                                        );
	                                        if ( propagate === false ) {
	                                            $.cancelEvent( event );
	                                        }
	                                    }
	                                    delegate.lastClickPos = null;
	                                }
	                            }
	                        }
	                    } else if ( pointsList.contacts === 2 ) {
	                        if ( tracker.pinchHandler && updateGPoint.type === 'touch' ) {
	                            // Reset for pinch
	                            delegate.pinchGPoints = pointsList.asArray();
	                            delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                            delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                        }
	                    }
	                } else {
	                    // Pointer was activated in another element but removed in our element
	
	                    // Release (pressed in another element)
	                    if ( tracker.releaseHandler ) {
	                        propagate = tracker.releaseHandler(
	                            {
	                                eventSource:           tracker,
	                                pointerType:           updateGPoint.type,
	                                position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
	                                buttons:               pointsList.buttons,
	                                insideElementPressed:  updateGPoint.insideElementPressed,
	                                insideElementReleased: updateGPoint.insideElement,
	                                isTouchEvent:          updateGPoint.type === 'touch',
	                                originalEvent:         event,
	                                preventDefaultAction:  false,
	                                userData:              tracker.userData
	                            }
	                        );
	                        if ( propagate === false ) {
	                            $.cancelEvent( event );
	                        }
	                    }
	                }
	            }
	        }
	
	        return releaseCapture;
	    }
	
	
	    /**
	     * Call when pointer(s) change coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
	     *
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersMove( tracker, event, gPoints ) {
	        var delegate = THIS[ tracker.hash ],
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            gPointArray,
	            delta,
	            propagate;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                if ( curGPoint.hasOwnProperty( 'isPrimary' ) ) {
	                    updateGPoint.isPrimary = curGPoint.isPrimary;
	                }
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	            } else {
	                // Initialize for tracking and add to the tracking list (no pointerover or pointerdown event occurred before this)
	                curGPoint.captured = false;
	                curGPoint.insideElementPressed = false;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	        }
	
	        // Stop (mouse only)
	        if ( tracker.stopHandler && gPoints[ 0 ].type === 'mouse' ) {
	            clearTimeout( tracker.stopTimeOut );
	            tracker.stopTimeOut = setTimeout( function() {
	                handlePointerStop( tracker, event, gPoints[ 0 ].type );
	            }, tracker.stopDelay );
	        }
	
	        if ( pointsList.contacts === 0 ) {
	            // Move (no contacts: hovering mouse or other hover-capable device)
	            if ( tracker.moveHandler ) {
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPoints[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        } else if ( pointsList.contacts === 1 ) {
	            // Move (1 contact)
	            if ( tracker.moveHandler ) {
	                updateGPoint = pointsList.asArray()[ 0 ];
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          updateGPoint.type,
	                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         updateGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            // Drag
	            if ( tracker.dragHandler ) {
	                updateGPoint = pointsList.asArray()[ 0 ];
	                delta = updateGPoint.currentPos.minus( updateGPoint.lastPos );
	                propagate = tracker.dragHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          updateGPoint.type,
	                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        delta:                delta,
	                        speed:                updateGPoint.speed,
	                        direction:            updateGPoint.direction,
	                        shift:                event.shiftKey,
	                        isTouchEvent:         updateGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        } else if ( pointsList.contacts === 2 ) {
	            // Move (2 contacts, use center)
	            if ( tracker.moveHandler ) {
	                gPointArray = pointsList.asArray();
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPointArray[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( getCenterPoint( gPointArray[ 0 ].currentPos, gPointArray[ 1 ].currentPos ), tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPointArray[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            // Pinch
	            if ( tracker.pinchHandler && gPoints[ 0 ].type === 'touch' ) {
	                delta = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                if ( delta != delegate.currentPinchDist ) {
	                    delegate.lastPinchDist = delegate.currentPinchDist;
	                    delegate.currentPinchDist = delta;
	                    delegate.lastPinchCenter = delegate.currentPinchCenter;
	                    delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                    propagate = tracker.pinchHandler(
	                        {
	                            eventSource:          tracker,
	                            pointerType:          'touch',
	                            gesturePoints:        delegate.pinchGPoints,
	                            lastCenter:           getPointRelativeToAbsolute( delegate.lastPinchCenter, tracker.element ),
	                            center:               getPointRelativeToAbsolute( delegate.currentPinchCenter, tracker.element ),
	                            lastDistance:         delegate.lastPinchDist,
	                            distance:             delegate.currentPinchDist,
	                            shift:                event.shiftKey,
	                            originalEvent:        event,
	                            preventDefaultAction: false,
	                            userData:             tracker.userData
	                        }
	                    );
	                    if ( propagate === false ) {
	                        $.cancelEvent( event );
	                    }
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersCancel( tracker, event, gPoints ) {
	        updatePointersUp( tracker, event, gPoints, 0 );
	        updatePointersExit( tracker, event, gPoints );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerStop( tracker, originalMoveEvent, pointerType ) {
	        if ( tracker.stopHandler ) {
	            tracker.stopHandler( {
	                eventSource:          tracker,
	                pointerType:          pointerType,
	                position:             getMouseRelative( originalMoveEvent, tracker.element ),
	                buttons:              tracker.getActivePointersListByType( pointerType ).buttons,
	                isTouchEvent:         pointerType === 'touch',
	                originalEvent:        originalMoveEvent,
	                preventDefaultAction: false,
	                userData:             tracker.userData
	            } );
	        }
	    }
	
	} ( OpenSeadragon ) );
	
	/*
	 * OpenSeadragon - Control
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * An enumeration of supported locations where controls can be anchored.
	 * The anchoring is always relative to the container.
	 * @member ControlAnchor
	 * @memberof OpenSeadragon
	 * @static
	 * @type {Object}
	 * @property {Number} NONE
	 * @property {Number} TOP_LEFT
	 * @property {Number} TOP_RIGHT
	 * @property {Number} BOTTOM_LEFT
	 * @property {Number} BOTTOM_RIGHT
	 * @property {Number} ABSOLUTE
	 */
	$.ControlAnchor = {
	    NONE: 0,
	    TOP_LEFT: 1,
	    TOP_RIGHT: 2,
	    BOTTOM_RIGHT: 3,
	    BOTTOM_LEFT: 4,
	    ABSOLUTE: 5
	};
	
	/**
	 * @class Control
	 * @classdesc A Control represents any interface element which is meant to allow the user
	 * to interact with the zoomable interface. Any control can be anchored to any
	 * element.
	 *
	 * @memberof OpenSeadragon
	 * @param {Element} element - the control element to be anchored in the container.
	 * @param {Object } options - All required and optional settings for configuring a control element.
	 * @param {OpenSeadragon.ControlAnchor} [options.anchor=OpenSeadragon.ControlAnchor.NONE] - the position of the control
	 *  relative to the container.
	 * @param {Boolean} [options.attachToViewer=true] - Whether the control should be added directly to the viewer, or
	 *  directly to the container
	 * @param {Boolean} [options.autoFade=true] - Whether the control should have the autofade behavior
	 * @param {Element} container - the element to control will be anchored too.
	 */
	$.Control = function ( element, options, container ) {
	    var parent = element.parentNode;
	    if (typeof options === 'number')
	    {
	        $.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; " +
	                        "please use an options object instead.  " +
	                        "Support for this deprecated variant is scheduled for removal in December 2013");
	         options = {anchor: options};
	    }
	    options.attachToViewer = (typeof options.attachToViewer === 'undefined') ? true : options.attachToViewer;
	    /**
	     * True if the control should have autofade behavior.
	     * @member {Boolean} autoFade
	     * @memberof OpenSeadragon.Control#
	     */
	    this.autoFade = (typeof options.autoFade === 'undefined') ? true : options.autoFade;
	    /**
	     * The element providing the user interface with some type of control (e.g. a zoom-in button).
	     * @member {Element} element
	     * @memberof OpenSeadragon.Control#
	     */
	    this.element    = element;
	    /**
	     * The position of the Control relative to its container.
	     * @member {OpenSeadragon.ControlAnchor} anchor
	     * @memberof OpenSeadragon.Control#
	     */
	    this.anchor     = options.anchor;
	    /**
	     * The Control's containing element.
	     * @member {Element} container
	     * @memberof OpenSeadragon.Control#
	     */
	    this.container  = container;
	    /**
	     * A neutral element surrounding the control element.
	     * @member {Element} wrapper
	     * @memberof OpenSeadragon.Control#
	     */
	    if ( this.anchor == $.ControlAnchor.ABSOLUTE ) {
	        this.wrapper    = $.makeNeutralElement( "div" );
	        this.wrapper.style.position = "absolute";
	        this.wrapper.style.top = typeof ( options.top )  == "number" ? ( options.top + 'px' ) : options.top;
	        this.wrapper.style.left  = typeof ( options.left )  == "number" ?  (options.left + 'px' ) : options.left;
	        this.wrapper.style.height = typeof ( options.height )  == "number" ? ( options.height + 'px' ) : options.height;
	        this.wrapper.style.width  = typeof ( options.width )  == "number" ? ( options.width + 'px' ) : options.width;
	        this.wrapper.style.margin = "0px";
	        this.wrapper.style.padding = "0px";
	
	        this.element.style.position = "relative";
	        this.element.style.top = "0px";
	        this.element.style.left = "0px";
	        this.element.style.height = "100%";
	        this.element.style.width = "100%";
	    } else {
	        this.wrapper    = $.makeNeutralElement( "div" );
	        this.wrapper.style.display = "inline-block";
	        if ( this.anchor == $.ControlAnchor.NONE ) {
	            // IE6 fix
	            this.wrapper.style.width = this.wrapper.style.height = "100%";
	        }
	    }
	    this.wrapper.appendChild( this.element );
	
	    if (options.attachToViewer ) {
	        if ( this.anchor == $.ControlAnchor.TOP_RIGHT ||
	             this.anchor == $.ControlAnchor.BOTTOM_RIGHT ) {
	            this.container.insertBefore(
	                this.wrapper,
	                this.container.firstChild
	            );
	        } else {
	            this.container.appendChild( this.wrapper );
	        }
	    } else {
	        parent.appendChild( this.wrapper );
	    }
	};
	
	$.Control.prototype = /** @lends OpenSeadragon.Control.prototype */{
	
	    /**
	     * Removes the control from the container.
	     * @function
	     */
	    destroy: function() {
	        this.wrapper.removeChild( this.element );
	        this.container.removeChild( this.wrapper );
	    },
	
	    /**
	     * Determines if the control is currently visible.
	     * @function
	     * @return {Boolean} true if currenly visible, false otherwise.
	     */
	    isVisible: function() {
	        return this.wrapper.style.display != "none";
	    },
	
	    /**
	     * Toggles the visibility of the control.
	     * @function
	     * @param {Boolean} visible - true to make visible, false to hide.
	     */
	    setVisible: function( visible ) {
	        this.wrapper.style.display = visible ?
	            ( this.anchor == $.ControlAnchor.ABSOLUTE ? 'block' : 'inline-block' ) :
	            "none";
	    },
	
	    /**
	     * Sets the opacity level for the control.
	     * @function
	     * @param {Number} opactiy - a value between 1 and 0 inclusively.
	     */
	    setOpacity: function( opacity ) {
	        if ( this.element[ $.SIGNAL ] && $.Browser.vendor == $.BROWSERS.IE ) {
	            $.setElementOpacity( this.element, opacity, true );
	        } else {
	            $.setElementOpacity( this.wrapper, opacity, true );
	        }
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ControlDock
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	    /**
	     * @class ControlDock
	     * @classdesc Provides a container element (a &lt;form&gt; element) with support for the layout of control elements.
	     *
	     * @memberof OpenSeadragon
	     */
	    $.ControlDock = function( options ){
	        var layouts = [ 'topleft', 'topright', 'bottomright', 'bottomleft'],
	            layout,
	            i;
	
	        $.extend( true, this, {
	            id: 'controldock-'+$.now()+'-'+Math.floor(Math.random()*1000000),
	            container: $.makeNeutralElement( 'div' ),
	            controls: []
	        }, options );
	
	        // Disable the form's submit; otherwise button clicks and return keys
	        // can trigger it.
	        this.container.onsubmit = function() {
	            return false;
	        };
	
	        if( this.element ){
	            this.element = $.getElement( this.element );
	            this.element.appendChild( this.container );
	            this.element.style.position = 'relative';
	            this.container.style.width = '100%';
	            this.container.style.height = '100%';
	        }
	
	        for( i = 0; i < layouts.length; i++ ){
	            layout = layouts[ i ];
	            this.controls[ layout ] = $.makeNeutralElement( "div" );
	            this.controls[ layout ].style.position = 'absolute';
	            if ( layout.match( 'left' ) ){
	                this.controls[ layout ].style.left = '0px';
	            }
	            if ( layout.match( 'right' ) ){
	                this.controls[ layout ].style.right = '0px';
	            }
	            if ( layout.match( 'top' ) ){
	                this.controls[ layout ].style.top = '0px';
	            }
	            if ( layout.match( 'bottom' ) ){
	                this.controls[ layout ].style.bottom = '0px';
	            }
	        }
	
	        this.container.appendChild( this.controls.topleft );
	        this.container.appendChild( this.controls.topright );
	        this.container.appendChild( this.controls.bottomright );
	        this.container.appendChild( this.controls.bottomleft );
	    };
	
	    $.ControlDock.prototype = /** @lends OpenSeadragon.ControlDock.prototype */{
	
	        /**
	         * @function
	         */
	        addControl: function ( element, controlOptions ) {
	            element = $.getElement( element );
	            var div = null;
	
	            if ( getControlIndex( this, element ) >= 0 ) {
	                return;     // they're trying to add a duplicate control
	            }
	
	            switch ( controlOptions.anchor ) {
	                case $.ControlAnchor.TOP_RIGHT:
	                    div = this.controls.topright;
	                    element.style.position = "relative";
	                    element.style.paddingRight = "0px";
	                    element.style.paddingTop = "0px";
	                    break;
	                case $.ControlAnchor.BOTTOM_RIGHT:
	                    div = this.controls.bottomright;
	                    element.style.position = "relative";
	                    element.style.paddingRight = "0px";
	                    element.style.paddingBottom = "0px";
	                    break;
	                case $.ControlAnchor.BOTTOM_LEFT:
	                    div = this.controls.bottomleft;
	                    element.style.position = "relative";
	                    element.style.paddingLeft = "0px";
	                    element.style.paddingBottom = "0px";
	                    break;
	                case $.ControlAnchor.TOP_LEFT:
	                    div = this.controls.topleft;
	                    element.style.position = "relative";
	                    element.style.paddingLeft = "0px";
	                    element.style.paddingTop = "0px";
	                    break;
	                case $.ControlAnchor.ABSOLUTE:
	                    div = this.container;
	                    element.style.margin = "0px";
	                    element.style.padding = "0px";
	                    break;
	                default:
	                case $.ControlAnchor.NONE:
	                    div = this.container;
	                    element.style.margin = "0px";
	                    element.style.padding = "0px";
	                    break;
	            }
	
	            this.controls.push(
	                new $.Control( element, controlOptions, div )
	            );
	            element.style.display = "inline-block";
	        },
	
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        removeControl: function ( element ) {
	            element = $.getElement( element );
	            var i = getControlIndex( this, element );
	
	            if ( i >= 0 ) {
	                this.controls[ i ].destroy();
	                this.controls.splice( i, 1 );
	            }
	
	            return this;
	        },
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        clearControls: function () {
	            while ( this.controls.length > 0 ) {
	                this.controls.pop().destroy();
	            }
	
	            return this;
	        },
	
	
	        /**
	         * @function
	         * @return {Boolean}
	         */
	        areControlsEnabled: function () {
	            var i;
	
	            for ( i = this.controls.length - 1; i >= 0; i-- ) {
	                if ( this.controls[ i ].isVisible() ) {
	                    return true;
	                }
	            }
	
	            return false;
	        },
	
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        setControlsEnabled: function( enabled ) {
	            var i;
	
	            for ( i = this.controls.length - 1; i >= 0; i-- ) {
	                this.controls[ i ].setVisible( enabled );
	            }
	
	            return this;
	        }
	
	    };
	
	
	    ///////////////////////////////////////////////////////////////////////////////
	    // Utility methods
	    ///////////////////////////////////////////////////////////////////////////////
	    function getControlIndex( dock, element ) {
	        var controls = dock.controls,
	            i;
	
	        for ( i = controls.length - 1; i >= 0; i-- ) {
	            if ( controls[ i ].element == element ) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Viewer
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// dictionary from hash to private properties
	var THIS = {};
	var nextHash = 1;
	
	/**
	 *
	 * The main point of entry into creating a zoomable image on the page.
	 *
	 * We have provided an idiomatic javascript constructor which takes
	 * a single object, but still support the legacy positional arguments.
	 *
	 * The options below are given in order that they appeared in the constructor
	 * as arguments and we translate a positional call into an idiomatic call.
	 *
	 * @class Viewer
	 * @classdesc The main OpenSeadragon viewer class.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @extends OpenSeadragon.ControlDock
	 * @param {OpenSeadragon.Options} options - Viewer options.
	 *
	 **/
	$.Viewer = function( options ) {
	
	    var args  = arguments,
	        _this = this,
	        i;
	
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    if( !$.isPlainObject( options ) ){
	        options = {
	            id:                 args[ 0 ],
	            xmlPath:            args.length > 1 ? args[ 1 ] : undefined,
	            prefixUrl:          args.length > 2 ? args[ 2 ] : undefined,
	            controls:           args.length > 3 ? args[ 3 ] : undefined,
	            overlays:           args.length > 4 ? args[ 4 ] : undefined
	        };
	    }
	
	    //options.config and the general config argument are deprecated
	    //in favor of the more direct specification of optional settings
	    //being pass directly on the options object
	    if ( options.config ){
	        $.extend( true, options, options.config );
	        delete options.config;
	    }
	
	    //Public properties
	    //Allow the options object to override global defaults
	    $.extend( true, this, {
	
	        //internal state and dom identifiers
	        id:             options.id,
	        hash:           options.hash || nextHash++,
	
	        //dom nodes
	        /**
	         * The parent element of this Viewer instance, passed in when the Viewer was created.
	         * @member {Element} element
	         * @memberof OpenSeadragon.Viewer#
	         */
	        element:        null,
	        /**
	         * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
	         * Child element of {@link OpenSeadragon.Viewer#element}.
	         * @member {Element} container
	         * @memberof OpenSeadragon.Viewer#
	         */
	        container:      null,
	        /**
	         * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
	         * Child element of {@link OpenSeadragon.Viewer#container},
	         * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
	         * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
	         * @member {Element} canvas
	         * @memberof OpenSeadragon.Viewer#
	         */
	        canvas:         null,
	
	        // Overlays list. An overlay allows to add html on top of the viewer.
	        overlays:           [],
	        // Container inside the canvas where overlays are drawn.
	        overlaysContainer:  null,
	
	        //private state properties
	        previousBody:   [],
	
	        //This was originally initialized in the constructor and so could never
	        //have anything in it.  now it can because we allow it to be specified
	        //in the options and is only empty by default if not specified. Also
	        //this array was returned from get_controls which I find confusing
	        //since this object has a controls property which is treated in other
	        //functions like clearControls.  I'm removing the accessors.
	        customControls: [],
	
	        //These are originally not part options but declared as members
	        //in initialize.  It's still considered idiomatic to put them here
	        source:         null,
	        /**
	         * Handles rendering of tiles in the viewer. Created for each TileSource opened.
	         * @member {OpenSeadragon.Drawer} drawer
	         * @memberof OpenSeadragon.Viewer#
	         */
	        drawer:             null,
	        world:              null,
	        /**
	         * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
	         * @member {OpenSeadragon.Viewport} viewport
	         * @memberof OpenSeadragon.Viewer#
	         */
	        viewport:       null,
	        /**
	         * @member {OpenSeadragon.Navigator} navigator
	         * @memberof OpenSeadragon.Viewer#
	         */
	        navigator:      null,
	
	        //A collection viewport is a separate viewport used to provide
	        //simultaneous rendering of sets of tiles
	        collectionViewport:     null,
	        collectionDrawer:       null,
	
	        //UI image resources
	        //TODO: rename navImages to uiImages
	        navImages:      null,
	
	        //interface button controls
	        buttons:        null,
	
	        //TODO: this is defunct so safely remove it
	        profiler:       null
	
	    }, $.DEFAULT_SETTINGS, options );
	
	    if ( typeof( this.hash) === "undefined" ) {
	        throw new Error("A hash must be defined, either by specifying options.id or options.hash.");
	    }
	    if ( typeof( THIS[ this.hash ] ) !== "undefined" ) {
	        // We don't want to throw an error here, as the user might have discarded
	        // the previous viewer with the same hash and now want to recreate it.
	        $.console.warn("Hash " + this.hash + " has already been used.");
	    }
	
	    //Private state properties
	    THIS[ this.hash ] = {
	        "fsBoundsDelta":     new $.Point( 1, 1 ),
	        "prevContainerSize": null,
	        "animating":         false,
	        "forceRedraw":       false,
	        "mouseInside":       false,
	        "group":             null,
	        // whether we should be continuously zooming
	        "zooming":           false,
	        // how much we should be continuously zooming by
	        "zoomFactor":        null,
	        "lastZoomTime":      null,
	        "fullPage":          false,
	        "onfullscreenchange": null
	    };
	
	    this._sequenceIndex = 0;
	    this._firstOpen = true;
	    this._updateRequestId = null;
	    this._loadQueue = [];
	    this.currentOverlays = [];
	
	    this._lastScrollTime = $.now(); // variable used to help normalize the scroll event speed of different devices
	
	    //Inherit some behaviors and properties
	    $.EventSource.call( this );
	
	    this.addHandler( 'open-failed', function ( event ) {
	        var msg = $.getString( "Errors.OpenFailed", event.eventSource, event.message);
	        _this._showMessage( msg );
	    });
	
	    $.ControlDock.call( this, options );
	
	    //Deal with tile sources
	    if ( this.xmlPath  ){
	        //Deprecated option.  Now it is preferred to use the tileSources option
	        this.tileSources = [ this.xmlPath ];
	    }
	
	    this.element              = this.element || document.getElementById( this.id );
	    this.canvas               = $.makeNeutralElement( "div" );
	
	    this.canvas.className = "openseadragon-canvas";
	    (function( style ){
	        style.width    = "100%";
	        style.height   = "100%";
	        style.overflow = "hidden";
	        style.position = "absolute";
	        style.top      = "0px";
	        style.left     = "0px";
	    }(this.canvas.style));
	    $.setElementTouchActionNone( this.canvas );
	    this.canvas.tabIndex = options.tabIndex || 0;
	
	    //the container is created through applying the ControlDock constructor above
	    this.container.className = "openseadragon-container";
	    (function( style ){
	        style.width     = "100%";
	        style.height    = "100%";
	        style.position  = "relative";
	        style.overflow  = "hidden";
	        style.left      = "0px";
	        style.top       = "0px";
	        style.textAlign = "left";  // needed to protect against
	    }( this.container.style ));
	
	    this.container.insertBefore( this.canvas, this.container.firstChild );
	    this.element.appendChild( this.container );
	
	    //Used for toggling between fullscreen and default container size
	    //TODO: these can be closure private and shared across Viewer
	    //      instances.
	    this.bodyWidth      = document.body.style.width;
	    this.bodyHeight     = document.body.style.height;
	    this.bodyOverflow   = document.body.style.overflow;
	    this.docOverflow    = document.documentElement.style.overflow;
	
	    this.innerTracker = new $.MouseTracker({
	        element:                  this.canvas,
	        startDisabled:            this.mouseNavEnabled ? false : true,
	        clickTimeThreshold:       this.clickTimeThreshold,
	        clickDistThreshold:       this.clickDistThreshold,
	        dblClickTimeThreshold:    this.dblClickTimeThreshold,
	        dblClickDistThreshold:    this.dblClickDistThreshold,
	        keyDownHandler:           $.delegate( this, onCanvasKeyDown ),
	        keyHandler:               $.delegate( this, onCanvasKeyPress ),
	        clickHandler:             $.delegate( this, onCanvasClick ),
	        dblClickHandler:          $.delegate( this, onCanvasDblClick ),
	        dragHandler:              $.delegate( this, onCanvasDrag ),
	        dragEndHandler:           $.delegate( this, onCanvasDragEnd ),
	        enterHandler:             $.delegate( this, onCanvasEnter ),
	        exitHandler:              $.delegate( this, onCanvasExit ),
	        pressHandler:             $.delegate( this, onCanvasPress ),
	        releaseHandler:           $.delegate( this, onCanvasRelease ),
	        nonPrimaryPressHandler:   $.delegate( this, onCanvasNonPrimaryPress ),
	        nonPrimaryReleaseHandler: $.delegate( this, onCanvasNonPrimaryRelease ),
	        scrollHandler:            $.delegate( this, onCanvasScroll ),
	        pinchHandler:             $.delegate( this, onCanvasPinch )
	    });
	
	    this.outerTracker = new $.MouseTracker({
	        element:               this.container,
	        startDisabled:         this.mouseNavEnabled ? false : true,
	        clickTimeThreshold:    this.clickTimeThreshold,
	        clickDistThreshold:    this.clickDistThreshold,
	        dblClickTimeThreshold: this.dblClickTimeThreshold,
	        dblClickDistThreshold: this.dblClickDistThreshold,
	        enterHandler:          $.delegate( this, onContainerEnter ),
	        exitHandler:           $.delegate( this, onContainerExit )
	    });
	
	    if( this.toolbar ){
	        this.toolbar = new $.ControlDock({ element: this.toolbar });
	    }
	
	    this.bindStandardControls();
	
	    THIS[ this.hash ].prevContainerSize = _getSafeElemSize( this.container );
	
	    // Create the world
	    this.world = new $.World({
	        viewer: this
	    });
	
	    this.world.addHandler('add-item', function(event) {
	        // For backwards compatibility, we maintain the source property
	        _this.source = _this.world.getItemAt(0).source;
	
	        THIS[ _this.hash ].forceRedraw = true;
	
	        if (!_this._updateRequestId) {
	            _this._updateRequestId = scheduleUpdate( _this, updateMulti );
	        }
	    });
	
	    this.world.addHandler('remove-item', function(event) {
	        // For backwards compatibility, we maintain the source property
	        if (_this.world.getItemCount()) {
	            _this.source = _this.world.getItemAt(0).source;
	        } else {
	            _this.source = null;
	        }
	
	        THIS[ _this.hash ].forceRedraw = true;
	    });
	
	    this.world.addHandler('metrics-change', function(event) {
	        if (_this.viewport) {
	            _this.viewport.setHomeBounds(_this.world.getHomeBounds(), _this.world.getContentFactor());
	        }
	    });
	
	    this.world.addHandler('item-index-change', function(event) {
	        // For backwards compatibility, we maintain the source property
	        _this.source = _this.world.getItemAt(0).source;
	    });
	
	    // Create the viewport
	    this.viewport = new $.Viewport({
	        containerSize:      THIS[ this.hash ].prevContainerSize,
	        springStiffness:    this.springStiffness,
	        animationTime:      this.animationTime,
	        minZoomImageRatio:  this.minZoomImageRatio,
	        maxZoomPixelRatio:  this.maxZoomPixelRatio,
	        visibilityRatio:    this.visibilityRatio,
	        wrapHorizontal:     this.wrapHorizontal,
	        wrapVertical:       this.wrapVertical,
	        defaultZoomLevel:   this.defaultZoomLevel,
	        minZoomLevel:       this.minZoomLevel,
	        maxZoomLevel:       this.maxZoomLevel,
	        viewer:             this,
	        degrees:            this.degrees,
	        navigatorRotate:    this.navigatorRotate,
	        homeFillsViewer:    this.homeFillsViewer,
	        margins:            this.viewportMargins
	    });
	
	    this.viewport.setHomeBounds(this.world.getHomeBounds(), this.world.getContentFactor());
	
	    // Create the image loader
	    this.imageLoader = new $.ImageLoader({
	        jobLimit: this.imageLoaderLimit
	    });
	
	    // Create the tile cache
	    this.tileCache = new $.TileCache({
	        maxImageCacheCount: this.maxImageCacheCount
	    });
	
	    // Create the drawer
	    this.drawer = new $.Drawer({
	        viewer:             this,
	        viewport:           this.viewport,
	        element:            this.canvas,
	        debugGridColor:     this.debugGridColor
	    });
	
	    // Overlay container
	    this.overlaysContainer    = $.makeNeutralElement( "div" );
	    this.canvas.appendChild( this.overlaysContainer );
	
	    // Now that we have a drawer, see if it supports rotate. If not we need to remove the rotate buttons
	    if (!this.drawer.canRotate()) {
	        // Disable/remove the rotate left/right buttons since they aren't supported
	        if (this.rotateLeft) {
	            i = this.buttons.buttons.indexOf(this.rotateLeft);
	            this.buttons.buttons.splice(i, 1);
	            this.buttons.element.removeChild(this.rotateLeft.element);
	        }
	        if (this.rotateRight) {
	            i = this.buttons.buttons.indexOf(this.rotateRight);
	            this.buttons.buttons.splice(i, 1);
	            this.buttons.element.removeChild(this.rotateRight.element);
	        }
	    }
	
	    //Instantiate a navigator if configured
	    if ( this.showNavigator){
	        this.navigator = new $.Navigator({
	            id:                this.navigatorId,
	            position:          this.navigatorPosition,
	            sizeRatio:         this.navigatorSizeRatio,
	            maintainSizeRatio: this.navigatorMaintainSizeRatio,
	            top:               this.navigatorTop,
	            left:              this.navigatorLeft,
	            width:             this.navigatorWidth,
	            height:            this.navigatorHeight,
	            autoResize:        this.navigatorAutoResize,
	            prefixUrl:         this.prefixUrl,
	            viewer:            this,
	            navigatorRotate:   this.navigatorRotate,
	            crossOriginPolicy: this.crossOriginPolicy
	        });
	    }
	
	    // Sequence mode
	    if (this.sequenceMode) {
	        this.bindSequenceControls();
	    }
	
	    // Open initial tilesources
	    if (this.tileSources) {
	        this.open( this.tileSources );
	    }
	
	    // Add custom controls
	    for ( i = 0; i < this.customControls.length; i++ ) {
	        this.addControl(
	            this.customControls[ i ].id,
	            {anchor: this.customControls[ i ].anchor}
	        );
	    }
	
	    // Initial fade out
	    $.requestAnimationFrame( function(){
	        beginControlsAutoHide( _this );
	    } );
	};
	
	$.extend( $.Viewer.prototype, $.EventSource.prototype, $.ControlDock.prototype, /** @lends OpenSeadragon.Viewer.prototype */{
	
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isOpen: function () {
	        return !!this.world.getItemCount();
	    },
	
	    // deprecated
	    openDzi: function ( dzi ) {
	        $.console.error( "[Viewer.openDzi] this function is deprecated; use Viewer.open() instead." );
	        return this.open( dzi );
	    },
	
	    // deprecated
	    openTileSource: function ( tileSource ) {
	        $.console.error( "[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead." );
	        return this.open( tileSource );
	    },
	
	    /**
	     * Open tiled images into the viewer, closing any others.
	     * @function
	     * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
	     * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
	     * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
	     * except for the index property; images are added in sequence.
	     * A TileSource specifier is anything you could pass as the tileSource property
	     * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:open
	     * @fires OpenSeadragon.Viewer.event:open-failed
	     */
	    open: function (tileSources) {
	        var _this = this;
	
	        this.close();
	
	        if (!tileSources) {
	            return;
	        }
	
	        if (this.sequenceMode && $.isArray(tileSources)) {
	            if (this.referenceStrip) {
	                this.referenceStrip.destroy();
	                this.referenceStrip = null;
	            }
	
	            this.tileSources = tileSources;
	            this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage));
	            if (this.tileSources.length) {
	                this.open(this.tileSources[this._sequenceIndex]);
	
	                if ( this.showReferenceStrip ){
	                    this.referenceStrip = new $.ReferenceStrip({
	                        id:          this.referenceStripElement,
	                        position:    this.referenceStripPosition,
	                        sizeRatio:   this.referenceStripSizeRatio,
	                        scroll:      this.referenceStripScroll,
	                        height:      this.referenceStripHeight,
	                        width:       this.referenceStripWidth,
	                        tileSources: this.tileSources,
	                        prefixUrl:   this.prefixUrl,
	                        viewer:      this
	                    });
	                }
	            }
	
	            this._updateSequenceButtons( this._sequenceIndex );
	            return;
	        }
	
	        if (!$.isArray(tileSources)) {
	            tileSources = [tileSources];
	        }
	
	        if (!tileSources.length) {
	            return;
	        }
	
	        this._opening = true;
	
	        var expected = tileSources.length;
	        var successes = 0;
	        var failures = 0;
	        var failEvent;
	
	        var checkCompletion = function() {
	            if (successes + failures === expected) {
	                if (successes) {
	                    if (_this._firstOpen || !_this.preserveViewport) {
	                        _this.viewport.goHome( true );
	                        _this.viewport.update();
	                    }
	
	                    _this._firstOpen = false;
	
	                    var source = tileSources[0];
	                    if (source.tileSource) {
	                        source = source.tileSource;
	                    }
	
	                    // Global overlays
	                    if( _this.overlays && !_this.preserveOverlays ){
	                        for ( var i = 0; i < _this.overlays.length; i++ ) {
	                            _this.currentOverlays[ i ] = getOverlayObject( _this, _this.overlays[ i ] );
	                        }
	                    }
	
	                    _this._drawOverlays();
	                    _this._opening = false;
	
	                    /**
	                     * Raised when the viewer has opened and loaded one or more TileSources.
	                     *
	                     * @event open
	                     * @memberof OpenSeadragon.Viewer
	                     * @type {object}
	                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                     * @property {OpenSeadragon.TileSource} source - The tile source that was opened.
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    // TODO: what if there are multiple sources?
	                    _this.raiseEvent( 'open', { source: source } );
	                } else {
	                    _this._opening = false;
	
	                    /**
	                     * Raised when an error occurs loading a TileSource.
	                     *
	                     * @event open-failed
	                     * @memberof OpenSeadragon.Viewer
	                     * @type {object}
	                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                     * @property {String} message - Information about what failed.
	                     * @property {String} source - The tile source that failed.
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    _this.raiseEvent( 'open-failed', failEvent );
	                }
	            }
	        };
	
	        var doOne = function(options) {
	            if (!$.isPlainObject(options) || !options.tileSource) {
	                options = {
	                    tileSource: options
	                };
	            }
	
	            if (options.index !== undefined) {
	                $.console.error('[Viewer.open] setting indexes here is not supported; use addTiledImage instead');
	                delete options.index;
	            }
	
	            if (options.collectionImmediately === undefined) {
	                options.collectionImmediately = true;
	            }
	
	            var originalSuccess = options.success;
	            options.success = function(event) {
	                successes++;
	
	                // TODO: now that options has other things besides tileSource, the overlays
	                // should probably be at the options level, not the tileSource level.
	                if (options.tileSource.overlays) {
	                    for (var i = 0; i < options.tileSource.overlays.length; i++) {
	                        _this.addOverlay(options.tileSource.overlays[i]);
	                    }
	                }
	
	                if (originalSuccess) {
	                    originalSuccess(event);
	                }
	
	                checkCompletion();
	            };
	
	            var originalError = options.error;
	            options.error = function(event) {
	                failures++;
	
	                if (!failEvent) {
	                    failEvent = event;
	                }
	
	                if (originalError) {
	                    originalError(event);
	                }
	
	                checkCompletion();
	            };
	
	            _this.addTiledImage(options);
	        };
	
	        // TileSources
	        for (var i = 0; i < tileSources.length; i++) {
	            doOne(tileSources[i]);
	        }
	
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:close
	     */
	    close: function ( ) {
	        if ( !THIS[ this.hash ] ) {
	            //this viewer has already been destroyed: returning immediately
	            return this;
	        }
	
	        this._opening = false;
	
	        if ( this.navigator ) {
	            this.navigator.close();
	        }
	
	        if( ! this.preserveOverlays) {
	            this.clearOverlays();
	            this.overlaysContainer.innerHTML = "";
	        }
	
	        THIS[ this.hash ].animating = false;
	        this.world.removeAll();
	        this.imageLoader.clear();
	
	        /**
	         * Raised when the viewer is closed (see {@link OpenSeadragon.Viewer#close}).
	         *
	         * @event close
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'close' );
	
	        return this;
	    },
	
	
	    /**
	     * Function to destroy the viewer and clean up everything created by OpenSeadragon.
	     *
	     * Example:
	     * var viewer = OpenSeadragon({
	     *   [...]
	     * });
	     *
	     * //when you are done with the viewer:
	     * viewer.destroy();
	     * viewer = null; //important
	     *
	     * @function
	     */
	    destroy: function( ) {
	        if ( !THIS[ this.hash ] ) {
	            //this viewer has already been destroyed: returning immediately
	            return;
	        }
	
	        this.close();
	
	        this.clearOverlays();
	        this.overlaysContainer.innerHTML = "";
	
	        //TODO: implement this...
	        //this.unbindSequenceControls()
	        //this.unbindStandardControls()
	
	        if (this.referenceStrip) {
	            this.referenceStrip.destroy();
	            this.referenceStrip = null;
	        }
	
	        if ( this._updateRequestId !== null ) {
	            $.cancelAnimationFrame( this._updateRequestId );
	            this._updateRequestId = null;
	        }
	
	        if ( this.drawer ) {
	            this.drawer.destroy();
	        }
	
	        this.removeAllHandlers();
	
	        // Go through top element (passed to us) and remove all children
	        // Use removeChild to make sure it handles SVG or any non-html
	        // also it performs better - http://jsperf.com/innerhtml-vs-removechild/15
	        if (this.element){
	            while (this.element.firstChild) {
	                this.element.removeChild(this.element.firstChild);
	            }
	        }
	
	        // destroy the mouse trackers
	        if (this.innerTracker){
	            this.innerTracker.destroy();
	        }
	        if (this.outerTracker){
	            this.outerTracker.destroy();
	        }
	
	        THIS[ this.hash ] = null;
	        delete THIS[ this.hash ];
	
	        // clear all our references to dom objects
	        this.canvas = null;
	        this.container = null;
	
	        // clear our reference to the main element - they will need to pass it in again, creating a new viewer
	        this.element = null;
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isMouseNavEnabled: function () {
	        return this.innerTracker.isTracking();
	    },
	
	    /**
	     * @function
	     * @param {Boolean} enabled - true to enable, false to disable
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:mouse-enabled
	     */
	    setMouseNavEnabled: function( enabled ){
	        this.innerTracker.setTracking( enabled );
	        /**
	         * Raised when mouse/touch navigation is enabled or disabled (see {@link OpenSeadragon.Viewer#setMouseNavEnabled}).
	         *
	         * @event mouse-enabled
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} enabled
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'mouse-enabled', { enabled: enabled } );
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    areControlsEnabled: function () {
	        var enabled = this.controls.length,
	            i;
	        for( i = 0; i < this.controls.length; i++ ){
	            enabled = enabled && this.controls[ i ].isVisibile();
	        }
	        return enabled;
	    },
	
	
	    /**
	     * Shows or hides the controls (e.g. the default navigation buttons).
	     *
	     * @function
	     * @param {Boolean} true to show, false to hide.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:controls-enabled
	     */
	    setControlsEnabled: function( enabled ) {
	        if( enabled ){
	            abortControlsAutoHide( this );
	        } else {
	            beginControlsAutoHide( this );
	        }
	        /**
	         * Raised when the navigation controls are shown or hidden (see {@link OpenSeadragon.Viewer#setControlsEnabled}).
	         *
	         * @event controls-enabled
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} enabled
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'controls-enabled', { enabled: enabled } );
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isFullPage: function () {
	        return THIS[ this.hash ].fullPage;
	    },
	
	
	    /**
	     * Toggle full page mode.
	     * @function
	     * @param {Boolean} fullPage
	     *      If true, enter full page mode.  If false, exit full page mode.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pre-full-page
	     * @fires OpenSeadragon.Viewer.event:full-page
	     */
	    setFullPage: function( fullPage ) {
	
	        var body = document.body,
	            bodyStyle = body.style,
	            docStyle = document.documentElement.style,
	            _this = this,
	            hash,
	            nodes,
	            i;
	
	        //dont bother modifying the DOM if we are already in full page mode.
	        if ( fullPage == this.isFullPage() ) {
	            return this;
	        }
	
	        var fullPageEventArgs = {
	            fullPage: fullPage,
	            preventDefaultAction: false
	        };
	        /**
	         * Raised when the viewer is about to change to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
	         *
	         * @event pre-full-page
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullPage - True if entering full-page mode, false if exiting full-page mode.
	         * @property {Boolean} preventDefaultAction - Set to true to prevent full-page mode change. Default: false.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'pre-full-page', fullPageEventArgs );
	        if ( fullPageEventArgs.preventDefaultAction ) {
	            return this;
	        }
	
	        if ( fullPage ) {
	
	            this.elementSize = $.getElementSize( this.element );
	            this.pageScroll = $.getPageScroll();
	
	            this.elementMargin = this.element.style.margin;
	            this.element.style.margin = "0";
	            this.elementPadding = this.element.style.padding;
	            this.element.style.padding = "0";
	
	            this.bodyMargin = bodyStyle.margin;
	            this.docMargin = docStyle.margin;
	            bodyStyle.margin = "0";
	            docStyle.margin = "0";
	
	            this.bodyPadding = bodyStyle.padding;
	            this.docPadding = docStyle.padding;
	            bodyStyle.padding = "0";
	            docStyle.padding = "0";
	
	            this.bodyWidth = bodyStyle.width;
	            this.bodyHeight = bodyStyle.height;
	            bodyStyle.width = "100%";
	            bodyStyle.height = "100%";
	
	            //when entering full screen on the ipad it wasnt sufficient to leave
	            //the body intact as only only the top half of the screen would
	            //respond to touch events on the canvas, while the bottom half treated
	            //them as touch events on the document body.  Thus we remove and store
	            //the bodies elements and replace them when we leave full screen.
	            this.previousBody = [];
	            THIS[ this.hash ].prevElementParent = this.element.parentNode;
	            THIS[ this.hash ].prevNextSibling = this.element.nextSibling;
	            THIS[ this.hash ].prevElementWidth = this.element.style.width;
	            THIS[ this.hash ].prevElementHeight = this.element.style.height;
	            nodes = body.childNodes.length;
	            for ( i = 0; i < nodes; i++ ) {
	                this.previousBody.push( body.childNodes[ 0 ] );
	                body.removeChild( body.childNodes[ 0 ] );
	            }
	
	            //If we've got a toolbar, we need to enable the user to use css to
	            //preserve it in fullpage mode
	            if ( this.toolbar && this.toolbar.element ) {
	                //save a reference to the parent so we can put it back
	                //in the long run we need a better strategy
	                this.toolbar.parentNode = this.toolbar.element.parentNode;
	                this.toolbar.nextSibling = this.toolbar.element.nextSibling;
	                body.appendChild( this.toolbar.element );
	
	                //Make sure the user has some ability to style the toolbar based
	                //on the mode
	                $.addClass( this.toolbar.element, 'fullpage' );
	            }
	
	            $.addClass( this.element, 'fullpage' );
	            body.appendChild( this.element );
	
	            this.element.style.height = $.getWindowSize().y + 'px';
	            this.element.style.width = $.getWindowSize().x + 'px';
	
	            if ( this.toolbar && this.toolbar.element ) {
	                this.element.style.height = (
	                    $.getElementSize( this.element ).y - $.getElementSize( this.toolbar.element ).y
	                ) + 'px';
	            }
	
	            THIS[ this.hash ].fullPage = true;
	
	            // mouse will be inside container now
	            $.delegate( this, onContainerEnter )( {} );
	
	        } else {
	
	            this.element.style.margin = this.elementMargin;
	            this.element.style.padding = this.elementPadding;
	
	            bodyStyle.margin = this.bodyMargin;
	            docStyle.margin = this.docMargin;
	
	            bodyStyle.padding = this.bodyPadding;
	            docStyle.padding = this.docPadding;
	
	            bodyStyle.width = this.bodyWidth;
	            bodyStyle.height = this.bodyHeight;
	
	            body.removeChild( this.element );
	            nodes = this.previousBody.length;
	            for ( i = 0; i < nodes; i++ ) {
	                body.appendChild( this.previousBody.shift() );
	            }
	
	            $.removeClass( this.element, 'fullpage' );
	            THIS[ this.hash ].prevElementParent.insertBefore(
	                this.element,
	                THIS[ this.hash ].prevNextSibling
	            );
	
	            //If we've got a toolbar, we need to enable the user to use css to
	            //reset it to its original state
	            if ( this.toolbar && this.toolbar.element ) {
	                body.removeChild( this.toolbar.element );
	
	                //Make sure the user has some ability to style the toolbar based
	                //on the mode
	                $.removeClass( this.toolbar.element, 'fullpage' );
	
	                this.toolbar.parentNode.insertBefore(
	                    this.toolbar.element,
	                    this.toolbar.nextSibling
	                );
	                delete this.toolbar.parentNode;
	                delete this.toolbar.nextSibling;
	            }
	
	            this.element.style.width = THIS[ this.hash ].prevElementWidth;
	            this.element.style.height = THIS[ this.hash ].prevElementHeight;
	
	            // After exiting fullPage or fullScreen, it can take some time
	            // before the browser can actually set the scroll.
	            var restoreScrollCounter = 0;
	            var restoreScroll = function() {
	                $.setPageScroll( _this.pageScroll );
	                var pageScroll = $.getPageScroll();
	                restoreScrollCounter++;
	                if ( restoreScrollCounter < 10 &&
	                    pageScroll.x !== _this.pageScroll.x ||
	                    pageScroll.y !== _this.pageScroll.y ) {
	                    $.requestAnimationFrame( restoreScroll );
	                }
	            };
	            $.requestAnimationFrame( restoreScroll );
	
	            THIS[ this.hash ].fullPage = false;
	
	            // mouse will likely be outside now
	            $.delegate( this, onContainerExit )( { } );
	
	        }
	
	        if ( this.navigator && this.viewport ) {
	            this.navigator.update( this.viewport );
	        }
	
	        /**
	         * Raised when the viewer has changed to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
	         *
	         * @event full-page
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullPage - True if changed to full-page mode, false if exited full-page mode.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'full-page', { fullPage: fullPage } );
	
	        return this;
	    },
	
	    /**
	     * Toggle full screen mode if supported. Toggle full page mode otherwise.
	     * @function
	     * @param {Boolean} fullScreen
	     *      If true, enter full screen mode.  If false, exit full screen mode.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pre-full-screen
	     * @fires OpenSeadragon.Viewer.event:full-screen
	     */
	    setFullScreen: function( fullScreen ) {
	        var _this = this;
	
	        if ( !$.supportsFullScreen ) {
	            return this.setFullPage( fullScreen );
	        }
	
	        if ( $.isFullScreen() === fullScreen ) {
	            return this;
	        }
	
	        var fullScreeEventArgs = {
	            fullScreen: fullScreen,
	            preventDefaultAction: false
	        };
	        /**
	         * Raised when the viewer is about to change to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
	         * Note: the pre-full-screen event is not raised when the user is exiting
	         * full-screen mode by pressing the Esc key. In that case, consider using
	         * the full-screen, pre-full-page or full-page events.
	         *
	         * @event pre-full-screen
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullScreen - True if entering full-screen mode, false if exiting full-screen mode.
	         * @property {Boolean} preventDefaultAction - Set to true to prevent full-screen mode change. Default: false.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'pre-full-screen', fullScreeEventArgs );
	        if ( fullScreeEventArgs.preventDefaultAction ) {
	            return this;
	        }
	
	        if ( fullScreen ) {
	
	            this.setFullPage( true );
	            // If the full page mode is not actually entered, we need to prevent
	            // the full screen mode.
	            if ( !this.isFullPage() ) {
	                return this;
	            }
	
	            this.fullPageStyleWidth = this.element.style.width;
	            this.fullPageStyleHeight = this.element.style.height;
	            this.element.style.width = '100%';
	            this.element.style.height = '100%';
	
	            var onFullScreenChange = function() {
	                var isFullScreen = $.isFullScreen();
	                if ( !isFullScreen ) {
	                    $.removeEvent( document, $.fullScreenEventName, onFullScreenChange );
	                    $.removeEvent( document, $.fullScreenErrorEventName, onFullScreenChange );
	
	                    _this.setFullPage( false );
	                    if ( _this.isFullPage() ) {
	                        _this.element.style.width = _this.fullPageStyleWidth;
	                        _this.element.style.height = _this.fullPageStyleHeight;
	                    }
	                }
	                if ( _this.navigator && _this.viewport ) {
	                    _this.navigator.update( _this.viewport );
	                }
	                /**
	                 * Raised when the viewer has changed to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
	                 *
	                 * @event full-screen
	                 * @memberof OpenSeadragon.Viewer
	                 * @type {object}
	                 * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                 * @property {Boolean} fullScreen - True if changed to full-screen mode, false if exited full-screen mode.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( 'full-screen', { fullScreen: isFullScreen } );
	            };
	            $.addEvent( document, $.fullScreenEventName, onFullScreenChange );
	            $.addEvent( document, $.fullScreenErrorEventName, onFullScreenChange );
	
	            $.requestFullScreen( document.body );
	
	        } else {
	            $.exitFullScreen();
	        }
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isVisible: function () {
	        return this.container.style.visibility != "hidden";
	    },
	
	
	    /**
	     * @function
	     * @param {Boolean} visible
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:visible
	     */
	    setVisible: function( visible ){
	        this.container.style.visibility = visible ? "" : "hidden";
	        /**
	         * Raised when the viewer is shown or hidden (see {@link OpenSeadragon.Viewer#setVisible}).
	         *
	         * @event visible
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} visible
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'visible', { visible: visible } );
	        return this;
	    },
	
	    /**
	     * Add a tiled image to the viewer.
	     * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
	     *  supports except arrays of images.
	     * Note that you can specify options.width or options.height, but not both.
	     * The other dimension will be calculated according to the item's aspect ratio.
	     * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
	     * automatically arranged with the others.
	     * @function
	     * @param {Object} options
	     * @param {String|Object|Function} options.tileSource - The TileSource specifier.
	     * A String implies a url used to determine the tileSource implementation
	     *      based on the file extension of url. JSONP is implied by *.js,
	     *      otherwise the url is retrieved as text and the resulting text is
	     *      introspected to determine if its json, xml, or text and parsed.
	     * An Object implies an inline configuration which has a single
	     *      property sufficient for being able to determine tileSource
	     *      implementation. If the object has a property which is a function
	     *      named 'getTileUrl', it is treated as a custom TileSource.
	     * @param {Number} [options.index] The index of the item. Added on top of
	     * all other items if not specified.
	     * @param {Boolean} [options.replace=false] If true, the item at options.index will be
	     * removed and the new item is added in its place. options.tileSource will be
	     * interpreted and fetched if necessary before the old item is removed to avoid leaving
	     * a gap in the world.
	     * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
	     * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
	     * @param {Number} [options.width=1] The width for the image in viewport coordinates.
	     * @param {Number} [options.height] The height for the image in viewport coordinates.
	     * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
	     * (portions of the image outside of this area will not be visible). Only works on
	     * browsers that support the HTML5 canvas.
	     * @param {Number} [options.opacity] Opacity the tiled image should be drawn at by default.
	     * @param {Function} [options.success] A function that gets called when the image is
	     * successfully added. It's passed the event object which contains a single property:
	     * "item", the resulting TiledImage.
	     * @param {Function} [options.error] A function that gets called if the image is
	     * unable to be added. It's passed the error event object, which contains "message"
	     * and "source" properties.
	     * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
	     * specifies whether to snap to the new arrangement immediately or to animate to it.
	     * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
	     * @fires OpenSeadragon.World.event:add-item
	     * @fires OpenSeadragon.Viewer.event:add-item-failed
	     */
	    addTiledImage: function( options ) {
	        $.console.assert(options, "[Viewer.addTiledImage] options is required");
	        $.console.assert(options.tileSource, "[Viewer.addTiledImage] options.tileSource is required");
	        $.console.assert(!options.replace || (options.index > -1 && options.index < this.world.getItemCount()),
	            "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");
	
	        var _this = this;
	
	        if (options.replace) {
	            options.replaceItem = _this.world.getItemAt(options.index);
	        }
	
	        this._hideMessage();
	
	        if (options.placeholderFillStyle === undefined) {
	            options.placeholderFillStyle = this.placeholderFillStyle;
	        }
	        if (options.opacity === undefined) {
	            options.opacity = this.opacity;
	        }
	
	        var myQueueItem = {
	            options: options
	        };
	
	        function raiseAddItemFailed( event ) {
	            for (var i = 0; i < _this._loadQueue.length; i++) {
	                if (_this._loadQueue[i] === myQueueItem) {
	                    _this._loadQueue.splice(i, 1);
	                    break;
	                }
	            }
	
	            if (_this._loadQueue.length === 0) {
	                refreshWorld(myQueueItem);
	            }
	
	             /**
	             * Raised when an error occurs while adding a item.
	             * @event add-item-failed
	             * @memberOf OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {String} message
	             * @property {String} source
	             * @property {Object} options The options passed to the addTiledImage method.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( 'add-item-failed', event );
	
	            if (options.error) {
	                options.error(event);
	            }
	        }
	
	        function refreshWorld(theItem) {
	            if (_this.collectionMode) {
	                _this.world.arrange({
	                    immediately: theItem.options.collectionImmediately,
	                    rows: _this.collectionRows,
	                    columns: _this.collectionColumns,
	                    layout: _this.collectionLayout,
	                    tileSize: _this.collectionTileSize,
	                    tileMargin: _this.collectionTileMargin
	                });
	                _this.world.setAutoRefigureSizes(true);
	            }
	        }
	
	        if ($.isArray(options.tileSource)) {
	            setTimeout(function() {
	                raiseAddItemFailed({
	                    message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
	                    source: options.tileSource,
	                    options: options
	                });
	            });
	            return;
	        }
	
	        this._loadQueue.push(myQueueItem);
	
	        getTileSourceImplementation( this, options.tileSource, function( tileSource ) {
	
	            myQueueItem.tileSource = tileSource;
	
	            // add everybody at the front of the queue that's ready to go
	            var queueItem, tiledImage, optionsClone;
	            while (_this._loadQueue.length) {
	                queueItem = _this._loadQueue[0];
	                if (!queueItem.tileSource) {
	                    break;
	                }
	
	                _this._loadQueue.splice(0, 1);
	
	                if (queueItem.options.replace) {
	                    var newIndex = _this.world.getIndexOfItem(queueItem.options.replaceItem);
	                    if (newIndex != -1) {
	                        queueItem.options.index = newIndex;
	                    }
	                    _this.world.removeItem(queueItem.options.replaceItem);
	                }
	
	                tiledImage = new $.TiledImage({
	                    viewer: _this,
	                    source: queueItem.tileSource,
	                    viewport: _this.viewport,
	                    drawer: _this.drawer,
	                    tileCache: _this.tileCache,
	                    imageLoader: _this.imageLoader,
	                    x: queueItem.options.x,
	                    y: queueItem.options.y,
	                    width: queueItem.options.width,
	                    height: queueItem.options.height,
	                    clip: queueItem.options.clip,
	                    placeholderFillStyle: queueItem.options.placeholderFillStyle,
	                    opacity: queueItem.options.opacity,
	                    springStiffness: _this.springStiffness,
	                    animationTime: _this.animationTime,
	                    minZoomImageRatio: _this.minZoomImageRatio,
	                    wrapHorizontal: _this.wrapHorizontal,
	                    wrapVertical: _this.wrapVertical,
	                    immediateRender: _this.immediateRender,
	                    blendTime: _this.blendTime,
	                    alwaysBlend: _this.alwaysBlend,
	                    minPixelRatio: _this.minPixelRatio,
	                    crossOriginPolicy: _this.crossOriginPolicy,
	                    debugMode: _this.debugMode
	                });
	
	                if (_this.collectionMode) {
	                    _this.world.setAutoRefigureSizes(false);
	                }
	                _this.world.addItem( tiledImage, {
	                    index: queueItem.options.index
	                });
	
	                if (_this._loadQueue.length === 0) {
	                    //this restores the autoRefigureSizes flag to true.
	                    refreshWorld(queueItem);
	                }
	
	                if (_this.world.getItemCount() === 1 && !_this.preserveViewport) {
	                    _this.viewport.goHome(true);
	                }
	
	                if (_this.navigator) {
	                    optionsClone = $.extend({}, queueItem.options, {
	                        originalTiledImage: tiledImage,
	                        tileSource: queueItem.tileSource
	                    });
	
	                    _this.navigator.addTiledImage(optionsClone);
	                }
	
	                if (queueItem.options.success) {
	                    queueItem.options.success({
	                        item: tiledImage
	                    });
	                }
	            }
	        }, function( event ) {
	            event.options = options;
	            raiseAddItemFailed(event);
	        } );
	    },
	
	    // deprecated
	    addLayer: function( options ) {
	        var _this = this;
	
	        $.console.error( "[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead." );
	
	        var optionsClone = $.extend({}, options, {
	            success: function(event) {
	                _this.raiseEvent("add-layer", {
	                    options: options,
	                    drawer: event.item
	                });
	            },
	            error: function(event) {
	                _this.raiseEvent("add-layer-failed", event);
	            }
	        });
	
	        this.addTiledImage(optionsClone);
	        return this;
	    },
	
	    // deprecated
	    getLayerAtLevel: function( level ) {
	        $.console.error( "[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead." );
	        return this.world.getItemAt(level);
	    },
	
	    // deprecated
	    getLevelOfLayer: function( drawer ) {
	        $.console.error( "[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead." );
	        return this.world.getIndexOfItem(drawer);
	    },
	
	    // deprecated
	    getLayersCount: function() {
	        $.console.error( "[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead." );
	        return this.world.getItemCount();
	    },
	
	    // deprecated
	    setLayerLevel: function( drawer, level ) {
	        $.console.error( "[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead." );
	        return this.world.setItemIndex(drawer, level);
	    },
	
	    // deprecated
	    removeLayer: function( drawer ) {
	        $.console.error( "[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead." );
	        return this.world.removeItem(drawer);
	    },
	
	    /**
	     * Force the viewer to redraw its contents.
	     * @returns {OpenSeadragon.Viewer} Chainable.
	     */
	    forceRedraw: function() {
	        THIS[ this.hash ].forceRedraw = true;
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     */
	    bindSequenceControls: function(){
	
	        //////////////////////////////////////////////////////////////////////////
	        // Image Sequence Controls
	        //////////////////////////////////////////////////////////////////////////
	        var onFocusHandler          = $.delegate( this, onFocus ),
	            onBlurHandler           = $.delegate( this, onBlur ),
	            onNextHandler           = $.delegate( this, onNext ),
	            onPreviousHandler       = $.delegate( this, onPrevious ),
	            navImages               = this.navImages,
	            useGroup                = true ;
	
	        if( this.showSequenceControl ){
	
	            if( this.previousButton || this.nextButton ){
	                //if we are binding to custom buttons then layout and
	                //grouping is the responsibility of the page author
	                useGroup = false;
	            }
	
	            this.previousButton = new $.Button({
	                element:    this.previousButton ? $.getElement( this.previousButton ) : null,
	                clickTimeThreshold: this.clickTimeThreshold,
	                clickDistThreshold: this.clickDistThreshold,
	                tooltip:    $.getString( "Tooltips.PreviousPage" ),
	                srcRest:    resolveUrl( this.prefixUrl, navImages.previous.REST ),
	                srcGroup:   resolveUrl( this.prefixUrl, navImages.previous.GROUP ),
	                srcHover:   resolveUrl( this.prefixUrl, navImages.previous.HOVER ),
	                srcDown:    resolveUrl( this.prefixUrl, navImages.previous.DOWN ),
	                onRelease:  onPreviousHandler,
	                onFocus:    onFocusHandler,
	                onBlur:     onBlurHandler
	            });
	
	            this.nextButton = new $.Button({
	                element:    this.nextButton ? $.getElement( this.nextButton ) : null,
	                clickTimeThreshold: this.clickTimeThreshold,
	                clickDistThreshold: this.clickDistThreshold,
	                tooltip:    $.getString( "Tooltips.NextPage" ),
	                srcRest:    resolveUrl( this.prefixUrl, navImages.next.REST ),
	                srcGroup:   resolveUrl( this.prefixUrl, navImages.next.GROUP ),
	                srcHover:   resolveUrl( this.prefixUrl, navImages.next.HOVER ),
	                srcDown:    resolveUrl( this.prefixUrl, navImages.next.DOWN ),
	                onRelease:  onNextHandler,
	                onFocus:    onFocusHandler,
	                onBlur:     onBlurHandler
	            });
	
	            if( !this.navPrevNextWrap ){
	                this.previousButton.disable();
	            }
	
	            if (!this.tileSources || !this.tileSources.length) {
	                this.nextButton.disable();
	            }
	
	            if( useGroup ){
	                this.paging = new $.ButtonGroup({
	                    buttons: [
	                        this.previousButton,
	                        this.nextButton
	                    ],
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold
	                });
	
	                this.pagingControl = this.paging.element;
	
	                if( this.toolbar ){
	                    this.toolbar.addControl(
	                        this.pagingControl,
	                        {anchor: $.ControlAnchor.BOTTOM_RIGHT}
	                    );
	                }else{
	                    this.addControl(
	                        this.pagingControl,
	                        {anchor: this.sequenceControlAnchor || $.ControlAnchor.TOP_LEFT}
	                    );
	                }
	            }
	        }
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     */
	    bindStandardControls: function(){
	        //////////////////////////////////////////////////////////////////////////
	        // Navigation Controls
	        //////////////////////////////////////////////////////////////////////////
	        var beginZoomingInHandler   = $.delegate( this, beginZoomingIn ),
	            endZoomingHandler       = $.delegate( this, endZooming ),
	            doSingleZoomInHandler   = $.delegate( this, doSingleZoomIn ),
	            beginZoomingOutHandler  = $.delegate( this, beginZoomingOut ),
	            doSingleZoomOutHandler  = $.delegate( this, doSingleZoomOut ),
	            onHomeHandler           = $.delegate( this, onHome ),
	            onFullScreenHandler     = $.delegate( this, onFullScreen ),
	            onRotateLeftHandler     = $.delegate( this, onRotateLeft ),
	            onRotateRightHandler    = $.delegate( this, onRotateRight ),
	            onFocusHandler          = $.delegate( this, onFocus ),
	            onBlurHandler           = $.delegate( this, onBlur ),
	            navImages               = this.navImages,
	            buttons                 = [],
	            useGroup                = true ;
	
	
	        if ( this.showNavigationControl ) {
	
	            if( this.zoomInButton || this.zoomOutButton ||
	                this.homeButton || this.fullPageButton ||
	                this.rotateLeftButton || this.rotateRightButton ) {
	                //if we are binding to custom buttons then layout and
	                //grouping is the responsibility of the page author
	                useGroup = false;
	            }
	
	            if ( this.showZoomControl ) {
	                buttons.push( this.zoomInButton = new $.Button({
	                    element:    this.zoomInButton ? $.getElement( this.zoomInButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.ZoomIn" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.zoomIn.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.zoomIn.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.zoomIn.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.zoomIn.DOWN ),
	                    onPress:    beginZoomingInHandler,
	                    onRelease:  endZoomingHandler,
	                    onClick:    doSingleZoomInHandler,
	                    onEnter:    beginZoomingInHandler,
	                    onExit:     endZoomingHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	
	                buttons.push( this.zoomOutButton = new $.Button({
	                    element:    this.zoomOutButton ? $.getElement( this.zoomOutButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.ZoomOut" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.zoomOut.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.zoomOut.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.zoomOut.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.zoomOut.DOWN ),
	                    onPress:    beginZoomingOutHandler,
	                    onRelease:  endZoomingHandler,
	                    onClick:    doSingleZoomOutHandler,
	                    onEnter:    beginZoomingOutHandler,
	                    onExit:     endZoomingHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showHomeControl ) {
	                buttons.push( this.homeButton = new $.Button({
	                    element:    this.homeButton ? $.getElement( this.homeButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.Home" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.home.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.home.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.home.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.home.DOWN ),
	                    onRelease:  onHomeHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showFullPageControl ) {
	                buttons.push( this.fullPageButton = new $.Button({
	                    element:    this.fullPageButton ? $.getElement( this.fullPageButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.FullPage" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.fullpage.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.fullpage.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.fullpage.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.fullpage.DOWN ),
	                    onRelease:  onFullScreenHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showRotationControl ) {
	                buttons.push( this.rotateLeftButton = new $.Button({
	                    element:    this.rotateLeftButton ? $.getElement( this.rotateLeftButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.RotateLeft" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.rotateleft.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.rotateleft.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.rotateleft.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.rotateleft.DOWN ),
	                    onRelease:  onRotateLeftHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	
	                buttons.push( this.rotateRightButton = new $.Button({
	                    element:    this.rotateRightButton ? $.getElement( this.rotateRightButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.RotateRight" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.rotateright.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.rotateright.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.rotateright.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.rotateright.DOWN ),
	                    onRelease:  onRotateRightHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	
	            }
	
	            if ( useGroup ) {
	                this.buttons = new $.ButtonGroup({
	                    buttons:            buttons,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold
	                });
	
	                this.navControl  = this.buttons.element;
	                this.addHandler( 'open', $.delegate( this, lightUp ) );
	
	                if( this.toolbar ){
	                    this.toolbar.addControl(
	                        this.navControl,
	                        {anchor: $.ControlAnchor.TOP_LEFT}
	                    );
	                } else {
	                    this.addControl(
	                        this.navControl,
	                        {anchor: this.navigationControlAnchor || $.ControlAnchor.TOP_LEFT}
	                    );
	                }
	            }
	
	        }
	        return this;
	    },
	
	    /**
	     * Gets the active page of a sequence
	     * @function
	     * @return {Number}
	     */
	    currentPage: function() {
	        return this._sequenceIndex;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:page
	     */
	    goToPage: function( page ){
	        if( this.tileSources && page >= 0 && page < this.tileSources.length ){
	            /**
	             * Raised when the page is changed on a viewer configured with multiple image sources (see {@link OpenSeadragon.Viewer#goToPage}).
	             *
	             * @event page
	             * @memberof OpenSeadragon.Viewer
	             * @type {Object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {Number} page - The page index.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'page', { page: page } );
	
	            this._sequenceIndex = page;
	
	            this._updateSequenceButtons( page );
	
	            this.open( this.tileSources[ page ] );
	
	            if( this.referenceStrip ){
	                this.referenceStrip.setFocus( page );
	            }
	        }
	
	        return this;
	    },
	
	   /**
	     * Adds an html element as an overlay to the current viewport.  Useful for
	     * highlighting words or areas of interest on an image or other zoomable
	     * interface. The overlays added via this method are removed when the viewport
	     * is closed which include when changing page.
	     * @method
	     * @param {Element|String|Object} element - A reference to an element or an id for
	     *      the element which will be overlayed. Or an Object specifying the configuration for the overlay
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
	     *      rectangle which will be overlayed.
	     * @param {OpenSeadragon.OverlayPlacement} placement - The position of the
	     *      viewport which the location coordinates will be treated as relative
	     *      to.
	     * @param {function} onDraw - If supplied the callback is called when the overlay
	     *      needs to be drawn. It it the responsibility of the callback to do any drawing/positioning.
	     *      It is passed position, size and element.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:add-overlay
	     */
	    addOverlay: function( element, location, placement, onDraw ) {
	        var options;
	        if( $.isPlainObject( element ) ){
	            options = element;
	        } else {
	            options = {
	                element: element,
	                location: location,
	                placement: placement,
	                onDraw: onDraw
	            };
	        }
	
	        element = $.getElement( options.element );
	
	        if ( getOverlayIndex( this.currentOverlays, element ) >= 0 ) {
	            // they're trying to add a duplicate overlay
	            return this;
	        }
	
	        var overlay = getOverlayObject( this, options);
	        this.currentOverlays.push(overlay);
	        overlay.drawHTML( this.overlaysContainer, this.viewport );
	
	        /**
	         * Raised when an overlay is added to the viewer (see {@link OpenSeadragon.Viewer#addOverlay}).
	         *
	         * @event add-overlay
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Element} element - The overlay element.
	         * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
	         * @property {OpenSeadragon.OverlayPlacement} placement
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'add-overlay', {
	            element: element,
	            location: options.location,
	            placement: options.placement
	        });
	        return this;
	    },
	
	    /**
	     * Updates the overlay represented by the reference to the element or
	     * element id moving it to the new location, relative to the new placement.
	     * @method
	     * @param {Element|String} element - A reference to an element or an id for
	     *      the element which is overlayed.
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
	     *      rectangle which will be overlayed.
	     * @param {OpenSeadragon.OverlayPlacement} placement - The position of the
	     *      viewport which the location coordinates will be treated as relative
	     *      to.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:update-overlay
	     */
	    updateOverlay: function( element, location, placement ) {
	        var i;
	
	        element = $.getElement( element );
	        i = getOverlayIndex( this.currentOverlays, element );
	
	        if ( i >= 0 ) {
	            this.currentOverlays[ i ].update( location, placement );
	            THIS[ this.hash ].forceRedraw = true;
	            /**
	             * Raised when an overlay's location or placement changes
	             * (see {@link OpenSeadragon.Viewer#updateOverlay}).
	             *
	             * @event update-overlay
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
	             * Viewer which raised the event.
	             * @property {Element} element
	             * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
	             * @property {OpenSeadragon.OverlayPlacement} placement
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'update-overlay', {
	                element: element,
	                location: location,
	                placement: placement
	            });
	        }
	        return this;
	    },
	
	    /**
	     * Removes an overlay identified by the reference element or element id
	     * and schedules an update.
	     * @method
	     * @param {Element|String} element - A reference to the element or an
	     *      element id which represent the ovelay content to be removed.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:remove-overlay
	     */
	    removeOverlay: function( element ) {
	        var i;
	
	        element = $.getElement( element );
	        i = getOverlayIndex( this.currentOverlays, element );
	
	        if ( i >= 0 ) {
	            this.currentOverlays[ i ].destroy();
	            this.currentOverlays.splice( i, 1 );
	            THIS[ this.hash ].forceRedraw = true;
	            /**
	             * Raised when an overlay is removed from the viewer
	             * (see {@link OpenSeadragon.Viewer#removeOverlay}).
	             *
	             * @event remove-overlay
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
	             * Viewer which raised the event.
	             * @property {Element} element - The overlay element.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'remove-overlay', {
	                element: element
	            });
	        }
	        return this;
	    },
	
	    /**
	     * Removes all currently configured Overlays from this Viewer and schedules
	     * an update.
	     * @method
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:clear-overlay
	     */
	    clearOverlays: function() {
	        while ( this.currentOverlays.length > 0 ) {
	            this.currentOverlays.pop().destroy();
	        }
	        THIS[ this.hash ].forceRedraw = true;
	        /**
	         * Raised when all overlays are removed from the viewer (see {@link OpenSeadragon.Drawer#clearOverlays}).
	         *
	         * @event clear-overlay
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'clear-overlay', {} );
	        return this;
	    },
	
	    /**
	     * Updates the sequence buttons.
	     * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
	     * @private
	     * @param {Number} Sequence Value
	     */
	    _updateSequenceButtons: function( page ) {
	
	            if ( this.nextButton ) {
	                if(!this.tileSources || this.tileSources.length - 1 === page) {
	                    //Disable next button
	                    if ( !this.navPrevNextWrap ) {
	                        this.nextButton.disable();
	                    }
	                } else {
	                    this.nextButton.enable();
	                }
	            }
	            if ( this.previousButton ) {
	                if ( page > 0 ) {
	                    //Enable previous button
	                    this.previousButton.enable();
	                } else {
	                    if ( !this.navPrevNextWrap ) {
	                        this.previousButton.disable();
	                    }
	                }
	            }
	      },
	
	    /**
	     * Display a message in the viewport
	     * @function OpenSeadragon.Viewer.prototype._showMessage
	     * @private
	     * @param {String} text message
	     */
	    _showMessage: function ( message ) {
	        this._hideMessage();
	
	        var div = $.makeNeutralElement( "div" );
	        div.appendChild( document.createTextNode( message ) );
	
	        this.messageDiv = $.makeCenteredNode( div );
	
	        $.addClass(this.messageDiv, "openseadragon-message");
	
	        this.container.appendChild( this.messageDiv );
	    },
	
	    /**
	     * Hide any currently displayed viewport message
	     * @function OpenSeadragon.Viewer.prototype._hideMessage
	     * @private
	     */
	    _hideMessage: function () {
	        var div = this.messageDiv;
	        if (div) {
	            div.parentNode.removeChild(div);
	            delete this.messageDiv;
	        }
	    },
	
	    /**
	     * Gets this viewer's gesture settings for the given pointer device type.
	     * @method
	     * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
	     * @return {OpenSeadragon.GestureSettings}
	     */
	    gestureSettingsByDeviceType: function ( type ) {
	        switch ( type ) {
	            case 'mouse':
	                return this.gestureSettingsMouse;
	            case 'touch':
	                return this.gestureSettingsTouch;
	            case 'pen':
	                return this.gestureSettingsPen;
	            default:
	                return this.gestureSettingsUnknown;
	        }
	    },
	
	    // private
	    _drawOverlays: function() {
	        var i,
	            length = this.currentOverlays.length;
	        for ( i = 0; i < length; i++ ) {
	            this.currentOverlays[ i ].drawHTML( this.overlaysContainer, this.viewport );
	        }
	    },
	
	    /**
	     * Cancel the "in flight" images.
	     */
	    _cancelPendingImages: function() {
	        this._loadQueue = [];
	    }
	});
	
	
	/**
	 * _getSafeElemSize is like getElementSize(), but refuses to return 0 for x or y,
	 * which was causing some calling operations to return NaN.
	 * @returns {Point}
	 * @private
	 */
	function _getSafeElemSize (oElement) {
	    oElement = $.getElement( oElement );
	
	    return new $.Point(
	        (oElement.clientWidth === 0 ? 1 : oElement.clientWidth),
	        (oElement.clientHeight === 0 ? 1 : oElement.clientHeight)
	    );
	}
	
	/**
	 * @function
	 * @private
	 */
	function getTileSourceImplementation( viewer, tileSource, successCallback,
	    failCallback ) {
	    var _this = viewer;
	
	    //allow plain xml strings or json strings to be parsed here
	    if ( $.type( tileSource ) == 'string' ) {
	        if ( tileSource.match( /\s*<.*/ ) ) {
	            tileSource = $.parseXml( tileSource );
	        } else if ( tileSource.match( /\s*[\{\[].*/ ) ) {
	            tileSource = $.parseJSON(tileSource);
	        }
	    }
	
	    function waitUntilReady(tileSource, originalTileSource) {
	        if (tileSource.ready) {
	            successCallback(tileSource);
	        } else {
	            tileSource.addHandler('ready', function () {
	                successCallback(tileSource);
	            });
	            tileSource.addHandler('open-failed', function (event) {
	                failCallback({
	                    message: event.message,
	                    source: originalTileSource
	                });
	            });
	        }
	    }
	
	    setTimeout( function() {
	        if ( $.type( tileSource ) == 'string' ) {
	            //If its still a string it means it must be a url at this point
	            tileSource = new $.TileSource({
	                url: tileSource,
	                crossOriginPolicy: viewer.crossOriginPolicy,
	                ajaxWithCredentials: viewer.ajaxWithCredentials,
	                useCanvas: viewer.useCanvas,
	                success: function( event ) {
	                    successCallback( event.tileSource );
	                }
	            });
	            tileSource.addHandler( 'open-failed', function( event ) {
	                failCallback( event );
	            } );
	
	        } else if ($.isPlainObject(tileSource) || tileSource.nodeType) {
	            if (!tileSource.crossOriginPolicy && viewer.crossOriginPolicy) {
	                tileSource.crossOriginPolicy = viewer.crossOriginPolicy;
	            }
	            if (tileSource.ajaxWithCredentials === undefined) {
	                tileSource.ajaxWithCredentials = viewer.ajaxWithCredentials;
	            }
	            if (tileSource.useCanvas === undefined) {
	                tileSource.useCanvas = viewer.useCanvas;
	            }
	
	            if ( $.isFunction( tileSource.getTileUrl ) ) {
	                //Custom tile source
	                var customTileSource = new $.TileSource( tileSource );
	                customTileSource.getTileUrl = tileSource.getTileUrl;
	                successCallback( customTileSource );
	            } else {
	                //inline configuration
	                var $TileSource = $.TileSource.determineType( _this, tileSource );
	                if ( !$TileSource ) {
	                    failCallback( {
	                        message: "Unable to load TileSource",
	                        source: tileSource
	                    });
	                    return;
	                }
	                var options = $TileSource.prototype.configure.apply( _this, [ tileSource ] );
	                waitUntilReady(new $TileSource(options), tileSource);
	            }
	        } else {
	            //can assume it's already a tile source implementation
	            waitUntilReady(tileSource, tileSource);
	        }
	    });
	}
	
	function getOverlayObject( viewer, overlay ) {
	    if ( overlay instanceof $.Overlay ) {
	        return overlay;
	    }
	
	    var element = null;
	    if ( overlay.element ) {
	        element = $.getElement( overlay.element );
	    } else {
	        var id = overlay.id ?
	            overlay.id :
	            "openseadragon-overlay-" + Math.floor( Math.random() * 10000000 );
	
	        element = $.getElement( overlay.id );
	        if ( !element ) {
	            element         = document.createElement( "a" );
	            element.href    = "#/overlay/" + id;
	        }
	        element.id = id;
	        $.addClass( element, overlay.className ?
	            overlay.className :
	            "openseadragon-overlay"
	        );
	    }
	
	    var location = overlay.location;
	    if ( !location ) {
	        if ( overlay.width && overlay.height ) {
	            location = overlay.px !== undefined ?
	                viewer.viewport.imageToViewportRectangle( new $.Rect(
	                    overlay.px,
	                    overlay.py,
	                    overlay.width,
	                    overlay.height
	                ) ) :
	                new $.Rect(
	                    overlay.x,
	                    overlay.y,
	                    overlay.width,
	                    overlay.height
	                );
	        } else {
	            location = overlay.px !== undefined ?
	                viewer.viewport.imageToViewportCoordinates( new $.Point(
	                    overlay.px,
	                    overlay.py
	                ) ) :
	                new $.Point(
	                    overlay.x,
	                    overlay.y
	                );
	        }
	    }
	
	    var placement = overlay.placement;
	    if ( placement && ( $.type( placement ) === "string" ) ) {
	        placement = $.OverlayPlacement[ overlay.placement.toUpperCase() ];
	    }
	
	    return new $.Overlay({
	        element: element,
	        location: location,
	        placement: placement,
	        onDraw: overlay.onDraw,
	        checkResize: overlay.checkResize
	    });
	}
	
	/**
	 * @private
	 * @inner
	 * Determines the index of the given overlay in the given overlays array.
	 */
	function getOverlayIndex( overlays, element ) {
	    var i;
	    for ( i = overlays.length - 1; i >= 0; i-- ) {
	        if ( overlays[ i ].element === element ) {
	            return i;
	        }
	    }
	
	    return -1;
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// Schedulers provide the general engine for animation
	///////////////////////////////////////////////////////////////////////////////
	function scheduleUpdate( viewer, updateFunc ){
	    return $.requestAnimationFrame( function(){
	        updateFunc( viewer );
	    } );
	}
	
	
	//provides a sequence in the fade animation
	function scheduleControlsFade( viewer ) {
	    $.requestAnimationFrame( function(){
	        updateControlsFade( viewer );
	    });
	}
	
	
	//initiates an animation to hide the controls
	function beginControlsAutoHide( viewer ) {
	    if ( !viewer.autoHideControls ) {
	        return;
	    }
	    viewer.controlsShouldFade = true;
	    viewer.controlsFadeBeginTime =
	        $.now() +
	        viewer.controlsFadeDelay;
	
	    window.setTimeout( function(){
	        scheduleControlsFade( viewer );
	    }, viewer.controlsFadeDelay );
	}
	
	
	//determines if fade animation is done or continues the animation
	function updateControlsFade( viewer ) {
	    var currentTime,
	        deltaTime,
	        opacity,
	        i;
	    if ( viewer.controlsShouldFade ) {
	        currentTime = $.now();
	        deltaTime = currentTime - viewer.controlsFadeBeginTime;
	        opacity = 1.0 - deltaTime / viewer.controlsFadeLength;
	
	        opacity = Math.min( 1.0, opacity );
	        opacity = Math.max( 0.0, opacity );
	
	        for ( i = viewer.controls.length - 1; i >= 0; i--) {
	            if (viewer.controls[ i ].autoFade) {
	                viewer.controls[ i ].setOpacity( opacity );
	            }
	        }
	
	        if ( opacity > 0 ) {
	            // fade again
	            scheduleControlsFade( viewer );
	        }
	    }
	}
	
	
	//stop the fade animation on the controls and show them
	function abortControlsAutoHide( viewer ) {
	    var i;
	    viewer.controlsShouldFade = false;
	    for ( i = viewer.controls.length - 1; i >= 0; i-- ) {
	        viewer.controls[ i ].setOpacity( 1.0 );
	    }
	}
	
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Default view event handlers.
	///////////////////////////////////////////////////////////////////////////////
	function onFocus(){
	    abortControlsAutoHide( this );
	}
	
	function onBlur(){
	    beginControlsAutoHide( this );
	
	}
	
	function onCanvasKeyDown( event ) {
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch( event.keyCode ){
	            case 38://up arrow
	                if ( event.shift ) {
	                    this.viewport.zoomBy(1.1);
	                } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, -40)));
	                }
	                this.viewport.applyConstraints();
	                return false;
	            case 40://down arrow
	                if ( event.shift ) {
	                    this.viewport.zoomBy(0.9);
	                } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, 40)));
	                }
	                this.viewport.applyConstraints();
	                return false;
	            case 37://left arrow
	                this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-40, 0)));
	                this.viewport.applyConstraints();
	                return false;
	            case 39://right arrow
	                this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(40, 0)));
	                this.viewport.applyConstraints();
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	function onCanvasKeyPress( event ) {
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch( event.keyCode ){
	            case 43://=|+
	            case 61://=|+
	                this.viewport.zoomBy(1.1);
	                this.viewport.applyConstraints();
	                return false;
	            case 45://-|_
	                this.viewport.zoomBy(0.9);
	                this.viewport.applyConstraints();
	                return false;
	            case 48://0|)
	                this.viewport.goHome();
	                this.viewport.applyConstraints();
	                return false;
	            case 119://w
	            case 87://W
	                if ( event.shift ) {
	                    this.viewport.zoomBy(1.1);
	                } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, -40)));
	                }
	                this.viewport.applyConstraints();
	                return false;
	            case 115://s
	            case 83://S
	                if ( event.shift ) {
	                    this.viewport.zoomBy(0.9);
	                } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, 40)));
	                }
	                this.viewport.applyConstraints();
	                return false;
	            case 97://a
	                this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-40, 0)));
	                this.viewport.applyConstraints();
	                return false;
	            case 100://d
	                this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(40, 0)));
	                this.viewport.applyConstraints();
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	function onCanvasClick( event ) {
	    var gestureSettings;
	
	    var haveKeyboardFocus = document.activeElement == this.canvas;
	
	    // If we don't have keyboard focus, request it.
	    if ( !haveKeyboardFocus ) {
	        this.canvas.focus();
	    }
	
	    if ( !event.preventDefaultAction && this.viewport && event.quick ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.clickToZoom ) {
	            this.viewport.zoomBy(
	                event.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick,
	                this.viewport.pointFromPixel( event.position, true )
	            );
	            this.viewport.applyConstraints();
	        }
	    }
	    /**
	     * Raised when a mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-click
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-click', {
	        tracker: event.eventSource,
	        position: event.position,
	        quick: event.quick,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasDblClick( event ) {
	    var gestureSettings;
	
	    if ( !event.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.dblClickToZoom ) {
	            this.viewport.zoomBy(
	                event.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick,
	                this.viewport.pointFromPixel( event.position, true )
	            );
	            this.viewport.applyConstraints();
	        }
	    }
	    /**
	     * Raised when a double mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-double-click
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-double-click', {
	        tracker: event.eventSource,
	        position: event.position,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasDrag( event ) {
	    var gestureSettings;
	
	    if ( !event.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if( !this.panHorizontal ){
	            event.delta.x = 0;
	        }
	        if( !this.panVertical ){
	            event.delta.y = 0;
	        }
	        this.viewport.panBy( this.viewport.deltaPointsFromPixels( event.delta.negate() ), gestureSettings.flickEnabled );
	        if( this.constrainDuringPan ){
	            this.viewport.applyConstraints();
	        }
	    }
	    /**
	     * Raised when a mouse or touch drag operation occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-drag
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
	     * @property {Number} speed - Current computed speed, in pixels per second.
	     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-drag', {
	        tracker: event.eventSource,
	        position: event.position,
	        delta: event.delta,
	        speed: event.speed,
	        direction: event.direction,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasDragEnd( event ) {
	    var gestureSettings;
	
	    if ( !event.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.flickEnabled && event.speed >= gestureSettings.flickMinSpeed ) {
	            var amplitudeX = gestureSettings.flickMomentum * ( event.speed * Math.cos( event.direction - (Math.PI / 180 * this.viewport.degrees) ) ),
	                amplitudeY = gestureSettings.flickMomentum * ( event.speed * Math.sin( event.direction - (Math.PI / 180 * this.viewport.degrees) ) ),
	                center = this.viewport.pixelFromPoint( this.viewport.getCenter( true ) ),
	                target = this.viewport.pointFromPixel( new $.Point( center.x - amplitudeX, center.y - amplitudeY ) );
	            if( !this.panHorizontal ) {
	                target.x = center.x;
	            }
	            if( !this.panVertical ) {
	                target.y = center.y;
	            }
	            this.viewport.panTo( target, false );
	        }
	        this.viewport.applyConstraints();
	    }
	    /**
	     * Raised when a mouse or touch drag operation ends on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-drag-end
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} speed - Speed at the end of a drag gesture, in pixels per second.
	     * @property {Number} direction - Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-drag-end', {
	        tracker: event.eventSource,
	        position: event.position,
	        speed: event.speed,
	        direction: event.direction,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasEnter( event ) {
	    /**
	     * Raised when a pointer enters the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-enter
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-enter', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasExit( event ) {
	    /**
	     * Raised when a pointer leaves the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-exit
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-exit', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasPress( event ) {
	    /**
	     * Raised when the primary mouse button is pressed or touch starts on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-press
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-press', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        insideElementPressed: event.insideElementPressed,
	        insideElementReleased: event.insideElementReleased,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasRelease( event ) {
	    /**
	     * Raised when the primary mouse button is released or touch ends on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-release
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-release', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        insideElementPressed: event.insideElementPressed,
	        insideElementReleased: event.insideElementReleased,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasNonPrimaryPress( event ) {
	    /**
	     * Raised when any non-primary pointer button is pressed on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-nonprimary-press
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {Number} button - Button which caused the event.
	     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     * @property {Number} buttons - Current buttons pressed.
	     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-nonprimary-press', {
	        tracker: event.eventSource,
	        position: event.position,
	        pointerType: event.pointerType,
	        button: event.button,
	        buttons: event.buttons,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasNonPrimaryRelease( event ) {
	    /**
	     * Raised when any non-primary pointer button is released on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-nonprimary-release
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {Number} button - Button which caused the event.
	     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     * @property {Number} buttons - Current buttons pressed.
	     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-nonprimary-release', {
	        tracker: event.eventSource,
	        position: event.position,
	        pointerType: event.pointerType,
	        button: event.button,
	        buttons: event.buttons,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasPinch( event ) {
	    var gestureSettings,
	        centerPt,
	        lastCenterPt,
	        panByPt;
	
	    if ( !event.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.pinchToZoom ) {
	            centerPt = this.viewport.pointFromPixel( event.center, true );
	            lastCenterPt = this.viewport.pointFromPixel( event.lastCenter, true );
	            panByPt = lastCenterPt.minus( centerPt );
	            if( !this.panHorizontal ) {
	                panByPt.x = 0;
	            }
	            if( !this.panVertical ) {
	                panByPt.y = 0;
	            }
	            this.viewport.zoomBy( event.distance / event.lastDistance, centerPt, true );
	            this.viewport.panBy( panByPt, true );
	            this.viewport.applyConstraints();
	        }
	        if ( gestureSettings.pinchRotate ) {
	            // Pinch rotate
	            var angle1 = Math.atan2(event.gesturePoints[0].currentPos.y - event.gesturePoints[1].currentPos.y,
	                event.gesturePoints[0].currentPos.x - event.gesturePoints[1].currentPos.x);
	            var angle2 = Math.atan2(event.gesturePoints[0].lastPos.y - event.gesturePoints[1].lastPos.y,
	                event.gesturePoints[0].lastPos.x - event.gesturePoints[1].lastPos.x);
	            this.viewport.setRotation(this.viewport.getRotation() + ((angle1 - angle2) * (180 / Math.PI)));
	        }
	    }
	    /**
	     * Raised when a pinch event occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-pinch
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gesturePoints - Gesture points associated with the gesture. Velocity data can be found here.
	     * @property {OpenSeadragon.Point} lastCenter - The previous center point of the two pinch contact points relative to the tracked element.
	     * @property {OpenSeadragon.Point} center - The center point of the two pinch contact points relative to the tracked element.
	     * @property {Number} lastDistance - The previous distance between the two pinch contact points in CSS pixels.
	     * @property {Number} distance - The distance between the two pinch contact points in CSS pixels.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent('canvas-pinch', {
	        tracker: event.eventSource,
	        gesturePoints: event.gesturePoints,
	        lastCenter: event.lastCenter,
	        center: event.center,
	        lastDistance: event.lastDistance,
	        distance: event.distance,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	    //cancels event
	    return false;
	}
	
	function onCanvasScroll( event ) {
	    var gestureSettings,
	        factor,
	        thisScrollTime,
	        deltaScrollTime;
	
	    /* Certain scroll devices fire the scroll event way too fast so we are injecting a simple adjustment to keep things
	     * partially normalized. If we have already fired an event within the last 'minScrollDelta' milliseconds we skip
	     * this one and wait for the next event. */
	    thisScrollTime = $.now();
	    deltaScrollTime = thisScrollTime - this._lastScrollTime;
	    if (deltaScrollTime > this.minScrollDeltaTime) {
	        this._lastScrollTime = thisScrollTime;
	
	        if ( !event.preventDefaultAction && this.viewport ) {
	            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	            if ( gestureSettings.scrollToZoom ) {
	                factor = Math.pow( this.zoomPerScroll, event.scroll );
	                this.viewport.zoomBy(
	                    factor,
	                    this.viewport.pointFromPixel( event.position, true )
	                );
	                this.viewport.applyConstraints();
	            }
	        }
	        /**
	         * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#canvas} element (mouse wheel).
	         *
	         * @event canvas-scroll
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	         * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	         * @property {Number} scroll - The scroll delta for the event.
	         * @property {Boolean} shift - True if the shift key was pressed during this event.
	         * @property {Object} originalEvent - The original DOM event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'canvas-scroll', {
	            tracker: event.eventSource,
	            position: event.position,
	            scroll: event.scroll,
	            shift: event.shift,
	            originalEvent: event.originalEvent
	        });
	        if (gestureSettings && gestureSettings.scrollToZoom) {
	            //cancels event
	            return false;
	        }
	    }
	    else {
	        return false;   // We are swallowing this event
	    }
	}
	
	function onContainerEnter( event ) {
	    THIS[ this.hash ].mouseInside = true;
	    abortControlsAutoHide( this );
	    /**
	     * Raised when the cursor enters the {@link OpenSeadragon.Viewer#container} element.
	     *
	     * @event container-enter
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'container-enter', {
	        tracker: event.eventSource,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onContainerExit( event ) {
	    if ( event.pointers < 1 ) {
	        THIS[ this.hash ].mouseInside = false;
	        if ( !THIS[ this.hash ].animating ) {
	            beginControlsAutoHide( this );
	        }
	    }
	    /**
	     * Raised when the cursor leaves the {@link OpenSeadragon.Viewer#container} element.
	     *
	     * @event container-exit
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'container-exit', {
	        tracker: event.eventSource,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Page update routines ( aka Views - for future reference )
	///////////////////////////////////////////////////////////////////////////////
	
	function updateMulti( viewer ) {
	    updateOnce( viewer );
	
	    // Request the next frame, unless we've been closed
	    if ( viewer.isOpen() ) {
	        viewer._updateRequestId = scheduleUpdate( viewer, updateMulti );
	    } else {
	        viewer._updateRequestId = false;
	    }
	}
	
	function updateOnce( viewer ) {
	
	    //viewer.profiler.beginUpdate();
	
	    if (viewer._opening) {
	        return;
	    }
	
	    var containerSize;
	    if ( viewer.autoResize ) {
	        containerSize = _getSafeElemSize( viewer.container );
	        if ( !containerSize.equals( THIS[ viewer.hash ].prevContainerSize ) ) {
	            if ( viewer.preserveImageSizeOnResize ) {
	                var prevContainerSize = THIS[ viewer.hash ].prevContainerSize;
	                var bounds = viewer.viewport.getBounds(true);
	                var deltaX = (containerSize.x - prevContainerSize.x);
	                var deltaY = (containerSize.y - prevContainerSize.y);
	                var viewportDiff = viewer.viewport.deltaPointsFromPixels(new OpenSeadragon.Point(deltaX, deltaY), true);
	                viewer.viewport.resize(new OpenSeadragon.Point(containerSize.x, containerSize.y), false);
	
	                // Keep the center of the image in the center and just adjust the amount of image shown
	                bounds.width += viewportDiff.x;
	                bounds.height += viewportDiff.y;
	                bounds.x -= (viewportDiff.x / 2);
	                bounds.y -= (viewportDiff.y / 2);
	                viewer.viewport.fitBoundsWithConstraints(bounds, true);
	            }
	            else {
	                // maintain image position
	                var oldBounds = viewer.viewport.getBounds();
	                var oldCenter = viewer.viewport.getCenter();
	                resizeViewportAndRecenter(viewer, containerSize, oldBounds, oldCenter);
	            }
	            THIS[ viewer.hash ].prevContainerSize = containerSize;
	            THIS[ viewer.hash ].forceRedraw = true;
	        }
	    }
	
	    var viewportChange = viewer.viewport.update();
	    var animated = viewer.world.update() || viewportChange;
	
	    if (viewportChange) {
	        /**
	         * Raised when any spring animation update occurs (zoom, pan, etc.),
	         * before the viewer has drawn the new location.
	         *
	         * @event viewport-change
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent('viewport-change');
	    }
	
	    if( viewer.referenceStrip ){
	        animated = viewer.referenceStrip.update( viewer.viewport ) || animated;
	    }
	
	    if ( !THIS[ viewer.hash ].animating && animated ) {
	        /**
	         * Raised when any spring animation starts (zoom, pan, etc.).
	         *
	         * @event animation-start
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent( "animation-start" );
	        abortControlsAutoHide( viewer );
	    }
	
	    if ( animated || THIS[ viewer.hash ].forceRedraw || viewer.world.needsDraw() ) {
	        drawWorld( viewer );
	        viewer._drawOverlays();
	        if( viewer.navigator ){
	            viewer.navigator.update( viewer.viewport );
	        }
	
	        THIS[ viewer.hash ].forceRedraw = false;
	
	        if (animated) {
	            /**
	             * Raised when any spring animation update occurs (zoom, pan, etc.),
	             * after the viewer has drawn the new location.
	             *
	             * @event animation
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            viewer.raiseEvent( "animation" );
	        }
	    }
	
	    if ( THIS[ viewer.hash ].animating && !animated ) {
	        /**
	         * Raised when any spring animation ends (zoom, pan, etc.).
	         *
	         * @event animation-finish
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent( "animation-finish" );
	
	        if ( !THIS[ viewer.hash ].mouseInside ) {
	            beginControlsAutoHide( viewer );
	        }
	    }
	
	    THIS[ viewer.hash ].animating = animated;
	
	    //viewer.profiler.endUpdate();
	}
	
	// This function resizes the viewport and recenters the image
	// as it was before resizing.
	// TODO: better adjust width and height. The new width and height
	// should depend on the image dimensions and on the dimensions
	// of the viewport before and after switching mode.
	function resizeViewportAndRecenter( viewer, containerSize, oldBounds, oldCenter ) {
	    var viewport = viewer.viewport;
	
	    viewport.resize( containerSize, true );
	
	    var newBounds = new $.Rect(
	        oldCenter.x - ( oldBounds.width / 2.0 ),
	        oldCenter.y - ( oldBounds.height / 2.0 ),
	        oldBounds.width,
	        oldBounds.height
	    );
	
	    // let the viewport decide if the bounds are too big or too small
	    viewport.fitBoundsWithConstraints( newBounds, true );
	}
	
	function drawWorld( viewer ) {
	    viewer.imageLoader.clear();
	    viewer.drawer.clear();
	    viewer.world.draw();
	
	    /**
	     * <em>- Needs documentation -</em>
	     *
	     * @event update-viewport
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    viewer.raiseEvent( 'update-viewport', {} );
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// Navigation Controls
	///////////////////////////////////////////////////////////////////////////////
	function resolveUrl( prefix, url ) {
	    return prefix ? prefix + url : url;
	}
	
	
	
	function beginZoomingIn() {
	    THIS[ this.hash ].lastZoomTime = $.now();
	    THIS[ this.hash ].zoomFactor = this.zoomPerSecond;
	    THIS[ this.hash ].zooming = true;
	    scheduleZoom( this );
	}
	
	
	function beginZoomingOut() {
	    THIS[ this.hash ].lastZoomTime = $.now();
	    THIS[ this.hash ].zoomFactor = 1.0 / this.zoomPerSecond;
	    THIS[ this.hash ].zooming = true;
	    scheduleZoom( this );
	}
	
	
	function endZooming() {
	    THIS[ this.hash ].zooming = false;
	}
	
	
	function scheduleZoom( viewer ) {
	    $.requestAnimationFrame( $.delegate( viewer, doZoom ) );
	}
	
	
	function doZoom() {
	    var currentTime,
	        deltaTime,
	        adjustedFactor;
	
	    if ( THIS[ this.hash ].zooming && this.viewport) {
	        currentTime     = $.now();
	        deltaTime       = currentTime - THIS[ this.hash ].lastZoomTime;
	        adjustedFactor  = Math.pow( THIS[ this.hash ].zoomFactor, deltaTime / 1000 );
	
	        this.viewport.zoomBy( adjustedFactor );
	        this.viewport.applyConstraints();
	        THIS[ this.hash ].lastZoomTime = currentTime;
	        scheduleZoom( this );
	    }
	}
	
	
	function doSingleZoomIn() {
	    if ( this.viewport ) {
	        THIS[ this.hash ].zooming = false;
	        this.viewport.zoomBy(
	            this.zoomPerClick / 1.0
	        );
	        this.viewport.applyConstraints();
	    }
	}
	
	
	function doSingleZoomOut() {
	    if ( this.viewport ) {
	        THIS[ this.hash ].zooming = false;
	        this.viewport.zoomBy(
	            1.0 / this.zoomPerClick
	        );
	        this.viewport.applyConstraints();
	    }
	}
	
	
	function lightUp() {
	    this.buttons.emulateEnter();
	    this.buttons.emulateExit();
	}
	
	
	function onHome() {
	    if ( this.viewport ) {
	        this.viewport.goHome();
	    }
	}
	
	
	function onFullScreen() {
	    if ( this.isFullPage() && !$.isFullScreen() ) {
	        // Is fullPage but not fullScreen
	        this.setFullPage( false );
	    } else {
	        this.setFullScreen( !this.isFullPage() );
	    }
	    // correct for no mouseout event on change
	    if ( this.buttons ) {
	        this.buttons.emulateExit();
	    }
	    this.fullPageButton.element.focus();
	    if ( this.viewport ) {
	        this.viewport.applyConstraints();
	    }
	}
	
	/**
	 * Note: The current rotation feature is limited to 90 degree turns.
	 */
	function onRotateLeft() {
	    if ( this.viewport ) {
	        var currRotation = this.viewport.getRotation();
	        if (currRotation === 0) {
	            currRotation = 270;
	        }
	        else {
	            currRotation -= 90;
	        }
	        this.viewport.setRotation(currRotation);
	    }
	}
	
	/**
	 * Note: The current rotation feature is limited to 90 degree turns.
	 */
	function onRotateRight() {
	    if ( this.viewport ) {
	        var currRotation = this.viewport.getRotation();
	        if (currRotation === 270) {
	            currRotation = 0;
	        }
	        else {
	            currRotation += 90;
	        }
	        this.viewport.setRotation(currRotation);
	    }
	}
	
	
	function onPrevious(){
	    var previous = this._sequenceIndex - 1;
	    if(this.navPrevNextWrap && previous < 0){
	        previous += this.tileSources.length;
	    }
	    this.goToPage( previous );
	}
	
	
	function onNext(){
	    var next = this._sequenceIndex + 1;
	    if(this.navPrevNextWrap && next >= this.tileSources.length){
	        next = 0;
	    }
	    this.goToPage( next );
	}
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Navigator
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Navigator
	 * @classdesc The Navigator provides a small view of the current image as fixed
	 * while representing the viewport as a moving box serving as a frame
	 * of reference in the larger viewport as to which portion of the image
	 * is currently being examined.  The navigator's viewport can be interacted
	 * with using the keyboard or the mouse.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.Viewer
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 */
	$.Navigator = function( options ){
	
	    var viewer      = options.viewer,
	        _this = this,
	        viewerSize,
	        navigatorSize;
	
	    //We may need to create a new element and id if they did not
	    //provide the id for the existing element
	    if( !options.id ){
	        options.id              = 'navigator-' + $.now();
	        this.element            = $.makeNeutralElement( "div" );
	        options.controlOptions  = {
	            anchor:           $.ControlAnchor.TOP_RIGHT,
	            attachToViewer:   true,
	            autoFade:         true
	        };
	
	        if( options.position ){
	            if( 'BOTTOM_RIGHT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.BOTTOM_RIGHT;
	            } else if( 'BOTTOM_LEFT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.BOTTOM_LEFT;
	            } else if( 'TOP_RIGHT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.TOP_RIGHT;
	            } else if( 'TOP_LEFT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.TOP_LEFT;
	            } else if( 'ABSOLUTE' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.ABSOLUTE;
	               options.controlOptions.top = options.top;
	               options.controlOptions.left = options.left;
	               options.controlOptions.height = options.height;
	               options.controlOptions.width = options.width;
	            }
	        }
	
	    } else {
	        this.element            = document.getElementById( options.id );
	        options.controlOptions  = {
	            anchor:           $.ControlAnchor.NONE,
	            attachToViewer:   false,
	            autoFade:         false
	        };
	    }
	    this.element.id         = options.id;
	    this.element.className  += ' navigator';
	
	    options = $.extend( true, {
	        sizeRatio:     $.DEFAULT_SETTINGS.navigatorSizeRatio
	    }, options, {
	        element:                this.element,
	        tabIndex:               -1, // No keyboard navigation, omit from tab order
	        //These need to be overridden to prevent recursion since
	        //the navigator is a viewer and a viewer has a navigator
	        showNavigator:          false,
	        mouseNavEnabled:        false,
	        showNavigationControl:  false,
	        showSequenceControl:    false,
	        immediateRender:        true,
	        blendTime:              0,
	        animationTime:          0,
	        autoResize:             options.autoResize,
	        // prevent resizing the navigator from adding unwanted space around the image
	        minZoomImageRatio:      1.0
	    });
	
	    options.minPixelRatio = this.minPixelRatio = viewer.minPixelRatio;
	
	    $.setElementTouchActionNone( this.element );
	
	    this.borderWidth = 2;
	    //At some browser magnification levels the display regions lines up correctly, but at some there appears to
	    //be a one pixel gap.
	    this.fudge = new $.Point(1, 1);
	    this.totalBorderWidths = new $.Point(this.borderWidth*2, this.borderWidth*2).minus(this.fudge);
	
	
	    if ( options.controlOptions.anchor != $.ControlAnchor.NONE ) {
	        (function( style, borderWidth ){
	            style.margin        = '0px';
	            style.border        = borderWidth + 'px solid #555';
	            style.padding       = '0px';
	            style.background    = '#000';
	            style.opacity       = 0.8;
	            style.overflow      = 'hidden';
	        }( this.element.style, this.borderWidth));
	    }
	
	    this.displayRegion           = $.makeNeutralElement( "div" );
	    this.displayRegion.id        = this.element.id + '-displayregion';
	    this.displayRegion.className = 'displayregion';
	
	    (function( style, borderWidth ){
	        style.position      = 'relative';
	        style.top           = '0px';
	        style.left          = '0px';
	        style.fontSize      = '0px';
	        style.overflow      = 'hidden';
	        style.border        = borderWidth + 'px solid #900';
	        style.margin        = '0px';
	        style.padding       = '0px';
	        //TODO: IE doesnt like this property being set
	        //try{ style.outline  = '2px auto #909'; }catch(e){/*ignore*/}
	
	        style.background    = 'transparent';
	
	        // We use square bracket notation on the statement below, because float is a keyword.
	        // This is important for the Google Closure compiler, if nothing else.
	        /*jshint sub:true */
	        style['float']      = 'left'; //Webkit
	
	        style.cssFloat      = 'left'; //Firefox
	        style.styleFloat    = 'left'; //IE
	        style.zIndex        = 999999999;
	        style.cursor        = 'default';
	    }( this.displayRegion.style, this.borderWidth ));
	
	    this.displayRegionContainer = $.makeNeutralElement("div");
	    this.displayRegionContainer.id = this.element.id + '-displayregioncontainer';
	    this.displayRegionContainer.className = "displayregioncontainer";
	    this.displayRegionContainer.style.width = "100%";
	    this.displayRegionContainer.style.height = "100%";
	
	    viewer.addControl(
	        this.element,
	        options.controlOptions
	    );
	
	    this._resizeWithViewer = options.controlOptions.anchor != $.ControlAnchor.ABSOLUTE &&
	        options.controlOptions.anchor != $.ControlAnchor.NONE;
	
	    if ( this._resizeWithViewer ) {
	        if ( options.width && options.height ) {
	            this.element.style.height = typeof ( options.height )  == "number" ? ( options.height + 'px' ) : options.height;
	            this.element.style.width  = typeof ( options.width )  == "number" ? ( options.width + 'px' ) : options.width;
	        } else {
	            viewerSize = $.getElementSize( viewer.element );
	            this.element.style.height = Math.round( viewerSize.y * options.sizeRatio ) + 'px';
	            this.element.style.width  = Math.round( viewerSize.x * options.sizeRatio ) + 'px';
	            this.oldViewerSize = viewerSize;
	        }
	        navigatorSize = $.getElementSize( this.element );
	        this.elementArea = navigatorSize.x * navigatorSize.y;
	    }
	
	    this.oldContainerSize = new $.Point( 0, 0 );
	
	    $.Viewer.apply( this, [ options ] );
	
	    this.displayRegionContainer.appendChild(this.displayRegion);
	    this.element.getElementsByTagName('div')[0].appendChild(this.displayRegionContainer);
	
	    if (options.navigatorRotate) {
	        options.viewer.addHandler("rotate", function (args) {
	            _setTransformRotate(_this.displayRegionContainer, args.degrees);
	            _setTransformRotate(_this.displayRegion, -args.degrees);
	            _this.viewport.setRotation(args.degrees);
	        });
	    }
	
	    // Remove the base class' (Viewer's) innerTracker and replace it with our own
	    this.innerTracker.destroy();
	    this.innerTracker = new $.MouseTracker({
	        element:         this.element,
	        dragHandler:     $.delegate( this, onCanvasDrag ),
	        clickHandler:    $.delegate( this, onCanvasClick ),
	        releaseHandler:  $.delegate( this, onCanvasRelease ),
	        scrollHandler:   $.delegate( this, onCanvasScroll )
	    });
	
	    this.addHandler("reset-size", function() {
	        if (_this.viewport) {
	            _this.viewport.goHome(true);
	        }
	    });
	
	    this.addHandler("reset-size", function() {
	        if (_this.viewport) {
	            _this.viewport.goHome(true);
	        }
	    });
	
	    viewer.world.addHandler("item-index-change", function(event) {
	        var item = _this.world.getItemAt(event.previousIndex);
	        _this.world.setItemIndex(item, event.newIndex);
	    });
	
	    viewer.world.addHandler("remove-item", function(event) {
	        var theirItem = event.item;
	        var myItem = _this._getMatchingItem(theirItem);
	        if (myItem) {
	            _this.world.removeItem(myItem);
	        }
	    });
	
	    this.update(viewer.viewport);
	};
	
	$.extend( $.Navigator.prototype, $.EventSource.prototype, $.Viewer.prototype, /** @lends OpenSeadragon.Navigator.prototype */{
	
	    /**
	     * Used to notify the navigator when its size has changed.
	     * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
	     * @function
	     */
	    updateSize: function () {
	        if ( this.viewport ) {
	            var containerSize = new $.Point(
	                    (this.container.clientWidth === 0 ? 1 : this.container.clientWidth),
	                    (this.container.clientHeight === 0 ? 1 : this.container.clientHeight)
	                );
	
	            if ( !containerSize.equals( this.oldContainerSize ) ) {
	                this.viewport.resize( containerSize, true );
	                this.viewport.goHome(true);
	                this.oldContainerSize = containerSize;
	                this.drawer.clear();
	                this.world.draw();
	            }
	        }
	    },
	
	    /**
	     * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
	     * @function
	     * @param {OpenSeadragon.Viewport} The viewport this navigator is tracking.
	     */
	    update: function( viewport ) {
	
	        var viewerSize,
	            newWidth,
	            newHeight,
	            bounds,
	            topleft,
	            bottomright;
	
	        viewerSize = $.getElementSize( this.viewer.element );
	        if ( this._resizeWithViewer && viewerSize.x && viewerSize.y && !viewerSize.equals( this.oldViewerSize ) ) {
	            this.oldViewerSize = viewerSize;
	
	            if ( this.maintainSizeRatio || !this.elementArea) {
	                newWidth  = viewerSize.x * this.sizeRatio;
	                newHeight = viewerSize.y * this.sizeRatio;
	            } else {
	                newWidth = Math.sqrt(this.elementArea * (viewerSize.x / viewerSize.y));
	                newHeight = this.elementArea / newWidth;
	            }
	
	            this.element.style.width  = Math.round( newWidth ) + 'px';
	            this.element.style.height = Math.round( newHeight ) + 'px';
	
	            if (!this.elementArea) {
	                this.elementArea = newWidth * newHeight;
	            }
	
	            this.updateSize();
	        }
	
	        if( viewport && this.viewport ) {
	            bounds      = viewport.getBounds( true );
	            topleft     = this.viewport.pixelFromPoint( bounds.getTopLeft(), false );
	            bottomright = this.viewport.pixelFromPoint( bounds.getBottomRight(), false )
	                .minus( this.totalBorderWidths );
	
	            //update style for navigator-box
	            var style = this.displayRegion.style;
	            style.display = this.world.getItemCount() ? 'block' : 'none';
	
	            style.top    = Math.round( topleft.y ) + 'px';
	            style.left   = Math.round( topleft.x ) + 'px';
	
	            var width = Math.abs( topleft.x - bottomright.x );
	            var height = Math.abs( topleft.y - bottomright.y );
	            // make sure width and height are non-negative so IE doesn't throw
	            style.width  = Math.round( Math.max( width, 0 ) ) + 'px';
	            style.height = Math.round( Math.max( height, 0 ) ) + 'px';
	        }
	
	    },
	
	    // overrides Viewer.addTiledImage
	    addTiledImage: function(options) {
	        var _this = this;
	
	        var original = options.originalTiledImage;
	        delete options.original;
	
	        var optionsClone = $.extend({}, options, {
	            success: function(event) {
	                var myItem = event.item;
	                myItem._originalForNavigator = original;
	                _this._matchBounds(myItem, original, true);
	
	                original.addHandler('bounds-change', function() {
	                    _this._matchBounds(myItem, original);
	                });
	            }
	        });
	
	        return $.Viewer.prototype.addTiledImage.apply(this, [optionsClone]);
	    },
	
	    // private
	    _getMatchingItem: function(theirItem) {
	        var count = this.world.getItemCount();
	        var item;
	        for (var i = 0; i < count; i++) {
	            item = this.world.getItemAt(i);
	            if (item._originalForNavigator === theirItem) {
	                return item;
	            }
	        }
	
	        return null;
	    },
	
	    // private
	    _matchBounds: function(myItem, theirItem, immediately) {
	        var bounds = theirItem.getBounds();
	        myItem.setPosition(bounds.getTopLeft(), immediately);
	        myItem.setWidth(bounds.width, immediately);
	    }
	});
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasClick( event ) {
	    if ( event.quick && this.viewer.viewport ) {
	        this.viewer.viewport.panTo( this.viewport.pointFromPixel( event.position ).rotate( -this.viewer.viewport.degrees, this.viewer.viewport.getHomeBounds().getCenter() ) );
	        this.viewer.viewport.applyConstraints();
	    }
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasDrag( event ) {
	    if ( this.viewer.viewport ) {
	        if( !this.panHorizontal ){
	            event.delta.x = 0;
	        }
	        if( !this.panVertical ){
	            event.delta.y = 0;
	        }
	        this.viewer.viewport.panBy(
	            this.viewport.deltaPointsFromPixels(
	                event.delta
	            )
	        );
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasRelease( event ) {
	    if ( event.insideElementPressed && this.viewer.viewport ) {
	        this.viewer.viewport.applyConstraints();
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasScroll( event ) {
	    /**
	     * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#navigator} element (mouse wheel, touch pinch, etc.).
	     *
	     * @event navigator-scroll
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} scroll - The scroll delta for the event.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.viewer.raiseEvent( 'navigator-scroll', {
	        tracker: event.eventSource,
	        position: event.position,
	        scroll: event.scroll,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	
	    //dont scroll the page up and down if the user is scrolling
	    //in the navigator
	    return false;
	}
	
	/**
	    * @function
	    * @private
	    * @param {Object} element
	    * @param {Number} degrees
	    */
	function _setTransformRotate (element, degrees) {
	    element.style.webkitTransform = "rotate(" + degrees + "deg)";
	    element.style.mozTransform = "rotate(" + degrees + "deg)";
	    element.style.msTransform = "rotate(" + degrees + "deg)";
	    element.style.oTransform = "rotate(" + degrees + "deg)";
	    element.style.transform = "rotate(" + degrees + "deg)";
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - getString/setString
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	//TODO: I guess this is where the i18n needs to be reimplemented.  I'll look
	//      into existing patterns for i18n in javascript but i think that mimicking
	//      pythons gettext might be a reasonable approach.
	var I18N = {
	    Errors: {
	        Dzc:            "Sorry, we don't support Deep Zoom Collections!",
	        Dzi:            "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
	        Xml:            "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
	        ImageFormat:    "Sorry, we don't support {0}-based Deep Zoom Images.",
	        Security:       "It looks like a security restriction stopped us from " +
	                        "loading this Deep Zoom Image.",
	        Status:         "This space unintentionally left blank ({0} {1}).",
	        OpenFailed:     "Unable to open {0}: {1}"
	    },
	
	    Tooltips: {
	        FullPage:       "Toggle full page",
	        Home:           "Go home",
	        ZoomIn:         "Zoom in",
	        ZoomOut:        "Zoom out",
	        NextPage:       "Next page",
	        PreviousPage:   "Previous page",
	        RotateLeft:     "Rotate left",
	        RotateRight:    "Rotate right"
	    }
	};
	
	$.extend( $, /** @lends OpenSeadragon */{
	
	    /**
	     * @function
	     * @param {String} property
	     */
	    getString: function( prop ) {
	
	        var props   = prop.split('.'),
	            string  = null,
	            args    = arguments,
	            container = I18N,
	            i;
	
	        for ( i = 0; i < props.length-1; i++ ) {
	            // in case not a subproperty
	            container = container[ props[ i ] ] || {};
	        }
	        string = container[ props[ i ] ];
	
	        if ( typeof( string ) != "string" ) {
	            $.console.debug( "Untranslated source string:", prop );
	            string = ""; // FIXME: this breaks gettext()-style convention, which would return source
	        }
	
	        return string.replace(/\{\d+\}/g, function(capture) {
	            var i = parseInt( capture.match( /\d+/ ), 10 ) + 1;
	            return i < args.length ?
	                args[ i ] :
	                "";
	        });
	    },
	
	    /**
	     * @function
	     * @param {String} property
	     * @param {*} value
	     */
	    setString: function( prop, value ) {
	
	        var props     = prop.split('.'),
	            container = I18N,
	            i;
	
	        for ( i = 0; i < props.length - 1; i++ ) {
	            if ( !container[ props[ i ] ] ) {
	                container[ props[ i ] ] = {};
	            }
	            container = container[ props[ i ] ];
	        }
	
	        container[ props[ i ] ] = value;
	    }
	
	});
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Point
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Point
	 * @classdesc A Point is really used as a 2-dimensional vector, equally useful for
	 * representing a point on a plane, or the height and width of a plane
	 * not requiring any other frame of reference.
	 *
	 * @memberof OpenSeadragon
	 * @param {Number} [x] The vector component 'x'. Defaults to the origin at 0.
	 * @param {Number} [y] The vector component 'y'. Defaults to the origin at 0.
	 */
	$.Point = function( x, y ) {
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Point#
	     */
	    this.x = typeof ( x ) == "number" ? x : 0;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Point#
	     */
	    this.y = typeof ( y ) == "number" ? y : 0;
	};
	
	$.Point.prototype = /** @lends OpenSeadragon.Point.prototype */{
	    /**
	     * @function
	     * @returns {OpenSeadragon.Point} a duplicate of this Point
	     */
	    clone: function() {
	        return new $.Point(this.x, this.y);
	    },
	
	    /**
	     * Add another Point to this point and return a new Point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to add vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the sum of the
	     *  vector components
	     */
	    plus: function( point ) {
	        return new $.Point(
	            this.x + point.x,
	            this.y + point.y
	        );
	    },
	
	    /**
	     * Substract another Point to this point and return a new Point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to substract vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the substraction of the
	     *  vector components
	     */
	    minus: function( point ) {
	        return new $.Point(
	            this.x - point.x,
	            this.y - point.y
	        );
	    },
	
	    /**
	     * Multiply this point by a factor and return a new Point.
	     * @function
	     * @param {Number} factor The factor to multiply vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the multiplication
	     *  of the vector components by the factor
	     */
	    times: function( factor ) {
	        return new $.Point(
	            this.x * factor,
	            this.y * factor
	        );
	    },
	
	    /**
	     * Divide this point by a factor and return a new Point.
	     * @function
	     * @param {Number} factor The factor to divide vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the division of the
	     *  vector components by the factor
	     */
	    divide: function( factor ) {
	        return new $.Point(
	            this.x / factor,
	            this.y / factor
	        );
	    },
	
	    /**
	     * Compute the opposite of this point and return a new Point.
	     * @function
	     * @returns {OpenSeadragon.Point} A new point representing the opposite of the
	     *  vector components
	     */
	    negate: function() {
	        return new $.Point( -this.x, -this.y );
	    },
	
	    /**
	     * Compute the distance between this point and another point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to compute the distance with.
	     * @returns {Number} The distance between the 2 points
	     */
	    distanceTo: function( point ) {
	        return Math.sqrt(
	            Math.pow( this.x - point.x, 2 ) +
	            Math.pow( this.y - point.y, 2 )
	        );
	    },
	
	    /**
	     * Apply a function to each coordinate of this point and return a new point.
	     * @function
	     * @param {function} func The function to apply to each coordinate.
	     * @returns {OpenSeadragon.Point} A new point with the coordinates computed
	     * by the specified function
	     */
	    apply: function( func ) {
	        return new $.Point( func( this.x ), func( this.y ) );
	    },
	
	    /**
	     * Check if this point is equal to another one.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to compare this point with.
	     * @returns {Boolean} true if they are equal, false otherwise.
	     */
	    equals: function( point ) {
	        return (
	            point instanceof $.Point
	        ) && (
	            this.x === point.x
	        ) && (
	            this.y === point.y
	        );
	    },
	
	    /**
	     * Rotates the point around the specified pivot
	     * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
	     * @function
	     * @param {Number} degress to rotate around the pivot.
	     * @param {OpenSeadragon.Point} pivot Point about which to rotate.
	     * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
	     */
	    rotate: function ( degrees, pivot ) {
	        var angle = degrees * Math.PI / 180.0,
	            x = Math.cos( angle ) * ( this.x - pivot.x ) - Math.sin( angle ) * ( this.y - pivot.y ) + pivot.x,
	            y = Math.sin( angle ) * ( this.x - pivot.x ) + Math.cos( angle ) * ( this.y - pivot.y ) + pivot.y;
	        return new $.Point( x, y );
	    },
	
	    /**
	     * Convert this point to a string in the format (x,y) where x and y are
	     * rounded to the nearest integer.
	     * @function
	     * @returns {String} A string representation of this point.
	     */
	    toString: function() {
	        return "(" + (Math.round(this.x * 100) / 100) + "," + (Math.round(this.y * 100) / 100) + ")";
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	
	/**
	 * @class TileSource
	 * @classdesc The TileSource contains the most basic implementation required to create a
	 * smooth transition between layers in an image pyramid. It has only a single key
	 * interface that must be implemented to complete its key functionality:
	 * 'getTileUrl'.  It also has several optional interfaces that can be
	 * implemented if a new TileSource wishes to support configuration via a simple
	 * object or array ('configure') and if the tile source supports or requires
	 * configuration via retrieval of a document on the network ala AJAX or JSONP,
	 * ('getImageInfo').
	 * <br/>
	 * By default the image pyramid is split into N layers where the image's longest
	 * side in M (in pixels), where N is the smallest integer which satisfies
	 *      <strong>2^(N+1) >= M</strong>.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 *      You can either specify a URL, or literally define the TileSource (by specifying
	 *      width, height, tileSize, tileOverlap, minLevel, and maxLevel). For the former,
	 *      the extending class is expected to implement 'getImageInfo' and 'configure'.
	 *      For the latter, the construction is assumed to occur through
	 *      the extending classes implementation of 'configure'.
	 * @param {String} [options.url]
	 *      The URL for the data necessary for this TileSource.
	 * @param {Function} [options.success]
	 *      A function to be called upon successful creation.
	 * @param {Boolean} [options.ajaxWithCredentials]
	 *      If this TileSource needs to make an AJAX call, this specifies whether to set
	 *      the XHR's withCredentials (for accessing secure data).
	 * @param {Number} [options.width]
	 *      Width of the source image at max resolution in pixels.
	 * @param {Number} [options.height]
	 *      Height of the source image at max resolution in pixels.
	 * @param {Number} [options.tileSize]
	 *      The size of the tiles to assumed to make up each pyramid layer in pixels.
	 *      Tile size determines the point at which the image pyramid must be
	 *      divided into a matrix of smaller images.
	 *      Use options.tileWidth and options.tileHeight to support non-square tiles.
	 * @param {Number} [options.tileWidth]
	 *      The width of the tiles to assumed to make up each pyramid layer in pixels.
	 * @param {Number} [options.tileHeight]
	 *      The height of the tiles to assumed to make up each pyramid layer in pixels.
	 * @param {Number} [options.tileOverlap]
	 *      The number of pixels each tile is expected to overlap touching tiles.
	 * @param {Number} [options.minLevel]
	 *      The minimum level to attempt to load.
	 * @param {Number} [options.maxLevel]
	 *      The maximum level to attempt to load.
	 */
	$.TileSource = function( width, height, tileSize, tileOverlap, minLevel, maxLevel ) {
	    var _this = this;
	
	    var args = arguments,
	        options,
	        i;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: args[0],
	            height: args[1],
	            tileSize: args[2],
	            tileOverlap: args[3],
	            minLevel: args[4],
	            maxLevel: args[5]
	        };
	    }
	
	    //Tile sources supply some events, namely 'ready' when they must be configured
	    //by asynchronously fetching their configuration data.
	    $.EventSource.call( this );
	
	    //we allow options to override anything we dont treat as
	    //required via idiomatic options or which is functionally
	    //set depending on the state of the readiness of this tile
	    //source
	    $.extend( true, this, options );
	
	    if (!this.success) {
	        //Any functions that are passed as arguments are bound to the ready callback
	        for ( i = 0; i < arguments.length; i++ ) {
	            if ( $.isFunction( arguments[ i ] ) ) {
	                this.success = arguments[ i ];
	                //only one callback per constructor
	                break;
	            }
	        }
	    }
	
	    if (this.success) {
	        this.addHandler( 'ready', function ( event ) {
	            _this.success( event );
	        } );
	    }
	
	    /**
	     * Ratio of width to height
	     * @member {Number} aspectRatio
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * Vector storing x and y dimensions ( width and height respectively ).
	     * @member {OpenSeadragon.Point} dimensions
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The overlap in pixels each tile shares with its adjacent neighbors.
	     * @member {Number} tileOverlap
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The minimum pyramid level this tile source supports or should attempt to load.
	     * @member {Number} minLevel
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The maximum pyramid level this tile source supports or should attempt to load.
	     * @member {Number} maxLevel
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     *
	     * @member {Boolean} ready
	     * @memberof OpenSeadragon.TileSource#
	     */
	
	    if( 'string' == $.type( arguments[ 0 ] ) ){
	        this.url = arguments[0];
	    }
	
	    if (this.url) {
	        //in case the getImageInfo method is overriden and/or implies an
	        //async mechanism set some safe defaults first
	        this.aspectRatio = 1;
	        this.dimensions  = new $.Point( 10, 10 );
	        this._tileWidth  = 0;
	        this._tileHeight = 0;
	        this.tileOverlap = 0;
	        this.minLevel    = 0;
	        this.maxLevel    = 0;
	        this.ready       = false;
	        //configuration via url implies the extending class
	        //implements and 'configure'
	        this.getImageInfo( this.url );
	
	    } else {
	
	        //explicit configuration via positional args in constructor
	        //or the more idiomatic 'options' object
	        this.ready       = true;
	        this.aspectRatio = ( options.width && options.height ) ?
	            (  options.width / options.height ) : 1;
	        this.dimensions  = new $.Point( options.width, options.height );
	        
	        if ( this.tileSize ){
	            this._tileWidth = this._tileHeight = this.tileSize;
	            delete this.tileSize;
	        } else {
	            if( this.tileWidth ){
	                // We were passed tileWidth in options, but we want to rename it
	                // with a leading underscore to make clear that it is not safe to directly modify it
	                this._tileWidth = this.tileWidth;
	                delete this.tileWidth;
	            } else {
	                this._tileWidth = 0;
	            }
	
	            if( this.tileHeight ){
	                // See note above about renaming this.tileWidth
	                this._tileHeight = this.tileHeight;
	                delete this.tileHeight;
	            } else {
	                this._tileHeight = 0;
	            }
	        }
	        
	        this.tileOverlap = options.tileOverlap ? options.tileOverlap : 0;
	        this.minLevel    = options.minLevel ? options.minLevel : 0;
	        this.maxLevel    = ( undefined !== options.maxLevel && null !== options.maxLevel ) ?
	            options.maxLevel : (
	                ( options.width && options.height ) ? Math.ceil(
	                    Math.log( Math.max( options.width, options.height ) ) /
	                    Math.log( 2 )
	                ) : 0
	            );
	        if( this.success && $.isFunction( this.success ) ){
	            this.success( this );
	        }
	    }
	
	
	};
	
	
	$.TileSource.prototype = /** @lends OpenSeadragon.TileSource.prototype */{
	
	    getTileSize: function( level ) {
	        $.console.error(
	            "[TileSource.getTileSize] is deprecated." +
	            "Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"
	        );
	        return this._tileWidth;
	    },
	    
	    /**
	     * Return the tileWidth for a given level.
	     * Subclasses should override this if tileWidth can be different at different levels
	     *   such as in IIIFTileSource.  Code should use this function rather than reading
	     *   from ._tileWidth directly.
	     * @function
	     * @param {Number} level
	     */
	    getTileWidth: function( level ) {
	        if (!this._tileWidth) {
	            return this.getTileSize(level);
	        }
	        return this._tileWidth;
	    },
	
	    /**
	     * Return the tileHeight for a given level.
	     * Subclasses should override this if tileHeight can be different at different levels
	     *   such as in IIIFTileSource.  Code should use this function rather than reading
	     *   from ._tileHeight directly.
	     * @function
	     * @param {Number} level
	     */
	    getTileHeight: function( level ) {
	        if (!this._tileHeight) {
	            return this.getTileSize(level);
	        }
	        return this._tileHeight;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getLevelScale: function( level ) {
	
	        // see https://github.com/openseadragon/openseadragon/issues/22
	        // we use the tilesources implementation of getLevelScale to generate
	        // a memoized re-implementation
	        var levelScaleCache = {},
	            i;
	        for( i = 0; i <= this.maxLevel; i++ ){
	            levelScaleCache[ i ] = 1 / Math.pow(2, this.maxLevel - i);
	        }
	        this.getLevelScale = function( _level ){
	            return levelScaleCache[ _level ];
	        };
	        return this.getLevelScale( level );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getNumTiles: function( level ) {
	        var scale = this.getLevelScale( level ),
	            x = Math.ceil( scale * this.dimensions.x / this.getTileWidth(level) ),
	            y = Math.ceil( scale * this.dimensions.y / this.getTileHeight(level) );
	
	        return new $.Point( x, y );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getPixelRatio: function( level ) {
	        var imageSizeScaled = this.dimensions.times( this.getLevelScale( level ) ),
	            rx = 1.0 / imageSizeScaled.x,
	            ry = 1.0 / imageSizeScaled.y;
	
	        return new $.Point(rx, ry);
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getClosestLevel: function( rect ) {
	        var i,
	            tilesPerSide,
	            tiles;
	
	        for( i = this.minLevel; i < this.maxLevel; i++ ){
	            tiles = this.getNumTiles( i );
	            tilesPerSide = new $.Point(
	              Math.floor( rect.x / this.getTileWidth(i) ),
	              Math.floor( rect.y / this.getTileHeight(i) )
	            );
	            
	            if( tiles.x + 1 >= tilesPerSide.x && tiles.y + 1 >= tilesPerSide.y ){
	                break;
	            }
	        }
	        return Math.max( 0, i - 1 );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {OpenSeadragon.Point} point
	     */
	    getTileAtPoint: function( level, point ) {
	        var pixel = point.times( this.dimensions.x ).times( this.getLevelScale(level) ),
	            tx = Math.floor( pixel.x / this.getTileWidth(level) ),
	            ty = Math.floor( pixel.y / this.getTileHeight(level) );
	
	        return new $.Point( tx, ty );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileBounds: function( level, x, y ) {
	        var dimensionsScaled = this.dimensions.times( this.getLevelScale( level ) ),
	            tileWidth = this.getTileWidth(level),
	            tileHeight = this.getTileHeight(level),
	            px = ( x === 0 ) ? 0 : tileWidth * x - this.tileOverlap,
	            py = ( y === 0 ) ? 0 : tileHeight * y - this.tileOverlap,
	            sx = tileWidth + ( x === 0 ? 1 : 2 ) * this.tileOverlap,
	            sy = tileHeight + ( y === 0 ? 1 : 2 ) * this.tileOverlap,
	            scale = 1.0 / dimensionsScaled.x;
	
	        sx = Math.min( sx, dimensionsScaled.x - px );
	        sy = Math.min( sy, dimensionsScaled.y - py );
	
	        return new $.Rect( px * scale, py * scale, sx * scale, sy * scale );
	    },
	
	
	    /**
	     * Responsible for retrieving, and caching the
	     * image metadata pertinent to this TileSources implementation.
	     * @function
	     * @param {String} url
	     * @throws {Error}
	     */
	    getImageInfo: function( url ) {
	        var _this = this,
	            callbackName,
	            callback,
	            readySource,
	            options,
	            urlParts,
	            filename,
	            lastDot;
	
	
	        if( url ) {
	            urlParts = url.split( '/' );
	            filename = urlParts[ urlParts.length - 1 ];
	            lastDot  = filename.lastIndexOf( '.' );
	            if ( lastDot > -1 ) {
	                urlParts[ urlParts.length - 1 ] = filename.slice( 0, lastDot );
	            }
	        }
	
	        callback = function( data ){
	            if( typeof(data) === "string" ) {
	                data = $.parseXml( data );
	            }
	            var $TileSource = $.TileSource.determineType( _this, data, url );
	            if ( !$TileSource ) {
	                /**
	                 * Raised when an error occurs loading a TileSource.
	                 *
	                 * @event open-failed
	                 * @memberof OpenSeadragon.TileSource
	                 * @type {object}
	                 * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	                 * @property {String} message
	                 * @property {String} source
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( 'open-failed', { message: "Unable to load TileSource", source: url } );
	                return;
	            }
	
	            options = $TileSource.prototype.configure.apply( _this, [ data, url ]);
	            if (options.ajaxWithCredentials === undefined) {
	                options.ajaxWithCredentials = _this.ajaxWithCredentials;
	            }
	
	            readySource = new $TileSource( options );
	            _this.ready = true;
	            /**
	             * Raised when a TileSource is opened and initialized.
	             *
	             * @event ready
	             * @memberof OpenSeadragon.TileSource
	             * @type {object}
	             * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	             * @property {Object} tileSource
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( 'ready', { tileSource: readySource } );
	        };
	
	        if( url.match(/\.js$/) ){
	            //TODO: Its not very flexible to require tile sources to end jsonp
	            //      request for info  with a url that ends with '.js' but for
	            //      now it's the only way I see to distinguish uniformly.
	            callbackName = url.split( '/' ).pop().replace('.js','');
	            $.jsonp({
	                url: url,
	                async: false,
	                callbackName: callbackName,
	                callback: callback
	            });
	        } else {
	            // request info via xhr asynchronously.
	            $.makeAjaxRequest( {
	                url: url,
	                withCredentials: this.ajaxWithCredentials,
	                success: function( xhr ) {
	                    var data = processResponse( xhr );
	                    callback( data );
	                },
	                error: function ( xhr, exc ) {
	                    var msg;
	
	                    /*
	                        IE < 10 will block XHR requests to different origins. Any property access on the request
	                        object will raise an exception which we'll attempt to handle by formatting the original
	                        exception rather than the second one raised when we try to access xhr.status
	                     */
	                    try {
	                        msg = "HTTP " + xhr.status + " attempting to load TileSource";
	                    } catch ( e ) {
	                        var formattedExc;
	                        if ( typeof( exc ) == "undefined" || !exc.toString ) {
	                            formattedExc = "Unknown error";
	                        } else {
	                            formattedExc = exc.toString();
	                        }
	
	                        msg = formattedExc + " attempting to load TileSource";
	                    }
	
	                    /***
	                     * Raised when an error occurs loading a TileSource.
	                     *
	                     * @event open-failed
	                     * @memberof OpenSeadragon.TileSource
	                     * @type {object}
	                     * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	                     * @property {String} message
	                     * @property {String} source
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    _this.raiseEvent( 'open-failed', {
	                        message: msg,
	                        source: url
	                    });
	                }
	            });
	        }
	
	    },
	
	    /**
	     * Responsible determining if a the particular TileSource supports the
	     * data format ( and allowed to apply logic against the url the data was
	     * loaded from, if any ). Overriding implementations are expected to do
	     * something smart with data and / or url to determine support.  Also
	     * understand that iteration order of TileSources is not guarunteed so
	     * please make sure your data or url is expressive enough to ensure a simple
	     * and sufficient mechanisim for clear determination.
	     * @function
	     * @param {String|Object|Array|Document} data
	     * @param {String} url - the url the data was loaded
	     *      from if any.
	     * @return {Boolean}
	     */
	    supports: function( data, url ) {
	        return false;
	    },
	
	    /**
	     * Responsible for parsing and configuring the
	     * image metadata pertinent to this TileSources implementation.
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {String|Object|Array|Document} data
	     * @param {String} url - the url the data was loaded
	     *      from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     * @throws {Error}
	     */
	    configure: function( data, url ) {
	        throw new Error( "Method not implemented." );
	    },
	
	    /**
	     * Responsible for retriving the url which will return an image for the
	     * region speified by the given x, y, and level components.
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function( level, x, y ) {
	        throw new Error( "Method not implemented." );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    tileExists: function( level, x, y ) {
	        var numTiles = this.getNumTiles( level );
	        return  level >= this.minLevel &&
	                level <= this.maxLevel &&
	                x >= 0 &&
	                y >= 0 &&
	                x < numTiles.x &&
	                y < numTiles.y;
	    }
	};
	
	
	$.extend( true, $.TileSource.prototype, $.EventSource.prototype );
	
	
	/**
	 * Decides whether to try to process the response as xml, json, or hand back
	 * the text
	 * @private
	 * @inner
	 * @function
	 * @param {XMLHttpRequest} xhr - the completed network request
	 */
	function processResponse( xhr ){
	    var responseText = xhr.responseText,
	        status       = xhr.status,
	        statusText,
	        data;
	
	    if ( !xhr ) {
	        throw new Error( $.getString( "Errors.Security" ) );
	    } else if ( xhr.status !== 200 && xhr.status !== 0 ) {
	        status     = xhr.status;
	        statusText = ( status == 404 ) ?
	            "Not Found" :
	            xhr.statusText;
	        throw new Error( $.getString( "Errors.Status", status, statusText ) );
	    }
	
	    if( responseText.match(/\s*<.*/) ){
	        try{
	        data = ( xhr.responseXML && xhr.responseXML.documentElement ) ?
	            xhr.responseXML :
	            $.parseXml( responseText );
	        } catch (e){
	            data = xhr.responseText;
	        }
	    }else if( responseText.match(/\s*[\{\[].*/) ){
	        data = $.parseJSON(responseText);
	    }else{
	        data = responseText;
	    }
	    return data;
	}
	
	
	/**
	 * Determines the TileSource Implementation by introspection of OpenSeadragon
	 * namespace, calling each TileSource implementation of 'isType'
	 * @private
	 * @inner
	 * @function
	 * @param {Object|Array|Document} data - the tile source configuration object
	 * @param {String} url - the url where the tile source configuration object was
	 *      loaded from, if any.
	 */
	$.TileSource.determineType = function( tileSource, data, url ){
	    var property;
	    for( property in OpenSeadragon ){
	        if( property.match(/.+TileSource$/) &&
	            $.isFunction( OpenSeadragon[ property ] ) &&
	            $.isFunction( OpenSeadragon[ property ].prototype.supports ) &&
	            OpenSeadragon[ property ].prototype.supports.call( tileSource, data, url )
	        ){
	            return OpenSeadragon[ property ];
	        }
	    }
	
	    $.console.error( "No TileSource was able to open %s %s", url, data );
	};
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - DziTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class DziTileSource
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 * @param {String} fileFormat
	 * @param {OpenSeadragon.DisplayRect[]} displayRects
	 * @property {String} tilesUrl
	 * @property {String} fileFormat
	 * @property {OpenSeadragon.DisplayRect[]} displayRects
	 */
	$.DziTileSource = function( width, height, tileSize, tileOverlap, tilesUrl, fileFormat, displayRects, minLevel, maxLevel ) {
	    var i,
	        rect,
	        level,
	        options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[ 0 ],
	            height: arguments[ 1 ],
	            tileSize: arguments[ 2 ],
	            tileOverlap: arguments[ 3 ],
	            tilesUrl: arguments[ 4 ],
	            fileFormat: arguments[ 5 ],
	            displayRects: arguments[ 6 ],
	            minLevel: arguments[ 7 ],
	            maxLevel: arguments[ 8 ]
	        };
	    }
	
	    this._levelRects  = {};
	    this.tilesUrl     = options.tilesUrl;
	    this.fileFormat   = options.fileFormat;
	    this.displayRects = options.displayRects;
	
	    if ( this.displayRects ) {
	        for ( i = this.displayRects.length - 1; i >= 0; i-- ) {
	            rect = this.displayRects[ i ];
	            for ( level = rect.minLevel; level <= rect.maxLevel; level++ ) {
	                if ( !this._levelRects[ level ] ) {
	                    this._levelRects[ level ] = [];
	                }
	                this._levelRects[ level ].push( rect );
	            }
	        }
	    }
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.DziTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.DziTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        var ns;
	        if ( data.Image ) {
	            ns = data.Image.xmlns;
	        } else if ( data.documentElement) {
	            if ("Image" == data.documentElement.localName || "Image" == data.documentElement.tagName) {
	                ns = data.documentElement.namespaceURI;
	            }
	        }
	
	        return ( "http://schemas.microsoft.com/deepzoom/2008" == ns ||
	            "http://schemas.microsoft.com/deepzoom/2009" == ns );
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object|XMLDocument} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	
	        var options;
	
	        if( !$.isPlainObject(data) ){
	
	            options = configureFromXML( this, data );
	
	        }else{
	
	            options = configureFromObject( this, data );
	        }
	
	        if (url && !options.tilesUrl) {
	            options.tilesUrl = url.replace(/([^\/]+)\.(dzi|xml|js)(\?.*|$)/, '$1_files/');
	
	            if (url.search(/\.(dzi|xml|js)\?/) != -1) {
	                options.queryParams = url.match(/\?.*/);
	            }else{
	                options.queryParams = '';
	            }
	        }
	
	        return options;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        return [ this.tilesUrl, level, '/', x, '_', y, '.', this.fileFormat, this.queryParams ].join( '' );
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    tileExists: function( level, x, y ) {
	        var rects = this._levelRects[ level ],
	            rect,
	            scale,
	            xMin,
	            yMin,
	            xMax,
	            yMax,
	            i;
	
	        if ( !rects || !rects.length ) {
	            return true;
	        }
	
	        for ( i = rects.length - 1; i >= 0; i-- ) {
	            rect = rects[ i ];
	
	            if ( level < rect.minLevel || level > rect.maxLevel ) {
	                continue;
	            }
	
	            scale = this.getLevelScale( level );
	            xMin = rect.x * scale;
	            yMin = rect.y * scale;
	            xMax = xMin + rect.width * scale;
	            yMax = yMin + rect.height * scale;
	
	            xMin = Math.floor( xMin / this.tileSize );
	            yMin = Math.floor( yMin / this.tileSize );
	            xMax = Math.ceil( xMax / this.tileSize );
	            yMax = Math.ceil( yMax / this.tileSize );
	
	            if ( xMin <= x && x < xMax && yMin <= y && y < yMax ) {
	                return true;
	            }
	        }
	
	        return false;
	    }
	});
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromXML( tileSource, xmlDoc ){
	
	    if ( !xmlDoc || !xmlDoc.documentElement ) {
	        throw new Error( $.getString( "Errors.Xml" ) );
	    }
	
	    var root           = xmlDoc.documentElement,
	        rootName       = root.localName || root.tagName,
	        ns             = xmlDoc.documentElement.namespaceURI,
	        configuration  = null,
	        displayRects   = [],
	        dispRectNodes,
	        dispRectNode,
	        rectNode,
	        sizeNode,
	        i;
	
	    if ( rootName == "Image" ) {
	
	        try {
	            sizeNode = root.getElementsByTagName("Size" )[ 0 ];
	            if (sizeNode === undefined) {
	                sizeNode = root.getElementsByTagNameNS(ns, "Size" )[ 0 ];
	            }
	
	            configuration = {
	                Image: {
	                    xmlns:       "http://schemas.microsoft.com/deepzoom/2008",
	                    Url:         root.getAttribute( "Url" ),
	                    Format:      root.getAttribute( "Format" ),
	                    DisplayRect: null,
	                    Overlap:     parseInt( root.getAttribute( "Overlap" ), 10 ),
	                    TileSize:    parseInt( root.getAttribute( "TileSize" ), 10 ),
	                    Size: {
	                        Height: parseInt( sizeNode.getAttribute( "Height" ), 10 ),
	                        Width:  parseInt( sizeNode.getAttribute( "Width" ), 10 )
	                    }
	                }
	            };
	
	            if ( !$.imageFormatSupported( configuration.Image.Format ) ) {
	                throw new Error(
	                    $.getString( "Errors.ImageFormat", configuration.Image.Format.toUpperCase() )
	                );
	            }
	
	            dispRectNodes = root.getElementsByTagName("DisplayRect" );
	            if (dispRectNodes === undefined) {
	                dispRectNodes = root.getElementsByTagNameNS(ns, "DisplayRect" )[ 0 ];
	            }
	
	            for ( i = 0; i < dispRectNodes.length; i++ ) {
	                dispRectNode = dispRectNodes[ i ];
	                rectNode     = dispRectNode.getElementsByTagName("Rect" )[ 0 ];
	                if (rectNode === undefined) {
	                    rectNode = dispRectNode.getElementsByTagNameNS(ns, "Rect" )[ 0 ];
	                }
	
	                displayRects.push({
	                    Rect: {
	                        X: parseInt( rectNode.getAttribute( "X" ), 10 ),
	                        Y: parseInt( rectNode.getAttribute( "Y" ), 10 ),
	                        Width: parseInt( rectNode.getAttribute( "Width" ), 10 ),
	                        Height: parseInt( rectNode.getAttribute( "Height" ), 10 ),
	                        MinLevel: parseInt( dispRectNode.getAttribute( "MinLevel" ), 10 ),
	                        MaxLevel: parseInt( dispRectNode.getAttribute( "MaxLevel" ), 10 )
	                    }
	                });
	            }
	
	            if( displayRects.length ){
	                configuration.Image.DisplayRect = displayRects;
	            }
	
	            return configureFromObject( tileSource, configuration );
	
	        } catch ( e ) {
	            throw (e instanceof Error) ?
	                e :
	                new Error( $.getString("Errors.Dzi") );
	        }
	    } else if ( rootName == "Collection" ) {
	        throw new Error( $.getString( "Errors.Dzc" ) );
	    } else if ( rootName == "Error" ) {
	        return $._processDZIError( root );
	    }
	
	    throw new Error( $.getString( "Errors.Dzi" ) );
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromObject( tileSource, configuration ){
	    var imageData     = configuration.Image,
	        tilesUrl      = imageData.Url,
	        fileFormat    = imageData.Format,
	        sizeData      = imageData.Size,
	        dispRectData  = imageData.DisplayRect || [],
	        width         = parseInt( sizeData.Width, 10 ),
	        height        = parseInt( sizeData.Height, 10 ),
	        tileSize      = parseInt( imageData.TileSize, 10 ),
	        tileOverlap   = parseInt( imageData.Overlap, 10 ),
	        displayRects  = [],
	        rectData,
	        i;
	
	    //TODO: need to figure out out to better handle image format compatibility
	    //      which actually includes additional file formats like xml and pdf
	    //      and plain text for various tilesource implementations to avoid low
	    //      level errors.
	    //
	    //      For now, just don't perform the check.
	    //
	    /*if ( !imageFormatSupported( fileFormat ) ) {
	        throw new Error(
	            $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
	        );
	    }*/
	
	    for ( i = 0; i < dispRectData.length; i++ ) {
	        rectData = dispRectData[ i ].Rect;
	
	        displayRects.push( new $.DisplayRect(
	            parseInt( rectData.X, 10 ),
	            parseInt( rectData.Y, 10 ),
	            parseInt( rectData.Width, 10 ),
	            parseInt( rectData.Height, 10 ),
	            parseInt( rectData.MinLevel, 10 ),
	            parseInt( rectData.MaxLevel, 10 )
	        ));
	    }
	
	    return $.extend(true, {
	        width: width, /* width *required */
	        height: height, /* height *required */
	        tileSize: tileSize, /* tileSize *required */
	        tileOverlap: tileOverlap, /* tileOverlap *required */
	        minLevel: null, /* minLevel */
	        maxLevel: null, /* maxLevel */
	        tilesUrl: tilesUrl, /* tilesUrl */
	        fileFormat: fileFormat, /* fileFormat */
	        displayRects: displayRects /* displayRects */
	    }, configuration );
	
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - IIIFTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class IIIFTileSource
	 * @classdesc A client implementation of the International Image Interoperability
	 * Format: Image API 1.0 - 2.0
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @see http://iiif.io/api/image/
	 */
	$.IIIFTileSource = function( options ){
	
	
	    $.extend( true, this, options );
	
	    if ( !( this.height && this.width && this['@id'] ) ) {
	        throw new Error( 'IIIF required parameters not provided.' );
	    }
	
	    options.tileSizePerScaleFactor = {};
	
	    // N.B. 2.0 renamed scale_factors to scaleFactors
	    if ( this.tile_width && this.tile_height ) {
	        options.tileWidth = this.tile_width;
	        options.tileHeight = this.tile_height;
	    } else if ( this.tile_width ) {
	        options.tileSize = this.tile_width;
	    } else if ( this.tile_height ) {
	        options.tileSize = this.tile_height;
	    } else if ( this.tiles ) {
	        // Version 2.0 forwards
	        if ( this.tiles.length == 1 ) {
	            options.tileWidth  = this.tiles[0].width;
	            // Use height if provided, otherwise assume square tiles and use width.
	            options.tileHeight = this.tiles[0].height || this.tiles[0].width;
	            this.scale_factors = this.tiles[0].scaleFactors;
	        } else {
	            // Multiple tile sizes at different levels
	            this.scale_factors = [];
	            for (var t = 0; t < this.tiles.length; t++ ) {
	                for (var sf = 0; sf < this.tiles[t].scaleFactors.length; sf++) {
	                    var scaleFactor = this.tiles[t].scaleFactors[sf];
	                    this.scale_factors.push(scaleFactor);
	                    options.tileSizePerScaleFactor[scaleFactor] = {
	                        width: this.tiles[t].width,
	                        height: this.tiles[t].height || this.tiles[t].width
	                    };
	                }
	            }
	        }
	    } else {
	        // use the largest of tileOptions that is smaller than the short dimension
	        var shortDim = Math.min( this.height, this.width ),
	            tileOptions = [256,512,1024],
	            smallerTiles = [];
	
	        for ( var c = 0; c < tileOptions.length; c++ ) {
	            if ( tileOptions[c] <= shortDim ) {
	                smallerTiles.push( tileOptions[c] );
	            }
	        }
	
	        if ( smallerTiles.length > 0 ) {
	            options.tileSize = Math.max.apply( null, smallerTiles );
	        } else {
	            // If we're smaller than 256, just use the short side.
	            options.tileSize = shortDim;
	        }
	    }
	
	    if ( !options.maxLevel ) {
	        if ( !this.scale_factors ) {
	            options.maxLevel = Number( Math.ceil( Math.log( Math.max( this.width, this.height ), 2 ) ) );
	        } else {
	            options.maxLevel = Math.floor( Math.pow( Math.max.apply(null, this.scale_factors), 0.5) );
	        }
	    }
	
	    $.TileSource.apply( this, [ options ] );
	};
	
	$.extend( $.IIIFTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.IIIFTileSource.prototype */{
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	     
	    supports: function( data, url ) {
	        // Version 2.0 and forwards
	        if (data.protocol && data.protocol == 'http://iiif.io/api/image') {
	            return true;
	        // Version 1.1
	        } else if ( data['@context'] && (
	            data['@context'] == "http://library.stanford.edu/iiif/image-api/1.1/context.json" ||
	            data['@context'] == "http://iiif.io/api/image/1/context.json") ) {
	            // N.B. the iiif.io context is wrong, but where the representation lives so likely to be used
	            return true;
	
	        // Version 1.0
	        } else if ( data.profile &&
	            data.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") === 0) {
	            return true;
	        } else if ( data.identifier && data.width && data.height ) {
	            return true;
	        } else if ( data.documentElement &&
	            "info" == data.documentElement.tagName &&
	            "http://library.stanford.edu/iiif/image-api/ns/" ==
	                data.documentElement.namespaceURI) {
	            return true;
	
	        // Not IIIF
	        } else {
	            return false;
	        }
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @example <caption>IIIF 1.1 Info Looks like this</caption>
	     * {
	     *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
	     *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
	     *   "width" : 6000,
	     *   "height" : 4000,
	     *   "scale_factors" : [ 1, 2, 4 ],
	     *   "tile_width" : 1024,
	     *   "tile_height" : 1024,
	     *   "formats" : [ "jpg", "png" ],
	     *   "qualities" : [ "native", "grey" ],
	     *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
	     * }
	     */
	    configure: function( data, url ){
	        // Try to deduce our version and fake it upwards if needed
	        if ( !$.isPlainObject(data) ) {
	            var options = configureFromXml10( data );
	            options['@context'] = "http://iiif.io/api/image/1.0/context.json";
	            options['@id'] = url.replace('/info.xml', '');
	            return options;
	        } else if ( !data['@context'] ) {
	            data['@context'] = 'http://iiif.io/api/image/1.0/context.json';
	            data['@id'] = url.replace('/info.json', '');
	            return data;
	        } else {
	            return data;
	        }
	    },
	
	    /**
	     * Return the tileWidth for the given level.
	     * @function
	     * @param {Number} level
	     */
	    getTileWidth: function( level ) {
	        var scaleFactor = Math.pow(2, this.maxLevel - level);
	
	        if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor]) {
	            return this.tileSizePerScaleFactor[scaleFactor].width;
	        }
	        return this._tileWidth;
	    },
	
	    /**
	     * Return the tileHeight for the given level.
	     * @function
	     * @param {Number} level
	     */
	    getTileHeight: function( level ) {
	        var scaleFactor = Math.pow(2, this.maxLevel - level);
	
	        if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor]) {
	            return this.tileSizePerScaleFactor[scaleFactor].height;
	        }
	        return this._tileHeight;
	    },
	
	
	    /**
	     * Responsible for retreiving the url which will return an image for the
	     * region specified by the given x, y, and level components.
	     * @function
	     * @param {Number} level - z index
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function( level, x, y ){
	
	        //# constants
	        var IIIF_ROTATION = '0',
	            //## get the scale (level as a decimal)
	            scale = Math.pow( 0.5, this.maxLevel - level ),
	
	            //# image dimensions at this level
	            levelWidth = Math.ceil( this.width * scale ),
	            levelHeight = Math.ceil( this.height * scale ),
	
	            //## iiif region
	            tileWidth,
	            tileHeight,
	            iiifTileSizeWidth,
	            iiifTileSizeHeight,
	            iiifRegion,
	            iiifTileX,
	            iiifTileY,
	            iiifTileW,
	            iiifTileH,
	            iiifSize,
	            iiifQuality,
	            uri;
	
	        tileWidth = this.getTileWidth(level);
	        tileHeight = this.getTileHeight(level);
	        iiifTileSizeWidth = Math.ceil( tileWidth / scale );
	        iiifTileSizeHeight = Math.ceil( tileHeight / scale );
	
	        if ( this['@context'].indexOf('/1.0/context.json') > -1 ||
	             this['@context'].indexOf('/1.1/context.json') > -1 ||
	             this['@context'].indexOf('/1/context.json') > -1 ) {
	            iiifQuality = "native.jpg";
	        } else {
	            iiifQuality = "default.jpg";
	        }
	
	        if ( levelWidth < tileWidth && levelHeight < tileHeight ){
	            iiifSize = levelWidth + ",";
	            iiifRegion = 'full';
	        } else {
	            iiifTileX = x * iiifTileSizeWidth;
	            iiifTileY = y * iiifTileSizeHeight;
	            iiifTileW = Math.min( iiifTileSizeWidth, this.width - iiifTileX );
	            iiifTileH = Math.min( iiifTileSizeHeight, this.height - iiifTileY );
	            iiifSize = Math.ceil( iiifTileW * scale ) + ",";
	            iiifRegion = [ iiifTileX, iiifTileY, iiifTileW, iiifTileH ].join( ',' );
	        }
	        uri = [ this['@id'], iiifRegion, iiifSize, IIIF_ROTATION, iiifQuality ].join( '/' );
	
	        return uri;
	    }
	
	  });
	
	
	    function configureFromXml10(xmlDoc) {
	        //parse the xml
	        if ( !xmlDoc || !xmlDoc.documentElement ) {
	            throw new Error( $.getString( "Errors.Xml" ) );
	        }
	
	        var root            = xmlDoc.documentElement,
	            rootName        = root.tagName,
	            configuration   = null;
	
	        if ( rootName == "info" ) {
	            try {
	                configuration = {};
	                parseXML10( root, configuration );
	                return configuration;
	
	            } catch ( e ) {
	                throw (e instanceof Error) ?
	                    e :
	                    new Error( $.getString("Errors.IIIF") );
	            }
	        }
	        throw new Error( $.getString( "Errors.IIIF" ) );
	    }
	
	    function parseXML10( node, configuration, property ) {
	        var i,
	            value;
	        if ( node.nodeType == 3 && property ) {//text node
	            value = node.nodeValue.trim();
	            if( value.match(/^\d*$/)){
	                value = Number( value );
	            }
	            if( !configuration[ property ] ){
	                configuration[ property ] = value;
	            }else{
	                if( !$.isArray( configuration[ property ] ) ){
	                    configuration[ property ] = [ configuration[ property ] ];
	                }
	                configuration[ property ].push( value );
	            }
	        } else if( node.nodeType == 1 ){
	            for( i = 0; i < node.childNodes.length; i++ ){
	                parseXML10( node.childNodes[ i ], configuration, node.nodeName );
	            }
	        }
	    }
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - OsmTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Derived from the OSM tile source in Rainer Simon's seajax-utils project
	 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
	 * the included code to the OpenSeadragon project under the New BSD license;
	 * see <https://github.com/openseadragon/openseadragon/issues/58>.
	 */
	
	
	(function( $ ){
	
	/**
	 * @class OsmTileSource
	 * @classdesc A tilesource implementation for OpenStreetMap.<br><br>
	 *
	 * Note 1. Zoomlevels. Deep Zoom and OSM define zoom levels differently. In  Deep
	 * Zoom, level 0 equals an image of 1x1 pixels. In OSM, level 0 equals an image of
	 * 256x256 levels (see http://gasi.ch/blog/inside-deep-zoom-2). I.e. there is a
	 * difference of log2(256)=8 levels.<br><br>
	 *
	 * Note 2. Image dimension. According to the OSM Wiki
	 * (http://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Zoom_levels)
	 * the highest Mapnik zoom level has 256.144x256.144 tiles, with a 256x256
	 * pixel size. I.e. the Deep Zoom image dimension is 65.572.864x65.572.864
	 * pixels.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 */
	$.OsmTileSource = function( width, height, tileSize, tileOverlap, tilesUrl ) {
	    var options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[0],
	            height: arguments[1],
	            tileSize: arguments[2],
	            tileOverlap: arguments[3],
	            tilesUrl: arguments[4]
	        };
	    }
	    //apply default setting for standard public OpenStreatMaps service
	    //but allow them to be specified so fliks can host there own instance
	    //or apply against other services supportting the same standard
	    if( !options.width || !options.height ){
	        options.width = 65572864;
	        options.height = 65572864;
	    }
	    if( !options.tileSize ){
	        options.tileSize = 256;
	        options.tileOverlap = 0;
	    }
	    if( !options.tilesUrl ){
	        options.tilesUrl = "http://tile.openstreetmap.org/";
	    }
	    options.minLevel = 8;
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.OsmTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.OsmTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return (
	            data.type &&
	            "openstreetmaps" == data.type
	        );
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	        return data;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        return this.tilesUrl + (level - 8) + "/" + x + "/" + y + ".png";
	    }
	});
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TmsTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Derived from the TMS tile source in Rainer Simon's seajax-utils project
	 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
	 * the included code to the OpenSeadragon project under the New BSD license;
	 * see <https://github.com/openseadragon/openseadragon/issues/58>.
	 */
	
	
	(function( $ ){
	
	/**
	 * @class TmsTileSource
	 * @classdesc A tilesource implementation for Tiled Map Services (TMS).
	 * TMS tile scheme ( [ as supported by OpenLayers ] is described here
	 * ( http://openlayers.org/dev/examples/tms.html ).
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 */
	$.TmsTileSource = function( width, height, tileSize, tileOverlap, tilesUrl ) {
	    var options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[0],
	            height: arguments[1],
	            tileSize: arguments[2],
	            tileOverlap: arguments[3],
	            tilesUrl: arguments[4]
	        };
	    }
	    // TMS has integer multiples of 256 for width/height and adds buffer
	    // if necessary -> account for this!
	    var bufferedWidth = Math.ceil(options.width / 256) * 256,
	        bufferedHeight = Math.ceil(options.height / 256) * 256,
	        max;
	
	    // Compute number of zoomlevels in this tileset
	    if (bufferedWidth > bufferedHeight) {
	        max = bufferedWidth / 256;
	    } else {
	        max = bufferedHeight / 256;
	    }
	    options.maxLevel = Math.ceil(Math.log(max)/Math.log(2)) - 1;
	    options.tileSize = 256;
	    options.width = bufferedWidth;
	    options.height = bufferedHeight;
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.TmsTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.TmsTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return ( data.type && "tiledmapservice" == data.type );
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	        return data;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        // Convert from Deep Zoom definition to TMS zoom definition
	        var yTiles = this.getNumTiles( level ).y - 1;
	
	        return this.tilesUrl + level + "/" + x + "/" +  (yTiles - y) + ".png";
	    }
	});
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - LegacyTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class LegacyTileSource
	 * @classdesc The LegacyTileSource allows simple, traditional image pyramids to be loaded
	 * into an OpenSeadragon Viewer.  Basically, this translates to the historically
	 * common practice of starting with a 'master' image, maybe a tiff for example,
	 * and generating a set of 'service' images like one or more thumbnails, a medium
	 * resolution image and a high resolution image in standard web formats like
	 * png or jpg.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Array} levels An array of file descriptions, each is an object with
	 *      a 'url', a 'width', and a 'height'.  Overriding classes can expect more
	 *      properties but these properties are sufficient for this implementation.
	 *      Additionally, the levels are required to be listed in order from
	 *      smallest to largest.
	 * @property {Number} aspectRatio
	 * @property {Number} dimensions
	 * @property {Number} tileSize
	 * @property {Number} tileOverlap
	 * @property {Number} minLevel
	 * @property {Number} maxLevel
	 * @property {Array}  levels
	 */
	$.LegacyTileSource = function( levels ) {
	
	    var options,
	        width,
	        height;
	
	    if( $.isArray( levels ) ){
	        options = {
	            type: 'legacy-image-pyramid',
	            levels: levels
	        };
	    }
	
	    //clean up the levels to make sure we support all formats
	    options.levels = filterFiles( options.levels );
	
	    if ( options.levels.length > 0 ) {
	        width = options.levels[ options.levels.length - 1 ].width;
	        height = options.levels[ options.levels.length - 1 ].height;
	    }
	    else {
	        width = 0;
	        height = 0;
	        $.console.error( "No supported image formats found" );
	    }
	
	    $.extend( true, options, {
	        width: width,
	        height: height,
	        tileSize: Math.max( height, width ),
	        tileOverlap: 0,
	        minLevel: 0,
	        maxLevel: options.levels.length > 0 ? options.levels.length - 1 : 0
	    } );
	
	    $.TileSource.apply( this, [ options ] );
	
	    this.levels = options.levels;
	};
	
	$.extend( $.LegacyTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.LegacyTileSource.prototype */{
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return (
	            data.type &&
	            "legacy-image-pyramid" == data.type
	        ) || (
	            data.documentElement &&
	            "legacy-image-pyramid" == data.documentElement.getAttribute('type')
	        );
	    },
	
	
	    /**
	     *
	     * @function
	     * @param {Object|XMLDocument} configuration - the raw configuration
	     * @param {String} dataUrl - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( configuration, dataUrl ){
	
	        var options;
	
	        if( !$.isPlainObject(configuration) ){
	
	            options = configureFromXML( this, configuration );
	
	        }else{
	
	            options = configureFromObject( this, configuration );
	        }
	
	        return options;
	
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getLevelScale: function ( level ) {
	        var levelScale = NaN;
	        if ( this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel ) {
	            levelScale =
	                this.levels[ level ].width /
	                this.levels[ this.maxLevel ].width;
	        }
	        return levelScale;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getNumTiles: function( level ) {
	        var scale = this.getLevelScale( level );
	        if ( scale ){
	            return new $.Point( 1, 1 );
	        } else {
	            return new $.Point( 0, 0 );
	        }
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {OpenSeadragon.Point} point
	     */
	    getTileAtPoint: function( level, point ) {
	        return new $.Point( 0, 0 );
	    },
	
	
	    /**
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function ( level, x, y ) {
	        var url = null;
	        if ( this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel ) {
	            url = this.levels[ level ].url;
	        }
	        return url;
	    }
	} );
	
	/**
	 * This method removes any files from the Array which dont conform to our
	 * basic requirements for a 'level' in the LegacyTileSource.
	 * @private
	 * @inner
	 * @function
	 */
	function filterFiles( files ){
	    var filtered = [],
	        file,
	        i;
	    for( i = 0; i < files.length; i++ ){
	        file = files[ i ];
	        if( file.height &&
	            file.width &&
	            file.url && (
	                file.url.toLowerCase().match(/^.*\.(png|jpg|jpeg|gif)$/) || (
	                    file.mimetype &&
	                    file.mimetype.toLowerCase().match(/^.*\/(png|jpg|jpeg|gif)$/)
	                )
	            ) ){
	            //This is sufficient to serve as a level
	            filtered.push({
	                url: file.url,
	                width: Number( file.width ),
	                height: Number( file.height )
	            });
	        }
	        else {
	            $.console.error( 'Unsupported image format: %s', file.url ? file.url : '<no URL>' );
	        }
	    }
	
	    return filtered.sort(function(a,b){
	        return a.height - b.height;
	    });
	
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromXML( tileSource, xmlDoc ){
	
	    if ( !xmlDoc || !xmlDoc.documentElement ) {
	        throw new Error( $.getString( "Errors.Xml" ) );
	    }
	
	    var root         = xmlDoc.documentElement,
	        rootName     = root.tagName,
	        conf         = null,
	        levels       = [],
	        level,
	        i;
	
	    if ( rootName == "image" ) {
	
	        try {
	            conf = {
	                type:        root.getAttribute( "type" ),
	                levels:      []
	            };
	
	            levels = root.getElementsByTagName( "level" );
	            for ( i = 0; i < levels.length; i++ ) {
	                level = levels[ i ];
	
	                conf.levels .push({
	                    url:    level.getAttribute( "url" ),
	                    width:  parseInt( level.getAttribute( "width" ), 10 ),
	                    height: parseInt( level.getAttribute( "height" ), 10 )
	                });
	            }
	
	            return configureFromObject( tileSource, conf );
	
	        } catch ( e ) {
	            throw (e instanceof Error) ?
	                e :
	                new Error( 'Unknown error parsing Legacy Image Pyramid XML.' );
	        }
	    } else if ( rootName == "collection" ) {
	        throw new Error( 'Legacy Image Pyramid Collections not yet supported.' );
	    } else if ( rootName == "error" ) {
	        throw new Error( 'Error: ' + xmlDoc );
	    }
	
	    throw new Error( 'Unknown element ' + rootName );
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromObject( tileSource, configuration ){
	
	    return configuration.levels;
	
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ImageTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ($) {
	
	    /**
	     * @class ImageTileSource
	     * @classdesc The ImageTileSource allows a simple image to be loaded
	     * into an OpenSeadragon Viewer.
	     * There are 2 ways to open an ImageTileSource:
	     * 1. viewer.open({type: 'image', url: fooUrl});
	     * 2. viewer.open(new OpenSeadragon.ImageTileSource({url: fooUrl}));
	     *
	     * With the first syntax, the crossOriginPolicy, ajaxWithCredentials and
	     * useCanvas options are inherited from the viewer if they are not
	     * specified directly in the options object.
	     *
	     * @memberof OpenSeadragon
	     * @extends OpenSeadragon.TileSource
	     * @param {Object} options Options object.
	     * @param {String} options.url URL of the image
	     * @param {Boolean} [options.buildPyramid=true] If set to true (default), a
	     * pyramid will be built internally to provide a better downsampling.
	     * @param {String|Boolean} [options.crossOriginPolicy=false] Valid values are
	     * 'Anonymous', 'use-credentials', and false. If false, image requests will
	     * not use CORS preventing internal pyramid building for images from other
	     * domains.
	     * @param {String|Boolean} [options.ajaxWithCredentials=false] Whether to set
	     * the withCredentials XHR flag for AJAX requests (when loading tile sources).
	     * @param {Boolean} [options.useCanvas=true] Set to false to prevent any use
	     * of the canvas API.
	     */
	    $.ImageTileSource = function (options) {
	
	        options = $.extend({
	            buildPyramid: true,
	            crossOriginPolicy: false,
	            ajaxWithCredentials: false,
	            useCanvas: true
	        }, options);
	        $.TileSource.apply(this, [options]);
	
	    };
	
	    $.extend($.ImageTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.ImageTileSource.prototype */{
	        /**
	         * Determine if the data and/or url imply the image service is supported by
	         * this tile source.
	         * @function
	         * @param {Object|Array} data
	         * @param {String} optional - url
	         */
	        supports: function (data, url) {
	            return data.type && data.type === "image";
	        },
	        /**
	         *
	         * @function
	         * @param {Object} options - the options
	         * @param {String} dataUrl - the url the image was retreived from, if any.
	         * @return {Object} options - A dictionary of keyword arguments sufficient
	         *      to configure this tile sources constructor.
	         */
	        configure: function (options, dataUrl) {
	            return options;
	        },
	        /**
	         * Responsible for retrieving, and caching the
	         * image metadata pertinent to this TileSources implementation.
	         * @function
	         * @param {String} url
	         * @throws {Error}
	         */
	        getImageInfo: function (url) {
	            var image = this._image = new Image();
	            var _this = this;
	
	            if (this.crossOriginPolicy) {
	                image.crossOrigin = this.crossOriginPolicy;
	            }
	            if (this.ajaxWithCredentials) {
	                image.useCredentials = this.ajaxWithCredentials;
	            }
	
	            $.addEvent(image, 'load', function () {
	                _this.width = image.naturalWidth;
	                _this.height = image.naturalHeight;
	                _this.aspectRatio = _this.width / _this.height;
	                _this.dimensions = new $.Point(_this.width, _this.height);
	                _this._tileWidth = _this.width;
	                _this._tileHeight = _this.height;
	                _this.tileOverlap = 0;
	                _this.minLevel = 0;
	                _this.levels = _this._buildLevels();
	                _this.maxLevel = _this.levels.length - 1;
	
	                _this.ready = true;
	                /**
	                 * Raised when a TileSource is opened and initialized.
	                 *
	                 * @event ready
	                 * @memberof OpenSeadragon.TileSource
	                 * @type {object}
	                 * @property {OpenSeadragon.TileSource} eventSource - A reference
	                 * to the TileSource which raised the event.
	                 * @property {Object} tileSource
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent('ready', {tileSource: _this});
	            });
	
	            $.addEvent(image, 'error', function () {
	                /***
	                 * Raised when an error occurs loading a TileSource.
	                 *
	                 * @event open-failed
	                 * @memberof OpenSeadragon.TileSource
	                 * @type {object}
	                 * @property {OpenSeadragon.TileSource} eventSource - A reference
	                 * to the TileSource which raised the event.
	                 * @property {String} message
	                 * @property {String} source
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent('open-failed', {
	                    message: "Error loading image at " + url,
	                    source: url
	                });
	            });
	
	            image.src = url;
	        },
	        /**
	         * @function
	         * @param {Number} level
	         */
	        getLevelScale: function (level) {
	            var levelScale = NaN;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                levelScale =
	                        this.levels[level].width /
	                        this.levels[this.maxLevel].width;
	            }
	            return levelScale;
	        },
	        /**
	         * @function
	         * @param {Number} level
	         */
	        getNumTiles: function (level) {
	            var scale = this.getLevelScale(level);
	            if (scale) {
	                return new $.Point(1, 1);
	            } else {
	                return new $.Point(0, 0);
	            }
	        },
	        /**
	         * @function
	         * @param {Number} level
	         * @param {OpenSeadragon.Point} point
	         */
	        getTileAtPoint: function (level, point) {
	            return new $.Point(0, 0);
	        },
	        /**
	         * Retrieves a tile url
	         * @function
	         * @param {Number} level Level of the tile
	         * @param {Number} x x coordinate of the tile
	         * @param {Number} y y coordinate of the tile
	         */
	        getTileUrl: function (level, x, y) {
	            var url = null;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                url = this.levels[level].url;
	            }
	            return url;
	        },
	        /**
	         * Retrieves a tile context 2D
	         * @function
	         * @param {Number} level Level of the tile
	         * @param {Number} x x coordinate of the tile
	         * @param {Number} y y coordinate of the tile
	         */
	        getContext2D: function (level, x, y) {
	            var context = null;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                context = this.levels[level].context2D;
	            }
	            return context;
	        },
	        /**
	         * @private Build the differents levels of the pyramid if possible
	         * (canvas API enabled and no canvas tainting issue)
	         */
	        _buildLevels: function () {
	            var levels = [{
	                    url: this._image.src,
	                    width: this._image.naturalWidth,
	                    height: this._image.naturalHeight
	                }];
	
	            if (!this.buildPyramid || !$.supportsCanvas || !this.useCanvas) {
	                // We don't need the image anymore. Allows it to be GC.
	                delete this._image;
	                return levels;
	            }
	
	            var currentWidth = this._image.naturalWidth;
	            var currentHeight = this._image.naturalHeight;
	
	            var bigCanvas = document.createElement("canvas");
	            var bigContext = bigCanvas.getContext("2d");
	
	            bigCanvas.width = currentWidth;
	            bigCanvas.height = currentHeight;
	            bigContext.drawImage(this._image, 0, 0, currentWidth, currentHeight);
	            // We cache the context of the highest level because the browser
	            // is a lot faster at downsampling something it already has
	            // downsampled before.
	            levels[0].context2D = bigContext;
	            // We don't need the image anymore. Allows it to be GC.
	            delete this._image;
	
	            if ($.isCanvasTainted(bigCanvas)) {
	                // If the canvas is tainted, we can't compute the pyramid.
	                return levels;
	            }
	
	            // We build smaller levels until either width or height becomes
	            // 1 pixel wide.
	            while (currentWidth >= 2 && currentHeight >= 2) {
	                currentWidth = Math.floor(currentWidth / 2);
	                currentHeight = Math.floor(currentHeight / 2);
	                var smallCanvas = document.createElement("canvas");
	                var smallContext = smallCanvas.getContext("2d");
	                smallCanvas.width = currentWidth;
	                smallCanvas.height = currentHeight;
	                smallContext.drawImage(bigCanvas, 0, 0, currentWidth, currentHeight);
	
	                levels.splice(0, 0, {
	                    context2D: smallContext,
	                    width: currentWidth,
	                    height: currentHeight
	                });
	
	                bigCanvas = smallCanvas;
	                bigContext = smallContext;
	            }
	            return levels;
	        }
	    });
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - TileSourceCollection
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// deprecated
	$.TileSourceCollection = function( tileSize, tileSources, rows, layout  ) {
	    $.console.error('TileSourceCollection is deprecated; use World instead');
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Button
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * An enumeration of button states
	 * @member ButtonState
	 * @memberof OpenSeadragon
	 * @static
	 * @type {Object}
	 * @property {Number} REST
	 * @property {Number} GROUP
	 * @property {Number} HOVER
	 * @property {Number} DOWN
	 */
	$.ButtonState = {
	    REST:   0,
	    GROUP:  1,
	    HOVER:  2,
	    DOWN:   3
	};
	
	/**
	 * @class Button
	 * @classdesc Manages events, hover states for individual buttons, tool-tips, as well
	 * as fading the buttons out when the user has not interacted with them
	 * for a specified period.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 * @param {Element} [options.element=null] Element to use as the button. If not specified, an HTML &lt;button&gt; element is created.
	 * @param {String} [options.tooltip=null] Provides context help for the button when the
	 *  user hovers over it.
	 * @param {String} [options.srcRest=null] URL of image to use in 'rest' state.
	 * @param {String} [options.srcGroup=null] URL of image to use in 'up' state.
	 * @param {String} [options.srcHover=null] URL of image to use in 'hover' state.
	 * @param {String} [options.srcDown=null] URL of image to use in 'down' state.
	 * @param {Number} [options.fadeDelay=0] How long to wait before fading.
	 * @param {Number} [options.fadeLength=2000] How long should it take to fade the button.
	 * @param {OpenSeadragon.EventHandler} [options.onPress=null] Event handler callback for {@link OpenSeadragon.Button.event:press}.
	 * @param {OpenSeadragon.EventHandler} [options.onRelease=null] Event handler callback for {@link OpenSeadragon.Button.event:release}.
	 * @param {OpenSeadragon.EventHandler} [options.onClick=null] Event handler callback for {@link OpenSeadragon.Button.event:click}.
	 * @param {OpenSeadragon.EventHandler} [options.onEnter=null] Event handler callback for {@link OpenSeadragon.Button.event:enter}.
	 * @param {OpenSeadragon.EventHandler} [options.onExit=null] Event handler callback for {@link OpenSeadragon.Button.event:exit}.
	 * @param {OpenSeadragon.EventHandler} [options.onFocus=null] Event handler callback for {@link OpenSeadragon.Button.event:focus}.
	 * @param {OpenSeadragon.EventHandler} [options.onBlur=null] Event handler callback for {@link OpenSeadragon.Button.event:blur}.
	 */
	$.Button = function( options ) {
	
	    var _this = this;
	
	    $.EventSource.call( this );
	
	    $.extend( true, this, {
	
	        tooltip:            null,
	        srcRest:            null,
	        srcGroup:           null,
	        srcHover:           null,
	        srcDown:            null,
	        clickTimeThreshold: $.DEFAULT_SETTINGS.clickTimeThreshold,
	        clickDistThreshold: $.DEFAULT_SETTINGS.clickDistThreshold,
	        /**
	         * How long to wait before fading.
	         * @member {Number} fadeDelay
	         * @memberof OpenSeadragon.Button#
	         */
	        fadeDelay:          0,
	        /**
	         * How long should it take to fade the button.
	         * @member {Number} fadeLength
	         * @memberof OpenSeadragon.Button#
	         */
	        fadeLength:         2000,
	        onPress:            null,
	        onRelease:          null,
	        onClick:            null,
	        onEnter:            null,
	        onExit:             null,
	        onFocus:            null,
	        onBlur:             null
	
	    }, options );
	
	    /**
	     * The button element.
	     * @member {Element} element
	     * @memberof OpenSeadragon.Button#
	     */
	    this.element        = options.element   || $.makeNeutralElement( "div" );
	
	    //if the user has specified the element to bind the control to explicitly
	    //then do not add the default control images
	    if ( !options.element ) {
	        this.imgRest      = $.makeTransparentImage( this.srcRest );
	        this.imgGroup     = $.makeTransparentImage( this.srcGroup );
	        this.imgHover     = $.makeTransparentImage( this.srcHover );
	        this.imgDown      = $.makeTransparentImage( this.srcDown );
	
	        this.imgRest.alt  =
	        this.imgGroup.alt =
	        this.imgHover.alt =
	        this.imgDown.alt  =
	            this.tooltip;
	
	        this.element.style.position = "relative";
	        $.setElementTouchActionNone( this.element );
	
	        this.imgGroup.style.position =
	        this.imgHover.style.position =
	        this.imgDown.style.position  =
	            "absolute";
	
	        this.imgGroup.style.top =
	        this.imgHover.style.top =
	        this.imgDown.style.top  =
	            "0px";
	
	        this.imgGroup.style.left =
	        this.imgHover.style.left =
	        this.imgDown.style.left  =
	            "0px";
	
	        this.imgHover.style.visibility =
	        this.imgDown.style.visibility  =
	            "hidden";
	
	        if ( $.Browser.vendor == $.BROWSERS.FIREFOX  && $.Browser.version < 3 ){
	            this.imgGroup.style.top =
	            this.imgHover.style.top =
	            this.imgDown.style.top  =
	                "";
	        }
	
	        this.element.appendChild( this.imgRest );
	        this.element.appendChild( this.imgGroup );
	        this.element.appendChild( this.imgHover );
	        this.element.appendChild( this.imgDown );
	    }
	
	
	    this.addHandler( "press",     this.onPress );
	    this.addHandler( "release",   this.onRelease );
	    this.addHandler( "click",     this.onClick );
	    this.addHandler( "enter",     this.onEnter );
	    this.addHandler( "exit",      this.onExit );
	    this.addHandler( "focus",     this.onFocus );
	    this.addHandler( "blur",      this.onBlur );
	
	    /**
	     * The button's current state.
	     * @member {OpenSeadragon.ButtonState} currentState
	     * @memberof OpenSeadragon.Button#
	     */
	    this.currentState = $.ButtonState.GROUP;
	
	    // When the button last began to fade.
	    this.fadeBeginTime  = null;
	    // Whether this button should fade after user stops interacting with the viewport.
	    this.shouldFade     = false;
	
	    this.element.style.display  = "inline-block";
	    this.element.style.position = "relative";
	    this.element.title          = this.tooltip;
	
	    /**
	     * Tracks mouse/touch/key events on the button.
	     * @member {OpenSeadragon.MouseTracker} tracker
	     * @memberof OpenSeadragon.Button#
	     */
	    this.tracker = new $.MouseTracker({
	
	        element:            this.element,
	        clickTimeThreshold: this.clickTimeThreshold,
	        clickDistThreshold: this.clickDistThreshold,
	
	        enterHandler: function( event ) {
	            if ( event.insideElementPressed ) {
	                inTo( _this, $.ButtonState.DOWN );
	                /**
	                 * Raised when the cursor enters the Button element.
	                 *
	                 * @event enter
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "enter", { originalEvent: event.originalEvent } );
	            } else if ( !event.buttonDownAny ) {
	                inTo( _this, $.ButtonState.HOVER );
	            }
	        },
	
	        focusHandler: function ( event ) {
	            this.enterHandler( event );
	            /**
	             * Raised when the Button element receives focus.
	             *
	             * @event focus
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "focus", { originalEvent: event.originalEvent } );
	        },
	
	        exitHandler: function( event ) {
	            outTo( _this, $.ButtonState.GROUP );
	            if ( event.insideElementPressed ) {
	                /**
	                 * Raised when the cursor leaves the Button element.
	                 *
	                 * @event exit
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "exit", { originalEvent: event.originalEvent } );
	            }
	        },
	
	        blurHandler: function ( event ) {
	            this.exitHandler( event );
	            /**
	             * Raised when the Button element loses focus.
	             *
	             * @event blur
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "blur", { originalEvent: event.originalEvent } );
	        },
	
	        pressHandler: function ( event ) {
	            inTo( _this, $.ButtonState.DOWN );
	            /**
	             * Raised when a mouse button is pressed or touch occurs in the Button element.
	             *
	             * @event press
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "press", { originalEvent: event.originalEvent } );
	        },
	
	        releaseHandler: function( event ) {
	            if ( event.insideElementPressed && event.insideElementReleased ) {
	                outTo( _this, $.ButtonState.HOVER );
	                /**
	                 * Raised when the mouse button is released or touch ends in the Button element.
	                 *
	                 * @event release
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "release", { originalEvent: event.originalEvent } );
	            } else if ( event.insideElementPressed ) {
	                outTo( _this, $.ButtonState.GROUP );
	            } else {
	                inTo( _this, $.ButtonState.HOVER );
	            }
	        },
	
	        clickHandler: function( event ) {
	            if ( event.quick ) {
	                /**
	                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
	                 *
	                 * @event click
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent("click", { originalEvent: event.originalEvent });
	            }
	        },
	
	        keyHandler: function( event ){
	            //console.log( "%s : handling key %s!", _this.tooltip, event.keyCode);
	            if( 13 === event.keyCode ){
	                /***
	                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
	                 *
	                 * @event click
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "click", { originalEvent: event.originalEvent } );
	                /***
	                 * Raised when the mouse button is released or touch ends in the Button element.
	                 *
	                 * @event release
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "release", { originalEvent: event.originalEvent } );
	                return false;
	            }
	            return true;
	        }
	
	    });
	
	    outTo( this, $.ButtonState.REST );
	};
	
	$.extend( $.Button.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.Button.prototype */{
	
	    /**
	     * TODO: Determine what this function is intended to do and if it's actually
	     * useful as an API point.
	     * @function
	     */
	    notifyGroupEnter: function() {
	        inTo( this, $.ButtonState.GROUP );
	    },
	
	    /**
	     * TODO: Determine what this function is intended to do and if it's actually
	     * useful as an API point.
	     * @function
	     */
	    notifyGroupExit: function() {
	        outTo( this, $.ButtonState.REST );
	    },
	
	    /**
	     * @function
	     */
	    disable: function(){
	        this.notifyGroupExit();
	        this.element.disabled = true;
	        $.setElementOpacity( this.element, 0.2, true );
	    },
	
	    /**
	     * @function
	     */
	    enable: function(){
	        this.element.disabled = false;
	        $.setElementOpacity( this.element, 1.0, true );
	        this.notifyGroupEnter();
	    }
	
	});
	
	
	function scheduleFade( button ) {
	    $.requestAnimationFrame(function(){
	        updateFade( button );
	    });
	}
	
	function updateFade( button ) {
	    var currentTime,
	        deltaTime,
	        opacity;
	
	    if ( button.shouldFade ) {
	        currentTime = $.now();
	        deltaTime   = currentTime - button.fadeBeginTime;
	        opacity     = 1.0 - deltaTime / button.fadeLength;
	        opacity     = Math.min( 1.0, opacity );
	        opacity     = Math.max( 0.0, opacity );
	
	        if( button.imgGroup ){
	            $.setElementOpacity( button.imgGroup, opacity, true );
	        }
	        if ( opacity > 0 ) {
	            // fade again
	            scheduleFade( button );
	        }
	    }
	}
	
	function beginFading( button ) {
	    button.shouldFade = true;
	    button.fadeBeginTime = $.now() + button.fadeDelay;
	    window.setTimeout( function(){
	        scheduleFade( button );
	    }, button.fadeDelay );
	}
	
	function stopFading( button ) {
	    button.shouldFade = false;
	    if( button.imgGroup ){
	        $.setElementOpacity( button.imgGroup, 1.0, true );
	    }
	}
	
	function inTo( button, newState ) {
	
	    if( button.element.disabled ){
	        return;
	    }
	
	    if ( newState >= $.ButtonState.GROUP &&
	         button.currentState == $.ButtonState.REST ) {
	        stopFading( button );
	        button.currentState = $.ButtonState.GROUP;
	    }
	
	    if ( newState >= $.ButtonState.HOVER &&
	         button.currentState == $.ButtonState.GROUP ) {
	        if( button.imgHover ){
	            button.imgHover.style.visibility = "";
	        }
	        button.currentState = $.ButtonState.HOVER;
	    }
	
	    if ( newState >= $.ButtonState.DOWN &&
	         button.currentState == $.ButtonState.HOVER ) {
	        if( button.imgDown ){
	            button.imgDown.style.visibility = "";
	        }
	        button.currentState = $.ButtonState.DOWN;
	    }
	}
	
	
	function outTo( button, newState ) {
	
	    if( button.element.disabled ){
	        return;
	    }
	
	    if ( newState <= $.ButtonState.HOVER &&
	         button.currentState == $.ButtonState.DOWN ) {
	        if( button.imgDown ){
	            button.imgDown.style.visibility = "hidden";
	        }
	        button.currentState = $.ButtonState.HOVER;
	    }
	
	    if ( newState <= $.ButtonState.GROUP &&
	         button.currentState == $.ButtonState.HOVER ) {
	        if( button.imgHover ){
	            button.imgHover.style.visibility = "hidden";
	        }
	        button.currentState = $.ButtonState.GROUP;
	    }
	
	    if ( newState <= $.ButtonState.REST &&
	         button.currentState == $.ButtonState.GROUP ) {
	        beginFading( button );
	        button.currentState = $.ButtonState.REST;
	    }
	}
	
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ButtonGroup
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	/**
	 * @class ButtonGroup
	 * @classdesc Manages events on groups of buttons.
	 *
	 * @memberof OpenSeadragon
	 * @param {Object} options - A dictionary of settings applied against the entire group of buttons.
	 * @param {Array} options.buttons Array of buttons
	 * @param {Element} [options.element] Element to use as the container
	 **/
	$.ButtonGroup = function( options ) {
	
	    $.extend( true, this, {
	        /**
	         * An array containing the buttons themselves.
	         * @member {Array} buttons
	         * @memberof OpenSeadragon.ButtonGroup#
	         */
	        buttons:            [],
	        clickTimeThreshold: $.DEFAULT_SETTINGS.clickTimeThreshold,
	        clickDistThreshold: $.DEFAULT_SETTINGS.clickDistThreshold,
	        labelText:          ""
	    }, options );
	
	    // copy the button elements  TODO: Why?
	    var buttons = this.buttons.concat([]),
	        _this = this,
	        i;
	
	    /**
	     * The shared container for the buttons.
	     * @member {Element} element
	     * @memberof OpenSeadragon.ButtonGroup#
	     */
	    this.element = options.element || $.makeNeutralElement( "div" );
	
	    // TODO What if there IS an options.group specified?
	    if( !options.group ){
	        this.label   = $.makeNeutralElement( "label" );
	        //TODO: support labels for ButtonGroups
	        //this.label.innerHTML = this.labelText;
	        this.element.style.display = "inline-block";
	        this.element.appendChild( this.label );
	        for ( i = 0; i < buttons.length; i++ ) {
	            this.element.appendChild( buttons[ i ].element );
	        }
	    }
	
	    $.setElementTouchActionNone( this.element );
	
	    /**
	     * Tracks mouse/touch/key events accross the group of buttons.
	     * @member {OpenSeadragon.MouseTracker} tracker
	     * @memberof OpenSeadragon.ButtonGroup#
	     */
	    this.tracker = new $.MouseTracker({
	        element:            this.element,
	        clickTimeThreshold: this.clickTimeThreshold,
	        clickDistThreshold: this.clickDistThreshold,
	        enterHandler: function ( event ) {
	            var i;
	            for ( i = 0; i < _this.buttons.length; i++ ) {
	                _this.buttons[ i ].notifyGroupEnter();
	            }
	        },
	        exitHandler: function ( event ) {
	            var i;
	            if ( !event.insideElementPressed ) {
	                for ( i = 0; i < _this.buttons.length; i++ ) {
	                    _this.buttons[ i ].notifyGroupExit();
	                }
	            }
	        },
	    });
	};
	
	$.ButtonGroup.prototype = /** @lends OpenSeadragon.ButtonGroup.prototype */{
	
	    /**
	     * TODO: Figure out why this is used on the public API and if a more useful
	     * api can be created.
	     * @function
	     * @private
	     */
	    emulateEnter: function() {
	        this.tracker.enterHandler( { eventSource: this.tracker } );
	    },
	
	    /**
	     * TODO: Figure out why this is used on the public API and if a more useful
	     * api can be created.
	     * @function
	     * @private
	     */
	    emulateExit: function() {
	        this.tracker.exitHandler( { eventSource: this.tracker } );
	    }
	};
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Rect
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Rect
	 * @classdesc A Rectangle really represents a 2x2 matrix where each row represents a
	 * 2 dimensional vector component, the first is (x,y) and the second is
	 * (width, height).  The latter component implies the equation of a simple
	 * plane.
	 *
	 * @memberof OpenSeadragon
	 * @param {Number} x The vector component 'x'.
	 * @param {Number} y The vector component 'y'.
	 * @param {Number} width The vector component 'height'.
	 * @param {Number} height The vector component 'width'.
	 */
	$.Rect = function( x, y, width, height ) {
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.x = typeof ( x ) == "number" ? x : 0;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.y = typeof ( y ) == "number" ? y : 0;
	    /**
	     * The vector component 'width'.
	     * @member {Number} width
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.width  = typeof ( width )  == "number" ? width : 0;
	    /**
	     * The vector component 'height'.
	     * @member {Number} height
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.height = typeof ( height ) == "number" ? height : 0;
	};
	
	$.Rect.prototype = /** @lends OpenSeadragon.Rect.prototype */{
	    /**
	     * @function
	     * @returns {OpenSeadragon.Rect} a duplicate of this Rect
	     */
	    clone: function() {
	        return new $.Rect(this.x, this.y, this.width, this.height);
	    },
	
	    /**
	     * The aspect ratio is simply the ratio of width to height.
	     * @function
	     * @returns {Number} The ratio of width to height.
	     */
	    getAspectRatio: function() {
	        return this.width / this.height;
	    },
	
	    /**
	     * Provides the coordinates of the upper-left corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
	     *  the rectangle.
	     */
	    getTopLeft: function() {
	        return new $.Point(
	            this.x,
	            this.y
	        );
	    },
	
	    /**
	     * Provides the coordinates of the bottom-right corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
	     *  the rectangle.
	     */
	    getBottomRight: function() {
	        return new $.Point(
	            this.x + this.width,
	            this.y + this.height
	        );
	    },
	
	    /**
	     * Provides the coordinates of the top-right corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
	     *  the rectangle.
	     */
	    getTopRight: function() {
	        return new $.Point(
	            this.x + this.width,
	            this.y
	        );
	    },
	
	    /**
	     * Provides the coordinates of the bottom-left corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
	     *  the rectangle.
	     */
	    getBottomLeft: function() {
	        return new $.Point(
	            this.x,
	            this.y + this.height
	        );
	    },
	
	    /**
	     * Computes the center of the rectangle.
	     * @function
	     * @returns {OpenSeadragon.Point} The center of the rectangle as represented
	     *  as represented by a 2-dimensional vector (x,y)
	     */
	    getCenter: function() {
	        return new $.Point(
	            this.x + this.width / 2.0,
	            this.y + this.height / 2.0
	        );
	    },
	
	    /**
	     * Returns the width and height component as a vector OpenSeadragon.Point
	     * @function
	     * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
	     *  the width and height of the rectangle.
	     */
	    getSize: function() {
	        return new $.Point( this.width, this.height );
	    },
	
	    /**
	     * Determines if two Rectangles have equivalent components.
	     * @function
	     * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
	     * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
	     */
	    equals: function( other ) {
	        return ( other instanceof $.Rect ) &&
	            ( this.x === other.x ) &&
	            ( this.y === other.y ) &&
	            ( this.width === other.width ) &&
	            ( this.height === other.height );
	    },
	
	    /**
	    * Multiply all dimensions in this Rect by a factor and return a new Rect.
	    * @function
	    * @param {Number} factor The factor to multiply vector components.
	    * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
	    *  of the vector components by the factor
	    */
	    times: function( factor ) {
	        return new OpenSeadragon.Rect(
	            this.x * factor,
	            this.y * factor,
	            this.width * factor,
	            this.height * factor
	        );
	    },
	
	    /**
	     * Returns the smallest rectangle that will contain this and the given rectangle.
	     * @param {OpenSeadragon.Rect} rect
	     * @return {OpenSeadragon.Rect} The new rectangle.
	     */
	    // ----------
	    union: function(rect) {
	        var left = Math.min(this.x, rect.x);
	        var top = Math.min(this.y, rect.y);
	        var right = Math.max(this.x + this.width, rect.x + rect.width);
	        var bottom = Math.max(this.y + this.height, rect.y + rect.height);
	
	        return new OpenSeadragon.Rect(left, top, right - left, bottom - top);
	    },
	
	    /**
	     * Rotates a rectangle around a point. Currently only 90, 180, and 270
	     * degrees are supported.
	     * @function
	     * @param {Number} degrees The angle in degrees to rotate.
	     * @param {OpenSeadragon.Point} pivot The point about which to rotate.
	     * Defaults to the center of the rectangle.
	     * @return {OpenSeadragon.Rect}
	     */
	    rotate: function( degrees, pivot ) {
	        // TODO support arbitrary rotation
	        var width = this.width,
	            height = this.height,
	            newTopLeft;
	
	        degrees = ( degrees + 360 ) % 360;
	        if (degrees % 90 !== 0) {
	            throw new Error('Currently only 0, 90, 180, and 270 degrees are supported.');
	        }
	
	        if( degrees === 0 ){
	            return new $.Rect(
	                this.x,
	                this.y,
	                this.width,
	                this.height
	            );
	        }
	
	        pivot = pivot || this.getCenter();
	
	        switch ( degrees ) {
	            case 90:
	                newTopLeft = this.getBottomLeft();
	                width = this.height;
	                height = this.width;
	                break;
	            case 180:
	                newTopLeft = this.getBottomRight();
	                break;
	            case 270:
	                newTopLeft = this.getTopRight();
	                width = this.height;
	                height = this.width;
	                break;
	            default:
	                newTopLeft = this.getTopLeft();
	                break;
	        }
	
	        newTopLeft = newTopLeft.rotate(degrees, pivot);
	
	        return new $.Rect(newTopLeft.x, newTopLeft.y, width, height);
	    },
	
	    /**
	     * Provides a string representation of the rectangle which is useful for
	     * debugging.
	     * @function
	     * @returns {String} A string representation of the rectangle.
	     */
	    toString: function() {
	        return "[" +
	            (Math.round(this.x*100) / 100) + "," +
	            (Math.round(this.y*100) / 100) + "," +
	            (Math.round(this.width*100) / 100) + "x" +
	            (Math.round(this.height*100) / 100) +
	        "]";
	    }
	};
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ReferenceStrip
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ( $ ) {
	
	// dictionary from id to private properties
	var THIS = {};
	
	/**
	 *  The CollectionDrawer is a reimplementation if the Drawer API that
	 *  focuses on allowing a viewport to be redefined as a collection
	 *  of smaller viewports, defined by a clear number of rows and / or
	 *  columns of which each item in the matrix of viewports has its own
	 *  source.
	 *
	 *  This idea is a reexpression of the idea of dzi collections
	 *  which allows a clearer algorithm to reuse the tile sources already
	 *  supported by OpenSeadragon, in heterogenious or homogenious
	 *  sequences just like mixed groups already supported by the viewer
	 *  for the purpose of image sequnces.
	 *
	 *  TODO:   The difficult part of this feature is figuring out how to express
	 *          this functionality as a combination of the functionality already
	 *          provided by Drawer, Viewport, TileSource, and Navigator.  It may
	 *          require better abstraction at those points in order to effeciently
	 *          reuse those paradigms.
	 */
	/**
	 * @class ReferenceStrip
	 * @memberof OpenSeadragon
	 * @param {Object} options
	 */
	$.ReferenceStrip = function ( options ) {
	
	    var _this       = this,
	        viewer      = options.viewer,
	        viewerSize  = $.getElementSize( viewer.element ),
	        element,
	        style,
	        i;
	
	    //We may need to create a new element and id if they did not
	    //provide the id for the existing element
	    if ( !options.id ) {
	        options.id              = 'referencestrip-' + $.now();
	        this.element            = $.makeNeutralElement( "div" );
	        this.element.id         = options.id;
	        this.element.className  = 'referencestrip';
	    }
	
	    options = $.extend( true, {
	        sizeRatio:  $.DEFAULT_SETTINGS.referenceStripSizeRatio,
	        position:   $.DEFAULT_SETTINGS.referenceStripPosition,
	        scroll:     $.DEFAULT_SETTINGS.referenceStripScroll,
	        clickTimeThreshold:  $.DEFAULT_SETTINGS.clickTimeThreshold
	    }, options, {
	        //required overrides
	        element:                this.element,
	        //These need to be overridden to prevent recursion since
	        //the navigator is a viewer and a viewer has a navigator
	        showNavigator:          false,
	        mouseNavEnabled:        false,
	        showNavigationControl:  false,
	        showSequenceControl:    false
	    } );
	
	    $.extend( this, options );
	    //Private state properties
	    THIS[this.id] = {
	        "animating":           false
	    };
	
	    this.minPixelRatio = this.viewer.minPixelRatio;
	
	    style = this.element.style;
	    style.marginTop     = '0px';
	    style.marginRight   = '0px';
	    style.marginBottom  = '0px';
	    style.marginLeft    = '0px';
	    style.left          = '0px';
	    style.bottom        = '0px';
	    style.border        = '0px';
	    style.background    = '#000';
	    style.position      = 'relative';
	
	    $.setElementTouchActionNone( this.element );
	
	    $.setElementOpacity( this.element, 0.8 );
	
	    this.viewer = viewer;
	    this.innerTracker = new $.MouseTracker( {
	        element:        this.element,
	        dragHandler:    $.delegate( this, onStripDrag ),
	        scrollHandler:  $.delegate( this, onStripScroll ),
	        enterHandler:   $.delegate( this, onStripEnter ),
	        exitHandler:    $.delegate( this, onStripExit ),
	        keyDownHandler: $.delegate( this, onKeyDown ),
	        keyHandler:     $.delegate( this, onKeyPress )
	    } );
	
	    //Controls the position and orientation of the reference strip and sets the
	    //appropriate width and height
	    if ( options.width && options.height ) {
	        this.element.style.width  = options.width + 'px';
	        this.element.style.height = options.height + 'px';
	        viewer.addControl(
	            this.element,
	            { anchor: $.ControlAnchor.BOTTOM_LEFT }
	        );
	    } else {
	        if ( "horizontal" == options.scroll ) {
	            this.element.style.width = (
	                viewerSize.x *
	                options.sizeRatio *
	                viewer.tileSources.length
	            ) + ( 12 * viewer.tileSources.length ) + 'px';
	
	            this.element.style.height = (
	                viewerSize.y *
	                options.sizeRatio
	            ) + 'px';
	
	            viewer.addControl(
	                this.element,
	                { anchor: $.ControlAnchor.BOTTOM_LEFT }
	            );
	        } else {
	            this.element.style.height = (
	                viewerSize.y *
	                options.sizeRatio *
	                viewer.tileSources.length
	            ) + ( 12 * viewer.tileSources.length ) + 'px';
	
	            this.element.style.width = (
	                viewerSize.x *
	                options.sizeRatio
	            ) + 'px';
	
	            viewer.addControl(
	                this.element,
	                { anchor: $.ControlAnchor.TOP_LEFT }
	            );
	
	        }
	    }
	
	    this.panelWidth = ( viewerSize.x * this.sizeRatio ) + 8;
	    this.panelHeight = ( viewerSize.y * this.sizeRatio ) + 8;
	    this.panels = [];
	
	    /*jshint loopfunc:true*/
	    for ( i = 0; i < viewer.tileSources.length; i++ ) {
	
	        element = $.makeNeutralElement( 'div' );
	        element.id = this.element.id + "-" + i;
	
	        element.style.width         = _this.panelWidth + 'px';
	        element.style.height        = _this.panelHeight + 'px';
	        element.style.display       = 'inline';
	        element.style.float         = 'left'; //Webkit
	        element.style.cssFloat      = 'left'; //Firefox
	        element.style.styleFloat    = 'left'; //IE
	        element.style.padding       = '2px';
	        $.setElementTouchActionNone( element );
	
	        element.innerTracker = new $.MouseTracker( {
	            element:            element,
	            clickTimeThreshold: this.clickTimeThreshold,
	            clickDistThreshold: this.clickDistThreshold,
	            pressHandler: function ( event ) {
	                event.eventSource.dragging = $.now();
	            },
	            releaseHandler: function ( event ) {
	                var tracker = event.eventSource,
	                    id      = tracker.element.id,
	                    page    = Number( id.split( '-' )[2] ),
	                    now     = $.now();
	
	                if ( event.insideElementPressed &&
	                     event.insideElementReleased &&
	                     tracker.dragging &&
	                     ( now - tracker.dragging ) < tracker.clickTimeThreshold ) {
	                    tracker.dragging = null;
	                    viewer.goToPage( page );
	                }
	            }
	        } );
	
	        this.element.appendChild( element );
	
	        element.activePanel = false;
	
	        this.panels.push( element );
	
	    }
	    loadPanels( this, this.scroll == 'vertical' ? viewerSize.y : viewerSize.x, 0 );
	    this.setFocus( 0 );
	
	};
	
	$.extend( $.ReferenceStrip.prototype, $.EventSource.prototype, $.Viewer.prototype, /** @lends OpenSeadragon.ReferenceStrip.prototype */{
	
	    /**
	     * @function
	     */
	    setFocus: function ( page ) {
	        var element      = $.getElement( this.element.id + '-' + page ),
	            viewerSize   = $.getElementSize( this.viewer.canvas ),
	            scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	            scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	            offsetLeft   = -Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	            offsetTop    = -Number( this.element.style.marginTop.replace( 'px', '' ) ),
	            offset;
	
	        if ( this.currentSelected !== element ) {
	            if ( this.currentSelected ) {
	                this.currentSelected.style.background = '#000';
	            }
	            this.currentSelected = element;
	            this.currentSelected.style.background = '#999';
	
	            if ( 'horizontal' == this.scroll ) {
	                //right left
	                offset = ( Number( page ) ) * ( this.panelWidth + 3 );
	                if ( offset > offsetLeft + viewerSize.x - this.panelWidth ) {
	                    offset = Math.min( offset, ( scrollWidth - viewerSize.x ) );
	                    this.element.style.marginLeft = -offset + 'px';
	                    loadPanels( this, viewerSize.x, -offset );
	                } else if ( offset < offsetLeft ) {
	                    offset = Math.max( 0, offset - viewerSize.x / 2 );
	                    this.element.style.marginLeft = -offset + 'px';
	                    loadPanels( this, viewerSize.x, -offset );
	                }
	            } else {
	                offset = ( Number( page ) ) * ( this.panelHeight + 3 );
	                if ( offset > offsetTop + viewerSize.y - this.panelHeight ) {
	                    offset = Math.min( offset, ( scrollHeight - viewerSize.y ) );
	                    this.element.style.marginTop = -offset + 'px';
	                    loadPanels( this, viewerSize.y, -offset );
	                } else if ( offset < offsetTop ) {
	                    offset = Math.max( 0, offset - viewerSize.y / 2 );
	                    this.element.style.marginTop = -offset + 'px';
	                    loadPanels( this, viewerSize.y, -offset );
	                }
	            }
	
	            this.currentPage = page;
	            $.getElement( element.id + '-displayregion' ).focus();
	            onStripEnter.call( this, { eventSource: this.innerTracker } );
	        }
	    },
	
	    /**
	     * @function
	     */
	    update: function () {
	        if ( THIS[this.id].animating ) {
	            $.console.log( 'image reference strip update' );
	            return true;
	        }
	        return false;
	    },
	
	    // Overrides Viewer.destroy
	    destroy: function() {
	        if (this.element) {
	            this.element.parentNode.removeChild(this.element);
	        }
	    }
	
	} );
	
	
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripDrag( event ) {
	
	    var offsetLeft   = Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	        offsetTop    = Number( this.element.style.marginTop.replace( 'px', '' ) ),
	        scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	        scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	        viewerSize   = $.getElementSize( this.viewer.canvas );
	    this.dragging = true;
	    if ( this.element ) {
	        if ( 'horizontal' == this.scroll ) {
	            if ( -event.delta.x > 0 ) {
	                //forward
	                if ( offsetLeft > -( scrollWidth - viewerSize.x ) ) {
	                    this.element.style.marginLeft = ( offsetLeft + ( event.delta.x * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft + ( event.delta.x * 2 ) );
	                }
	            } else if ( -event.delta.x < 0 ) {
	                //reverse
	                if ( offsetLeft < 0 ) {
	                    this.element.style.marginLeft = ( offsetLeft + ( event.delta.x * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft + ( event.delta.x * 2 ) );
	                }
	            }
	        } else {
	            if ( -event.delta.y > 0 ) {
	                //forward
	                if ( offsetTop > -( scrollHeight - viewerSize.y ) ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.delta.y * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.delta.y * 2 ) );
	                }
	            } else if ( -event.delta.y < 0 ) {
	                //reverse
	                if ( offsetTop < 0 ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.delta.y * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.delta.y * 2 ) );
	                }
	            }
	        }
	    }
	    return false;
	
	}
	
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripScroll( event ) {
	    var offsetLeft   = Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	        offsetTop    = Number( this.element.style.marginTop.replace( 'px', '' ) ),
	        scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	        scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	        viewerSize   = $.getElementSize( this.viewer.canvas );
	    if ( this.element ) {
	        if ( 'horizontal' == this.scroll ) {
	            if ( event.scroll > 0 ) {
	                //forward
	                if ( offsetLeft > -( scrollWidth - viewerSize.x ) ) {
	                    this.element.style.marginLeft = ( offsetLeft - ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft - ( event.scroll * 60 ) );
	                }
	            } else if ( event.scroll < 0 ) {
	                //reverse
	                if ( offsetLeft < 0 ) {
	                    this.element.style.marginLeft = ( offsetLeft - ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft - ( event.scroll * 60 ) );
	                }
	            }
	        } else {
	            if ( event.scroll < 0 ) {
	                //scroll up
	                if ( offsetTop > viewerSize.y - scrollHeight ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.scroll * 60 ) );
	                }
	            } else if ( event.scroll > 0 ) {
	                //scroll dowm
	                if ( offsetTop < 0 ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.scroll * 60 ) );
	                }
	            }
	        }
	    }
	    //cancels event
	    return false;
	}
	
	
	function loadPanels( strip, viewerSize, scroll ) {
	    var panelSize,
	        activePanelsStart,
	        activePanelsEnd,
	        miniViewer,
	        style,
	        i,
	        element;
	    if ( 'horizontal' == strip.scroll ) {
	        panelSize = strip.panelWidth;
	    } else {
	        panelSize = strip.panelHeight;
	    }
	    activePanelsStart = Math.ceil( viewerSize / panelSize ) + 5;
	    activePanelsEnd = Math.ceil( ( Math.abs( scroll ) + viewerSize ) / panelSize ) + 1;
	    activePanelsStart = activePanelsEnd - activePanelsStart;
	    activePanelsStart = activePanelsStart < 0 ? 0 : activePanelsStart;
	
	    for ( i = activePanelsStart; i < activePanelsEnd && i < strip.panels.length; i++ ) {
	        element = strip.panels[i];
	        if ( !element.activePanel ) {
	            miniViewer = new $.Viewer( {
	                id:                     element.id,
	                tileSources:            [strip.viewer.tileSources[i]],
	                element:                element,
	                navigatorSizeRatio:     strip.sizeRatio,
	                showNavigator:          false,
	                mouseNavEnabled:        false,
	                showNavigationControl:  false,
	                showSequenceControl:    false,
	                immediateRender:        true,
	                blendTime:              0,
	                animationTime:          0
	            } );
	
	            miniViewer.displayRegion           = $.makeNeutralElement( "textarea" );
	            miniViewer.displayRegion.id        = element.id + '-displayregion';
	            miniViewer.displayRegion.className = 'displayregion';
	
	            style               = miniViewer.displayRegion.style;
	            style.position      = 'relative';
	            style.top           = '0px';
	            style.left          = '0px';
	            style.fontSize      = '0px';
	            style.overflow      = 'hidden';
	            style.float         = 'left'; //Webkit
	            style.cssFloat      = 'left'; //Firefox
	            style.styleFloat    = 'left'; //IE
	            style.zIndex        = 999999999;
	            style.cursor        = 'default';
	            style.width         = ( strip.panelWidth - 4 ) + 'px';
	            style.height        = ( strip.panelHeight - 4 ) + 'px';
	
	            // TODO: What is this for? Future keyboard navigation support?
	            miniViewer.displayRegion.innerTracker = new $.MouseTracker( {
	                element: miniViewer.displayRegion,
	                startDisabled: true
	            } );
	
	            element.getElementsByTagName( 'div' )[0].appendChild(
	                miniViewer.displayRegion
	            );
	
	            element.activePanel = true;
	        }
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripEnter( event ) {
	    var element = event.eventSource.element;
	
	    //$.setElementOpacity(element, 0.8);
	
	    //element.style.border = '1px solid #555';
	    //element.style.background = '#000';
	
	    if ( 'horizontal' == this.scroll ) {
	
	        //element.style.paddingTop = "0px";
	        element.style.marginBottom = "0px";
	
	    } else {
	
	        //element.style.paddingRight = "0px";
	        element.style.marginLeft = "0px";
	
	    }
	    return false;
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripExit( event ) {
	    var element = event.eventSource.element;
	
	    if ( 'horizontal' == this.scroll ) {
	
	        //element.style.paddingTop = "10px";
	        element.style.marginBottom = "-" + ( $.getElementSize( element ).y / 2 ) + "px";
	
	    } else {
	
	        //element.style.paddingRight = "10px";
	        element.style.marginLeft = "-" + ( $.getElementSize( element ).x / 2 ) + "px";
	
	    }
	    return false;
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onKeyDown( event ) {
	    //console.log( event.keyCode );
	
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch ( event.keyCode ) {
	            case 38: //up arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 40: //down arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 37: //left arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 39: //right arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onKeyPress( event ) {
	    //console.log( event.keyCode );
	
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch ( event.keyCode ) {
	            case 61: //=|+
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 45: //-|_
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 48: //0|)
	            case 119: //w
	            case 87: //W
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 115: //s
	            case 83: //S
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 97: //a
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 100: //d
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	
	
	} ( OpenSeadragon ) );
	
	/*
	 * OpenSeadragon - DisplayRect
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class DisplayRect
	 * @classdesc A display rectangle is very similar to {@link OpenSeadragon.Rect} but adds two
	 * fields, 'minLevel' and 'maxLevel' which denote the supported zoom levels
	 * for this rectangle.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.Rect
	 * @param {Number} x The vector component 'x'.
	 * @param {Number} y The vector component 'y'.
	 * @param {Number} width The vector component 'height'.
	 * @param {Number} height The vector component 'width'.
	 * @param {Number} minLevel The lowest zoom level supported.
	 * @param {Number} maxLevel The highest zoom level supported.
	 */
	$.DisplayRect = function( x, y, width, height, minLevel, maxLevel ) {
	    $.Rect.apply( this, [ x, y, width, height ] );
	
	    /**
	     * The lowest zoom level supported.
	     * @member {Number} minLevel
	     * @memberof OpenSeadragon.DisplayRect#
	     */
	    this.minLevel = minLevel;
	    /**
	     * The highest zoom level supported.
	     * @member {Number} maxLevel
	     * @memberof OpenSeadragon.DisplayRect#
	     */
	    this.maxLevel = maxLevel;
	};
	
	$.extend( $.DisplayRect.prototype, $.Rect.prototype );
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Spring
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Spring
	 * @memberof OpenSeadragon
	 * @param {Object} options - Spring configuration settings.
	 * @param {Number} options.springStiffness - Spring stiffness. Must be greater than zero.
	 * The closer to zero, the closer to linear animation.
	 * @param {Number} options.animationTime - Animation duration per spring, in seconds.
	 * Must be greater than zero.
	 * @param {Number} [options.initial=0] - Initial value of spring.
	 * @param {Boolean} [options.exponential=false] - Whether this spring represents
	 * an exponential scale (such as zoom) and should be animated accordingly. Note that
	 * exponential springs must have non-zero values.
	 */
	$.Spring = function( options ) {
	    var args = arguments;
	
	    if( typeof( options ) != 'object' ){
	        //allows backward compatible use of ( initialValue, config ) as
	        //constructor parameters
	        options = {
	            initial: args.length && typeof ( args[ 0 ] ) == "number" ?
	                args[ 0 ] :
	                undefined,
	            /**
	             * Spring stiffness.
	             * @member {Number} springStiffness
	             * @memberof OpenSeadragon.Spring#
	             */
	            springStiffness: args.length > 1 ?
	                args[ 1 ].springStiffness :
	                5.0,
	            /**
	             * Animation duration per spring.
	             * @member {Number} animationTime
	             * @memberof OpenSeadragon.Spring#
	             */
	            animationTime: args.length > 1 ?
	                args[ 1 ].animationTime :
	                1.5
	        };
	    }
	
	    $.console.assert(typeof options.springStiffness === "number" && options.springStiffness !== 0,
	        "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number");
	
	    $.console.assert(typeof options.animationTime === "number" && options.springStiffness !== 0,
	        "[OpenSeadragon.Spring] options.animationTime must be a non-zero number");
	
	    if (options.exponential) {
	        this._exponential = true;
	        delete options.exponential;
	    }
	
	    $.extend( true, this, options);
	
	    /**
	     * @member {Object} current
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.current = {
	        value: typeof ( this.initial ) == "number" ?
	            this.initial :
	            (this._exponential ? 0 : 1),
	        time:  $.now() // always work in milliseconds
	    };
	
	    $.console.assert(!this._exponential || this.current.value !== 0,
	        "[OpenSeadragon.Spring] value must be non-zero for exponential springs");
	
	    /**
	     * @member {Object} start
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.start = {
	        value: this.current.value,
	        time:  this.current.time
	    };
	
	    /**
	     * @member {Object} target
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.target = {
	        value: this.current.value,
	        time:  this.current.time
	    };
	
	    if (this._exponential) {
	        this.start._logValue = Math.log(this.start.value);
	        this.target._logValue = Math.log(this.target.value);
	        this.current._logValue = Math.log(this.current.value);
	    }
	};
	
	$.Spring.prototype = /** @lends OpenSeadragon.Spring.prototype */{
	
	    /**
	     * @function
	     * @param {Number} target
	     */
	    resetTo: function( target ) {
	        $.console.assert(!this._exponential || target !== 0,
	            "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs");
	
	        this.start.value = this.target.value = this.current.value = target;
	        this.start.time = this.target.time = this.current.time = $.now();
	
	        if (this._exponential) {
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	            this.current._logValue = Math.log(this.current.value);
	        }
	    },
	
	    /**
	     * @function
	     * @param {Number} target
	     */
	    springTo: function( target ) {
	        $.console.assert(!this._exponential || target !== 0,
	            "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs");
	
	        this.start.value  = this.current.value;
	        this.start.time   = this.current.time;
	        this.target.value = target;
	        this.target.time  = this.start.time + 1000 * this.animationTime;
	
	        if (this._exponential) {
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	        }
	    },
	
	    /**
	     * @function
	     * @param {Number} delta
	     */
	    shiftBy: function( delta ) {
	        this.start.value  += delta;
	        this.target.value += delta;
	
	        if (this._exponential) {
	            $.console.assert(this.target.value !== 0 && this.start.value !== 0,
	                "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs");
	
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	        }
	    },
	
	    setExponential: function(value) {
	        this._exponential = value;
	
	        if (this._exponential) {
	            $.console.assert(this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0,
	                "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs");
	
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	            this.current._logValue = Math.log(this.current.value);
	        }
	    },
	
	    /**
	     * @function
	     */
	    update: function() {
	        this.current.time  = $.now();
	
	        var startValue, targetValue;
	        if (this._exponential) {
	            startValue = this.start._logValue;
	            targetValue = this.target._logValue;
	        } else {
	            startValue = this.start.value;
	            targetValue = this.target.value;
	        }
	
	        var currentValue = (this.current.time >= this.target.time) ?
	            targetValue :
	            startValue +
	                ( targetValue - startValue ) *
	                transform(
	                    this.springStiffness,
	                    ( this.current.time - this.start.time ) /
	                    ( this.target.time  - this.start.time )
	                );
	
	        if (this._exponential) {
	            this.current.value = Math.exp(currentValue);
	        } else {
	            this.current.value = currentValue;
	        }
	    }
	};
	
	/**
	 * @private
	 */
	function transform( stiffness, x ) {
	    return ( 1.0 - Math.exp( stiffness * -x ) ) /
	        ( 1.0 - Math.exp( -stiffness ) );
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ImageLoader
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// private class
	function ImageJob ( options ) {
	
	    $.extend( true, this, {
	        timeout:        $.DEFAULT_SETTINGS.timeout,
	        jobId:          null
	    }, options );
	
	    /**
	     * Image object which will contain downloaded image.
	     * @member {Image} image
	     * @memberof OpenSeadragon.ImageJob#
	     */
	    this.image = null;
	}
	
	ImageJob.prototype = {
	    errorMsg: null,
	    start: function(){
	        var _this = this;
	
	        this.image = new Image();
	
	        if ( this.crossOriginPolicy !== false ) {
	            this.image.crossOrigin = this.crossOriginPolicy;
	        }
	
	        this.image.onload = function(){
	            _this.finish( true );
	        };
	        this.image.onabort = this.image.onerror = function(){
	            _this.errorMsg = "Image load aborted";
	            _this.finish( false );
	        };
	
	        this.jobId = window.setTimeout( function(){
	            _this.errorMsg = "Image load exceeded timeout";
	            _this.finish( false );
	        }, this.timeout);
	
	        this.image.src = this.src;
	    },
	
	    finish: function( successful ) {
	        this.image.onload = this.image.onerror = this.image.onabort = null;
	        if (!successful) {
	            this.image = null;
	        }
	
	        if ( this.jobId ) {
	            window.clearTimeout( this.jobId );
	        }
	
	        this.callback( this );
	    }
	
	};
	
	/**
	 * @class ImageLoader
	 * @memberof OpenSeadragon
	 * @classdesc Handles downloading of a set of images using asynchronous queue pattern.
	 * You generally won't have to interact with the ImageLoader directly.
	 * @param {Object} options - Options for this ImageLoader.
	 * @param {Number} [options.jobLimit] - The number of concurrent image requests. See imageLoaderLimit in {@link OpenSeadragon.Options} for details.
	 */
	$.ImageLoader = function( options ) {
	
	    $.extend( true, this, {
	        jobLimit:       $.DEFAULT_SETTINGS.imageLoaderLimit,
	        jobQueue:       [],
	        jobsInProgress: 0
	    }, options );
	
	};
	
	$.ImageLoader.prototype = /** @lends OpenSeadragon.ImageLoader.prototype */{
	
	    /**
	     * Add an unloaded image to the loader queue.
	     * @method
	     * @param {String} src - URL of image to download.
	     * @param {String} crossOriginPolicy - CORS policy to use for downloads
	     * @param {Function} callback - Called once image has been downloaded.
	     */
	    addJob: function( options ) {
	        var _this = this,
	            complete = function( job ) {
	                completeJob( _this, job, options.callback );
	            },
	            jobOptions = {
	                src: options.src,
	                crossOriginPolicy: options.crossOriginPolicy,
	                callback: complete,
	                abort: options.abort
	            },
	            newJob = new ImageJob( jobOptions );
	
	        if ( !this.jobLimit || this.jobsInProgress < this.jobLimit ) {
	            newJob.start();
	            this.jobsInProgress++;
	        }
	        else {
	            this.jobQueue.push( newJob );
	        }
	    },
	
	    /**
	     * Clear any unstarted image loading jobs from the queue.
	     * @method
	     */
	    clear: function() {
	        for( var i = 0; i < this.jobQueue.length; i++ ) {
	            var job = this.jobQueue[i];
	            if ( typeof job.abort === "function" ) {
	                job.abort();
	            }
	        }
	
	        this.jobQueue = [];
	    }
	};
	
	/**
	 * Cleans up ImageJob once completed.
	 * @method
	 * @private
	 * @param loader - ImageLoader used to start job.
	 * @param job - The ImageJob that has completed.
	 * @param callback - Called once cleanup is finished.
	 */
	function completeJob( loader, job, callback ) {
	    var nextJob;
	
	    loader.jobsInProgress--;
	
	    if ( (!loader.jobLimit || loader.jobsInProgress < loader.jobLimit) && loader.jobQueue.length > 0) {
	        nextJob = loader.jobQueue.shift();
	        nextJob.start();
	        loader.jobsInProgress++;
	    }
	
	    callback( job.image, job.errorMsg );
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Tile
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Tile
	 * @memberof OpenSeadragon
	 * @param {Number} level The zoom level this tile belongs to.
	 * @param {Number} x The vector component 'x'.
	 * @param {Number} y The vector component 'y'.
	 * @param {OpenSeadragon.Point} bounds Where this tile fits, in normalized
	 *      coordinates.
	 * @param {Boolean} exists Is this tile a part of a sparse image? ( Also has
	 *      this tile failed to load? )
	 * @param {String} url The URL of this tile's image.
	 * @param {CanvasRenderingContext2D} context2D The context2D of this tile if it
	 * is provided directly by the tile source.
	 */
	$.Tile = function(level, x, y, bounds, exists, url, context2D) {
	    /**
	     * The zoom level this tile belongs to.
	     * @member {Number} level
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.level   = level;
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.x       = x;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.y       = y;
	    /**
	     * Where this tile fits, in normalized coordinates
	     * @member {OpenSeadragon.Rect} bounds
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.bounds  = bounds;
	    /**
	     * Is this tile a part of a sparse image? Also has this tile failed to load?
	     * @member {Boolean} exists
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.exists  = exists;
	    /**
	     * The URL of this tile's image.
	     * @member {String} url
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.url     = url;
	    /**
	     * The context2D of this tile if it is provided directly by the tile source.
	     * @member {CanvasRenderingContext2D} context2D
	     * @memberOf OpenSeadragon.Tile#
	     */
	    this.context2D = context2D;
	    /**
	     * Is this tile loaded?
	     * @member {Boolean} loaded
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.loaded  = false;
	    /**
	     * Is this tile loading?
	     * @member {Boolean} loading
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.loading = false;
	
	    /**
	     * The HTML div element for this tile
	     * @member {Element} element
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.element    = null;
	    /**
	     * The HTML img element for this tile.
	     * @member {Element} imgElement
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.imgElement = null;
	    /**
	     * The Image object for this tile.
	     * @member {Object} image
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.image      = null;
	
	    /**
	     * The alias of this.element.style.
	     * @member {String} style
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.style      = null;
	    /**
	     * This tile's position on screen, in pixels.
	     * @member {OpenSeadragon.Point} position
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.position   = null;
	    /**
	     * This tile's size on screen, in pixels.
	     * @member {OpenSeadragon.Point} size
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.size       = null;
	    /**
	     * The start time of this tile's blending.
	     * @member {Number} blendStart
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.blendStart = null;
	    /**
	     * The current opacity this tile should be.
	     * @member {Number} opacity
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.opacity    = null;
	    /**
	     * The distance of this tile to the viewport center.
	     * @member {Number} distance
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.distance   = null;
	    /**
	     * The visibility score of this tile.
	     * @member {Number} visibility
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.visibility = null;
	
	    /**
	     * Whether this tile is currently being drawn.
	     * @member {Boolean} beingDrawn
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.beingDrawn     = false;
	    /**
	     * Timestamp the tile was last touched.
	     * @member {Number} lastTouchTime
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.lastTouchTime  = 0;
	};
	
	$.Tile.prototype = /** @lends OpenSeadragon.Tile.prototype */{
	
	    /**
	     * Provides a string representation of this tiles level and (x,y)
	     * components.
	     * @function
	     * @returns {String}
	     */
	    toString: function() {
	        return this.level + "/" + this.x + "_" + this.y;
	    },
	
	    /**
	     * Renders the tile in an html container.
	     * @function
	     * @param {Element} container
	     */
	    drawHTML: function( container ) {
	        if (!this.cacheImageRecord) {
	            $.console.warn(
	                '[Tile.drawHTML] attempting to draw tile %s when it\'s not cached',
	                this.toString());
	            return;
	        }
	
	        if ( !this.loaded ) {
	            $.console.warn(
	                "Attempting to draw tile %s when it's not yet loaded.",
	                this.toString()
	            );
	            return;
	        }
	
	        //EXPERIMENTAL - trying to figure out how to scale the container
	        //               content during animation of the container size.
	
	        if ( !this.element ) {
	            this.element                              = $.makeNeutralElement( "div" );
	            this.imgElement                           = this.cacheImageRecord.getImage().cloneNode();
	            this.imgElement.style.msInterpolationMode = "nearest-neighbor";
	            this.imgElement.style.width               = "100%";
	            this.imgElement.style.height              = "100%";
	
	            this.style                     = this.element.style;
	            this.style.position            = "absolute";
	        }
	        if ( this.element.parentNode != container ) {
	            container.appendChild( this.element );
	        }
	        if ( this.imgElement.parentNode != this.element ) {
	            this.element.appendChild( this.imgElement );
	        }
	
	        this.style.top     = this.position.y + "px";
	        this.style.left    = this.position.x + "px";
	        this.style.height  = this.size.y + "px";
	        this.style.width   = this.size.x + "px";
	
	        $.setElementOpacity( this.element, this.opacity );
	    },
	
	    /**
	     * Renders the tile in a canvas-based context.
	     * @function
	     * @param {Canvas} context
	     * @param {Function} drawingHandler - Method for firing the drawing event.
	     * drawingHandler({context, tile, rendered})
	     * where <code>rendered</code> is the context with the pre-drawn image.
	     */
	    drawCanvas: function( context, drawingHandler ) {
	
	        var position = this.position,
	            size     = this.size,
	            rendered;
	
	        if (!this.context2D && !this.cacheImageRecord) {
	            $.console.warn(
	                '[Tile.drawCanvas] attempting to draw tile %s when it\'s not cached',
	                this.toString());
	            return;
	        }
	
	        rendered = this.context2D || this.cacheImageRecord.getRenderedContext();
	
	        if ( !this.loaded || !rendered ){
	            $.console.warn(
	                "Attempting to draw tile %s when it's not yet loaded.",
	                this.toString()
	            );
	
	            return;
	        }
	
	        context.save();
	
	        context.globalAlpha = this.opacity;
	
	        //if we are supposed to be rendering fully opaque rectangle,
	        //ie its done fading or fading is turned off, and if we are drawing
	        //an image with an alpha channel, then the only way
	        //to avoid seeing the tile underneath is to clear the rectangle
	        if (context.globalAlpha === 1 &&
	                (this.context2D || this.url.match('.png'))) {
	            //clearing only the inside of the rectangle occupied
	            //by the png prevents edge flikering
	            context.clearRect(
	                (position.x * $.pixelDensityRatio)+1,
	                (position.y * $.pixelDensityRatio)+1,
	                (size.x * $.pixelDensityRatio)-2,
	                (size.y * $.pixelDensityRatio)-2
	            );
	
	        }
	
	        // This gives the application a chance to make image manipulation
	        // changes as we are rendering the image
	        drawingHandler({context: context, tile: this, rendered: rendered});
	
	        context.drawImage(
	            rendered.canvas,
	            0,
	            0,
	            rendered.canvas.width,
	            rendered.canvas.height,
	            position.x * $.pixelDensityRatio,
	            position.y * $.pixelDensityRatio,
	            size.x * $.pixelDensityRatio,
	            size.y * $.pixelDensityRatio
	        );
	
	        context.restore();
	    },
	
	    /**
	     * Removes tile from its container.
	     * @function
	     */
	    unload: function() {
	        if ( this.imgElement && this.imgElement.parentNode ) {
	            this.imgElement.parentNode.removeChild( this.imgElement );
	        }
	        if ( this.element && this.element.parentNode ) {
	            this.element.parentNode.removeChild( this.element );
	        }
	
	        this.element    = null;
	        this.imgElement = null;
	        this.loaded     = false;
	        this.loading    = false;
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Overlay
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	    /**
	     * An enumeration of positions that an overlay may be assigned relative to
	     * the viewport.
	     * @member OverlayPlacement
	     * @memberof OpenSeadragon
	     * @static
	     * @type {Object}
	     * @property {Number} CENTER
	     * @property {Number} TOP_LEFT
	     * @property {Number} TOP
	     * @property {Number} TOP_RIGHT
	     * @property {Number} RIGHT
	     * @property {Number} BOTTOM_RIGHT
	     * @property {Number} BOTTOM
	     * @property {Number} BOTTOM_LEFT
	     * @property {Number} LEFT
	     */
	    $.OverlayPlacement = {
	        CENTER:       0,
	        TOP_LEFT:     1,
	        TOP:          2,
	        TOP_RIGHT:    3,
	        RIGHT:        4,
	        BOTTOM_RIGHT: 5,
	        BOTTOM:       6,
	        BOTTOM_LEFT:  7,
	        LEFT:         8
	    };
	
	    /**
	     * @class Overlay
	     * @classdesc Provides a way to float an HTML element on top of the viewer element.
	     *
	     * @memberof OpenSeadragon
	     * @param {Object} options
	     * @param {Element} options.element
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} options.location - The
	     * location of the overlay on the image. If a {@link OpenSeadragon.Point}
	     * is specified, the overlay will keep a constant size independently of the
	     * zoom. If a {@link OpenSeadragon.Rect} is specified, the overlay size will
	     * be adjusted when the zoom changes.
	     * @param {OpenSeadragon.OverlayPlacement} [options.placement=OpenSeadragon.OverlayPlacement.TOP_LEFT]
	     * Relative position to the viewport.
	     * Only used if location is a {@link OpenSeadragon.Point}.
	     * @param {OpenSeadragon.Overlay.OnDrawCallback} [options.onDraw]
	     * @param {Boolean} [options.checkResize=true] Set to false to avoid to
	     * check the size of the overlay everytime it is drawn when using a
	     * {@link OpenSeadragon.Point} as options.location. It will improve
	     * performances but will cause a misalignment if the overlay size changes.
	     */
	    $.Overlay = function( element, location, placement ) {
	
	        /**
	         * onDraw callback signature used by {@link OpenSeadragon.Overlay}.
	         *
	         * @callback OnDrawCallback
	         * @memberof OpenSeadragon.Overlay
	         * @param {OpenSeadragon.Point} position
	         * @param {OpenSeadragon.Point} size
	         * @param {Element} element
	         */
	
	        var options;
	        if ( $.isPlainObject( element ) ) {
	            options = element;
	        } else {
	            options = {
	                element: element,
	                location: location,
	                placement: placement
	            };
	        }
	
	        this.element    = options.element;
	        this.scales     = options.location instanceof $.Rect;
	        this.bounds     = new $.Rect(
	            options.location.x,
	            options.location.y,
	            options.location.width,
	            options.location.height
	        );
	        this.position   = new $.Point(
	            options.location.x,
	            options.location.y
	        );
	        this.size       = new $.Point(
	            options.location.width,
	            options.location.height
	        );
	        this.style      = options.element.style;
	        // rects are always top-left
	        this.placement  = options.location instanceof $.Point ?
	            options.placement :
	            $.OverlayPlacement.TOP_LEFT;
	        this.onDraw = options.onDraw;
	        this.checkResize = options.checkResize === undefined ?
	            true : options.checkResize;
	    };
	
	    $.Overlay.prototype = /** @lends OpenSeadragon.Overlay.prototype */{
	
	        /**
	         * @function
	         * @param {OpenSeadragon.OverlayPlacement} position
	         * @param {OpenSeadragon.Point} size
	         */
	        adjust: function( position, size ) {
	            switch ( this.placement ) {
	                case $.OverlayPlacement.TOP_LEFT:
	                    break;
	                case $.OverlayPlacement.TOP:
	                    position.x -= size.x / 2;
	                    break;
	                case $.OverlayPlacement.TOP_RIGHT:
	                    position.x -= size.x;
	                    break;
	                case $.OverlayPlacement.RIGHT:
	                    position.x -= size.x;
	                    position.y -= size.y / 2;
	                    break;
	                case $.OverlayPlacement.BOTTOM_RIGHT:
	                    position.x -= size.x;
	                    position.y -= size.y;
	                    break;
	                case $.OverlayPlacement.BOTTOM:
	                    position.x -= size.x / 2;
	                    position.y -= size.y;
	                    break;
	                case $.OverlayPlacement.BOTTOM_LEFT:
	                    position.y -= size.y;
	                    break;
	                case $.OverlayPlacement.LEFT:
	                    position.y -= size.y / 2;
	                    break;
	                default:
	                case $.OverlayPlacement.CENTER:
	                    position.x -= size.x / 2;
	                    position.y -= size.y / 2;
	                    break;
	            }
	        },
	
	        /**
	         * @function
	         */
	        destroy: function() {
	            var element = this.element,
	                style   = this.style;
	
	            if ( element.parentNode ) {
	                element.parentNode.removeChild( element );
	                //this should allow us to preserve overlays when required between
	                //pages
	                if ( element.prevElementParent ) {
	                    style.display = 'none';
	                    //element.prevElementParent.insertBefore(
	                    //    element,
	                    //    element.prevNextSibling
	                    //);
	                    document.body.appendChild( element );
	                }
	            }
	
	            // clear the onDraw callback
	            this.onDraw = null;
	
	            style.top = "";
	            style.left = "";
	            style.position = "";
	
	            if ( this.scales ) {
	                style.width = "";
	                style.height = "";
	            }
	        },
	
	        /**
	         * @function
	         * @param {Element} container
	         */
	        drawHTML: function( container, viewport ) {
	            var element = this.element,
	                style   = this.style,
	                scales  = this.scales,
	                degrees  = viewport.degrees,
	                position = viewport.pixelFromPoint(
	                    this.bounds.getTopLeft(),
	                    true
	                ),
	                size,
	                overlayCenter;
	
	            if ( element.parentNode != container ) {
	                //save the source parent for later if we need it
	                element.prevElementParent  = element.parentNode;
	                element.prevNextSibling    = element.nextSibling;
	                container.appendChild( element );
	                this.size = $.getElementSize( element );
	            }
	
	            if ( scales ) {
	                size = viewport.deltaPixelsFromPoints(
	                    this.bounds.getSize(),
	                    true
	                );
	            } else if ( this.checkResize ) {
	                size = $.getElementSize( element );
	            } else {
	                size = this.size;
	            }
	
	            this.position = position;
	            this.size     = size;
	
	            this.adjust( position, size );
	
	            position = position.apply( Math.round );
	            size     = size.apply( Math.round );
	
	            // rotate the position of the overlay
	            // TODO only rotate overlays if in canvas mode
	            // TODO replace the size rotation with CSS3 transforms
	            // TODO add an option to overlays to not rotate with the image
	            // Currently only rotates position and size
	            if( degrees !== 0 && this.scales ) {
	                overlayCenter = new $.Point( size.x / 2, size.y / 2 );
	
	                var drawerCenter = new $.Point(
	                    viewport.viewer.drawer.canvas.width / 2,
	                    viewport.viewer.drawer.canvas.height / 2
	                );
	                position = position.plus( overlayCenter ).rotate(
	                    degrees,
	                    drawerCenter
	                ).minus( overlayCenter );
	
	                size = size.rotate( degrees, new $.Point( 0, 0 ) );
	                size = new $.Point( Math.abs( size.x ), Math.abs( size.y ) );
	            }
	
	            // call the onDraw callback if it exists to allow one to overwrite
	            // the drawing/positioning/sizing of the overlay
	            if ( this.onDraw ) {
	                this.onDraw( position, size, element );
	            } else {
	                style.left     = position.x + "px";
	                style.top      = position.y + "px";
	                style.position = "absolute";
	
	                if (style.display != 'none') {
	                    style.display  = 'block';
	                }
	
	                if ( scales ) {
	                    style.width  = size.x + "px";
	                    style.height = size.y + "px";
	                }
	            }
	        },
	
	        /**
	         * @function
	         * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location
	         * @param {OpenSeadragon.OverlayPlacement} position
	         */
	        update: function( location, placement ) {
	            this.scales     = location instanceof $.Rect;
	            this.bounds     = new $.Rect(
	                location.x,
	                location.y,
	                location.width,
	                location.height
	            );
	            // rects are always top-left
	            this.placement  = location instanceof $.Point ?
	                placement :
	                $.OverlayPlacement.TOP_LEFT;
	        }
	
	    };
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Drawer
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Drawer
	 * @memberof OpenSeadragon
	 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
	 * @param {Object} options - Options for this Drawer.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this Drawer.
	 * @param {OpenSeadragon.Viewport} options.viewport - Reference to Viewer viewport.
	 * @param {Element} options.element - Parent element.
	 * @param {Number} [options.debugGridColor] - See debugGridColor in {@link OpenSeadragon.Options} for details.
	 */
	$.Drawer = function( options ) {
	
	    $.console.assert( options.viewer, "[Drawer] options.viewer is required" );
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    var args  = arguments;
	
	    if( !$.isPlainObject( options ) ){
	        options = {
	            source:     args[ 0 ], // Reference to Viewer tile source.
	            viewport:   args[ 1 ], // Reference to Viewer viewport.
	            element:    args[ 2 ]  // Parent element.
	        };
	    }
	
	    $.console.assert( options.viewport, "[Drawer] options.viewport is required" );
	    $.console.assert( options.element, "[Drawer] options.element is required" );
	
	    if ( options.source ) {
	        $.console.error( "[Drawer] options.source is no longer accepted; use TiledImage instead" );
	    }
	
	    this.viewer = options.viewer;
	    this.viewport = options.viewport;
	    this.debugGridColor = options.debugGridColor || $.DEFAULT_SETTINGS.debugGridColor;
	    if (options.opacity) {
	        $.console.error( "[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead" );
	    }
	
	    this.useCanvas  = $.supportsCanvas && ( this.viewer ? this.viewer.useCanvas : true );
	    /**
	     * The parent element of this Drawer instance, passed in when the Drawer was created.
	     * The parent of {@link OpenSeadragon.Drawer#canvas}.
	     * @member {Element} container
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.container  = $.getElement( options.element );
	    /**
	     * A &lt;canvas&gt; element if the browser supports them, otherwise a &lt;div&gt; element.
	     * Child element of {@link OpenSeadragon.Drawer#container}.
	     * @member {Element} canvas
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.canvas     = $.makeNeutralElement( this.useCanvas ? "canvas" : "div" );
	    /**
	     * 2d drawing context for {@link OpenSeadragon.Drawer#canvas} if it's a &lt;canvas&gt; element, otherwise null.
	     * @member {Object} context
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.context    = this.useCanvas ? this.canvas.getContext( "2d" ) : null;
	
	    /**
	     * Sketch canvas used to temporarily draw tiles which cannot be drawn directly
	     * to the main canvas due to opacity. Lazily initialized.
	     */
	    this.sketchCanvas = null;
	    this.sketchContext = null;
	
	    /**
	     * @member {Element} element
	     * @memberof OpenSeadragon.Drawer#
	     * @deprecated Alias for {@link OpenSeadragon.Drawer#container}.
	     */
	    this.element    = this.container;
	
	    // We force our container to ltr because our drawing math doesn't work in rtl.
	    // This issue only affects our canvas renderer, but we do it always for consistency.
	    // Note that this means overlays you want to be rtl need to be explicitly set to rtl.
	    this.container.dir = 'ltr';
	
	    // check canvas available width and height, set canvas width and height such that the canvas backing store is set to the proper pixel density
	    if (this.useCanvas) {
	        var viewportSize = this._calculateCanvasSize();
	        this.canvas.width = viewportSize.x;
	        this.canvas.height = viewportSize.y;
	    }
	
	    this.canvas.style.width     = "100%";
	    this.canvas.style.height    = "100%";
	    this.canvas.style.position  = "absolute";
	    $.setElementOpacity( this.canvas, this.opacity, true );
	
	    // explicit left-align
	    this.container.style.textAlign = "left";
	    this.container.appendChild( this.canvas );
	};
	
	$.Drawer.prototype = /** @lends OpenSeadragon.Drawer.prototype */{
	    // deprecated
	    addOverlay: function( element, location, placement, onDraw ) {
	        $.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead.");
	        this.viewer.addOverlay( element, location, placement, onDraw );
	        return this;
	    },
	
	    // deprecated
	    updateOverlay: function( element, location, placement ) {
	        $.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead.");
	        this.viewer.updateOverlay( element, location, placement );
	        return this;
	    },
	
	    // deprecated
	    removeOverlay: function( element ) {
	        $.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead.");
	        this.viewer.removeOverlay( element );
	        return this;
	    },
	
	    // deprecated
	    clearOverlays: function() {
	        $.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead.");
	        this.viewer.clearOverlays();
	        return this;
	    },
	
	    /**
	     * Set the opacity of the drawer.
	     * @param {Number} opacity
	     * @return {OpenSeadragon.Drawer} Chainable.
	     */
	    setOpacity: function( opacity ) {
	        $.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");
	        var world = this.viewer.world;
	        for (var i = 0; i < world.getItemCount(); i++) {
	            world.getItemAt( i ).setOpacity( opacity );
	        }
	        return this;
	    },
	
	    /**
	     * Get the opacity of the drawer.
	     * @returns {Number}
	     */
	    getOpacity: function() {
	        $.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");
	        var world = this.viewer.world;
	        var maxOpacity = 0;
	        for (var i = 0; i < world.getItemCount(); i++) {
	            var opacity = world.getItemAt( i ).getOpacity();
	            if ( opacity > maxOpacity ) {
	                maxOpacity = opacity;
	            }
	        }
	        return maxOpacity;
	    },
	
	    // deprecated
	    needsUpdate: function() {
	        $.console.error( "[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead." );
	        return this.viewer.world.needsDraw();
	    },
	
	    // deprecated
	    numTilesLoaded: function() {
	        $.console.error( "[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead." );
	        return this.viewer.tileCache.numTilesLoaded();
	    },
	
	    // deprecated
	    reset: function() {
	        $.console.error( "[Drawer.reset] this function is deprecated. Use World.resetItems instead." );
	        this.viewer.world.resetItems();
	        return this;
	    },
	
	    // deprecated
	    update: function() {
	        $.console.error( "[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead." );
	        this.clear();
	        this.viewer.world.draw();
	        return this;
	    },
	
	    /**
	     * @return {Boolean} True if rotation is supported.
	     */
	    canRotate: function() {
	        return this.useCanvas;
	    },
	
	    /**
	     * Destroy the drawer (unload current loaded tiles)
	     */
	    destroy: function() {
	        //force unloading of current canvas (1x1 will be gc later, trick not necessarily needed)
	        this.canvas.width  = 1;
	        this.canvas.height = 1;
	        this.sketchCanvas = null;
	        this.sketchContext = null;
	    },
	
	    /**
	     * Clears the Drawer so it's ready to draw another frame.
	     */
	    clear: function() {
	        this.canvas.innerHTML = "";
	        if ( this.useCanvas ) {
	            var viewportSize = this._calculateCanvasSize();
	            if( this.canvas.width != viewportSize.x ||
	                this.canvas.height != viewportSize.y ) {
	                this.canvas.width = viewportSize.x;
	                this.canvas.height = viewportSize.y;
	                if ( this.sketchCanvas !== null ) {
	                    this.sketchCanvas.width = this.canvas.width;
	                    this.sketchCanvas.height = this.canvas.height;
	                }
	            }
	            this._clear();
	        }
	    },
	
	    _clear: function ( useSketch ) {
	        if ( !this.useCanvas ) {
	            return;
	        }
	        var context = this._getContext( useSketch );
	        var canvas = context.canvas;
	        context.clearRect( 0, 0, canvas.width, canvas.height );
	    },
	
	    /**
	     * Translates from OpenSeadragon viewer rectangle to drawer rectangle.
	     * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
	     * @return {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
	     */
	    viewportToDrawerRectangle: function(rectangle) {
	        var topLeft = this.viewport.pixelFromPoint(rectangle.getTopLeft(), true);
	        var size = this.viewport.deltaPixelsFromPoints(rectangle.getSize(), true);
	
	        return new $.Rect(
	            topLeft.x * $.pixelDensityRatio,
	            topLeft.y * $.pixelDensityRatio,
	            size.x    * $.pixelDensityRatio,
	            size.y    * $.pixelDensityRatio
	        );
	    },
	
	    /**
	     * Draws the given tile.
	     * @param {OpenSeadragon.Tile} tile - The tile to draw.
	     * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
	     * drawingHandler({context, tile, rendered})
	     * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
	     * where <code>rendered</code> is the context with the pre-drawn image.
	     */
	    drawTile: function( tile, drawingHandler, useSketch ) {
	        $.console.assert(tile, '[Drawer.drawTile] tile is required');
	        $.console.assert(drawingHandler, '[Drawer.drawTile] drawingHandler is required');
	
	        if ( this.useCanvas ) {
	            var context = this._getContext( useSketch );
	            // TODO do this in a more performant way
	            // specifically, don't save,rotate,restore every time we draw a tile
	            if( this.viewport.degrees !== 0 ) {
	                this._offsetForRotation( tile, this.viewport.degrees, useSketch );
	                tile.drawCanvas( context, drawingHandler );
	                this._restoreRotationChanges( tile, useSketch );
	            } else {
	                tile.drawCanvas( context, drawingHandler );
	            }
	        } else {
	            tile.drawHTML( this.canvas );
	        }
	    },
	
	    _getContext: function( useSketch ) {
	        var context = this.context;
	        if ( useSketch ) {
	            if (this.sketchCanvas === null) {
	                this.sketchCanvas = document.createElement( "canvas" );
	                this.sketchCanvas.width = this.canvas.width;
	                this.sketchCanvas.height = this.canvas.height;
	                this.sketchContext = this.sketchCanvas.getContext( "2d" );
	            }
	            context = this.sketchContext;
	        }
	        return context;
	    },
	
	    // private
	    saveContext: function( useSketch ) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        this._getContext( useSketch ).save();
	    },
	
	    // private
	    restoreContext: function( useSketch ) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        this._getContext( useSketch ).restore();
	    },
	
	    // private
	    setClip: function(rect, useSketch) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        var context = this._getContext( useSketch );
	        context.beginPath();
	        context.rect(rect.x, rect.y, rect.width, rect.height);
	        context.clip();
	    },
	
	    // private
	    drawRectangle: function(rect, fillStyle, useSketch) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        var context = this._getContext( useSketch );
	        context.save();
	        context.fillStyle = fillStyle;
	        context.fillRect(rect.x, rect.y, rect.width, rect.height);
	        context.restore();
	    },
	
	    /**
	     * Blends the sketch canvas in the main canvas.
	     * @param {Float} opacity The opacity of the blending.
	     * @returns {undefined}
	     */
	    blendSketch: function(opacity) {
	        if (!this.useCanvas || !this.sketchCanvas) {
	            return;
	        }
	
	        this.context.save();
	        this.context.globalAlpha = opacity;
	        this.context.drawImage(this.sketchCanvas, 0, 0);
	        this.context.restore();
	    },
	
	    // private
	    drawDebugInfo: function( tile, count, i ){
	        if ( !this.useCanvas ) {
	            return;
	        }
	
	        var context = this.context;
	        context.save();
	        context.lineWidth = 2 * $.pixelDensityRatio;
	        context.font = 'small-caps bold ' + (13 * $.pixelDensityRatio) + 'px arial';
	        context.strokeStyle = this.debugGridColor;
	        context.fillStyle = this.debugGridColor;
	
	        if ( this.viewport.degrees !== 0 ) {
	            this._offsetForRotation( tile, this.viewport.degrees );
	        }
	
	        context.strokeRect(
	            tile.position.x * $.pixelDensityRatio,
	            tile.position.y * $.pixelDensityRatio,
	            tile.size.x * $.pixelDensityRatio,
	            tile.size.y * $.pixelDensityRatio
	        );
	
	        var tileCenterX = (tile.position.x + (tile.size.x / 2)) * $.pixelDensityRatio;
	        var tileCenterY = (tile.position.y + (tile.size.y / 2)) * $.pixelDensityRatio;
	
	        // Rotate the text the right way around.
	        context.translate( tileCenterX, tileCenterY );
	        context.rotate( Math.PI / 180 * -this.viewport.degrees );
	        context.translate( -tileCenterX, -tileCenterY );
	
	        if( tile.x === 0 && tile.y === 0 ){
	            context.fillText(
	                "Zoom: " + this.viewport.getZoom(),
	                tile.position.x * $.pixelDensityRatio,
	                (tile.position.y - 30) * $.pixelDensityRatio
	            );
	            context.fillText(
	                "Pan: " + this.viewport.getBounds().toString(),
	                tile.position.x * $.pixelDensityRatio,
	                (tile.position.y - 20) * $.pixelDensityRatio
	            );
	        }
	        context.fillText(
	            "Level: " + tile.level,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 20) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Column: " + tile.x,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 30) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Row: " + tile.y,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 40) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Order: " + i + " of " + count,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 50) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Size: " + tile.size.toString(),
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 60) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Position: " + tile.position.toString(),
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 70) * $.pixelDensityRatio
	        );
	
	        if ( this.viewport.degrees !== 0 ) {
	            this._restoreRotationChanges( tile );
	        }
	        context.restore();
	    },
	
	    // private
	    debugRect: function(rect) {
	        if ( this.useCanvas ) {
	            var context = this.context;
	            context.save();
	            context.lineWidth = 2 * $.pixelDensityRatio;
	            context.strokeStyle = this.debugGridColor;
	            context.fillStyle = this.debugGridColor;
	
	            context.strokeRect(
	                rect.x * $.pixelDensityRatio,
	                rect.y * $.pixelDensityRatio,
	                rect.width * $.pixelDensityRatio,
	                rect.height * $.pixelDensityRatio
	            );
	
	            context.restore();
	        }
	    },
	
	    // private
	    _offsetForRotation: function( tile, degrees, useSketch ){
	        var cx = this.canvas.width / 2,
	            cy = this.canvas.height / 2;
	
	        var context = this._getContext( useSketch );
	        context.save();
	
	        context.translate(cx, cy);
	        context.rotate( Math.PI / 180 * degrees);
	        context.translate(-cx, -cy);
	    },
	
	    // private
	    _restoreRotationChanges: function( tile, useSketch ){
	        var context = this._getContext( useSketch );
	        context.restore();
	    },
	
	    // private
	    _calculateCanvasSize: function() {
	        var pixelDensityRatio = $.pixelDensityRatio;
	        var viewportSize = this.viewport.getContainerSize();
	        return {
	            x: viewportSize.x * pixelDensityRatio,
	            y: viewportSize.y * pixelDensityRatio
	        };
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Viewport
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	
	/**
	 * @class Viewport
	 * @memberof OpenSeadragon
	 * @classdesc Handles coordinate-related functionality (zoom, pan, rotation, etc.)
	 * for an {@link OpenSeadragon.Viewer}.
	 * @param {Object} options - Options for this Viewport.
	 * @param {Object} [options.margins] - See viewportMargins in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.springStiffness] - See springStiffness in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.animationTime] - See animationTime in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomImageRatio] - See minZoomImageRatio in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.maxZoomPixelRatio] - See maxZoomPixelRatio in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.visibilityRatio] - See visibilityRatio in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapHorizontal] - See wrapHorizontal in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapVertical] - See wrapVertical in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.defaultZoomLevel] - See defaultZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomLevel] - See minZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.maxZoomLevel] - See maxZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.degrees] - See degrees in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.homeFillsViewer] - See homeFillsViewer in {@link OpenSeadragon.Options}.
	 */
	$.Viewport = function( options ) {
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    var args = arguments;
	    if(  args.length && args[ 0 ] instanceof $.Point ){
	        options = {
	            containerSize:  args[ 0 ],
	            contentSize:    args[ 1 ],
	            config:         args[ 2 ]
	        };
	    }
	
	    //options.config and the general config argument are deprecated
	    //in favor of the more direct specification of optional settings
	    //being passed directly on the options object
	    if ( options.config ){
	        $.extend( true, options, options.config );
	        delete options.config;
	    }
	
	    this._margins = $.extend({
	        left: 0,
	        top: 0,
	        right: 0,
	        bottom: 0
	    }, options.margins || {});
	
	    delete options.margins;
	
	    $.extend( true, this, {
	
	        //required settings
	        containerSize:      null,
	        contentSize:        null,
	
	        //internal state properties
	        zoomPoint:          null,
	        viewer:           null,
	
	        //configurable options
	        springStiffness:    $.DEFAULT_SETTINGS.springStiffness,
	        animationTime:      $.DEFAULT_SETTINGS.animationTime,
	        minZoomImageRatio:  $.DEFAULT_SETTINGS.minZoomImageRatio,
	        maxZoomPixelRatio:  $.DEFAULT_SETTINGS.maxZoomPixelRatio,
	        visibilityRatio:    $.DEFAULT_SETTINGS.visibilityRatio,
	        wrapHorizontal:     $.DEFAULT_SETTINGS.wrapHorizontal,
	        wrapVertical:       $.DEFAULT_SETTINGS.wrapVertical,
	        defaultZoomLevel:   $.DEFAULT_SETTINGS.defaultZoomLevel,
	        minZoomLevel:       $.DEFAULT_SETTINGS.minZoomLevel,
	        maxZoomLevel:       $.DEFAULT_SETTINGS.maxZoomLevel,
	        degrees:            $.DEFAULT_SETTINGS.degrees,
	        homeFillsViewer:    $.DEFAULT_SETTINGS.homeFillsViewer
	
	    }, options );
	
	    this._updateContainerInnerSize();
	
	    this.centerSpringX = new $.Spring({
	        initial: 0,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	    this.centerSpringY = new $.Spring({
	        initial: 0,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	    this.zoomSpring    = new $.Spring({
	        exponential: true,
	        initial: 1,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	
	    this._oldCenterX = this.centerSpringX.current.value;
	    this._oldCenterY = this.centerSpringY.current.value;
	    this._oldZoom    = this.zoomSpring.current.value;
	
	    if (this.contentSize) {
	        this.resetContentSize( this.contentSize );
	    } else {
	        this.setHomeBounds(new $.Rect(0, 0, 1, 1), 1);
	    }
	
	    this.goHome( true );
	    this.update();
	};
	
	$.Viewport.prototype = /** @lends OpenSeadragon.Viewport.prototype */{
	    /**
	     * Updates the viewport's home bounds and constraints for the given content size.
	     * @function
	     * @param {OpenSeadragon.Point} contentSize - size of the content in content units
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:reset-size
	     */
	    resetContentSize: function( contentSize ){
	        $.console.assert(contentSize, "[Viewport.resetContentSize] contentSize is required");
	        $.console.assert(contentSize instanceof $.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point");
	        $.console.assert(contentSize.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0");
	        $.console.assert(contentSize.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0");
	
	        this.setHomeBounds(new $.Rect(0, 0, 1, contentSize.y / contentSize.x), contentSize.x);
	        return this;
	    },
	
	    /**
	     * Updates the viewport's home bounds and constraints.
	     * @function
	     * @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
	     * @param {Number} contentFactor - how many content units per viewport unit
	     * @fires OpenSeadragon.Viewer.event:reset-size
	     */
	    setHomeBounds: function(bounds, contentFactor) {
	        $.console.assert(bounds, "[Viewport.setHomeBounds] bounds is required");
	        $.console.assert(bounds instanceof $.Rect, "[Viewport.setHomeBounds] bounds must be an OpenSeadragon.Rect");
	        $.console.assert(bounds.width > 0, "[Viewport.setHomeBounds] bounds.width must be greater than 0");
	        $.console.assert(bounds.height > 0, "[Viewport.setHomeBounds] bounds.height must be greater than 0");
	
	        this.homeBounds = bounds.clone();
	        this.contentSize = this.homeBounds.getSize().times(contentFactor);
	        this.contentAspectX = this.contentSize.x / this.contentSize.y;
	        this.contentAspectY = this.contentSize.y / this.contentSize.x;
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewer's content size or home bounds are reset
	             * (see {@link OpenSeadragon.Viewport#resetContentSize},
	             * {@link OpenSeadragon.Viewport#setHomeBounds}).
	             *
	             * @event reset-size
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} contentSize
	             * @property {OpenSeadragon.Rect} homeBounds
	             * @property {Number} contentFactor
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'reset-size', {
	                contentSize: this.contentSize.clone(),
	                contentFactor: contentFactor,
	                homeBounds: this.homeBounds.clone()
	            });
	        }
	    },
	
	    /**
	     * @function
	     */
	    getHomeZoom: function() {
	        if( this.defaultZoomLevel ){
	            return this.defaultZoomLevel;
	        } else {
	            var aspectFactor =
	                this.contentAspectX / this.getAspectRatio();
	
	            var output;
	            if( this.homeFillsViewer ){ // fill the viewer and clip the image
	                output = ( aspectFactor >= 1) ?
	                    aspectFactor :
	                    1;
	            } else {
	                output = ( aspectFactor >= 1 ) ?
	                    1 :
	                    aspectFactor;
	            }
	
	            return output / this.homeBounds.width;
	        }
	    },
	
	    /**
	     * @function
	     */
	    getHomeBounds: function() {
	        var center = this.homeBounds.getCenter( ),
	            width  = 1.0 / this.getHomeZoom( ),
	            height = width / this.getAspectRatio();
	
	        return new $.Rect(
	            center.x - ( width / 2.0 ),
	            center.y - ( height / 2.0 ),
	            width,
	            height
	        );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} immediately
	     * @fires OpenSeadragon.Viewer.event:home
	     */
	    goHome: function( immediately ) {
	        if( this.viewer ){
	            /**
	             * Raised when the "home" operation occurs (see {@link OpenSeadragon.Viewport#goHome}).
	             *
	             * @event home
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'home', {
	                immediately: immediately
	            });
	        }
	        return this.fitBounds( this.getHomeBounds(), immediately );
	    },
	
	    /**
	     * @function
	     */
	    getMinZoom: function() {
	        var homeZoom = this.getHomeZoom(),
	            zoom = this.minZoomLevel ?
	            this.minZoomLevel :
	                this.minZoomImageRatio * homeZoom;
	
	        return zoom;
	    },
	
	    /**
	     * @function
	     */
	    getMaxZoom: function() {
	        var zoom = this.maxZoomLevel;
	        if (!zoom) {
	            zoom = this.contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x;
	            zoom /= this.homeBounds.width;
	        }
	
	        return Math.max( zoom, this.getHomeZoom() );
	    },
	
	    /**
	     * @function
	     */
	    getAspectRatio: function() {
	        return this._containerInnerSize.x / this._containerInnerSize.y;
	    },
	
	    /**
	     * @function
	     * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
	     */
	    getContainerSize: function() {
	        return new $.Point(
	            this.containerSize.x,
	            this.containerSize.y
	        );
	    },
	
	    /**
	     * @function
	     * The margins push the "home" region in from the sides by the specified amounts.
	     * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
	     */
	    getMargins: function() {
	        return $.extend({}, this._margins); // Make a copy so we are not returning our original
	    },
	
	    /**
	     * @function
	     * The margins push the "home" region in from the sides by the specified amounts.
	     * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
	     */
	    setMargins: function(margins) {
	        $.console.assert($.type(margins) === 'object', '[Viewport.setMargins] margins must be an object');
	
	        this._margins = $.extend({
	            left: 0,
	            top: 0,
	            right: 0,
	            bottom: 0
	        }, margins);
	
	        this._updateContainerInnerSize();
	        this.viewer.forceRedraw();
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
	     */
	    getBounds: function( current ) {
	        var center = this.getCenter( current ),
	            width  = 1.0 / this.getZoom( current ),
	            height = width / this.getAspectRatio();
	
	        return new $.Rect(
	            center.x - ( width / 2.0 ),
	            center.y - ( height / 2.0 ),
	            width,
	            height
	        );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
	     * including the space taken by margins, in viewport coordinates.
	     */
	    getBoundsWithMargins: function( current ) {
	        var bounds = this.getBounds(current);
	        var factor = this._containerInnerSize.x * this.getZoom(current);
	        bounds.x -= this._margins.left / factor;
	        bounds.y -= this._margins.top / factor;
	        bounds.width += (this._margins.left + this._margins.right) / factor;
	        bounds.height += (this._margins.top + this._margins.bottom) / factor;
	        return bounds;
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    getCenter: function( current ) {
	        var centerCurrent = new $.Point(
	                this.centerSpringX.current.value,
	                this.centerSpringY.current.value
	            ),
	            centerTarget = new $.Point(
	                this.centerSpringX.target.value,
	                this.centerSpringY.target.value
	            ),
	            oldZoomPixel,
	            zoom,
	            width,
	            height,
	            bounds,
	            newZoomPixel,
	            deltaZoomPixels,
	            deltaZoomPoints;
	
	        if ( current ) {
	            return centerCurrent;
	        } else if ( !this.zoomPoint ) {
	            return centerTarget;
	        }
	
	        oldZoomPixel = this.pixelFromPoint(this.zoomPoint, true);
	
	        zoom    = this.getZoom();
	        width   = 1.0 / zoom;
	        height  = width / this.getAspectRatio();
	        bounds  = new $.Rect(
	            centerCurrent.x - width / 2.0,
	            centerCurrent.y - height / 2.0,
	            width,
	            height
	        );
	
	        newZoomPixel = this._pixelFromPoint(this.zoomPoint, bounds);
	        deltaZoomPixels = newZoomPixel.minus( oldZoomPixel );
	        deltaZoomPoints = deltaZoomPixels.divide( this._containerInnerSize.x * zoom );
	
	        return centerTarget.plus( deltaZoomPoints );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    getZoom: function( current ) {
	        if ( current ) {
	            return this.zoomSpring.current.value;
	        } else {
	            return this.zoomSpring.target.value;
	        }
	    },
	
	    /**
	     * @function
	     * @private
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Rect} constrained bounds.
	     */
	    _applyBoundaryConstraints: function( bounds, immediately ) {
	        var dx = 0,
	            dy = 0,
	            newBounds = new $.Rect(
	                bounds.x,
	                bounds.y,
	                bounds.width,
	                bounds.height
	            );
	
	        var horizontalThreshold = this.visibilityRatio * newBounds.width;
	        var verticalThreshold   = this.visibilityRatio * newBounds.height;
	
	        if ( this.wrapHorizontal ) {
	            //do nothing
	        } else {
	            var thresholdLeft = newBounds.x + (newBounds.width - horizontalThreshold);
	            if (this.homeBounds.x > thresholdLeft) {
	                dx = this.homeBounds.x - thresholdLeft;
	            }
	
	            var homeRight = this.homeBounds.x + this.homeBounds.width;
	            var thresholdRight = newBounds.x + horizontalThreshold;
	            if (homeRight < thresholdRight) {
	                var newDx = homeRight - thresholdRight;
	                if (dx) {
	                    dx = (dx + newDx) / 2;
	                } else {
	                    dx = newDx;
	                }
	            }
	        }
	
	        if ( this.wrapVertical ) {
	            //do nothing
	        } else {
	            var thresholdTop = newBounds.y + (newBounds.height - verticalThreshold);
	            if (this.homeBounds.y > thresholdTop) {
	                dy = this.homeBounds.y - thresholdTop;
	            }
	
	            var homeBottom = this.homeBounds.y + this.homeBounds.height;
	            var thresholdBottom = newBounds.y + verticalThreshold;
	            if (homeBottom < thresholdBottom) {
	                var newDy = homeBottom - thresholdBottom;
	                if (dy) {
	                    dy = (dy + newDy) / 2;
	                } else {
	                    dy = newDy;
	                }
	            }
	        }
	
	        if ( dx || dy ) {
	            newBounds.x += dx;
	            newBounds.y += dy;
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewport constraints are applied (see {@link OpenSeadragon.Viewport#applyConstraints}).
	             *
	             * @event constrain
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'constrain', {
	                immediately: immediately
	            });
	        }
	
	        return newBounds;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:constrain
	     */
	    applyConstraints: function( immediately ) {
	        var actualZoom = this.getZoom(),
	            constrainedZoom = Math.max(
	                Math.min( actualZoom, this.getMaxZoom() ),
	                this.getMinZoom()
	            ),
	            bounds,
	            constrainedBounds;
	
	        if ( actualZoom != constrainedZoom ) {
	            this.zoomTo( constrainedZoom, this.zoomPoint, immediately );
	        }
	
	        bounds = this.getBounds();
	
	        constrainedBounds = this._applyBoundaryConstraints( bounds, immediately );
	
	        if ( bounds.x !== constrainedBounds.x || bounds.y !== constrainedBounds.y || immediately ){
	            this.fitBounds( constrainedBounds, immediately );
	        }
	
	        return this;
	    },
	
	    /**
	     * @function
	     * @param {Boolean} immediately
	     */
	    ensureVisible: function( immediately ) {
	        return this.applyConstraints( immediately );
	    },
	
	    /**
	     * @function
	     * @private
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Object} options (immediately=false, constraints=false)
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    _fitBounds: function( bounds, options ) {
	        options = options || {};
	        var immediately = options.immediately || false;
	        var constraints = options.constraints || false;
	
	        var aspect = this.getAspectRatio(),
	            center = bounds.getCenter(),
	            newBounds = new $.Rect(
	                bounds.x,
	                bounds.y,
	                bounds.width,
	                bounds.height
	            ),
	            oldBounds,
	            oldZoom,
	            newZoom,
	            referencePoint,
	            newBoundsAspectRatio,
	            newConstrainedZoom;
	
	        if ( newBounds.getAspectRatio() >= aspect ) {
	            newBounds.height = bounds.width / aspect;
	            newBounds.y      = center.y - newBounds.height / 2;
	        } else {
	            newBounds.width = bounds.height * aspect;
	            newBounds.x     = center.x - newBounds.width / 2;
	        }
	
	        if ( constraints ) {
	            newBoundsAspectRatio = newBounds.getAspectRatio();
	        }
	
	        this.panTo( this.getCenter( true ), true );
	        this.zoomTo( this.getZoom( true ), null, true );
	
	        oldBounds = this.getBounds();
	        oldZoom   = this.getZoom();
	        newZoom   = 1.0 / newBounds.width;
	
	        if ( constraints ) {
	            newConstrainedZoom = Math.max(
	                Math.min(newZoom, this.getMaxZoom() ),
	                this.getMinZoom()
	            );
	
	            if (newZoom !== newConstrainedZoom) {
	                newZoom = newConstrainedZoom;
	                newBounds.width = 1.0 / newZoom;
	                newBounds.x = center.x - newBounds.width / 2;
	                newBounds.height = newBounds.width / newBoundsAspectRatio;
	                newBounds.y = center.y - newBounds.height / 2;
	            }
	
	            newBounds = this._applyBoundaryConstraints( newBounds, immediately );
	            center = newBounds.getCenter();
	        }
	
	        if (immediately) {
	            this.panTo( center, true );
	            return this.zoomTo(newZoom, null, true);
	        }
	
	        if (Math.abs(newZoom - oldZoom) < 0.00000001 ||
	                Math.abs(newBounds.width - oldBounds.width) < 0.00000001) {
	            return this.panTo( center, immediately );
	        }
	
	        referencePoint = oldBounds.getTopLeft().times(
	            this._containerInnerSize.x / oldBounds.width
	        ).minus(
	            newBounds.getTopLeft().times(
	                this._containerInnerSize.x / newBounds.width
	            )
	        ).divide(
	            this._containerInnerSize.x / oldBounds.width -
	            this._containerInnerSize.x / newBounds.width
	        );
	
	        return this.zoomTo( newZoom, referencePoint, immediately );
	    },
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitBounds: function( bounds, immediately ) {
	        return this._fitBounds( bounds, {
	            immediately: immediately,
	            constraints: false
	        } );
	    },
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitBoundsWithConstraints: function( bounds, immediately ) {
	        return this._fitBounds( bounds, {
	            immediately: immediately,
	            constraints: true
	        } );
	    },
	
	    /**
	     * Zooms so the image just fills the viewer vertically.
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitVertically: function( immediately ) {
	        var box = new $.Rect(this.homeBounds.x + (this.homeBounds.width / 2), this.homeBounds.y,
	            0, this.homeBounds.height);
	
	        return this.fitBounds( box, immediately );
	    },
	
	    /**
	     * Zooms so the image just fills the viewer horizontally.
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitHorizontally: function( immediately ) {
	        var box = new $.Rect(this.homeBounds.x, this.homeBounds.y + (this.homeBounds.height / 2),
	            this.homeBounds.width, 0);
	
	        return this.fitBounds( box, immediately );
	    },
	
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Point} delta
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pan
	     */
	    panBy: function( delta, immediately ) {
	        var center = new $.Point(
	            this.centerSpringX.target.value,
	            this.centerSpringY.target.value
	        );
	        delta = delta.rotate( -this.degrees, new $.Point( 0, 0 ) );
	        return this.panTo( center.plus( delta ), immediately );
	    },
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Point} center
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pan
	     */
	    panTo: function( center, immediately ) {
	        if ( immediately ) {
	            this.centerSpringX.resetTo( center.x );
	            this.centerSpringY.resetTo( center.y );
	        } else {
	            this.centerSpringX.springTo( center.x );
	            this.centerSpringY.springTo( center.y );
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewport is panned (see {@link OpenSeadragon.Viewport#panBy} and {@link OpenSeadragon.Viewport#panTo}).
	             *
	             * @event pan
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} center
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'pan', {
	                center: center,
	                immediately: immediately
	            });
	        }
	
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:zoom
	     */
	    zoomBy: function( factor, refPoint, immediately ) {
	        if( refPoint instanceof $.Point && !isNaN( refPoint.x ) && !isNaN( refPoint.y ) ) {
	            refPoint = refPoint.rotate(
	                -this.degrees,
	                new $.Point( this.centerSpringX.target.value, this.centerSpringY.target.value )
	            );
	        }
	        return this.zoomTo( this.zoomSpring.target.value * factor, refPoint, immediately );
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:zoom
	     */
	    zoomTo: function( zoom, refPoint, immediately ) {
	
	        this.zoomPoint = refPoint instanceof $.Point &&
	            !isNaN(refPoint.x) &&
	            !isNaN(refPoint.y) ?
	            refPoint :
	            null;
	
	        if ( immediately ) {
	            this.zoomSpring.resetTo( zoom );
	        } else {
	            this.zoomSpring.springTo( zoom );
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewport zoom level changes (see {@link OpenSeadragon.Viewport#zoomBy} and {@link OpenSeadragon.Viewport#zoomTo}).
	             *
	             * @event zoom
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Number} zoom
	             * @property {OpenSeadragon.Point} refPoint
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'zoom', {
	                zoom: zoom,
	                refPoint: refPoint,
	                immediately: immediately
	            });
	        }
	
	        return this;
	    },
	
	    /**
	     * Rotates this viewport to the angle specified.
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    setRotation: function( degrees ) {
	        if( !( this.viewer && this.viewer.drawer.canRotate() ) ) {
	            return this;
	        }
	
	        degrees = ( degrees + 360 ) % 360;
	        this.degrees = degrees;
	        this.viewer.forceRedraw();
	
	        /**
	         * Raised when rotation has been changed.
	         *
	         * @event rotate
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Number} degrees - The number of degrees the rotation was set to.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        if (this.viewer !== null)
	        {
	            this.viewer.raiseEvent('rotate', {"degrees": degrees});
	        }
	        return this;
	    },
	
	    /**
	     * Gets the current rotation in degrees.
	     * @function
	     * @return {Number} The current rotation in degrees.
	     */
	    getRotation: function() {
	        return this.degrees;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:resize
	     */
	    resize: function( newContainerSize, maintain ) {
	        var oldBounds = this.getBounds(),
	            newBounds = oldBounds,
	            widthDeltaFactor;
	
	        this.containerSize.x = newContainerSize.x;
	        this.containerSize.y = newContainerSize.y;
	
	        this._updateContainerInnerSize();
	
	        if ( maintain ) {
	            // TODO: widthDeltaFactor will always be 1; probably not what's intended
	            widthDeltaFactor = newContainerSize.x / this.containerSize.x;
	            newBounds.width  = oldBounds.width * widthDeltaFactor;
	            newBounds.height = newBounds.width / this.getAspectRatio();
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewer is resized (see {@link OpenSeadragon.Viewport#resize}).
	             *
	             * @event resize
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} newContainerSize
	             * @property {Boolean} maintain
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'resize', {
	                newContainerSize: newContainerSize,
	                maintain: maintain
	            });
	        }
	
	        return this.fitBounds( newBounds, true );
	    },
	
	    // private
	    _updateContainerInnerSize: function() {
	        this._containerInnerSize = new $.Point(
	            Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)),
	            Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom))
	        );
	    },
	
	    /**
	     * @function
	     */
	    update: function() {
	        var oldZoomPixel,
	            newZoomPixel,
	            deltaZoomPixels,
	            deltaZoomPoints;
	
	        if (this.zoomPoint) {
	            oldZoomPixel = this.pixelFromPoint( this.zoomPoint, true );
	        }
	
	        this.zoomSpring.update();
	
	        if (this.zoomPoint && this.zoomSpring.current.value != this._oldZoom) {
	            newZoomPixel    = this.pixelFromPoint( this.zoomPoint, true );
	            deltaZoomPixels = newZoomPixel.minus( oldZoomPixel );
	            deltaZoomPoints = this.deltaPointsFromPixels( deltaZoomPixels, true );
	
	            this.centerSpringX.shiftBy( deltaZoomPoints.x );
	            this.centerSpringY.shiftBy( deltaZoomPoints.y );
	        } else {
	            this.zoomPoint = null;
	        }
	
	        this.centerSpringX.update();
	        this.centerSpringY.update();
	
	        var changed = this.centerSpringX.current.value != this._oldCenterX ||
	            this.centerSpringY.current.value != this._oldCenterY ||
	            this.zoomSpring.current.value != this._oldZoom;
	
	        this._oldCenterX = this.centerSpringX.current.value;
	        this._oldCenterY = this.centerSpringY.current.value;
	        this._oldZoom    = this.zoomSpring.current.value;
	
	        return changed;
	    },
	
	
	    /**
	     * Convert a delta (translation vector) from pixels coordinates to viewport coordinates
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    deltaPixelsFromPoints: function( deltaPoints, current ) {
	        return deltaPoints.times(
	            this._containerInnerSize.x * this.getZoom( current )
	        );
	    },
	
	    /**
	     * Convert a delta (translation vector) from viewport coordinates to pixels coordinates.
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    deltaPointsFromPixels: function( deltaPixels, current ) {
	        return deltaPixels.divide(
	            this._containerInnerSize.x * this.getZoom( current )
	        );
	    },
	
	    /**
	     * Convert image pixel coordinates to viewport coordinates.
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    pixelFromPoint: function( point, current ) {
	        return this._pixelFromPoint(point, this.getBounds( current ));
	    },
	
	    // private
	    _pixelFromPoint: function( point, bounds ) {
	        return point.minus(
	            bounds.getTopLeft()
	        ).times(
	            this._containerInnerSize.x / bounds.width
	        ).plus(
	            new $.Point(this._margins.left, this._margins.top)
	        );
	    },
	
	    /**
	     * Convert viewport coordinates to image pixel coordinates.
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    pointFromPixel: function( pixel, current ) {
	        var bounds = this.getBounds( current );
	        return pixel.minus(
	            new $.Point(this._margins.left, this._margins.top)
	        ).divide(
	            this._containerInnerSize.x / bounds.width
	        ).plus(
	            bounds.getTopLeft()
	        );
	    },
	
	    // private
	    _viewportToImageDelta: function( viewerX, viewerY ) {
	        var scale = this.homeBounds.width;
	        return new $.Point(viewerX * (this.contentSize.x / scale),
	            viewerY * ((this.contentSize.y * this.contentAspectX) / scale));
	    },
	
	    /**
	     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
	     * This method can be called either by passing X,Y coordinates or an
	     * OpenSeadragon.Point
	     * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
	     * @function
	     * @param {OpenSeadragon.Point} viewerX the point in viewport coordinate system.
	     * @param {Number} viewerX X coordinate in viewport coordinate system.
	     * @param {Number} viewerY Y coordinate in viewport coordinate system.
	     * @return {OpenSeadragon.Point} a point representing the coordinates in the image.
	     */
	    viewportToImageCoordinates: function( viewerX, viewerY ) {
	        if ( arguments.length == 1 ) {
	            //they passed a point instead of individual components
	            return this.viewportToImageCoordinates( viewerX.x, viewerX.y );
	        }
	
	        if (this.viewer && this.viewer.world.getItemCount() > 1) {
	            $.console.error('[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.');
	        }
	
	        return this._viewportToImageDelta(viewerX - this.homeBounds.x, viewerY - this.homeBounds.y);
	    },
	
	    // private
	    _imageToViewportDelta: function( imageX, imageY ) {
	        var scale = this.homeBounds.width;
	        return new $.Point((imageX / this.contentSize.x) * scale,
	            (imageY / this.contentSize.y / this.contentAspectX) * scale);
	    },
	
	    /**
	     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
	     * This method can be called either by passing X,Y coordinates or an
	     * OpenSeadragon.Point
	     * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
	     * @function
	     * @param {OpenSeadragon.Point} imageX the point in image coordinate system.
	     * @param {Number} imageX X coordinate in image coordinate system.
	     * @param {Number} imageY Y coordinate in image coordinate system.
	     * @return {OpenSeadragon.Point} a point representing the coordinates in the viewport.
	     */
	    imageToViewportCoordinates: function( imageX, imageY ) {
	        if ( arguments.length == 1 ) {
	            //they passed a point instead of individual components
	            return this.imageToViewportCoordinates( imageX.x, imageX.y );
	        }
	
	        if (this.viewer && this.viewer.world.getItemCount() > 1) {
	            $.console.error('[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.');
	        }
	
	        var point = this._imageToViewportDelta(imageX, imageY);
	        point.x += this.homeBounds.x;
	        point.y += this.homeBounds.y;
	        return point;
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of the image in
	     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an
	     * OpenSeadragon.Rect
	     * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
	     * @function
	     * @param {OpenSeadragon.Rect} imageX the rectangle in image coordinate system.
	     * @param {Number} imageX the X coordinate of the top left corner of the rectangle
	     * in image coordinate system.
	     * @param {Number} imageY the Y coordinate of the top left corner of the rectangle
	     * in image coordinate system.
	     * @param {Number} pixelWidth the width in pixel of the rectangle.
	     * @param {Number} pixelHeight the height in pixel of the rectangle.
	     */
	    imageToViewportRectangle: function( imageX, imageY, pixelWidth, pixelHeight ) {
	        var coordA,
	            coordB,
	            rect;
	        if( arguments.length == 1 ) {
	            //they passed a rectangle instead of individual components
	            rect = imageX;
	            return this.imageToViewportRectangle(
	                rect.x, rect.y, rect.width, rect.height
	            );
	        }
	
	        coordA = this.imageToViewportCoordinates(
	            imageX, imageY
	        );
	        coordB = this._imageToViewportDelta(
	            pixelWidth, pixelHeight
	        );
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y
	        );
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of
	     * the viewport in point coordinates to image rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an
	     * OpenSeadragon.Rect
	     * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
	     * @function
	     * @param {OpenSeadragon.Rect} viewerX the rectangle in viewport coordinate system.
	     * @param {Number} viewerX the X coordinate of the top left corner of the rectangle
	     * in viewport coordinate system.
	     * @param {Number} imageY the Y coordinate of the top left corner of the rectangle
	     * in viewport coordinate system.
	     * @param {Number} pointWidth the width of the rectangle in viewport coordinate system.
	     * @param {Number} pointHeight the height of the rectangle in viewport coordinate system.
	     */
	    viewportToImageRectangle: function( viewerX, viewerY, pointWidth, pointHeight ) {
	        var coordA,
	            coordB,
	            rect;
	        if ( arguments.length == 1 ) {
	            //they passed a rectangle instead of individual components
	            rect = viewerX;
	            return this.viewportToImageRectangle(
	                rect.x, rect.y, rect.width, rect.height
	            );
	        }
	
	        coordA = this.viewportToImageCoordinates( viewerX, viewerY );
	        coordB = this._viewportToImageDelta(pointWidth, pointHeight);
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y
	        );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to image
	     * coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToImageCoordinates: function( pixel ) {
	        var point = this.pointFromPixel( pixel, true );
	        return this.viewportToImageCoordinates( point );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the image to
	     * viewer element coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToViewerElementCoordinates: function( pixel ) {
	        var point = this.imageToViewportCoordinates( pixel );
	        return this.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to image coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToImageCoordinates: function( pixel ) {
	        var viewerCoordinates = pixel.minus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	        return this.viewerElementToImageCoordinates( viewerCoordinates );
	    },
	
	    /**
	     * Convert image coordinates to pixel coordinates relative to the window.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToWindowCoordinates: function( pixel ) {
	        var viewerCoordinates = this.imageToViewerElementCoordinates( pixel );
	        return viewerCoordinates.plus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to viewport
	     * coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToViewportCoordinates: function( pixel ) {
	        return this.pointFromPixel( pixel, true );
	    },
	
	    /**
	     * Convert viewport coordinates to pixel coordinates relative to the
	     * viewer element.
	     * @param {OpenSeadragon.Point} point
	     * @returns {OpenSeadragon.Point}
	     */
	    viewportToViewerElementCoordinates: function( point ) {
	        return this.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to viewport coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToViewportCoordinates: function( pixel ) {
	        var viewerCoordinates = pixel.minus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	        return this.viewerElementToViewportCoordinates( viewerCoordinates );
	    },
	
	    /**
	     * Convert viewport coordinates to pixel coordinates relative to the window.
	     * @param {OpenSeadragon.Point} point
	     * @returns {OpenSeadragon.Point}
	     */
	    viewportToWindowCoordinates: function( point ) {
	        var viewerCoordinates = this.viewportToViewerElementCoordinates( point );
	        return viewerCoordinates.plus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	    },
	
	    /**
	     * Convert a viewport zoom to an image zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} viewportZoom The viewport zoom
	     * target zoom.
	     * @returns {Number} imageZoom The image zoom
	     */
	    viewportToImageZoom: function( viewportZoom ) {
	        if (this.viewer && this.viewer.world.getItemCount() > 1) {
	            $.console.error('[Viewport.viewportToImageZoom] is not accurate with multi-image.');
	        }
	
	        var imageWidth = this.contentSize.x;
	        var containerWidth = this._containerInnerSize.x;
	        var scale = this.homeBounds.width;
	        var viewportToImageZoomRatio = (containerWidth / imageWidth) * scale;
	        return viewportZoom * viewportToImageZoomRatio;
	    },
	
	    /**
	     * Convert an image zoom to a viewport zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} imageZoom The image zoom
	     * target zoom.
	     * @returns {Number} viewportZoom The viewport zoom
	     */
	    imageToViewportZoom: function( imageZoom ) {
	        if (this.viewer && this.viewer.world.getItemCount() > 1) {
	            $.console.error('[Viewport.imageToViewportZoom] is not accurate with multi-image.');
	        }
	
	        var imageWidth = this.contentSize.x;
	        var containerWidth = this._containerInnerSize.x;
	        var scale = this.homeBounds.width;
	        var viewportToImageZoomRatio = (imageWidth / containerWidth) / scale;
	        return imageZoom * viewportToImageZoomRatio;
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TiledImage
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * You shouldn't have to create a TiledImage directly; use {@link OpenSeadragon.Viewer#open}
	 * or {@link OpenSeadragon.Viewer#addTiledImage} instead.
	 * @class TiledImage
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
	 * A new instance is created for each TileSource opened.
	 * @param {Object} options - Configuration for this TiledImage.
	 * @param {OpenSeadragon.TileSource} options.source - The TileSource that defines this TiledImage.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this TiledImage.
	 * @param {OpenSeadragon.TileCache} options.tileCache - The TileCache for this TiledImage to use.
	 * @param {OpenSeadragon.Drawer} options.drawer - The Drawer for this TiledImage to draw onto.
	 * @param {OpenSeadragon.ImageLoader} options.imageLoader - The ImageLoader for this TiledImage to use.
	 * @param {Number} [options.x=0] - Left position, in viewport coordinates.
	 * @param {Number} [options.y=0] - Top position, in viewport coordinates.
	 * @param {Number} [options.width=1] - Width, in viewport coordinates.
	 * @param {Number} [options.height] - Height, in viewport coordinates.
	 * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
	 * (portions of the image outside of this area will not be visible). Only works on
	 * browsers that support the HTML5 canvas.
	 * @param {Number} [options.springStiffness] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.animationTime] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomImageRatio] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapHorizontal] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapVertical] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.immediateRender] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.blendTime] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.alwaysBlend] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minPixelRatio] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.opacity=1] - Opacity the tiled image should be drawn at.
	 * @param {Boolean} [options.debugMode] - See {@link OpenSeadragon.Options}.
	 * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
	 * @param {String|Boolean} [options.crossOriginPolicy] - See {@link OpenSeadragon.Options}.
	 */
	$.TiledImage = function( options ) {
	    var _this = this;
	
	    $.console.assert( options.tileCache, "[TiledImage] options.tileCache is required" );
	    $.console.assert( options.drawer, "[TiledImage] options.drawer is required" );
	    $.console.assert( options.viewer, "[TiledImage] options.viewer is required" );
	    $.console.assert( options.imageLoader, "[TiledImage] options.imageLoader is required" );
	    $.console.assert( options.source, "[TiledImage] options.source is required" );
	    $.console.assert(!options.clip || options.clip instanceof $.Rect,
	        "[TiledImage] options.clip must be an OpenSeadragon.Rect if present");
	
	    $.EventSource.call( this );
	
	    this._tileCache = options.tileCache;
	    delete options.tileCache;
	
	    this._drawer = options.drawer;
	    delete options.drawer;
	
	    this._imageLoader = options.imageLoader;
	    delete options.imageLoader;
	
	    if (options.clip instanceof $.Rect) {
	        this._clip = options.clip.clone();
	    }
	
	    delete options.clip;
	
	    var x = options.x || 0;
	    delete options.x;
	    var y = options.y || 0;
	    delete options.y;
	
	    // Ratio of zoomable image height to width.
	    this.normHeight = options.source.dimensions.y / options.source.dimensions.x;
	    this.contentAspectX = options.source.dimensions.x / options.source.dimensions.y;
	
	    var scale = 1;
	    if ( options.width ) {
	        scale = options.width;
	        delete options.width;
	
	        if ( options.height ) {
	            $.console.error( "specifying both width and height to a tiledImage is not supported" );
	            delete options.height;
	        }
	    } else if ( options.height ) {
	        scale = options.height / this.normHeight;
	        delete options.height;
	    }
	
	    $.extend( true, this, {
	
	        //internal state properties
	        viewer:         null,
	        tilesMatrix:    {},    // A '3d' dictionary [level][x][y] --> Tile.
	        coverage:       {},    // A '3d' dictionary [level][x][y] --> Boolean.
	        lastDrawn:      [],    // An unordered list of Tiles drawn last frame.
	        lastResetTime:  0,     // Last time for which the tiledImage was reset.
	        _midDraw:       false, // Is the tiledImage currently updating the viewport?
	        _needsDraw:     true,  // Does the tiledImage need to update the viewport again?
	        _hasOpaqueTile: false,  // Do we have even one fully opaque tile?
	
	        //configurable settings
	        springStiffness:      $.DEFAULT_SETTINGS.springStiffness,
	        animationTime:        $.DEFAULT_SETTINGS.animationTime,
	        minZoomImageRatio:    $.DEFAULT_SETTINGS.minZoomImageRatio,
	        wrapHorizontal:       $.DEFAULT_SETTINGS.wrapHorizontal,
	        wrapVertical:         $.DEFAULT_SETTINGS.wrapVertical,
	        immediateRender:      $.DEFAULT_SETTINGS.immediateRender,
	        blendTime:            $.DEFAULT_SETTINGS.blendTime,
	        alwaysBlend:          $.DEFAULT_SETTINGS.alwaysBlend,
	        minPixelRatio:        $.DEFAULT_SETTINGS.minPixelRatio,
	        debugMode:            $.DEFAULT_SETTINGS.debugMode,
	        crossOriginPolicy:    $.DEFAULT_SETTINGS.crossOriginPolicy,
	        placeholderFillStyle: $.DEFAULT_SETTINGS.placeholderFillStyle,
	        opacity:              $.DEFAULT_SETTINGS.opacity
	
	    }, options );
	
	    this._xSpring = new $.Spring({
	        initial: x,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._ySpring = new $.Spring({
	        initial: y,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._scaleSpring = new $.Spring({
	        initial: scale,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._updateForScale();
	
	    // We need a callback to give image manipulation a chance to happen
	    this._drawingHandler = function(args) {
	      /**
	       * This event is fired just before the tile is drawn giving the application a chance to alter the image.
	       *
	       * NOTE: This event is only fired when the drawer is using a <canvas>.
	       *
	       * @event tile-drawing
	       * @memberof OpenSeadragon.Viewer
	       * @type {object}
	       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	       * @property {OpenSeadragon.Tile} tile - The Tile being drawn.
	       * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	       * @property {OpenSeadragon.Tile} context - The HTML canvas context being drawn into.
	       * @property {OpenSeadragon.Tile} rendered - The HTML canvas context containing the tile imagery.
	       * @property {?Object} userData - Arbitrary subscriber-defined object.
	       */
	        _this.viewer.raiseEvent('tile-drawing', $.extend({
	            tiledImage: _this
	        }, args));
	    };
	};
	
	$.extend($.TiledImage.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.TiledImage.prototype */{
	    /**
	     * @returns {Boolean} Whether the TiledImage needs to be drawn.
	     */
	    needsDraw: function() {
	        return this._needsDraw;
	    },
	
	    /**
	     * Clears all tiles and triggers an update on the next call to
	     * {@link OpenSeadragon.TiledImage#update}.
	     */
	    reset: function() {
	        this._tileCache.clearTilesFor(this);
	        this.lastResetTime = $.now();
	        this._needsDraw = true;
	    },
	
	    /**
	     * Updates the TiledImage's bounds, animating if needed.
	     * @returns {Boolean} Whether the TiledImage animated.
	     */
	    update: function() {
	        var oldX = this._xSpring.current.value;
	        var oldY = this._ySpring.current.value;
	        var oldScale = this._scaleSpring.current.value;
	
	        this._xSpring.update();
	        this._ySpring.update();
	        this._scaleSpring.update();
	
	        if (this._xSpring.current.value !== oldX || this._ySpring.current.value !== oldY ||
	                this._scaleSpring.current.value !== oldScale) {
	            this._updateForScale();
	            this._needsDraw = true;
	            return true;
	        }
	
	        return false;
	    },
	
	    /**
	     * Draws the TiledImage to its Drawer.
	     */
	    draw: function() {
	        this._midDraw = true;
	        updateViewport( this );
	        this._midDraw = false;
	    },
	
	    /**
	     * Destroy the TiledImage (unload current loaded tiles).
	     */
	    destroy: function() {
	        this.reset();
	    },
	
	    /**
	     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
	     * @param {Boolean} [current=false] - Pass true for the current location; false for target location.
	     */
	    getBounds: function(current) {
	        if (current) {
	            return new $.Rect( this._xSpring.current.value, this._ySpring.current.value,
	                this._worldWidthCurrent, this._worldHeightCurrent );
	        }
	
	        return new $.Rect( this._xSpring.target.value, this._ySpring.target.value,
	            this._worldWidthTarget, this._worldHeightTarget );
	    },
	
	    // deprecated
	    getWorldBounds: function() {
	        $.console.error('[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead');
	        return this.getBounds();
	    },
	
	    /**
	     * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
	     */
	    getContentSize: function() {
	        return new $.Point(this.source.dimensions.x, this.source.dimensions.y);
	    },
	
	    // private
	    _viewportToImageDelta: function( viewerX, viewerY, current ) {
	        var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
	        return new $.Point(viewerX * (this.source.dimensions.x / scale),
	            viewerY * ((this.source.dimensions.y * this.contentAspectX) / scale));
	    },
	
	    /**
	     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
	     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
	     * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
	     * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Point} A point representing the coordinates in the image.
	     */
	    viewportToImageCoordinates: function( viewerX, viewerY, current ) {
	        if (viewerX instanceof $.Point) {
	            //they passed a point instead of individual components
	            current = viewerY;
	            viewerY = viewerX.y;
	            viewerX = viewerX.x;
	        }
	
	        if (current) {
	            return this._viewportToImageDelta(viewerX - this._xSpring.current.value,
	                viewerY - this._ySpring.current.value);
	        }
	
	        return this._viewportToImageDelta(viewerX - this._xSpring.target.value,
	            viewerY - this._ySpring.target.value);
	    },
	
	    // private
	    _imageToViewportDelta: function( imageX, imageY, current ) {
	        var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
	        return new $.Point((imageX / this.source.dimensions.x) * scale,
	            (imageY / this.source.dimensions.y / this.contentAspectX) * scale);
	    },
	
	    /**
	     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
	     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
	     * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
	     * @param {Number} [imageY] - The Y coordinate in image coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Point} A point representing the coordinates in the viewport.
	     */
	    imageToViewportCoordinates: function( imageX, imageY, current ) {
	        if (imageX instanceof $.Point) {
	            //they passed a point instead of individual components
	            current = imageY;
	            imageY = imageX.y;
	            imageX = imageX.x;
	        }
	
	        var point = this._imageToViewportDelta(imageX, imageY);
	        if (current) {
	            point.x += this._xSpring.current.value;
	            point.y += this._ySpring.current.value;
	        } else {
	            point.x += this._xSpring.target.value;
	            point.y += this._ySpring.target.value;
	        }
	
	        return point;
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of the image in
	     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
	     * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
	     * @param {Number} [imageY] - The top coordinate in image coordinate system.
	     * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
	     * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
	     */
	    imageToViewportRectangle: function( imageX, imageY, pixelWidth, pixelHeight, current ) {
	        if (imageX instanceof $.Rect) {
	            //they passed a rect instead of individual components
	            current = imageY;
	            pixelWidth = imageX.width;
	            pixelHeight = imageX.height;
	            imageY = imageX.y;
	            imageX = imageX.x;
	        }
	
	        var coordA = this.imageToViewportCoordinates(imageX, imageY, current);
	        var coordB = this._imageToViewportDelta(pixelWidth, pixelHeight, current);
	
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y
	        );
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of
	     * the viewport in point coordinates to image rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
	     * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
	     * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
	     * @param {Number} [pointWidth] - The width in viewport coordinate system.
	     * @param {Number} [pointHeight] - The height in viewport coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the image.
	     */
	    viewportToImageRectangle: function( viewerX, viewerY, pointWidth, pointHeight, current ) {
	        if (viewerX instanceof $.Rect) {
	            //they passed a rect instead of individual components
	            current = viewerY;
	            pointWidth = viewerX.width;
	            pointHeight = viewerX.height;
	            viewerY = viewerX.y;
	            viewerX = viewerX.x;
	        }
	
	        var coordA = this.viewportToImageCoordinates(viewerX, viewerY, current);
	        var coordB = this._viewportToImageDelta(pointWidth, pointHeight, current);
	
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y
	        );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to image
	     * coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToImageCoordinates: function( pixel ) {
	        var point = this.viewport.pointFromPixel( pixel, true );
	        return this.viewportToImageCoordinates( point );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the image to
	     * viewer element coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToViewerElementCoordinates: function( pixel ) {
	        var point = this.imageToViewportCoordinates( pixel );
	        return this.viewport.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to image coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToImageCoordinates: function( pixel ) {
	        var viewerCoordinates = pixel.minus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	        return this.viewerElementToImageCoordinates( viewerCoordinates );
	    },
	
	    /**
	     * Convert image coordinates to pixel coordinates relative to the window.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToWindowCoordinates: function( pixel ) {
	        var viewerCoordinates = this.imageToViewerElementCoordinates( pixel );
	        return viewerCoordinates.plus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	    },
	
	    /**
	     * Convert a viewport zoom to an image zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * @function
	     * @param {Number} viewportZoom The viewport zoom
	     * @returns {Number} imageZoom The image zoom
	     */
	    viewportToImageZoom: function( viewportZoom ) {
	        var ratio = this._scaleSpring.current.value *
	                this.viewport._containerInnerSize.x / this.source.dimensions.x;
	        return ratio * viewportZoom ;
	    },
	
	    /**
	     * Convert an image zoom to a viewport zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} imageZoom The image zoom
	     * @returns {Number} viewportZoom The viewport zoom
	     */
	    imageToViewportZoom: function( imageZoom ) {
	        var ratio = this._scaleSpring.current.value *
	                this.viewport._containerInnerSize.x / this.source.dimensions.x;
	        return imageZoom / ratio;
	    },
	
	    /**
	     * Sets the TiledImage's position in the world.
	     * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setPosition: function(position, immediately) {
	        var sameTarget = (this._xSpring.target.value === position.x &&
	            this._ySpring.target.value === position.y);
	
	        if (immediately) {
	            if (sameTarget && this._xSpring.current.value === position.x &&
	                    this._ySpring.current.value === position.y) {
	                return;
	            }
	
	            this._xSpring.resetTo(position.x);
	            this._ySpring.resetTo(position.y);
	            this._needsDraw = true;
	        } else {
	            if (sameTarget) {
	                return;
	            }
	
	            this._xSpring.springTo(position.x);
	            this._ySpring.springTo(position.y);
	            this._needsDraw = true;
	        }
	
	        if (!sameTarget) {
	            this._raiseBoundsChange();
	        }
	    },
	
	    /**
	     * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
	     * @param {Number} width - The new width, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setWidth: function(width, immediately) {
	        this._setScale(width, immediately);
	    },
	
	    /**
	     * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
	     * @param {Number} height - The new height, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setHeight: function(height, immediately) {
	        this._setScale(height / this.normHeight, immediately);
	    },
	
	    /**
	     * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
	     * in image pixels, or null if none.
	     */
	    getClip: function() {
	        if (this._clip) {
	            return this._clip.clone();
	        }
	
	        return null;
	    },
	
	    /**
	     * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
	     * (portions of the image outside of this area will not be visible). Only works on
	     * browsers that support the HTML5 canvas.
	     */
	    setClip: function(newClip) {
	        $.console.assert(!newClip || newClip instanceof $.Rect,
	            "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null");
	
	        if (newClip instanceof $.Rect) {
	            this._clip = newClip.clone();
	        } else {
	            this._clip = null;
	        }
	
	        this._needsDraw = true;
	    },
	
	    /**
	     * @returns {Number} The TiledImage's current opacity.
	     */
	    getOpacity: function() {
	        return this.opacity;
	    },
	
	    /**
	     * @param {Number} opacity Opacity the tiled image should be drawn at.
	     */
	    setOpacity: function(opacity) {
	        this.opacity = opacity;
	        this._needsDraw = true;
	    },
	
	    // private
	    _setScale: function(scale, immediately) {
	        var sameTarget = (this._scaleSpring.target.value === scale);
	        if (immediately) {
	            if (sameTarget && this._scaleSpring.current.value === scale) {
	                return;
	            }
	
	            this._scaleSpring.resetTo(scale);
	            this._updateForScale();
	            this._needsDraw = true;
	        } else {
	            if (sameTarget) {
	                return;
	            }
	
	            this._scaleSpring.springTo(scale);
	            this._updateForScale();
	            this._needsDraw = true;
	        }
	
	        if (!sameTarget) {
	            this._raiseBoundsChange();
	        }
	    },
	
	    // private
	    _updateForScale: function() {
	        this._worldWidthTarget = this._scaleSpring.target.value;
	        this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value;
	        this._worldWidthCurrent = this._scaleSpring.current.value;
	        this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
	    },
	
	    // private
	    _raiseBoundsChange: function() {
	        /**
	         * Raised when the TiledImage's bounds are changed.
	         * Note that this event is triggered only when the animation target is changed;
	         * not for every frame of animation.
	         * @event bounds-change
	         * @memberOf OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {OpenSeadragon.World} eventSource - A reference to the TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('bounds-change');
	    }
	});
	
	/**
	 * @private
	 * @inner
	 * Pretty much every other line in this needs to be documented so it's clear
	 * how each piece of this routine contributes to the drawing process.  That's
	 * why there are so many TODO's inside this function.
	 */
	function updateViewport( tiledImage ) {
	
	    tiledImage._needsDraw = false;
	
	    var tile,
	        level,
	        best            = null,
	        haveDrawn       = false,
	        currentTime     = $.now(),
	        viewportBounds  = tiledImage.viewport.getBoundsWithMargins( true ),
	        zeroRatioC      = tiledImage.viewport.deltaPixelsFromPoints(
	            tiledImage.source.getPixelRatio( 0 ),
	            true
	        ).x * tiledImage._scaleSpring.current.value,
	        lowestLevel     = Math.max(
	            tiledImage.source.minLevel,
	            Math.floor(
	                Math.log( tiledImage.minZoomImageRatio ) /
	                Math.log( 2 )
	            )
	        ),
	        highestLevel    = Math.min(
	            Math.abs(tiledImage.source.maxLevel),
	            Math.abs(Math.floor(
	                Math.log( zeroRatioC / tiledImage.minPixelRatio ) /
	                Math.log( 2 )
	            ))
	        ),
	        degrees         = tiledImage.viewport.degrees,
	        renderPixelRatioC,
	        renderPixelRatioT,
	        zeroRatioT,
	        optimalRatio,
	        levelOpacity,
	        levelVisibility;
	
	    viewportBounds.x -= tiledImage._xSpring.current.value;
	    viewportBounds.y -= tiledImage._ySpring.current.value;
	
	    // Reset tile's internal drawn state
	    while ( tiledImage.lastDrawn.length > 0 ) {
	        tile = tiledImage.lastDrawn.pop();
	        tile.beingDrawn = false;
	    }
	
	    //Change bounds for rotation
	    if (degrees === 90 || degrees === 270) {
	        viewportBounds = viewportBounds.rotate( degrees );
	    } else if (degrees !== 0 && degrees !== 180) {
	        // This is just an approximation.
	        var orthBounds = viewportBounds.rotate(90);
	        viewportBounds.x -= orthBounds.width / 2;
	        viewportBounds.y -= orthBounds.height / 2;
	        viewportBounds.width += orthBounds.width;
	        viewportBounds.height += orthBounds.height;
	    }
	
	    var viewportTL = viewportBounds.getTopLeft();
	    var viewportBR = viewportBounds.getBottomRight();
	
	    //Don't draw if completely outside of the viewport
	    if  ( !tiledImage.wrapHorizontal && (viewportBR.x < 0 || viewportTL.x > tiledImage._worldWidthCurrent ) ) {
	        return;
	    }
	
	    if ( !tiledImage.wrapVertical && ( viewportBR.y < 0 || viewportTL.y > tiledImage._worldHeightCurrent ) ) {
	        return;
	    }
	
	    // Calculate viewport rect / bounds
	    if ( !tiledImage.wrapHorizontal ) {
	        viewportTL.x = Math.max( viewportTL.x, 0 );
	        viewportBR.x = Math.min( viewportBR.x, tiledImage._worldWidthCurrent );
	    }
	
	    if ( !tiledImage.wrapVertical ) {
	        viewportTL.y = Math.max( viewportTL.y, 0 );
	        viewportBR.y = Math.min( viewportBR.y, tiledImage._worldHeightCurrent );
	    }
	
	    // Calculations for the interval of levels to draw
	    // (above in initial var statement)
	    // can return invalid intervals; fix that here if necessary
	    lowestLevel = Math.min( lowestLevel, highestLevel );
	
	    // Update any level that will be drawn
	    var drawLevel; // FIXME: drawLevel should have a more explanatory name
	    for ( level = highestLevel; level >= lowestLevel; level-- ) {
	        drawLevel = false;
	
	        //Avoid calculations for draw if we have already drawn this
	        renderPixelRatioC = tiledImage.viewport.deltaPixelsFromPoints(
	            tiledImage.source.getPixelRatio( level ),
	            true
	        ).x * tiledImage._scaleSpring.current.value;
	
	        if ( ( !haveDrawn && renderPixelRatioC >= tiledImage.minPixelRatio ) ||
	             ( level == lowestLevel ) ) {
	            drawLevel = true;
	            haveDrawn = true;
	        } else if ( !haveDrawn ) {
	            continue;
	        }
	
	        //Perform calculations for draw if we haven't drawn this
	        renderPixelRatioT = tiledImage.viewport.deltaPixelsFromPoints(
	            tiledImage.source.getPixelRatio( level ),
	            false
	        ).x * tiledImage._scaleSpring.current.value;
	
	        zeroRatioT      = tiledImage.viewport.deltaPixelsFromPoints(
	            tiledImage.source.getPixelRatio(
	                Math.max(
	                    tiledImage.source.getClosestLevel( tiledImage.viewport.containerSize ) - 1,
	                    0
	                )
	            ),
	            false
	        ).x * tiledImage._scaleSpring.current.value;
	
	        optimalRatio    = tiledImage.immediateRender ?
	            1 :
	            zeroRatioT;
	
	        levelOpacity    = Math.min( 1, ( renderPixelRatioC - 0.5 ) / 0.5 );
	
	        levelVisibility = optimalRatio / Math.abs(
	            optimalRatio - renderPixelRatioT
	        );
	
	        // Update the level and keep track of 'best' tile to load
	        best = updateLevel(
	            tiledImage,
	            haveDrawn,
	            drawLevel,
	            level,
	            levelOpacity,
	            levelVisibility,
	            viewportTL,
	            viewportBR,
	            currentTime,
	            best
	        );
	
	        // Stop the loop if lower-res tiles would all be covered by
	        // already drawn tiles
	        if (  providesCoverage( tiledImage.coverage, level ) ) {
	            break;
	        }
	    }
	
	    // Perform the actual drawing
	    drawTiles( tiledImage, tiledImage.lastDrawn );
	
	    // Load the new 'best' tile
	    if (best && !best.context2D) {
	        loadTile( tiledImage, best, currentTime );
	    }
	
	}
	
	
	function updateLevel( tiledImage, haveDrawn, drawLevel, level, levelOpacity, levelVisibility, viewportTL, viewportBR, currentTime, best ){
	
	    var x, y,
	        tileTL,
	        tileBR,
	        numberOfTiles,
	        viewportCenter  = tiledImage.viewport.pixelFromPoint( tiledImage.viewport.getCenter() );
	
	
	    if( tiledImage.viewer ){
	        /**
	         * <em>- Needs documentation -</em>
	         *
	         * @event update-level
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	         * @property {Object} havedrawn
	         * @property {Object} level
	         * @property {Object} opacity
	         * @property {Object} visibility
	         * @property {Object} topleft
	         * @property {Object} bottomright
	         * @property {Object} currenttime
	         * @property {Object} best
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        tiledImage.viewer.raiseEvent( 'update-level', {
	            tiledImage: tiledImage,
	            havedrawn: haveDrawn,
	            level: level,
	            opacity: levelOpacity,
	            visibility: levelVisibility,
	            topleft: viewportTL,
	            bottomright: viewportBR,
	            currenttime: currentTime,
	            best: best
	        });
	    }
	
	    //OK, a new drawing so do your calculations
	    tileTL    = tiledImage.source.getTileAtPoint( level, viewportTL.divide( tiledImage._scaleSpring.current.value ));
	    tileBR    = tiledImage.source.getTileAtPoint( level, viewportBR.divide( tiledImage._scaleSpring.current.value ));
	    numberOfTiles  = tiledImage.source.getNumTiles( level );
	
	    resetCoverage( tiledImage.coverage, level );
	
	    if ( !tiledImage.wrapHorizontal ) {
	        tileBR.x = Math.min( tileBR.x, numberOfTiles.x - 1 );
	    }
	    if ( !tiledImage.wrapVertical ) {
	        tileBR.y = Math.min( tileBR.y, numberOfTiles.y - 1 );
	    }
	
	    for ( x = tileTL.x; x <= tileBR.x; x++ ) {
	        for ( y = tileTL.y; y <= tileBR.y; y++ ) {
	
	            best = updateTile(
	                tiledImage,
	                drawLevel,
	                haveDrawn,
	                x, y,
	                level,
	                levelOpacity,
	                levelVisibility,
	                viewportCenter,
	                numberOfTiles,
	                currentTime,
	                best
	            );
	
	        }
	    }
	
	    return best;
	}
	
	function updateTile( tiledImage, drawLevel, haveDrawn, x, y, level, levelOpacity, levelVisibility, viewportCenter, numberOfTiles, currentTime, best){
	
	    var tile = getTile(
	            x, y,
	            level,
	            tiledImage.source,
	            tiledImage.tilesMatrix,
	            currentTime,
	            numberOfTiles,
	            tiledImage._worldWidthCurrent,
	            tiledImage._worldHeightCurrent
	        ),
	        drawTile = drawLevel;
	
	    if( tiledImage.viewer ){
	        /**
	         * <em>- Needs documentation -</em>
	         *
	         * @event update-tile
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	         * @property {OpenSeadragon.Tile} tile
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        tiledImage.viewer.raiseEvent( 'update-tile', {
	            tiledImage: tiledImage,
	            tile: tile
	        });
	    }
	
	    setCoverage( tiledImage.coverage, level, x, y, false );
	
	    if ( !tile.exists ) {
	        return best;
	    }
	
	    if ( haveDrawn && !drawTile ) {
	        if ( isCovered( tiledImage.coverage, level, x, y ) ) {
	            setCoverage( tiledImage.coverage, level, x, y, true );
	        } else {
	            drawTile = true;
	        }
	    }
	
	    if ( !drawTile ) {
	        return best;
	    }
	
	    positionTile(
	        tile,
	        tiledImage.source.tileOverlap,
	        tiledImage.viewport,
	        viewportCenter,
	        levelVisibility,
	        tiledImage
	    );
	
	    if (!tile.loaded) {
	        if (tile.context2D) {
	            setTileLoaded(tiledImage, tile);
	        } else {
	            var imageRecord = tiledImage._tileCache.getImageRecord(tile.url);
	            if (imageRecord) {
	                var image = imageRecord.getImage();
	                setTileLoaded(tiledImage, tile, image);
	            }
	        }
	    }
	
	    if ( tile.loaded ) {
	        var needsDraw = blendTile(
	            tiledImage,
	            tile,
	            x, y,
	            level,
	            levelOpacity,
	            currentTime
	        );
	
	        if ( needsDraw ) {
	            tiledImage._needsDraw = true;
	        }
	    } else if ( tile.loading ) {
	        // the tile is already in the download queue
	        // thanks josh1093 for finally translating this typo
	    } else {
	        best = compareTiles( best, tile );
	    }
	
	    return best;
	}
	
	function getTile( x, y, level, tileSource, tilesMatrix, time, numTiles, worldWidth, worldHeight ) {
	    var xMod,
	        yMod,
	        bounds,
	        exists,
	        url,
	        context2D,
	        tile;
	
	    if ( !tilesMatrix[ level ] ) {
	        tilesMatrix[ level ] = {};
	    }
	    if ( !tilesMatrix[ level ][ x ] ) {
	        tilesMatrix[ level ][ x ] = {};
	    }
	
	    if ( !tilesMatrix[ level ][ x ][ y ] ) {
	        xMod    = ( numTiles.x + ( x % numTiles.x ) ) % numTiles.x;
	        yMod    = ( numTiles.y + ( y % numTiles.y ) ) % numTiles.y;
	        bounds  = tileSource.getTileBounds( level, xMod, yMod );
	        exists  = tileSource.tileExists( level, xMod, yMod );
	        url     = tileSource.getTileUrl( level, xMod, yMod );
	        context2D = tileSource.getContext2D ?
	            tileSource.getContext2D(level, xMod, yMod) : undefined;
	
	        bounds.x += ( x - xMod ) / numTiles.x;
	        bounds.y += (worldHeight / worldWidth) * (( y - yMod ) / numTiles.y);
	
	        tilesMatrix[ level ][ x ][ y ] = new $.Tile(
	            level,
	            x,
	            y,
	            bounds,
	            exists,
	            url,
	            context2D
	        );
	    }
	
	    tile = tilesMatrix[ level ][ x ][ y ];
	    tile.lastTouchTime = time;
	
	    return tile;
	}
	
	function loadTile( tiledImage, tile, time ) {
	    tile.loading = true;
	    tiledImage._imageLoader.addJob({
	        src: tile.url,
	        crossOriginPolicy: tiledImage.crossOriginPolicy,
	        callback: function( image, errorMsg ){
	            onTileLoad( tiledImage, tile, time, image, errorMsg );
	        },
	        abort: function() {
	            tile.loading = false;
	        }
	    });
	}
	
	function onTileLoad( tiledImage, tile, time, image, errorMsg ) {
	    if ( !image ) {
	        $.console.log( "Tile %s failed to load: %s - error: %s", tile, tile.url, errorMsg );
	        /**
	         * Triggered when a tile fails to load.
	         *
	         * @event tile-load-failed
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Tile} tile - The tile that failed to load.
	         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image the tile belongs to.
	         * @property {number} time - The time in milliseconds when the tile load began.
	         * @property {string} message - The error message.
	         */
	        tiledImage.viewer.raiseEvent("tile-load-failed", {tile: tile, tiledImage: tiledImage, time: time, message: errorMsg});
	        if( !tiledImage.debugMode ){
	            tile.loading = false;
	            tile.exists = false;
	            return;
	        }
	    } else if ( time < tiledImage.lastResetTime ) {
	        $.console.log( "Ignoring tile %s loaded before reset: %s", tile, tile.url );
	        tile.loading = false;
	        return;
	    }
	
	    var finish = function() {
	        var cutoff = Math.ceil( Math.log(
	            tiledImage.source.getTileWidth(tile.level) ) / Math.log( 2 ) );
	        setTileLoaded(tiledImage, tile, image, cutoff);
	    };
	
	    // Check if we're mid-update; this can happen on IE8 because image load events for
	    // cached images happen immediately there
	    if ( !tiledImage._midDraw ) {
	        finish();
	    } else {
	        // Wait until after the update, in case caching unloads any tiles
	        window.setTimeout( finish, 1);
	    }
	}
	
	function setTileLoaded(tiledImage, tile, image, cutoff) {
	    var increment = 0;
	
	    function getCompletionCallback() {
	        increment++;
	        return completionCallback;
	    }
	
	    function completionCallback() {
	        increment--;
	        if (increment === 0) {
	            tile.loading = false;
	            tile.loaded = true;
	            if (!tile.context2D) {
	                tiledImage._tileCache.cacheTile({
	                    image: image,
	                    tile: tile,
	                    cutoff: cutoff,
	                    tiledImage: tiledImage
	                });
	            }
	            tiledImage._needsDraw = true;
	        }
	    }
	
	    /**
	     * Triggered when a tile has just been loaded in memory. That means that the
	     * image has been downloaded and can be modified before being drawn to the canvas.
	     *
	     * @event tile-loaded
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {Image} image - The image of the tile.
	     * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the loaded tile.
	     * @property {OpenSeadragon.Tile} tile - The tile which has been loaded.
	     * @property {function} getCompletionCallback - A function giving a callback to call
	     * when the asynchronous processing of the image is done. The image will be
	     * marked as entirely loaded when the callback has been called once for each
	     * call to getCompletionCallback.
	     */
	    tiledImage.viewer.raiseEvent("tile-loaded", {
	        tile: tile,
	        tiledImage: tiledImage,
	        image: image,
	        getCompletionCallback: getCompletionCallback
	    });
	    // In case the completion callback is never called, we at least force it once.
	    getCompletionCallback()();
	}
	
	function positionTile( tile, overlap, viewport, viewportCenter, levelVisibility, tiledImage ){
	    var boundsTL     = tile.bounds.getTopLeft();
	
	    boundsTL.x *= tiledImage._scaleSpring.current.value;
	    boundsTL.y *= tiledImage._scaleSpring.current.value;
	    boundsTL.x += tiledImage._xSpring.current.value;
	    boundsTL.y += tiledImage._ySpring.current.value;
	
	    var boundsSize   = tile.bounds.getSize();
	
	    boundsSize.x *= tiledImage._scaleSpring.current.value;
	    boundsSize.y *= tiledImage._scaleSpring.current.value;
	
	    var positionC    = viewport.pixelFromPoint( boundsTL, true ),
	        positionT    = viewport.pixelFromPoint( boundsTL, false ),
	        sizeC        = viewport.deltaPixelsFromPoints( boundsSize, true ),
	        sizeT        = viewport.deltaPixelsFromPoints( boundsSize, false ),
	        tileCenter   = positionT.plus( sizeT.divide( 2 ) ),
	        tileDistance = viewportCenter.distanceTo( tileCenter );
	
	    if ( !overlap ) {
	        sizeC = sizeC.plus( new $.Point( 1, 1 ) );
	    }
	
	    tile.position   = positionC;
	    tile.size       = sizeC;
	    tile.distance   = tileDistance;
	    tile.visibility = levelVisibility;
	}
	
	
	function blendTile( tiledImage, tile, x, y, level, levelOpacity, currentTime ){
	    var blendTimeMillis = 1000 * tiledImage.blendTime,
	        deltaTime,
	        opacity;
	
	    if ( !tile.blendStart ) {
	        tile.blendStart = currentTime;
	    }
	
	    deltaTime   = currentTime - tile.blendStart;
	    opacity     = blendTimeMillis ? Math.min( 1, deltaTime / ( blendTimeMillis ) ) : 1;
	
	    if ( tiledImage.alwaysBlend ) {
	        opacity *= levelOpacity;
	    }
	
	    tile.opacity = opacity;
	
	    tiledImage.lastDrawn.push( tile );
	
	    if ( opacity == 1 ) {
	        setCoverage( tiledImage.coverage, level, x, y, true );
	        tiledImage._hasOpaqueTile = true;
	    } else if ( deltaTime < blendTimeMillis ) {
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * @private
	 * @inner
	 * Returns true if the given tile provides coverage to lower-level tiles of
	 * lower resolution representing the same content. If neither x nor y is
	 * given, returns true if the entire visible level provides coverage.
	 *
	 * Note that out-of-bounds tiles provide coverage in this sense, since
	 * there's no content that they would need to cover. Tiles at non-existent
	 * levels that are within the image bounds, however, do not.
	 */
	function providesCoverage( coverage, level, x, y ) {
	    var rows,
	        cols,
	        i, j;
	
	    if ( !coverage[ level ] ) {
	        return false;
	    }
	
	    if ( x === undefined || y === undefined ) {
	        rows = coverage[ level ];
	        for ( i in rows ) {
	            if ( rows.hasOwnProperty( i ) ) {
	                cols = rows[ i ];
	                for ( j in cols ) {
	                    if ( cols.hasOwnProperty( j ) && !cols[ j ] ) {
	                        return false;
	                    }
	                }
	            }
	        }
	
	        return true;
	    }
	
	    return (
	        coverage[ level ][ x] === undefined ||
	        coverage[ level ][ x ][ y ] === undefined ||
	        coverage[ level ][ x ][ y ] === true
	    );
	}
	
	/**
	 * @private
	 * @inner
	 * Returns true if the given tile is completely covered by higher-level
	 * tiles of higher resolution representing the same content. If neither x
	 * nor y is given, returns true if the entire visible level is covered.
	 */
	function isCovered( coverage, level, x, y ) {
	    if ( x === undefined || y === undefined ) {
	        return providesCoverage( coverage, level + 1 );
	    } else {
	        return (
	             providesCoverage( coverage, level + 1, 2 * x, 2 * y ) &&
	             providesCoverage( coverage, level + 1, 2 * x, 2 * y + 1 ) &&
	             providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y ) &&
	             providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y + 1 )
	        );
	    }
	}
	
	/**
	 * @private
	 * @inner
	 * Sets whether the given tile provides coverage or not.
	 */
	function setCoverage( coverage, level, x, y, covers ) {
	    if ( !coverage[ level ] ) {
	        $.console.warn(
	            "Setting coverage for a tile before its level's coverage has been reset: %s",
	            level
	        );
	        return;
	    }
	
	    if ( !coverage[ level ][ x ] ) {
	        coverage[ level ][ x ] = {};
	    }
	
	    coverage[ level ][ x ][ y ] = covers;
	}
	
	/**
	 * @private
	 * @inner
	 * Resets coverage information for the given level. This should be called
	 * after every draw routine. Note that at the beginning of the next draw
	 * routine, coverage for every visible tile should be explicitly set.
	 */
	function resetCoverage( coverage, level ) {
	    coverage[ level ] = {};
	}
	
	/**
	 * @private
	 * @inner
	 * Determines whether the 'last best' tile for the area is better than the
	 * tile in question.
	 */
	function compareTiles( previousBest, tile ) {
	    if ( !previousBest ) {
	        return tile;
	    }
	
	    if ( tile.visibility > previousBest.visibility ) {
	        return tile;
	    } else if ( tile.visibility == previousBest.visibility ) {
	        if ( tile.distance < previousBest.distance ) {
	            return tile;
	        }
	    }
	
	    return previousBest;
	}
	
	function drawTiles( tiledImage, lastDrawn ) {
	    var i,
	        tile;
	
	    if ( tiledImage.opacity <= 0 ) {
	        drawDebugInfo( tiledImage, lastDrawn );
	        return;
	    }
	    var useSketch = tiledImage.opacity < 1;
	    if ( useSketch ) {
	        tiledImage._drawer._clear( true );
	    }
	
	    var usedClip = false;
	    if ( tiledImage._clip ) {
	        tiledImage._drawer.saveContext(useSketch);
	
	        var box = tiledImage.imageToViewportRectangle(tiledImage._clip, true);
	        var clipRect = tiledImage._drawer.viewportToDrawerRectangle(box);
	        tiledImage._drawer.setClip(clipRect, useSketch);
	
	        usedClip = true;
	    }
	
	    if ( tiledImage.placeholderFillStyle && tiledImage._hasOpaqueTile === false ) {
	        var placeholderRect = tiledImage._drawer.viewportToDrawerRectangle(tiledImage.getBounds(true));
	
	        var fillStyle = null;
	        if ( typeof tiledImage.placeholderFillStyle === "function" ) {
	            fillStyle = tiledImage.placeholderFillStyle(tiledImage, tiledImage._drawer.context);
	        }
	        else {
	            fillStyle = tiledImage.placeholderFillStyle;
	        }
	
	        tiledImage._drawer.drawRectangle(placeholderRect, fillStyle, useSketch);
	    }
	
	    for ( i = lastDrawn.length - 1; i >= 0; i-- ) {
	        tile = lastDrawn[ i ];
	        tiledImage._drawer.drawTile( tile, tiledImage._drawingHandler, useSketch );
	        tile.beingDrawn = true;
	
	        if( tiledImage.viewer ){
	            /**
	             * <em>- Needs documentation -</em>
	             *
	             * @event tile-drawn
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	             * @property {OpenSeadragon.Tile} tile
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            tiledImage.viewer.raiseEvent( 'tile-drawn', {
	                tiledImage: tiledImage,
	                tile: tile
	            });
	        }
	    }
	
	    if ( usedClip ) {
	        tiledImage._drawer.restoreContext( useSketch );
	    }
	
	    if ( useSketch ) {
	        tiledImage._drawer.blendSketch( tiledImage.opacity );
	    }
	    drawDebugInfo( tiledImage, lastDrawn );
	}
	
	function drawDebugInfo( tiledImage, lastDrawn ) {
	    if( tiledImage.debugMode ) {
	        for ( var i = lastDrawn.length - 1; i >= 0; i-- ) {
	            var tile = lastDrawn[ i ];
	            try {
	                tiledImage._drawer.drawDebugInfo( tile, lastDrawn.length, i );
	            } catch(e) {
	                $.console.error(e);
	            }
	        }
	    }
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TileCache
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// private class
	var TileRecord = function( options ) {
	    $.console.assert( options, "[TileCache.cacheTile] options is required" );
	    $.console.assert( options.tile, "[TileCache.cacheTile] options.tile is required" );
	    $.console.assert( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );
	    this.tile = options.tile;
	    this.tiledImage = options.tiledImage;
	};
	
	// private class
	var ImageRecord = function(options) {
	    $.console.assert( options, "[ImageRecord] options is required" );
	    $.console.assert( options.image, "[ImageRecord] options.image is required" );
	    this._image = options.image;
	    this._tiles = [];
	};
	
	ImageRecord.prototype = {
	    destroy: function() {
	        this._image = null;
	        this._renderedContext = null;
	        this._tiles = null;
	    },
	
	    getImage: function() {
	        return this._image;
	    },
	
	    getRenderedContext: function() {
	        if (!this._renderedContext) {
	            var canvas = document.createElement( 'canvas' );
	            canvas.width = this._image.width;
	            canvas.height = this._image.height;
	            this._renderedContext = canvas.getContext('2d');
	            this._renderedContext.drawImage( this._image, 0, 0 );
	            //since we are caching the prerendered image on a canvas
	            //allow the image to not be held in memory
	            this._image = null;
	        }
	        return this._renderedContext;
	    },
	
	    setRenderedContext: function(renderedContext) {
	        $.console.error("ImageRecord.setRenderedContext is deprecated. " +
	                "The rendered context should be created by the ImageRecord " +
	                "itself when calling ImageRecord.getRenderedContext.");
	        this._renderedContext = renderedContext;
	    },
	
	    addTile: function(tile) {
	        $.console.assert(tile, '[ImageRecord.addTile] tile is required');
	        this._tiles.push(tile);
	    },
	
	    removeTile: function(tile) {
	        for (var i = 0; i < this._tiles.length; i++) {
	            if (this._tiles[i] === tile) {
	                this._tiles.splice(i, 1);
	                return;
	            }
	        }
	
	        $.console.warn('[ImageRecord.removeTile] trying to remove unknown tile', tile);
	    },
	
	    getTileCount: function() {
	        return this._tiles.length;
	    }
	};
	
	/**
	 * @class TileCache
	 * @memberof OpenSeadragon
	 * @classdesc Stores all the tiles displayed in a {@link OpenSeadragon.Viewer}.
	 * You generally won't have to interact with the TileCache directly.
	 * @param {Object} options - Configuration for this TileCache.
	 * @param {Number} [options.maxImageCacheCount] - See maxImageCacheCount in
	 * {@link OpenSeadragon.Options} for details.
	 */
	$.TileCache = function( options ) {
	    options = options || {};
	
	    this._maxImageCacheCount = options.maxImageCacheCount || $.DEFAULT_SETTINGS.maxImageCacheCount;
	    this._tilesLoaded = [];
	    this._imagesLoaded = [];
	    this._imagesLoadedCount = 0;
	};
	
	$.TileCache.prototype = /** @lends OpenSeadragon.TileCache.prototype */{
	    /**
	     * @returns {Number} The total number of tiles that have been loaded by
	     * this TileCache.
	     */
	    numTilesLoaded: function() {
	        return this._tilesLoaded.length;
	    },
	
	    /**
	     * Caches the specified tile, removing an old tile if necessary to stay under the
	     * maxImageCacheCount specified on construction. Note that if multiple tiles reference
	     * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
	     * the number of images below that number. Note, as well, that even the number of images
	     * may temporarily surpass that number, but should eventually come back down to the max specified.
	     * @param {Object} options - Tile info.
	     * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
	     * @param {Image} options.image - The image of the tile to cache.
	     * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
	     * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
	     * function will release an old tile. The cutoff option specifies a tile level at or below which
	     * tiles will not be released.
	     */
	    cacheTile: function( options ) {
	        $.console.assert( options, "[TileCache.cacheTile] options is required" );
	        $.console.assert( options.tile, "[TileCache.cacheTile] options.tile is required" );
	        $.console.assert( options.tile.url, "[TileCache.cacheTile] options.tile.url is required" );
	        $.console.assert( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );
	
	        var cutoff = options.cutoff || 0;
	        var insertionIndex = this._tilesLoaded.length;
	
	        var imageRecord = this._imagesLoaded[options.tile.url];
	        if (!imageRecord) {
	            $.console.assert( options.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord" );
	            imageRecord = this._imagesLoaded[options.tile.url] = new ImageRecord({
	                image: options.image
	            });
	
	            this._imagesLoadedCount++;
	        }
	
	        imageRecord.addTile(options.tile);
	        options.tile.cacheImageRecord = imageRecord;
	
	        // Note that just because we're unloading a tile doesn't necessarily mean
	        // we're unloading an image. With repeated calls it should sort itself out, though.
	        if ( this._imagesLoadedCount > this._maxImageCacheCount ) {
	            var worstTile       = null;
	            var worstTileIndex  = -1;
	            var worstTileRecord = null;
	            var prevTile, worstTime, worstLevel, prevTime, prevLevel, prevTileRecord;
	
	            for ( var i = this._tilesLoaded.length - 1; i >= 0; i-- ) {
	                prevTileRecord = this._tilesLoaded[ i ];
	                prevTile = prevTileRecord.tile;
	
	                if ( prevTile.level <= cutoff || prevTile.beingDrawn ) {
	                    continue;
	                } else if ( !worstTile ) {
	                    worstTile       = prevTile;
	                    worstTileIndex  = i;
	                    worstTileRecord = prevTileRecord;
	                    continue;
	                }
	
	                prevTime    = prevTile.lastTouchTime;
	                worstTime   = worstTile.lastTouchTime;
	                prevLevel   = prevTile.level;
	                worstLevel  = worstTile.level;
	
	                if ( prevTime < worstTime ||
	                   ( prevTime == worstTime && prevLevel > worstLevel ) ) {
	                    worstTile       = prevTile;
	                    worstTileIndex  = i;
	                    worstTileRecord = prevTileRecord;
	                }
	            }
	
	            if ( worstTile && worstTileIndex >= 0 ) {
	                this._unloadTile(worstTileRecord);
	                insertionIndex = worstTileIndex;
	            }
	        }
	
	        this._tilesLoaded[ insertionIndex ] = new TileRecord({
	            tile: options.tile,
	            tiledImage: options.tiledImage
	        });
	    },
	
	    /**
	     * Clears all tiles associated with the specified tiledImage.
	     * @param {OpenSeadragon.TiledImage} tiledImage
	     */
	    clearTilesFor: function( tiledImage ) {
	        $.console.assert(tiledImage, '[TileCache.clearTilesFor] tiledImage is required');
	        var tileRecord;
	        for ( var i = 0; i < this._tilesLoaded.length; ++i ) {
	            tileRecord = this._tilesLoaded[ i ];
	            if ( tileRecord.tiledImage === tiledImage ) {
	                this._unloadTile(tileRecord);
	                this._tilesLoaded.splice( i, 1 );
	                i--;
	            }
	        }
	    },
	
	    // private
	    getImageRecord: function(url) {
	        $.console.assert(url, '[TileCache.getImageRecord] url is required');
	        return this._imagesLoaded[url];
	    },
	
	    // private
	    _unloadTile: function(tileRecord) {
	        $.console.assert(tileRecord, '[TileCache._unloadTile] tileRecord is required');
	        var tile = tileRecord.tile;
	        var tiledImage = tileRecord.tiledImage;
	
	        tile.unload();
	        tile.cacheImageRecord = null;
	
	        var imageRecord = this._imagesLoaded[tile.url];
	        imageRecord.removeTile(tile);
	        if (!imageRecord.getTileCount()) {
	            imageRecord.destroy();
	            delete this._imagesLoaded[tile.url];
	            this._imagesLoadedCount--;
	        }
	
	        /**
	         * Triggered when a tile has just been unloaded from memory.
	         *
	         * @event tile-unloaded
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the unloaded tile.
	         * @property {OpenSeadragon.Tile} tile - The tile which has been unloaded.
	         */
	        tiledImage.viewer.raiseEvent("tile-unloaded", {
	            tile: tile,
	            tiledImage: tiledImage
	        });
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - World
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class World
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @classdesc Keeps track of all of the tiled images in the scene.
	 * @param {Object} options - World options.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this World.
	 **/
	$.World = function( options ) {
	    var _this = this;
	
	    $.console.assert( options.viewer, "[World] options.viewer is required" );
	
	    $.EventSource.call( this );
	
	    this.viewer = options.viewer;
	    this._items = [];
	    this._needsDraw = false;
	    this._autoRefigureSizes = true;
	    this._needsSizesFigured = false;
	    this._delegatedFigureSizes = function(event) {
	        if (_this._autoRefigureSizes) {
	            _this._figureSizes();
	        } else {
	            _this._needsSizesFigured = true;
	        }
	    };
	
	    this._figureSizes();
	};
	
	$.extend( $.World.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.World.prototype */{
	    /**
	     * Add the specified item.
	     * @param {OpenSeadragon.TiledImage} item - The item to add.
	     * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
	     * @fires OpenSeadragon.World.event:add-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    addItem: function( item, options ) {
	        $.console.assert(item, "[World.addItem] item is required");
	        $.console.assert(item instanceof $.TiledImage, "[World.addItem] only TiledImages supported at this time");
	
	        options = options || {};
	        if (options.index !== undefined) {
	            var index = Math.max(0, Math.min(this._items.length, options.index));
	            this._items.splice(index, 0, item);
	        } else {
	            this._items.push( item );
	        }
	
	        if (this._autoRefigureSizes) {
	            this._figureSizes();
	        } else {
	            this._needsSizesFigured = true;
	        }
	
	        this._needsDraw = true;
	
	        item.addHandler('bounds-change', this._delegatedFigureSizes);
	
	        /**
	         * Raised when an item is added to the World.
	         * @event add-item
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item that has been added.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'add-item', {
	            item: item
	        } );
	    },
	
	    /**
	     * Get the item at the specified index.
	     * @param {Number} index - The item's index.
	     * @returns {OpenSeadragon.TiledImage} The item at the specified index.
	     */
	    getItemAt: function( index ) {
	        $.console.assert(index !== undefined, "[World.getItemAt] index is required");
	        return this._items[ index ];
	    },
	
	    /**
	     * Get the index of the given item or -1 if not present.
	     * @param {OpenSeadragon.TiledImage} item - The item.
	     * @returns {Number} The index of the item or -1 if not present.
	     */
	    getIndexOfItem: function( item ) {
	        $.console.assert(item, "[World.getIndexOfItem] item is required");
	        return $.indexOf( this._items, item );
	    },
	
	    /**
	     * @returns {Number} The number of items used.
	     */
	    getItemCount: function() {
	        return this._items.length;
	    },
	
	    /**
	     * Change the index of a item so that it appears over or under others.
	     * @param {OpenSeadragon.TiledImage} item - The item to move.
	     * @param {Number} index - The new index.
	     * @fires OpenSeadragon.World.event:item-index-change
	     */
	    setItemIndex: function( item, index ) {
	        $.console.assert(item, "[World.setItemIndex] item is required");
	        $.console.assert(index !== undefined, "[World.setItemIndex] index is required");
	
	        var oldIndex = this.getIndexOfItem( item );
	
	        if ( index >= this._items.length ) {
	            throw new Error( "Index bigger than number of layers." );
	        }
	
	        if ( index === oldIndex || oldIndex === -1 ) {
	            return;
	        }
	
	        this._items.splice( oldIndex, 1 );
	        this._items.splice( index, 0, item );
	        this._needsDraw = true;
	
	        /**
	         * Raised when the order of the indexes has been changed.
	         * @event item-index-change
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item whose index has
	         * been changed
	         * @property {Number} previousIndex - The previous index of the item
	         * @property {Number} newIndex - The new index of the item
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'item-index-change', {
	            item: item,
	            previousIndex: oldIndex,
	            newIndex: index
	        } );
	    },
	
	    /**
	     * Remove an item.
	     * @param {OpenSeadragon.TiledImage} item - The item to remove.
	     * @fires OpenSeadragon.World.event:remove-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    removeItem: function( item ) {
	        $.console.assert(item, "[World.removeItem] item is required");
	
	        var index = $.indexOf(this._items, item );
	        if ( index === -1 ) {
	            return;
	        }
	
	        item.removeHandler('bounds-change', this._delegatedFigureSizes);
	        item.destroy();
	        this._items.splice( index, 1 );
	        this._figureSizes();
	        this._needsDraw = true;
	        this._raiseRemoveItem(item);
	    },
	
	    /**
	     * Remove all items.
	     * @fires OpenSeadragon.World.event:remove-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    removeAll: function() {
	        // We need to make sure any pending images are canceled so the world items don't get messed up
	        this.viewer._cancelPendingImages();
	        var item;
	        for (var i = 0; i < this._items.length; i++) {
	            item = this._items[i];
	            item.removeHandler('bounds-change', this._delegatedFigureSizes);
	            item.destroy();
	        }
	
	        var removedItems = this._items;
	        this._items = [];
	        this._figureSizes();
	        this._needsDraw = true;
	
	        for (i = 0; i < removedItems.length; i++) {
	            item = removedItems[i];
	            this._raiseRemoveItem(item);
	        }
	    },
	
	    /**
	     * Clears all tiles and triggers updates for all items.
	     */
	    resetItems: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            this._items[i].reset();
	        }
	    },
	
	    /**
	     * Updates (i.e. animates bounds of) all items.
	     */
	    update: function() {
	        var animated = false;
	        for ( var i = 0; i < this._items.length; i++ ) {
	            animated = this._items[i].update() || animated;
	        }
	
	        return animated;
	    },
	
	    /**
	     * Draws all items.
	     */
	    draw: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            this._items[i].draw();
	        }
	
	        this._needsDraw = false;
	    },
	
	    /**
	     * @returns {Boolean} true if any items need updating.
	     */
	    needsDraw: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            if ( this._items[i].needsDraw() ) {
	                return true;
	            }
	        }
	        return this._needsDraw;
	    },
	
	    /**
	     * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
	     */
	    getHomeBounds: function() {
	        return this._homeBounds.clone();
	    },
	
	    /**
	     * To facilitate zoom constraints, we keep track of the pixel density of the
	     * densest item in the World (i.e. the item whose content size to viewport size
	     * ratio is the highest) and save it as this "content factor".
	     * @returns {Number} the number of content units per viewport unit.
	     */
	    getContentFactor: function() {
	        return this._contentFactor;
	    },
	
	    /**
	     * As a performance optimization, setting this flag to false allows the bounds-change event handler
	     * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
	     * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
	     * or the system may behave oddly.
	     * @param {Boolean} [value] The value to which to set the flag.
	     */
	    setAutoRefigureSizes: function(value) {
	        this._autoRefigureSizes = value;
	        if (value & this._needsSizesFigured) {
	            this._figureSizes();
	            this._needsSizesFigured = false;
	        }
	    },
	
	    /**
	     * Arranges all of the TiledImages with the specified settings.
	     * @param {Object} options - Specifies how to arrange.
	     * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
	     * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    arrange: function(options) {
	        options = options || {};
	        var immediately = options.immediately || false;
	        var layout = options.layout || $.DEFAULT_SETTINGS.collectionLayout;
	        var rows = options.rows || $.DEFAULT_SETTINGS.collectionRows;
	        var columns = options.columns || $.DEFAULT_SETTINGS.collectionColumns;
	        var tileSize = options.tileSize || $.DEFAULT_SETTINGS.collectionTileSize;
	        var tileMargin = options.tileMargin || $.DEFAULT_SETTINGS.collectionTileMargin;
	        var increment = tileSize + tileMargin;
	        var wrap;
	        if (!options.rows && columns) {
	            wrap = columns;
	        } else {
	            wrap = Math.ceil(this._items.length / rows);
	        }
	        var x = 0;
	        var y = 0;
	        var item, box, width, height, position;
	
	        this.setAutoRefigureSizes(false);
	        for (var i = 0; i < this._items.length; i++) {
	            if (i && (i % wrap) === 0) {
	                if (layout === 'horizontal') {
	                    y += increment;
	                    x = 0;
	                } else {
	                    x += increment;
	                    y = 0;
	                }
	            }
	
	            item = this._items[i];
	            box = item.getBounds();
	            if (box.width > box.height) {
	                width = tileSize;
	            } else {
	                width = tileSize * (box.width / box.height);
	            }
	
	            height = width * (box.height / box.width);
	            position = new $.Point(x + ((tileSize - width) / 2),
	                y + ((tileSize - height) / 2));
	
	            item.setPosition(position, immediately);
	            item.setWidth(width, immediately);
	
	            if (layout === 'horizontal') {
	                x += increment;
	            } else {
	                y += increment;
	            }
	        }
	        this.setAutoRefigureSizes(true);
	    },
	
	    // private
	    _figureSizes: function() {
	        var oldHomeBounds = this._homeBounds ? this._homeBounds.clone() : null;
	        var oldContentSize = this._contentSize ? this._contentSize.clone() : null;
	        var oldContentFactor = this._contentFactor || 0;
	
	        if ( !this._items.length ) {
	            this._homeBounds = new $.Rect(0, 0, 1, 1);
	            this._contentSize = new $.Point(1, 1);
	            this._contentFactor = 1;
	        } else {
	            var bounds = this._items[0].getBounds();
	            this._contentFactor = this._items[0].getContentSize().x / bounds.width;
	            var left = bounds.x;
	            var top = bounds.y;
	            var right = bounds.x + bounds.width;
	            var bottom = bounds.y + bounds.height;
	            var box;
	            for ( var i = 1; i < this._items.length; i++ ) {
	                box = this._items[i].getBounds();
	                this._contentFactor = Math.max(this._contentFactor, this._items[i].getContentSize().x / box.width);
	                left = Math.min( left, box.x );
	                top = Math.min( top, box.y );
	                right = Math.max( right, box.x + box.width );
	                bottom = Math.max( bottom, box.y + box.height );
	            }
	
	            this._homeBounds = new $.Rect( left, top, right - left, bottom - top );
	            this._contentSize = new $.Point(this._homeBounds.width * this._contentFactor,
	                this._homeBounds.height * this._contentFactor);
	        }
	
	        if (this._contentFactor !== oldContentFactor || !this._homeBounds.equals(oldHomeBounds) ||
	                !this._contentSize.equals(oldContentSize)) {
	            /**
	             * Raised when the home bounds or content factor change.
	             * @event metrics-change
	             * @memberOf OpenSeadragon.World
	             * @type {object}
	             * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent('metrics-change', {});
	        }
	    },
	
	    // private
	    _raiseRemoveItem: function(item) {
	        /**
	         * Raised when an item is removed.
	         * @event remove-item
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item's underlying item.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'remove-item', { item: item } );
	    }
	});
	
	}( OpenSeadragon ));
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = OpenSeadragon;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	
	// This is the WebRotate viewer as exported from from v2.5.2 of the webrotate
	// 360 wordpress plugin. The original js is obfuscated by wrapping a an eval
	// and decode step around a bunch of encoded string data. I replaced the
	// top-level eval with a console.log and pretty-printed the output which can
	// be seen here. This allows us to better minify the code and debug it if
	// required.
	// It also allows us to see that they overwrite String.trim. Yuck.
	/*
	 * Copyright (c) 2015, WebRotate 360 LLC. All rights reserved.
	 */
	(function() {
	    WR360 = {};
	})();
	(function() {
	    Function.prototype.bE = function(eB) {
	        if (eB.constructor == Function) {
	            this.prototype = new eB;
	            this.prototype.constructor = this;
	            this.prototype.ct = eB.prototype;
	            this.prototype.iQ = 0;
	            this.prototype.aB = function() {
	                var ct = this.ct;
	                for (var i = this.iQ; i > 0; i--) {
	                    ct = ct.ct;
	                }
	                this.iQ++;
	                return ct;
	            };
	        } else {
	            this.prototype = eB;
	            this.prototype.constructor = this;
	            this.prototype.ct = eB;
	        }
	        return this;
	    };
	    String.prototype.format = function() {
	        var aI = this;
	        i = arguments.length;
	        while (i--) {
	            aI = aI.replace(new RegExp("\\{" + i + "\\}", "gm"), arguments[i]);
	        }
	        return aI;
	    };
	    String.prototype.trim = function() {
	        return this.replace(/^\s+|\s+$/g, "");
	    };
	    String.prototype.dd = function() {
	        var aI = this;
	        if (aI.length == 1) {
	            aI = "0" + aI;
	        }
	        return aI;
	    };
	    String.prototype.mI = function() {
	        var aI = this;
	        if (aI.length == 1) {
	            aI = "00" + aI;
	        } else if (aI.length == 2) {
	            aI = "0" + aI;
	        }
	        return aI;
	    };
	    String.prototype.aK = function() {
	        if (this == "auto") {
	            return 0;
	        }
	        return parseInt(this.replace("px", ""));
	    };
	    String.prototype.ad = function() {
	        var aI = this;
	        aI = aI.replace(/\r\n/g, "<br>");
	        aI = aI.replace(/\n\r/g, "<br>");
	        aI = aI.replace(/\r/g, "<br>");
	        aI = aI.replace(/\n/g, "<br>");
	        return aI;
	    };
	})();
	(function() {
	    WR360.by = function() {};
	    WR360.by.kf = null;
	    WR360.by.kd = function() {
	        var Device = {};
	        Device.UA = navigator.userAgent;
	        Device.Type = false;
	        Device.jf = ["iPhone", "iPod", "iPad", "android"];
	        for (var d = 0; d < Device.jf.length; d++) {
	            var t = Device.jf[d];
	            Device[t] = !!Device.UA.match(new RegExp(t, "i"));
	            Device.Type = Device.Type || Device[t];
	        }
	        return Device.Type ? true : false;
	    };
	    WR360.by.iR = WR360.by.kd();
	    WR360.by.cz = function(string, defaultValue) {
	        if (string == null || string.length == 0) {
	            return defaultValue;
	        }
	        return string;
	    };
	    WR360.by.dM = function(string, defaultValue) {
	        if (string == null || string.length == 0) {
	            return defaultValue;
	        }
	        return parseFloat(string);
	    };
	    WR360.by.je = function(string, defaultValue) {
	        if (string == null || string.length == 0) {
	            return defaultValue;
	        }
	        return parseFloat(string.replace(",", "."));
	    };
	    WR360.by.bX = function(string, defaultValue) {
	        if (string == null || string.length == 0) {
	            return defaultValue;
	        }
	        return string.toLowerCase() == "true" || string.toLowerCase() == "1";
	    };
	    WR360.by.oe = function(data) {
	        var e = /^((http|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+\.[^#?\s]+)(#[\w\-]+)?$/;
	        try {
	            if (data.match(e)) {
	                var fH = {
	                    url: RegExp['$&'],
	                    protocol: RegExp.$2,
	                    host: RegExp.$3,
	                    path: RegExp.$4,
	                    file: RegExp.$6,
	                    hash: RegExp.$7
	                };
	                fH.fY = WR360.by.nh(fH.path);
	                fH.iH = fH.fY + "/" + fH.file;
	                return fH;
	            } else {
	                return {
	                    url: "",
	                    protocol: "",
	                    host: "",
	                    path: "",
	                    file: "",
	                    hash: "",
	                    fY: "",
	                    iH: ""
	                };
	            }
	        } catch (ex) {
	            return {
	                url: "",
	                protocol: "",
	                host: "",
	                path: "",
	                file: "",
	                hash: "",
	                fY: "",
	                iH: ""
	            };
	        }
	    };
	    WR360.by.ge = function() {
	        var charCode;
	        var jd = "";
	        var mq = 10 + parseInt(Math.random() * 10);
	        for (var i = 0; i < mq; i++) {
	            charCode = 97 + parseInt(Math.random() * 26);
	            jd += String.fromCharCode(charCode);
	        }
	        return jd;
	    };
	    WR360.by.lp = function() {
	        if (WR360.by.kf == null) {
	            WR360.by.kf = false;
	            if (jQuery.browser.msie) {
	                if (parseInt(jQuery.browser.version.substring(0, 1)) <= 8) {
	                    WR360.by.kf = true;
	                }
	            }
	        }
	        return WR360.by.kf;
	    };
	    WR360.by.hL = function() {
	        if (jQuery.browser.msie == true) {
	            return;
	        }
	        var qk = false;
	        var trident = /Trident\/7\./;
	        if (trident.test(navigator.userAgent)) {
	            qk = true;
	        }
	        if (typeof jQuery.browser !== "undefined" && qk == true) {
	            jQuery.browser.version = "99";
	            jQuery.browser.msie = true;
	            jQuery.browser.webkit = false;
	            jQuery.browser.mozilla = false;
	            jQuery.browser.opera = false;
	        }
	    };
	    WR360.by.mG = function() {
	        if (jQuery.browser) {
	            WR360.by.hL();
	            return;
	        }
	        var matched, browser;
	        if (!jQuery.uaMatch) {
	            jQuery.uaMatch = function(ua) {
	                ua = ua.toLowerCase();
	                var match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
	                return {
	                    browser: match[1] || "",
	                    version: match[2] || "0"
	                };
	            };
	        }
	        matched = jQuery.uaMatch(navigator.userAgent);
	        browser = {};
	        if (matched.browser) {
	            browser[matched.browser] = true;
	            browser.version = matched.version;
	        }
	        if (browser.chrome) {
	            browser.webkit = true;
	        } else if (browser.webkit) {
	            browser.safari = true;
	        }
	        jQuery.browser = browser;
	        WR360.by.hL();
	    };
	    WR360.by.jS = function(cdata) {
	        var pattern = /\<(\w+?)\s+?/gim;
	        var tagName;
	        var gS = WR360.ImageRotator.mv();
	        if (gS == null || gS.length == 0) {
	            return "";
	        }
	        var fU = gS.split(",");
	        if (fU.length == 0) {
	            return "";
	        }
	        var tags = cdata.match(pattern);
	        if (tags == null || tags.length == 0) {
	            return "";
	        }
	        for (var i = 0; i < tags.length; i++) {
	            if (tags[i].match(pattern)) {
	                tagName = RegExp.$1;
	                var iI = false;
	                for (var j = 0; j < fU.length; j++) {
	                    if (tagName.toLowerCase() == fU[j]) {
	                        iI = true;
	                        break;
	                    }
	                }
	                if (!iI) {
	                    return tagName;
	                }
	            }
	        }
	        return "";
	    };
	    WR360.by.nh = function(path) {
	        var e = /.*?\/(\w+)\/$/;
	        if (path.match(e)) {
	            return RegExp.$1;
	        } else {
	            return "";
	        }
	    };
	    WR360.by.fS = function(e) {
	        var fw = 0,
	            gI = 0;
	        var hU = typeof window.event !== "undefined" && typeof window.event.targetTouches !== "undefined";
	        if (!WR360.by.iR && !hU) {
	            if (e.pageX || e.pageY) {
	                fw = e.pageX;
	                gI = e.pageY;
	            } else if (e.clientX || e.clientY) {
	                fw = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
	                gI = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
	            }
	        } else {
	            if (window.event.targetTouches) {
	                fw = window.event.targetTouches[0].screenX;
	                gI = window.event.targetTouches[0].screenY;
	            }
	        }
	        return {
	            x: fw,
	            y: gI
	        };
	    };
	    WR360.by.fA = function(cu, eJ) {
	        var x = cu.offset().left;
	        var y = cu.offset().top;
	        var x2 = x + cu.outerWidth(false);
	        var y2 = y + cu.outerHeight(false);
	        return eJ.x >= x && eJ.x <= x2 && eJ.y >= y && eJ.y <= y2;
	    };
	    WR360.by.pA = function() {
	        var rlocalProtocol = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/;
	        var rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
	        var ajaxLocation = "";
	        try {
	            ajaxLocation = location.href;
	        } catch (e) {
	            ajaxLocation = document.createElement("a");
	            ajaxLocation.href = "";
	            ajaxLocation = ajaxLocation.href;
	        }
	        var ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];
	        var qm = rlocalProtocol.test(ajaxLocParts[1]);
	        return qm;
	    };
	    WR360.by.qT = function(options) {
	        try {
	            if (!jQuery.browser.msie) {
	                return false;
	            }
	            var qW = window.ActiveXObject !== undefined;
	            if (qW == false) {
	                return false;
	            }
	            if (!WR360.by.pA()) {
	                return false;
	            }
	            var xhr = null;
	            try {
	                xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
	            } catch (e) {}
	            if (xhr == null) {
	                return false;
	            }
	            if (!options.async) {
	                options.async = jQuery.ajaxSettings.async;
	            }
	            xhr.open(options.type, options.url, options.async);
	            var LocalCallback = function() {
	                try {
	                    var text = xhr.responseText;
	                    if (options.success) {
	                        options.success(text);
	                    }
	                } catch (e) {
	                    if (options.error) {
	                        options.error(e);
	                    }
	                }
	            };
	            xhr.send(null);
	            if (!options.async) {
	                LocalCallback();
	            } else if (xhr.readyState === 4) {
	                setTimeout(LocalCallback, 0);
	            } else {
	                xhr.onreadystatechange = LocalCallback;
	            }
	            return true;
	        } catch (e) {
	            return false;
	        }
	    };
	})();
	(function() {
	    WR360.J = function() {
	        this.dr = new Array;
	    };
	    WR360.J.prototype.iS = function(item) {
	        var result = -1;
	        for (var i = 0; i < this.dr.length; i++) {
	            if (this.dr[i] == item) {
	                result = i;
	                break;
	            }
	        }
	        return result;
	    };
	    WR360.J.prototype.bk = function(item) {
	        var result = false;
	        if (item != null) {
	            this.dr.push(item);
	            result = true;
	        }
	        return result;
	    };
	    WR360.J.prototype.removeItem = function(item) {
	        var result = false;
	        var hN = this.iS(item);
	        if (hN > -1) {
	            this.dr.splice(hN, 1);
	            result = true;
	        }
	        return result;
	    };
	    WR360.J.prototype.clear = function() {
	        this.dr = new Array;
	    };
	    WR360.J.prototype.contains = function(item) {
	        return this.iS(item) > -1;
	    };
	    WR360.J.prototype.mh = function(index) {
	        return this.dr[index];
	    };
	    WR360.J.prototype.ds = function() {
	        return this.dr.length;
	    };
	    WR360.J.prototype.nz = function() {
	        return this.dr.length == 0;
	    };
	})();
	(function() {
	    WR360.gl = function() {
	        this.settings = new WR360.kT;
	        this.bF = new Array;
	        this.hi = new Array;
	        this.aw = new Array;
	        this.ky = new Array;
	        this.aw.ep = 0;
	        this.aw.eU = 0;
	    };
	    WR360.gl.prototype.iq = function() {
	        return this.aw.ep > 0 && this.aw.eU > 0;
	    };
	    WR360.gl.prototype.ly = function() {
	        for (var dj = 0; dj < this.bF.length; dj++) {
	            var cd = this.bF[dj];
	            if (cd.disabled == false && cd.dI == false && cd.id != "#logo") {
	                return true;
	            }
	        }
	        return false;
	    };
	    WR360.Control = function() {
	        this.gp = 0.12;
	        this.inBrowserFullScreen = false;
	        this.dJ = false;
	        this.iu = false;
	        this.doubleClickFullscreen = false;
	        this.mouseHoverDrag = false;
	        this.qc = true;
	        this.hideHotspotsOnLoad = false;
	        this.hideHotspotsOnZoom = true;
	    };
	    WR360.Margin = function() {
	        this.top = 0;
	        this.right = 0;
	        this.bottom = 0;
	        this.left = 0;
	    };
	    WR360.Margin.prototype.parse = function(fG) {
	        if (fG == null || fG.length == 0) {
	            return;
	        }
	        var aj = fG.split(",");
	        for (var i = 0; i < aj.length; i++) {
	            switch (i) {
	                case 0:
	                    this.top = WR360.by.dM(aj[i], this.top);
	                    break;
	                case 1:
	                    this.right = WR360.by.dM(aj[i], this.right);
	                    break;
	                case 2:
	                    this.bottom = WR360.by.dM(aj[i], this.bottom);
	                    break;
	                case 3:
	                    this.left = WR360.by.dM(aj[i], this.left);
	                    break;
	                default:
	                    break;
	            }
	        }
	    };
	    WR360.Align = function() {
	        this.vertical = WR360.Align.TOP;
	        this.horizontal = WR360.Align.LEFT;
	    };
	    WR360.Align.TOP = -1;
	    WR360.Align.CENTER = 0;
	    WR360.Align.BOTTOM = 1;
	    WR360.Align.LEFT = -1;
	    WR360.Align.CENTER = 0;
	    WR360.Align.RIGHT = 1;
	    WR360.Align.prototype.parse = function(bK) {
	        if (bK == null || bK.length == 0) {
	            return;
	        }
	        var gP = bK.split(",");
	        for (var i = 0; i < gP.length; i++) {
	            switch (i) {
	                case 0:
	                    var verticalAlign = gP[i].toLowerCase().trim();
	                    if (verticalAlign == "top" || verticalAlign == "-1") {
	                        this.vertical = WR360.Align.TOP;
	                    } else if (verticalAlign == "center" || verticalAlign == "0") {
	                        this.vertical = WR360.Align.CENTER;
	                    } else if (verticalAlign == "bottom" || verticalAlign == "1") {
	                        this.vertical = WR360.Align.BOTTOM;
	                    }
	                    break;
	                case 1:
	                    var ag = gP[i].toLowerCase().trim();
	                    if (ag == "left" || ag == "-1") {
	                        this.horizontal = WR360.Align.LEFT;
	                    } else if (ag == "center" || ag == "0") {
	                        this.horizontal = WR360.Align.CENTER;
	                    } else if (ag == "right" || ag == "1") {
	                        this.horizontal = WR360.Align.RIGHT;
	                    }
	                    break;
	                default:
	                    break;
	            }
	        }
	    };
	    WR360.ix = function() {
	        this.x = 0;
	        this.y = 0;
	        this.oP = false;
	        this.nb = false;
	    };
	    WR360.ix.prototype.ot = function() {
	        return this.oP || this.nb;
	    };
	    WR360.ix.prototype.parse = function(offsetX, offsetY) {
	        this.oP = offsetX != null && offsetX.length > 0;
	        this.nb = offsetY != null && offsetY.length > 0;
	        this.x = WR360.by.dM(offsetX, this.x);
	        this.y = WR360.by.dM(offsetY, this.y);
	    };
	    WR360.kc = function() {
	        this.id = "";
	        this.type = "";
	        this.dI = false;
	        this.className = "";
	        this.color = "";
	        this.alpha = 0;
	        this.jN = "spot_circle_plus.png";
	        this.disabled = false;
	        this.bo = null;
	        this.offset = new WR360.ix;
	        this.margin = new WR360.Margin;
	        this.align = new WR360.Align;
	        this.ps = 0;
	        this.activateOnClick = false;
	    };
	    WR360.HotspotInfo = function() {
	        this.src = "";
	        this.qG = WR360.HotspotInfo.iE.NONE;
	        this.qO = "";
	        this.clickDataParam = "";
	        this.url = "";
	        this.eb = "_self";
	        this.aI = "";
	        this.ga = 242;
	        this.gb = "#525B69";
	        this.gk = "#FFFFFF";
	        this.fO = 14;
	        this.cdata = "";
	        this.aC = false;
	    };
	    WR360.HotspotInfo.iE = {};
	    WR360.HotspotInfo.iE.NONE = 0;
	    WR360.HotspotInfo.iE.qq = 1;
	    WR360.HotspotInfo.iE.mA = 2;
	    WR360.HotspotInfo.iE.qx = 3;
	    WR360.HotspotInfo.iE.sL = 4;
	    WR360.HotspotInfo.iE.ss = 5;
	    WR360.HotspotInfo.iE.rH = 6;
	    WR360.HotspotInfo.iE.qP = 7;
	    WR360.HotspotInfo.iE.pB = 8;
	    WR360.HotspotInfo.iE.sr = 9;
	    WR360.HotspotInfo.iE.sX = 10;
	    WR360.lv = function() {
	        this.src = "";
	        this.label = "";
	        this.bF = new Array;
	        this.hi = new Array;
	        this.cS = null;
	    };
	    WR360.lq = function() {
	        this.source = "";
	        this.offsetX = 0;
	        this.offsetY = 0;
	    };
	    WR360.nu = function() {
	        this.image = "first";
	    };
	    WR360.jJ = function() {
	        this.fE = 0;
	        this.rotate = "false";
	        this.kC = -1;
	        this.oc = "false";
	        this.gg = 7;
	        this.bounce = false;
	        this.op = -1;
	        this.pe = false;
	        this.useInertia = true;
	        this.inertiaRelToDragSpeed = true;
	        this.inertiaTimeToStop = 700;
	        this.inertiaMaxInterval = 120;
	    };
	    WR360.kT = function() {
	        this.eH = new WR360.nu;
	        this.bI = new WR360.jH;
	        this.control = new WR360.Control;
	        this.bg = new WR360.jJ;
	    };
	    WR360.jH = function() {
	        this.hb = true;
	        this.gj = true;
	        this.gw = true;
	        this.iT = true;
	        this.hY = true;
	        this.bY = true;
	        this.iU = true;
	        this.bz = true;
	        this.gx = 0;
	        this.kK = "";
	        this.lh = "";
	        this.gH = "#ffffff";
	        this.iC = 0.9;
	        this.gX = 0.9;
	        this.gC = "#949494";
	        this.hW = "";
	        this.fullScreenBackColor = "#ffffff";
	        this.showFullScreenToolbar = false;
	    };
	    WR360.kB = function() {
	        this.src = "";
	    };
	})();
	(function() {
	    WR360.dh = function() {
	        this.dw = {};
	    };
	    WR360.dh.prototype = {
	        constructor: WR360.dh,
	        oK: function() {
	            return null;
	        },
	        addEventListener: function(type, cc, param) {
	            if (typeof this.dw[type] == "undefined") {
	                this.dw[type] = [];
	            }
	            this.dw[type].push({
	                cc: cc,
	                param: param
	            });
	        },
	        dispatchEvent: function(event) {
	            if (typeof event == "string") {
	                event = {
	                    type: event
	                };
	            }
	            if (!event.target) {
	                event.target = this;
	            }
	            if (!event.type) {
	                throw new Error("Event object missing 'type' property.");
	            }
	            if (this.dw[event.type] instanceof Array) {
	                var cs = this.dw[event.type];
	                for (var i = 0, ia = cs.length; i < ia; i++) {
	                    cs[i].cc.call(this, event, cs[i].param);
	                }
	            }
	        },
	        removeEventListener: function(type, cc) {
	            if (this.dw[type] instanceof Array) {
	                var cs = this.dw[type];
	                for (var i = 0, ia = cs.length; i < ia; i++) {
	                    if (cs[i].cc === cc) {
	                        cs.splice(i, 1);
	                        break;
	                    }
	                }
	            }
	        }
	    };
	    WR360.Event = function(type, bubbles, cancelable) {
	        this.type = type;
	        this.bubbles = bubbles;
	        this.cancelable = cancelable;
	    };
	})();
	(function() {
	    WR360.dY = function() {
	        this.aB().constructor.call(this);
	        this.cQ = false;
	        this.rootPath = "";
	        this.gE = false;
	    };
	    WR360.dY.bE(WR360.dh);
	    WR360.dY.prototype.Init = function(rootPath, V) {
	        this.rootPath = rootPath;
	        this.cQ = false;
	    };
	    WR360.dY.prototype.bO = function() {
	        if (this.cQ == true) {
	            return;
	        }
	        this.gE = true;
	    };
	})();
	(function() {
	    WR360.ba = function(image, index, rootPath, graphicsPath, oq) {
	        this.aB().constructor.call(this);
	        if (image == null) {
	            throw new Error("ImageObject.ctor. null == hotspot");
	        }
	        this.image = image;
	        this.F = new Image;
	        this.bG = null;
	        this.index = index;
	        this.rootPath = rootPath;
	        this.graphicsPath = graphicsPath;
	        this.oq = oq;
	        this.F.be = this;
	        this.F.onload = this.gm;
	        this.F.onerror = this.gc;
	        this.aA();
	        WR360.ba.lg++;
	        this.pi = WR360.ba.lg;
	    };
	    WR360.ba.bE(WR360.dh);
	    WR360.ba.lg = 0;
	    WR360.ba.iK = "pixel.png";
	    WR360.ba.prototype.aA = function() {
	        this.bG = new Image;
	        this.bG.be = this;
	        this.bG.cQ = false;
	        this.bG.onload = this.lQ;
	        this.bG.onerror = this.lL;
	        this.bG.onabort = this.lG;
	    };
	    WR360.ba.prototype.gm = function() {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.ah(WR360.ah.COMPLETE, true, false, bu, false, bu.index, true, ""));
	    };
	    WR360.ba.prototype.gc = function() {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.ah(WR360.ah.ERROR, true, false, bu, false, bu.index, false, "Error loading image: " + this.src));
	    };
	    WR360.ba.prototype.lQ = function() {
	        var bu = this.be;
	        if (bu.hx(this)) {
	            return;
	        }
	        this.cQ = true;
	        bu.dispatchEvent(new WR360.ah(WR360.ah.eD, true, false, bu, true, bu.index, true, ""));
	    };
	    WR360.ba.prototype.lL = function() {
	        var bu = this.be;
	        if (bu.hx(this)) {
	            return;
	        }
	        bu.dispatchEvent(new WR360.ah(WR360.ah.dU, true, false, bu, true, bu.index, false, "Error loading high-res image: " + this.src));
	    };
	    WR360.ba.prototype.lG = function() {
	        var bu = this.be;
	        if (bu.hx(this)) {
	            return;
	        }
	        bu.dispatchEvent(new WR360.ah(WR360.ah.fD, true, false, bu, true, bu.index, false, "Abort loading high-res image: " + this.src));
	    };
	    WR360.ba.prototype.hx = function(image) {
	        return image.src.indexOf(WR360.ba.iK) != -1;
	    };
	    WR360.ba.prototype.Load = function() {
	        var qv = this.oq ? this.image.cS.src : this.image.src;
	        this.F.src = this.rootPath + qv;
	    };
	    WR360.ba.prototype.hS = function() {
	        if (this.bG == null) {
	            this.aA();
	        }
	        this.bG.src = this.rootPath + this.image.cS.src;
	    };
	    WR360.ba.prototype.aE = function() {
	        if (this.bG == null) {
	            return;
	        }
	        this.hK();
	    };
	    WR360.ba.prototype.hK = function() {
	        if (this.bG == null) {
	            throw new Error("forceUnloadHighRes: highresBitmapLoader==null");
	        }
	        this.bG.cQ = false;
	        this.bG.src = this.graphicsPath + "/" + WR360.ba.iK;
	    };
	    WR360.ba.prototype.kz = function() {
	        if (this.bG == null) {
	            return;
	        }
	        if (this.bG.cQ == false) {
	            return;
	        } else {
	            this.hK();
	        }
	    };
	    WR360.ah = function(type, bubbles, cancelable, af, ht, index, success, errorMessage) {
	        this.aB().constructor.call(this, type, bubbles, cancelable);
	        this.af = af;
	        this.ht = ht;
	        this.index = index;
	        this.success = success;
	        this.errorMessage = errorMessage;
	    };
	    WR360.ah.bE(WR360.Event);
	    WR360.ah.COMPLETE = "ImageObject_complete";
	    WR360.ah.ERROR = "ImageObject_error";
	    WR360.ah.eD = "ImageObject_Highres_complete";
	    WR360.ah.fD = "ImageObject_Highres_abort";
	    WR360.ah.dU = "ImageObject_Highres_error";
	})();
	(function() {
	    WR360.fC = function(bi, index, rootPath) {
	        this.aB().constructor.call(this);
	        if (bi == null) {
	            throw new Error("HotspotObject.ctor. null == hotspot");
	        }
	        this.bi = bi;
	        this.index = index;
	        this.F = new Image;
	        this.rootPath = rootPath;
	        this.F.be = this;
	        this.F.onload = this.gm;
	        this.F.onerror = this.gc;
	    };
	    WR360.fC.bE(WR360.dh);
	    WR360.fC.prototype.gm = function() {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.da(WR360.da.COMPLETE, true, false, bu, bu.index, true, ""));
	    };
	    WR360.fC.prototype.gc = function() {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.da(WR360.da.ERROR, true, false, bu, bu.index, false, "Error loading image: " + this.src));
	    };
	    WR360.fC.prototype.Load = function() {
	        this.F.src = this.rootPath + this.bi.bo.src;
	    };
	    WR360.da = function(type, bubbles, cancelable, aO, index, success, errorMessage) {
	        this.aB().constructor.call(this, type, bubbles, cancelable);
	        this.aO = aO;
	        this.index = index;
	        this.success = success;
	        this.errorMessage = errorMessage;
	    };
	    WR360.da.bE(WR360.Event);
	    WR360.da.COMPLETE = "HotspotObject_complete";
	    WR360.da.ERROR = "HotspotObject_error";
	})();
	(function() {
	    WR360.cL = function(bh) {
	        this.aB().constructor.call(this);
	        if (bh == null) {
	            throw new Error("ImagePreloader: imageRotator is null");
	        }
	        this.image = null;
	        this.bh = bh;
	    };
	    WR360.cL.bE(WR360.dY);
	    WR360.cL.le = "first";
	    WR360.cL.la = "none";
	    WR360.cL.prototype.Load = function(rootPath, V) {
	        this.ct.Init.call(this, rootPath, V);
	        var hh = V.settings.eH.image;
	        var av = typeof this.bh.qQ !== "undefined" && this.bh.qQ();
	        var qI = this.bh.settings.fullScreenOnClick;
	        if (!av) {
	            if (this.bh.dV == true && this.bh.reloadImageIndex >= 0) {
	                var bW = this.bh.reloadImageIndex;
	                if (bW > V.aw.length - 1) {
	                    bW = 0;
	                }
	                hh = V.aw[bW].src;
	            } else if (V.settings.eH.image.length == 0 || V.settings.eH.image.toLowerCase() == WR360.cL.la) {
	                this.dispatchEvent(new WR360.cO(WR360.cO.COMPLETE, true, false, null, true, ""));
	                return;
	            }
	        } else {
	            if (V.aw.length == 0) {
	                this.dispatchEvent(new WR360.cO(WR360.cO.COMPLETE, true, false, null, true, ""));
	                return;
	            }
	            var aF = qI == true ? V.settings.bg.fE : this.bh.pH.bV.ob();
	            if (aF < 0 || aF > V.aw.length - 1) {
	                aF = 0;
	            }
	            hh = V.aw[aF].src;
	            var oq = av && V.settings.control.qc && this.bh.bV.lc;
	            if (oq) {
	                hh = V.aw[aF].cS != null ? V.aw[aF].cS.src : V.aw[aF].src;
	            }
	        }
	        this.image = new Image;
	        this.image.be = this;
	        this.image.onload = this.os;
	        this.image.onerror = this.mj;
	        this.image.src = this.rootPath + hh;
	    };
	    WR360.cL.prototype.os = function() {
	        this.be.dispatchEvent(new WR360.cO(WR360.cO.COMPLETE, true, false, this.be.image, true, ""));
	    };
	    WR360.cL.prototype.mj = function() {
	        this.be.dispatchEvent(new WR360.cO(WR360.cO.ERROR, true, false, null, false, "Preloader IO ERROR: " + this.src));
	    };
	    WR360.cO = function(type, bubbles, cancelable, image, success, errorMessage) {
	        this.aB().constructor.call(this, type, bubbles, cancelable);
	        this.image = image;
	        this.success = success;
	        this.errorMessage = errorMessage;
	    };
	    WR360.cO.bE(WR360.Event);
	    WR360.cO.COMPLETE = "complete";
	    WR360.cO.ERROR = "error";
	})();
	(function() {
	    WR360.dP = function(cR) {
	        this.aB().constructor.call(this);
	        this.aw = new Array;
	        this.cG = 0;
	        this.cR = cR;
	        this.mu = "cache_" + cR.substr(1, cR.length);
	    };
	    WR360.dP.bE(WR360.dY);
	    WR360.dP.prototype.jq = function() {
	        return this.aw.length;
	    };
	    WR360.dP.prototype.Init = function(rootPath, graphicsPath, V, oq) {
	        this.ct.Init.call(this, rootPath, V);
	        this.ln(rootPath, graphicsPath, V, oq);
	    };
	    WR360.dP.prototype.ln = function(rootPath, graphicsPath, V, oq) {
	        for (var i = 0; i < V.aw.length; i++) {
	            this.aw[i] = new WR360.ba(V.aw[i], i, rootPath, graphicsPath, oq);
	        }
	    };
	    WR360.dP.prototype.kE = function() {
	        this.cG = 0;
	        for (var i = 0; i < this.aw.length; i++) {
	            var af = this.aw[i];
	            af.be = this;
	            af.addEventListener(WR360.ah.COMPLETE, this.nU);
	            af.addEventListener(WR360.ah.ERROR, this.ou);
	            af.Load();
	        }
	    };
	    WR360.dP.prototype.oB = function(index) {
	        var af = aw[index];
	        af.be = this;
	        af.hS();
	    };
	    WR360.dP.prototype.oW = function(jM) {
	        for (var i = 0; i < this.aw.length; i++) {
	            if (i == jM) {
	                continue;
	            }
	            this.aw[i].kz();
	        }
	    };
	    WR360.dP.prototype.bf = function() {
	        if (this.gE == true) {
	            this.cQ = true;
	            this.dispatchEvent(new WR360.cf(WR360.cf.bJ, true, false, null, Math.round(this.cG * 100 / this.aw.length), false, ""));
	            return true;
	        }
	        return false;
	    };
	    WR360.dP.prototype.nU = function(e) {
	        this.be.kA(e);
	    };
	    WR360.dP.prototype.kA = function(e) {
	        if (this.bf() == true) {
	            return;
	        }
	        if (e.ht) {
	            return;
	        }
	        this.cG++;
	        var eR = WR360.cf.PROGRESS;
	        if (this.cG >= this.aw.length) {
	            eR = WR360.cf.COMPLETE;
	            this.cQ = true;
	        }
	        this.dispatchEvent(new WR360.cf(eR, true, false, e.af, Math.round(this.cG * 100 / this.aw.length), true, ""));
	    };
	    WR360.dP.prototype.ou = function(e) {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.cf(WR360.cf.ERROR, true, false, e.af, Math.round(bu.cG * 100 / bu.aw.length), false, e.errorMessage));
	    };
	    WR360.cf = function(type, bubbles, cancelable, af, ee, success, errorMessage) {
	        this.aB().constructor.call(this, type, bubbles, cancelable);
	        this.af = af;
	        this.ee = ee;
	        this.errorMessage = errorMessage;
	        this.success = success;
	    };
	    WR360.cf.bE(WR360.Event);
	    WR360.cf.PROGRESS = "ImagesCache_progress";
	    WR360.cf.COMPLETE = "ImagesCache_complete";
	    WR360.cf.ERROR = "ImagesCache_error";
	    WR360.cf.bJ = "ImagesCache_canceled";
	})();
	(function() {
	    WR360.dc = function() {
	        this.aB().constructor.call(this);
	        this.dH = 0;
	        this.bF = new Array;
	        this.hu = -1;
	    };
	    WR360.dc.bE(WR360.dY);
	    WR360.dc.pg = "TEXT_HOTSPOT";
	    WR360.dc.prototype.Init = function(rootPath, V) {
	        this.ct.Init.call(this, rootPath, V);
	        this.ku(rootPath, V);
	    };
	    WR360.dc.prototype.ku = function(rootPath, V) {
	        var eW = 0;
	        for (var i = 0; i < V.bF.length; i++) {
	            if (!V.bF[i].disabled) {
	                if (this.hu == -1) {
	                    this.bF[eW] = new WR360.fC(V.bF[i], eW, rootPath);
	                } else if (eW < this.hu) {
	                    this.bF[eW] = new WR360.fC(V.bF[i], eW, rootPath);
	                }
	                eW++;
	            }
	        }
	    };
	    WR360.dc.prototype.kD = function() {
	        this.dH = 0;
	        for (var i = 0; i < this.bF.length; i++) {
	            var aO = this.bF[i];
	            if (aO.bi.bo.src.length > 0) {
	                aO.be = this;
	                aO.addEventListener(WR360.da.COMPLETE, this.mN);
	                aO.addEventListener(WR360.da.ERROR, this.og);
	                aO.Load();
	            } else {
	                this.kq(new WR360.da(WR360.da.COMPLETE, true, false, aO, aO.index, true, ""));
	            }
	        }
	    };
	    WR360.dc.prototype.bf = function() {
	        if (this.gE == true) {
	            this.cQ = true;
	            this.dispatchEvent(new WR360.dK(WR360.dK.bJ, true, false, null, Math.round(this.dH * 100 / this.bF.length), false, ""));
	            return true;
	        }
	        return false;
	    };
	    WR360.dc.prototype.mN = function(e) {
	        this.be.kq(e);
	    };
	    WR360.dc.prototype.kq = function(e) {
	        if (this.bf() == true) {
	            return;
	        }
	        this.dH++;
	        var eR = WR360.dK.PROGRESS;
	        if (this.dH >= this.bF.length) {
	            eR = WR360.dK.COMPLETE;
	            this.cQ = true;
	        }
	        this.dispatchEvent(new WR360.dK(eR, true, false, e.aO, Math.round(this.dH * 100 / this.bF.length), true, ""));
	    };
	    WR360.dc.prototype.og = function(e) {
	        var bu = this.be;
	        bu.dispatchEvent(new WR360.dK(WR360.dK.ERROR, true, false, e.aO, Math.round(bu.dH * 100 / bu.bF.length), false, e.errorMessage));
	    };
	    WR360.dK = function(type, bubbles, cancelable, aO, ee, success, errorMessage) {
	        this.aB().constructor.call(this, type, bubbles, cancelable);
	        this.aO = aO;
	        this.ee = ee;
	        this.errorMessage = errorMessage;
	        this.success = success;
	    };
	    WR360.dK.bE(WR360.Event);
	    WR360.dK.PROGRESS = "HotspotsCache_progress";
	    WR360.dK.COMPLETE = "HotspotsCache_complete";
	    WR360.dK.ERROR = "HotspotsCache_error";
	    WR360.dK.bJ = "HotspotsCache_canceled";
	})();
	(function() {
	    WR360.cI = function(visible, aO, bV, bh, H) {
	        this.df = visible;
	        this.dz = 0;
	        this.dg = 0;
	        this.aO = aO;
	        this.bV = bV;
	        this.playing = false;
	        this.bh = bh;
	        this.H = H;
	        this.bb = null;
	        this.cb = this.bh.gK(this.aO.bi);
	        this.H.append("<div class='wr360hotspot_" + this.bh.oY + "' id='" + this.cb + "'/>");
	        this.bb = jQuery("#" + this.cb);
	        this.aH(visible);
	        this.bb.css("position", "absolute");
	    };
	    WR360.cI.prototype.cD = function(visible) {
	        this.fR();
	    };
	    WR360.cI.prototype.jE = function(visible) {
	        if (this.bH) {
	            this.bH.cN(false);
	        }
	    };
	    WR360.cI.prototype.aH = function(visible) {
	        if (this.bb == null) {
	            throw new Error("SetVisible: hotspotElement==null.");
	        }
	        this.df = visible;
	        if (visible) {
	            this.bb.show();
	        } else {
	            this.bb.hide();
	        }
	    };
	    WR360.cI.prototype.eC = function(x) {
	        this.dz = x;
	    };
	    WR360.cI.prototype.fv = function(y) {
	        this.dg = y;
	    };
	    WR360.cI.prototype.mc = function() {
	        return this.dz;
	    };
	    WR360.cI.prototype.mB = function() {
	        return this.dg;
	    };
	    WR360.cI.prototype.nT = function() {
	        if (this.bH != null) {
	            var aM = this.bV.oy(this.aO, this.bH.qh, this.bH.qw);
	            this.dz = aM.x;
	            this.dg = aM.y;
	            this.bH.dv.Css("left", this.dz);
	            this.bH.dv.Css("top", this.dg);
	            if (this.aO.F.src.length > 0) {
	                var aq = this.bH.aN.find("img");
	                aq.css("width", this.aO.F.width * this.bV.lB);
	                aq.css("height", this.aO.F.height * this.bV.lB);
	            }
	        }
	    };
	    WR360.cI.prototype.fR = function() {
	        if (this.bH == null) {
	            this.bH = new WR360.bx(this.bV, WR360.hI.lD(), true, this.H, this.cb);
	            this.bH.iZ(this.aO);
	            this.bH.jB(this);
	            this.bH.jw(this.gV());
	        }
	    };
	    WR360.cI.prototype.gV = function() {
	        return {
	            x: this.dz,
	            y: this.dg
	        };
	    };
	})();
	(function() {
	    WR360.aT = function(visible, aO, bV, bh, H) {
	        this.df = visible;
	        this.dz = 0;
	        this.dg = 0;
	        this.aO = aO;
	        this.bV = bV;
	        this.playing = false;
	        this.bh = bh;
	        this.H = H;
	        this.bb = null;
	        this.cb = "";
	        this.kN = bh.settings.graphicsPath + "/" + this.aO.bi.jN;
	        this.image = new Image;
	        this.bH = null;
	        this.fc = false;
	        this.jx = 0;
	        this.gB = 0;
	        this.bh.addEventListener(WR360.Events.hG, jQuery.proxy(this.mC, this));
	        this.image.onload = jQuery.proxy(this.nK, this);
	        this.image.onerror = jQuery.proxy(this.nY, this);
	        this.cb = this.bh.gK(this.aO.bi);
	        this.H.append("<div class='hotspot_indicator wr360hotspot_" + this.bh.oY + "' id='" + this.cb + "'/>");
	        this.bb = jQuery("#" + this.cb);
	        this.aH(visible);
	        this.bb.css("position", "absolute");
	        if (this.aO.bi.activateOnClick == false) {
	            this.bb.mouseover(jQuery.proxy(function(event) {
	                this.OnMouseOver(event);
	            }, this));
	        } else {
	            this.bb.click(jQuery.proxy(function(event) {
	                this.OnMouseOver(event);
	            }, this));
	        }
	        this.bb.mouseout(jQuery.proxy(function(event) {
	            this.OnMouseOut(event);
	        }, this));
	        this.bb.bind("touchstart", jQuery.proxy(function(event) {
	            this.pn(event);
	        }, this));
	        this.image.src = this.kN;
	    };
	    WR360.aT.prototype.nK = function(e) {
	        this.eC(this.dz);
	        this.fv(this.dg);
	        var image;
	        if (WR360.by.lp()) {
	            image = this.image;
	        } else {
	            image = e.target;
	        }
	        this.bb.css("background-image", "url(" + image.src + ")");
	        this.bb.css("width", image.width);
	        this.bb.css("height", image.height);
	    };
	    WR360.aT.prototype.nY = function(e) {
	        WR360.bZ.gA("DynamicHotspotPresenter. Error loading image: " + e.target.src);
	    };
	    WR360.aT.prototype.cD = function() {
	        var au = 800;
	        var ll = this.aO.index;
	        var bu = this;
	        this.jx = setTimeout(function() {
	            bu.lf();
	        }, ll * au);
	    };
	    WR360.aT.prototype.jE = function() {
	        if (this.bH) {
	            this.bH.cN(false);
	        }
	    };
	    WR360.aT.prototype.aH = function(visible, aX) {
	        if (this.bb == null) {
	            throw new Error("SetVisible: hotspotElement==null.");
	        }
	        this.df = visible;
	        if (visible) {
	            if (aX && !WR360.by.lp()) {
	                this.bb.fadeIn(300);
	            } else {
	                this.bb.show();
	            }
	        } else {
	            if (aX && !WR360.by.lp()) {
	                this.bb.fadeOut(300);
	            } else {
	                this.bb.hide();
	            }
	        }
	    };
	    WR360.aT.prototype.eC = function(x) {
	        this.dz = x;
	        this.bb.css("left", x - this.image.width / 2);
	    };
	    WR360.aT.prototype.fv = function(y) {
	        this.dg = y;
	        this.bb.css("top", y - this.image.height / 2);
	    };
	    WR360.aT.prototype.mc = function() {
	        return this.dz;
	    };
	    WR360.aT.prototype.lX = function() {
	        return this.image.width;
	    };
	    WR360.aT.prototype.lT = function() {
	        return this.image.height;
	    };
	    WR360.aT.prototype.mB = function() {
	        return this.dg;
	    };
	    WR360.aT.prototype.mE = function() {
	        return this.image.width;
	    };
	    WR360.aT.prototype.mr = function() {
	        return this.image.height;
	    };
	    WR360.aT.prototype.mx = function() {};
	    WR360.aT.prototype.nl = function() {};
	    WR360.aT.prototype.mQ = function() {};
	    WR360.aT.prototype.jY = function(e) {
	        if (this.playing == true) {
	            this.playing = false;
	            var cV = {
	                x: this.bh.dO,
	                y: this.bh.ei
	            };
	            if (WR360.by.fA(this.bb, cV) == true) {
	                this.fc = true;
	                var bu = this;
	                this.gB = setInterval(function() {
	                    bu.mb();
	                }, 200);
	            }
	            this.nl();
	        }
	    };
	    WR360.aT.prototype.mC = function(e) {
	        if (this.bH) {
	            this.bH.cN(false);
	        }
	    };
	    WR360.aT.prototype.OnMouseOut = function(e) {
	        e.stopPropagation();
	        this.fc = false;
	    };
	    WR360.aT.prototype.OnMouseOver = function(e) {
	        e.stopPropagation();
	        if (this.bh.fu == true) {
	            return;
	        }
	        if (this.playing == true) {
	            return;
	        }
	        if (this.fc == true) {
	            return;
	        }
	        this.mQ();
	        if (this.aO == null) {
	            throw new Error("ERROR: Cannot read HotspotObject from " + this.toString());
	        }
	        if (!this.bh.fu) {
	            this.fR();
	        }
	    };
	    WR360.aT.prototype.pn = function(e) {
	        e.stopPropagation();
	        this.OnMouseOver(e);
	    };
	    WR360.aT.prototype.nT = function() {
	        if (this.aO.bi.ps == 1 && this.bH != null) {
	            var aM = this.bV.oy(this.aO, this.bH.qh, this.bH.qw);
	            this.dz = aM.x;
	            this.dg = aM.y;
	            this.bH.dv.Css("left", this.dz);
	            this.bH.dv.Css("top", this.dg);
	            if (this.aO.F.src.length > 0) {
	                var aq = this.bH.aN.find("img");
	                aq.css("width", this.aO.F.width * this.bV.lB);
	                aq.css("height", this.aO.F.height * this.bV.lB);
	            }
	        }
	    };
	    WR360.aT.prototype.fR = function() {
	        this.playing = true;
	        this.bh.dispatchEvent(new WR360.Event(WR360.Events.hG, false, false));
	        this.bh.cJ();
	        if (this.bH == null) {
	            var gv = false;
	            if (this.aO.bi.ps == 1) {
	                gv = true;
	            }
	            this.bH = new WR360.bx(this.bV, this.bh.cF, gv, this.H, this.cb);
	            this.bH.iZ(this.aO);
	            this.bH.addEventListener(WR360.bx.ii, jQuery.proxy(this.jY, this));
	            this.bH.jB(this);
	            this.bH.jw(this.gV());
	        } else {
	            this.bH.jl(this.gV());
	        }
	    };
	    WR360.aT.prototype.gV = function() {
	        return {
	            x: this.dz,
	            y: this.dg
	        };
	    };
	    WR360.aT.prototype.mb = function() {
	        var cV = {
	            x: this.bh.dO,
	            y: this.bh.ei
	        };
	        if (WR360.by.fA(this.bb, cV) == false) {
	            this.fc = false;
	            clearInterval(this.gB);
	            this.gB = 0;
	        }
	    };
	    WR360.aT.prototype.lf = function() {
	        this.jx = 0;
	        this.mx();
	    };
	    WR360.aT.prototype.fZ = function() {
	        return this.bb;
	    };
	})();
	(function() {
	    WR360.bx = function(bV, cF, cv, H, cb) {
	        this.aB().constructor.call(this);
	        this.bV = bV;
	        this.cF = cF;
	        this.cv = cv;
	        this.H = H;
	        this.cb = cb;
	        this.ig = WR360.by.ge();
	        this.jj = false;
	        this.ca = false;
	        this.hn = false;
	        this.qG = "";
	        this.qO = "";
	        this.url = "";
	        this.eb = "";
	        this.ao = null;
	        this.bq = null;
	        this.aN = null;
	        this.am = null;
	        this.dW = null;
	        this.eV = null;
	        this.hf = 0;
	        this.dR = 0;
	        this.bv = 0;
	        this.bs = 0;
	        this.gL = 0;
	        this.kh = 15;
	        this.io = false;
	        this.ps = 0;
	        this.qh = 0;
	        this.qw = 0;
	        this.aO = null;
	        this.H.append("<div class='hotspot_rollover wr360rollover_" + this.bV.bh.oY + "' id='" + this.ig + "'/>");
	        this.ao = jQuery("#" + this.ig);
	        this.dv = new WR360.ef(this);
	        this.dv.aH(false);
	        this.ao.css("position", "absolute");
	        if (this.cv) {
	            this.ao.css("left", 0);
	            this.ao.css("top", 0);
	        }
	    };
	    WR360.bx.bE(WR360.dh);
	    WR360.bx.ii = "ROLLOVER_OUT_EVENT";
	    WR360.ef = function(ab) {
	        this.ab = ab;
	        this.df = true;
	    };
	    WR360.ef.prototype.Bind = function(cg, kr) {
	        var cu = this.ab.ca ? this.ab.bq : this.ab.aN;
	        cu.bind(cg, kr);
	    };
	    WR360.ef.prototype.iY = function() {
	        return this.ab.ca ? this.ab.bq : this.ab.aN;
	    };
	    WR360.ef.prototype.Css = function(nc, value) {
	        var cu = this.ab.ca ? this.ab.bq : this.ab.aN;
	        cu.css(nc, value);
	    };
	    WR360.ef.prototype.aH = function(visible) {
	        if (this.df == visible) {
	            return;
	        }
	        if (visible) {
	            this.ab.ao.show();
	        } else {
	            this.ab.ao.hide();
	        }
	        this.df = visible;
	    };
	    WR360.ef.prototype.hC = function(visible, duration, hZ) {
	        if (this.df == visible) {
	            return;
	        }
	        if (visible) {
	            if (!WR360.by.lp()) {
	                this.ab.ao.fadeIn(duration, hZ);
	            } else {
	                this.ab.ao.show();
	                hZ();
	            }
	        } else {
	            if (!WR360.by.lp()) {
	                this.ab.ao.fadeOut(duration, hZ);
	            } else {
	                this.ab.ao.hide();
	                hZ();
	            }
	        }
	        this.df = visible;
	    };
	    WR360.ef.prototype.dX = function() {
	        return this.df;
	    };
	    WR360.bx.prototype.iZ = function(aO) {
	        this.aO = aO;
	        this.ps = aO.bi.ps;
	        if (this.jj == false) {
	            var cE = null;
	            if (aO.bi.bo.cdata.length != 0) {
	                this.hn = true;
	                var ea = WR360.by.ge();
	                this.ao.append("<div id='" + ea + "'/>");
	                this.aN = jQuery("#" + ea);
	                this.aN.css("position", "relative");
	                if (aO.bi.bo.aC == true) {
	                    this.aN.css("font-family", "Arial");
	                    this.aN.css("color", "#FF0000");
	                    this.aN.css("background-color", "#FFFF00");
	                    this.aN.css("font-size", "14px");
	                }
	                this.aN.append(aO.bi.bo.cdata);
	                cE = this.aN;
	                this.aN.find("a").mousedown(jQuery.proxy(function(event) {
	                    this.nA(event);
	                }, this));
	            } else {
	                if (aO.F.src.length > 0) {
	                    this.hn = true;
	                    var ea = WR360.by.ge();
	                    this.ao.append("<div id='" + ea + "'/>");
	                    this.aN = jQuery("#" + ea);
	                    this.aN.css("position", "relative");
	                    this.aN.append("<img src='" + aO.F.src + "'/>");
	                    this.ao.css("width", aO.F.width);
	                    this.ao.css("height", aO.F.height);
	                    cE = this.aN;
	                    if (this.cv == true) {
	                        var aq = this.aN.find("img");
	                        aq.css("width", aO.F.width * this.bV.lB);
	                        aq.css("height", aO.F.height * this.bV.lB);
	                    }
	                }
	                if (!this.cv || this.aN == null) {
	                    if (aO.bi.bo.aI.length != 0) {
	                        var ib = WR360.by.ge();
	                        this.ao.append("<div id='" + ib + "'/>");
	                        this.bq = jQuery("#" + ib);
	                        this.bq.css("position", "relative");
	                        this.bq.css("z-index", 10002);
	                        this.bq.css("font-family", "Arial");
	                        this.bq.css("width", aO.bi.bo.ga + "px");
	                        this.bq.css("color", aO.bi.bo.gb);
	                        this.bq.css("background-color", aO.bi.bo.gk);
	                        this.bq.css("font-size", aO.bi.bo.fO + "px");
	                        this.bq.css("border", "1px #eeeeee solid");
	                        this.bq.css("padding", "6px 8px 10px 8px");
	                        this.bq.html(aO.bi.bo.aI.ad());
	                        if (!cE) {
	                            this.ca = true;
	                            cE = this.bq;
	                        } else {}
	                    }
	                }
	            }
	            if (cE == null) {
	                return;
	            }
	            if (this.cv == false) {
	                cE.css("left", -(this.ao.css("width").aK() / 2));
	                cE.css("top", -(this.ao.css("height").aK() / 2));
	            } else {
	                this.qh = this.ao.outerWidth();
	                this.qw = this.ao.outerHeight();
	                var aM = this.bV.oy(aO, this.qh, this.qw);
	                cE.css("left", aM.x);
	                cE.css("top", aM.y);
	            }
	            this.jj = true;
	            if (aO.bi.bo.qG != WR360.HotspotInfo.iE.NONE || aO.bi.bo.url.length != 0) {
	                this.qG = aO.bi.bo.qG;
	                this.qO = aO.bi.bo.qO;
	                this.url = aO.bi.bo.url;
	                this.eb = aO.bi.bo.eb;
	                this.dv.Css("cursor", "pointer");
	            }
	            this.dv.aH(false);
	        }
	    };
	    WR360.bx.prototype.jB = function(cd) {
	        this.dW = cd;
	    };
	    WR360.bx.prototype.jw = function(cU) {
	        this.eV = cU;
	        this.hf = this.ao.css("width").aK() / 2;
	        this.dR = this.ao.css("height").aK() / 2;
	        this.bv = this.ao.css("width").aK() / 5;
	        this.bs = this.ao.css("height").aK() / 4;
	        if (this.ps == 2 || this.cv == true) {
	            this.hf = 1;
	            this.dR = 1;
	            this.ao.css("width", 1);
	            this.ao.css("height", 1);
	        }
	        this.jl(this.eV);
	    };
	    WR360.bx.prototype.qp = function() {
	        if (!this.dv.dX()) {
	            return;
	        }
	        var cV = {
	            x: this.bV.bh.dO,
	            y: this.bV.bh.ei
	        };
	        if (WR360.by.fA(this.dW.fZ(), cV) == false) {
	            var cu = this.ca ? this.bq : this.aN;
	            if (WR360.by.fA(cu, cV) == false) {
	                this.cN(true);
	            }
	        }
	    };
	    WR360.bx.prototype.kG = function(pl) {
	        if (!this.cv || this.ps == 1) {
	            this.qp();
	        }
	    };
	    WR360.bx.prototype.ld = function(e) {
	        e.stopPropagation();
	        if (!this.cv || this.ps == 1) {
	            this.cN(true);
	        }
	    };
	    WR360.bx.prototype.lm = function(e) {
	        e.stopPropagation();
	        var pU = this.oi(e);
	        if ((!this.cv || this.ps == 1) && !pU) {
	            this.cN(true);
	        }
	    };
	    WR360.bx.prototype.nA = function(e) {
	        e.stopPropagation();
	    };
	    WR360.bx.prototype.oi = function(e) {
	        if (this.qG == WR360.HotspotInfo.iE.NONE && this.url.length > 0) {
	            var re = this.url.substr(this.url.lastIndexOf(".") + 1);
	            if (re && re.length > 0 && re.toLowerCase() == "xml") {
	                this.bV.bh.reload(this.url, this.bV.bh.settings.rootPath);
	            } else {
	                window.open(this.url, this.eb);
	            }
	            return true;
	        }
	        switch (this.qG) {
	            case WR360.HotspotInfo.iE.sX:
	                if (this.bV.bh.pY == true) {
	                    this.bV.bh.mp();
	                } else {
	                    this.bV.bh.mR();
	                }
	                break;
	            case WR360.HotspotInfo.iE.qq:
	                this.bV.bh.mp();
	                this.bV.bh.mR();
	                break;
	            case WR360.HotspotInfo.iE.mA:
	                this.bV.bh.mp();
	                break;
	            case WR360.HotspotInfo.iE.qx:
	                this.bV.bh.mp();
	                this.bV.iG(1);
	                break;
	            case WR360.HotspotInfo.iE.sL:
	                this.bV.bh.mp();
	                this.bV.iG(-1);
	                break;
	            case WR360.HotspotInfo.iE.ss:
	                this.bV.qB(this.aO.bi.bo.qO, this.aO.bi.bo.clickDataParam);
	                break;
	            case WR360.HotspotInfo.iE.rH:
	                this.bV.bh.mp();
	                this.bV.qo(this.aO.bi.bo.qO);
	                break;
	            case WR360.HotspotInfo.iE.qP:
	                this.bV.bh.mf();
	                break;
	            case WR360.HotspotInfo.iE.pB:
	                this.bV.bh.mt();
	                break;
	            case WR360.HotspotInfo.iE.sr:
	                this.bV.bh.rc(null);
	                break;
	            default:
	                ;
	        }
	        return false;
	    };
	    WR360.bx.prototype.mi = function(it) {
	        var bP = 10;
	        var fI = this.hf + bP;
	        var hv = 0;
	        if (it + fI >= this.H.css("width").aK()) {
	            return this.H.css("width").aK() - fI;
	        } else if (it - fI <= 0) {
	            return fI;
	        }
	        return it;
	    };
	    WR360.bx.prototype.lF = function(gR) {
	        var bP = 5;
	        var jv = 0;
	        var iL = this.dR + jv + this.kh + bP;
	        if (gR + iL >= this.H.css("height").aK()) {
	            return this.H.css("height").aK() - iL;
	        } else if (gR - this.dR + bP <= 0) {
	            return this.dR + bP;
	        }
	        return gR;
	    };
	    WR360.bx.prototype.jl = function(cU) {
	        this.unbindRolloverEvents();
	        if (this.dv.dX()) {
	            return;
	        }
	        this.eV = cU;
	        if (this.cv == false) {
	            this.ao.css("left", this.mi(this.eV.x));
	            this.ao.css("top", this.lF(this.eV.y));
	        }
	        if (this.cv || this.ca) {
	            this.ao.css("width", this.hf * 2);
	            this.ao.css("height", this.dR * 2);
	        }
	        if (this.hn == true) {
	            this.dv.hC(true, 300, jQuery.proxy(this.jm, this));
	        } else if (this.ca == true) {
	            this.dv.hC(true, 300, jQuery.proxy(this.jm, this));
	        }
	        if (!WR360.by.iR) {
	            var bu = this;
	            this.gL = setInterval(function() {
	                bu.kG();
	            }, 300);
	        }
	    };
	    WR360.bx.prototype.cN = function(aX) {
	        if (!WR360.by.iR) {
	            clearInterval(this.gL);
	            this.gL = 0;
	        }
	        if (!this.dv.dX()) {
	            return;
	        }
	        if (WR360.by.lp()) {
	            aX = false;
	        }
	        if (aX) {
	            this.dv.hC(false, 400, jQuery.proxy(this.kk, this));
	        } else {
	            this.dv.aH(false);
	            this.kk();
	        }
	        this.unbindRolloverEvents();
	        this.dispatchEvent(new WR360.Event(WR360.bx.ii, false, false));
	    };
	    WR360.bx.prototype.unbindRolloverEvents = function() {
	        if (this.bq) {
	            this.bq.unbind();
	        }
	        if (this.aN) {
	            this.aN.unbind();
	        }
	        this.H.unbind("touchstart.proxy" + this.ig);
	        this.H.unbind("mousedown.proxy" + this.ig);
	    };
	    WR360.bx.prototype.jm = function() {
	        if (!WR360.by.iR) {
	            this.dv.Bind("mousedown", jQuery.proxy(function(event) {
	                this.lm(event);
	            }, this));
	            this.H.bind("mousedown.proxy" + this.ig, jQuery.proxy(function(event) {
	                this.ld(event);
	            }, this));
	        } else {
	            this.dv.Bind("touchstart", jQuery.proxy(function(event) {
	                this.lm(event);
	            }, this));
	            this.H.bind("touchstart.proxy" + this.ig, jQuery.proxy(function(event) {
	                this.ld(event);
	            }, this));
	        }
	    };
	    WR360.bx.prototype.kk = function() {};
	    WR360.bx.prototype.iA = function() {};
	})();
	(function() {
	    WR360.jI = function(id, visible) {
	        this.Id = id;
	        this.Visible = visible;
	    };
	})();
	(function() {
	    WR360.cP = function(id, dF, cn) {
	        this.cj = false;
	        this.df = false;
	        this.id = id;
	        this.dF = dF;
	        this.cn = cn;
	        this.K = jQuery("#" + this.id);
	    };
	    WR360.cP.prototype.iW = function() {
	        return this.cj;
	    };
	    WR360.cP.prototype.fi = function(fh) {
	        if (this.cj == fh) {
	            return;
	        }
	        if (!this.cj) {
	            this.K.attr("class", this.cn);
	        } else {
	            this.K.attr("class", this.dF);
	        }
	        this.cj = fh;
	    };
	    WR360.cP.prototype.aH = function(visible) {
	        if (this.K == null) {
	            throw new Error("SetVisible: buttonElement==null.");
	        }
	        this.df = visible;
	        if (visible) {
	            this.K.show();
	        } else {
	            this.K.hide();
	        }
	    };
	    WR360.eI = function(id, cg, be, dF, ck, cn, cY, du) {
	        this.aB().constructor.call(this, id, dF, cn);
	        this.jn = false;
	        this.cg = cg;
	        this.ck = ck;
	        this.cY = cY;
	        this.du = du;
	        this.be = be;
	    };
	    WR360.eI.bE(WR360.cP);
	    WR360.eI.prototype.cD = function() {
	        if (this.jn) {
	            return;
	        }
	        this.K.bind(this.cg, jQuery.proxy(this.ck, this.be));
	        this.jn = true;
	    };
	    WR360.eI.prototype.fi = function(fh) {
	        if (this.cj == fh) {
	            return;
	        }
	        if (!this.cj) {
	            this.K.unbind(this.cg);
	            this.K.attr("class", this.cn);
	            if (this.du == 0) {
	                this.K.bind(this.cg, jQuery.proxy(this.cY, this.be));
	            } else {
	                var bu = this;
	                setTimeout(function() {
	                    bu.ka();
	                }, this.du);
	            }
	        } else {
	            this.K.unbind(this.cg);
	            this.K.attr("class", this.dF);
	            if (this.du == 0) {
	                this.K.bind(this.cg, jQuery.proxy(this.ck, this.be));
	            } else {
	                var bu = this;
	                setTimeout(function() {
	                    bu.lj();
	                }, this.du);
	            }
	        }
	        this.cj = fh;
	    };
	    WR360.cP.prototype.ka = function() {
	        this.K.bind(this.cg, jQuery.proxy(this.cY, this.be));
	    };
	    WR360.cP.prototype.lj = function() {
	        this.K.bind(this.cg, jQuery.proxy(this.ck, this.be));
	    };
	    WR360.fb = function(id, cg, be, dF, ck, cn, cY, du) {
	        this.aB().constructor.call(this, id, cg, be, dF, ck, cn, cY, du);
	    };
	    WR360.fb.bE(WR360.eI);
	    WR360.fb.prototype.pb = function() {
	        return this.iW();
	    };
	    WR360.fb.prototype.ji = function(playing) {
	        this.fi(playing);
	    };
	    WR360.ej = function(id, dF, cn) {
	        this.aB().constructor.call(this, id, dF, cn);
	    };
	    WR360.ej.bE(WR360.cP);
	    WR360.ej.prototype.nM = function() {
	        return this.iW();
	    };
	    WR360.ej.prototype.as = function(dn) {
	        this.fi(dn);
	    };
	})();
	(function() {
	    WR360.bN = function() {
	        this.he = 1;
	        this.aF = -1;
	        this.bU = null;
	        this.bB = null;
	        this.V = null;
	        this.es = 0;
	        this.fe = 0;
	        this.bh = null;
	        this.db = true;
	        this.cA = null;
	        this.hz = null;
	        this.ce = null;
	        this.en = false;
	        this.hw = false;
	        this.cX = new WR360.J;
	        this.aU = null;
	        this.dZ = 0;
	        this.jr = true;
	        this.lc = false;
	        this.H = null;
	        this.bd = null;
	        this.jp = null;
	        this.aG = null;
	        this.kL = null;
	        this.qH = null;
	        this.kv = -1;
	        this.kl = "ready";
	        this.lB = 1;
	        this.rm = false;
	        this.pJ = 0;
	    };
	    WR360.bN.prototype.nR = function() {
	        for (var ai in this.cA) {
	            ai.aH(false);
	            ai.jE();
	        }
	    };
	    WR360.bN.prototype.iF = function(bh, bd, jp) {
	        this.bh = bh;
	        this.bd = bd;
	        this.aG = bd;
	        this.jp = jp;
	    };
	    WR360.bN.prototype.cD = function(bU, bB, V, es, fe, aU, H) {
	        this.cA = new Array;
	        this.hz = new Array;
	        this.ce = new Array;
	        this.bU = bU;
	        this.bB = bB;
	        this.V = V;
	        this.aU = aU;
	        this.H = H;
	        this.lB = this.bh.lB;
	        this.he = this.bh.bA.settings.bg.kC == -1 ? 1 : -1;
	        if (this.bh.pH != null && this.bh.pH.configFileFullScreenURL == "" && this.bh.settings.fullScreenOnClick == false) {
	            this.es = this.bh.pH.dG;
	            this.fe = this.bh.pH.dA;
	        } else {
	            this.es = es;
	            this.fe = fe;
	        }
	        this.bh.addEventListener(WR360.Events.gM, jQuery.proxy(this.lO, this));
	        this.bh.addEventListener(WR360.Events.gY, jQuery.proxy(this.mo, this));
	        if (this.V.settings.control.hideHotspotsOnLoad) {
	            this.db = false;
	        }
	        for (var i = 0; i < this.bB.bF.length; i++) {
	            var aO = this.bB.bF[i];
	            if (aO.bi.disabled == true) {
	                continue;
	            }
	            var dj = aO.bi.id;
	            var ai = null;
	            if (aO.bi.dI == false) {
	                ai = new WR360.aT(false, aO, this, this.bh, this.H);
	            } else {
	                ai = new WR360.cI(false, aO, this, this.bh, this.H);
	            }
	            this.cA[dj] = ai;
	            this.hz[dj] = this.ce[i] = new WR360.jI(dj, true);
	            ai.cD();
	        }
	    };
	    WR360.bN.prototype.oy = function(aO, qb, rj) {
	        var x = 0;
	        var y = 0;
	        var bi = aO.bi;
	        var width = qb;
	        var height = rj;
	        if (aO.F.src.length > 0) {
	            width = aO.F.width * this.lB;
	            height = aO.F.height * this.lB;
	        }
	        if (bi.offset.ot()) {
	            return {
	                x: bi.offset.x * this.lB,
	                y: bi.offset.y * this.lB
	            };
	        }
	        switch (bi.align.horizontal) {
	            case WR360.Align.LEFT:
	                x = bi.margin.left;
	                break;
	            case WR360.Align.CENTER:
	                x = bi.margin.left + (this.H.css("width").aK() - bi.margin.left - bi.margin.right - width) / 2;
	                break;
	            case WR360.Align.RIGHT:
	                x = this.H.css("width").aK() - bi.margin.right - width;
	                break;
	            default:
	                ;
	        }
	        switch (bi.align.vertical) {
	            case WR360.Align.TOP:
	                y = bi.margin.top;
	                break;
	            case WR360.Align.CENTER:
	                y = bi.margin.top + (this.H.css("height").aK() - bi.margin.top - bi.margin.bottom - height) / 2;
	                break;
	            case WR360.Align.BOTTOM:
	                y = this.H.css("height").aK() - bi.margin.bottom - height;
	                break;
	            default:
	                ;
	        }
	        return {
	            x: x,
	            y: y
	        };
	    };
	    WR360.bN.prototype.fo = function() {
	        var dir = this.V.settings.bg.kC;
	        if (this.V.settings.bg.oc == "true") {
	            this.he = dir == -1 ? 1 : -1;
	        } else {
	            this.he = dir == -1 ? -1 : 1;
	        }
	        return this.iG(this.he);
	    };
	    WR360.bN.prototype.eT = function() {
	        var dir = this.V.settings.bg.kC;
	        if (this.V.settings.bg.oc == "true") {
	            this.he = dir == -1 ? 1 : -1;
	        } else {
	            this.he = dir == -1 ? 1 : -1;
	        }
	        return this.iG(this.he);
	    };
	    WR360.bN.prototype.ny = function() {
	        this.dE(0);
	    };
	    WR360.bN.prototype.nC = function() {
	        this.dE(this.bU.aw.length - 1);
	    };
	    WR360.bN.prototype.iG = function(jG) {
	        return this.dE(this.aF + jG);
	    };
	    WR360.bN.prototype.qo = function(label) {
	        if (label && label.length > 0) {
	            for (var i = 0; i < this.bU.aw.length; i++) {
	                if (this.bU.aw[i].image.label.toLowerCase() == label.toLowerCase()) {
	                    return this.dE(i);
	                }
	            }
	        }
	        return false;
	    };
	    WR360.bN.prototype.qB = function(label, rF, hZ) {
	        if (this.pJ != 0) {
	            return true;
	        }
	        this.bh.cJ();
	        var targetIndex = -1;
	        if (label && label.length > 0) {
	            for (targetIndex = 0; targetIndex < this.bU.aw.length; targetIndex++) {
	                if (this.bU.aw[targetIndex].image.label.toLowerCase() == label.toLowerCase()) {
	                    break;
	                }
	            }
	        }
	        if (targetIndex == -1) {
	            return false;
	        }
	        if (targetIndex == this.aF) {
	            return true;
	        }
	        var pE = false;
	        var pO = true;
	        var lM = this;
	        var pv = Math.abs(lM.aF - targetIndex);
	        if (pv <= this.bU.aw.length / 2) {
	            pO = lM.aF < targetIndex;
	        } else {
	            pO = lM.aF > targetIndex;
	        }
	        var qD = function() {
	            if (pE || lM.aF == targetIndex) {
	                clearInterval(lM.pJ);
	                lM.pJ = 0;
	                lM.bh.removeEventListener(WR360.Events.mA, pV);
	                lM.bh.eg.ji(false);
	                lM.bh.pY = false;
	                if (lM.aF == targetIndex && typeof hZ !== "undefined") {
	                    if (hZ != null) {
	                        hZ(label);
	                    }
	                }
	                return;
	            }
	            lM.rm = true;
	            pO ? lM.eT() : lM.fo();
	            lM.rm = false;
	        };
	        var pV = function() {
	            pE = true;
	        };
	        this.bh.addEventListener(WR360.Events.mA, pV);
	        this.bh.eg.ji(true);
	        this.bh.pY = true;
	        var gg = WR360.by.dM(rF, 1);
	        var eo = gg / this.bU.aw.length * 1000;
	        this.pJ = setInterval(function() {
	            qD();
	        }, eo);
	        return true;
	    };
	    WR360.bN.prototype.ob = function() {
	        return this.aF;
	    };
	    WR360.bN.prototype.lV = function(index) {
	        var kj = false;
	        if (index < 0) {
	            index = -index;
	            kj = true;
	        }
	        if (index > this.bU.aw.length - 1) {
	            index = index % this.bU.aw.length;
	        }
	        if (index > 0 && kj) {
	            index = this.bU.aw.length - index;
	        }
	        return index;
	    };
	    WR360.bN.prototype.nk = function(index) {
	        if (!this.rm && this.V.settings.bg.bounce) {
	            if (index >= this.bU.aw.length - 1) {
	                return this.bU.aw.length - 1;
	            } else if (index <= 0) {
	                return 0;
	            }
	        }
	        return this.lV(index);
	    };
	    WR360.bN.prototype.fK = function(bW, deltaX, deltaY) {
	        var fL = this.bU.aw[bW].bG;
	        if (fL == null) {
	            return;
	        }
	        if (deltaX == null) {
	            deltaX = 0;
	        }
	        if (deltaY == null) {
	            deltaY = 0;
	        }
	        var dC = 0;
	        var cK = 0;
	        if (this.bh.bA.iq()) {
	            dC = this.bh.bA.aw.ep;
	            cK = this.bh.bA.aw.eU;
	        } else {
	            dC = fL.width;
	            cK = fL.height;
	        }
	        this.aG.css("width", dC);
	        this.aG.css("height", cK);
	        if (this.jr) {
	            this.aG.css("margin-left", this.aU['_viewPort.x'] + (this.aU['_viewPort.width'] - dC) / 2 + deltaX);
	            this.aG.css("margin-top", this.aU['_viewPort.y'] + (this.aU['_viewPort.height'] - cK) / 2 + deltaY);
	            if (this.dZ == 0) {
	                this.dZ = dC / this.aU['_viewPort.width'];
	            }
	            if (this.bh.fm - dC < 0) {
	                this.bh.eL.eY = this.bh.fm - dC;
	                this.bh.eL.fd = 0;
	            } else {
	                this.bh.eL.eY = 0;
	                this.bh.eL.fd = this.bh.fm - dC;
	            }
	            if (this.bh.fJ - cK < 0) {
	                this.bh.eL.ev = this.bh.fJ - cK;
	                this.bh.eL.fM = 0;
	            } else {
	                this.bh.eL.ev = 0;
	                this.bh.eL.fM = this.bh.fJ - cK;
	            }
	            this.jr = false;
	        }
	        this.hs(fL.src);
	        if (!this.bh.eG()) {
	            this.eh(bW);
	        }
	        this.aU['_viewPort.zoomedInX'] = this.aG.css("margin-left").aK();
	        this.aU['_viewPort.zoomedInY'] = this.aG.css("margin-top").aK();
	        this.aU['_viewPort.zoomedInWidth'] = this.aG.css("width").aK();
	        this.aU['_viewPort.zoomedInHeight'] = this.aG.css("height").aK();
	        this.hw = true;
	    };
	    WR360.bN.prototype.dE = function(index, deltaX, deltaY) {
	        var ic = this.aF;
	        var returnValue = true;
	        this.aF = parseInt(this.nk(index));
	        if (ic >= 0 && this.aF == ic) {
	            returnValue = false;
	        }
	        var af = this.bU.aw[this.aF];
	        if (this.en && af.image.cS != null) {
	            if (af.bG != null && af.bG.cQ == true) {
	                this.aS(null);
	                this.fK(this.aF);
	            } else {
	                this.aS(af);
	                if (!this.cX.contains(af)) {
	                    this.cX.bk(af);
	                    af.addEventListener(WR360.ah.eD, jQuery.proxy(this.hm, this), {
	                        deltaX: deltaX,
	                        deltaY: deltaY
	                    });
	                    af.addEventListener(WR360.ah.dU, jQuery.proxy(this.eK, this));
	                    af.addEventListener(WR360.ah.fD, jQuery.proxy(this.eK, this));
	                    af.hS();
	                    if (af.bG == null || af.bG.cQ == false) {
	                        this.bh.hc(true);
	                        this.bh.er(this.cX.ds().toString());
	                    }
	                }
	                if (af.bG == null || af.bG.cQ == false) {
	                    this.iM(this.aF, true);
	                }
	            }
	        } else {
	            this.iM(this.aF, this.hw);
	        }
	        return returnValue;
	    };
	    WR360.bN.prototype.aS = function(iw) {
	        var bC = 0;
	        if (this.cX.contains(iw)) {
	            bC = 1;
	        }
	        while (this.cX.ds() > bC) {
	            var af = this.cX.mh(0);
	            if (af != iw) {
	                af.removeEventListener(WR360.ah.eD, this.hm);
	                af.removeEventListener(WR360.ah.dU, this.eK);
	                af.removeEventListener(WR360.ah.fD, this.eK);
	                af.aE();
	                this.cX.removeItem(af);
	            }
	        }
	        if (this.cX.ds() == 0) {
	            this.bh.hc(false);
	        }
	        this.bh.er(this.cX.ds().toString());
	    };
	    WR360.bN.prototype.iM = function(bW, jT) {
	        if (this.bU == null) {
	            return;
	        }
	        if (this.bU.aw[bW].F.src.length == 0) {
	            return;
	        }
	        this.hs(this.bU.aw[bW].F.src);
	        if (!this.bh.eG()) {
	            this.eh(bW);
	        }
	        if (jT) {
	            this.hw = false;
	        }
	    };
	    WR360.bN.prototype.kg = function() {
	        if (this.ce != null) {
	            for (var i = 0; i < this.ce.length; i++) {
	                this.ce[i].Visible = false;
	            }
	        }
	    };
	    WR360.bN.prototype.eh = function(bW, aX) {
	        if (!this.db) {
	            return;
	        }
	        if (this.aG.is(":visible") != true) {
	            var bn = this;
	            setTimeout(function() {
	                bn.eh(bW, aX);
	            }, 400);
	            return;
	        }
	        this.kg();
	        if (!this.bU) {
	            return;
	        }
	        var af = this.bU.aw[bW];
	        if (!af) {
	            return;
	        }
	        for (var i = 0; i < af.image.bF.length; i++) {
	            var al = af.image.bF[i];
	            if (al != null) {
	                var ai = this.cA[al.source];
	                if (ai != null) {
	                    ai.eC(this.aG.css("left").aK() + this.aG.css("margin-left").aK() + al.offsetX * (this.aG.css("width").aK() / this.es));
	                    ai.fv(this.aG.css("top").aK() + this.aG.css("margin-top").aK() + al.offsetY * (this.aG.css("height").aK() / this.fe));
	                    ai.aH(true, aX);
	                    this.hz[al.source].Visible = true;
	                }
	            }
	        }
	        for (var i = 0; i < this.ce.length; i++) {
	            var bi = this.ce[i];
	            if (typeof bi !== undefined && bi != null) {
	                ai = this.cA[bi.Id];
	                if (ai != null) {
	                    var aO = ai.aO;
	                    if (aO != null && (aO.bi.dI == true || aO.bi.ps == 1)) {
	                        ai.nT();
	                    }
	                }
	            }
	        }
	        this.kQ();
	    };
	    WR360.bN.prototype.kQ = function() {
	        for (var i = 0; i < this.ce.length; i++) {
	            var jg = this.ce[i];
	            if (!jg.Visible) {
	                this.cA[jg.Id].aH(false);
	            }
	        }
	    };
	    WR360.bN.prototype.kM = function(duration, left, top, marginLeft, marginTop, width, height) {
	        if (!this.db) {
	            return;
	        }
	        var af = this.bU.aw[this.aF];
	        for (var i = 0; i < af.image.bF.length; i++) {
	            var al = af.image.bF[i];
	            if (al != null) {
	                var ai = this.cA[al.source];
	                if (ai != null) {
	                    var aO = ai.aO;
	                    if (aO.bi.dI == false) {
	                        ai.bb.animate({
	                            left: left + marginLeft + al.offsetX * (width / this.es) - ai.lX() / 2,
	                            top: top + marginTop + al.offsetY * (height / this.fe) - ai.lT() / 2
	                        }, duration);
	                    }
	                }
	            }
	        }
	    };
	    WR360.bN.prototype.lx = function(aX) {
	        for (var i = 0; i < this.ce.length; i++) {
	            this.cA[this.ce[i].Id].aH(false, aX);
	        }
	        this.bh.R = false;
	    };
	    WR360.bN.prototype.hs = function(src) {
	        if (!this.bh.eG()) {
	            this.bd.attr("src", src);
	        } else {
	            if (this.aG == this.bd) {
	                this.aG = this.jp;
	                this.kL = this.bd;
	                this.pK(this.bd, this.jp);
	                this.jp.attr("src", src);
	                this.mZ(this.jp, this.bd, this);
	            } else if (this.aG == this.jp) {
	                this.aG = this.bd;
	                this.kL = this.jp;
	                this.pK(this.jp, this.bd);
	                this.bd.attr("src", src);
	                this.mZ(this.bd, this.jp, this);
	            }
	        }
	    };
	    WR360.bN.prototype.pK = function(fromElement, toElement) {
	        toElement.css("margin-left", fromElement.css("margin-left"));
	        toElement.css("margin-top", fromElement.css("margin-top"));
	        toElement.css("width", fromElement.css("width"));
	        toElement.css("height", fromElement.css("height"));
	        toElement.css("left", fromElement.css("left"));
	        toElement.css("top", fromElement.css("top"));
	        toElement.css("display", fromElement.css("display"));
	    };
	    WR360.bN.prototype.mZ = function(oh, pk, jO) {
	        setTimeout(function() {
	            oh.css("z-index", 2002);
	            pk.css("z-index", 0);
	            jO.eh(jO.aF);
	        }, 10);
	    };
	    WR360.bN.prototype.lO = function(e) {
	        this.db = true;
	        this.eh(this.aF, true);
	        this.bh.ih(true);
	    };
	    WR360.bN.prototype.mo = function(e) {
	        this.db = false;
	        this.lx(true);
	        this.bh.ih(false);
	    };
	    WR360.bN.prototype.fP = function() {
	        this.eh(this.aF);
	    };
	    WR360.bN.prototype.hm = function(e, offset) {
	        if (e.af == null) {
	            return;
	        }
	        this.cX.removeItem(e.af);
	        if (this.cX.ds() == 0) {
	            this.bh.hc(false);
	        }
	        this.bh.er(this.cX.ds().toString());
	        if (!this.en) {
	            return;
	        }
	        e.af.removeEventListener(WR360.ah.eD, this.hm);
	        e.af.removeEventListener(WR360.ah.dU, this.eK);
	        e.af.removeEventListener(WR360.ah.fD, this.eK);
	        if (e.af.index != this.aF) {
	            return;
	        }
	        this.fK(this.aF, offset.deltaX, offset.deltaY);
	    };
	    WR360.bN.prototype.eK = function(e) {
	        if (e.af == null) {
	            return;
	        }
	        this.cX.removeItem(e.af);
	        if (this.cX.ds() == 0) {
	            this.bh.hc(false);
	        }
	        this.bh.er(this.cX.ds().toString());
	        e.af.removeEventListener(WR360.ah.eD, this.hm);
	        e.af.removeEventListener(WR360.ah.dU, this.eK);
	        e.af.removeEventListener(WR360.ah.fD, this.eK);
	    };
	})();
	(function() {
	    WR360.by.mG();
	    var hT = false;
	    var jR = true;
	    document.ondragstart = function() {
	        return false;
	    };
	    jQuery(window).unload(function() {
	        jQuery.each(lH.ew, function() {
	            if (this.av) {
	                this.pR(null);
	            }
	        });
	    });
	    jQuery(window).resize(function() {
	        jQuery.each(lH.ew, function() {
	            if (this.or == true) {
	                this.pS();
	            }
	        });
	    });
	
	    function ra() {
	        jQuery.each(lH.ew, function() {
	            this.qn();
	        });
	    }
	    jQuery(document).ready(function() {
	        hT = true;
	        if (typeof lH === "undefined" || typeof lH.ew === "undfeined") {
	            return;
	        }
	        jQuery.each(lH.ew, function() {
	            this.jy();
	        });
	    });
	    var ko = "ECAwQFBgcICQAB";
	    var fp = "";
	    WR360.jX = function() {
	        this.eY = 0;
	        this.ev = 0;
	        this.fd = 0;
	        this.fM = 0;
	    };
	    WR360.ImageRotator = function(cR) {
	        this.aB().constructor.call(this);
	        if (cR != null && cR.length > 0) {
	            this.cR = "#" + cR;
	            this.oY = cR;
	        }
	        lH.add(this);
	        this.settings = new WR360.jQ;
	        this.jP = 0;
	        this.fm = 0;
	        this.fJ = 0;
	        this.dO = 0;
	        this.ei = 0;
	        this.hl = false;
	        this.oX = 0;
	        this.cp = 0;
	        this.ha = 0;
	        this.hg = 0;
	        this.qe = 0;
	        this.eu = false;
	        this.eS = 0;
	        this.eO = 0;
	        this.ri = false;
	        this.nJ = 0;
	        this.kU = false;
	        this.pY = false;
	        this.oS = false;
	        this.bU = null;
	        this.bB = null;
	        this.eE = null;
	        this.eP = 0;
	        this.dG = 0;
	        this.dA = 0;
	        this.loaded = false;
	        this.viewerBackgroundColor = "";
	        this.bA = new WR360.gl;
	        this.nL = "";
	        this.configFileFullScreenURL = "";
	        this.fN = "";
	        this.gf = "";
	        this.rootPath = "";
	        this.cq = null;
	        this.toolbar = new WR360.Toolbar(this);
	        this.dV = false;
	        this.reloadImageIndex = -1;
	        this.aU = new Array;
	        this.dn = false;
	        this.qY = true;
	        this.R = false;
	        this.bd = null;
	        this.jp = null;
	        this.jW = 0;
	        this.jt = 0;
	        this.eL = new WR360.jX;
	        this.bV = new WR360.bN;
	        this.fs = 0;
	        this.fX = 0;
	        this.db = true;
	        this.cF = new WR360.hI;
	        this.fu = false;
	        this.jo = true;
	        this.or = false;
	        this.av = false;
	        this.reloadCallback = null;
	        this.ok = null;
	        this.fl = 0;
	        this.ak = 0;
	        this.aV = 0;
	        this.fq = 0;
	        this.oa = 0;
	        this.pp = 0;
	        this.O = 50 * this.hE();
	        this.eo = 500 * this.hE();
	        this.gy = 0;
	        this.gQ = -1;
	        this.bw = 300;
	        this.licenseFileURL = "license.lic";
	        this.cr = null;
	        this.cZ = null;
	        this.oV = false;
	        this.fT = true;
	        this.fQ = false;
	        this.pL = true;
	        this.eg = null;
	        this.dN = null;
	        this.bY = null;
	        this.qZ = null;
	        this.hB = false;
	        this.bS = false;
	        this.ey = false;
	        this.gT = false;
	        this.bM = false;
	        this.qX = false;
	        this.lB = 1;
	        this.gu = "rdVd3lrjF/EFcxKccvguE5TGmYpDXz16dn3CLv2qNR7fcnEECgg7ebiZEA==";
	        this.oD = "i8ujXOfyQKsb0ntiQLRJNqDYT9/9OTL6lvTpPB41YFAxMZ9Rt1pBpA==";
	        this.hV = "pEObvaqAslGmqYSI1iZngQ3MF/Ar3ZGxZ78TLJ1LZW4kqxU0";
	        this.pD = "ohtdbI/Ul1vCoSNkyoMEAlSUbVOqLNdSbs9XJPekPzilsNp6DFHMI/E=";
	        this.qN = "WXau8tyNHUiBQE1xmrkAdTYP/ZKx+Vu92rRIkbli1cMxbsyz";
	        this.gF = "RamEB6nl1dIeNBEZm7QDsOVb3dGGYWkwNVHWuvJ94wp9G3vW5SHvOOlX44oxMBX7X1vxUANM+tmDqjoqhA==";
	        this.ju = "GlSkJBzsD5RcCjrwLEVCJ7mIFwJDyCqGGD5NdA==";
	        this.bc = "eLD7JUtPYvyJvsxgrAnCsNSQCgEM7pIfT94HS1rOoLcL2MwyCMuro5pRUlZ5d1RS1DrWjP6l1qNzk6TlHh9omapeMmUV8/FkXCK0FPgIoU9yitzubDz5YmpAWEZAouM9ortgcOiOj734L22h//27xDhbGQa+VU9RGknhdPZN5uqrsOrF0a+kMfYYNxSxRbS7OsmPnBTwGkcq4HiLvnc=";
	        this.ap = "TwxktOdX72sNWYxdOZklOOQODD3v/24BL/L3TqfGHTdXH1FgV4B3p0l369uDHjcukAzhbGZGeHpcIcE0hYFO+RQdLIzsG/rzmx37a88D+HbdTlQrliszG4ssH4QdWjuUYEAu1q5Z4kswmvKFVxbERVldXQrZzLX9wzrZGoej0bkEwuw5";
	        this.aY = "Q3al7L/L0P9pKODM8KKroGEN0uVXShCvTyhMM6e/SVOR3++eyV0lzeMt9srGcZIhVUNQw5ilDRPYx4WQE9wm0zp6XDihvR7PyNMi6Kf2ejGoVPg3WPY9hNN1dqrqaEaaSsRQvU1kSATMxl7M9Y5KYC7xtB2jhpb47MLtMyVDDsXPWNws9x9aYbFHXmNFywwJ2aYUoA7kCgGBaKajtCCNdXmK+jJXm3a7";
	        this.bj = "HBxXgwukRpBsuvZcuDhoAlS7QJKv3fqMVC6hPzKuX6bxLD57uiXEN4s+TsbGT+PVr97SoEnk5qVnLihaVLyvY7s6cd2oBhvpsPEfJRiXTofF0atdDzoFJgkrSUPb1Gk7CUn/E4kcVidBATbFSAqXuToe55CMy0DX1ACkFWwtvIrDX/CYGw31M/OIVxEIZHXkNj9LOexPqp33jeQj7hEpzGUdv0qsmJdtydHpAXSGiyIeXj9bZA==";
	        this.aQ = "W7rMSKsW9MaGeot+2i175+dODmvU77QTH4r7nbbbHaYtwpgCIbCkAHxjP2TEULx8R6SO5WujzE4H+gskhOTj/gH8SchaFibUWdh6ZWoa5TyB1v0snPyH1gOhLiJdxHqY9Fnd4gpjHGyn+EbOOT+tvSAj20D7ZbduDQ/w45q2ETE/KOrNuLY5rYrwYVSPOIzt0H8TA+ZWMRkhfmczD/MSBtm9EU7YCy/OXWxPyuYE/WQVKTMYIg==";
	        this.hq = "CE5WQFjMWoXIqJM96X2TgU1Zno0u6NzcBR5NJQzcCnh6aLx0jbxlaRPwn23afzHaH0PznBiCZ0lDce+LCiBOsh6d8iQ/78e5DT2xkuCR0oZ4svuWHzfHXMOnGjea5DEZgrcmoKPPZ/1AQDYmIfog2qS+iLXffCi6AfBAGH3i5atEbEWTzNbZVKTc+czWAg9K2d+K1JU4YKaCJJLu0U6OxhJfKuGd/O7R1Uw4Kbd8ytef/QhfOorY6lzvtGRsiJSdj7HsaEUqPPoXMxSHbDqbVJNaS4HUEzpuLVT/tYCaTpcAhtQL6FzvISKN7W+wMtKCLogNAqITfVyvlAywc/N7RvE5HZnkBVVs8yUGA139CBfKdsbvAsN/fmLL5qlTu1bqSNJM2dYuGsVnC88WwMqvAl8jhNiregSonOIBO2F5JpdH/BSKT/2YLTEvHLOkUow+yGMPAqDX+D3mAb5iEeHGIgUfov5T8pIyyzENjwPSKsPrhpF5sonxIaMPXbQmATZjjkHyDUbLul+79/xeAWuRCAo9uW+pJhCqopFL6KuxlWEr1LcA5hHL3soUkHIBLrUwplCxDEsz2Px1cRLQiOOaLolpdnHt/DH3c97zeofte92zzy0D+Di8wqU+vWZTnVfxPM0T01UZFfeZ/7C4gjRSAASHYtwFTw0DSMsoAY4pRy4VjXdv888STtiIxSSjTnWNTXvjr/zPJqVb+uFslxxyvPDXcUW7HYvOhMSEEA3S1/PlGKIO/datgZgI5tge+a/IwbXaS/LCg95KhBkp6Dlenx9CCXJ8y/yOz2TNzTNG4ULUHwDm2ohcMkg1aQjdyS9yZF0nu51IdiXLSXs8tmE1fzFLu/I5VnxIXScQdG/uDFgsRREhMQK+zBYTkP8tDrcT8al4Sma69AK3ud4GVxvsVLp0dK8tG7+ELIMA9jdFxEvfnJYHdOWqvgYnBUYSmq6x1u0alDr+HxuNBznWOrtjEfGOuwOFkx1OU09JAY1OFuA+iaCDOcDRip9xJpSt2S1oz0bAo+56uKlUA8sMf+wIVR8uIW/5N04yaxhnMu2LXxPV4tzu/3oqwzMmFr5VPcyDL4JD1FZfX2B7/Qrr4JgAtkyy4tY0a/pckoZCugR3VL0HW38EVJMuAZoO7jmoeApqhFnXeEeI9mosIrbMOXvsw1XdilTlNUOLPUrLTsY3jOhK9Iciq1QsoiNXdqSbJk3bnOqF9A9bs5PKmicW6bDXa/wHLOVFZumZJQazPY1eAblal3FfN8Taq+o5vwlqtODHMh2bILVcWv/lQbB1tWUh8p7FwLVEbU0dSxvLjbplkOnZz/5KEb4Q4GDOhw5D0q/MM6RqGGNJFMKbK3qBuQHK0Y9E16F4ZDCDOmoErVGwRkhCDMYUxH8M69WyM49KgECj4p5gAJFAy06Q2HKUispuQu/3Jb1hFe1RA5DTkH0fBrDokm5dOooZg5HubZ7qsoDD9xsX+maN0F9uFSCXS+oyBFgjTfGz4oqM8cHNly3AK3P/T/Z96AqZrNaSZoNQhQpQWlTxR+FDCa/jt+F5XWYkj8H7rCXxvKZFUwbMDgkv5XLDQgARb/sI";
	        this.cl = "dktqJEFqoPEq0tpyHW+t+g0A5z1CM2WYZjA=";
	        this.cB = "R/l5GGs2Xaf3cRvrvK1nanLt6096Idh0";
	        this.ay = "QNwfbJZzxJbLJoAS6wD5rjfHAwo=";
	        this.eN = "+TRK8gwDasJDqGQwNufuXbi0Y6X3EzfY";
	        this.eQ = "Afj02wTB6swmDOMmUBKl0YqPUGAmx3mj";
	        this.ft = "wCGtg+3u3OfUBYPdq/af6ZVoYJ7/UddZbmK1Zw==";
	        this.iO = "sU1SxZ+bTWPPsst0n2G3qVvXmytz72GF/Dk7IouwuME=";
	        this.gZ = "UWNbywprZj418vl75nvvduad1DXwSOjFCo6Ehv6sWqoQKzts8y/bduk2OBO6w/Ob3XV9U4EiAQ2r0l6ceDhoTqSK";
	        this.gq = "cW56SgPLG88nDk0oTcc44H6Wnkw3TZr3iPKk4aa9SGp8GxIRAURjmfeen+Cw7oZ4i62ZoFszodE3nXLf";
	        this.pr = "rDRrdT/G3CyWJhlFPwJyqargFHqHSCgKoUMu3HDGhxn7WohEA1YONuK2TagGaNDqG8vk2Z7RQ7WLc3ZWG8L0mOstNa/bYPwAKhefJqWqoSJnQ1i6myiTb8fStXxQR9ptNBlonx9ez4seVsruQea7mLfWlfFPH7rus+XJepIsSrTTh4v6GiYq1xkcCHSwEK6cEHGm09Leu2MQRCiRQ8U7zGCQjcdS9Xsj0/XDmsVyPW2Kk9EblA4atSsaaxnAiyxX/SZEnbn3L/cPI0AqMGWumQBN+kDQYr9Ez5H3aVhMIyKE0JCD/8NfLpSvSVP/XnzvFdFdpORN7xW7z4iiR683ef+wu4CsNyVYpDIe6rpupAFcsv8uXOuzXyfI67HfvIWNYMD8iZD/whCQ3AEh2u7TCIUoI6L4gw==";
	        this.oG = "XOwh26ByinkEBUnj6JYyAyG6Pogtg8f5ZIeHJwEuLX3zRu/HhwD8pXT4p3rMXhURL06HWGS+mRJED6xdIPObueNhlPDsnAA+Jp+xVBwlDfqEeQ3gQZhbTJK7Tsc6uDVhE3JlkB6+PUEDdTBq1zaWJgpGWPkJFmAFM0lcAyeEY4L75+M4wgYVmOOXesWfVFlWlJgx9j6RqhvlgwrOmo6UwNLU/sqsxK7dQw1vKslg3qYko6saw9snTERvFoCfy4/JBdLtWPYkEgFu7OAbWUjTXfPQvuSNCBMYxfHJEU5/sGlqPhlFPbIdM6IogZbtGxoHMi7DPPl7XxhGDeJVu47VZqggct/pXoq6m30yK8BA3lp3fsDpFOzWyzZvhbqkqNVE2KIxFXL4aG+TWVRqjDfhMvYv5662n0HfQyvVhI3ViyE6eNSXUmo0cSDdCH+s5fcq20G2vKS0QLAXUUVO966s+2VxCN+4/M1N0ZgkbnaSHQ92M9gPbQZqstX7VCXXUuT9cWYmNnogsrJoXtp+C3eaTsyr+A7Psjc6hJzoHLwW9W0Qd69RiHH4WwOi/H4H77pMJOI1ux46B9QGKMJglscX9j0dam1+Lw==";
	        this.pf = "Xj/4NHvML4pcsq3MvkaM3AhqEAHI30bVi+sjPrV7rQ==";
	        this.nF = "74jKbQgCCCSweCxY5xm3RfzymxqRs40kgKxSqA==";
	        this.po = "aejT9R7nMP19KhITxmBxBaOBaJgGqR6+y4ZzYDYmBTjUY7nw7TGGm7Hp438XllTR";
	        this.oz = "A8qo8fCMEFHG785164bZu5KlOzaZbE/92zINLNcQ+c2z+PBCNSRT/nkAObS7v9HLu3KzZR0=";
	        this.nB = "v8yhMDISy8CQJF073b9a6xB2lMix";
	        this.oO = "4IIhiEFPgpBJmPziEDdMl+hEws/AK+6ACB9P";
	        this.nS = "1JY2qJxMa43yQJRXJ5DsaZWEsCMesyT34OV3khaxQVbiWxZjZ3g=";
	    };
	    WR360.ImageRotator.bE(WR360.dh);
	    WR360.ImageRotator.km = 4;
	    var oH = false;
	    WR360.ImageRotator.Create = function(cR) {
	        if (!oH) {
	            var nf = lH.get(0);
	            if (cR != null && cR.length > 0) {
	                nf.cR = "#" + cR;
	                nf.oY = cR;
	            }
	            oH = true;
	            return nf;
	        }
	        return new WR360.ImageRotator(cR);
	    };
	    WR360.ImageRotator.kR = function() {
	        if (fp.length > 0) {
	            return fp;
	        }
	        fp = kP + ko + kZ;
	        return fp;
	    };
	    WR360.ImageRotator.prototype.bm = function() {
	        if (!jR || this.bM == true) {
	            return;
	        }
	        var ns = WR360.ImageRotator.kR();
	        var bQ = ac.fk.bL(ns);
	        this.gu = ac.G.aD(this.gu, bQ);
	        this.oD = ac.G.aD(this.oD, bQ);
	        this.hV = ac.G.aD(this.hV, bQ);
	        this.pD = ac.G.aD(this.pD, bQ);
	        this.qN = ac.G.aD(this.qN, bQ);
	        this.gF = ac.G.aD(this.gF, bQ);
	        this.ju = ac.G.aD(this.ju, bQ);
	        this.bc = ac.G.aD(this.bc, bQ);
	        this.ap = ac.G.aD(this.ap, bQ);
	        this.aY = ac.G.aD(this.aY, bQ);
	        this.bj = ac.G.aD(this.bj, bQ);
	        this.aQ = ac.G.aD(this.aQ, bQ);
	        this.hq = ac.G.aD(this.hq, bQ);
	        this.cl = ac.G.aD(this.cl, bQ);
	        this.cB = ac.G.aD(this.cB, bQ);
	        this.ay = ac.G.aD(this.ay, bQ);
	        this.eN = ac.G.aD(this.eN, bQ);
	        this.eQ = ac.G.aD(this.eQ, bQ);
	        this.ft = ac.G.aD(this.ft, bQ);
	        this.iO = ac.G.aD(this.iO, bQ);
	        this.gZ = ac.G.aD(this.gZ, bQ);
	        this.gq = ac.G.aD(this.gq, bQ);
	        this.pr = ac.G.aD(this.pr, bQ);
	        this.oG = ac.G.aD(this.oG, bQ);
	        this.pf = ac.G.aD(this.pf, bQ);
	        this.nF = ac.G.aD(this.nF, bQ);
	        this.po = ac.G.aD(this.po, bQ);
	        this.oz = ac.G.aD(this.oz, bQ);
	        this.nB = ac.G.aD(this.nB, bQ);
	        this.oO = ac.G.aD(this.oO, bQ);
	        this.nS = ac.G.aD(this.nS, bQ);
	        this.bM = true;
	    };
	    WR360.ImageRotator.prototype.rh = function() {
	        ra();
	    };
	    WR360.ImageRotator.nn = function(align, defaultValue) {
	        if (align == null) {
	            return defaultValue;
	        }
	        if (align.toLocaleLowerCase() == "left") {
	            return -1;
	        }
	        if (align.toLocaleLowerCase() == "right") {
	            return 1;
	        }
	        return defaultValue;
	    };
	    WR360.ImageRotator.prototype.reload = function(configFileURL, rootPath, hZ, reloadImageIndex) {
	        if (typeof this.pj !== "undefined") {
	            this.pj();
	        }
	        this.kI(false);
	        this.ri = true;
	        if (configFileURL && configFileURL.length > 0) {
	            this.settings.configFileURL = configFileURL;
	        }
	        this.settings.rootPath = rootPath;
	        this.hB = false;
	        this.co();
	        this.cJ();
	        this.ff();
	        this.hD();
	        this.mU();
	        this.loaded = false;
	        this.eP = 0;
	        this.jP = 0;
	        this.jo = true;
	        this.db = true;
	        this.nV = null;
	        this.fN = this.settings.configFileURL;
	        this.gf = this.settings.rootPath;
	        this.fX = 0;
	        this.bA = new WR360.gl;
	        this.bV = new WR360.bN;
	        this.reloadCallback = null;
	        this.dV = true;
	        this.reloadImageIndex = typeof reloadImageIndex !== "undefined" ? reloadImageIndex : -1;
	        if (typeof hZ !== "undefined" && hZ != null) {
	            this.reloadCallback = hZ;
	        }
	        this.gN(null);
	    };
	    WR360.ImageRotator.prototype.ih = function(db) {
	        if (db == null) {
	            throw new Error("ImageRotator.SetHotspotsOnProperty: hotspotsOn == null");
	        }
	        this.db = db;
	        if (this.bY) {
	            this.bY.fi(!this.db);
	        }
	    };
	    WR360.ImageRotator.prototype.lz = function() {
	        if (this.bA.ly()) {
	            this.dispatchEvent(new WR360.Event(WR360.Events.gY, false, false));
	        }
	    };
	    WR360.ImageRotator.prototype.iV = function() {
	        if (this.bA.ly()) {
	            this.dispatchEvent(new WR360.Event(WR360.Events.gM, false, false));
	        }
	    };
	    WR360.ImageRotator.prototype.runImageRotator = function(cR) {
	        if (this.cR == null || this.cR.length == 0) {
	            if (cR == null || cR.length == 0) {
	                throw new Error("Player ID parameter is empty.");
	            }
	            this.cR = "#" + cR;
	            this.oY = cR;
	        }
	        if (this.settings.fullScreenOnClick == true && this.pH === undefined) {
	            this.bm();
	            var bn = this;
	            jQuery(this.cR).click(function() {
	                bn.rg();
	            });
	            return;
	        }
	        this.gU = "#" + this.aR("wr360LeftButton", "wr360LeftButton");
	        this.hd = "#" + this.aR("wr360RightButton", "wr360RightButton");
	        this.jA = "#" + this.aR("wr360ZoomButton", "wr360ZoomButton");
	        this.jD = "#" + this.aR("wr360PlayButton", "wr360PlayButton");
	        this.kp = "#" + this.aR("wr360HotspotsButton", "wr360HotspotsButton");
	        this.pQ = "#" + this.aR("wr360FullScreenButton", "wr360FullScreenButton");
	        this.ja = "#" + this.aR("wr360ThemePanel_", "wr360ThemePanel_");
	        this.ie = "#" + this.aR("wr360ToolBar", "wr360ToolBar");
	        this.nQ = "#" + this.aR("wr360ThemePanelBack", "wr360ThemePanelBack");
	        this.kW = "#" + this.aR("wr360ProgressBar", "wr360ProgressBar");
	        this.fj = "#" + this.aR("wr360ProgressNum", "wr360ProgressNum");
	        jQuery(this.cR).removeClass("wr360_player").addClass("wr360_player");
	        this.fm = this.settings.viewWidthJQFix ? this.settings.viewWidthJQFix : jQuery(this.cR).innerWidth();
	        this.fJ = this.settings.viewHeightJQFix ? this.settings.viewHeightJQFix : jQuery(this.cR).innerHeight();
	        this.viewerBackgroundColor = jQuery(this.cR).css("backgroundColor");
	        if (WR360.by.iR) {
	            this.cF.gD = false;
	        }
	        if (this.settings.responsiveBaseHeight == 0) {
	            this.settings.responsiveBaseHeight = this.fJ;
	        }
	        this.gf = this.settings.rootPath;
	        this.fN = this.settings.configFileURL;
	        this.gN(null);
	        this.or = true;
	    };
	    WR360.ImageRotator.prototype.gN = function(hQ) {
	        if (!hQ || hQ.success == false) {
	            this.bS = true;
	            this.jy();
	        }
	    };
	    WR360.ImageRotator.prototype.aR = function(stringToChange, oA) {
	        return stringToChange.replace(oA, oA + "_" + this.oY);
	    };
	    WR360.ImageRotator.prototype.oQ = function() {
	        if (this.qX) {
	            return;
	        }
	        this.ap = this.aR(this.ap, this.cl.replace("#", ""));
	        this.aY = this.aR(this.aY, this.cB.replace("#", ""));
	        this.bj = this.aR(this.bj, this.eN.replace("#", ""));
	        this.aQ = this.aR(this.aQ, this.eQ.replace("#", ""));
	        this.hq = this.aR(this.hq, "wr360container");
	        this.hq = this.aR(this.hq, "wr360image");
	        this.hq = this.aR(this.hq, "wr360image2");
	        this.hq = this.aR(this.hq, "wr360toolheader");
	        this.hq = this.aR(this.hq, "wr360placer");
	        this.hq = this.aR(this.hq, "wr360LeftButton");
	        this.hq = this.aR(this.hq, "wr360RightButton");
	        this.hq = this.aR(this.hq, "wr360ZoomButton");
	        this.hq = this.aR(this.hq, "wr360PlayButton");
	        this.hq = this.aR(this.hq, "wr360HotspotsButton");
	        this.hq = this.aR(this.hq, "wr360FullScreenButton");
	        this.hq = this.aR(this.hq, "wr360ThemePanel_");
	        this.hq = this.aR(this.hq, "wr360ToolBar");
	        this.hq = this.aR(this.hq, "wr360ThemePanelBack");
	        this.hq = this.aR(this.hq, "wr360ProgressBar");
	        this.hq = this.aR(this.hq, "wr360ProgressNum");
	        this.cl = this.aR(this.cl, "wr360menu");
	        this.cB = this.aR(this.cB, this.cB.replace("#", ""));
	        this.eN = this.aR(this.eN, this.eN.replace("#", ""));
	        this.eQ = this.aR(this.eQ, this.eQ.replace("#", ""));
	        this.ft = this.aR(this.ft, "wr360placer");
	        this.iO = this.aR(this.iO, "wr360toolheader");
	        this.pf = this.aR(this.pf, "wr360container");
	        this.qX = true;
	    };
	    WR360.ImageRotator.prototype.jy = function() {
	        if (this.bS == false || hT == false || this.hB == true) {
	            return;
	        }
	        this.hB = true;
	        this.bm();
	        this.oQ();
	        this.lk();
	        this.pS();
	        this.kO();
	    };
	    WR360.ImageRotator.mv = function() {
	        return this.gq;
	    };
	    WR360.ImageRotator.oJ = function() {
	        return "id,class";
	    };
	    WR360.ImageRotator.ov = function() {
	        return ac;
	    };
	    WR360.ImageRotator.oZ = function() {
	        return WR360.ImageRotator.kR();
	    };
	    WR360.ImageRotator.prototype.hj = function() {
	        return this.rootPath;
	    };
	    WR360.ImageRotator.prototype.lk = function() {
	        if (this.dV == false) {
	            jQuery(this.cR).append(this.hq);
	        }
	        jQuery(this.pf).css("width", this.settings.viewWidthJQFix ? this.settings.viewWidthJQFix : jQuery(this.cR).innerWidth());
	        jQuery(this.pf).css("height", this.settings.viewHeightJQFix ? this.settings.viewHeightJQFix : jQuery(this.cR).innerHeight());
	        if (this.qr) {
	            this.qr();
	        }
	        if (this.qU) {
	            this.qU();
	        }
	        this.toolbar.cD();
	        this.bd = jQuery("#wr360image_" + this.oY);
	        this.jp = jQuery("#wr360image2_" + this.oY);
	        this.bd.hide();
	        this.jp.hide();
	        if (!this.eG()) {
	            this.jp = null;
	        }
	        this.bV.iF(this, this.bd, this.jp);
	        jQuery(this.ja).hide();
	        WR360.bZ.od(this.gu + " ~ " + this.settings.version);
	    };
	    WR360.ImageRotator.prototype.eG = function() {
	        return (jQuery.browser.mozilla || jQuery.browser.opera) && this.settings.zIndexLayersOn == true;
	    };
	    jQuery.ajaxSetup({
	        error: function(XMLHttpRequest, fr, ec) {
	            WR360.bZ.gA(fr);
	            WR360.bZ.gA(ec);
	            WR360.bZ.gA(XMLHttpRequest.responseText);
	        }
	    });
	    WR360.ImageRotator.prototype.im = function() {
	        this.aL();
	        var aW = this.fN.length != 0;
	        if (aW) {
	            if (!this.mY()) {
	                WR360.bZ.gA("Could not parse XML config path.");
	                return;
	            }
	        }
	        this.fs = 0;
	        this.dn = false;
	        if (this.dN) {
	            this.dN.as(false);
	        }
	        this.qY = true;
	        this.R = false;
	        if (!this.av && this.pL) {
	            if (this.fT == true && this != lH.get(0)) {
	                return;
	            }
	        }
	        if (this.av && this.fT && this.pL) {
	            return;
	        }
	        if (this.qS()) {
	            return;
	        }
	        if (aW) {
	            this.ki();
	        } else {
	            this.dq();
	        }
	    };
	    WR360.ImageRotator.prototype.kO = function() {
	        var bu = this;
	        var options = {
	            type: "GET",
	            url: this.licenseFileURL,
	            dataType: "text",
	            success: function(gi) {
	                bu.nd(gi);
	            },
	            error: function(e) {
	                bu.lW(e);
	            }
	        };
	        if (!WR360.by.qT(options)) {
	            jQuery.ajax(options);
	        }
	    };
	    WR360.ImageRotator.prototype.md = function() {
	        this.ok = new Image;
	        this.ok.src = this.gZ;
	    };
	    WR360.ImageRotator.prototype.nd = function(gi) {
	        if (this.qS()) {
	            return;
	        }
	        this.jK(gi);
	        this.im();
	    };
	    WR360.ImageRotator.prototype.lW = function(e) {
	        if (this.qS()) {
	            return;
	        }
	        this.dQ();
	        this.im();
	    };
	    WR360.ImageRotator.prototype.ek = function() {
	        return this.fT == false;
	    };
	    WR360.ImageRotator.prototype.gz = function() {
	        return this.fQ == true;
	    };
	    WR360.ImageRotator.prototype.qS = function() {
	        if (this.pL) {
	            return false;
	        }
	        var lu = this.jh(document.location.hostname);
	        var qt = this.jh(this.hV);
	        var pP = this.jh(this.pD);
	        var qV = this.jh(this.qN);
	        if (lu.indexOf(qt) == -1 && lu.indexOf(pP) == -1 && lu.indexOf(qV) == -1) {
	            return true;
	        }
	        return false;
	    };
	    WR360.ImageRotator.prototype.jh = function(eA) {
	        var gr = 0;
	        if (eA.substr(0, 10) == "http://www") {
	            gr = 11;
	        } else if (eA.substr(0, 7) == "http://") {
	            gr = 7;
	        } else if (eA.substr(0, 4) == "www.") {
	            gr = 4;
	        }
	        var gG = eA.indexOf("/", gr);
	        if (gG == -1) {
	            gG = eA.length;
	        }
	        var pa = eA.substring(gr, gG);
	        return pa;
	    };
	    WR360.ImageRotator.prototype.az = function() {
	        if (location.href.indexOf("http://") == -1 || location.href.indexOf("localhost") != -1 || location.href.indexOf("127.0.0") != -1) {
	            return true;
	        }
	        var lu = this.jh(document.location.hostname);
	        var kH = this.jh(this.cZ);
	        if (lu != kH) {
	            if (this.cZ.indexOf(".") == -1) {
	                if (this.cZ.length >= 4 && lu.indexOf(this.cZ) != -1) {
	                    return true;
	                }
	            }
	            return false;
	        } else {
	            return true;
	        }
	    };
	    WR360.ImageRotator.prototype.dQ = function() {
	        this.fQ = false;
	        this.fT = true;
	    };
	    WR360.ImageRotator.prototype.jK = function(gW) {
	        if (gW == null || gW.length == 0) {
	            this.dQ();
	            return;
	        }
	        var mW = WR360.ImageRotator.kR();
	        try {
	            var hy = getBrowserId(gW, mW);
	        } catch (kV) {
	            this.dQ();
	            return;
	        }
	        if (hy == null || hy.length == 0) {
	            this.dQ();
	            return;
	        }
	        var fW = hy.split("^^");
	        if (fW.length < 3) {
	            this.dQ();
	            return;
	        }
	        this.cr = fW[0];
	        if (this.cr.length == 0) {
	            this.dQ();
	            return;
	        }
	        this.cZ = fW[2];
	        if (this.cZ.length == 0) {
	            this.dQ();
	            return;
	        }
	        var hF = fW[1];
	        if (hF.length != 12) {
	            this.dQ();
	            return;
	        }
	        try {
	            var an = this.cr + this.cZ;
	            var aa = 0;
	            for (var i = 0; i < an.length; i++) {
	                aa += an.charCodeAt(i);
	            }
	            var bD = hF.substr(0, 4);
	            var ae = parseInt(bD, 16);
	            if (aa != ae) {
	                this.dQ();
	                return;
	            }
	            var kS = hF.substr(6, 1);
	            var kJ = Number(kS);
	            this.fQ = kJ == 1;
	        } catch (kV) {
	            this.dQ();
	            return;
	        }
	        if (this.gz() && this.az() == false) {
	            this.dQ();
	            return;
	        }
	        this.fT = false;
	    };
	    WR360.ImageRotator.prototype.mz = function() {
	        jQuery(this.iO).show();
	    };
	    WR360.ImageRotator.prototype.hD = function() {
	        if (this.oa != 0) {
	            clearInterval(this.oa);
	            this.oa = 0;
	        }
	        if (this.pp != 0) {
	            clearInterval(this.pp);
	            this.pp = 0;
	        }
	    };
	    WR360.ImageRotator.prototype.oT = function() {
	        if (jQuery(this.pf).find(this.iO).length == 0) {
	            jQuery(this.pf).append(this.po.format(this.nF, this.iO.replace("#", "")));
	        }
	        var p = jQuery(this.iO);
	        p.attr(this.nB, this.pr);
	        p.show();
	        if (jQuery(this.iO).find(this.ft).length == 0) {
	            p.append(this.oz.format(this.ft.replace("#", ""), this.hV, this.gu));
	        }
	        var y = jQuery(this.ft);
	        y.attr(this.nB, this.oG);
	        var z = y.html();
	        if (z != this.oD) {
	            y.html(this.oD);
	        }
	        y.show();
	    };
	    WR360.ImageRotator.prototype.nI = function() {
	        if (!jQuery(this.cl).is(":visible")) {
	            jQuery(this.cl).remove();
	            this.aL();
	            jQuery(this.cl).unbind(this.oO);
	            jQuery(this.pf).unbind(this.oO);
	            jQuery(this.pf).bind(this.oO, function(event) {
	                ow(event);
	            });
	            jQuery(this.cl).bind(this.oO, function(event) {
	                ow(event);
	            });
	            var bn = this;
	            jQuery(this.cl).unbind("mousemove");
	            jQuery(this.cl).unbind("mouseout");
	            jQuery(this.cl).bind("mousemove", function(event) {
	                bn.gT = true;
	            });
	            jQuery(this.cl).bind("mouseout", function(event) {
	                bn.gT = false;
	            });
	        }
	    };
	    WR360.ImageRotator.prototype.mY = function() {
	        var configFileURL = this.fN;
	        if (null != configFileURL && configFileURL.length > 0) {
	            var el = configFileURL.lastIndexOf("/");
	            if (-1 == el) {
	                el = configFileURL.lastIndexOf("\\");
	            }
	            if (-1 != el) {
	                var path = this.gf;
	                if (null != path && path.length > 0 && this.ek() == true) {
	                    this.rootPath = path;
	                } else {
	                    this.rootPath = configFileURL.substr(0, el + 1);
	                }
	                this.nL = configFileURL.substr(el + 1);
	                this.jF = configFileURL;
	                return true;
	            }
	        }
	        this.jF = this.rootPath + this.nL;
	        return true;
	    };
	    WR360.ImageRotator.prototype.ki = function() {
	        var bu = this;
	        var options = {
	            type: "GET",
	            url: this.jF,
	            dataType: "xml",
	            success: function(di) {
	                bu.mO(di);
	            },
	            error: function(jk, fr, ec) {
	                bu.mH(jk, fr, ec);
	            }
	        };
	        if (!WR360.by.qT(options)) {
	            jQuery.ajax(options);
	        }
	    };
	    WR360.ImageRotator.prototype.dq = function() {
	        this.cq = new WR360.lE(this.bA, this);
	        this.eP = this.bA.settings.bg.fE;
	        if (this.bA.aw.length > 0 && this.bA.aw[0].cS != null) {
	            this.bV.lc = true;
	        }
	        if (this.av == true) {
	            jQuery(this.cR).css({
	                'background-color': this.bA.settings.bI.fullScreenBackColor
	            });
	        } else {
	            jQuery(this.pf).css({
	                'background-color': this.viewerBackgroundColor
	            });
	        }
	        this.eE = new WR360.cL(this);
	        this.eE.addEventListener(WR360.cO.COMPLETE, jQuery.proxy(this.lZ, this));
	        this.eE.addEventListener(WR360.cO.ERROR, jQuery.proxy(this.lK, this));
	        this.eE.Load(this.hj(), this.bA);
	        this.bB = new WR360.dc;
	        if (this.ek() == false) {
	            this.bB.hu = WR360.ImageRotator.km;
	        }
	        this.bB.addEventListener(WR360.dK.PROGRESS, jQuery.proxy(this.nN, this));
	        this.bB.addEventListener(WR360.dK.ERROR, jQuery.proxy(this.pq, this));
	        this.bB.addEventListener(WR360.dK.COMPLETE, jQuery.proxy(this.nZ, this));
	        this.bB.Init(this.hj(), this.bA);
	        this.bU = new WR360.dP(this.cR);
	        this.bU.addEventListener(WR360.cf.PROGRESS, jQuery.proxy(this.mP, this));
	        this.bU.addEventListener(WR360.cf.COMPLETE, jQuery.proxy(this.lP, this));
	        this.bU.addEventListener(WR360.cf.ERROR, jQuery.proxy(this.ml, this));
	        this.bU.Init(this.hj(), this.settings.graphicsPath, this.bA, this.av && this.bA.settings.control.qc && this.bV.lc);
	        this.fX += this.bU.aw.length;
	        this.fX += this.bB.bF.length;
	        this.bB.kD();
	        this.bU.kE();
	    };
	    WR360.ImageRotator.prototype.mO = function(di) {
	        var bn = this;
	        var V = this.bA;
	        if (jQuery.browser.msie && WR360.by.pA()) {
	            di = jQuery.parseXML(di);
	        }
	        var ip = jQuery(di).find("settings");
	        if (ip && ip.length == 0) {
	            WR360.bZ.gA("ERROR: Cannot read config section 'settings'.");
	            return;
	        }
	        jQuery(di).find("preloader").each(function() {
	            V.settings.eH.image = jQuery(this).attr("image");
	        });
	        jQuery(di).find("userInterface").each(function() {
	            V.settings.bI.hb = WR360.by.bX(jQuery(this).attr("showArrows"), V.settings.bI.hb);
	            V.settings.bI.gj = WR360.by.bX(jQuery(this).attr("showTogglePlayButton"), V.settings.bI.gj);
	            V.settings.bI.gw = WR360.by.bX(jQuery(this).attr("showZoomButtons"), V.settings.bI.gw);
	            V.settings.bI.iT = WR360.by.bX(jQuery(this).attr("showFullScreenButton"), V.settings.bI.iT);
	            V.settings.bI.hY = WR360.by.bX(jQuery(this).attr("showScrollbar"), V.settings.bI.hY);
	            V.settings.bI.bY = WR360.by.bX(jQuery(this).attr("showHotspotsButton"), V.settings.bI.bY);
	            V.settings.bI.iU = WR360.by.bX(jQuery(this).attr("showToolTips"), V.settings.bI.iU);
	            V.settings.bI.bz = WR360.by.bX(jQuery(this).attr("showProgressNumbers"), V.settings.bI.bz);
	            V.settings.bI.gx = WR360.ImageRotator.nn(jQuery(this).attr("toolbarAlign"), V.settings.bI.gx);
	            V.settings.bI.kK = WR360.by.cz(jQuery(this).attr("toolbarForeColor"), V.settings.bI.kK);
	            V.settings.bI.lh = WR360.by.cz(jQuery(this).attr("toolbarHoverColor"), V.settings.bI.lh);
	            V.settings.bI.gH = WR360.by.cz(jQuery(this).attr("toolbarBackColor"), V.settings.bI.gH);
	            V.settings.bI.iC = WR360.by.je(jQuery(this).attr("toolbarAlpha"), V.settings.bI.iC);
	            V.settings.bI.gX = WR360.by.je(jQuery(this).attr("toolbarBackAlpha"), V.settings.bI.gX);
	            V.settings.bI.gC = WR360.by.cz(jQuery(this).attr("progressNumColor"), V.settings.bI.gC);
	            V.settings.bI.hW = WR360.by.cz(jQuery(this).attr("progressLoopColor"), V.settings.bI.hW);
	            V.settings.bI.fullScreenBackColor = WR360.by.cz(jQuery(this).attr("fullScreenBackColor"), V.settings.bI.fullScreenBackColor);
	            V.settings.bI.showFullScreenToolbar = WR360.by.bX(jQuery(this).attr("showFullScreenToolbar"), V.settings.bI.showFullScreenToolbar);
	        });
	        jQuery(di).find("control").each(function() {
	            V.settings.control.gp = WR360.by.je(jQuery(this).attr("dragSpeed"), V.settings.control.gp);
	            V.settings.control.dJ = WR360.by.bX(jQuery(this).attr("disableMouseControl"), V.settings.control.dJ);
	            V.settings.control.inBrowserFullScreen = WR360.by.bX(jQuery(this).attr("inBrowserFullScreen"), V.settings.control.inBrowserFullScreen);
	            V.settings.control.doubleClickFullscreen = WR360.by.bX(jQuery(this).attr("doubleClickFullscreen"), V.settings.control.doubleClickFullscreen);
	            V.settings.control.iu = WR360.by.bX(jQuery(this).attr("doubleClickZooms"), V.settings.control.iu);
	            V.settings.control.qc = WR360.by.bX(jQuery(this).attr("showHighresOnFullScreen"), V.settings.control.qc);
	            V.settings.control.mouseHoverDrag = WR360.by.bX(jQuery(this).attr("mouseHoverDrag"), V.settings.control.mouseHoverDrag);
	            V.settings.control.hideHotspotsOnLoad = WR360.by.bX(jQuery(this).attr("hideHotspotsOnLoad"), V.settings.control.hideHotspotsOnLoad);
	            V.settings.control.hideHotspotsOnZoom = WR360.by.bX(jQuery(this).attr("hideHotspotsOnZoom"), V.settings.control.hideHotspotsOnZoom);
	        });
	        jQuery(di).find("rotation").each(function() {
	            V.settings.bg.fE = WR360.by.cz(jQuery(this).attr("firstImage"), V.settings.bg.fE);
	            V.settings.bg.rotate = WR360.by.cz(jQuery(this).attr("rotate"), V.settings.bg.rotate);
	            V.settings.bg.kC = WR360.by.dM(jQuery(this).attr("rotateDirection"), V.settings.bg.kC);
	            V.settings.bg.oc = WR360.by.cz(jQuery(this).attr("forceDirection"), V.settings.bg.oc);
	            V.settings.bg.gg = WR360.by.dM(jQuery(this).attr("rotatePeriod"), V.settings.bg.gg);
	            V.settings.bg.bounce = WR360.by.bX(jQuery(this).attr("bounce"), V.settings.bg.bounce);
	            V.settings.bg.op = WR360.by.dM(jQuery(this).attr("stopPlaybackOn"), V.settings.bg.op);
	            V.settings.bg.pe = WR360.by.bX(jQuery(this).attr("playbackForceRestart"), V.settings.bg.pe);
	            V.settings.bg.useInertia = WR360.by.bX(jQuery(this).attr("useInertia"), V.settings.bg.useInertia);
	            V.settings.bg.inertiaRelToDragSpeed = WR360.by.bX(jQuery(this).attr("inertiaRelToDragSpeed"), V.settings.bg.inertiaRelToDragSpeed);
	            V.settings.bg.inertiaTimeToStop = WR360.by.dM(jQuery(this).attr("inertiaTimeToStop"), V.settings.bg.inertiaTimeToStop);
	            V.settings.bg.inertiaMaxInterval = WR360.by.dM(jQuery(this).attr("inertiaMaxInterval"), V.settings.bg.inertiaMaxInterval);
	        });
	        var hH = jQuery(di).find("hotspots");
	        if (hH && hH.length > 0) {
	            var kw = 0;
	            hH.each(function() {
	                jQuery(this).find("hotspot").each(function() {
	                    var bi = new WR360.kc;
	                    bi.id = jQuery(this).attr("id");
	                    bi.type = jQuery(this).attr("type");
	                    bi.dI = WR360.by.bX(jQuery(this).attr("absolutePosition"), bi.dI);
	                    bi.ps = WR360.by.dM(jQuery(this).attr("renderMode"), bi.ps);
	                    bi.className = jQuery(this).attr("className");
	                    bi.color = WR360.by.cz(jQuery(this).attr("color"), bi.color);
	                    bi.alpha = WR360.by.je(jQuery(this).attr("alpha"), bi.alpha);
	                    bi.jN = WR360.by.cz(jQuery(this).attr("indicatorImage"), bi.jN);
	                    bi.disabled = WR360.by.bX(jQuery(this).attr("disabled"), bi.disabled);
	                    bi.activateOnClick = WR360.by.bX(jQuery(this).attr("activateOnClick"), bi.activateOnClick);
	                    bi.offset.parse(jQuery(this).attr("offsetX"), jQuery(this).attr("offsetY"));
	                    bi.margin.parse(jQuery(this).attr("margin"));
	                    bi.align.parse(jQuery(this).attr("align"));
	                    jQuery(this).find("spotinfo").each(function() {
	                        bi.bo = new WR360.HotspotInfo;
	                        bi.bo.src = WR360.by.cz(jQuery(this).attr("src"), bi.bo.src);
	                        bi.bo.url = WR360.by.cz(jQuery(this).attr("url"), bi.bo.url);
	                        bi.bo.eb = WR360.by.cz(jQuery(this).attr("urlTarget"), bi.bo.eb);
	                        bi.bo.aI = WR360.by.cz(jQuery(this).attr("txt"), bi.bo.aI);
	                        bi.bo.ga = WR360.by.dM(jQuery(this).attr("txtWidth"), bi.bo.ga);
	                        bi.bo.gb = WR360.by.cz(jQuery(this).attr("txtColor"), bi.bo.gb);
	                        bi.bo.gk = WR360.by.cz(jQuery(this).attr("txtBkColor"), bi.bo.gk);
	                        bi.bo.fO = WR360.by.dM(jQuery(this).attr("fntHeight"), bi.bo.fO);
	                        bi.bo.qG = WR360.by.dM(jQuery(this).attr("clickAction"), bi.bo.qG);
	                        bi.bo.qO = WR360.by.cz(jQuery(this).attr("clickData"), bi.bo.qO);
	                        bi.bo.clickDataParam = WR360.by.dM(jQuery(this).attr("clickDataParam"), bi.bo.clickDataParam);
	                        jQuery(this).find("cdata").each(function() {
	                            bi.bo.cdata = WR360.by.cz(jQuery(this).text(), bi.bo.cdata);
	                        });
	                    });
	                    if (bi.disabled == false) {
	                        V.bF[kw] = bi;
	                        V.hi[bi.id] = bi;
	                        kw++;
	                    }
	                });
	            });
	        } else {
	            return;
	        }
	        var fV = jQuery(di).find("images");
	        if (fV && fV.length > 0) {
	            var bW = 0;
	            fV.each(function() {
	                V.aw.ep = WR360.by.dM(jQuery(this).attr("highresWidth"), V.aw.ep);
	                V.aw.eU = WR360.by.dM(jQuery(this).attr("highresHeight"), V.aw.eU);
	                jQuery(this).find("image").each(function() {
	                    var dp = new WR360.lv;
	                    dp.src = jQuery(this).attr("src");
	                    dp.label = WR360.by.cz(jQuery(this).attr("label"), dp.label);
	                    var hO = 0;
	                    jQuery(this).find("hotspot").each(function() {
	                        var al = new WR360.lq;
	                        al.source = WR360.by.cz(jQuery(this).attr("source"), al.source);
	                        al.offsetX = WR360.by.dM(jQuery(this).attr("offsetX"), al.offsetX);
	                        al.offsetY = WR360.by.dM(jQuery(this).attr("offsetY"), al.offsetY);
	                        dp.bF[hO] = al;
	                        dp.hi[al.source] = al;
	                        hO++;
	                    });
	                    jQuery(this).find("highres").each(function() {
	                        dp.cS = new WR360.kB;
	                        dp.cS.src = WR360.by.cz(jQuery(this).attr("src"), dp.cS.src);
	                    });
	                    V.aw[bW] = dp;
	                    V.ky[dp.src] = dp;
	                    bW++;
	                });
	            });
	        } else {
	            WR360.bZ.gA("ERROR: Cannot read config section 'images'.");
	            return;
	        }
	        this.dq();
	    };
	    WR360.ImageRotator.prototype.mP = function(e) {
	        this.dS();
	    };
	    WR360.ImageRotator.prototype.nN = function(e) {
	        this.dS();
	    };
	    WR360.ImageRotator.prototype.lP = function(e) {
	        this.dS();
	        this.jb(e);
	    };
	    WR360.ImageRotator.prototype.nZ = function(e) {
	        this.dS();
	        this.jb(e);
	    };
	    WR360.ImageRotator.prototype.ml = function(e) {
	        WR360.bZ.gA(e.errorMessage);
	    };
	    WR360.ImageRotator.prototype.pq = function(e) {
	        WR360.bZ.gA(e.errorMessage);
	    };
	    WR360.ImageRotator.prototype.dS = function() {
	        this.fs++;
	        var kt = Math.round(this.fs / this.fX * 100);
	        this.cq.il(kt);
	    };
	    WR360.ImageRotator.prototype.jb = function(e) {
	        if (this.qS()) {
	            return;
	        }
	        if (this.fs < this.fX) {
	            return;
	        }
	        this.jo = false;
	        try {
	            this.cq.il(99);
	            this.jV(this.bU.aw[this.eP].F);
	            this.bV.cD(this.bU, this.bB, this.bA, this.dG, this.dA, this.aU, jQuery(this.pf));
	            if (this.dV == true && this.reloadImageIndex >= 0) {
	                this.bV.dE(this.reloadImageIndex);
	            } else if (this.settings.fullScreenOnClick == true || typeof this.qz === "undefined" || !this.qz()) {
	                this.bV.dE(this.bA.settings.bg.fE);
	            }
	            this.cq.destroy();
	            this.lo();
	            var qL = this.jp ? this.jp : this.bd;
	            qL.fadeIn(600, jQuery.proxy(function() {
	                this.ke();
	            }, this));
	            if (this.settings.apiReadyCallback != null && this.dV != true) {
	                this.settings.apiReadyCallback(new WR360.API(this));
	            }
	            if (this.dV == true && this.reloadCallback != null) {
	                this.reloadCallback();
	                this.reloadCallback = null;
	            }
	            this.dV = false;
	        } catch (ex) {
	            WR360.bZ.gA("Exception: " + ex.message);
	        }
	    };
	    WR360.ImageRotator.prototype.fK = function(deltaX, deltaY) {
	        this.bV.en = true;
	        this.bV.dE(this.bV.aF, deltaX, deltaY);
	    };
	    WR360.ImageRotator.prototype.lZ = function(e) {
	        if (!this.jo) {
	            return;
	        }
	        var image = e.image;
	        if (image == null) {
	            return;
	        }
	        this.jV(this.eE.image);
	        this.bV.hs(image.src);
	        var qL = this.jp ? this.jp : this.bd;
	        qL.fadeIn(600);
	    };
	    WR360.ImageRotator.prototype.lK = function(e) {
	        WR360.bZ.gA(e.errorMessage);
	    };
	    WR360.ImageRotator.prototype.mH = function(jk, fr, ec) {
	        WR360.bZ.gA("Could not load configuration file '" + this.fN + "': " + fr + ", " + ec.toString());
	    };
	    WR360.ImageRotator.prototype.ci = function() {
	        if (location.href.indexOf("http://") == -1 || location.href.indexOf("localhost") != -1 || location.href.indexOf("127.0.0") != -1) {
	            return true;
	        }
	        return false;
	    };
	    WR360.ImageRotator.prototype.lo = function() {
	        this.dG = this.bU.aw[this.eP].F.width;
	        this.dA = this.bU.aw[this.eP].F.height;
	        this.loaded = true;
	        this.kY();
	        this.nx();
	        this.toolbar.mV(this.bA, this);
	        if (this.qa) {
	            this.qa();
	        }
	        this.nt();
	        this.pS();
	        if (this.ek() == false) {
	            if (location.href.indexOf("http://") != -1 && location.href.indexOf("localhost") == -1 && location.href.indexOf("127.0.0") == -1) {
	                var lM = this;
	                setTimeout(function() {
	                    lM.md();
	                }, 2000);
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.gK = function(bi) {
	        var ax = bi.id;
	        if (ax != null) {
	            ax = ax.replace(/ /g, "_");
	        }
	        if (bi.dI == true) {
	            return "wr360StaticSpot_" + ax + "_" + this.oY;
	        } else {
	            return "wr360DynamicSpot_" + ax + "_" + this.oY;
	        }
	    };
	    WR360.ImageRotator.prototype.mU = function() {
	        jQuery(".wr360hotspot_" + this.oY).remove();
	        jQuery(".wr360rollover_" + this.oY).remove();
	    };
	    WR360.ImageRotator.prototype.nt = function() {
	        var bn = this;
	        if (bn.dV == false) {
	            jQuery(this.pf).bind("selectstart", function(event) {
	                bn.na(event);
	            });
	            jQuery(this.pf).bind("mousemove", function(event) {
	                bn.onMouseMove(event);
	            });
	            jQuery(this.pf).bind("mousedown", function(event) {
	                bn.onMouseDown(event);
	            });
	            jQuery(this.pf).bind("mouseup", function(event) {
	                bn.onMouseUp(event);
	            });
	            jQuery(this.pf).bind("mouseleave", function(event) {
	                bn.onMouseLeave(event);
	            });
	            this.bd.bind("dblclick", function(event) {
	                bn.lJ(event, this);
	            });
	            if (this.jp) {
	                this.jp.bind("dblclick", function(event) {
	                    bn.lJ(event, this);
	                });
	            }
	            jQuery(this.pf).bind(this.oO, function(event) {
	                ow(event);
	            });
	            jQuery(this.cl).bind(this.oO, function(event) {
	                ow(event);
	            });
	            jQuery(this.pf).bind("touchstart", function(event) {
	                bn.mk(event);
	            });
	            jQuery(this.pf).bind("touchmove", function(event) {
	                bn.nm(event);
	            });
	            jQuery(this.pf).bind("touchend", function(event) {
	                bn.mL(event);
	            });
	            jQuery(this.pf).bind("touchcancel", function() {
	                bn.ma(event);
	            });
	            jQuery(this.bc).bind("mousedown", function(event) {
	                bn.ph();
	            });
	            jQuery(this.cl).bind("mouseover", function(event) {
	                bn.gT = true;
	            });
	            jQuery(this.cl).bind("mouseout", function(event) {
	                bn.gT = false;
	            });
	        }
	        if (bn.ek() == false) {
	            if (bn.oa == 0) {
	                bn.oa = setInterval(function() {
	                    bn.oT();
	                }, 2000);
	            }
	        }
	        if (bn.pp == 0) {
	            bn.pp = setInterval(function() {
	                bn.nI();
	            }, 5000);
	        }
	    };
	    WR360.ImageRotator.prototype.nx = function() {
	        var bn = this;
	        if (bn.dV == false) {
	            jQuery(this.gU).bind({
	                mousedown: function() {
	                    bn.np();
	                },
	                mouseup: function() {
	                    bn.nr();
	                },
	                mouseout: function() {
	                    bn.lY();
	                }
	            });
	            jQuery(this.hd).bind({
	                mousedown: function() {
	                    bn.nv();
	                },
	                mouseup: function() {
	                    bn.mT();
	                },
	                mouseout: function() {
	                    bn.mK();
	                }
	            });
	            jQuery(this.jA).bind({
	                mousedown: function(event) {
	                    bn.mt(event);
	                }
	            });
	            this.dN = new WR360.ej(this.jA.replace("#", ""), "zoomin_button", "zoomout_button");
	            jQuery(this.kp).bind({
	                click: function(event) {
	                    bn.mf(event);
	                }
	            });
	            jQuery(this.pQ).bind({
	                click: function(event) {
	                    if (bn.rc) {
	                        bn.rc(event);
	                    }
	                }
	            });
	            this.bY = new WR360.cP(this.kp.replace("#", ""), "hotspotson_button", "hotspotsoff_button");
	            this.qZ = new WR360.cP(this.pQ.replace("#", ""), "fullscreenon_button", "fullscreenoff_button");
	            this.eg = new WR360.fb(this.jD.replace("#", ""), "click", this, "play_button", bn.mR, "pause_button", bn.mp, 500);
	            this.eg.cD();
	            jQuery(this.ja).mousedown(function(event) {
	                bn.nj(event);
	            });
	            jQuery(this.ja).mousemove(function(event) {
	                bn.nD(event);
	            });
	            jQuery(this.ja).mouseleave(function(event) {
	                bn.oj(event);
	            });
	        }
	        this.ih(!this.bA.settings.control.hideHotspotsOnLoad);
	    };
	    WR360.ImageRotator.prototype.pS = function() {
	        if (this.pW) {
	            if (this.pW()) {
	                if (this.bV) {
	                    this.bV.eh(this.bV.aF, false);
	                }
	                return;
	            }
	        }
	        if (this.settings.viewWidthJQFix == 0 && this.settings.viewHeightJQFix == 0) {
	            this.kI(false);
	            this.fm = jQuery(this.cR).innerWidth();
	            if (this.settings.responsiveBaseWidth == 0) {
	                this.fJ = jQuery(this.cR).innerHeight();
	                jQuery(this.pf).css({
	                    width: this.fm,
	                    height: this.fJ
	                });
	                this.lB = 1;
	            } else {
	                var ratio = this.settings.responsiveBaseHeight / this.settings.responsiveBaseWidth;
	                this.fJ = this.fm * ratio;
	                jQuery(this.pf).css({
	                    width: this.fm,
	                    height: this.fJ
	                });
	                jQuery(this.cR).css({
	                    height: this.fJ
	                });
	                jQuery(this.cR).parent().css({
	                    height: this.fJ
	                });
	                this.lB = this.fm / this.settings.responsiveBaseWidth;
	            }
	        }
	        if (this.bV != null) {
	            this.gs();
	            if (this.bV.H != null) {
	                this.bV.eh(this.bV.aF, !this.av);
	                this.bV.lB = this.lB;
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.gs = function() {
	        var cW = this.settings.viewWidthJQFix ? this.settings.viewWidthJQFix : jQuery(this.pf).innerWidth();
	        var dk = this.settings.viewHeightJQFix ? this.settings.viewHeightJQFix : jQuery(this.pf).innerHeight();
	        var jU = dk / cW;
	        var ks = this.dA / this.dG;
	        var fB = 0,
	            cw = 0,
	            fa = 0,
	            fF = 0;
	        if (this.dG < cW && this.dA < dk) {
	            fB = this.dG;
	            cw = this.dA;
	            fa = (cW - this.dG) / 2;
	            fF = (dk - this.dA) / 2;
	        } else {
	            if (jU >= ks) {
	                fB = cW;
	                cw = cW / this.dG * this.dA;
	                fa = 0;
	                fF = (dk - cw) / 2;
	            } else {
	                cw = dk;
	                fB = dk / this.dA * this.dG;
	                fa = (cW - fB) / 2;
	                fF = 0;
	            }
	        }
	        if (this.settings.qs != -1) {
	            fa = this.settings.qs;
	        }
	        if (this.settings.rf != -1) {
	            fF = this.settings.rf;
	        }
	        if (this.settings.qJ != -1) {
	            fB = this.settings.qJ;
	            if (this.settings.imageViewportHeight == -1) {
	                cw = fB / this.dG * this.dA;
	            }
	        }
	        if (this.settings.imageViewportHeight != -1) {
	            cw = this.settings.imageViewportHeight;
	            if (this.settings.qJ == -1) {
	                fB = cw / this.dA * this.dG;
	            }
	        }
	        jQuery(this.pf).css("text-align", "left");
	        this.bd.css("margin-left", fa);
	        this.bd.css("margin-top", fF);
	        this.bd.css("width", fB);
	        this.bd.css("height", cw);
	        if (this.jp) {
	            this.jp.css("margin-left", fa);
	            this.jp.css("margin-top", fF);
	            this.jp.css("width", fB);
	            this.jp.css("height", cw);
	        }
	        this.aU['_viewPort.x'] = fa;
	        this.aU['_viewPort.y'] = fF;
	        this.aU['_viewPort.width'] = fB;
	        this.aU['_viewPort.height'] = cw;
	        if (this.bA.iq()) {
	            this.bV.dZ = this.bA.aw.ep / this.aU['_viewPort.width'];
	        }
	    };
	    var kP = "AQIDBAUGBwgJAA";
	    WR360.ImageRotator.prototype.aP = function() {
	        if (this.dV == false) {
	            jQuery(this.pf).append(this.ap);
	            jQuery(this.cl).append(this.aY);
	            jQuery(this.cB).append(this.bj);
	            if (this.nS.indexOf(this.cr) == -1) {
	                jQuery(this.cB).append(this.aQ);
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.aL = function() {
	        var eZ = "";
	        var gn = this.gu;
	        var bp = 6;
	        var fg = 0;
	        this.mz();
	        this.aP();
	        if (this.ek()) {
	            if (this.cr != null && this.cr.length > 0) {
	                if (!this.gz()) {
	                    eZ = this.ju + this.cr;
	                } else {
	                    eZ = this.cr + " &copy;";
	                }
	            }
	        } else {
	            gn = this.gF;
	        }
	        if (eZ.length != 0) {
	            fg = Math.max(eZ.length * bp, fg);
	            jQuery(this.cB).css("width", fg);
	            var ij = "";
	            if (this.cZ != null && this.cZ.length > 0) {
	                if (this.gz() && this.cZ.indexOf(".") == -1) {
	                    if (this.ci()) {
	                        jQuery(this.eN).html(eZ);
	                        jQuery(this.eQ).hide();
	                        return;
	                    }
	                    ij = document.location.hostname;
	                } else {
	                    ij = this.cZ;
	                }
	            }
	            jQuery(this.eN).html(this.bc.format(ij, eZ));
	        } else {
	            jQuery(this.eN).hide();
	        }
	        if (!this.gz()) {
	            fg = Math.max(gn.length * bp, fg);
	            jQuery(this.cB).css("width", fg);
	            jQuery(this.eQ).html(this.bc.format(this.hV, gn));
	        } else {
	            jQuery(this.eQ).hide();
	        }
	    };
	    WR360.ImageRotator.prototype.lw = function(iX, delay) {
	        if (jQuery.browser.webkit || jQuery.browser.mozilla || jQuery.browser.opera || jQuery.browser.msie && jQuery.browser.version == "99") {
	            jQuery(iX).fadeIn(delay);
	            return true;
	        } else {
	            jQuery(iX).show();
	            return false;
	        }
	    };
	    WR360.ImageRotator.prototype.jV = function(image) {
	        this.dG = image.width;
	        this.dA = image.height;
	        this.pS();
	    };
	    WR360.ImageRotator.prototype.ng = function() {
	        var fB = this.aU['_viewPort.width'];
	        if (fB > this.dG) {
	            return 1;
	        }
	        return this.dG / fB;
	    };
	    WR360.ImageRotator.prototype.mJ = function() {
	        if (this.bV.dZ == 0) {
	            return this.ng();
	        } else {
	            return this.bV.dZ;
	        }
	    };
	    WR360.ImageRotator.prototype.hE = function() {
	        return 1;
	    };
	    WR360.ImageRotator.prototype.kY = function() {
	        if (this.bA.aw.length > 0 && this.bA.settings.bg.gg > 0) {
	            this.eo = this.bA.settings.bg.gg / this.bA.aw.length * 1000;
	            this.O = this.eo;
	            if (this.bA.settings.control.gp > 0) {
	                this.O *= this.bA.settings.control.gp;
	            }
	            this.O *= this.hE();
	            this.eo *= this.hE();
	        }
	    };
	    WR360.ImageRotator.prototype.mR = function(e) {
	        this.gJ();
	    };
	    WR360.ImageRotator.prototype.mp = function(e) {
	        this.cJ();
	    };
	    WR360.ImageRotator.prototype.lY = function(e) {
	        if (this.pY == false) {
	            this.co();
	        }
	    };
	    WR360.ImageRotator.prototype.np = function(e) {
	        this.bV.eT();
	        this.cJ();
	        this.co();
	        this.hl = true;
	        var bu = this;
	        this.ak = setTimeout(function() {
	            bu.jz();
	        }, this.bw);
	    };
	    WR360.ImageRotator.prototype.mt = function(e) {
	        if (this.eG()) {
	            this.ri = true;
	            if (this.pY == true) {
	                this.cJ();
	                if (this.dn && this.bV.lc) {
	                    return;
	                }
	            }
	        }
	        this.jL(false, e);
	    };
	    WR360.ImageRotator.prototype.nr = function(e) {
	        this.co();
	    };
	    WR360.ImageRotator.prototype.mK = function(e) {
	        if (this.pY == false) {
	            this.co();
	        }
	    };
	    WR360.ImageRotator.prototype.nv = function(e) {
	        this.bV.fo();
	        this.cJ();
	        this.co();
	        this.hl = false;
	        var bu = this;
	        this.ak = setTimeout(function() {
	            bu.jz();
	        }, this.bw);
	    };
	    WR360.ImageRotator.prototype.mT = function(e) {
	        this.co();
	    };
	    WR360.ImageRotator.prototype.mf = function(e) {
	        if (this.R) {
	            return;
	        }
	        this.dispatchEvent(new WR360.Event(this.db ? WR360.Events.gY : WR360.Events.gM, false, false));
	    };
	    WR360.ImageRotator.prototype.nj = function(e) {
	        e.stopPropagation();
	        this.dispatchEvent(new WR360.Event(WR360.Events.hG, false, false));
	    };
	    WR360.ImageRotator.prototype.nD = function(e) {
	        this.kU = true;
	    };
	    WR360.ImageRotator.prototype.oj = function(e) {
	        this.kU = false;
	    };
	    WR360.ImageRotator.prototype.na = function(e) {
	        e.preventDefault();
	        e.stopPropagation();
	    };
	    WR360.ImageRotator.prototype.onMouseDown = function(e) {
	        if (e.button == mg()) {
	            this.pm(e);
	            if (this.bA.settings.control.dJ) {
	                return;
	            }
	            this.kx(e);
	        } else if (e.button == mD()) {
	            e.preventDefault();
	            this.nP(e);
	        }
	    };
	    WR360.ImageRotator.prototype.kx = function(e) {
	        this.fu = true;
	        this.ri = true;
	        this.cJ();
	        this.eu = true;
	        if (!e) {
	            e = window.event;
	        }
	        var cC = WR360.by.fS(e);
	        this.dO = cC.x;
	        this.ei = cC.y;
	        this.jW = this.bV.aG.css("margin-left").aK();
	        this.jt = this.bV.aG.css("margin-top").aK();
	    };
	    var kZ = "AgMEBQYHCAkAAQI=";
	    WR360.ImageRotator.prototype.onMouseUp = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        this.fu = false;
	        this.eu = false;
	        this.ff();
	    };
	    WR360.ImageRotator.prototype.onMouseLeave = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        jQuery(this.pf).css("cursor", "default");
	        this.fu = false;
	        this.eu = false;
	        this.ff();
	    };
	    WR360.ImageRotator.prototype.lJ = function(e, target) {
	        e.preventDefault();
	        if (this.bA.settings.control.doubleClickFullscreen) {
	            this.rc(e);
	            return;
	        }
	        if (this.av == true) {
	            return;
	        }
	        if (!this.bA.settings.control.iu) {
	            return;
	        }
	        this.jL(true, e, target);
	    };
	    WR360.ImageRotator.prototype.onMouseMove = function(e) {
	        if (this.qS()) {
	            return;
	        }
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        jQuery(this.pf).css("cursor", "pointer");
	        if (!e) {
	            e = window.event;
	        }
	        var cC = WR360.by.fS(e);
	        this.cp = cC.x;
	        this.ha = cC.y;
	        this.hg += Math.abs(this.cp - this.dO);
	        this.qe += Math.abs(this.ha - this.ei);
	        if (this.eu == false && this.bA.settings.control.mouseHoverDrag == false) {
	            this.dO = this.cp;
	            this.ei = this.ha;
	            return;
	        }
	        if (this.eu == false && this.bA.settings.control.mouseHoverDrag == true) {
	            if (this.pY == true || this.dn == true || this.kU == true) {
	                this.dO = this.cp;
	                this.ei = this.ha;
	                return;
	            }
	        }
	        if (this.qY || this.av && !this.settings.fullScreenOnClick) {
	            this.kF();
	        } else {
	            this.ff();
	            this.nq(e);
	        }
	    };
	    WR360.ImageRotator.prototype.nq = function(e) {
	        var et = this.jW + (this.cp - this.dO);
	        var gO = this.jt + (this.ha - this.ei);
	        if (et < this.eL.eY) {
	            et = this.eL.eY;
	        } else if (et > this.eL.fd) {
	            et = this.eL.fd;
	        }
	        if (gO < this.eL.ev) {
	            gO = this.eL.ev;
	        } else if (gO > this.eL.fM) {
	            gO = this.eL.fM;
	        }
	        if (this.eG()) {
	            if (this.jp == this.bV.aG) {
	                this.bd.hide();
	            } else {
	                this.jp.hide();
	            }
	        }
	        this.bV.aG.css("margin-left", et);
	        this.bV.aG.css("margin-top", gO);
	        this.bV.fP();
	    };
	    WR360.ImageRotator.prototype.mk = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        this.eS = Date.now();
	        this.eO = this.hg;
	        this.kx(e);
	    };
	    WR360.ImageRotator.prototype.mL = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        this.onMouseUp(e);
	        this.oC();
	    };
	    WR360.ImageRotator.prototype.nm = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        var qg = this.hg;
	        var qK = this.qe;
	        this.onMouseMove(e);
	        if (this.hg - qg > 8 && this.qe - qK < 20 || this.av == true || this.dn == true) {
	            e.preventDefault();
	        } else {
	            this.ri = true;
	        }
	    };
	    WR360.ImageRotator.prototype.ma = function(e) {
	        if (this.bA.settings.control.dJ) {
	            return;
	        }
	        this.onMouseLeave(e);
	        this.ri = true;
	    };
	    WR360.ImageRotator.prototype.ke = function() {
	        if (this.bA.settings.bg.rotate == "false") {
	            return;
	        }
	        if (this.bA.settings.bg.rotate == "once") {
	            this.gQ = this.bA.settings.bg.bounce ? this.bU.jq() * 2 - 2 : this.bU.jq();
	        }
	        this.gJ();
	    };
	    WR360.ImageRotator.prototype.kF = function() {
	        if (this.fl == 0) {
	            var bu = this;
	            this.fl = setInterval(function() {
	                bu.lN();
	            }, this.O);
	            this.eS = Date.now();
	            this.eO = this.hg;
	        }
	    };
	    WR360.ImageRotator.prototype.ff = function() {
	        if (this.fl == 0) {
	            return;
	        }
	        clearInterval(this.fl);
	        this.fl = 0;
	        this.oC();
	    };
	    WR360.ImageRotator.prototype.oC = function() {
	        if (!this.bA.settings.bg.useInertia) {
	            return;
	        }
	        if (this.dn) {
	            return;
	        }
	        this.ri = false;
	        this.eS = Date.now() - this.eS;
	        this.eO = this.hg - this.eO;
	        var gp = this.eO / this.eS;
	        if (gp > 0.1 && this.nJ < 120) {
	            this.qM(0, gp);
	        }
	    };
	    WR360.ImageRotator.prototype.qM = function(startTime, pu) {
	        var ox = this.O;
	        if (startTime > 0) {
	            var relativeToSpeed = this.bA.settings.bg.inertiaRelToDragSpeed;
	            var pI = relativeToSpeed == true ? this.bA.settings.bg.inertiaTimeToStop * pu : this.bA.settings.bg.inertiaTimeToStop;
	            var py = this.bA.settings.bg.inertiaMaxInterval;
	            var nH = Date.now() - startTime;
	            ox = py * (nH /= pI) * nH + this.O;
	            if (ox > py) {
	                return;
	            }
	        } else {
	            startTime = Date.now();
	        }
	        var bu = this;
	        setTimeout(function() {
	            if (bu.ri) {
	                return;
	            }
	            bu.qf();
	            bu.qM(startTime, pu);
	        }, ox);
	    };
	    WR360.ImageRotator.prototype.me = function() {
	        if (this.gy++ == this.gQ) {
	            this.cJ();
	            return;
	        }
	        this.ql();
	    };
	    WR360.ImageRotator.prototype.qf = function() {
	        var oM = this.bA.settings.bg.kC == -1 ? 1 : -1;
	        if (this.bV.he == oM) {
	            if (this.bV.eT() == false) {
	                this.bV.fo();
	            }
	        } else {
	            if (this.bV.fo() == false) {
	                this.bV.eT();
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.ql = function() {
	        if (this.pY == false) {
	            return;
	        }
	        var oM = this.bA.settings.bg.kC == -1 ? 1 : -1;
	        if (this.bA.settings.bg.op > 0 || this.bV.he == oM) {
	            if (this.bV.eT() == false) {
	                this.bV.fo();
	            }
	        } else {
	            if (this.bV.fo() == false) {
	                this.bV.eT();
	            }
	        }
	        if (this.bA.settings.bg.op > 0 && this.bV.aF == this.bA.settings.bg.op) {
	            this.cJ();
	        }
	    };
	    WR360.ImageRotator.prototype.gJ = function() {
	        if (this.pY) {
	            return;
	        }
	        this.eg.ji(true);
	        this.pY = true;
	        this.gy = 0;
	        if (this.bA.settings.bg.op > 0) {
	            if (this.bA.settings.bg.pe && this.bV.aF >= this.bA.settings.bg.op) {
	                this.bV.ny();
	            }
	        } else if (this.bA.settings.bg.pe) {
	            this.bV.ny();
	        }
	        var bu = this;
	        this.fq = setInterval(function() {
	            bu.me();
	        }, this.eo);
	    };
	    WR360.ImageRotator.prototype.cJ = function() {
	        this.dispatchEvent(new WR360.Event(WR360.Events.mA, false, false));
	        if (!this.pY) {
	            return;
	        }
	        this.eg.ji(false);
	        this.pY = false;
	        this.gQ = -1;
	        this.gy = 0;
	        if (this.fq != 0) {
	            clearInterval(this.fq);
	            this.fq = 0;
	        }
	    };
	    WR360.ImageRotator.prototype.co = function() {
	        if (this.ak != 0) {
	            clearTimeout(this.ak);
	            this.ak = 0;
	        }
	        if (this.aV != 0) {
	            clearInterval(this.aV);
	            this.aV = 0;
	        }
	    };
	    WR360.ImageRotator.prototype.jz = function() {
	        var bu = this;
	        this.aV = setInterval(function() {
	            bu.iJ();
	        }, this.O);
	    };
	    WR360.ImageRotator.prototype.lN = function() {
	        if (this.cp > this.dO) {
	            this.bV.fo();
	            this.nJ = 0;
	        } else if (this.cp < this.dO) {
	            this.bV.eT();
	            this.nJ = 0;
	        } else {
	            this.nJ += this.O;
	        }
	        this.dO = this.cp;
	    };
	    WR360.ImageRotator.prototype.iJ = function() {
	        if (this.hl) {
	            this.bV.eT();
	        } else {
	            this.bV.fo();
	        }
	    };
	    WR360.ImageRotator.prototype.hc = function(show) {
	        if (show) {
	            this.cq.show();
	        } else {
	            this.cq.hide();
	        }
	    };
	    WR360.ImageRotator.prototype.er = function(text) {
	        this.cq.lb(text);
	    };
	    WR360.lE = function(V, bh) {
	        this.bh = bh;
	        this.bz = V.settings.bI.bz;
	        jQuery(bh.kW).show();
	        jQuery(bh.fj).html("");
	        if (jQuery.browser.msie) {
	            jQuery(bh.fj).css("margin-top", "1px");
	        }
	        if (this.bz == false) {
	            jQuery(bh.fj).hide();
	        } else {
	            jQuery(bh.fj).show();
	        }
	        this.il = function(percent) {
	            if (this.bz == true) {
	                jQuery(bh.fj).html(percent + "%");
	            }
	        };
	        this.lb = function(text) {};
	        this.destroy = function() {
	            if (this.bz == true) {
	                jQuery(bh.fj).html("");
	                jQuery(bh.fj).hide();
	            }
	            jQuery(bh.kW).hide();
	            jQuery(bh.ja).show();
	        };
	        this.show = function() {
	            jQuery(bh.kW).show();
	        };
	        this.hide = function() {
	            jQuery(bh.kW).hide();
	        };
	    };
	    WR360.bZ = function() {};
	    WR360.bZ.od = function(text) {
	        this.eF("INFO", text);
	    };
	    WR360.bZ.pd = function(text) {
	        this.eF("DBG", text);
	    };
	    WR360.bZ.gA = function(text) {
	        this.eF("ERR", text);
	    };
	    WR360.bZ.oU = function(text) {
	        this.eF("CRI", text);
	    };
	    WR360.bZ.nG = function(text) {
	        this.eF("WRN", text);
	    };
	    WR360.bZ.eF = function(lA, text) {
	        if (window.console) {
	            var date = new Date;
	            var kn = "{0}:{1}:{2}.{3}".format(date.getHours().toString().dd(), date.getMinutes().toString().dd(), date.getSeconds().toString().dd(), date.getMilliseconds().toString().mI());
	            window.console.log(kn + " " + lA + " " + text + "\n");
	        }
	    };
	
	    function mg() {
	        if (jQuery.browser.msie) {
	            if (parseInt(jQuery.browser.version.substring(0, 1)) < 9 && jQuery.browser.version.substring(1, 2) == ".") {
	                return 1;
	            }
	        }
	        return 0;
	    }
	
	    function mD() {
	        return 2;
	    }
	    WR360.ImageRotator.prototype.qn = function() {
	        this.ey = false;
	        this.gT = false;
	        jQuery(this.cl).css("display", "none");
	    };
	    WR360.ImageRotator.prototype.pm = function(e) {
	        if (this.ey) {
	            if (this.gT == false) {
	                this.qn();
	                return true;
	            }
	            return true;
	        }
	        return false;
	    };
	    WR360.ImageRotator.prototype.ph = function() {
	        this.ey = false;
	        this.gT = false;
	        jQuery(this.cl).css("display", "none");
	    };
	    WR360.ImageRotator.prototype.mF = function() {
	        var scrollX = 0,
	            scrollY = 0;
	        if (typeof window.pageYOffset == "number") {
	            scrollX = window.pageXOffset;
	            scrollY = window.pageYOffset;
	        } else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
	            scrollX = document.body.scrollLeft;
	            scrollY = document.body.scrollTop;
	        } else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
	            scrollX = document.documentElement.scrollLeft;
	            scrollY = document.documentElement.scrollTop;
	        }
	        return {
	            scrollX: scrollX,
	            scrollY: scrollY
	        };
	    };
	    WR360.ImageRotator.prototype.nP = function(e) {
	        var cC = WR360.by.fS(e);
	        jQuery(this.cl).css("left", cC.x - jQuery(this.pf).offset().left);
	        jQuery(this.cl).css("top", cC.y - jQuery(this.pf).offset().top);
	        jQuery(this.cl).css("display", "");
	        jQuery(this.eN).css("backgroundColor", "#FFFFFF");
	        jQuery(this.eQ).css("backgroundColor", "#FFFFFF");
	        this.ey = true;
	        return false;
	    };
	
	    function ow(e) {
	        e.preventDefault();
	        return false;
	    }
	    WR360.Toolbar = function(bh) {
	        this.hM = 0;
	        this.iz = 0;
	        this.ik = 0;
	        this.iy = 0;
	        this.rk = 0;
	        this.jZ = 0;
	        this.bh = bh;
	        this.iB = false;
	    };
	    WR360.Toolbar.prototype.cD = function() {
	        if (this.iB == false) {
	            this.hM = jQuery(this.bh.gU).outerWidth(true);
	            this.iz = jQuery(this.bh.hd).outerWidth(true);
	            this.ik = jQuery(this.bh.jA).outerWidth(true);
	            this.iy = jQuery(this.bh.jD).outerWidth(true);
	            this.rk = jQuery(this.bh.pQ).outerWidth(true);
	            this.jZ = jQuery(this.bh.kp).outerWidth(true);
	            this.iB = true;
	        }
	    };
	    WR360.Toolbar.prototype.Translate = function(V, bh) {
	        if (V.settings.bI.iU == true) {
	            if (typeof WR360_TRANSLATE_OVERRIDE !== "undefined") {
	                bh.settings.i18n = WR360_TRANSLATE_OVERRIDE;
	            }
	            jQuery(this.bh.gU).attr("title", bh.settings.i18n.arrowLeftButtonTooltip);
	            jQuery(this.bh.hd).attr("title", bh.settings.i18n.arrowRightButtonTooltip);
	            jQuery(this.bh.jA).attr("title", bh.settings.i18n.zoomButtonsTooltip);
	            jQuery(this.bh.jD).attr("title", bh.settings.i18n.togglePlayButtonTooltip);
	            jQuery(this.bh.pQ).attr("title", bh.settings.i18n.fullScreenButtonTooltip);
	            jQuery(this.bh.kp).attr("title", bh.settings.i18n.hotspotButtonTooltip);
	        }
	    };
	    WR360.Toolbar.prototype.mV = function(V, bh) {
	        var align = V.settings.bI.gx;
	        if (align == 0) {
	            jQuery(bh.ie).css("float", "none");
	        } else if (align == -1) {
	            jQuery(bh.ie).css("float", "left");
	        } else if (align == 1) {
	            jQuery(bh.ie).css("float", "right");
	        }
	        jQuery(bh.nQ).css("background-color", V.settings.bI.gH);
	        jQuery(bh.nQ).css("opacity", V.settings.bI.gX);
	        jQuery(bh.ie).css("opacity", V.settings.bI.iC);
	        var cT = 0;
	        if (V.settings.bI.hb == true) {
	            cT += this.hM;
	            cT += this.iz;
	            jQuery(bh.gU).show();
	            jQuery(bh.hd).show();
	        } else {
	            jQuery(bh.gU).hide();
	            jQuery(bh.hd).hide();
	        }
	        if (V.settings.bI.gw == true && bh.av == false) {
	            cT += this.ik;
	            bh.dN.aH(true);
	        } else {
	            bh.dN.aH(false);
	        }
	        if (V.settings.bI.gj == true) {
	            cT += this.iy;
	            jQuery(bh.jD).show();
	        } else {
	            jQuery(bh.jD).hide();
	        }
	        if (V.settings.bI.iT == true && bh.av == false) {
	            cT += this.rk;
	            bh.qZ.aH(true);
	        } else {
	            bh.qZ.aH(false);
	        }
	        if (V.settings.bI.bY == true && V.ly()) {
	            cT += this.jZ;
	            bh.bY.aH(true);
	        } else {
	            bh.bY.aH(false);
	        }
	        jQuery(this.bh.ie).css("width", bh.settings.toolbarWidthJQFix ? bh.settings.toolbarWidthJQFix : cT);
	        this.Translate(V, bh);
	    };
	    WR360.Translations = function() {
	        this.zoomButtonsTooltip = "Zoom in / out";
	        this.hotspotButtonTooltip = "Hot-spots on / off";
	        this.fullScreenButtonTooltip = "Full Screen on / off";
	        this.togglePlayButtonTooltip = "Play / Stop";
	        this.arrowLeftButtonTooltip = "Rotate left";
	        this.arrowRightButtonTooltip = "Rotate right";
	    };
	    WR360.jQ = function() {
	        this.jsScriptOnly = true;
	        this.graphicsPath = "";
	        this.configFileURL = "";
	        this.rootPath = "";
	        this.responsiveBaseWidth = 0;
	        this.responsiveBaseHeight = 0;
	        this.viewWidthJQFix = 0;
	        this.viewHeightJQFix = 0;
	        this.toolbarWidthJQFix = 0;
	        this.zIndexLayersOn = true;
	        this.inBrowserFullScreen = false;
	        this.qs = -1;
	        this.rf = -1;
	        this.qJ = -1;
	        this.imageViewportHeight = -1;
	        this.fullScreenOnClick = false;
	        this.apiReadyCallback = null;
	        this.version = "v3.5 (build 3.5.0.175)";
	        this.i18n = new WR360.Translations;
	    };
	    WR360.Events = function() {};
	    WR360.Events.gM = "SET_HOTSPOTS_ON";
	    WR360.Events.gY = "SET_HOTSPOTS_OFF";
	    WR360.Events.hG = "HIDE_ROLLOVER";
	    WR360.Events.mA = "IR_STOP_PLAYBACK";
	    WR360.Events.LOADED = "IR_LOADED";
	    WR360.hI = function() {
	        this.ed = true;
	        this.js = true;
	        this.hk = false;
	        this.gD = true;
	    };
	    WR360.hI.lD = function() {
	        var ez = new WR360.hI;
	        ez.ed = false;
	        ez.js = false;
	        ez.hk = false;
	        ez.gD = false;
	        return ez;
	    };
	    WR360.lC = function() {
	        this.ew = [];
	    };
	    WR360.lC.prototype = {
	        constructor: WR360.lC,
	        add: function(rotator) {
	            if (!(rotator instanceof WR360.ImageRotator)) {
	                throw new Error("Added object is not an ImageRotator object.");
	            }
	            for (var i = 0, ia = this.ew.length; i < ia; i++) {
	                if (this.ew[i] === rotator) {
	                    throw new Error("Added ImageRotator already exists.");
	                }
	            }
	            this.ew.push(rotator);
	        },
	        remove: function(rotator) {
	            for (var i = 0, ia = this.ew.length; i < ia; i++) {
	                if (this.ew[i] === rotator) {
	                    this.ew.splice(i, 1);
	                    break;
	                }
	            }
	        },
	        get: function(index) {
	            if (index < 0 || index > this.ew.length - 1) {
	                return null;
	            } else {
	                return this.ew[index];
	            }
	        }
	    };
	    var lH = new WR360.lC;
	})();
	var _imageRotator = new WR360.ImageRotator;
	(function() {
	    jQuery.fn.rotator = function(options) {
	        var oR = jQuery.extend({}, jQuery.fn.rotator.defaults, options);
	        return this.each(function() {
	            var o = jQuery.metadata ? jQuery.extend({}, oR, jQuery.metadata.get(this)) : oR;
	            qu(this, o);
	        });
	    };
	
	    function qu(qd, oR) {
	        var cR = qd.attributes.id.value;
	        if (cR == null || (typeof cR).toString().toLowerCase() != "string" || cR.length == 0) {
	            throw new Error("Can't get Player ID from the jQuery selected element.");
	        }
	        var ir = WR360.ImageRotator.Create(cR);
	        if (ir == null) {
	            return;
	        }
	        ir.licenseFileURL = oR.licenseFileURL;
	        ir.settings.graphicsPath = oR.graphicsPath;
	        ir.settings.configFileURL = oR.configFileURL;
	        ir.settings.rootPath = oR.rootPath;
	        ir.settings.responsiveBaseWidth = oR.responsiveBaseWidth;
	        ir.settings.responsiveBaseHeight = oR.responsiveBaseHeight;
	        ir.settings.viewWidthJQFix = oR.viewWidthJQFix;
	        ir.settings.viewHeightJQFix = oR.viewHeightJQFix;
	        ir.settings.toolbarWidthJQFix = oR.toolbarWidthJQFix;
	        ir.settings.zIndexLayersOn = oR.zIndexLayersOn;
	        ir.settings.qs = oR.qs;
	        ir.settings.rf = oR.rf;
	        ir.settings.qJ = oR.qJ;
	        ir.settings.imageViewportHeight = oR.imageViewportHeight;
	        ir.settings.i18n = oR.i18n;
	        ir.settings.fullScreenOnClick = oR.fullScreenOnClick;
	        ir.settings.inBrowserFullScreen = oR.inBrowserFullScreen;
	        ir.settings.apiReadyCallback = oR.apiReadyCallback;
	        if (ir.qC) {
	            ir.qC(oR.configFileFullScreenURL);
	        }
	        ir.runImageRotator();
	    }
	    jQuery.fn.rotator.defaults = {
	        licenseFileURL: "license.lic",
	        graphicsPath: "",
	        configFileURL: "",
	        configFileFullScreenURL: "",
	        rootPath: "",
	        responsiveBaseWidth: 0,
	        responsiveBaseHeight: 0,
	        viewWidthJQFix: 0,
	        viewHeightJQFix: 0,
	        toolbarWidthJQFix: 0,
	        zIndexLayersOn: true,
	        qs: -1,
	        rf: -1,
	        qJ: -1,
	        imageViewportHeight: -1,
	        fullScreenOnClick: false,
	        inBrowserFullScreen: false,
	        i18n: new WR360.Translations,
	        apiReadyCallback: null
	    };
	})();
	(function() {
	    var c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	    var d = window.ac = {};
	    var a = d.fk = {
	        iv: function(h, g) {
	            return h << g | h >>> 32 - g;
	        },
	        om: function(h, g) {
	            return h << 32 - g | h >>> g;
	        },
	        endian: function(h) {
	            if (h.constructor == Number) {
	                return a.iv(h, 8) & 16711935 | a.iv(h, 24) & 4278255360;
	            }
	            for (var g = 0; g < h.length; g++) {
	                h[g] = a.endian(h[g]);
	            }
	            return h;
	        },
	        mw: function(h) {
	            for (var g = []; h > 0; h--) {
	                g.push(Math.floor(Math.random() * 256));
	            }
	            return g;
	        },
	        ar: function(h) {
	            for (var k = [], j = 0, g = 0; j < h.length; j++, g += 8) {
	                k[g >>> 5] |= h[j] << 24 - g % 32;
	            }
	            return k;
	        },
	        iP: function(i) {
	            for (var h = [], g = 0; g < i.length * 32; g += 8) {
	                h.push(i[g >>> 5] >>> 24 - g % 32 & 255);
	            }
	            return h;
	        },
	        aZ: function(g) {
	            for (var j = [], h = 0; h < g.length; h++) {
	                j.push((g[h] >>> 4).toString(16));
	                j.push((g[h] & 15).toString(16));
	            }
	            return j.join("");
	        },
	        oI: function(h) {
	            for (var g = [], i = 0; i < h.length; i += 2) {
	                g.push(parseInt(h.substr(i, 2), 16));
	            }
	            return g;
	        },
	        aJ: function(h) {
	            if (typeof btoa == "function") {
	                return btoa(e.T(h));
	            }
	            for (var g = [], l = 0; l < h.length; l += 3) {
	                var m = h[l] << 16 | h[l + 1] << 8 | h[l + 2];
	                for (var k = 0; k < 4; k++) {
	                    if (l * 8 + k * 6 <= h.length * 8) {
	                        g.push(c.charAt(m >>> 6 * (3 - k) & 63));
	                    } else {
	                        g.push("=");
	                    }
	                }
	            }
	            return g.join("");
	        },
	        bL: function(h) {
	            if (typeof atob == "function") {
	                return e.de(atob(h));
	            }
	            h = h.replace(/[^A-Z0-9+\/]/gi, "");
	            for (var g = [], j = 0, k = 0; j < h.length; k = ++j % 4) {
	                if (k == 0) {
	                    continue;
	                }
	                g.push((c.indexOf(h.charAt(j - 1)) & Math.pow(2, -2 * k + 8) - 1) << k * 2 | c.indexOf(h.charAt(j)) >>> 6 - k * 2);
	            }
	            return g;
	        }
	    };
	    d.mode = {};
	    var b = d.charenc = {};
	    var f = b.UTF8 = {
	        de: function(g) {
	            return e.de(unescape(encodeURIComponent(g)));
	        },
	        T: function(g) {
	            return decodeURIComponent(escape(e.T(g)));
	        }
	    };
	    var e = b.Binary = {
	        de: function(j) {
	            for (var g = [], h = 0; h < j.length; h++) {
	                g.push(j.charCodeAt(h));
	            }
	            return g;
	        },
	        T: function(g) {
	            for (var j = [], h = 0; h < g.length; h++) {
	                j.push(String.fromCharCode(g[h]));
	            }
	            return j.join("");
	        }
	    };
	})();
	(function() {
	    var f = ac,
	        a = f.fk,
	        b = f.charenc,
	        e = b.UTF8,
	        d = b.Binary;
	    var c = f.SHA1 = function(i, g) {
	        var h = a.iP(c.mn(i));
	        return g && g.asBytes ? h : g && g.asString ? d.T(h) : a.aZ(h);
	    };
	    c.mn = function(o) {
	        if (o.constructor == String) {
	            o = e.de(o);
	        }
	        var v = a.ar(o),
	            x = o.length * 8,
	            p = [],
	            r = 1732584193,
	            q = -271733879,
	            k = -1732584194,
	            h = 271733878,
	            g = -1009589776;
	        v[x >> 5] |= 128 << 24 - x % 32;
	        v[(x + 64 >>> 9 << 4) + 15] = x;
	        for (var z = 0; z < v.length; z += 16) {
	            var E = r,
	                D = q,
	                C = k,
	                B = h,
	                A = g;
	            for (var y = 0; y < 80; y++) {
	                if (y < 16) {
	                    p[y] = v[z + y];
	                } else {
	                    var u = p[y - 3] ^ p[y - 8] ^ p[y - 14] ^ p[y - 16];
	                    p[y] = u << 1 | u >>> 31;
	                }
	                var s = (r << 5 | r >>> 27) + g + (p[y] >>> 0) + (y < 20 ? (q & k | ~q & h) + 1518500249 : y < 40 ? (q ^ k ^ h) + 1859775393 : y < 60 ? (q & k | q & h | k & h) - 1894007588 : (q ^ k ^ h) - 899497514);
	                g = h;
	                h = k;
	                k = q << 30 | q >>> 2;
	                q = r;
	                r = s;
	            }
	            r += E;
	            q += D;
	            k += C;
	            h += B;
	            g += A;
	        }
	        return [r, q, k, h, g];
	    };
	    c.dB = 16;
	})();
	(function() {
	    var e = ac,
	        a = e.fk,
	        b = e.charenc,
	        d = b.UTF8,
	        c = b.Binary;
	    e.HMAC = function(l, m, k, h) {
	        if (m.constructor == String) {
	            m = d.de(m);
	        }
	        if (k.constructor == String) {
	            k = d.de(k);
	        }
	        if (k.length > l.dB * 4) {
	            k = l(k, {
	                asBytes: true
	            });
	        }
	        var g = k.slice(0),
	            n = k.slice(0);
	        for (var j = 0; j < l.dB * 4; j++) {
	            g[j] ^= 92;
	            n[j] ^= 54;
	        }
	        var f = l(g.concat(l(n.concat(m), {
	            asBytes: true
	        })), {
	            asBytes: true
	        });
	        return h && h.asBytes ? f : h && h.asString ? c.T(f) : a.aZ(f);
	    };
	})();
	
	function getBrowserId(t, k) {
	    var kb = ac.fk.bL(k);
	    return ac.G.aD(t, kb);
	}(function() {
	    var e = ac,
	        a = e.fk,
	        b = e.charenc,
	        d = b.UTF8,
	        c = b.Binary;
	    e.PBKDF2 = function(q, o, f, t) {
	        if (q.constructor == String) {
	            q = d.de(q);
	        }
	        if (o.constructor == String) {
	            o = d.de(o);
	        }
	        var s = t && t.hasher || e.SHA1,
	            k = t && t.iterations || 1;
	
	        function p(i, j) {
	            return e.HMAC(s, j, i, {
	                asBytes: true
	            });
	        }
	        var h = [],
	            g = 1;
	        while (h.length < f) {
	            var l = p(q, o.concat(a.iP([g])));
	            for (var r = l, n = 1; n < k; n++) {
	                r = p(q, r);
	                for (var m = 0; m < l.length; m++) {
	                    l[m] ^= r[m];
	                }
	            }
	            h = h.concat(l);
	            g++;
	        }
	        h.length = f;
	        return t && t.asBytes ? h : t && t.asString ? c.T(h) : a.aZ(h);
	    };
	})();
	(function() {
	    ac.mode.OFB = {
	        jc: a,
	        aD: a
	    };
	
	    function a(c, b, d) {
	        var g = c.dB * 4,
	            f = d.slice(0);
	        for (var e = 0; e < b.length; e++) {
	            if (e % g == 0) {
	                c.mX(f, 0);
	            }
	            b[e] ^= f[e % g];
	        }
	    }
	})();
	(function() {
	    var l = ac,
	        a = l.fk,
	        u = l.charenc,
	        s = u.UTF8,
	        j = u.Binary;
	    var v = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22];
	    for (var n = [], r = 0; r < 256; r++) {
	        n[v[r]] = r;
	    }
	    var q = [],
	        p = [],
	        m = [],
	        h = [],
	        g = [],
	        e = [];
	
	    function f(y, x) {
	        for (var w = 0, z = 0; z < 8; z++) {
	            if (x & 1) {
	                w ^= y;
	            }
	            var A = y & 128;
	            y = y << 1 & 255;
	            if (A) {
	                y ^= 27;
	            }
	            x >>>= 1;
	        }
	        return w;
	    }
	    for (var r = 0; r < 256; r++) {
	        q[r] = f(r, 2);
	        p[r] = f(r, 3);
	        m[r] = f(r, 9);
	        h[r] = f(r, 11);
	        g[r] = f(r, 13);
	        e[r] = f(r, 14);
	    }
	    var k = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
	    var c = [
	            [],
	            [],
	            [],
	            []
	        ],
	        d, b, t;
	    var o = l.G = {
	        jc: function(A, z, y) {
	            var i = s.de(A),
	                x = a.mw(o.dB * 4),
	                w = z.constructor == String ? l.PBKDF2(z, x, 32, {
	                    asBytes: true
	                }) : z;
	            mode = y && y.mode || l.mode.OFB;
	            o.jC(w);
	            mode.jc(o, i, x);
	            return a.aJ(x.concat(i));
	        },
	        aD: function(z, y, x) {
	            var A = a.bL(z),
	                w = A.splice(0, o.dB * 4),
	                i = y.constructor == String ? l.PBKDF2(y, w, 32, {
	                    asBytes: true
	                }) : y;
	            mode = x && x.mode || l.mode.OFB;
	            o.jC(i);
	            mode.aD(o, A, w);
	            return s.T(A);
	        },
	        dB: 4,
	        mX: function(w, x) {
	            for (var D = 0; D < o.dB; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] = w[x + i * 4 + D];
	                }
	            }
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] ^= t[i][D];
	                }
	            }
	            for (var C = 1; C < b; C++) {
	                for (var D = 0; D < 4; D++) {
	                    for (var i = 0; i < 4; i++) {
	                        c[D][i] = v[c[D][i]];
	                    }
	                }
	                c[1].push(c[1].shift());
	                c[2].push(c[2].shift());
	                c[2].push(c[2].shift());
	                c[3].unshift(c[3].pop());
	                for (var i = 0; i < 4; i++) {
	                    var B = c[0][i],
	                        A = c[1][i],
	                        z = c[2][i],
	                        y = c[3][i];
	                    c[0][i] = q[B] ^ p[A] ^ z ^ y;
	                    c[1][i] = B ^ q[A] ^ p[z] ^ y;
	                    c[2][i] = B ^ A ^ q[z] ^ p[y];
	                    c[3][i] = p[B] ^ A ^ z ^ q[y];
	                }
	                for (var D = 0; D < 4; D++) {
	                    for (var i = 0; i < 4; i++) {
	                        c[D][i] ^= t[C * 4 + i][D];
	                    }
	                }
	            }
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] = v[c[D][i]];
	                }
	            }
	            c[1].push(c[1].shift());
	            c[2].push(c[2].shift());
	            c[2].push(c[2].shift());
	            c[3].unshift(c[3].pop());
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] ^= t[b * 4 + i][D];
	                }
	            }
	            for (var D = 0; D < o.dB; D++) {
	                for (var i = 0; i < 4; i++) {
	                    w[x + i * 4 + D] = c[D][i];
	                }
	            }
	        },
	        oE: function(x, w) {
	            for (var D = 0; D < o.dB; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] = x[w + i * 4 + D];
	                }
	            }
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] ^= t[b * 4 + i][D];
	                }
	            }
	            for (var C = 1; C < b; C++) {
	                c[1].unshift(c[1].pop());
	                c[2].push(c[2].shift());
	                c[2].push(c[2].shift());
	                c[3].push(c[3].shift());
	                for (var D = 0; D < 4; D++) {
	                    for (var i = 0; i < 4; i++) {
	                        c[D][i] = n[c[D][i]];
	                    }
	                }
	                for (var D = 0; D < 4; D++) {
	                    for (var i = 0; i < 4; i++) {
	                        c[D][i] ^= t[(b - C) * 4 + i][D];
	                    }
	                }
	                for (var i = 0; i < 4; i++) {
	                    var B = c[0][i],
	                        A = c[1][i],
	                        z = c[2][i],
	                        y = c[3][i];
	                    c[0][i] = e[B] ^ h[A] ^ g[z] ^ m[y];
	                    c[1][i] = m[B] ^ e[A] ^ h[z] ^ g[y];
	                    c[2][i] = g[B] ^ m[A] ^ e[z] ^ h[y];
	                    c[3][i] = h[B] ^ g[A] ^ m[z] ^ e[y];
	                }
	            }
	            c[1].unshift(c[1].pop());
	            c[2].push(c[2].shift());
	            c[2].push(c[2].shift());
	            c[3].push(c[3].shift());
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] = n[c[D][i]];
	                }
	            }
	            for (var D = 0; D < 4; D++) {
	                for (var i = 0; i < 4; i++) {
	                    c[D][i] ^= t[i][D];
	                }
	            }
	            for (var D = 0; D < o.dB; D++) {
	                for (var i = 0; i < 4; i++) {
	                    x[w + i * 4 + D] = c[D][i];
	                }
	            }
	        },
	        jC: function(i) {
	            d = i.length / 4;
	            b = d + 6;
	            o.ni(i);
	        },
	        ni: function(w) {
	            t = [];
	            for (var x = 0; x < d; x++) {
	                t[x] = [w[x * 4], w[x * 4 + 1], w[x * 4 + 2], w[x * 4 + 3]];
	            }
	            for (var x = d; x < o.dB * (b + 1); x++) {
	                var i = [t[x - 1][0], t[x - 1][1], t[x - 1][2], t[x - 1][3]];
	                if (x % d == 0) {
	                    i.push(i.shift());
	                    i[0] = v[i[0]];
	                    i[1] = v[i[1]];
	                    i[2] = v[i[2]];
	                    i[3] = v[i[3]];
	                    i[0] ^= k[x / d];
	                } else {
	                    if (d > 6 && x % d == 4) {
	                        i[0] = v[i[0]];
	                        i[1] = v[i[1]];
	                        i[2] = v[i[2]];
	                        i[3] = v[i[3]];
	                    }
	                }
	                t[x] = [t[x - d][0] ^ i[0], t[x - d][1] ^ i[1], t[x - d][2] ^ i[2], t[x - d][3] ^ i[3]];
	            }
	        }
	    };
	})();
	(function() {
	    WR360.ImageRotator.prototype.jL = function(gh, e, target) {
	        var aX = true;
	        if (this.R) {
	            return;
	        }
	        if (!this.dn) {
	            this.kX(this.mJ(), aX, gh, e, target);
	        } else {
	            this.kI(aX);
	        }
	    };
	    WR360.ImageRotator.prototype.kX = function(ratio, aX, gh, e, target) {
	        var fz = 300;
	        if (!this.dn) {
	            var deltaX = 0;
	            var deltaY = 0;
	            var hJ = false;
	            var af = this.bU.aw[this.bV.aF];
	            if (af.image.cS != null) {
	                this.lz();
	                hJ = true;
	            }
	            if (this.bA.settings.control.hideHotspotsOnZoom) {
	                this.lz();
	            }
	            var gd = this.aU['_viewPort.x'] - (this.aU['_viewPort.width'] * ratio - this.aU['_viewPort.width']) / 2 + deltaX;
	            var ho = this.aU['_viewPort.y'] - (this.aU['_viewPort.height'] * ratio - this.aU['_viewPort.height']) / 2 + deltaY;
	            var dC = this.aU['_viewPort.width'] * ratio;
	            var cK = this.aU['_viewPort.height'] * ratio;
	            if (!aX) {
	                this.bV.aG.css("margin-left", gd);
	                this.bV.aG.css("margin-top", ho);
	                this.bV.aG.css("width", dC);
	                this.bV.aG.css("height", cK);
	                this.bV.aG.css("left", 0);
	                this.bV.aG.css("top", 0);
	                this.eL.eY = -(dC - this.fm);
	                this.eL.ev = -(cK - this.fJ);
	                this.eL.fd = 0;
	                this.eL.fM = 0;
	                this.qY = false;
	                this.dn = true;
	                this.dN.as(true);
	                if (hJ) {
	                    this.fK(deltaX, deltaY);
	                }
	                this.bV.fP();
	            } else {
	                this.bV.aG.animate({
	                    marginLeft: gd,
	                    marginTop: ho,
	                    width: dC,
	                    height: cK,
	                    left: 0,
	                    top: 0
	                }, fz, jQuery.proxy(function() {
	                    if (this.fm - dC < 0) {
	                        this.eL.eY = this.fm - dC;
	                        this.eL.fd = 0;
	                    } else {
	                        this.eL.eY = 0;
	                        this.eL.fd = this.fm - dC;
	                    }
	                    if (this.fJ - cK < 0) {
	                        this.eL.ev = this.fJ - cK;
	                        this.eL.fM = 0;
	                    } else {
	                        this.eL.ev = 0;
	                        this.eL.fM = this.fJ - cK;
	                    }
	                    this.dn = true;
	                    this.dN.as(true);
	                    if (hJ) {
	                        this.fK(deltaX, deltaY);
	                    }
	                    this.bV.fP();
	                    this.R = false;
	                }, this));
	                this.bV.kM(fz, this.bV.aG.css("left").aK(), this.bV.aG.css("top").aK(), gd, ho, dC, cK);
	                this.R = true;
	                this.qY = false;
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.kI = function(aX) {
	        var fz = 300;
	        if (this.dn) {
	            this.bV.aS(null);
	            this.bV.en = false;
	            this.bV.dE(this.bV.aF);
	            if (this.bV.kL != null) {
	                this.bV.kL.hide();
	            }
	            if (!aX) {
	                this.bV.aG.css("margin-left", this.aU['_viewPort.x']);
	                this.bV.aG.css("margin-top", this.aU['_viewPort.y']);
	                this.bV.aG.css("width", this.aU['_viewPort.width']);
	                this.bV.aG.css("height", this.aU['_viewPort.height']);
	                this.bV.aG.css("left", 0);
	                this.bV.aG.css("top", 0);
	                this.qY = true;
	                this.dn = false;
	                this.dN.as(false);
	                this.iV();
	            } else {
	                this.bV.aG.animate({
	                    marginLeft: this.aU['_viewPort.x'],
	                    marginTop: this.aU['_viewPort.y'],
	                    width: this.aU['_viewPort.width'],
	                    height: this.aU['_viewPort.height'],
	                    left: 0,
	                    top: 0
	                }, fz, jQuery.proxy(function() {
	                    this.qY = true;
	                    this.dn = false;
	                    this.dN.as(false);
	                    this.iV();
	                    this.R = false;
	                }, this));
	                this.bV.kM(fz, 0, 0, this.aU['_viewPort.x'], this.aU['_viewPort.y'], this.aU['_viewPort.width'], this.aU['_viewPort.height']);
	                this.R = true;
	            }
	        }
	    };
	})();
	(function() {
	    WR360.ImageRotator.prototype.getAPI = function() {
	        return new WR360.API(this);
	    };
	    WR360.API = function(L) {
	        this.toolbar = new WR360.API.Tools(L);
	        this.images = new WR360.API.Images(L);
	        this.configuration = new WR360.API.Config(L);
	        this.L = L;
	    };
	    WR360.API.prototype.reload = function(configFileURL, rootPath, hZ, reloadImageIndex) {
	        this.L.reload(configFileURL, rootPath, hZ, reloadImageIndex);
	    };
	    WR360.API.Tools = function(L) {
	        this.L = L;
	    };
	    WR360.API.Tools.prototype.zoomToggle = function() {
	        this.L.mt();
	    };
	    WR360.API.Tools.prototype.hotspotToggle = function() {
	        this.L.mf();
	    };
	    WR360.API.Tools.prototype.openFullScreen = function() {
	        this.L.rc(null);
	    };
	    WR360.API.Tools.prototype.playbackToggle = function() {
	        if (this.L.pY == true) {
	            this.L.mp();
	        } else {
	            this.L.mR();
	        }
	    };
	    WR360.API.Tools.prototype.playbackStop = function() {
	        this.L.mp();
	    };
	    WR360.API.Tools.prototype.playbackStart = function() {
	        this.L.mp();
	        this.L.mR();
	    };
	    WR360.API.Tools.prototype.startLeftArrowRotate = function() {
	        this.L.mp();
	        this.L.np();
	    };
	    WR360.API.Tools.prototype.startRightArrowRotate = function() {
	        this.L.mp();
	        this.L.nv();
	    };
	    WR360.API.Tools.prototype.stopArrowRotate = function() {
	        this.L.co();
	    };
	    WR360.API.Images = function(L) {
	        this.L = L;
	    };
	    WR360.API.Images.prototype.getTotalImageCount = function() {
	        return this.L.bV.bU.aw.length - 1;
	    };
	    WR360.API.Images.prototype.getCurrentImageIndex = function() {
	        return this.L.bV.ob();
	    };
	    WR360.API.Images.prototype.showImageByIndex = function(index) {
	        this.L.bV.dE(index);
	    };
	    WR360.API.Images.prototype.showImageByDelta = function(jG) {
	        this.L.bV.iG(jG);
	    };
	    WR360.API.Images.prototype.playToLabel = function(label, period, hZ) {
	        this.L.bV.qB(label, period, hZ);
	    };
	    WR360.API.Images.prototype.jumpToLabel = function(label) {
	        this.L.bV.qo(label);
	    };
	    WR360.API.Config = function(L) {
	        this.L = L;
	    };
	})();
	(function() {
	    WR360.ImageRotator.prototype.qQ = function() {
	        return this.av;
	    };
	    WR360.ImageRotator.prototype.qr = function() {
	        if (this.av === undefined) {
	            this.av = false;
	        }
	        if (this.qR === undefined) {
	            this.qR = null;
	        }
	        if (this.pH === undefined) {
	            this.pH = null;
	        }
	        if (this.qA === undefined) {
	            this.qA = "";
	        }
	        if (this.configFileFullScreenURL === undefined) {
	            this.configFileFullScreenURL = "";
	        }
	        if (this.pF === undefined) {
	            this.pF = null;
	        }
	        if (this.qj === undefined) {
	            this.qj = false;
	        }
	    };
	    WR360.ImageRotator.prototype.pW = function() {
	        if (this.av && this.loaded && jQuery(this.cR).is(":visible")) {
	            if (!this.qj) {
	                this.qy();
	                return true;
	            }
	        }
	        return false;
	    };
	    WR360.ImageRotator.prototype.qy = function() {
	        jQuery("body").css("overflow", "hidden");
	        var scrollXY = this.mF();
	        jQuery(this.cR).css({
	            top: scrollXY.scrollY,
	            left: scrollXY.scrollX,
	            width: jQuery(window).width(),
	            height: window.innerHeight ? window.innerHeight : jQuery(window).height()
	        });
	        jQuery(this.pf).css({
	            width: jQuery(window).width(),
	            height: window.innerHeight ? window.innerHeight : jQuery(window).height()
	        });
	        this.gs();
	    };
	    WR360.ImageRotator.prototype.qC = function(configFileFullScreenURL) {
	        if (this.qS()) {
	            return;
	        }
	        this.configFileFullScreenURL = configFileFullScreenURL;
	    };
	    WR360.ImageRotator.prototype.rg = function() {
	        if (this.qS()) {
	            return;
	        }
	        var zIndex = 50000;
	        var suffix = "_fs";
	        this.rh();
	        if (this.qR == null) {
	            jQuery("body").css("overflow", "hidden");
	            var pG = this.cR + suffix;
	            var pw = this.oY + suffix;
	            if (jQuery(pG).length == 0) {
	                var parentElement = jQuery("body");
	                if (parentElement == null) {
	                    throw new Error("Can't create full-screen image rotator: parent element is NULL.");
	                }
	                parentElement.append("<div id='" + pw + "' class='wr360_player'></div>");
	                var pF = document.getElementById(pw);
	                var qj = this.pz(pF);
	                if (qj) {
	                    if (pF.requestFullScreen) {
	                        pF.requestFullScreen();
	                    } else if (pF.mozRequestFullScreen) {
	                        pF.mozRequestFullScreen();
	                    } else if (pF.webkitRequestFullScreen) {
	                        pF.webkitRequestFullScreen();
	                    }
	                    jQuery(pG).css({
	                        width: screen.width,
	                        height: screen.height,
	                        'background-color': this.bA.settings.bI.fullScreenBackColor
	                    });
	                } else {
	                    var scrollXY = this.mF();
	                    jQuery(pG).css({
	                        position: "absolute",
	                        top: scrollXY.scrollY,
	                        left: scrollXY.scrollX,
	                        width: jQuery(window).width(),
	                        height: window.innerHeight ? window.innerHeight : jQuery(window).height(),
	                        'z-index': zIndex,
	                        'background-color': this.bA.settings.bI.fullScreenBackColor
	                    });
	                }
	            }
	            this.qR = new WR360.ImageRotator(pw);
	            this.qR.settings.jsScriptOnly = true;
	            this.qR.settings.graphicsPath = this.settings.graphicsPath;
	            this.qR.settings.configFileURL = this.configFileFullScreenURL.length > 0 ? this.configFileFullScreenURL : this.settings.configFileURL;
	            this.qR.licenseFileURL = this.licenseFileURL;
	            this.qR.settings.fullScreenOnClick = this.settings.fullScreenOnClick;
	            this.qR.settings.rootPath = this.settings.rootPath;
	            this.qR.settings.inBrowserFullScreen = this.settings.inBrowserFullScreen;
	            this.qR.settings.zIndexLayersOn = this.settings.zIndexLayersOn;
	            this.qR.av = true;
	            this.qR.pH = this;
	            this.qR.pF = pF;
	            this.qR.qj = qj;
	            if (qj) {
	                this.qR.pN();
	            }
	            this.qR.runImageRotator();
	        } else {
	            this.qR.qi();
	        }
	    };
	    WR360.ImageRotator.prototype.pN = function(e) {
	        document.addEventListener("mozfullscreenchange", jQuery.proxy(function(event) {
	            this.qE(event);
	        }, this));
	        document.addEventListener("webkitfullscreenchange", jQuery.proxy(function(event) {
	            this.qE(event);
	        }, this));
	    };
	    WR360.ImageRotator.prototype.qE = function(e) {
	        if (!document.mozFullScreen && !document.webkitIsFullScreen) {
	            if (jQuery(this.cR).is(":visible")) {
	                this.pR(e);
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.pz = function(cu) {
	        if (this.bA.settings.control.inBrowserFullScreen == true || this.settings.inBrowserFullScreen == true) {
	            return false;
	        }
	        return cu != null && (cu.requestFullScreen || cu.mozRequestFullScreen || cu.webkitRequestFullScreen);
	    };
	    WR360.ImageRotator.prototype.qi = function() {
	        if (this.qS()) {
	            return;
	        }
	        if (!this.av) {
	            return;
	        }
	        if (this.qj) {
	            jQuery("body").css("overflow", "hidden");
	            if (this.pF.requestFullScreen) {
	                this.pF.requestFullScreen();
	            } else if (this.pF.mozRequestFullScreen) {
	                this.pF.mozRequestFullScreen();
	            } else if (this.pF.webkitRequestFullScreen) {
	                this.pF.webkitRequestFullScreen();
	            }
	            jQuery(this.cR).css({
	                width: screen.width,
	                height: screen.height
	            });
	        } else {
	            this.qy();
	        }
	        if (this.pH != null) {
	            this.bV.dE(this.pH.bV.ob());
	        }
	        this.bV.aG.fadeIn(600);
	        jQuery(this.cR).show();
	    };
	    WR360.ImageRotator.prototype.pj = function() {
	        if (this.qR != null) {
	            this.pZ();
	            jQuery(this.qR.cR).remove();
	            this.qR = null;
	        }
	    };
	    WR360.ImageRotator.prototype.pZ = function() {
	        if (!this.av) {
	            return;
	        }
	        this.rh();
	        this.bV.aG.hide();
	        this.bV.lx();
	        jQuery(this.cR).hide();
	    };
	    WR360.ImageRotator.prototype.qU = function() {
	        if (this.av && this.pH.bA.settings.bI.iT == true) {
	            this.qA = this.cR + "_X";
	            if (jQuery(this.qA).length == 0) {
	                jQuery(this.cR).append("<a class='fullscreenoff_button' id='" + this.qA.replace("#", "") + "'></a>");
	                jQuery(this.qA).click(jQuery.proxy(function(event) {
	                    this.ro(event);
	                }, this));
	                jQuery(document).keydown(jQuery.proxy(function(event) {
	                    this.qF(event);
	                }, this));
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.qz = function() {
	        var success = false;
	        if (this.av && this.pH != null) {
	            this.bV.dE(this.pH.bV.ob());
	            success = true;
	        }
	        return success;
	    };
	    WR360.ImageRotator.prototype.qa = function() {
	        if (this.av) {
	            if (this.settings.fullScreenOnClick || this.bA.settings.bI.showFullScreenToolbar == true) {
	                return;
	            }
	            jQuery(this.ja).hide();
	            jQuery(this.nQ).hide();
	        }
	    };
	    WR360.ImageRotator.prototype.pM = function() {
	        return !this.av;
	    };
	    WR360.ImageRotator.prototype.rc = function(e) {
	        if (this.R) {
	            return;
	        }
	        if (!this.av) {
	            this.rg();
	            this.kI(false);
	        } else {
	            this.rn(e);
	        }
	    };
	    WR360.ImageRotator.prototype.pR = function(e) {
	        this.pZ();
	        jQuery("body").css({
	            overflow: "auto"
	        });
	    };
	    WR360.ImageRotator.prototype.ro = function(e) {
	        e.preventDefault();
	        this.rn(e);
	    };
	    WR360.ImageRotator.prototype.rn = function(e) {
	        if (this.av) {
	            if (this.qj && (document.mozFullScreen || document.webkitIsFullScreen)) {
	                if (document.cancelFullScreen) {
	                    document.cancelFullScreen();
	                } else if (document.mozCancelFullScreen) {
	                    document.mozCancelFullScreen();
	                } else if (document.webkitCancelFullScreen) {
	                    document.webkitCancelFullScreen();
	                }
	            } else {
	                this.pR(e);
	            }
	        }
	    };
	    WR360.ImageRotator.prototype.qF = function(e) {
	        if (this.av && jQuery(this.cR).is(":visible")) {
	            if (e.which == 27) {
	                e.preventDefault();
	                this.pR(e);
	            }
	        }
	    };
	})();
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = WR360;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*	
	 *	jQuery Touch Optimized Sliders "R"Us
	 *	Buttons addon
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 */
	 
	 (function( $ ) {
	 
	 	var _PLUGIN_ = 'tosrus',
			_ADDON_  = 'buttons';
	
		var _addonInitiated = false,
			_c, _d, _e, _f, _g;
	
		$[ _PLUGIN_ ].prototype[ '_addon_' + _ADDON_ ] = function()
		{
			if ( !_addonInitiated )
			{
				_c = $[ _PLUGIN_ ]._c;
				_d = $[ _PLUGIN_ ]._d;
				_e = $[ _PLUGIN_ ]._e;
				_f = $[ _PLUGIN_ ]._f;
				_g = $[ _PLUGIN_ ]._g;
	
				_c.add( 'prev next close disabled' );
	
				_addonInitiated = true;
			}
	
			var that = this,
				btns = this.opts[ _ADDON_ ];
	
			this.nodes.$prev = null;
			this.nodes.$next = null;
			this.nodes.$clse = null;
	
			if ( typeof btns == 'boolean' || ( typeof btns == 'string' && btns == 'inline' ) )
			{
				btns = {
					prev: btns,
					next: btns
				};
			}
			if ( typeof btns.close == 'undefined' )
			{
	 			btns.close = this.vars.fixed;
			}
			if ( this.nodes.$slides.length < 2 )
			{
				btns.prev = false;
				btns.next = false;
			}
	
			$.each(
				{
					'prev'	: 'prev',
					'next'	: 'next',
					'close'	: 'clse'
				},
				function( btn, value )
				{
					if ( btns[ btn ] )
					{
						//	Inline buttons
						if ( typeof btns[ btn ] == 'string' && btns[ btn ] == 'inline' )
						{
							if ( that.vars.fixed && btn != 'close' )
							{
								that.nodes.$slides
									.on( _e.loading,
										function( e, $anchor )
										{
											var $btn = createButton( btn, ' ' + _c.inline )[ btn == 'prev' ? 'prependTo' : 'appendTo' ]( this );
											bindEvent( that.nodes.$wrpr, $btn, btn, 1 );
											
											if ( !that.opts.infinite )
											{
												if (( btn == 'prev' && $(this).is( ':first-child' ) ) ||
													( btn == 'next' && $(this).is( ':last-child' ) ) )
												{
													$btn.addClass( _c.disabled );
												}
											}
										}
									);
							}
						}
	
						//	External buttons
						else
						{
							if ( typeof btns[ btn ] == 'string' )
							{
								btns[ btn ] = $(btns[ btn ]);
							}
							that.nodes[ '$' + value ] = ( btns[ btn ] instanceof $ )
								? btns[ btn ]
								: createButton( btn, '' ).appendTo( that.nodes.$wrpr );
	
							bindEvent( that.nodes.$wrpr, that.nodes[ '$' + value ], btn, null );
						}
					}
				}
			);
	
			if ( !this.opts.infinite )
			{
				this.updateButtons();
				this.nodes.$wrpr
					.on( _e.sliding,
						function( e, slide, direct )
						{
							that.updateButtons();
						}
					);
			}
		};
	
		function createButton( dir, cls )
		{
			return $('<a class="' + _c[ dir ] + '' + cls + '" href="#"><span></span></a>');
		}
		function bindEvent( $wrpr, $btn, dir, slides )
		{
			$btn
				.on( _e.click,
					function( e )
					{
						e.preventDefault();
						e.stopPropagation();
						$wrpr.trigger( _e[ dir ], [ slides ] );
					}
				);
		}
	
		$[ _PLUGIN_ ].prototype.updateButtons = function()
		{
			if ( this.nodes.$prev )
			{
				this.nodes.$prev[ ( ( this.slides.index < 1 ) ? 'add' : 'remove' ) + 'Class' ]( _c.disabled );
			}
			if ( this.nodes.$next )
			{
				this.nodes.$next[ ( ( this.slides.index >= this.slides.total - this.slides.visible ) ? 'add' : 'remove' ) + 'Class' ]( _c.disabled );
			}
		};
	
		//	Defaults
		$[ _PLUGIN_ ].defaults[ _ADDON_ ] = {
			prev	: !$[ _PLUGIN_ ].support.touch,
			next	: !$[ _PLUGIN_ ].support.touch
		};
	
		//	Add to plugin
		$[ _PLUGIN_ ].addons.push( _ADDON_ );
		$[ _PLUGIN_ ].ui.push( 'prev' );
		$[ _PLUGIN_ ].ui.push( 'next' );
		$[ _PLUGIN_ ].ui.push( 'close' );
	
	
	})( jQuery );


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*	
	 *	jQuery Touch Optimized Sliders "R"Us
	 *	Caption addon
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 */
	 
	 (function( $ ) {
	 
	 	var _PLUGIN_ = 'tosrus',
			_ADDON_  = 'caption';
	
		var _addonInitiated = false,
			_c, _d, _e, _f, _g;
	
		$[ _PLUGIN_ ].prototype[ '_addon_' + _ADDON_ ] = function()
		{		
			if ( !_addonInitiated )
			{
				_c = $[ _PLUGIN_ ]._c;
				_d = $[ _PLUGIN_ ]._d;
				_e = $[ _PLUGIN_ ]._e;
				_f = $[ _PLUGIN_ ]._f;
				_g = $[ _PLUGIN_ ]._g;
	
				_c.add( 'caption uibg' );
				_d.add( 'caption' );
	
				_addonInitiated = true;
			}
	
			var that = this,
				capt = this.opts[ _ADDON_ ];
	
	
			if ( capt.add )
			{
	
				capt.attributes = capt.attributes || [];
	
				if ( typeof capt.target == 'string' )
				{
					capt.target = $(capt.target);
				}
				if ( capt.target instanceof $ )
				{
					this.nodes.$capt = capt.target;
				}
				else
				{
					this.nodes.$capt = $('<div class="' + _c.caption + '" />').appendTo( this.nodes.$wrpr );
					if ( !this.nodes.$uibg )
					{
						this.nodes.$uibg = $('<div class="' + _c.uibg + '" />').prependTo( this.nodes.$wrpr );
					}
				}
				for ( var c = 0, l = this.slides.visible; c < l; c++ )
				{
					$('<div class="' + _c.caption + '-' + c + '" />')
						.css( 'width', this.opts.slides.width + ( ( this.slides.widthPercentage ) ? '%' : 'px' ) )
						.appendTo( this.nodes.$capt );
				}
	
				this.nodes.$slides
					.each(
						function( index )
						{
							var $slide = $(this),
								$anchor = ( that.vars.fixed )
									? $slide.data( _d.anchor )
									: $slide.children();
	
							$slide.data( _d.caption, '' );
							for ( var c = 0, l = capt.attributes.length; c < l; c++ )
							{
								var caption = $anchor.attr( capt.attributes[ c ] );
								if ( caption && caption.length )
								{
									$slide.data( _d.caption, caption );
									break;
								}
							}
						}
					);
	
				this.nodes.$wrpr
					.on( _e.sliding,
						function( e, slide, direct )
						{
							var show = false;
							for ( var c = 0, l = that.slides.visible; c < l; c++ )
							{
								that.nodes.$capt
									.children()
									.eq( c )
									.html( that.nodes.$sldr.children().eq( that.slides.index + c ).data( _d.caption ) || '' );
							}						
						}
					);
			}
		};
	
		//	Defaults
		$[ _PLUGIN_ ].defaults[ _ADDON_ ] = {
			add			: false,
			target		: null,
			attributes	: [ 'title', 'alt', 'rel' ]
		};
	
		//	Add to plugin
		$[ _PLUGIN_ ].addons.push( _ADDON_ );
		$[ _PLUGIN_ ].ui.push( 'caption' );
	
	
	})( jQuery );


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*	
	 *	jQuery Touch Optimized Sliders "R"Us
	 *	Drag addon
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 */
	
	(function( $ ) {
	
		if ( typeof Hammer != 'function' )
		{
			return;
		}
	
		var _PLUGIN_ = 'tosrus',
			_ADDON_  = 'drag';
	
		var _addonInitiated = false,
			_c, _d, _e, _f, _g;
	
		$[ _PLUGIN_ ].prototype[ '_addon_' + _ADDON_ ] = function()
		{
			if ( !_addonInitiated )
			{
				_c = $[ _PLUGIN_ ]._c;
				_d = $[ _PLUGIN_ ]._d;
				_e = $[ _PLUGIN_ ]._e;
				_f = $[ _PLUGIN_ ]._f;
				_g = $[ _PLUGIN_ ]._g;
	
				_addonInitiated = true;
			}
	
			var that = this;
	
			if ( this.opts[ _ADDON_ ] && this.opts.effect == 'slide' )
			{
				if ( Hammer.VERSION < 2 )
				{
					$[ _PLUGIN_ ].deprecated( 'Older version of the Hammer library', 'version 2 or newer' );
					return;
				}
	
				if ( this.nodes.$slides.length > 1 )
				{
					var _distance 	= 0,
						_direction	= false,
						_swiping	= false;
		
					var _hammer = new Hammer( this.nodes.$wrpr[ 0 ] );
	
					_hammer
						.on( 'panstart panleft panright panend swipeleft swiperight',
							function( e )
							{
								e.preventDefault();
							}
						)
						.on( 'panstart',
							function( e )
							{
			            		that.nodes.$sldr.addClass( _c.noanimation );
							}
						)
						.on( 'panleft panright',
							function( e )
							{
								_distance	= e.deltaX;
								_swiping	= false;
	
								switch( e.direction )
								{
									case 2:
										_direction = 'left';
										break;
									
									case 4:
										_direction = 'right';
										break;
									
									default:
										_direction = false;
										break;
								}
			
								if ( ( _direction == 'left' && that.slides.index + that.slides.visible >= that.slides.total  ) ||
									( _direction == 'right' && that.slides.index == 0 ) )
								{
									_distance /= 2.5;
								}
		
								that.nodes.$sldr.css( 'margin-left', Math.round( _distance ) );
							}
						)
						.on( 'swipeleft swiperight',
							function( e )
							{
								_swiping = true;
							}
						)
						.on( 'panend',
							function( e )
							{
								that.nodes.$sldr
									.removeClass( _c.noanimation )
									.addClass( _c.fastanimation );
	
								_f.transitionend( that.nodes.$sldr,
									function()
									{
										that.nodes.$sldr.removeClass( _c.fastanimation );
									}, that.conf.transitionDuration / 2
								);
		
								that.nodes.$sldr.css( 'margin-left', 0 );
		
								if ( _direction == 'left' || _direction == 'right' )
								{
									if ( _swiping )
									{
										var slides = that.slides.visible;
									}
									else
									{
										var slideWidth = that.nodes.$slides.first().width(),
											slides = Math.floor( ( Math.abs( _distance ) + ( slideWidth / 2 ) ) / slideWidth );	
									}
			
									if ( slides > 0 )
									{
										that.nodes.$wrpr.trigger( _e[ _direction == 'left' ? 'next' : 'prev' ], [ slides ] );
									}
								}
		
								_direction = false;
							}
						);
				}
			}
	
		};
	
		//	Defautls
		$[ _PLUGIN_ ].defaults[ _ADDON_ ] = $[ _PLUGIN_ ].support.touch;
	
		//	Add to plugin
		$[ _PLUGIN_ ].addons.push( _ADDON_ );
	
	
	})( jQuery );
	


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*	
	 *	jQuery Touch Optimized Sliders "R"Us
	 *	Keys addon
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 */
	 
	 (function( $ ) {
	 
	 	var _PLUGIN_ = 'tosrus',
			_ADDON_  = 'keys';
	
		var _addonInitiated = false,
			_c, _d, _e, _f, _g;
	
		$[ _PLUGIN_ ].prototype[ '_addon_' + _ADDON_ ] = function()
		{		
			if ( !_addonInitiated )
			{
				_c = $[ _PLUGIN_ ]._c;
				_d = $[ _PLUGIN_ ]._d;
				_e = $[ _PLUGIN_ ]._e;
				_f = $[ _PLUGIN_ ]._f;
				_g = $[ _PLUGIN_ ]._g;
	
				_e.add( 'keyup' );
	
				_addonInitiated = true;
			}
	
			var that = this,
				keys = this.opts[ _ADDON_ ];
	
			if ( typeof keys == 'boolean' && keys )
			{
				keys = {
					prev	: true,
					next	: true,
					close	: true
				};
			}
			if ( $.isPlainObject( keys) )
			{
				for ( var k in $[ _PLUGIN_ ].constants[ _ADDON_ ] )
				{
					if ( typeof keys[ k ] == 'boolean' && keys[ k ] )
					{
						keys[ k ] = $[ _PLUGIN_ ].constants[ _ADDON_ ][ k ];
					}
				}
	
				if ( this.nodes.$slides.length < 2 )
				{
					keys.prev = false;
					keys.next = false;
				}
	
				$(document)
					.on( _e.keyup,
						function( e )
						{
							if ( that.vars.opened )
							{
								var fn = false;
								switch( e.keyCode )
								{
									case keys.prev:
										fn = _e.prev;
										break;
		
									case keys.next:
										fn = _e.next;
										break;
		
									case keys.close:
										fn = _e.close;
										break;
								}
								if ( fn )
								{
									e.preventDefault();
									e.stopPropagation();
									that.nodes.$wrpr.trigger( fn );
								}
							}
						}
					);
			}
	
		};
	
		//	Defaults
		$[ _PLUGIN_ ].defaults[ _ADDON_ ] = false;
	
		$[ _PLUGIN_ ].constants[ _ADDON_ ] = {
			prev	: 37,
			next	: 39,
			close	: 27
		};
	
		//	Add to plugin
		$[ _PLUGIN_ ].addons.push( _ADDON_ );
	
	
	})( jQuery );


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*	
	 *	jQuery Touch Optimized Sliders "R"Us
	 *	Pagination addon
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 */
	
	 (function( $ ) {
	 
	 	var _PLUGIN_ = 'tosrus',
			_ADDON_  = 'pagination';
	
		var _addonInitiated = false,
			_c, _d, _e, _f, _g;
	
		$[ _PLUGIN_ ].prototype[ '_addon_' + _ADDON_ ] = function()
		{		
			if ( !_addonInitiated )
			{
				_c = $[ _PLUGIN_ ]._c;
				_d = $[ _PLUGIN_ ]._d;
				_e = $[ _PLUGIN_ ]._e;
				_f = $[ _PLUGIN_ ]._f;
				_g = $[ _PLUGIN_ ]._g;
	
				_c.add( 'pagination selected uibg bullets thumbnails' );
	
				_addonInitiated = true;
			}
	
			var that = this,
				pagr = this.opts[ _ADDON_ ];
	
	
			if ( this.nodes.$slides.length < 2 )
			{
				pagr.add = false;
			}
	
			if ( pagr.add )
			{
				if ( typeof pagr.target == 'string' )
				{
					pagr.target = $(pagr.target);
				}
				if ( pagr.target instanceof $ )
				{
					this.nodes.$pagr = pagr.target;
				}
				else
				{
					this.nodes.$pagr = $('<div class="' + _c.pagination + ' ' + _c[ pagr.type ] + '" />').appendTo( this.nodes.$wrpr );
					if ( !this.nodes.$uibg )
					{
						this.nodes.$uibg = $('<div class="' + _c.uibg + '" />').prependTo( this.nodes.$wrpr );
					}
				}
	
				if ( typeof pagr.anchorBuilder != 'function' )
				{
					switch( pagr.type )
					{
						case 'thumbnails':
							var pre 	= '<a href="#" style="background-image: url(',
								post	= ');"></a>';
	
							if ( this.vars.fixed )
							{
								pagr.anchorBuilder = function( index )
								{
									return pre + $(this).data( _d.anchor ).attr( 'href' ) + post;
								};
							}
							else
							{
								pagr.anchorBuilder = function( index )
								{
									return pre + $(this).find( 'img' ).attr( 'src' ) + post;
								};
							}
							break;
	
						case 'bullets':
						default:
							pagr.anchorBuilder = function( index )
							{
								return '<a href="#"></a>';
							};
							break;
					}
				}
	
				this.nodes.$slides
					.each(
						function( index )
						{
							$(pagr.anchorBuilder.call( this, index + 1 ) )
								.appendTo( that.nodes.$pagr )
								.on( _e.click,
									function( e )
									{
										e.preventDefault();
										e.stopPropagation();
	
										that.nodes.$wrpr.trigger( _e.slideTo, [ index ] );
									}
								);
						}
					);
				
				this.updatePagination();
				this.nodes.$wrpr
					.on( _e.sliding,
						function( e, slide, direct )
						{
							that.updatePagination();
						}
					);
			}
		};
		
		$[ _PLUGIN_ ].prototype.updatePagination = function()
		{
			if ( this.nodes.$pagr )
			{
				this.nodes.$pagr
					.children()
					.removeClass( _c.selected )
					.eq( this.slides.index )
					.addClass( _c.selected );
			}
		};
	
		//	Defaults
		$[ _PLUGIN_ ].defaults[ _ADDON_ ] = {
			add				: false,
			type			: 'bullets',
			target			: null,
			anchorBuilder	: null
		};
	
		//	Add to plugin
		$[ _PLUGIN_ ].addons.push( _ADDON_ );
		$[ _PLUGIN_ ].ui.push( 'pagination' );
		$[ _PLUGIN_ ].ui.push( 'bullets' );
		$[ _PLUGIN_ ].ui.push( 'thumbnails' );
	
	
	})( jQuery );


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(3);
	var Hammer = __webpack_require__(18);
	var FlameViewportScale = __webpack_require__(33);
	
	/*
	 *	jQuery Touch Optimized Sliders "R"Us 2.4.2
	 *	
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 *
	 *	Plugin website:
	 *	tosrus.frebsite.nl
	 *
	 *	Licensed under the MIT license.
	 *	http://en.wikipedia.org/wiki/MIT_License
	 */
	
	
	
	(function( $ ) {
	
		var _PLUGIN_	= 'tosrus',
			_ABBR_		= 'tos',
			_VERSION_	= '2.4.2';
	
	
		//	Plugin already excists
		if ( $[ _PLUGIN_ ] )
		{
			return;
		}
	
	
		//	Global variables
		var _c = {}, _d = {}, _e = {}, _f = {}, _g = {};
	
	
		/*
			Class
		*/
		$[ _PLUGIN_ ] = function( $node, opts, conf )
		{
			this.$node	= $node;
			this.opts	= opts;
			this.conf	= conf;
	
			this.vars	= {};
			this.nodes	= {};
			this.slides	= {};
	
			this._init();
	
			return this;
		};
		$[ _PLUGIN_ ].prototype = {
	
			//	Initialize the plugin
			_init: function()
			{
				var that = this;
	
				this._complementOptions();
				this.vars.fixed = ( this.opts.wrapper.target == 'window' );
	
				//	Add markup
				this.nodes.$wrpr = $('<div class="' + _c.wrapper + '" />');
				this.nodes.$sldr = $('<div class="' + _c.slider + '" />').appendTo( this.nodes.$wrpr );
		
				this.nodes.$wrpr
					.addClass( this.vars.fixed ? _c.fixed : _c.inline )
					.addClass( _c( 'fx-' + this.opts.effect ) )
					.addClass( _c( this.opts.slides.scale ) )
					.addClass( this.opts.wrapper.classes );
	
				//	Bind events
				this.nodes.$wrpr
	
					//	Custom events
					.on( _e.open + ' ' + _e.close + ' ' + _e.prev + ' ' + _e.next + ' ' + _e.slideTo,
						function( e )
						{
							arguments = Array.prototype.slice.call( arguments );
							var e = arguments.shift(),
								t = e.type;
		
							e.stopPropagation();
	
							if ( typeof that[ t ] == 'function' )
							{
								that[ t ].apply( that, arguments );
							}
						}
					)
	
					//	Callback events
					.on( _e.opening + ' ' + _e.closing + ' ' + _e.sliding + ' ' + _e.loading + ' ' + _e.loaded,
						function( e )
						{
							e.stopPropagation();
						}
					)
	
					//	Toggle UI
					.on( _e.click,
						function( e )
						{
							e.stopPropagation();
	
							switch ( that.opts.wrapper.onClick )
							{
								case 'toggleUI':
									that.nodes.$wrpr.toggleClass( _c.hover );
									break;
								
								case 'close':
									if ( !$(e.target).is( 'img' ) )
									{
										that.close();
									}
									break;
							}
						}
					);
	
	/*
				//	Prevent pinching if opened
				if ( $.fn.hammer && $[ _PLUGIN_ ].support.touch )
				{
					this.nodes.$wrpr
						.hammer()
						.on( _e.pinch,
							function( e )
							{
								if ( _g.$body.hasClass( _c.opened ) )
								{
									e.gesture.preventDefault();
									e.stopPropagation();
								}
							}
						);
				}
	*/
	
				//	Nodes
				this.nodes.$anchors = this._initAnchors();
				this.nodes.$slides  = this._initSlides();
	
				//	Slides
				this.slides.total	= this.nodes.$slides.length;
				this.slides.visible	= this.opts.slides.visible;
				this.slides.index	= 0;
	
				//	Vars
				this.vars.opened	= true;
	
	
				//	Init addons
				for ( var a = 0; a < $[ _PLUGIN_ ].addons.length; a++ )
				{
					if ( $.isFunction( this[ '_addon_' + $[ _PLUGIN_ ].addons[ a ] ] ) )
					{
						this[ '_addon_' + $[ _PLUGIN_ ].addons[ a ] ]();
					}
				}
				for ( var u = 0; u < $[ _PLUGIN_ ].ui.length; u++ )
				{
					if ( this.nodes.$wrpr.find( '.' + _c[ $[ _PLUGIN_ ].ui[ u ] ] ).length )
					{
						this.nodes.$wrpr.addClass( _c( 'has-' + $[ _PLUGIN_ ].ui[ u ] ) );
					}
				}
	
	
				//	Prevent closing when clicking on UI elements
				if ( this.opts.wrapper.onClick == 'close' )
				{
					this.nodes.$uibg || $()
						.add( this.nodes.$capt || $() )
						.add( this.nodes.$pagr || $() )
						.on( _e.click,
							function( e )
							{
								e.stopPropagation();
							}
						);
				}
	
	
				//	Start
				if ( this.vars.fixed )
				{
					this.nodes.$wrpr.appendTo( _g.$body );
					this.close( true );
				}
				else
				{
					this.nodes.$wrpr.appendTo( this.opts.wrapper.target );
	
					if ( this.opts.show )
					{
						this.vars.opened = false;
						this.open( 0, true );
					}
					else
					{
						this.close( true );
					}
				}
			},
	
	
			//	Open method, opens the gallery and slides to the designated slide
			open: function( index, direct )
			{
				var that = this;
	
				if ( !this.vars.opened )
				{
					if ( this.vars.fixed )
					{
						_g.scrollPosition = _g.$wndw.scrollTop();
						_g.$body.addClass( _c.opened );
						_f.setViewportScale();
					}
	
					if ( direct )
					{
						this.nodes.$wrpr
							.addClass( _c.opening )
							.trigger( _e.opening, [ index, direct ] );
					}
					else
					{
						setTimeout(
							function()
							{
								that.nodes.$wrpr
									.addClass( _c.opening )
									.trigger( _e.opening, [ index, direct ] );
							}, 5
						);
					}
	
					this.nodes.$wrpr
						.addClass( _c.hover )
						.addClass( _c.opened );
				}
	
				this.vars.opened = true;
				this._loadContents();
	
				//	Slide to given slide
				if ( $.isNumeric( index ) )
				{
					direct = ( direct || !this.vars.opened );
					this.slideTo( index, direct );
				}
			},
	
	
			//	Close method, closes the gallery
			close: function( direct )
			{
				if ( this.vars.opened )
				{
					if ( this.vars.fixed )
					{
						_g.$body.removeClass( _c.opened );
					}
	
					if ( direct )
					{
						this.nodes.$wrpr.removeClass( _c.opened );
					}
					else
					{
						_f.transitionend( this.nodes.$wrpr,
							function()
							{
								$(this).removeClass( _c.opened );
							}, this.conf.transitionDuration
						);
					}
	
					//	Close + Callback event
					this.nodes.$wrpr
						.removeClass( _c.hover )
						.removeClass( _c.opening )
						.trigger( _e.closing, [ this.slides.index, direct ] );
				}
				this.vars.opened = false;
			},
	
	
			//	Prev method, slides to the previous set of slides
			prev: function( slides, direct )
			{
				if ( !$.isNumeric( slides ) )
				{
					slides = this.opts.slides.slide;
				}
				this.slideTo( this.slides.index - slides, direct );
	
			},
	
	
			//	Next method, slides to the next set of slides
			next: function( slides, direct )
			{
				if ( !$.isNumeric( slides ) )
				{
					slides = this.opts.slides.slide;
				}
				this.slideTo( this.slides.index + slides, direct );
			},
	
	
			//	SlideTo method, slides to the designated slide
			slideTo: function( index, direct )
			{
				if ( !this.vars.opened )
				{
					return false;
				}
				if ( !$.isNumeric( index ) )
				{
					return false;
				}
	
				var doSlide = true;
	
				//	Less then first
				if ( index < 0 )
				{
					var atStart = ( this.slides.index == 0 );
	
					//	Infinite
					if ( this.opts.infinite )
					{
						if ( atStart )
						{
							index = this.slides.total - this.slides.visible;
						}
						else
						{
							index = 0;
						}
					}
					//	Non-infinite
					else
					{
						index = 0;
						if ( atStart )
						{
							doSlide = false;
						}
					}
				}
	
				//	More then last
				if ( index + this.slides.visible > this.slides.total )
				{
					var atEnd = ( this.slides.index + this.slides.visible >= this.slides.total );
	
					//	Infinite
					if ( this.opts.infinite )
					{
						if ( atEnd )
						{
							index = 0;
						}
						else
						{
							index = this.slides.total - this.slides.visible;
						}
					}
					//	Non-infinite
					else
					{
						index = this.slides.total - this.slides.visible;
						if ( atEnd )
						{
							doSlide = false;
						}
					}
				}
	
				this.slides.index = index;
				this._loadContents();
	
				if ( doSlide )
				{
					var left = 0 - ( this.slides.index * this.opts.slides.width ) + this.opts.slides.offset;
					if ( this.slides.widthPercentage )
					{
						left += '%';
					}
	
					if ( direct )
					{
						this.nodes.$sldr.addClass( _c.noanimation );
						_f.transitionend( this.nodes.$sldr,
							function()
							{
								$(this).removeClass( _c.noanimation );
							}, 5
						);
					}
	
					//	Transition
					for ( var e in $[ _PLUGIN_ ].effects )
					{
						if ( e == this.opts.effect )
						{
							$[ _PLUGIN_ ].effects[ e ].call( this, left, direct );
							break;
						}
					}
					
					//	Callback event
					this.nodes.$wrpr.trigger( _e.sliding, [ index, direct ] );
				}
			},
	
			_initAnchors: function()
			{
				var that = this,
					$a = $();
	
				if ( this.$node.is( 'a' ) )
				{
					for ( var m in $[ _PLUGIN_ ].media )
					{
						$a = $a.add( 
							this.$node.filter(
								function()
								{
									if ( that.opts.media[ m ] && that.opts.media[ m ].filterAnchors )
									{
										var result = that.opts.media[ m ].filterAnchors.call( that, $(this) );
										if ( typeof result == 'boolean' )
										{
											return result;
										}
									}
									return $[ _PLUGIN_ ].media[ m ].filterAnchors.call( that, $(this) );
								}
							)
						);
					}
				}
				return $a;
			},
			_initSlides: function()
			{
				this[ this.$node.is( 'a' ) ? '_initSlidesFromAnchors' : '_initSlidesFromContent' ]();
				return this.nodes.$sldr.children().css( 'width', this.opts.slides.width + ( this.slides.widthPercentage ? '%' : 'px' ) );
			},
			_initSlidesFromAnchors: function()
			{
				var that = this;
	
				this.nodes.$anchors
					.each(
						function( index )
						{
							var $anchor = $(this);
	
							//	Create the slide
							var $slide = $('<div class="' + _c.slide + ' ' + _c.loading + '" />')
								.data( _d.anchor, $anchor )
								.appendTo( that.nodes.$sldr );
	
							//	Clicking an achor opens the slide
							$anchor
								.data( _d.slide, $slide )
								.on( _e.click,
									function( e )
									{
										e.preventDefault();
										that.open( index );
									}
								);
						}
					);
			},
			_initSlidesFromContent: function()
			{
				var that = this;
	
				this.$node
					.children()
					.each(
						function()
						{
							var $slide = $(this);
	
							$('<div class="' + _c.slide + '" />')
								.append( $slide )
								.appendTo( that.nodes.$sldr );
	
							//	Init slide content
							for ( var m in $[ _PLUGIN_ ].media )
							{
								var result = null;
								if ( that.opts.media[ m ] && that.opts.media[ m ].filterSlides )
								{
									result = that.opts.media[ m ].filterSlides.call( that, $slide );
								}
								if ( typeof result != 'boolean' )
								{
									result = $[ _PLUGIN_ ].media[ m ].filterSlides.call( that, $slide );
								}
								if ( result )
								{
									$[ _PLUGIN_ ].media[ m ].initSlides.call( that, $slide );
									$slide.parent().addClass( _c( m ) );
									break;
								}
							}
						}
				);
			},
	
			_loadContents: function()
			{
				var that = this;
	
				switch ( this.opts.slides.load )
				{
					//	Load all
					case 'all':
						this._loadContent( 0, this.slides.total );
						break;
	
					//	Load current
					case 'visible':
						this._loadContent( this.slides.index, this.slides.index + this.slides.visible );
						break;
	
					//	Load current + prev + next
					case 'near-visible':
					default:
						this._loadContent( this.slides.index, this.slides.index + this.slides.visible );
						setTimeout(
							function()
							{
								that._loadContent( that.slides.index - that.slides.visible, that.slides.index );								//	prev
								that._loadContent( that.slides.index + that.slides.visible, that.slides.index + ( that.slides.visible * 2 ) );	//	next
							}, this.conf.transitionDuration
						);
						break;
				}
			},
			_loadContent: function( start, end )
			{
				var that = this;
	
				this.nodes.$slides
					.slice( start, end )
					.each(
						function()
						{
							var $slide		= $(this),
								contenttype = false;
	
							if ( $slide.children().length == 0 )
							{
								var $anchor = $slide.data( _d.anchor ),
									content = $anchor.attr( 'href' );
	
								//	Search for slide content
								for ( var m in $[ _PLUGIN_ ].media )
								{
									var result = null;
									if ( that.opts.media[ m ] && that.opts.media[ m ].filterAnchors )
									{
										result = that.opts.media[ m ].filterAnchors.call( that, $anchor );
									}
									if ( typeof result != 'boolean' )
									{
										result = $[ _PLUGIN_ ].media[ m ].filterAnchors.call( that, $anchor );
									}
									
									if ( result )
									{
										$[ _PLUGIN_ ].media[ m ].initAnchors.call( that, $slide, content );
										$slide.addClass( _c( m ) );
										break;
									}
								}
	
								//	Callback event
								$slide.trigger( _e.loading, [ $slide.data( _d.anchor ) ] );
							}
						}
				);
			},
	
			_complementOptions: function()
			{
				//	Wrapper
				if ( typeof this.opts.wrapper.target == 'undefined' )
				{
					this.opts.wrapper.target = ( this.$node.is( 'a' ) ) ? 'window' : this.$node;
				}
				if ( this.opts.wrapper.target != 'window' )
				{
					if ( typeof this.opts.wrapper.target == 'string' )
					{
						this.opts.wrapper.target = $(this.opts.wrapper.target);
					}
				}
		
				//	Show
				this.opts.show = _f.complBoolean(  this.opts.show, this.opts.wrapper.target != 'window' );
	
				//	Slides
				if ( $.isNumeric( this.opts.slides.width ) )
				{
					this.slides.widthPercentage	= false;
					this.opts.slides.visible 	= _f.complNumber( this.opts.slides.visible, 1 );
				}
				else
				{
					var percWidth = ( _f.isPercentage( this.opts.slides.width ) ) ? _f.getPercentage( this.opts.slides.width ) : false;
	
					this.slides.widthPercentage	= true;
					this.opts.slides.visible 	= _f.complNumber( this.opts.slides.visible, ( percWidth ) ? Math.floor( 100 / percWidth ) : 1 );
					this.opts.slides.width 		= ( percWidth ) ? percWidth : Math.ceil( 100 * 100 / this.opts.slides.visible ) / 100;
				}
				this.opts.slides.slide		=   _f.complNumber( this.opts.slides.slide, this.opts.slides.visible );
				this.opts.slides.offset 	= ( _f.isPercentage( this.opts.slides.offset ) ) ? _f.getPercentage( this.opts.slides.offset ) : _f.complNumber( this.opts.slides.offset, 0 );
			},
			
			_uniqueID: function()
			{
				if ( !this.__uniqueID )
				{
					this.__uniqueID = 0;
				}
				this.__uniqueID++;
				return _c( 'uid-' + this.__uniqueID );
			}
		};
	
	
		/*
			jQuery Plugin
		*/
		$.fn[ _PLUGIN_ ] = function( opts, optsD, optsT, conf )
		{
			//	First time plugin is fired
			if ( !_g.$wndw )
			{
				initPlugin();
			}
	
			//	Extend options
			opts = $.extend( true, {}, $[ _PLUGIN_ ].defaults, opts );
			opts = $.extend( true, {}, opts, $[ _PLUGIN_ ].support.touch ? optsT : optsD );
	
			//	Extend configuration
			conf = $.extend( true, {}, $[ _PLUGIN_ ].configuration, conf );
	
			var clss = new $[ _PLUGIN_ ]( this, opts, conf );
	
			this.data( _PLUGIN_, clss );
			return clss.nodes.$wrpr;
		};
	
	
		/*
			SUPPORT
		*/
		$[ _PLUGIN_ ].support = {
			touch: 'ontouchstart' in window.document || navigator.msMaxTouchPoints
		};
	
	
		/*
			Options
		*/
		$[ _PLUGIN_ ].defaults = {
	//		show		: null,				//	true for inline slider, false for popup lightbox
			infinite	: false,
			effect		: 'slide',
			wrapper	: {
	//			target	: null,				//	"window" for lightbox popup
				classes	: '',
				onClick	: 'toggleUI'		//	"toggleUI", "close" or null
			},
			slides	: {
	//			slide	: null,				//	slides.visible
	//			width	: null,				//	auto, max 100%
				offset	: 0,
				scale	: 'fit',			//	"fit" or "fill" (for images only)
				load	: 'near-visible',	//	"all", "visible" or "near-visible"
				visible	: 1
			},
			media	: {}
		};
	
		$[ _PLUGIN_ ].configuration = {
			transitionDuration: 400
		};
		
		$[ _PLUGIN_ ].constants = {};
	
	
		/*
			DEBUG
		*/
		$[ _PLUGIN_ ].debug = function( msg ) {};
		$[ _PLUGIN_ ].deprecated = function( depr, repl )
		{
			if ( typeof console != 'undefined' && typeof console.warn != 'undefined' )
			{
				console.warn( _PLUGIN_ + ': ' + depr + ' is deprecated, use ' + repl + ' instead.' );
			}
		};
	
	
		/*
			EFFECTS
		*/
		$[ _PLUGIN_ ].effects = {
			'slide': function( left )
			{
				this.nodes.$sldr.css( 'left', left );
			},
			'fade': function( left )
			{
				_f.transitionend( this.nodes.$sldr,
					function()
					{
						$(this)
							.css( 'left', left )
							.css( 'opacity', 1 );
					}, this.conf.transitionDuration
				);
				this.nodes.$sldr.css( 'opacity', 0 );
			}
		};
	
	
		$[ _PLUGIN_ ].version 	= _VERSION_;
		$[ _PLUGIN_ ].media		= {};
		$[ _PLUGIN_ ].addons 	= [];
		$[ _PLUGIN_ ].ui		= [];
	
	
		/*
			Private functions
		*/
		function initPlugin()
		{
	
			//	Classnames, Datanames, Eventnames
			_c = function( c ) { return _ABBR_ + '-' + c; };
			_d = function( d ) { return _ABBR_ + '-' + d; };
			_e = function( e ) { return e + '.' + _ABBR_; };
	
			$.each( [ _c, _d, _e ],
				function( i, o )
				{
					o.add = function( c )
					{
						c = c.split( ' ' );
						for ( var d in c )
						{
							o[ c[ d ] ] = o( c[ d ] );
						}
					};
				}
			);
	
			//	Classnames
			_c.add( 'touch desktop scale-1 scale-2 scale-3 wrapper opened opening fixed inline hover slider slide loading noanimation fastanimation' );
	
			//	Datanames
			_d.add( 'slide anchor' );
	
			//	Eventnames
			_e.add( 'open opening close closing prev next slideTo sliding click pinch scroll resize orientationchange load loading loaded transitionend webkitTransitionEnd' );
	
			//	Functions
			_f = {
				complObject: function( option, defaultVal )
				{
					if ( !$.isPlainObject( option ) )
					{
						option = defaultVal;
					}
					return option;
				},
				complBoolean: function( option, defaultVal )
				{
					if ( typeof option != 'boolean' )
					{
						option = defaultVal;
					}
					return option;
				},
				complNumber: function( option, defaultVal )
				{
					if ( !$.isNumeric( option ) )
					{
						option = defaultVal;
					}
					return option;
				},
				complString: function( option, defaultVal )
				{
					if ( typeof option != 'string' )
					{
						option = defaultVal;
					}
					return option;
				},
				isPercentage: function( value )
				{
					return ( typeof value == 'string' && value.slice( -1 ) == '%' );
					{
						value = parseInt( value.slice( 0, -1 ) );
					}
					return !isNaN( value );
				},
				getPercentage: function( value )
				{
					return parseInt( value.slice( 0, -1 ) );
				},
				resizeRatio: function( $i, $o, maxWidth, maxHeight, ratio )
				{		
					var _w = $o.width(),
						_h = $o.height();
			
					if ( maxWidth && _w > maxWidth )
					{
						_w = maxWidth;
					}
					if ( maxHeight && _h > maxHeight )
					{
						_h = maxHeight;
					}
			
					if ( _w / _h < ratio )
					{
						_h = _w / ratio;
					}
					else
					{
						_w = _h * ratio;
					}
					$i.width( _w ).height( _h );
				},
				transitionend: function( $e, fn, duration )
		        {
					var _ended = false,
						_fn = function()
						{
							if ( !_ended )
							{
								fn.call( $e[ 0 ] );
							}
							_ended = true;
						};
	
					$e.one( _e.transitionend, _fn );
					$e.one( _e.webkitTransitionEnd, _fn );
					setTimeout( _fn, duration * 1.1 );
		        },
		        setViewportScale: function()
		        {
		        	if ( _g.viewportScale )
					{
						var scale = _g.viewportScale.getScale();
						if ( typeof scale != 'undefined' )
						{
							scale = 1 / scale;
							_g.$body
								.removeClass( _c[ 'scale-1' ] )
								.removeClass( _c[ 'scale-2' ] )
								.removeClass( _c[ 'scale-3' ] )
								.addClass( _c[ 'scale-' + Math.max( Math.min( Math.round( scale ), 3 ), 1 ) ] );
						}
					}
		        }
			};
	
			// Global variables
			_g = {
				$wndw	: $(window),
				$html	: $('html'),
				$body	: $('body'),
	
				scrollPosition			: 0,
				viewportScale			: null,
				viewportScaleInterval	: null
			};
	
	
			//	Touch or desktop
			_g.$body.addClass( $[ _PLUGIN_ ].support.touch ? _c.touch : _c.desktop )
	
			//	Prevent scroling if opened
			_g.$wndw
				.on( _e.scroll,
					function( e )
					{
						if ( _g.$body.hasClass( _c.opened ) )
						{
							window.scrollTo( 0, _g.scrollPosition );
							e.preventDefault();
							e.stopPropagation();
							e.stopImmediatePropagation();
						}
					}
				);
	
			//	Invert viewport-scale
			if ( !_g.viewportScale && $[ _PLUGIN_ ].support.touch && typeof FlameViewportScale != 'undefined' )
			{
				_g.viewportScale = new FlameViewportScale();
				_f.setViewportScale();
				_g.$wndw
					.on( _e.orientationchange + ' ' + _e.resize,
						function( e )
						{
							if ( _g.viewportScaleInterval )
							{
								clearTimeout( _g.viewportScaleInterval );
								_g.viewportScaleInterval = null;
							}
							_g.viewportScaleInterval = setTimeout(
								function()
								{
									_f.setViewportScale();
								}, 500
							);
						}
					);
			}
	
	
			//	Add to plugin
			$[ _PLUGIN_ ]._c = _c;
			$[ _PLUGIN_ ]._d = _d;
			$[ _PLUGIN_ ]._e = _e;
			$[ _PLUGIN_ ]._f = _f;
			$[ _PLUGIN_ ]._g = _g;
		};
	
	})( jQuery );


/***/ },
/* 272 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
	 * Build: http://modernizr.com/download/#-touch-shiv-cssclasses-teststyles-prefixes
	 */
	;
	
	
	
	window.Modernizr = (function( window, document, undefined ) {
	
	    var version = '2.8.3',
	
	        Modernizr = {},
	
	        enableClasses = true,
	
	        docElement = document.documentElement,
	
	        mod = 'modernizr',
	        modElem = document.createElement(mod),
	        mStyle = modElem.style,
	
	        inputElem  ,
	
	
	        toString = {}.toString,
	
	        prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),
	
	
	
	        tests = {},
	        inputs = {},
	        attrs = {},
	
	        classes = [],
	
	        slice = classes.slice,
	
	        featureName,
	
	
	        injectElementWithStyles = function( rule, callback, nodes, testnames ) {
	
	            var style, ret, node, docOverflow,
	                div = document.createElement('div'),
	                body = document.body,
	                fakeBody = body || document.createElement('body');
	
	            if ( parseInt(nodes, 10) ) {
	                while ( nodes-- ) {
	                    node = document.createElement('div');
	                    node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	                    div.appendChild(node);
	                }
	            }
	
	            style = ['&#173;','<style id="s', mod, '">', rule, '</style>'].join('');
	            div.id = mod;
	            (body ? div : fakeBody).innerHTML += style;
	            fakeBody.appendChild(div);
	            if ( !body ) {
	                fakeBody.style.background = '';
	                fakeBody.style.overflow = 'hidden';
	                docOverflow = docElement.style.overflow;
	                docElement.style.overflow = 'hidden';
	                docElement.appendChild(fakeBody);
	            }
	
	            ret = callback(div, rule);
	            if ( !body ) {
	                fakeBody.parentNode.removeChild(fakeBody);
	                docElement.style.overflow = docOverflow;
	            } else {
	                div.parentNode.removeChild(div);
	            }
	
	            return !!ret;
	
	        },
	        _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;
	
	    if ( !is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined') ) {
	        hasOwnProp = function (object, property) {
	            return _hasOwnProperty.call(object, property);
	        };
	    }
	    else {
	        hasOwnProp = function (object, property) {
	            return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
	        };
	    }
	
	
	    if (!Function.prototype.bind) {
	        Function.prototype.bind = function bind(that) {
	
	            var target = this;
	
	            if (typeof target != "function") {
	                throw new TypeError();
	            }
	
	            var args = slice.call(arguments, 1),
	                bound = function () {
	
	                    if (this instanceof bound) {
	
	                        var F = function(){};
	                        F.prototype = target.prototype;
	                        var self = new F();
	
	                        var result = target.apply(
	                            self,
	                            args.concat(slice.call(arguments))
	                        );
	                        if (Object(result) === result) {
	                            return result;
	                        }
	                        return self;
	
	                    } else {
	
	                        return target.apply(
	                            that,
	                            args.concat(slice.call(arguments))
	                        );
	
	                    }
	
	                };
	
	            return bound;
	        };
	    }
	
	    function setCss( str ) {
	        mStyle.cssText = str;
	    }
	
	    function setCssAll( str1, str2 ) {
	        return setCss(prefixes.join(str1 + ';') + ( str2 || '' ));
	    }
	
	    function is( obj, type ) {
	        return typeof obj === type;
	    }
	
	    function contains( str, substr ) {
	        return !!~('' + str).indexOf(substr);
	    }
	
	
	    function testDOMProps( props, obj, elem ) {
	        for ( var i in props ) {
	            var item = obj[props[i]];
	            if ( item !== undefined) {
	
	                if (elem === false) return props[i];
	
	                if (is(item, 'function')){
	                    return item.bind(elem || obj);
	                }
	
	                return item;
	            }
	        }
	        return false;
	    }
	    tests['touch'] = function() {
	        var bool;
	
	        if(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
	            bool = true;
	        } else {
	            injectElementWithStyles(['@media (',prefixes.join('touch-enabled),('),mod,')','{#modernizr{top:9px;position:absolute}}'].join(''), function( node ) {
	                bool = node.offsetTop === 9;
	            });
	        }
	
	        return bool;
	    };
	    for ( var feature in tests ) {
	        if ( hasOwnProp(tests, feature) ) {
	            featureName  = feature.toLowerCase();
	            Modernizr[featureName] = tests[feature]();
	
	            classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
	        }
	    }
	
	
	
	    Modernizr.addTest = function ( feature, test ) {
	        if ( typeof feature == 'object' ) {
	            for ( var key in feature ) {
	                if ( hasOwnProp( feature, key ) ) {
	                    Modernizr.addTest( key, feature[ key ] );
	                }
	            }
	        } else {
	
	            feature = feature.toLowerCase();
	
	            if ( Modernizr[feature] !== undefined ) {
	                return Modernizr;
	            }
	
	            test = typeof test == 'function' ? test() : test;
	
	            if (typeof enableClasses !== "undefined" && enableClasses) {
	                docElement.className += ' ' + (test ? '' : 'no-') + feature;
	            }
	            Modernizr[feature] = test;
	
	        }
	
	        return Modernizr;
	    };
	
	
	    setCss('');
	    modElem = inputElem = null;
	
	    ;(function(window, document) {
	        var version = '3.7.0';
	
	        var options = window.html5 || {};
	
	        var reSkip = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i;
	
	        var saveClones = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i;
	
	        var supportsHtml5Styles;
	
	        var expando = '_html5shiv';
	
	        var expanID = 0;
	
	        var expandoData = {};
	
	        var supportsUnknownElements;
	
	        (function() {
	            try {
	                var a = document.createElement('a');
	                a.innerHTML = '<xyz></xyz>';
	                supportsHtml5Styles = ('hidden' in a);
	
	                supportsUnknownElements = a.childNodes.length == 1 || (function() {
	                        (document.createElement)('a');
	                        var frag = document.createDocumentFragment();
	                        return (
	                            typeof frag.cloneNode == 'undefined' ||
	                            typeof frag.createDocumentFragment == 'undefined' ||
	                            typeof frag.createElement == 'undefined'
	                        );
	                    }());
	            } catch(e) {
	                supportsHtml5Styles = true;
	                supportsUnknownElements = true;
	            }
	
	        }());
	
	        function addStyleSheet(ownerDocument, cssText) {
	            var p = ownerDocument.createElement('p'),
	                parent = ownerDocument.getElementsByTagName('head')[0] || ownerDocument.documentElement;
	
	            p.innerHTML = 'x<style>' + cssText + '</style>';
	            return parent.insertBefore(p.lastChild, parent.firstChild);
	        }
	
	        function getElements() {
	            var elements = html5.elements;
	            return typeof elements == 'string' ? elements.split(' ') : elements;
	        }
	
	        function getExpandoData(ownerDocument) {
	            var data = expandoData[ownerDocument[expando]];
	            if (!data) {
	                data = {};
	                expanID++;
	                ownerDocument[expando] = expanID;
	                expandoData[expanID] = data;
	            }
	            return data;
	        }
	
	        function createElement(nodeName, ownerDocument, data){
	            if (!ownerDocument) {
	                ownerDocument = document;
	            }
	            if(supportsUnknownElements){
	                return ownerDocument.createElement(nodeName);
	            }
	            if (!data) {
	                data = getExpandoData(ownerDocument);
	            }
	            var node;
	
	            if (data.cache[nodeName]) {
	                node = data.cache[nodeName].cloneNode();
	            } else if (saveClones.test(nodeName)) {
	                node = (data.cache[nodeName] = data.createElem(nodeName)).cloneNode();
	            } else {
	                node = data.createElem(nodeName);
	            }
	
	            return node.canHaveChildren && !reSkip.test(nodeName) && !node.tagUrn ? data.frag.appendChild(node) : node;
	        }
	
	        function createDocumentFragment(ownerDocument, data){
	            if (!ownerDocument) {
	                ownerDocument = document;
	            }
	            if(supportsUnknownElements){
	                return ownerDocument.createDocumentFragment();
	            }
	            data = data || getExpandoData(ownerDocument);
	            var clone = data.frag.cloneNode(),
	                i = 0,
	                elems = getElements(),
	                l = elems.length;
	            for(;i<l;i++){
	                clone.createElement(elems[i]);
	            }
	            return clone;
	        }
	
	        function shivMethods(ownerDocument, data) {
	            if (!data.cache) {
	                data.cache = {};
	                data.createElem = ownerDocument.createElement;
	                data.createFrag = ownerDocument.createDocumentFragment;
	                data.frag = data.createFrag();
	            }
	
	
	            ownerDocument.createElement = function(nodeName) {
	                if (!html5.shivMethods) {
	                    return data.createElem(nodeName);
	                }
	                return createElement(nodeName, ownerDocument, data);
	            };
	
	            ownerDocument.createDocumentFragment = Function('h,f', 'return function(){' +
	                'var n=f.cloneNode(),c=n.createElement;' +
	                'h.shivMethods&&(' +
	                getElements().join().replace(/[\w\-]+/g, function(nodeName) {
	                    data.createElem(nodeName);
	                    data.frag.createElement(nodeName);
	                    return 'c("' + nodeName + '")';
	                }) +
	                ');return n}'
	            )(html5, data.frag);
	        }
	
	        function shivDocument(ownerDocument) {
	            if (!ownerDocument) {
	                ownerDocument = document;
	            }
	            var data = getExpandoData(ownerDocument);
	
	            if (html5.shivCSS && !supportsHtml5Styles && !data.hasCSS) {
	                data.hasCSS = !!addStyleSheet(ownerDocument,
	                    'article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}' +
	                    'mark{background:#FF0;color:#000}' +
	                    'template{display:none}'
	                );
	            }
	            if (!supportsUnknownElements) {
	                shivMethods(ownerDocument, data);
	            }
	            return ownerDocument;
	        }
	
	        var html5 = {
	
	            'elements': options.elements || 'abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video',
	
	            'version': version,
	
	            'shivCSS': (options.shivCSS !== false),
	
	            'supportsUnknownElements': supportsUnknownElements,
	
	            'shivMethods': (options.shivMethods !== false),
	
	            'type': 'default',
	
	            'shivDocument': shivDocument,
	
	            createElement: createElement,
	
	            createDocumentFragment: createDocumentFragment
	        };
	
	        window.html5 = html5;
	
	        shivDocument(document);
	
	    }(this, document));
	
	    Modernizr._version      = version;
	
	    Modernizr._prefixes     = prefixes;
	
	    Modernizr.testStyles    = injectElementWithStyles;    docElement.className = docElement.className.replace(/(^|\s)no-js(\s|$)/, '$1$2') +
	
	        (enableClasses ? ' js ' + classes.join(' ') : '');
	
	    return Modernizr;
	
	})(this, this.document);
	;
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Modernizr;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(68),
	    LodashWrapper = __webpack_require__(108),
	    baseLodash = __webpack_require__(72),
	    isArray = __webpack_require__(9),
	    isObjectLike = __webpack_require__(29),
	    wrapperClone = __webpack_require__(319);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	 * Methods that operate on and return arrays, collections, and functions can
	 * be chained together. Methods that retrieve a single value or may return a
	 * primitive value will automatically end the chain returning the unwrapped
	 * value. Explicit chaining may be enabled using `_.chain`. The execution of
	 * chained methods is lazy, that is, execution is deferred until `_#value`
	 * is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	 * fusion is an optimization strategy which merge iteratee calls; this can help
	 * to avoid the creation of intermediate data structures and greatly reduce the
	 * number of iteratee executions.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	 * `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	 * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	 * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	 * and `where`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	 * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	 * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	 * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	 * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	 * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	 * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	 * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	 * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	 * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	 * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	 * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	 * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	 * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	 * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	 * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	 * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	 * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	 * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	 * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	 * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	 * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	 * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	 * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	 * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	 * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	 * `unescape`, `uniqueId`, `value`, and `words`
	 *
	 * The wrapper method `sample` will return a wrapped value when `n` is provided,
	 * otherwise an unwrapped value is returned.
	 *
	 * @name _
	 * @constructor
	 * @category Chain
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // returns an unwrapped value
	 * wrapped.reduce(function(total, n) {
	 *   return total + n;
	 * });
	 * // => 6
	 *
	 * // returns a wrapped value
	 * var squares = wrapped.map(function(n) {
	 *   return n * n;
	 * });
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	
	module.exports = lodash;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(275);


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(109),
	    baseEach = __webpack_require__(111),
	    createForEach = __webpack_require__(302);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection). Iteratee functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	var forEach = createForEach(arrayEach, baseEach);
	
	module.exports = forEach;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(297);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` through `iteratee`. The corresponding value
	 * of each key is an array of the elements responsible for generating the key.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([4.2, 6.1, 6.4], function(n) {
	 *   return Math.floor(n);
	 * });
	 * // => { '4': [4.2], '6': [6.1, 6.4] }
	 *
	 * _.groupBy([4.2, 6.1, 6.4], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => { '4': [4.2], '6': [6.1, 6.4] }
	 *
	 * // using the `_.property` callback shorthand
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    result[key] = [value];
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(74),
	    isLength = __webpack_require__(26),
	    keys = __webpack_require__(34);
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the size of `collection`.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  var length = collection ? getLength(collection) : 0;
	  return isLength(length) ? length : keys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(54);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	module.exports = now;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(286),
	    restParam = __webpack_require__(67);
	
	/**
	 * Defers invoking the `func` until the current call stack has cleared. Any
	 * additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to defer.
	 * @param {...*} [args] The arguments to invoke the function with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.defer(function(text) {
	 *   console.log(text);
	 * }, 'deferred');
	 * // logs 'deferred' after one or more milliseconds
	 */
	var defer = restParam(function(func, args) {
	  return baseDelay(func, 1, args);
	});
	
	module.exports = defer;


/***/ },
/* 280 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 281 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(34);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(292),
	    baseMatchesProperty = __webpack_require__(293),
	    bindCallback = __webpack_require__(41),
	    identity = __webpack_require__(77),
	    property = __webpack_require__(328);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(40),
	    arrayEach = __webpack_require__(109),
	    baseAssign = __webpack_require__(110),
	    baseForOwn = __webpack_require__(112),
	    initCloneArray = __webpack_require__(311),
	    initCloneByTag = __webpack_require__(312),
	    initCloneObject = __webpack_require__(313),
	    isArray = __webpack_require__(9),
	    isObject = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;
	
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseAssign(result, value);
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 285 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 286 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts an index
	 * of where to slice the arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Object} args The arguments provide to `func`.
	 * @returns {number} Returns the timer id.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(280),
	    isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(9),
	    isArrayLike = __webpack_require__(55),
	    isObjectLike = __webpack_require__(29);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(300);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(124);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from those provided.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the new array of filtered property names.
	 */
	function baseFunctions(object, props) {
	  var index = -1,
	      length = props.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var key = props[index];
	    if (isFunction(object[key])) {
	      result[++resIndex] = key;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFunctions;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(306),
	    equalByTag = __webpack_require__(307),
	    equalObjects = __webpack_require__(308),
	    isArray = __webpack_require__(9),
	    isTypedArray = __webpack_require__(323);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(71),
	    toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(291),
	    getMatchData = __webpack_require__(310),
	    toObject = __webpack_require__(27);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(70),
	    baseIsEqual = __webpack_require__(71),
	    baseSlice = __webpack_require__(115),
	    isArray = __webpack_require__(9),
	    isKey = __webpack_require__(75),
	    isStrictComparable = __webpack_require__(120),
	    last = __webpack_require__(107),
	    toObject = __webpack_require__(27),
	    toPath = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(70),
	    toPath = __webpack_require__(76);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 295 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 296 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Native method references. */
	var ArrayBuffer = global.ArrayBuffer,
	    Uint8Array = global.Uint8Array;
	
	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  var result = new ArrayBuffer(buffer.byteLength),
	      view = new Uint8Array(result);
	
	  view.set(new Uint8Array(buffer));
	  return result;
	}
	
	module.exports = bufferClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(283),
	    baseEach = __webpack_require__(111),
	    isArray = __webpack_require__(9);
	
	/**
	 * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	 *
	 * @private
	 * @param {Function} setter The function to set keys and values of the accumulator object.
	 * @param {Function} [initializer] The function to initialize the accumulator object.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee, thisArg) {
	    var result = initializer ? initializer() : {};
	    iteratee = baseCallback(iteratee, thisArg, 3);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        setter(result, value, iteratee(value, index, collection), collection);
	      }
	    } else {
	      baseEach(collection, function(value, key, collection) {
	        setter(result, value, iteratee(value, key, collection), collection);
	      });
	    }
	    return result;
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(41),
	    isIterateeCall = __webpack_require__(119),
	    restParam = __webpack_require__(67);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(74),
	    isLength = __webpack_require__(26),
	    toObject = __webpack_require__(27);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(27);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createCtorWrapper = __webpack_require__(73);
	
	/**
	 * Creates a function that wraps `func` and invokes it with the `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new bound function.
	 */
	function createBindWrapper(func, thisArg) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var fn = (this && this !== global && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(thisArg, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBindWrapper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(41),
	    isArray = __webpack_require__(9);
	
	/**
	 * Creates a function for `_.forEach` or `_.forEachRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createForEach(arrayFunc, eachFunc) {
	  return function(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee)
	      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	  };
	}
	
	module.exports = createForEach;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var arrayCopy = __webpack_require__(40),
	    composeArgs = __webpack_require__(116),
	    composeArgsRight = __webpack_require__(117),
	    createCtorWrapper = __webpack_require__(73),
	    isLaziable = __webpack_require__(314),
	    reorder = __webpack_require__(317),
	    replaceHolders = __webpack_require__(122),
	    setData = __webpack_require__(123);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that wraps `func` and invokes it with optional `this`
	 * binding of, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to reference.
	 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurry = bitmask & CURRY_FLAG,
	      isCurryBound = bitmask & CURRY_BOUND_FLAG,
	      isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	      Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	  function wrapper() {
	    // Avoid `arguments` object use disqualifying optimizations by
	    // converting it to an array before providing it to other functions.
	    var length = arguments.length,
	        index = length,
	        args = Array(length);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight);
	    }
	    if (isCurry || isCurryRight) {
	      var placeholder = wrapper.placeholder,
	          argsHolders = replaceHolders(args, placeholder);
	
	      length -= argsHolders.length;
	      if (length < arity) {
	        var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	            newArity = nativeMax(arity - length, 0),
	            newsHolders = isCurry ? argsHolders : undefined,
	            newHoldersRight = isCurry ? undefined : argsHolders,
	            newPartials = isCurry ? args : undefined,
	            newPartialsRight = isCurry ? undefined : args;
	
	        bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	        bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	        if (!isCurryBound) {
	          bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	        }
	        var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	            result = createHybridWrapper.apply(undefined, newData);
	
	        if (isLaziable(func)) {
	          setData(result, newData);
	        }
	        result.placeholder = placeholder;
	        return result;
	      }
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    if (argPos) {
	      args = reorder(args, argPos);
	    }
	    if (isAry && ary < args.length) {
	      args.length = ary;
	    }
	    if (this && this !== global && this instanceof wrapper) {
	      fn = Ctor || createCtorWrapper(func);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createCtorWrapper = __webpack_require__(73);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` and invokes it with the optional `this`
	 * binding of `thisArg` and the `partials` prepended to those provided to
	 * the wrapper.
	 *
	 * @private
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to the new function.
	 * @returns {Function} Returns the new bound function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    // Avoid `arguments` object use disqualifying optimizations by
	    // converting it to an array before providing it `func`.
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength);
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    var fn = (this && this !== global && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(114),
	    createBindWrapper = __webpack_require__(301),
	    createHybridWrapper = __webpack_require__(303),
	    createPartialWrapper = __webpack_require__(304),
	    getData = __webpack_require__(118),
	    mergeData = __webpack_require__(315),
	    setData = __webpack_require__(123);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to reference.
	 * @param {number} bitmask The bitmask of flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  length -= (holders ? holders.length : 0);
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func),
	      newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	  if (data) {
	    mergeData(newData, data);
	    bitmask = newData[1];
	    arity = newData[9];
	  }
	  newData[9] = arity == null
	    ? (isBindKey ? 0 : func.length)
	    : (nativeMax(arity - length, 0) || 0);
	
	  if (bitmask == BIND_FLAG) {
	    var result = createBindWrapper(newData[0], newData[2]);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	    result = createPartialWrapper.apply(undefined, newData);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(281);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 307 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(34);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(316);
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = array ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(120),
	    pairs = __webpack_require__(326);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 311 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(296);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}
	
	module.exports = initCloneObject;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(68),
	    getData = __webpack_require__(118),
	    getFuncName = __webpack_require__(309),
	    lodash = __webpack_require__(273);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(40),
	    composeArgs = __webpack_require__(116),
	    composeArgsRight = __webpack_require__(117),
	    replaceHolders = __webpack_require__(122);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers required to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	 * augment function arguments, making the order in which they are executed important,
	 * preventing the merging of metadata. However, we make an exception for a safe
	 * common case where curried functions have `_.ary` and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < ARY_FLAG;
	
	  var isCombo =
	    (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	    (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	    (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = arrayCopy(value);
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 316 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(40),
	    isIndex = __webpack_require__(42);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = arrayCopy(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(9),
	    isIndex = __webpack_require__(42),
	    isLength = __webpack_require__(26),
	    keysIn = __webpack_require__(125);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(68),
	    LodashWrapper = __webpack_require__(108),
	    arrayCopy = __webpack_require__(40);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  return wrapper instanceof LazyWrapper
	    ? wrapper.clone()
	    : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	}
	
	module.exports = wrapperClone;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(284),
	    bindCallback = __webpack_require__(41),
	    isIterateeCall = __webpack_require__(119);
	
	/**
	 * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	 * otherwise they are assigned by reference. If `customizer` is provided it's
	 * invoked to produce the cloned values. If `customizer` returns `undefined`
	 * cloning is handled by the method instead. The `customizer` is bound to
	 * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var shallow = _.clone(users);
	 * shallow[0] === users[0];
	 * // => true
	 *
	 * var deep = _.clone(users, true);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.clone(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(false);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 0
	 */
	function clone(value, isDeep, customizer, thisArg) {
	  if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	    isDeep = false;
	  }
	  else if (typeof isDeep == 'function') {
	    thisArg = customizer;
	    customizer = isDeep;
	    isDeep = false;
	  }
	  return typeof customizer == 'function'
	    ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
	    : baseClone(value, isDeep);
	}
	
	module.exports = clone;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(71),
	    bindCallback = __webpack_require__(41);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent. If `customizer` is provided it's invoked to compare values.
	 * If `customizer` returns `undefined` comparisons are handled by the method
	 * instead. The `customizer` is bound to `thisArg` and invoked with up to
	 * three arguments: (value, other [, index|key]).
	 *
	 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	 * numbers, `Object` objects, regexes, and strings. Objects are compared by
	 * their own, not inherited, enumerable properties. Functions and DOM nodes
	 * are **not** supported. Provide a customizer function to extend support
	 * for comparing other values.
	 *
	 * @static
	 * @memberOf _
	 * @alias eq
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize value comparisons.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * object == other;
	 * // => false
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * // using a customizer callback
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqual(array, other, function(value, other) {
	 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	 *     return true;
	 *   }
	 * });
	 * // => true
	 */
	function isEqual(value, other, customizer, thisArg) {
	  customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	module.exports = isEqual;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(124),
	    isObjectLike = __webpack_require__(29);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(26),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(289),
	    keysIn = __webpack_require__(125);
	
	/**
	 * Creates an array of function property names from all enumerable properties,
	 * own and inherited, of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @alias methods
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the new array of property names.
	 * @example
	 *
	 * _.functions(_);
	 * // => ['after', 'ary', 'assign', ...]
	 */
	function functions(object) {
	  return baseFunctions(object, keysIn(object));
	}
	
	module.exports = functions;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(70),
	    baseSlice = __webpack_require__(115),
	    isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(9),
	    isIndex = __webpack_require__(42),
	    isKey = __webpack_require__(75),
	    isLength = __webpack_require__(26),
	    last = __webpack_require__(107),
	    toPath = __webpack_require__(76);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `path` is a direct property.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': { 'c': 3 } } };
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b.c');
	 * // => true
	 *
	 * _.has(object, ['a', 'b', 'c']);
	 * // => true
	 */
	function has(object, path) {
	  if (object == null) {
	    return false;
	  }
	  var result = hasOwnProperty.call(object, path);
	  if (!result && !isKey(path)) {
	    path = toPath(path);
	    object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    if (object == null) {
	      return false;
	    }
	    path = last(path);
	    result = hasOwnProperty.call(object, path);
	  }
	  return result || (isLength(object.length) && isIndex(path, object.length) &&
	    (isArray(object) || isArguments(object)));
	}
	
	module.exports = has;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(34),
	    toObject = __webpack_require__(27);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(113),
	    basePropertyDeep = __webpack_require__(294),
	    isKey = __webpack_require__(75);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(126)))

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));


/***/ },
/* 331 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 332 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(332);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(331);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(126)))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** chunk-bd9aa8e74e24edc28b3c-ve.js
 **/